{
  "accueil.aFaire": "To do now",
  "accueil.approbationsEnAttente": "approvals and human decisions pending",
  "accueil.aucunDeploiementEchoue": "failed deployment",
  "accueil.aucuneExecution": "No run",
  "accueil.aucunProjet": "No project selected",
  "accueil.aucunProjetHint": "Choose a project in the context bar to see what awaits you.",
  "accueil.budgetNonDisponible": "AI budget: not available in this version (the current quota is shown in the panel)",
  "accueil.chargement": "Reading real data…",
  "accueil.deploiementsEchoues": "failed deployment(s): {{envs}}",
  "accueil.deployeVersion": "— {{version}} deployed",
  "accueil.deposerIdee": "Submit an idea",
  "accueil.doneNestPasDeploye": "Done is not deployed: below, what is actually running.",
  "accueil.erreurDetail": "One source of this block did not answer; the other figures are incomplete.",
  "accueil.etapeDone": "done (work)",
  "accueil.etapeInProgress": "in progress",
  "accueil.etapeInReview": "in review",
  "accueil.etapeTodo": "to do",
  "accueil.ideesAQualifier": "ideas to qualify",
  "accueil.jobsEnEchec": "failed jobs to resume",
  "accueil.progression": "Progress to production",
  "accueil.questionContributor": "What can I do next?",
  "accueil.questionOwner": "What is blocking?",
  "accueil.questionViewer": "Where do we stand?",
  "accueil.rienDeploye": "No successful deployment observed",
  "accueil.risques": "Risks and gates",
  "accueil.sod": "of your requests await ANOTHER approver (separation of duties)",
  "accueil.testsDerniere": "— latest test campaign",
  "accueil.testsEchec": "Failed",
  "accueil.testsOk": "Passed",
  "activity.acted": "acted on the item",
  "activity.attached": "attached",
  "activity.commented": "commented",
  "activity.created": "created the item",
  "activity.empty": "No activity.",
  "activity.hide": "Hide activity",
  "activity.loading": "Loading…",
  "activity.statusChanged": "changed the status",
  "activity.statutDone": "Done",
  "activity.statutInProgress": "In progress",
  "activity.statutInReview": "In review",
  "activity.statutTodo": "To do",
  "activity.system": "System",
  "activity.toggle": "Activity",
  "admin.accessDeniedDescription": "Your role does not grant access to governance (quotas, models, members).",
  "admin.accessDeniedTitle": "Access restricted to the workspace owner.",
  "admin.addMemberButton": "Add",
  "admin.addMemberHeading": "Add a member",
  "admin.allowedModelsHeading": "Allowed models",
  "admin.organisationAiModelsEmpty": "No global model is available for this organization. Ask a global administrator to enable a provider and publish a model.",
  "admin.aiConnectorActivationBlocked": "Enable the associated connector first.",
  "admin.colActions": "Actions",
  "admin.colCondition": "Condition",
  "admin.colConsumed": "Used",
  "admin.colEffect": "Effect",
  "admin.colEngine": "Engine",
  "admin.colJobs": "Jobs processed",
  "admin.colLastSeen": "Last seen",
  "admin.colLimit": "Limit",
  "admin.colPermission": "Permission",
  "admin.colResource": "Resource",
  "admin.colRole": "Role",
  "admin.colSince": "Since",
  "admin.colState": "Status",
  "admin.colUser": "User",
  "admin.colWorker": "Worker",
  "admin.effacerRecherche": "Clear the search",
  "admin.effetAllow": "Allow",
  "admin.effetDeny": "Deny",
  "admin.ilYA": "{{n}} s ago",
  "admin.loading": "Loading…",
  "admin.memberAddedToast": "Member added",
  "admin.memberRemovedToast": "Member removed",
  "admin.memberRoleAria": "Member role",
  "admin.memberUserPlaceholder": "user_id or username",
  "admin.membersHeading": "Members",
  "admin.membresAucunResultat": "No member matches this search",
  "admin.membresAucunResultatHint": "The search covers the identifier, the role and the join date.",
  "admin.modelAdd": "Allow this model",
  "admin.modelChoose": "— choose a model —",
  "admin.modelNoneLeftHint": "Every catalogue model is already allowed, or the catalogue is empty.",
  "admin.modelNoneLeftTitle": "No model left to add",
  "admin.modelRemove": "Remove",
  "admin.modelRemoveC1": "Generations requesting this model will be refused.",
  "admin.modelRemoveRev": "You can allow it again at any time; nothing is lost.",
  "admin.modelRemoveTitre": "Remove {{m}} from the allowed models?",
  "admin.modelRemoveVerbe": "Remove the model",
  "admin.modelRemovedToast": "Model removed from the list",
  "admin.modelToAdd": "Model to allow",
  "admin.motifAllow": "An ALLOW rule applies — it grants a right the role may not have.",
  "admin.motifDeny": "A DENY rule applies — it wins over the role. Fix it above.",
  "admin.motifNone": "No rule, and the role does not grant this permission. Fix it under “Roles & permissions”.",
  "admin.motifRbac": "No rule applies: the role grants it.",
  "admin.noMemberHint": "Roles are carried by the realm; this table may be empty.",
  "admin.noMemberTitle": "No member listed",
  "admin.noModelRestriction": "No model is allowed: generations are blocked.",
  "admin.noModelRestrictionTitle": "No model is allowed: generations are blocked.",
  "admin.noQuotaHint": "This workspace consumes without a cap. Set a limit below to define one.",
  "admin.noQuotaTitle": "No quota defined",
  "admin.pageDescription": "Workspace governance: resource quotas, allowed models, members.",
  "admin.permAucunResultat": "No permission matches this search",
  "admin.permAucunResultatHint": "The search covers the technical code and what the permission allows.",
  "admin.polAdd": "Add the rule",
  "admin.polAucunResultat": "No rule matches this search",
  "admin.polAucunResultatHint": "The search also covers the condition and the reason for the rule.",
  "admin.polChoisir": "— choose —",
  "admin.polCle": "Attribute (key)",
  "admin.polDelete": "Delete",
  "admin.polDeleteRev": "The rule can be recreated, but its history is lost.",
  "admin.polDeleteTitre": "Delete this rule?",
  "admin.polDeleteVerbe": "Delete the rule",
  "admin.polDescription": "Reason for the rule",
  "admin.polDescriptionAide": "Shown to the administrator who sees this rule refuse an action.",
  "admin.polEffect": "Effect",
  "admin.polEffectAide": "A deny ALWAYS wins over an allow, whatever the role grants.",
  "admin.polPermission": "Permission concerned",
  "admin.polRole": "Target role",
  "admin.polRoleAide": "Leaving it empty applies the rule to every role.",
  "admin.polSupprimeeToast": "Rule deleted",
  "admin.polTousRoles": "Every role",
  "admin.polValeur": "Expected value",
  "admin.polVideTitle": "No attribute rule",
  "admin.policiesHeading": "Access policies",
  "admin.pseudoCount": "{{n}} pseudonym(s) assigned for this organisation.",
  "admin.pseudoHeading": "Pseudonymisation",
  "admin.purgeAttest": "I have checked that no ongoing audit covers this period",
  "admin.purgeTitre": "Permanently delete {{n}} log event(s)?",
  "admin.purgeToast": "Logs purged",
  "admin.purgeVerbe": "Purge the logs",
  "admin.quoiMembres": "members",
  "admin.quoiPermissions": "permissions",
  "admin.quoiPolitiques": "rules",
  "admin.quoiWorkers": "workers",
  "admin.quotaAuMoinsUn": "A limit is at least 1. To stop limiting, remove the row from the table.",
  "admin.quotaDelete": "Remove",
  "admin.quotaDeleteC1": "The resource becomes UNCAPPED again for this workspace.",
  "admin.quotaDeleteC2": "The consumption counter goes with the limit.",
  "admin.quotaDeleteRev": "You can set a limit again, but the counter will restart from zero.",
  "admin.quotaDeleteTitre": "Remove the limit on {{r}}?",
  "admin.quotaDeleteVerbe": "Remove the limit",
  "admin.quotaExceeded": "Exceeded",
  "admin.quotaFormHeading": "Set or change a limit",
  "admin.quotaLimit": "Limit",
  "admin.quotaLimitAide": "Whole number. To remove any limit, delete the row rather than entering 0.",
  "admin.quotaNoCatalogTitle": "Resource catalogue unavailable",
  "admin.quotaNonApplique": "Saved, but not enforced yet: nothing refuses this overrun.",
  "admin.quotaReset": "Reset to zero",
  "admin.quotaResetC2": "The limit itself is kept unchanged.",
  "admin.quotaResetRev": "The previous value is not kept: the counter cannot be restored.",
  "admin.quotaResetTitre": "Reset the {{r}} counter to zero?",
  "admin.quotaResetVerbe": "Reset to zero",
  "admin.quotaResource": "Resource",
  "admin.quotaSave": "Save the limit",
  "admin.quotaSupprimeToast": "Limit removed",
  "admin.quotaWithinLimits": "Within limits",
  "admin.quotasHeading": "Quotas",
  "admin.rbacCaseAria": "{{permission}} for role {{role}}",
  "admin.rbacDernierAdminC2": "Grant this permission to another role first.",
  "admin.rbacDernierAdminTitre": "Not possible: {{r}} is the last administrator role",
  "admin.rbacDernierAdminVerbe": "Understood",
  "admin.rbacLoading": "Loading the matrix…",
  "admin.rbacScopeTitle": "These rights apply to the WHOLE organisation.",
  "admin.removeAttest": "I have checked that no pending approval depends on this person",
  "admin.removeC1": "Access is revoked immediately, including to artefacts already viewed.",
  "admin.removeC2": "Approvals this person was due to make stay pending.",
  "admin.removeMember": "Remove",
  "admin.removeMemberConfirm": "Remove this member from the workspace?",
  "admin.removeRev": "You can invite them again, but their membership history starts over.",
  "admin.removeTitle": "Remove {{u}} from this workspace?",
  "admin.removeVerb": "Remove the member",
  "admin.ressource.jetonsParJour": "Tokens per day",
  "admin.ressource.nombreDocuments": "Number of documents",
  "admin.ressource.requetesParMinute": "Requests per minute",
  "admin.ressource.tailleDocument": "Document size (MB)",
  "admin.retentionEtat": "{{n}} event(s) in this workspace log, oldest from {{d}}.",
  "admin.retentionHeading": "Log retention",
  "admin.retentionJours": "Keep logs for (days)",
  "admin.retentionPurger": "Purge now",
  "admin.retentionResultat": "{{n}} event(s) would be deleted with a {{j}}-day retention.",
  "admin.retentionSimuler": "Simulate the purge",
  "admin.roleContributor": "contributor",
  "admin.roleOwner": "owner",
  "admin.roleViewer": "viewer",
  "admin.rolesHeading": "Roles & permissions",
  "admin.section.conformite": "Compliance",
  "admin.section.integrations": "Integrations",
  "admin.section.membres": "Members",
  "admin.section.modeles": "Allowed models",
  "admin.section.politiques": "Access policies",
  "admin.section.quotas": "Quotas",
  "admin.section.roles": "Roles & permissions",
  "admin.section.workers": "Workers",
  "admin.sectionsLabel": "Administration sections",
  "admin.simAutorise": "Allowed",
  "admin.simCle": "Attribute (key)",
  "admin.simCleAide": "Optional. Leave empty to simulate a decision with no attribute.",
  "admin.simHeading": "Decision simulator",
  "admin.simPermission": "Requested permission",
  "admin.simRefuse": "Refused",
  "admin.simRole": "Simulated role",
  "admin.simRun": "Simulate",
  "admin.simValeur": "Value",
  "admin.title": "Administration",
  "admin.workerMort": "Inactive",
  "admin.workerMoteurInconnu": "not declared (older version)",
  "admin.workerPurge": "Remove",
  "admin.workerPurgeC2Mort": "Its processed-jobs counter is lost.",
  "admin.workerPurgeTitre": "Remove the heartbeat of {{w}}?",
  "admin.workerPurgeToast": "Heartbeat removed",
  "admin.workerPurgeVerbe": "Remove the heartbeat",
  "admin.workerVivant": "Active",
  "admin.workersAucunResultat": "No worker matches this search",
  "admin.workersAucunResultatHint": "The search covers the identifier, the status, the engine and its provenance.",
  "admin.workersHeading": "Workers",
  "admin.workersScopeTitle": "GLOBAL scope — not just this organisation.",
  "admin.workersVideTitle": "No worker has ever reported",
  "app.logout": "Sign out",
  "app.help": "Help",
  "app.helpAria": "Open contextual help",
  "app.helpTitle": "Contextual help",
  "app.helpDescription": "Orientation and next action for the current context.",
  "app.helpFor": "You are in “{{screen}}”.",
  "app.helpProject": "Active project:",
  "app.helpJourneyTitle": "Return to the journey",
  "app.helpJourneyDesc": "Review idea → publishing and the next action.",
  "app.helpProcessTitle": "View the effective process",
  "app.helpProcessDesc": "Check prerequisites, roles and gates for this project.",
  "app.localSupportChannel": "Local support: contact your organisation’s RunOps operator through its internal channel.",
  "app.commercialBoundary": "Commercial boundary: this on-premise installation offers no subscription, payment, or purchased balance; quotas express capacity governance only.",
  "app.localSupportSafety": "For diagnosis, provide the correlation identifier and non-sensitive context; never provide a token, secret, or document content.",
  "app.logoutShort": "Exit",
  "app.readonly": " · read-only",
  "app.readonlyShort": "Read-only",
  "app.search": "Search…",
  "app.searchAria": "Search (Ctrl+K)",
  "app.versionInterfaceLine": "Interface {{version}} · {{date}}",
  "app.versionGatewayLine": "Gateway {{version}} · {{date}}",
  "app.versionGatewayUnknown": "Gateway: unavailable",
  "app.versionDateUnknown": "unknown date",
  "approvals.and": "and",
  "approvals.approve": "Approve",
  "approvals.approveConsequence": "publishes this artifact to the repository (Git commit on the worker's next pass).",
  "approvals.authorNoticeOther": "another",
  "approvals.authorNoticeStrong": "You are the requester.",
  "approvals.authorNoticeText1": "Separation of duties (creator ≠ approver) requires that",
  "approvals.authorNoticeText2": "owner or contributor decide. Have a colleague review it — or, for a demo, sign back in with another account (e.g.",
  "approvals.authorNoticeText3": ") to approve.",
  "approvals.cancelEdit": "Cancel editing",
  "approvals.cardUnknown": "unknown",
  "approvals.close": "Close",
  "approvals.closeWithoutDeciding": "Close without deciding",
  "approvals.colAction": "Action",
  "approvals.colArtifact": "Artifact",
  "approvals.colCard": "Card",
  "approvals.colModel": "Model",
  "approvals.colRequester": "Requester",
  "approvals.colStatus": "Status",
  "approvals.collapse": "Collapse",
  "approvals.commentLabel": "Comment (required for a rejection)",
  "approvals.consult": "View",
  "approvals.contentToPublish": "Content to publish",
  "approvals.decidedBy": "by",
  "approvals.decidedToast": "Decision recorded",
  "approvals.decisionSubtitle": "Check the provenance (card, model, fingerprints) and the content before any decision.",
  "approvals.decisionTitle": "Approval decision",
  "approvals.detailLoading": "Loading the request…",
  "approvals.draftSpec": "Draft the specification",
  "approvals.draftSpecDesc": "produces the document, which comes back for approval.",
  "approvals.editContentManually": "Edit the content by hand",
  "approvals.editedContentLabel": "Edited content (returns for approval)",
  "approvals.editedToast": "Artefact updated",
  "approvals.emptyHint": "Submit an idea or upload a document; the generated specification will wait here for its decision.",
  "approvals.emptyTitle": "No approval request",
  "approvals.examine": "Examine",
  "approvals.fingerprintUnavailable": "unavailable",
  "approvals.generateBacklog": "Generate the backlog",
  "approvals.generateBacklogDesc": "breaks this approved specification into Epics → Stories → Tasks. The generated backlog goes through an approval in turn before becoming active on the board.",
  "approvals.generateEpics": "Generate epics",
  "approvals.generateEpicsDesc": "breaks this framing directly into epics on the board — self-acceptable by their generator as long as they stay intact; as soon as an epic is modified, another person must accept it — kicking off the cascade idea → epics → features → US → tasks.",
  "approvals.generateOptions": "Generate options",
  "approvals.generateOptionsDesc": "compares several solution paths from this approved framing. The generated options come back for approval, then feed the specification — the next step of the cycle.",
  "approvals.generatePersonas": "Generate personas",
  "approvals.generatePersonasProcessesDesc": "derive, from this same framing, the target users (roles, goals, frustrations) and the business processes (actors, steps, exceptions). Each comes back for approval.",
  "approvals.generateProcesses": "Generate processes",
  "approvals.howProduced": "How this artifact was produced",
  "approvals.instructionRequired": "Say what should change: the instruction guides the regeneration.",
  "approvals.loading": "Loading…",
  "approvals.metaArtifact": "Artifact",
  "approvals.metaDecision": "Decision",
  "approvals.metaInputFingerprint": "Input fingerprint",
  "approvals.metaModel": "Model",
  "approvals.metaOutputFingerprint": "Output fingerprint",
  "approvals.metaPromptCard": "Prompt card",
  "approvals.metaRequester": "Requester",
  "approvals.metaVersion": "Version",
  "approvals.modelUnknown": "unknown",
  "approvals.pageDescription": "Every generated artifact waits here for a reviewer's decision — never its requester's.",
  "approvals.pageTitle": "Approval center",
  "approvals.quoi": "requests",
  "approvals.readonlyStrong": "Read-only.",
  "approvals.readonlyText": "Your role does not allow deciding — only an owner or a contributor, different from the requester, can approve or reject.",
  "approvals.reasonRequired": "A rejection requires a reason: the requester will read it.",
  "approvals.regenHint": "Describe the expected revision; the AI restarts from the original input augmented with your instruction, as the next version.",
  "approvals.regenLaunchedPrefix": "Regeneration started as",
  "approvals.regenLaunchedSuffix": "— follow the model at work below; the new version will come back for approval.",
  "approvals.regenPlaceholder": "E.g. Number each requirement and add performance criteria.",
  "approvals.regenTitle": "Regenerate with instructions",
  "approvals.regenToast": "Regeneration started",
  "approvals.regenerate": "Regenerate",
  "approvals.reject": "Reject",
  "approvals.rejectConsequence": "removes the artifact from disk; its content remains viewable here with your justification.",
  "approvals.reviewAttestation": "I have read the content above in full",
  "approvals.evidenceAttestation": "I reviewed the grounded evidence for this exact receipt and validated its relevance",
  "approvals.evidenceAttestationRequired": "Review the grounded evidence and confirm its attestation before approving.",
  "approvals.revisedOnInstruction": "revised on instruction:",
  "approvals.saveEdit": "Save edit",
  "approvals.specGateApprovalBlocked": "Approval becomes available after a successful Spec Gate on this exact version. Rejection remains available.",
  "approvals.specGateChecks": "Checks passed",
  "approvals.specGateError": "Evaluation interrupted",
  "approvals.specGateErrorHint": "The evaluation could not complete. Retry after checking that the AI service is available.",
  "approvals.specGateEvaluate": "Evaluate specification",
  "approvals.specGateFailed": "Corrections required",
  "approvals.specGateFailedChecks": "Checks to fix",
  "approvals.specGateFailedHint": "Fix the checks and findings below, then evaluate the new version again.",
  "approvals.specGateFindings": "Priority findings",
  "approvals.specGateFreshUntil": "valid until",
  "approvals.specGateNotRequested": "Evaluation required",
  "approvals.specGateNotRequestedHint": "The specification must be evaluated against 13 checks before it can be approved.",
  "approvals.specGatePassed": "Ready for approval",
  "approvals.specGatePassedHint": "All 13 checks passed and the receipt matches this exact version.",
  "approvals.specGateGrounded": "Grounded evidence",
  "approvals.specGateAuthoritySteps": "Authority steps",
  "approvals.specGateGroundedStep": "1. Grounded evidence",
  "approvals.specGateGroundedYes": "Coordinates resolved and hashes checked by the server; relevance still requires human review.",
  "approvals.specGateGroundedNo": "Machine evidence not established.",
  "approvals.specGateHumanStep": "2. Human verification",
  "approvals.specGateHumanYes": "Human attestation recorded for this exact receipt.",
  "approvals.specGateHumanNo": "Explicit attestation still required.",
  "approvals.specGateBundle": "bundle",
  "approvals.specGateEvidence": "Grounded evidence",
  "approvals.specGateEvidenceUnavailable": "Grounded evidence could not be verified. Attestation is blocked.",
  "approvals.specGateReadonly": "An owner or contributor can start the evaluation. You can view its result.",
  "approvals.specGateReasons": "Why the gate is blocking",
  "approvals.specGateReceipt": "Exact receipt",
  "approvals.specGateRetry": "Evaluate specification again",
  "approvals.specGateRunning": "Evaluation in progress",
  "approvals.specGateRunningHint": "The model is running the 13 checks. The result will appear here automatically.",
  "approvals.specGateScore": "Overall score",
  "approvals.specGateStale": "Evaluation is outdated",
  "approvals.specGateStaleHint": "The content or its version changed after the last receipt. A new evaluation is required.",
  "approvals.specGateStarting": "Starting…",
  "approvals.specGateTitle": "Specification quality",
  "approvals.renewal.title": "Renew the Spec Gate evidence",
  "approvals.renewal.badgeCurrent": "Current evidence",
  "approvals.renewal.badgeExpired": "Evidence expired",
  "approvals.renewal.success": "Evidence renewed and attested by {{par}}, valid until {{date}}. Generation is possible again; the original decision is unchanged.",
  "approvals.renewal.alreadyCurrent": "The pinned evidence is current: if a generation was refused, the specification may not be published yet.",
  "approvals.renewal.expiredHint": "The evidence attested at decision time expired on {{date}} (24 h validity). The specification stays approved, but no generation is possible until current evidence is attached to it.",
  "approvals.renewal.expiredHintNoDate": "The evidence attested at decision time is no longer current. The specification stays approved, but no generation is possible until current evidence is attached to it.",
  "approvals.renewal.steps": "Renewal steps",
  "approvals.renewal.step1": "1. Re-evaluate the evidence",
  "approvals.renewal.running": "Re-evaluating the exact approved snapshot…",
  "approvals.renewal.passed": "New PASS evidence (13/13 grounded checks), valid until {{date}}.",
  "approvals.renewal.passedNoDate": "New PASS evidence (13/13 grounded checks).",
  "approvals.renewal.failed": "The re-evaluation found corrections: this evidence cannot be attached. Fix the specification in a new version, or run the re-evaluation again.",
  "approvals.renewal.error": "The re-evaluation did not complete. Run it again; the content is unchanged.",
  "approvals.renewal.none": "No re-evaluation since the expiry: run one to obtain current evidence.",
  "approvals.renewal.starting": "Starting…",
  "approvals.renewal.reevaluate": "Re-evaluate the evidence",
  "approvals.renewal.step2": "2. Attach the renewed evidence",
  "approvals.renewal.waitingPass": "Available as soon as a PASS re-evaluation of the same content is recorded.",
  "approvals.renewal.evidenceUnavailable": "The renewed receipt's evidence cannot be loaded: attaching waits until it has been reviewed.",
  "approvals.renewal.readonly": "Only a project owner or contributor can renew the evidence.",
  "approvals.renewal.selfRefused": "You requested this specification: another owner or contributor must attest the renewed evidence.",
  "approvals.renewal.attestation": "I reviewed the grounded evidence of this renewed receipt and confirm its relevance to the approved specification.",
  "approvals.renewal.comment": "Comment (optional)",
  "approvals.renewal.attaching": "Attaching…",
  "approvals.renewal.attach": "Attach the renewed evidence",
  "approvals.renewal.goTo": "Renew the specification's evidence",
  "approvals.statusApproved": "Approved",
  "approvals.statusPending": "Pending",
  "approvals.statusRejected": "Rejected",
  "approvals.supersededBadge": "replaced by a more recent version",
  "approvals.theProcesses": "the processes",
  "artifactFamily.analyses": "Analysis",
  "artifactFamily.backlog": "Backlog",
  "artifactFamily.cadrages": "Framing",
  "artifactFamily.changes": "Change",
  "artifactFamily.options": "Options",
  "artifactFamily.personas": "Personas",
  "artifactFamily.processes": "Processes",
  "artifactFamily.reviews": "Review",
  "artifactFamily.specs": "Specification",
  "artifacts.colArtifact": "Artifact",
  "artifacts.colCard": "Card",
  "artifacts.colCodeCommit": "Code commit",
  "artifacts.colOutputHash": "Output fingerprint",
  "artifacts.colPublicationCommit": "Publication commit",
  "artifacts.description": "Everything that has been approved then committed in this workspace — spec, fingerprint, publication commit AND commit of the generated code. The repository reflects the state of the approved specs.",
  "artifacts.emptyHint": "Approve a generation: the committed artifact will appear here with its hash and its commits.",
  "artifacts.emptyTitle": "No published artifact",
  "artifacts.fieldArtifactSpec": "Artifact (spec)",
  "artifacts.fieldCodeCommit": "Commit of the generated code",
  "artifacts.fieldDecidedBy": "Approved by",
  "artifacts.fieldInputHash": "Input fingerprint",
  "artifacts.fieldModel": "Model",
  "artifacts.fieldOutputHash": "Output fingerprint",
  "artifacts.fieldPromptCard": "Prompt card",
  "artifacts.fieldPublicationCommit": "Publication commit",
  "artifacts.fieldRequestedBy": "Requested by",
  "artifacts.loading": "Loading artifacts…",
  "artifacts.quoi": "artifacts",
  "artifacts.title": "Published artifacts",
  "artifacts.traceability": "Traceability",
  "artifacts.traceabilityDescription": "The artifact (spec) and the repository state that corresponds to it: commit of the generated code and publication commit. Click a value to copy it.",
  "artifacts.traceabilityTitle": "Artifact traceability",
  "att.deleteConsequence": "The file is removed from this item and from storage. You will have to upload it again to get it back.",
  "att.deleteTitle": "Delete « {{f}} »?",
  "att.deleteVerb": "Delete the attachment",
  "att.deletedToast": "Attachment deleted",
  "att.downloadedToast": "Attachment downloaded",
  "att.uploadedToast": "Attachment added",
  "attach.addFile": "Add a file",
  "attach.downloadAria": "Download",
  "attach.empty": "No attachments.",
  "attach.heading": "Attachments",
  "attach.hide": "Hide attachments",
  "attach.loading": "Loading…",
  "attach.removeAria": "Delete",
  "attach.unitBytes": "B",
  "attach.unitKilobytes": "KB",
  "attach.unitMegabytes": "MB",
  "attach.uploading": "Uploading…",
  "attachViewer.download": "Download",
  "attachViewer.fetchError": "Could not load the attachment.",
  "attachViewer.loading": "Loading…",
  "attachViewer.unsupported": "Preview unavailable for this file type.",
  "attention.all": "All ({{n}})",
  "attention.approvalSubtitle": "requested by {{w}}",
  "attention.approvePlan": "Approve the proposed plan and budget",
  "attention.category.approvals": "Approvals",
  "attention.category.colony": "Colony",
  "attention.category.organisation": "Organisation",
  "attention.category.quality": "Quality",
  "attention.description": "What awaits a decision in this project, with its age.",
  "attention.detail.age": "Waiting for",
  "attention.detail.kind": "Kind",
  "attention.detail.who": "By",
  "attention.detail.why": "Reason",
  "attention.emptyHint": "Approvals, mission plans and escalations will appear here with their age.",
  "attention.emptyTitle": "Nothing awaits your decision",
  "attention.escalationSubtitle": "{{c}} · {{r}}",
  "attention.filters": "Filter by category",
  "attention.kind.ai_tool_execution": "AI tool",
  "attention.kind.approval": "Approval",
  "attention.kind.mission_escalation": "Escalation",
  "attention.kind.mission_plan": "Mission plan",
  "attention.kind.mission_task_stopped": "Colony stopped",
  "attention.loading": "Loading…",
  "attention.openCockpit": "Decide in the HITL cockpit",
  "attention.openMission": "Open the mission cockpit",
  "attention.planSubtitle": "{{k}} · launched by {{w}}",
  "attention.reject": "Reject with a reason",
  "attention.taskSubtitle": "{{c}} · {{r}}",
  "attention.title": "Attention inbox",
  "attention.toolSubtitle": "proposed by {{w}}",
  "audit.chainVerified": "Hash chain verified — no tampering detected.",
  "audit.description": "Replays the workspace governance trail (decisions + event journal) and recomputes the hash chain: any tampering with a signed event is detected.",
  "audit.downloadBundle": "Download bundle",
  "audit.exportedToast": "Audit export generated",
  "audit.fingerprint": "Fingerprint",
  "audit.generateExport": "Generate export",
  "audit.generatedAt": "Generated on",
  "audit.generating": "Generating…",
  "audit.governanceDecisions": "governance decision(s).",
  "audit.heading": "Audit export",
  "audit.pseudonymise": "Replace people's identifiers with stable pseudonyms",
  "audit.signedEventsVerified": "signed event(s) verified",
  "audit.tampered": "Tampering detected",
  "audit.unsignedEvents": "unsigned (prior to immutability)",
  "backlog.accept": "Accept",
  "backlog.acceptedToast": "Item accepted",
  "backlog.aiGeneratedEpic": "Epic generated by AI — must be accepted by a human OTHER than its generator.",
  "backlog.aiGeneratedItem": "Item generated by AI — must be accepted by a human OTHER than its generator.",
  "backlog.aiItemModified": "AI-generated item, since edited — needs acceptance by someone else.",
  "backlog.analysisStarted": "Analysis started — the worker maps the scope below.",
  "backlog.analyzeRepo": "Analyze the repository",
  "backlog.analyzeScopeRequired": "Name at least one file to analyse.",
  "backlog.approvedDiffAttached": " · approved diff attached",
  "backlog.bulkConfirmC1": "The change applies to {{n}} item(s) at once, overwriting {{f}} of each.",
  "backlog.bulkConfirmC2": "No undo is available: you would have to redo the selection and revert item by item.",
  "backlog.bulkConfirmTitle": "Change {{n}} item(s)?",
  "backlog.bulkConfirmVerb": "Change",
  "backlog.bulkFieldPriority": "the priority",
  "backlog.bulkFieldSprint": "the sprint",
  "backlog.bulkFieldStatus": "the status",
  "backlog.bulkPriorityPlaceholder": "Priority…",
  "backlog.bulkPriorityLabel": "Priority (bulk)",
  "backlog.bulkSprintPlaceholder": "Sprint…",
  "backlog.bulkSprintLabel": "Sprint (bulk)",
  "backlog.bulkStatusPlaceholder": "Status…",
  "backlog.bulkStatusLabel": "Status (bulk)",
  "backlog.bulkEdit": "Bulk edit",
  "backlog.bulkToast": "Items updated",
  "backlog.cancel": "Cancel",
  "backlog.childrenGenerationStarted": "Generation started — the children will appear on the board after generation (to accept).",
  "backlog.childrenGenerationPending": "Generating work items…",
  "backlog.errorKeep": "The gateway did not respond ({{m}}). The previous board stays displayed.",
  "backlog.generatingChildren": "Generating…",
  "backlog.generatingDiff": "Generating…",
  "backlog.analyzing": "Analyzing…",
  "backlog.designingTests": "Designing…",
  "backlog.openSpecifications": "Open specifications",
  "backlog.reviewPending": "Reviewing…",
  "backlog.aiActionPending": "AI action in progress — follow its progress below.",
  "backlog.clear": "Clear",
  "backlog.codeGenerationStarted": "Generation started — follow the model at work below; the diff will need approval.",
  "backlog.codeReview": "Code review",
  "backlog.collapse": "Collapse",
  "backlog.columnDone": "Done",
  "backlog.columnInProgress": "In progress",
  "backlog.columnInReview": "In review",
  "backlog.columnTodo": "To do",
  "backlog.componentVersion": "Component / version",
  "backlog.createStory": "Create the story",
  "backlog.creating": "Creating…",
  "backlog.description": "The workspace's agile backlog — generated from an approved specification, then steered column by column.",
  "backlog.designTests": "Design tests",
  "backlog.designTestsSubmit": "Design the tests",
  "backlog.edit": "Edit",
  "backlog.effortPoints": "Effort (points)",
  "backlog.emptyHint": "Generate the backlog from an approved specification, or create a story.",
  "backlog.emptyTitle": "Empty backlog",
  "backlog.epicsHeading": "Epics — break them down into features with AI",
  "backlog.exitSelection": "Exit selection",
  "backlog.expand": "Expand",
  "backlog.featuresGenerationStarted": "Generation started — the features will appear on the board after generation (to accept).",
  "backlog.filesInvolved": "Affected files (comma-separated)",
  "backlog.filesToAnalyze": "Files to analyze (comma-separated)",
  "backlog.filesToCover": "Files to cover (comma-separated)",
  "backlog.filterKindAll": "All",
  "backlog.filterPriorityAll": "All",
  "backlog.generateCode": "Generate code",
  "backlog.generateDiff": "Generate the diff",
  "backlog.generateFeatures": "Generate features",
  "backlog.generateStories": "Generate user stories",
  "backlog.generateTasks": "Generate tasks",
  "backlog.kindBug": "Bug",
  "backlog.kindEpic": "Epic",
  "backlog.kindFeature": "Feature",
  "backlog.kindStory": "Story",
  "backlog.kindTask": "Task",
  "backlog.kindUsShort": "US",
  "backlog.labels": "Labels",
  "backlog.links": "Links",
  "backlog.loading": "Loading backlog…",
  "backlog.more": "More actions",
  "backlog.mrAlreadyOpen": "(already open)",
  "backlog.mrOnGitlab": "on GitLab",
  "backlog.mrOpened": "opened",
  "backlog.newStory": "New story",
  "backlog.noEpicGroup": "No epic",
  "backlog.noSprint": "No sprint",
  "backlog.none": "None",
  "backlog.openApprovals": "Open the approvals center",
  "backlog.parentEpic": "Parent epic",
  "backlog.priority": "Priority",
  "backlog.priorityCritical": "Critical",
  "backlog.priorityHigh": "High",
  "backlog.priorityLow": "Low",
  "backlog.priorityMedium": "Medium",
  "backlog.proposeMr": "Propose the MR",
  "backlog.readOnly": "Read-only — your role does not allow modifying the backlog.",
  "backlog.reviewStarted": "Review started on the last approved change.",
  "backlog.save": "Save",
  "backlog.scopeRequired": "Name at least one file involved.",
  "backlog.select": "Select",
  "backlog.selectedCount": "selected",
  "backlog.sending": "Sending…",
  "backlog.sprintTitle": "Sprint",
  "backlog.startAnalysis": "Start the analysis",
  "backlog.storyAsA": "As a",
  "backlog.storyAsAAide": "The role that has this need.",
  "backlog.storyAsAPlaceholder": "a role (e.g. user)",
  "backlog.storyCreatedToast": "Story created",
  "backlog.storyIWant": "I want",
  "backlog.storyIWantAide": "The need itself: it becomes the story title.",
  "backlog.storyIWantPlaceholder": "the need (used as the title)",
  "backlog.storySoThat": "So that",
  "backlog.storySoThatPlaceholder": "a benefit",
  "backlog.storyStructureHint": "A user story reads in three parts. \"I want\" is used as the title.",
  "backlog.storyTitle": "Story title",
  "backlog.tabBoard": "Board",
  "backlog.tabList": "List",
  "backlog.tabTree": "Hierarchy",
  "backlog.templatePrefix": "Template",
  "backlog.templateTitle": "Configuration template for this project",
  "backlog.testsDesignStarted": "Test design started — the worker proposes tests on the scope below.",
  "backlog.openTestApproval": "Open approval center",
  "backlog.testsScopeRequired": "Name at least one file to cover.",
  "backlog.title": "Backlog",
  "backlog.filtersActions": "Backlog filters and actions",
  "backlog.toAccept": "to accept",
  "backlog.type": "Type",
  "backlog.viewsLabel": "Backlog views",
  "champ.entierPositif": "A positive whole number is expected",
  "champ.longueurMax": "{{n}} characters maximum ({{actuel}} entered)",
  "champ.longueurMin": "At least {{n}} characters — {{manque}} missing",
  "champ.obligatoireSr": "(required)",
  "champ.pasAvant": "Must be on or after « {{ref}} »",
  "champ.requis": "This field is required",
  "chat.assistantTyping": "The assistant is replying…",
  "chat.chooseModel": "Choose a model…",
  "chat.description": "Chat with the assistant in the context of your workspace.",
  "chat.emptyState": "Ask a first question to start the conversation.",
  "chat.inputPlaceholder": "Write your question…",
  "chat.inputTokens": "Input tokens",
  "chat.loadingModels": "Loading models…",
  "chat.messageLabel": "Your message",
  "chat.model": "Model",
  "chat.noModelsTitle": "No model is allowed in this workspace",
  "chat.noModelsHint": "An owner must allow at least one model before starting a conversation.",
  "chat.configureModels": "Configure models",
  "chat.observabilityMissing": "The response has no Langfuse correlation ID — AI observability is degraded.",
  "chat.observabilityTrace": "Langfuse correlation — AI identifier",
  "admin.langfuseProbeLatency": "probe duration",
  "admin.langfuseIndexStatus": "indexing",
  "chat.outputTokens": "Output tokens",
  "chat.readOnly": "Read-only — your role does not allow sending messages.",
  "chat.roleAssistant": "Assistant",
  "chat.roleSystem": "System",
  "chat.roleYou": "You",
  "chat.sendButton": "Send",
  "chat.title": "Chat",
  "classif.componentCreatedToast": "Component created",
  "classif.componentTooltip": "Component",
  "classif.newComponent": "New component",
  "classif.newVersion": "New version",
  "classif.noComponent": "No component",
  "classif.noVersion": "No version",
  "classif.versionCreatedToast": "Version created",
  "classif.versionTooltip": "Target version",
  "cmdk.createGroup": "Create",
  "cmdk.emptyState": "No results.",
  "cmdk.searchPlaceholder": "Go to a screen, run an action…",
  "comments.addedToast": "Comment posted",
  "comments.empty": "No comments.",
  "comments.hide": "Hide comments",
  "comments.loading": "Loading…",
  "comments.mention": "Mention:",
  "comments.placeholder": "Write a comment… (@username to notify a member)",
  "comments.submit": "Comment",
  "comments.toggle": "Comments",
  "compare.compare": "Compare",
  "compare.comparison": "Comparison",
  "compare.createdToast": "Comparison started",
  "compare.description": "Replay a prompt across several models and compare their outputs and cost.",
  "compare.emptyHint": "Start one above.",
  "compare.emptyTitle": "No comparison",
  "compare.loading": "Loading…",
  "compare.loadingModels": "Loading models…",
  "compare.modelFailed": "Model failed",
  "compare.modelsLegend": "Models to compare (at least two distinct models)",
  "compare.noModelsTitle": "No model is allowed in this workspace",
  "compare.noModelsHint": "Allow at least two models before starting a comparison.",
  "compare.configureModels": "Configure models",
  "compare.modelsRequired": "Pick at least two distinct models to compare.",
  "compare.newComparison": "New comparison",
  "compare.promptLabel": "Prompt",
  "compare.promptPlaceholder": "Explain separation of duties in one sentence.",
  "compare.promptRequired": "Write the prompt to compare.",
  "compare.readOnly": "Read-only — running a comparison is reserved for contributors.",
  "compare.recentComparisons": "Recent comparisons",
  "compare.reviewUnavailable": "Review requires at least two successful, non-empty, measured outputs.",
  "compare.starting": "Starting…",
  "compare.title": "Multi-LLM diff",
  "compare.workerReplaying": "The worker is replaying the prompt on each model…",
  "config.addAgent": "Add an agent",
  "config.addApi": "Add an API",
  "config.addMcp": "Add an MCP server",
  "config.addMode": "Add a mode",
  "config.addModel": "Add a model",
  "config.addWorkflow": "Add a workflow",
  "config.agentDescPlaceholder": "Description",
  "config.agentIdPlaceholder": "ID",
  "config.agentLabelPlaceholder": "Display name",
  "config.agentRolePlaceholder": "Capability role",
  "config.agents": "Agents",
  "config.agentsEmpty": "No agent declared.",
  "config.allerTemplateEspace": "Open this project's template",
  "config.annulerModifs": "Discard",
  "config.apercu.aucunProjet": "No project uses this template — changes made here will change what nobody sees.",
  "config.apercu.contenu": "What this template contains",
  "config.apercu.impact": "Impact on the active project",
  "config.apercu.impactAucun": "Every item in this project has a type and a status declared by this template.",
  "config.apercu.impactChargement": "Measuring…",
  "config.apercu.impactHypothese": "(this project does NOT use this template: figures are hypothetical)",
  "config.apercu.impactIndisponible": "The project's items could not be read: impact cannot be measured.",
  "config.apercu.impactKind": "{{n}} items carry the type “{{k}}”, absent from this template: they stay in the database but can no longer be classified.",
  "config.apercu.impactNote": "Computed on the active project only, from its loaded items. Other attached projects are not measured here.",
  "config.apercu.impactPortee": "Measured on “{{p}}”, {{n}} items.",
  "config.apercu.impactSansProjet": "No active project: select one to measure the impact.",
  "config.apercu.impactStatut": "{{n}} items are in status “{{s}}”, absent from this template: their column will disappear from the board.",
  "config.apercu.nAgents": "agents",
  "config.apercu.nApis": "declared APIs",
  "config.apercu.nChamps": "declared fields",
  "config.apercu.nEtapes": "lifecycle stages",
  "config.apercu.nLiaisons": "link types",
  "config.apercu.nMcp": "MCP servers",
  "config.apercu.nModeles": "LLM models",
  "config.apercu.nStatuts": "statuses",
  "config.apercu.nTypes": "work-item types",
  "config.apercu.nWorkflows": "dynamic workflows",
  "config.apercu.projetActif": "active project",
  "config.apercu.rattachement": "Attached projects",
  "config.apercu.rattacherOu": "Attachment is chosen when a project is created, under “New project”.",
  "config.apercu.sansDescription": "This template has no description: nothing says what it is for.",
  "config.apiAuthPlaceholder": "Authentication (e.g. Bearer, none)",
  "config.apiBaseUrlPlaceholder": "Base URL (e.g. https://…/api/v4)",
  "config.apiDescPlaceholder": "Description",
  "config.apiIdPlaceholder": "Identifier (e.g. gitlab)",
  "config.apiLabelPlaceholder": "Display name",
  "config.apis": "APIs",
  "config.apisEmpty": "No API declared.",
  "config.avertissementAutre": "You are editing a template that project “{{p}}” does not use. Its screens will not change.",
  "config.builtinBadge": "Built-in",
  "config.cancel": "Cancel",
  "config.chipEspaceActif": "Used by the active workspace",
  "config.createTemplateButton": "Create template",
  "config.createdToast": "Template created",
  "config.deleteAttest": "I have checked which projects use this template",
  "config.deleteC1": "Projects using this template fall back to the built-in model.",
  "config.deleteC2": "Types and statuses specific to this template disappear from their screens; items carrying them stay in the database but can no longer be classified.",
  "config.deleteConfirm": "Delete this template? This cannot be undone.",
  "config.deleteTemplate": "Delete this template",
  "config.deleteTitle": "Delete template « {{n}} »?",
  "config.deleteVerb": "Delete the template",
  "config.deletedToast": "Template deleted",
  "config.duplicateDefault": "Duplicate the Default to edit",
  "config.duplicateDefaultDesc": "Model derived from the Default, freely editable.",
  "config.duplicateDefaultName": "Default copy",
  "config.duplicatedToast": "Template duplicated",
  "config.emptyLinks": "This template defines no link type.",
  "config.emptyTypes": "This template defines no work-item types.",
  "config.engineChosenBy": "chosen by",
  "config.engineFromArgument": "command-line argument",
  "config.engineFromDefault": "default value",
  "config.engineFromEnv": "environment variable",
  "config.engineRunning": "Engine serving jobs",
  "config.engineStale": "— last heartbeat, worker currently stopped",
  "config.enregistrer": "Save",
  "config.errNoDefault": "The Default template is unavailable: a copy cannot be created.",
  "config.generates": "Generates",
  "config.lifecycle": "Product lifecycle",
  "config.lifecycle.add": "Add a stage",
  "config.lifecycle.empty": "No stage of its own: the built-in lifecycle shown above applies.",
  "config.lifecycle.errDupStage": "Stage keys must be unique.",
  "config.lifecycle.fallbackBadge": "built-in lifecycle",
  "config.lifecycle.hint": "The stages an idea goes through until publication. Leave the list empty to keep the built-in lifecycle; a stage reusing a known key inherits its icon and route.",
  "config.lifecycle.icon": "Stage icon",
  "config.lifecycle.iconDefault": "(default for the key)",
  "config.lifecycle.iconLbl": "Icon",
  "config.lifecycle.key": "Stage key (e.g. idee)",
  "config.lifecycle.keyLbl": "Stage key",
  "config.lifecycle.label": "Display label",
  "config.lifecycle.labelLbl": "Label",
  "config.lifecycle.preview": "Rail preview",
  "config.lifecycle.remove": "Remove this stage",
  "config.lifecycle.seed": "Start from the built-in lifecycle",
  "config.lifecycle.to": "Route to act on (e.g. /ideas)",
  "config.lifecycle.toLbl": "Route",
  "config.lineage": "Generation lineage",
  "config.lineageHint": "Always generate children from the parent, step by step.",
  "config.links": "Link types",
  "config.llm": "LLM & routing",
  "config.llmModelsEmpty": "No model declared.",
  "config.llmRoutingLabel": "Routing policy",
  "config.llmRoutingPlaceholder": "e.g. every prompt declares a capability role; the router resolves it locally.",
  "config.mcp": "MCP servers & tools",
  "config.mcpDescPlaceholder": "Description",
  "config.mcpEmpty": "No MCP server declared.",
  "config.mcpIdPlaceholder": "ID",
  "config.mcpLabelPlaceholder": "Display name",
  "config.mcpToolsPlaceholder": "Tools, comma-separated",
  "config.modeActive": "Mode applied to this workspace",
  "config.modeDescPlaceholder": "Description",
  "config.modeIdPlaceholder": "ID",
  "config.modeLabelPlaceholder": "Display name",
  "config.modeNone": "(none — approval by a second human)",
  "config.model.addField": "Add a field",
  "config.model.addLink": "Add a link",
  "config.model.addStatus": "Add a status",
  "config.model.addType": "Add a type",
  "config.model.errDupField": "Field keys must be unique within a type.",
  "config.model.errDupLink": "Link keys must be unique.",
  "config.model.errDupStatus": "Status keys must be unique.",
  "config.model.errDupType": "Type keys must be unique.",
  "config.model.errNoStatus": "At least one status is required.",
  "config.model.errNoType": "At least one work-item type is required.",
  "config.model.fieldKey": "Field key",
  "config.model.fieldLabel": "Field label",
  "config.model.fieldType": "Field type",
  "config.model.fields": "Fields",
  "config.model.fieldsEmpty": "No field.",
  "config.model.generates": "Generates (child keys, comma-separated)",
  "config.model.generatesLbl": "Generates",
  "config.model.iconDefault": "(default for the kind)",
  "config.model.lineageDerived": "Recomposed from the “generates” fields above — it is never entered separately.",
  "config.model.linkDesc": "Description",
  "config.model.linkKey": "Key (e.g. blocks)",
  "config.model.linkKeyLbl": "Key",
  "config.model.linkLabel": "Label",
  "config.model.linksEmpty": "No link defined.",
  "config.model.linksHint": "The relations that can be declared between two items (blocks, duplicates…).",
  "config.model.moveDown": "Move down",
  "config.model.moveUp": "Move up",
  "config.model.removeField": "Remove this field",
  "config.model.removeLink": "Remove this link",
  "config.model.removeStatus": "Remove this status",
  "config.model.removeType": "Remove this type",
  "config.model.required": "Required",
  "config.model.reset": "Cancel",
  "config.model.richBody": "Rich body (Markdown + Mermaid)",
  "config.model.save": "Save model",
  "config.model.savedToast": "Model saved",
  "config.model.statusKey": "Status key (e.g. todo)",
  "config.model.statusKeyLbl": "Status key",
  "config.model.statusLabel": "Status label",
  "config.model.statusTone": "Tone",
  "config.model.title": "Work-item model",
  "config.model.toneDefault": "(default for the status)",
  "config.model.transitions": "Transitions (target keys)",
  "config.model.typeDesc": "Type description",
  "config.model.typeIcon": "Icon",
  "config.model.typeKey": "Type key (e.g. epic)",
  "config.model.typeKeyLbl": "Type key",
  "config.model.typeLabel": "Display label",
  "config.model.typesEmpty": "No type defined.",
  "config.model.typesHint": "Key (stable identifier), label, generated child type and each type's fields.",
  "config.model.unknownKind": "(unknown type)",
  "config.model.workflowEmpty": "No status defined.",
  "config.modelIdPlaceholder": "ID (e.g. qwen3-coder:30b)",
  "config.modelLabelPlaceholder": "Display name",
  "config.modelPoolPlaceholder": "Pool (gpu, cpu…)",
  "config.modelRolePlaceholder": "Capability role (e.g. code_agent_primary)",
  "config.modes": "Execution modes",
  "config.modesEmpty": "No mode declared.",
  "config.nModifications": "{{n}} unsaved changes",
  "config.newTemplate": "New template",
  "config.newTemplateHint": "Creates an organisation template by cloning the Default configuration.",
  "config.onglet.apercu": "Overview",
  "config.onglet.cycle": "Lifecycle",
  "config.onglet.liaisons": "Links",
  "config.onglet.plateforme": "Platform",
  "config.onglet.statuts": "Statuses & transitions",
  "config.onglet.types": "Types & fields",
  "config.ongletsLabel": "Configuration sections",
  "config.orgBadge": "Organisation",
  "config.platform": "Platform",
  "config.platform.blocsHint": "Six independent settings. Each block opens separately; the number shown is what it already contains.",
  "config.platformReset": "Cancel",
  "config.platformSave": "Save",
  "config.platformSavedToast": "Platform saved",
  "config.removeRow": "Remove this row",
  "config.savedToast": "Configuration saved",
  "config.source": "Source",
  "config.template": "Template",
  "config.templateDefaultOption": "Default (built-in)",
  "config.templateDescAide": "What is this way of working for?",
  "config.templateDescLabel": "Description",
  "config.templateDescPlaceholder": "What is this way of working for?",
  "config.templateNameAide": "This name appears in the selector above and when attaching a project.",
  "config.templateNameLabel": "Name",
  "config.templateNamePlaceholder": "e.g. Insurance delivery",
  "config.title": "Configuration",
  "config.types": "Work-item types & fields",
  "config.typesHint": "Each type, its fields, and the child type it generates.",
  "config.uneModification": "1 unsaved change",
  "config.workflow": "Statuses & transitions",
  "config.workflowDescPlaceholder": "Description",
  "config.workflowHint": "Workflow statuses and allowed transitions are enforced by the server.",
  "config.workflowIdPlaceholder": "Identifier (e.g. spec-to-code)",
  "config.workflowLabelPlaceholder": "Display name",
  "config.workflowStepsPlaceholder": "Ordered steps, comma-separated",
  "config.workflowTriggerLabel": "Trigger",
  "config.workflowTriggerPlaceholder": "Trigger (e.g. approval of a spec)",
  "config.workflows": "Dynamic workflows",
  "config.workflowsEmpty": "No dynamic workflow declared.",
  "confirm.cancel": "Cancel",
  "contexte.accesRetire": "Your access to project “{{id}}” was revoked, or it was deleted. You are now in “{{actuel}}”.",
  "contexte.aucunProgramme": "No program: a project can exist without a program.",
  "contexte.aucunProjet": "No accessible project in this organisation",
  "contexte.aucunProjetChoisi": "No project chosen",
  "contexte.aucunResultat": "No result for this search",
  "contexte.chargement": "Loading context…",
  "contexte.choisirProgramme": "Choose a program",
  "contexte.choisirProjet": "Choose a project",
  "contexte.continuerIci": "Continue here",
  "contexte.deepLinkPerimeProgramme": "Program “{{id}}” is not found or not accessible.",
  "contexte.deepLinkPerimeProjet": "Project “{{id}}” is not found or not accessible.",
  "contexte.fermerSansChanger": "Close without changing context",
  "contexte.feuilleTitre": "Change program or project",
  "contexte.nonVerifie": "Context not verified: network unavailable, context change blocked",
  "contexte.organisation": "Organisation",
  "contexte.organisationInconnue": "unknown organisation",
  "contexte.pastilleAria": "Project: {{nom}} — change",
  "contexte.pastilleAucun": "Choose a project",
  "contexte.perspective": "Perspective",
  "contexte.perspectiveProgrammes": "Programs",
  "contexte.perspectiveProjets": "Projects",
  "contexte.programmeParent": "Parent program",
  "contexte.programmeVide": "No project attached to this program: {{n}} / {{total}}",
  "contexte.projetCourant": "Current project",
  "contexte.projetHorsProgramme": "Project “{{projet}}” is not in program “{{programme}}”. Choose a project of the program, or stay in the previous context.",
  "contexte.rechercherProgramme": "Search a program",
  "contexte.rechercherProjet": "Search a project",
  "contexte.reessayer": "Retry",
  "contexte.region": "Work context",
  "contexte.rester": "Stay in “{{projet}}”",
  "contexte.revenirParent": "Back to an accessible context",
  "contexte.sansProgramme": "No program",
  "contexte.selectionBloquee": "Selection blocked: context not verified",
  "contexte.voirTousProjets": "See all projects",
  "create.idea": "New idea",
  "create.menu": "Create",
  "create.menuTiroir": "Create…",
  "create.menuTiroirDetail": "project, idea, story",
  "create.program": "New program",
  "create.project": "New project",
  "create.story": "New story",
  "ctx.clear": "all",
  "ctx.filterTitle": "{{n}} of {{total}} projects linked to this program",
  "dashboard.activeWorkspace": "Active workspace",
  "dashboard.aggregating": "Aggregating…",
  "dashboard.approved": "Approved",
  "dashboard.available": "Available",
  "dashboard.availableAgents": "Available agents",
  "dashboard.by": "by",
  "dashboard.colApprovals": "Approvals",
  "dashboard.colDocuments": "Documents",
  "dashboard.colInProgress": "In progress",
  "dashboard.colJobsPending": "Pending jobs",
  "dashboard.colWorkspace": "Workspace",
  "dashboard.createFirstWorkspace": "Create my first workspace",
  "dashboard.depositFirstIdea": "Submit my first idea",
  "dashboard.description": "Overview of your workspaces, the delivery journey and the runtime.",
  "dashboard.emptyWorkspaceIntro": "Your workspace is empty. Follow the cycle, from idea to publishing:",
  "dashboard.getStarted": "Get started",
  "dashboard.kpiApprovals": "approvals pending",
  "dashboard.kpiDocuments": "ingested documents",
  "dashboard.kpiJobs": "jobs running or pending",
  "dashboard.kpiWorkspaces": "projects",
  "dashboard.loadingWorkspaces": "Loading workspaces…",
  "dashboard.noAgents": "No agent configured",
  "dashboard.noDecisions": "No decision made",
  "dashboard.noDecisionsHint": "Artifact approvals and rejections will appear here.",
  "dashboard.noDescription": "No description",
  "dashboard.noModels": "No model served",
  "dashboard.noModelsHint": "Is the inference runtime started?",
  "dashboard.noWorkspaceToAggregate": "No workspace to aggregate",
  "dashboard.noWorkspaces": "No workspace",
  "dashboard.noWorkspacesHint": "A workspace groups a project's ideas, specifications, backlog and artefacts. Create the first one: you will own it.",
  "dashboard.onboardingApproveDesc": "Validate the artifact (creator ≠ approver).",
  "dashboard.onboardingApproveTitle": "Approve the spec",
  "dashboard.onboardingBacklogDesc": "Epics and stories from the approved spec.",
  "dashboard.onboardingBacklogTitle": "Generate the backlog",
  "dashboard.onboardingCodeDesc": "The worker writes, tests and opens an MR.",
  "dashboard.onboardingCodeTitle": "Generate the code",
  "dashboard.onboardingDeployDesc": "Pipelines and traced publishing.",
  "dashboard.onboardingDeployTitle": "Publish / deploy",
  "dashboard.onboardingIdeaDesc": "Describe a need; it is scoped automatically.",
  "dashboard.onboardingIdeaTitle": "Submit an idea",
  "dashboard.portfolio": "Portfolio",
  "dashboard.quoi": "workspaces",
  "dashboard.recentDecisions": "Recent decisions",
  "dashboard.rejected": "Rejected",
  "dashboard.servedModels": "Served models",
  "dashboard.title": "Dashboard",
  "dashboard.workspaces": "Workspaces",
  "density.toggleComfortable": "Density: comfortable (click for compact)",
  "density.toggleCompact": "Density: compact (click for comfortable)",
  "dependencies.badgeBlocking": "Blocking",
  "dependencies.badgeSatisfied": "Satisfied",
  "dependencies.chooseSpace": "Choose a space…",
  "dependencies.colAction": "Action",
  "dependencies.colExpectedArtifact": "Expected artifact",
  "dependencies.colState": "State",
  "dependencies.colWaitsForSpace": "Waits for space",
  "dependencies.declareButton": "Declare the dependency",
  "dependencies.declareHeading": "Declare a dependency",
  "dependencies.declaredHeading": "Declared dependencies",
  "dependencies.description": "Declare that one space is waiting for an artifact from another: publication of the dependent space stays blocked until the upstream has delivered.",
  "dependencies.emptyHint": "This space depends on no other to publish.",
  "dependencies.emptyTitle": "No dependency declared",
  "dependencies.expectedArtifactLabel": "Expected artifact (path fragment)",
  "dependencies.expectedSpaceLabel": "Expected space",
  "dependencies.hintRequired": "Name the expected artefact, for example “cadrage.md”.",
  "dependencies.loading": "Loading dependencies…",
  "dependencies.quoi": "dependencies",
  "dependencies.readOnlyNotice": "Read-only — declaration reserved for contributors.",
  "dependencies.remove": "Remove",
  "dependencies.spaceRequired": "Pick the space this one depends on.",
  "dependencies.title": "Cross-project dependencies",
  "deps.addedToast": "Dependency added",
  "deps.removedToast": "Dependency removed",
  "display.density": "Density",
  "display.menu": "Display preferences",
  "display.technical": "Technical identifiers",
  "display.theme": "Theme",
  "doc.decisions": "decisions",
  "doc.desc": "Regenerated from current data on every open — never stale.",
  "doc.download": "Download (.md)",
  "doc.generatedOn": "generated on",
  "doc.loading": "Generating documentation…",
  "doc.noWs": "No workspace selected",
  "doc.pickWs": "Choose a workspace to generate its documentation.",
  "doc.regen": "Regenerate",
  "doc.refreshing": "Regenerating…",
  "doc.refreshingStatus": "Regenerating documentation from the current data…",
  "doc.regionLabel": "Project documentation",
  "doc.reqs": "requirements",
  "doc.sprints": "sprints",
  "doc.title": "Living documentation",
  "editor.contentLabel": "Content (Markdown, frontmatter included)",
  "editor.contentRequired": "The new version cannot be empty.",
  "editor.description": "Edit an approved specification: the new version goes for approval (decided by someone other than you) before being published.",
  "editor.emptyHint": "Generate and then approve a specification to be able to edit it.",
  "editor.emptyTitle": "No approved specification",
  "editor.loading": "Loading…",
  "editor.loadingContent": "Loading content…",
  "editor.provenanceNote": "A unique artifact identifier is assigned to the edit; provenance (output fingerprint) is recomputed.",
  "editor.readOnly": "Read-only — editing is reserved for contributors.",
  "editor.savedToast": "Specification saved — awaiting approval",
  "editor.sourceLabel": "Specification to edit",
  "editor.sourcePlaceholder": "Choose a specification…",
  "editor.submit": "Submit the new version for approval",
  "editor.submitting": "Submitting…",
  "editor.title": "Specification editor",
  "empty.openApprovals": "Open the approvals center",
  "empty.openBacklog": "Open the backlog",
  "empty.openSprints": "Open sprints",
  "empty.openTree": "Open the tree",
  "empty.submitIdea": "Submit an idea",
  "export.doneToast": "Workspace export downloaded",
  "feedback.commentLabel": "Comment",
  "feedback.commentPlaceholder": "What was useful, what was missing…",
  "feedback.description": "Rate what the tool produces: the rating and comment feed the continuous improvement of the cards and models.",
  "feedback.emptyHint": "Be the first to rate this workspace.",
  "feedback.emptyTitle": "No feedback",
  "feedback.formTitle": "Leave feedback",
  "feedback.listTitle": "Recent feedback",
  "feedback.loading": "Loading…",
  "feedback.noteLabel": "Rating (1 to 5)",
  "feedback.rating1": "very insufficient",
  "feedback.rating2": "insufficient",
  "feedback.rating3": "fair",
  "feedback.rating4": "good",
  "feedback.rating5": "excellent",
  "feedback.readOnly": "Read-only — leaving feedback is reserved for contributors.",
  "feedback.sentToast": "Feedback sent",
  "feedback.submit": "Send feedback",
  "feedback.submitPending": "Sending…",
  "filters.createdToast": "Filter saved",
  "filters.deleteTitle": "Delete this saved filter?",
  "filters.deleteVerb": "Delete the filter",
  "filters.deletedToast": "Filter deleted",
  "form.legende": "required field",
  "form.required": "required",
  "form.resume": "{{n}} field(s) to fix: {{liste}}",
  "form.resume_one": "{{n}} field to fix: {{liste}}",
  "form.resume_other": "{{n}} fields to fix: {{liste}}",
  "form.tousObligatoires": "All fields are required.",
  "gen.analyzeToast": "Analysis started",
  "gen.backlogToast": "Backlog generation started",
  "gen.childrenToast": "Generation started",
  "gen.codeToast": "Code generation started",
  "gen.epicsToast": "Epic generation started",
  "gen.mrToast": "Merge request proposed",
  "gen.optionsToast": "Options being proposed",
  "gen.personasToast": "Persona generation started",
  "gen.processesToast": "Process mapping started",
  "gen.programEpicsToast": "Generation started",
  "gen.reviewToast": "Review started",
  "gen.specToast": "Specification drafting started",
  "gen.testsToast": "Test design started",
  "generation.carteAucune": "No generation card for this profile.",
  "generation.carteNom": "Card {{carte}} (card registry not published).",
  "generation.carteProfil": "Card",
  "generation.mesureAutreVersion": "Measured on {{mesuree}}, card in service {{courante}}: generability to re-measure.",
  "generation.recuCarte": "receipt {{etat}}",
  "generation.voirCarte": "See in the card registry",
  "gitlab.baseRequired": "The instance URL is required.",
  "gitlab.connect": "Connect",
  "gitlab.connectedTo": "Connected to",
  "gitlab.defaultBranch": "default branch",
  "gitlab.description": "Link the workspace to a GitLab project to track CI/CD status. The token is stored server-side, never returned; a public project is readable without a token.",
  "gitlab.heading": "GitLab Connector",
  "gitlab.instanceUrl": "Instance URL",
  "gitlab.loading": "Loading…",
  "gitlab.noMr": "No open MR.",
  "gitlab.noPipeline": "No pipeline.",
  "gitlab.openMrs": "Open merge requests",
  "gitlab.projectLabel": "Project (path or id)",
  "gitlab.projectPlaceholder": "group/project",
  "gitlab.projectRequired": "The project ID or path is required.",
  "gitlab.recentPipelines": "Recent pipelines",
  "gitlab.savedToast": "Connector saved",
  "gitlab.test": "Test",
  "gitlab.tokenLabel": "Access token",
  "gitlab.tokenOptional": "(optional for a public project)",
  "gitlab.tokenSaved": "(saved — leave empty to keep)",
  "gitlab.update": "Update",
  "graph.desc": "Hierarchy (parent→child) and links (blocks / relates to / duplicates). Hover a node for detail.",
  "graph.empty": "No item",
  "graph.emptyHint": "Break a spec into items to see the graph appear.",
  "graph.explicitLinks": "explicit links",
  "graph.hierLinks": "hierarchy links",
  "graph.items": "items",
  "graph.legendBlocks": "Blocks",
  "graph.legendDuplicates": "Duplicates",
  "graph.legendHierarchy": "Hierarchy",
  "graph.legendRelates": "Relates to",
  "graph.loading": "Building the graph…",
  "graph.resetView": "Reset view",
  "graph.sansRelation": "No relation — the items exist but are neither linked nor in a hierarchy.",
  "graph.title": "Work-item graph (DAG)",
  "graph.zoomIn": "Zoom in",
  "graph.zoomOut": "Zoom out",
  "grp.Concevoir": "Design",
  "grp.Explorer": "Explore",
  "grp.Gouvernance": "Governance",
  "grp.Générer": "Generate",
  "grp.Livraison": "Delivery",
  "grp.Livrer": "Deliver",
  "grp.Piloter": "Steer",
  "grp.Qualité": "Quality",
  "guide.description": "The end-to-end cycle, from idea to release. Every step is clickable: dive in, come back anytime.",
  "guide.blockedNext": "The process is blocked at “{{step}}”: review the prerequisites before continuing.",
  "guide.defaultTemplate": "Built-in template",
  "guide.emptyNext": "Submit an idea to produce the project's first artifact.",
  "guide.nextTitle": "Next action",
  "guide.noWorkspace": "No project selected",
  "guide.openNext": "Open step",
  "guide.openProcess": "View the effective process",
  "guide.pickWorkspace": "Select a project to display its effective process.",
  "guide.processLoading": "Reading prerequisites…",
  "guide.processUnavailable": "The execution plan is currently unavailable.",
  "guide.railIntro": "You are here, at the start of the cycle:",
  "guide.railEffective": "Lifecycle declared for this project:",
  "guide.readyNext": "The capabilities are ready. Start with “{{step}}”.",
  "guide.resolveBlocker": "View prerequisites",
  "guide.sodBody": "Separation of duties requires another owner or reviewer, different from the creator, to approve the decision.",
  "guide.sodTitle": "Good to know: creator ≠ approver",
  "guide.source": "Source: effective project template",
  "guide.startCta": "Get started: submit an idea",
  "guide.stepDefault": "Follow this step of the end-to-end lifecycle.",
  "guide.step.backlog": "Epics → stories → tasks, AI-augmented.",
  "guide.step.cadrage": "The framing (problem, value, risks) goes for approval.",
  "guide.step.code": "The worker writes, tests and opens an MR to approve.",
  "guide.step.idee": "Describe a need in plain language; it is framed automatically.",
  "guide.step.options": "Explore options before locking the specification.",
  "guide.step.publication": "Pipelines and traced release.",
  "guide.step.spec": "The approved specification becomes the source of the backlog.",
  "guide.stepsHeading": "The steps",
  "guide.title": "Getting started",
  "harnaisPlateforme.approuver": "Approve",
  "harnaisPlateforme.bandeauRecus": "{{valides}} of {{actives}} active card(s) carry a valid receipt: in production use, the worker refuses any card without a valid receipt, before calling the model.",
  "harnaisPlateforme.caste.architecte": "architect",
  "harnaisPlateforme.caste.designer": "designer",
  "harnaisPlateforme.caste.eclaireuse": "scout",
  "harnaisPlateforme.caste.garde": "guard",
  "harnaisPlateforme.caste.ouvriere": "worker",
  "harnaisPlateforme.caste.reine": "queen",
  "harnaisPlateforme.caste.reparatrice": "repairer",
  "harnaisPlateforme.caste.verificatrice": "verifier",
  "harnaisPlateforme.chargement": "Reading the card registry…",
  "harnaisPlateforme.col.action": "action",
  "harnaisPlateforme.col.carte": "card",
  "harnaisPlateforme.col.caste": "caste",
  "harnaisPlateforme.col.fenetre": "window",
  "harnaisPlateforme.col.modele": "role → model",
  "harnaisPlateforme.col.recu": "receipt",
  "harnaisPlateforme.col.statut": "status",
  "harnaisPlateforme.copiee": "Copied",
  "harnaisPlateforme.copier": "Copy the command",
  "harnaisPlateforme.demande.approuvee": "approved — to run on the host",
  "harnaisPlateforme.demande.attente": "awaiting approval",
  "harnaisPlateforme.demande.decidee": "decided by {{qui}}",
  "harnaisPlateforme.demande.executee": "executed — valid receipt",
  "harnaisPlateforme.demande.par": "requested by {{qui}} on {{quand}}",
  "harnaisPlateforme.demande.rapport": "Report",
  "harnaisPlateforme.demande.refusee": "refused",
  "harnaisPlateforme.demande.retiree": "withdrawn",
  "harnaisPlateforme.demandeCreee": "Request created: it awaits approval by another administrator.",
  "harnaisPlateforme.demanderQualification": "Request qualification (GPU)",
  "harnaisPlateforme.demandesAide": "The requester does not decide. Once approved, a request gives the promote_prompt.py command to run on the host; it is “executed” when the card carries a valid receipt citing its report.",
  "harnaisPlateforme.demandesTitre": "Promotion requests",
  "harnaisPlateforme.demandesVide": "No promotion request",
  "harnaisPlateforme.demandesVideIndice": "A request starts from the “Promote” button of a qualified card.",
  "harnaisPlateforme.erreur": "The card registry could not be read.",
  "harnaisPlateforme.exige": "Required: 100 % score and coverage, verified model identity, 100 % GPU residency.",
  "harnaisPlateforme.fermer": "Close",
  "harnaisPlateforme.filtre.actives": "Active ({{n}})",
  "harnaisPlateforme.filtre.brouillons": "Drafts ({{n}})",
  "harnaisPlateforme.filtre.candidates": "Candidates ({{n}})",
  "harnaisPlateforme.filtre.promouvables": "Active and promotable ({{n}})",
  "harnaisPlateforme.filtre.toutes": "All ({{n}})",
  "harnaisPlateforme.filtres": "Filter cards by status",
  "harnaisPlateforme.filtreVide": "No card with this status",
  "harnaisPlateforme.filtreVideIndice": "Cards and their status come from the repository prompt registry.",
  "harnaisPlateforme.instantane": "Snapshot published by {{worker}} {{age}} ago ({{quand}}), revision {{rev}}.",
  "harnaisPlateforme.instantaneAncien": "This snapshot is more than 15 minutes old: the worker no longer republishes it. Cards, receipts and resident models may have changed since.",
  "harnaisPlateforme.legende.absent": "never qualified",
  "harnaisPlateforme.legende.perime": "card, model or base changed",
  "harnaisPlateforme.legende.valide": "same version, same subject, same trust base",
  "harnaisPlateforme.legendeTable": "Registry cards, status, caste, model and receipt",
  "harnaisPlateforme.motifManquant": "A refusal carries its reason: at least 10 characters.",
  "harnaisPlateforme.motifRefus": "Reason for refusal (at least 10 characters)",
  "harnaisPlateforme.note": "Note for the approver (optional)",
  "harnaisPlateforme.poste.aucunResident": "No model resident in VRAM at snapshot time.",
  "harnaisPlateforme.poste.budget": "{{carte}} · budget {{budget}} MiB of {{total}} MiB",
  "harnaisPlateforme.poste.degrade": "degraded",
  "harnaisPlateforme.poste.fenetre": "resident window ≤ {{n}}",
  "harnaisPlateforme.poste.permutation": "{{a}} and {{b}} do not fit together in VRAM ({{somme}} > {{budget}} MiB): a review by the other family forces a swap.",
  "harnaisPlateforme.poste.residents": "Resident: {{liste}}",
  "harnaisPlateforme.poste.sondeIndisponible": "The residency probe did not answer the worker: the models actually loaded are unknown.",
  "harnaisPlateforme.poste.titre": "Station models",
  "harnaisPlateforme.promouvoir": "Promote",
  "harnaisPlateforme.promouvoirTitre": "Promote {{nom}} {{version}}",
  "harnaisPlateforme.qualificationAide": "Run on the GPU host: missions go first. The published canonical report appears here at the next worker snapshot.",
  "harnaisPlateforme.rapportRefuse": "refused",
  "harnaisPlateforme.rapportsPublies": "Reports published for this version",
  "harnaisPlateforme.rapportSurModele": "Qualification report on the model of its role ({{modele}}, pinned digest {{digest}}).",
  "harnaisPlateforme.recu.absent": "missing",
  "harnaisPlateforme.recu.perime": "stale",
  "harnaisPlateforme.recu.valide": "valid",
  "harnaisPlateforme.refus.absent": "No registry snapshot has been published by the worker.",
  "harnaisPlateforme.refus.autre": "Action refused by the gateway.",
  "harnaisPlateforme.refus.close": "The request is closed.",
  "harnaisPlateforme.refus.dejaActive": "Card already active: a new version gets qualified in turn.",
  "harnaisPlateforme.refus.demandeOuverte": "A request is already open for this version.",
  "harnaisPlateforme.refus.injection": "A blocking injection suite of at least 3 cases is required.",
  "harnaisPlateforme.refus.modele": "No approved model (pinned digest) for the card role.",
  "harnaisPlateforme.refus.nonEnAttente": "The request is no longer awaiting a decision.",
  "harnaisPlateforme.refus.nonPromouvable": "The registry does not declare this card promotable.",
  "harnaisPlateforme.refus.perime": "The registry snapshot is more than an hour old: the worker no longer publishes.",
  "harnaisPlateforme.refus.rapport": "No qualification report for this version.",
  "harnaisPlateforme.refus.rapportRefuse": "This report is published but the runtime refuses it.",
  "harnaisPlateforme.refus.sod": "You requested this promotion: another administrator will approve it.",
  "harnaisPlateforme.refus.version": "The card changed version since the request.",
  "harnaisPlateforme.refusAcces": "The card registry is reserved to platform administration.",
  "harnaisPlateforme.refuser": "Refuse",
  "harnaisPlateforme.registreTitre": "Card registry",
  "harnaisPlateforme.repli": "fallback {{role}} → {{modele}}",
  "harnaisPlateforme.residence.depasse": "{{fenetre}} > {{limite}}: overflows the GPU card",
  "harnaisPlateforme.residence.nonMesuree": "{{fenetre}}: residency not measured for this model",
  "harnaisPlateforme.residence.pleine": "{{fenetre}} ≤ {{limite}}: 100 % resident",
  "harnaisPlateforme.retirer": "Withdraw the request",
  "harnaisPlateforme.sodDemande": "You are requesting this promotion: another platform administrator will approve it.",
  "harnaisPlateforme.statut.active": "active",
  "harnaisPlateforme.statut.candidate": "candidate",
  "harnaisPlateforme.statut.deprecated": "deprecated",
  "harnaisPlateforme.statut.draft": "draft",
  "harnaisPlateforme.suiteInjection": "Blocking injection suite: {{n}} cases",
  "harnaisPlateforme.versProfils": "Qualified generation profiles",
  "harnaisPlateforme.vide": "No registry snapshot published",
  "harnaisPlateforme.videIndice": "The worker publishes the card registry and the station models when it starts, then every 5 minutes. Start the worker on the GPU host.",
  "history.colAction": "Action",
  "history.colDocument": "Document",
  "history.colJob": "Job",
  "history.colStatus": "Status",
  "history.colUpdated": "Updated",
  "history.emptyHint": "Drop an idea or upload a document: the work will appear here.",
  "history.emptyTitle": "No job in this workspace",
  "history.hide": "Hide",
  "history.loading": "Loading history…",
  "history.pageTitle": "History",
  "history.quoi": "jobs",
  "ideas.approvalsCenter": "approvals center",
  "ideas.charsRemaining": "more characters needed",
  "ideas.formTitle": "Your idea",
  "ideas.ideaLabel": "Idea in plain language",
  "ideas.ideaPlaceholder": "Example: our managers re-enter the same information between two tools; I want…",
  "ideas.ideaSubmittedBadge": "Idea submitted",
  "ideas.minCharsHint": "Describe the idea in at least 30 characters — below that, there is nothing to frame",
  "ideas.noWorkspaceSelected": "No workspace selected",
  "ideas.pageDescription": "Describe what you want to achieve, in your own words. The system derives a framing document from it — problem, users, value, constraints, risks and open questions — that a reviewer will need to approve. Grey areas become questions, never assumptions.",
  "ideas.pageTitle": "Submit an idea",
  "ideas.readOnlyNotice": "Read-only — your role does not allow submitting an idea.",
  "ideas.resultCadrage": "framing",
  "ideas.resultLeadIn": "It becomes a ",
  "ideas.resultMiddle": " (generated by the model below), then follows the cycle. The framing will await its decision at the ",
  "ideas.submitButton": "Submit and frame",
  "ideas.submittedToast": "Idea submitted",
  "ideas.submitting": "Submitting…",
  "impact.affectedByChange": "item(s) potentially affected by a change.",
  "impact.groupBlocked": "Blocked",
  "impact.groupDescendants": "Descendants",
  "impact.groupRelated": "Related",
  "impact.kindBug": "Bug",
  "impact.kindCadrage": "Framing",
  "impact.kindEpic": "Epic",
  "impact.kindFeature": "Feature",
  "impact.kindIdea": "Idea",
  "impact.kindStory": "Story",
  "impact.kindTask": "Task",
  "impact.levelPrefix": "lvl.",
  "impact.linkDuplicates": "duplicates",
  "impact.linkRelated": "linked",
  "impact.loading": "Analyzing…",
  "impact.noDownstream": "No downstream items — this change is isolated.",
  "impact.toggleHide": "Hide impact",
  "impact.toggleShow": "Impact analysis",
  "ingestion.answerHeading": "Answer",
  "ingestion.askButton": "Query",
  "ingestion.chooseModel": "Choose a model…",
  "ingestion.columnChecksum": "Checksum",
  "ingestion.columnFile": "File",
  "ingestion.columnStatus": "Status",
  "ingestion.columnUploadedAt": "Uploaded on",
  "ingestion.description": "Upload documents and query the knowledge base with verifiable citations.",
  "ingestion.documentIngested": "Document ingested",
  "ingestion.documentLabel": "Document",
  "ingestion.dropzoneHint": "Drop a file here, or choose one above.",
  "ingestion.errorNoFile": "Select a file before uploading",
  "ingestion.errorNoModel": "Select a model",
  "ingestion.errorNoQuestion": "Enter a question",
  "ingestion.errorNoWorkspace": "No workspace selected",
  "ingestion.loadingModels": "Loading models…",
  "ingestion.modelLabel": "Model",
  "ingestion.noModelsTitle": "No model is allowed in this workspace",
  "ingestion.noModelsHint": "Allow a model before querying the document base.",
  "ingestion.configureModels": "Configure models",
  "ingestion.noCitationHint": "The answer is not backed by an indexed document.",
  "ingestion.noCitationTitle": "No source cited",
  "ingestion.noSourceHint": "Upload a first document to index it.",
  "ingestion.noSourceTitle": "No source",
  "ingestion.questionLabel": "Question",
  "ingestion.questionPlaceholder": "What are the security requirements?",
  "ingestion.queuedToast": "Document being indexed",
  "ingestion.quoi": "sources",
  "ingestion.ragHeading": "Query the document base",
  "ingestion.readOnlyAsk": "Read-only — your role does not allow querying the document base.",
  "ingestion.readOnlyUpload": "Read-only — your role does not allow uploading a document.",
  "ingestion.searching": "Searching…",
  "ingestion.selectedFile": "Selected:",
  "ingestion.semanticSearch": "Semantic search in progress…",
  "ingestion.sourcesHeading": "Ingested sources",
  "ingestion.sourcesLabel": "Sources",
  "ingestion.title": "Ingestion and querying",
  "ingestion.uploadButton": "Upload",
  "ingestion.uploadHeading": "Upload a document",
  "ingestion.uploading": "Uploading…",
  "item.acceptance": "Acceptance criteria",
  "item.aiActions": "AI actions",
  "item.aiActionsHint": "Generate, analyze, review and propose — from the work object.",
  "item.assignee": "Assignee",
  "item.backToBacklog": "Backlog",
  "item.backToBoard": "Board",
  "item.createdBy": "Created by",
  "item.customFields": "Fields",
  "item.dans": "In",
  "item.effort": "Effort",
  "item.invalid": "Item not found",
  "item.invalidHint": "This link does not point to a valid item.",
  "item.job": "Generation job",
  "item.loading": "Loading item…",
  "item.metadata": "Metadata",
  "item.noSprint": "No sprint",
  "item.notFound": "Item not found",
  "item.notFoundHint": "This item does not exist, or you do not have access to it.",
  "item.open": "Open item page",
  "item.parent": "Parent",
  "item.provenance": "Provenance",
  "item.source": "Source",
  "item.sprint": "Sprint",
  "item.status": "Status",
  "item.unassigned": "Unassigned",
  "itemLabels.emptyHint": "No labels yet — create one.",
  "itemLabels.newLabelPlaceholder": "New label",
  "job.approvalGranted": "Approved by",
  "job.approvalRejected": "Rejected by",
  "job.approvalRequested": "Awaiting approval — a reviewer must decide",
  "job.artifactDiscarded": "Artifact removed (rejected)",
  "job.artifactWritten": "Specification written",
  "job.badgeAwaitingApproval": "Awaiting approval",
  "job.badgeFailed": "Failed",
  "job.badgeInProgress": "In progress",
  "job.badgePublished": "Published",
  "job.badgeRejected": "Rejected",
  "job.claimed": "Picked up by the worker",
  "job.committed": "Published",
  "job.documentFallback": "document",
  "job.doneCommitted": "Done",
  "job.donePending": "Generation complete — artifact submitted for approval",
  "job.emptyDetail": "(the model run locally) picks it up as soon as it is running, and progress is shown here live. If nothing appears, the worker is not started.",
  "job.emptyIntro": "Job queued. The",
  "job.enqueued": "Request recorded",
  "job.executionDetail": "Execution detail",
  "job.failed": "Failed",
  "job.generationFinished": "Generation completed in",
  "job.generationStarted": "Generating",
  "job.generatedTestsExecuted": "Generated tests executed",
  "job.generatedTestsFailed": "tests failed",
  "job.generatedTestsPassed": "tests passed",
  "job.costUnavailable": "cost not measured (no cloud tariff configured)",
  "job.modelFallback": "model",
  "job.progress": "Progress",
  "job.rowCard": "Card",
  "job.rowCost": "Cost",
  "job.rowDuration": "Duration",
  "job.rowInputTokens": "Input tokens",
  "job.rowModel": "Model",
  "job.rowOutputTokens": "Output tokens",
  "job.rowRepairs": "Repairs",
  "job.rowThroughput": "Throughput",
  "job.streamInterrupted": "Stream interrupted. Received events are retained.",
  "job.reconnect": "Reconnect stream",
  "job.unknownCause": "unknown cause",
  "labels.createdToast": "Label created",
  "lang.label": "Language",
  "lifecycle.Approbation": "Approval",
  "lifecycle.Backlog": "Backlog",
  "lifecycle.Code": "Code",
  "lifecycle.Idée": "Idea",
  "lifecycle.Publication": "Release",
  "lifecycle.Spécification": "Specification",
  "lifecycleRail.backlog": "Backlog",
  "lifecycleRail.cadrage": "Framing",
  "lifecycleRail.code": "Code",
  "lifecycleRail.idee": "Idea",
  "lifecycleRail.options": "Options",
  "lifecycleRail.publication": "Release",
  "lifecycleRail.spec": "Specification",
  "links.add": "Link",
  "links.blocksIncoming": "blocked by",
  "links.blocksOutgoing": "blocks",
  "links.createdToast": "Link created",
  "links.deleteConsequence": "The link disappears from both items. The items themselves are unchanged.",
  "links.deleteTitle": "Delete the link to #{{id}}?",
  "links.deleteVerb": "Delete the link",
  "links.deletedToast": "Link deleted",
  "links.duplicatesIncoming": "duplicated by",
  "links.duplicatesOutgoing": "duplicates",
  "links.empty": "No links.",
  "links.relatesToIncoming": "relates to",
  "links.relatesToOutgoing": "relates to",
  "links.selectPlaceholder": "Choose an item…",
  "login.contributor": "Contributor",
  "login.demo": "DEMO ACCOUNTS",
  "login.demoLocal": "Local demo",
  "login.error": "Sign-in failed.",
  "login.hint": "One click fills the form; “Sign in” submits.",
  "login.identifier": "Username",
  "login.owner": "Owner",
  "login.password": "Password",
  "login.rateLimited": "Too many attempts. Try again in {{seconds}} seconds.",
  "login.reader": "Reader",
  "login.submit": "Sign in",
  "login.submitting": "Signing in…",
  "login.subtitle": "Access your workspace.",
  "login.tagline": "The augmented software factory, from idea to release.",
  "login.title": "Sign in",
  "markdown.editTab": "Edit",
  "markdown.mermaidChargement": "Diagram not loaded: the connection seems interrupted. It will be requested again next time it is displayed.",
  "markdown.mermaidError": "Diagram could not be rendered — check the Mermaid syntax.",
  "markdown.previewEmpty": "Nothing to preview yet.",
  "markdown.previewTab": "Preview",
  "missions.age.days": "{{n}} d",
  "missions.age.hours": "{{n}} h",
  "missions.age.minutes": "{{n}} min",
  "missions.age.seconds": "{{n}} s",
  "missions.ago": "{{age}} ago",
  "missions.backToList": "Back to missions",
  "missions.board.empty": "No object posted yet.",
  "missions.board.loading": "Reading the blackboard…",
  "missions.board.newer": "Newer",
  "missions.board.older": "Older",
  "missions.board.provenance": "provenance",
  "missions.board.range": "{{a}}–{{b}} of {{n}}",
  "missions.board.title": "Blackboard register",
  "missions.cancel": "Cancel",
  "missions.caste.architecte": "Architect",
  "missions.caste.avanceur": "Advancer",
  "missions.caste.designer": "Designer",
  "missions.caste.eclaireuse": "Scout",
  "missions.caste.garde": "Guard",
  "missions.caste.greffiere": "Clerk",
  "missions.caste.humain": "Human",
  "missions.caste.livreuse": "Deliverer",
  "missions.caste.ouvriere": "Worker",
  "missions.caste.reine": "Queen",
  "missions.caste.reparatrice": "Repairer",
  "missions.caste.verificatrice_conception": "Verifier (design)",
  "missions.caste.verificatrice_execution": "Verifier (execution)",
  "missions.cockpit.active": "active",
  "missions.cockpit.approver": "Plan approved by",
  "missions.cockpit.budget": "Mission budget",
  "missions.cockpit.castes": "Castes",
  "missions.cockpit.dependsOn": "depends on {{d}}",
  "missions.cockpit.failed": "The mission failed: {{r}}",
  "missions.cockpit.graph": "Task graph",
  "missions.cockpit.job": "Current job",
  "missions.cockpit.level": "Level {{n}}",
  "missions.cockpit.loading": "Reading the mission cockpit…",
  "missions.cockpit.planning": "The queen is preparing the plan (job {{j}}: {{s}}).",
  "missions.cockpit.progress": "Progress: {{f}} task(s) done out of {{n}}",
  "missions.cockpit.progressLabel": "Tasks done",
  "missions.cockpit.requester": "Requested by",
  "missions.cockpit.rounds": "Correction rounds",
  "missions.cockpit.started": "started {{age}} ago",
  "missions.cockpit.steps": "Steps enqueued",
  "missions.cockpit.stopReason": "Stop reason: {{r}}",
  "missions.cockpit.suspended": "Suspended: {{r}}",
  "missions.cockpit.tasksCaption": "Tasks, caste, state, round, checks and last signal",
  "missions.cockpit.title": "Mission cockpit",
  "missions.col.caste": "Caste",
  "missions.col.checks": "Checks",
  "missions.col.dependsOn": "Depends on",
  "missions.col.estimate": "GPU estimate",
  "missions.col.round": "Round",
  "missions.col.signal": "Reason / last signal",
  "missions.col.state": "State",
  "missions.col.task": "Task",
  "missions.createdAgo": "launched {{age}} ago",
  "missions.decision.acceptStop": "Acknowledge the stop",
  "missions.decision.acknowledge": "Acknowledge",
  "missions.decision.announce": "Decision recorded on the blackboard.",
  "missions.decision.errReorient": "Reorienting requires an instruction.",
  "missions.decision.instruction": "Instruction (to reorient)",
  "missions.decision.otherFamily": "Hand over once to another model family",
  "missions.decision.reorient": "Reorient",
  "missions.decision.takeOver": "Take over",
  "missions.emptyHint": "A mission is launched from an approved specification, a sprint or a list of defects, with a budget in GPU minutes.",
  "missions.emptyHintReader": "A contributor or the workspace owner launches missions.",
  "missions.emptyTitle": "No mission in this workspace",
  "missions.escalations": "Escalations",
  "missions.evidence.back": "Back to the mission cockpit",
  "missions.evidence.checks": "Real-path checks · {{p}} / {{n}}",
  "missions.evidence.cost": "Cost",
  "missions.evidence.costDetail": "{{j}} tokens · {{s}} s of generation",
  "missions.evidence.costValue": "{{m}} GPU min",
  "missions.evidence.decision": "Decision",
  "missions.evidence.diff": "Diff",
  "missions.evidence.hiddenTests": "Hidden tests",
  "missions.evidence.junit": "JUnit: {{r}}",
  "missions.evidence.loading": "Reading the evidence file…",
  "missions.evidence.noChecks": "Check details not posted.",
  "missions.evidence.noReview": "No review posted.",
  "missions.evidence.noRounds": "No round run.",
  "missions.evidence.notYet": "The clerk has not yet posted this task’s evidence file.",
  "missions.evidence.opinionTag": "opinion — does not decide",
  "missions.evidence.path": "File",
  "missions.evidence.redCheck": "Red check: {{n}} — {{m}}",
  "missions.evidence.redChecks": "Red checks before → after",
  "missions.evidence.ref": "Reference and fingerprint",
  "missions.evidence.requirements": "Requirements covered",
  "missions.evidence.reviews": "Guard reviews",
  "missions.evidence.roundTests": "{{p}} / {{n}} ({{s}} skipped)",
  "missions.evidence.rounds": "Correction rounds",
  "missions.evidence.roundsTitle": "Correction rounds",
  "missions.evidence.stopReason": "Stop reason: {{r}}",
  "missions.evidence.subtitle": "Evidence file · mission “{{m}}” · task {{r}}",
  "missions.evidence.tests": "Tests run",
  "missions.evidence.testsDetail": "{{p}} green · {{f}} red · {{s}} skipped / {{n}} · exit code {{c}}",
  "missions.experimental": "experimental",
  "missions.form.autoAuto": "automatic",
  "missions.form.autoDeploy": "Deploy, promote, touch the organisation",
  "missions.form.autoGenerate": "Generate, fix, test in the sandbox",
  "missions.form.autoHuman": "blocking — human",
  "missions.form.autoMerge": "Merge a reviewed feature",
  "missions.form.autoNotified": "after the evidence file is approved",
  "missions.form.autonomy": "Autonomy per action type",
  "missions.form.budget": "Budget and limits",
  "missions.form.choose": "— choose —",
  "missions.form.defects": "Defects to fix",
  "missions.form.description": "Start gate: subject, mode and budget. The queen then proposes the plan, which another member approves before any write.",
  "missions.form.errDefects": "Tick at least one defect.",
  "missions.form.errEscalations": "Between 0 and 20 escalations.",
  "missions.form.errGpu": "Between 1 and 1,440 GPU minutes.",
  "missions.form.errRounds": "Between 1 and 3 rounds: beyond that, correction stops improving (ART-0171 § 4.3).",
  "missions.form.errSpec": "Choose the approved specification.",
  "missions.form.errSprint": "Choose the sprint to run.",
  "missions.form.escalations": "Escalations before stopping",
  "missions.form.items": "{{n}} items",
  "missions.form.kind": "Mission kind",
  "missions.form.mode": "Harness execution mode",
  "missions.form.modeA": "A — wrapped coding agent",
  "missions.form.modeAHelp": "Open agent on the local engine; same invariants, otherwise refused at launch.",
  "missions.form.modeB": "B — native harness (4 tools)",
  "missions.form.modeBHelp": "Read, write, run the checks, finish — in the sandbox.",
  "missions.form.modeC": "C — loop in the orchestrator",
  "missions.form.modeCHelp": "The harness runs and returns structured feedback; no tools for the model.",
  "missions.form.modesFromTemplate": "Modes allowed by the project template: {{m}} (ADR-0108).",
  "missions.form.noDefects": "No open defect in this workspace.",
  "missions.form.readOnly": "Your role in this workspace does not allow launching a mission.",
  "missions.form.rounds": "Correction rounds per task",
  "missions.form.spec": "Approved specification",
  "missions.form.sprint": "Sprint",
  "missions.form.stopsBudget": "Automatic stops: {{n}} round(s) · 2 unproductive rounds · action repeated 3 times · oscillation · budget exhausted.",
  "missions.form.subject": "Subject",
  "missions.form.submit": "Launch — the queen proposes the plan",
  "missions.form.title": "Title (optional)",
  "missions.gpuMinutes": "GPU minutes",
  "missions.gpuMinutesShort": "GPU min",
  "missions.kind.fix_defects": "Fix defects",
  "missions.kind.generate_app": "Generate an application",
  "missions.kind.sprint": "Run a sprint",
  "missions.launch": "Launch a mission",
  "missions.loading": "Loading missions…",
  "missions.minutesShort": "{{n}} min",
  "missions.modeShort": "Mode {{m}}",
  "missions.obj.checks": "checks {{p}} / {{t}}",
  "missions.obj.cost": "{{s}} s of GPU",
  "missions.obj.decision": "decision: {{r}}",
  "missions.obj.escalation": "escalation: {{r}}",
  "missions.obj.stop": "stop: {{r}}",
  "missions.obj.tests": "tests {{p}} green, {{f}} red, exit code {{c}}",
  "missions.opinion": "opinion",
  "missions.pageDescription": "Harness mode: the colony runs a sprint, generates an application or fixes defects between two human gates — plan and budget at the start, evidence file at the end.",
  "missions.pageTitle": "Missions",
  "missions.plan.announceApproved": "Plan approved: the colony starts.",
  "missions.plan.announceRejected": "Plan rejected: the mission is stopped.",
  "missions.plan.approve": "Approve and launch",
  "missions.plan.budget": "Approved budget",
  "missions.plan.budgetLine": "Budget: {{g}} GPU min · {{r}} rounds per task · {{e}} escalations",
  "missions.plan.caption": "Plan tasks, in order",
  "missions.plan.confirmReject": "Confirm rejection",
  "missions.plan.errBudget": "Budget out of bounds: 1 to 1,440 minutes, 1 to 3 rounds, 0 to 20 escalations.",
  "missions.plan.errReason": "Rejecting a plan requires a reason.",
  "missions.plan.readOnly": "A contributor or the workspace owner approves the plan.",
  "missions.plan.reason": "Rejection reason",
  "missions.plan.reject": "Reject with a reason",
  "missions.plan.sod": "You launched this mission: another member must approve its plan and budget (separation of duties).",
  "missions.plan.title": "Plan proposed by the queen",
  "missions.plan.untilApproval": "until your approval",
  "missions.reason.budget": "budget exhausted",
  "missions.reason.completed": "completed",
  "missions.reason.converged": "converged",
  "missions.reason.enqueue_refused": "step refused by a guard",
  "missions.reason.human_stop": "human stop",
  "missions.reason.human_takeover": "taken over by a human",
  "missions.reason.max_rounds": "round cap reached",
  "missions.reason.mission_stopped": "mission stopped",
  "missions.reason.oscillation": "oscillation between two diffs",
  "missions.reason.plan_failed": "plan failed",
  "missions.reason.plan_rejected": "plan rejected",
  "missions.reason.repetition": "repeated action",
  "missions.reason.step_failed": "step failed",
  "missions.reason.suspension_prolongee": "prolonged wait",
  "missions.reason.unproductive": "two unproductive rounds",
  "missions.roundN": "round {{n}}",
  "missions.roundsShort": "Rounds",
  "missions.status.draft": "Plan in preparation",
  "missions.status.failed": "Failed",
  "missions.status.plan_approved": "Plan approved",
  "missions.status.plan_proposed": "Plan to approve",
  "missions.status.running": "Running",
  "missions.status.stopped": "Stopped",
  "missions.status.succeeded": "Succeeded",
  "missions.status.suspended": "Suspended",
  "missions.stop.announce": "Mission stopped. The running job finishes its step.",
  "missions.stop.button": "Stop the mission",
  "missions.stop.confirmTitle": "Stop the mission “{{t}}”?",
  "missions.stop.effect1": "No new step starts: the queued job is cancelled, and so are tasks not yet started.",
  "missions.stop.effect2": "A job the worker has already started finishes its step: it is not killed.",
  "missions.stop.reason": "Reason (optional)",
  "missions.stop.reversibility": "A new mission can be launched on the same subject.",
  "missions.stop.verb": "Stop",
  "missions.suspension.admission": "admission refused by the engine",
  "missions.suspension.capacity": "application instance cap reached",
  "missions.suspension.human": "waiting for a human decision",
  "missions.suspension.vram": "a foreign model occupies GPU memory",
  "missions.taskStatus.cancelled": "Cancelled",
  "missions.taskStatus.pending": "To do",
  "missions.taskStatus.ready": "Ready",
  "missions.taskStatus.running": "Running",
  "missions.taskStatus.stopped": "Stopped",
  "missions.taskStatus.succeeded": "Done",
  "missions.tasksDone": "Tasks done",
  "missions.type.checks": "checks",
  "missions.type.commit": "commit",
  "missions.type.cost": "cost",
  "missions.type.decision": "decision",
  "missions.type.escalation": "escalation",
  "missions.type.evidence": "evidence file",
  "missions.type.plan": "plan",
  "missions.type.round": "round",
  "missions.type.stop": "stop",
  "missions.type.task_started": "task started",
  "missions.type.tests": "tests",
  "missions.type.verdict": "opinion",
  "missions.waitingHuman": "Waiting for a human",
  "missions.waitingHumanCount": "Waiting for a human ({{n}})",
  "mutation.ok": "Change saved",
  "n28.pastilleAria": "Next action for your role ({{role}}): {{action}}, pending for {{depuis}}",
  "nav./": "Home",
  "nav./admin": "Project settings",
  "nav./approvals": "Decisions to make",
  "nav./artifacts": "Published artifacts",
  "nav./attention": "Attention inbox",
  "nav./invitations": "Invitations",
  "nav./backlog": "Board",
  "nav./chat": "Project assistant",
  "nav./compare": "Compare models",
  "nav./config": "Templates",
  "nav./dependencies": "Cross-project dependencies",
  "nav./documentation": "Documentation",
  "nav./editor": "Specification editor",
  "nav./feedback": "Feedback on generations",
  "nav./graph": "Graph",
  "nav./guide": "Getting started",
  "nav./history": "Job log",
  "nav./ideas": "Submit an idea",
  "nav./ingestion": "Sources and knowledge",
  "nav./missions": "Missions",
  "nav./notifications": "Notifications",
  "nav./pipelines": "Pipelines",
  "nav./quotas": "Quotas and tier",
  "nav./programs": "Programmes",
  "nav./roadmap": "Roadmap",
  "nav./scorecard": "Indicators",
  "nav./sprints": "Sprints",
  "nav./timeline": "Activity",
  "nav./traceability": "Coverage and traceability",
  "nav./tree": "Tree",
  "nav./workflow": "Custom agents",
  "nav.aidePriseEnMain": "Help and getting started",
  "nav.backlog": "Backlog",
  "nav.entreesBarreHaute": "Top bar entries",
  "nav.fermerMenu": "Close the menu",
  "nav.menu": "Menu",
  "nav.nonLues": "{{n}} unread",
  "nav.notifications": "Notifications",
  "nav.ouvrirMenu": "Open the menu",
  "nav.parent.programme": "Organisation level",
  "nav.parent.projet": "Program level",
  "nav.processus": "Lifecycle and process",
  "nav.rechercherTiroir": "Search a screen, an action…",
  "nav.roadmap": "Roadmap",
  "nav.sprints": "Sprints",
  "navdesc./": "Your profile view: what awaits your decision and where the work stands",
  "navdesc./admin": "Members, allowed models and agents, quotas and integrations of the project",
  "navdesc./approvals": "Review, check and decide on produced documents: who must act, and why",
  "navdesc./artifacts": "Index of published artifacts, with digest and provenance",
  "navdesc./attention": "What awaits a decision, with its age: approvals, colony, defects to verify, waivers",
  "navdesc./invitations": "Join a space: your pending invitations; an invitation link opens here",
  "navdesc./backlog": "The work board: epics, stories, tasks — per-item code generation",
  "navdesc./chat": "Talk with the assistant in the project context",
  "navdesc./compare": "One prompt, several models: compare their answers",
  "navdesc./config": "Templates: item model, lifecycles, agents, models and routing, modes",
  "navdesc./dependencies": "Declare dependencies between projects",
  "navdesc./documentation": "Living project documentation, readable on screen",
  "navdesc./editor": "Edit an approved specification as a new version, Spec Gate",
  "navdesc./feedback": "Rate AI outputs and read the feedback",
  "navdesc./graph": "Interactive work-item DAG: hierarchy and links",
  "navdesc./guide": "The end-to-end cycle, clickable — come back whenever you like",
  "navdesc./history": "All past jobs and their glass box",
  "navdesc./ideas": "New request: describe the idea, then start its framing",
  "navdesc./ingestion": "Upload documents and query the document base",
  "navdesc./missions": "Launch a colony mission, steer it and read its evidence file",
  "navdesc./notifications": "Your @mentions and alerts; mark as read",
  "navdesc./pipelines": "Define and run pipelines, link a run to its deployment",
  "navdesc./programs": "The programmes you are a member of; create a programme",
  "navdesc./quotas": "Current consumption and limits of your space and AI models",
  "navdesc./roadmap": "Sprint timeline (Gantt), progress and \"today\"",
  "navdesc./scorecard": "Delivery, DORA, AI, governance and service objectives computed from data",
  "navdesc./sprints": "Agile iterations: commitment, progress, velocity",
  "navdesc./timeline": "Unified chronological feed of project events",
  "navdesc./traceability": "Requirement → code → test → defect, and the coverage gaps",
  "navdesc./tree": "Unified Epic→Feature→US→Task tree, AI-augmented",
  "navdesc./workflow": "Run a custom agent and follow its trace",
  "newWs.creating": "Creating…",
  "newWs.descriptionLabel": "Description",
  "newWs.descriptionPlaceholder": "What is this project for?",
  "newWs.nameAide": "This name appears in the project selector.",
  "newWs.nameLabel": "Project name",
  "newWs.namePlaceholder": "E.g. Insurance core modernization",
  "newWs.nameTooShort": "Name must be at least 3 characters long",
  "newWs.optional": "(optional)",
  "newWs.templateDefaultOption": "Default (built-in)",
  "newWs.templateHint": "The way of working (item types, workflow, links) for this project.",
  "newWs.templateLabel": "Configuration template",
  "newWs.title": "New workspace",
  "newWs.triggerButton": "New workspace",
  "notFound.backLink": "Back to dashboard",
  "notFound.heading": "Page not found",
  "notFound.message": "This address does not match any screen. Use the navigation or the command palette (Ctrl+K).",
  "navigation.mode.discovery": "Discovery mode",
  "navigation.mode.full": "Full mode",
  "navigation.mode.hidden": "{{count}} more tools via ⌘K",
  "navigation.mode.simplify": "Reduce to essential actions",
  "notif.all": "All",
  "notif.allReadToast": "All notifications marked as read",
  "notif.desc": "Your @mentions and alerts. Click an entry to jump to the item.",
  "notif.empty": "No notification",
  "notif.emptyHint": "You will be notified about mentions, approvals, or incidents.",
  "notif.approvalGranted": "approved your artifact",
  "notif.approvalRejected": "rejected your artifact",
  "notif.processApprovalRequested": "requests your approval for a process step",
  "notif.pipelineFailure": "reported a pipeline failure",
  "notif.deployFailure": "reported a deployment failure",
  "notif.emptyUnread": "No unread notification",
  "notif.loading": "Loading notifications…",
  "notif.markAll": "Mark all read",
  "notif.markRead": "Read",
  "notif.mentioned": "mentioned you",
  "notif.on": "on",
  "notif.system": "System",
  "notif.title": "Notifications",
  "notif.unread": "Unread",
  "odoo.aucune": "No Odoo connection",
  "odoo.aucuneIndice": "Enter the instance, the database and a technical account.",
  "odoo.base": "Database",
  "odoo.champRequis": "This field is required.",
  "odoo.chargement": "Reading the Odoo connection…",
  "odoo.configuree": "configured",
  "odoo.connecte": "connected",
  "odoo.connecteDetail": "uid {{uid}}{{version}}",
  "odoo.connecter": "Connect Odoo",
  "odoo.creer": "Create",
  "odoo.creerPartenaire": "Create a partner",
  "odoo.description": "Credentials are encrypted at rest and never shown again: each time you save, the password is entered again.",
  "odoo.enregistre": "Odoo connection saved",
  "odoo.enregistrer": "Save",
  "odoo.identifiant": "Login",
  "odoo.majLe": "updated on {{quand}}",
  "odoo.motDePasse": "Password",
  "odoo.motDePassePh": "enter again to save",
  "odoo.partenaireCree": "Partner no. {{id}} created and read back from Odoo.",
  "odoo.partenaireRequis": "Give the partner's name.",
  "odoo.partenaires": "Partners (res.partner)",
  "odoo.refus": "The Odoo connection is set by the project owner: it is not open to you.",
  "odoo.refusSansConnexion": "Save a connection first: testing and creating a partner require it.",
  "odoo.testEnCours": "Authenticating with Odoo…",
  "odoo.tester": "Test the connection",
  "odoo.titre": "Project Odoo (CRM) connection",
  "odoo.url": "Instance URL",
  "odoo.urlAide": "http(s) only; the host must be in the allowed egress list.",
  "quarantaine.statut.DEAD_LETTER": "dead letter",
  "quarantaine.statut.RETRY_WAIT": "retry pending",
  "quarantaine.statut.PENDING": "pending",
  "quarantaine.statut.LEASED": "being delivered",
  "quarantaine.statut.DELIVERED": "delivered",
  "quarantaine.cause.UNKNOWN_KEY": "unknown key",
  "quarantaine.cause.RETIRED_KEY": "retired key",
  "quarantaine.cause.MISSING_ALIAS": "missing alias",
  "quarantaine.cause.INVALID_KEY": "invalid key",
  "quarantaine.rejoue": "Event replayed — it is being delivered again",
  "quarantaine.titre": "Quarantined events (outbox)",
  "quarantaine.description": "Notifications whose signing key could not be resolved: kept, never lost, replayable after reclassification.",
  "quarantaine.refus": "The quarantine is viewed and replayed by platform administration only.",
  "quarantaine.confirmTitre": "Replay {{ek}}?",
  "quarantaine.confirmC1": "The event leaves the dead letter queue and is delivered again (replay generation {{g}}).",
  "quarantaine.confirmC2": "The replay and its reason are recorded in the audit log of organisation {{org}}.",
  "quarantaine.confirmRisque": "Risky replay: the project scope changed since the event was dead-lettered (generation {{a}} → {{n}}); delivery will use the new scope.",
  "quarantaine.confirmRev": "No automatic rollback: if delivery fails again, the event returns to the dead letter queue after six attempts.",
  "quarantaine.rejouerQuandMeme": "Replay anyway",
  "quarantaine.rejouer": "Replay",
  "quarantaine.attestation": "I have checked that the recipient accepts a delivery under the new scope",
  "quarantaine.porteeTitre": "Scope: the whole installation.",
  "quarantaine.porteeDesc": "Technical data only (hashed keys, cause, counters): no project content. Each replay is recorded in the event's organisation.",
  "quarantaine.filtreStatut": "Status",
  "quarantaine.tous": "All",
  "quarantaine.filtreCause": "Cause",
  "quarantaine.toutes": "All",
  "quarantaine.chargement": "Reading the quarantine…",
  "quarantaine.vide": "No quarantined events",
  "quarantaine.videIndice": "Every notification found its key.",
  "quarantaine.colEvenement": "Event · cause",
  "quarantaine.colProjet": "Organisation · project",
  "quarantaine.colStatut": "Status",
  "quarantaine.colTentatives": "Attempts",
  "quarantaine.colErreur": "Last error",
  "quarantaine.colVu": "Seen on",
  "quarantaine.voir": "View details of {{ek}}",
  "quarantaine.page": "Page {{p}} of {{n}} · {{total}} event(s)",
  "quarantaine.precedente": "Previous page",
  "quarantaine.suivante": "Next page",
  "quarantaine.detailTitre": "Details and replay",
  "quarantaine.correlation": "Correlation",
  "quarantaine.notification": "Notification",
  "quarantaine.notificationDetail": "no. {{n}} · classification version {{v}}",
  "quarantaine.cause": "Cause",
  "quarantaine.versionCle": "key version {{v}}",
  "quarantaine.chaine": "Chain",
  "quarantaine.generation": "Generation",
  "quarantaine.generationDetail": "replay {{r}} · scope {{a}} → {{n}} · lifecycle {{c}}",
  "quarantaine.journal": "Audit log",
  "quarantaine.dejaConsigne": "already recorded (a replay creates no duplicate)",
  "quarantaine.nonConsigne": "not recorded yet",
  "quarantaine.motif": "Reclassification reason (required, recorded)",
  "quarantaine.fermer": "Close",
  "quarantaine.nonRejouable": "Only a dead-lettered event on an active scope can be replayed.",
  "quarantaine.motifRequis": "The reclassification reason is required.",
  "quarantaine.enCours": "Replaying…",
  "quarantaine.resteEnQuarantaine": "The event stays in quarantine.",
  "executants.onglets": "Workers",
  "executants.battements": "Heartbeats",
  "executants.quarantaine": "Quarantine",
  "mcpTest.registre": "Registry",
  "mcpTest.activation": "Activation",
  "mcpTest.liaison": "Link to the agent",
  "mcpTest.empreinte": "Approved digest",
  "mcpTest.paquet": "Package on disk",
  "mcpTest.bacASable": "Sandbox",
  "mcpTest.outils": "Declared tools",
  "mcpTest.source": "Source",
  "mcpTest.tester": "Test the link",
  "mcpTest.enCours": "Checking the link…",
  "mcpTest.ok": "Link verified in {{ms}} ms: {{n}} checks passed, nothing was launched.",
  "mcpTest.ko": "Link not compliant: {{code}}",
  "mcpTest.conforme": "passed",
  "mcpTest.nonConforme": "failed",
  "exportGouv.public.owner": "Owners",
  "exportGouv.public.contributor": "Contributors",
  "exportGouv.public.viewer": "Viewers",
  "exportGouv.telecharge": "Governed export downloaded",
  "exportGouv.titre": "Governed export",
  "exportGouv.description": "A signed, time-limited link intended for a named audience of the project. The request and every download are recorded in the audit log.",
  "exportGouv.demander": "Request a governed export…",
  "exportGouv.refus": "Only the project owner requests a governed export and reads its history.",
  "exportGouv.lienPret": "Link ready — it will not be shown again.",
  "exportGouv.lien": "Export link (project session required)",
  "exportGouv.copier": "Copy the link",
  "exportGouv.expire": "Expires on",
  "exportGouv.publicCol": "Audience",
  "exportGouv.redaction": "Redaction",
  "exportGouv.pseudonymes": "pseudonyms",
  "exportGouv.nominatif": "named (owners only)",
  "exportGouv.demande": "Request",
  "exportGouv.telecharger": "Download",
  "exportGouv.echu": "The export link has expired or is no longer valid for this project: no data is served. Request a new export.",
  "exportGouv.chargement": "Reading export requests…",
  "exportGouv.aucun": "No governed export request for this project.",
  "exportGouv.colDemande": "Request",
  "exportGouv.colTelecharge": "Downloaded",
  "exportGouv.echuCourt": "expired",
  "exportGouv.valide": "valid",
  "exportGouv.jamais": "never",
  "exportGouv.dialogueTitre": "Request a governed export",
  "exportGouv.dialoguePortee": "Project {{ws}} · items, decisions, comments, sprints, log, attachment metadata.",
  "exportGouv.publicLegende": "Link audience (at least one)",
  "exportGouv.publicRequis": "Choose at least one audience.",
  "exportGouv.duree": "Link validity (hours)",
  "exportGouv.dureeInvalide": "Between 1 and 168 hours.",
  "exportGouv.dureeAide": "Between 1 and 168 hours (7 days).",
  "exportGouv.redactionImposee": "Redaction enforced: the audience goes beyond owners only, people will be replaced by stable pseudonyms. This is not the requester's choice.",
  "exportGouv.redactionNon": "Audience limited to owners: the export stays named.",
  "exportGouv.emission": "Issuing the signed link…",
  "exportGouv.annuler": "Cancel",
  "exportGouv.emettre": "Issue the link",
  "erreurs.code.QUARANTINE_REASON_REQUIRED": "The reclassification reason is required.",
  "erreurs.code.QUARANTINE_NOT_REPLAYABLE": "This event can no longer be replayed: it left the dead letter queue, or its scope or generations changed since it was read.",
  "erreurs.code.EXPORT_AUDIENCE_MISMATCH": "This export link is intended for another audience than your role in the project.",
  "erreurs.code.PLATFORM_ADMIN_REQUIRED": "Reserved to platform administration.",
  "pgmGouv.ajouter": "Add to the programme",
  "pgmGouv.ajoutTitre": "Add a requirement to the programme",
  "pgmGouv.categorie": "Category",
  "pgmGouv.chargement": "Reading the programme baseline…",
  "pgmGouv.code": "Identifier",
  "pgmGouv.codeRequis": "Give an identifier, shaped like DOD-PRG-001.",
  "pgmGouv.controle": "control",
  "pgmGouv.controleNom": "Control that verifies it",
  "pgmGouv.controleRequis": "Name the control that verifies this criterion.",
  "pgmGouv.critere": "Criterion",
  "pgmGouv.critereRequis": "State the criterion.",
  "pgmGouv.de": "Governance baseline of {{nom}}",
  "pgmGouv.dod": "definition of done criterion (DoD)",
  "pgmGouv.erreur": "The programme baseline could not be read; nothing has changed.",
  "pgmGouv.etatProjet": "Compliance is judged in each project (Design › Inherited requirements): at programme level, a criterion starts as “to verify”.",
  "pgmGouv.nAjoutes": "{{n}} added by the programme",
  "pgmGouv.nAVerifier": "{{n}} to verify",
  "pgmGouv.nCriteres": "{{n}} criterion(s)",
  "pgmGouv.nDerogation": "{{n}} under waiver",
  "pgmGouv.nfr": "non-functional requirement",
  "pgmGouv.origineOrganisation": "inherited from the organisation",
  "pgmGouv.origineProgramme": "added by the programme · inherited by attached projects",
  "pgmGouv.refusLecture": "You are not a member of this programme: its baseline is not open to you.",
  "pgmGouv.regle": "The programme strengthens the organisation's baseline for its projects: a criterion added here is inherited by its attached projects (a project that already carries this code keeps its own).",
  "pgmGouv.renforcer": "Strengthen, never relax. No removal at programme level in this version.",
  "pgmGouv.reserve": "Only the programme owner or manager adds a requirement; you keep read access.",
  "pgmGouv.seuil": "threshold {{s}}",
  "pgmGouv.seuilFacultatif": "Threshold (optional)",
  "pgmGouv.succes": "{{code}} added — to verify. Attached projects inherit it.",
  "pgmGouv.titreListe": "{{nom}} — governance baseline",
  "pgmGouv.type": "Type",
  "pgmGouv.vide": "No programme-specific requirement",
  "pgmGouv.videIndice": "Projects follow the organisation's baseline. Add a criterion to strengthen it.",
  "pipelines.addStage": "+ Add a stage",
  "pipelines.createPipeline": "Create pipeline",
  "pipelines.createdToast": "Pipeline created",
  "pipelines.creating": "Creating…",
  "pipelines.emptyHint": "Define one above.",
  "pipelines.emptyTitle": "No pipeline",
  "pipelines.loading": "Loading…",
  "pipelines.loadingRuns": "Loading runs…",
  "pipelines.nameLabel": "Name",
  "pipelines.namePlaceholder": "CI — lint & tests",
  "pipelines.nameRequired": "The pipeline name is required.",
  "pipelines.newPipeline": "New pipeline",
  "pipelines.pageDescription": "Define pipelines (command stages) and run them. Execution runs in a sandbox, on the host side, and only happens if it is enabled on the server.",
  "pipelines.pageTitle": "Pipelines & deployment",
  "pipelines.pipelinesTitle": "Pipelines",
  "pipelines.readOnly": "Read-only — defining a pipeline is reserved for contributors.",
  "pipelines.run": "Run",
  "pipelines.runToast": "Pipeline started",
  "pipelines.runsEmptyHint": "Run the pipeline to create a run.",
  "pipelines.runsEmptyTitle": "No run",
  "pipelines.runsTitle": "Runs",
  "pipelines.stageCommandPlaceholder": "Command",
  "pipelines.stageFailed": "Failed",
  "pipelines.stageNamePlaceholder": "Name",
  "pipelines.stageSkipped": "Skipped",
  "pipelines.stagesCount": "stage(s)",
  "pipelines.stagesLegend": "Stages (run in order, stops at the first failure)",
  "pipelines.viewRuns": "View runs",
  "planSprints.borneFacteur": "Factor above which the sprint is refused",
  "planSprints.borneItems": "Items per sprint, at most",
  "planSprints.borneNonEstime": "Assumed points for an unestimated item",
  "planSprints.bornePoints": "Points per sprint, at most",
  "planSprints.bornesLegend": "Sizing bounds (editable before launching)",
  "planSprints.consequencesLabel": "Consequences",
  "planSprints.enters": "enters this sprint",
  "planSprints.faulty": "cannot enter here",
  "planSprints.fromSprint": "comes from sprint {{id}}",
  "planSprints.howProduced": "How this proposal is produced",
  "planSprints.jobFailed": "Sprint planning failed.",
  "planSprints.launch": "Propose a breakdown",
  "planSprints.launchConsequence": "calls a model on the scope above and costs one generation.",
  "planSprints.noWriteConsequence": "No item is moved and no sprint is created: the result is a proposal, whose verdict the runtime recomputes against your backlog. Writing the plan stays a SEPARATE gesture, which you trigger under the diff once you have read it.",
  "planSprints.selectionSeule": "Keeping selects: {{n}} sprint(s) kept out of {{total}}. Nothing is written until you apply below.",
  "planSprints.apply": "Apply the kept sprints",
  "planSprints.bilanApplication": "{{sprints}} sprint(s) created, {{items}} item(s) filed.",
  "planSprints.refusEcrireInvalide": "“{{nom}}” is invalid: nothing was written. Fix it, or drop it from the selection.",
  "planSprints.refusEcrireVide": "“{{nom}}” carries no item: nothing was written.",
  "planSprints.refusEcrireIdentifiant": "Item “{{id}}” of “{{nom}}” is not a backlog identifier: nothing was written.",
  "planSprints.portee": "{{items}} planned items, of which {{avec}} carry at least one dependency; {{liens}} hand-entered “blocks” links and {{derives}} blockers derived from parentage. The autonomy check covers only those dependencies — a link never entered cannot contradict any plan.",
  "planSprints.porteeVide": "{{items}} planned items, NO declared dependency in this workspace. The autonomy check therefore had nothing to contradict: this verdict does not say “these sprints can ship on their own”, it says “nothing proves otherwise”. “Blocks” links are entered by hand on an item’s page.",
  "planSprints.porteeFiliation": "{{items}} planned items, of which {{avec}} carry at least one dependency. All of them come from parentage — {{derives}} blockers derived from “a parent ships only with its children” — because no “blocks” link has been entered in this workspace. The check was therefore able to contradict this plan on the hierarchy, but nothing contradicts it on what one story owes another.",
  "planSprints.refusBorne": "“{{borne}}” must be an integer between 1 and {{max}}.",
  "planSprints.refusLecture": "Your role lets you read this workspace, not launch a generation in it.",
  "planSprints.refusPerimetreVide": "Nothing to plan: no item outside a sprint, and no unfinished item in a planned or closed sprint.",
  "planSprints.refusSprintInvalide": "“{{nom}}” carries {{n}} blocking violation(s): fix them first.",
  "planSprints.refusTout": "“{{nom}}” is invalid: fix it, or keep the other sprints one by one.",
  "planSprints.retain": "Keep",
  "planSprints.retainAll": "Keep all",
  "planSprints.retained": "Kept",
  "planSprints.scopeLinks": "Declared dependencies",
  "planSprints.scopeLoading": "Reading the scope…",
  "planSprints.scopeReplan": "Items to replan",
  "planSprints.scopeUnestimated": "Without estimate",
  "planSprints.scopeUnplanned": "Items outside a sprint",
  "planSprints.sprintMetrics": "{{points}} pts · {{items}} items",
  "planSprints.sprintUnestimated": "{{n}} unestimated",
  "planSprints.unplaced": "Left out of the plan by the model:",
  "planSprints.v.cycleInterne": "{{item}} and {{ref}} block each other — shippable together, but the data is doubtful.",
  "planSprints.v.depassementItems": "{{mesure}} items against a bound of {{borne}} — overrun tolerated, to be owned.",
  "planSprints.v.depassementPoints": "{{mesure}} points against a bound of {{borne}} — overrun tolerated, to be owned.",
  "planSprints.v.dependanceAbsente": "{{item}} is blocked by {{ref}}, which is neither planned in this plan nor delivered.",
  "planSprints.v.dependanceInconnue": "{{item}} is blocked by {{ref}}, absent from this workspace’s backlog.",
  "planSprints.v.dependancePlusTard": "{{item}} is blocked by {{ref}}, planned in a LATER sprint: this sprint cannot ship on its own.",
  "planSprints.v.estimationManquante": "{{mesure}} item(s) without an estimate: their points are assumed, not measured.",
  "planSprints.v.horsGabaritItems": "{{mesure}} items against a ceiling of {{borne}}: that is no longer a sprint, that is the whole backlog.",
  "planSprints.v.horsGabaritPoints": "{{mesure}} points against a ceiling of {{borne}}: that is no longer a sprint, that is the whole backlog.",
  "planSprints.v.inconnu": "Finding “{{code}}” is not recognised by this interface.",
  "planSprints.v.itemEnDouble": "{{item}} is placed in two sprints at once.",
  "planSprints.v.itemInconnu": "{{item}} does not exist in this workspace’s backlog: the model made it up.",
  "planSprints.v.itemLivre": "{{item}} is already delivered: moving it would rewrite what a closed sprint shipped.",
  "planSprints.v.parentDisperse": "{{item}} is separated from its parent {{ref}}, placed in another sprint.",
  "planSprints.v.sourceHorsMandat": "{{item}} belongs to sprint {{ref}}, which is running: you do not pull work from under a started iteration.",
  "planSprints.v.sprintVide": "This sprint contains no usable item.",
  "planSprints.verdictInvalide": "Invalid",
  "planSprints.verdictReserve": "With reservations",
  "planSprints.verdictValide": "No violation",
  "planifier.affichagesBacklog": "Backlog displays",
  "planifier.aucuneFeature": "No feature to evaluate",
  "planifier.aucuneFeatureHint": "Split a capability into features and stories: the “ready” state will compute itself.",
  "planifier.backlogDescription": "The project items. The chosen display is in the address: it can be shared and comes back with the back button.",
  "planifier.capaciteChargement": "Reading missions…",
  "planifier.capaciteCompte": "Colony — ready: not computed · {{n}} active mission(s)",
  "planifier.capaciteErreur": "Colony capacity unreadable: the mission list did not respond.",
  "planifier.capaciteNote": "This banner blocks nothing: it tells what the colony has in progress. The count of ready features awaits the server-side readiness check.",
  "planifier.capaciteTitre": "Colony capacity — read-only",
  "planifier.colEtat": "State",
  "planifier.colFeature": "Feature and reason",
  "planifier.colMission": "Mission",
  "planifier.colUS": "Stories",
  "planifier.dorAVenir": "The “ready for the colony” check (feature and story DoR, fresh Spec Gate receipt per story, designed tests, size ≤ 32 K context and ≤ 400 lines) is not computed by this gateway: no feature is marked ready by default. Gaps visible in the data are named.",
  "planifier.etatFaite": "done",
  "planifier.etatNonEvaluee": "not evaluated",
  "planifier.evaluation": "Evaluating readiness criteria…",
  "planifier.evaluationErreur": "Evaluation unavailable: {{m}}",
  "planifier.lancerSprint": "Launch a mission on this sprint",
  "planifier.lancerSprintMotif": "This version does not run sprint missions yet (G4): only “Generate the application” does. Implement the stories one by one from their sheet.",
  "planifier.lancerTranche": "Launch a mission on this slice",
  "planifier.lancerTrancheMotif": "This version does not run missions on a slice yet (G4): only “Generate the application” does. Implement the stories from their sheet.",
  "planifier.manqueCriteres": "#{{id}} without acceptance criteria",
  "planifier.manqueSansUS": "no story",
  "planifier.manqueSource": "no source specification",
  "planifier.ouvrirHierarchie": "Open the hierarchy",
  "planifier.porteeSprint": "Counted on the active sprint ({{nom}}).",
  "planifier.porteeTableau": "No active sprint: counted on the whole board.",
  "planifier.reglerDansSprints": "Set in Sprints",
  "planifier.roadmapDescription": "The dated sprints of the project.",
  "planifier.sansProjet": "No project selected",
  "planifier.sansProjetHint": "The Backlog always belongs to a project: choose it in the context selector.",
  "planifier.sansProjetSprints": "Sprints always belong to a project: choose it in the context selector.",
  "planifier.sprintsLectureSeule": "Read-only — creating a sprint or adding a story to it is reserved to contributors.",
  "planifier.tranchesCaption": "Features and their “ready for the colony” state",
  "planifier.voirMissions": "See missions",
  "planifier.wipAVenir": "Work-in-progress limit per column: the setting is not yet stored by the gateway. Columns show their count; the limit will show here as “n / limit”, amber when reached, red when exceeded.",
  "planifier.wipAtteinte": "{{col}}: limit reached ({{n}} / {{l}}).",
  "planifier.wipAtteinteAria": "{{n}} card(s) against a limit of {{l}}: limit reached",
  "planifier.wipCompteAria": "{{n}} card(s)",
  "planifier.wipDepassee": "{{col}}: limit exceeded ({{n}} / {{l}}) — a warning; moving a card is still possible.",
  "planifier.wipDepasseeAria": "{{n}} card(s) against a limit of {{l}}: limit exceeded",
  "planifier.wipNonReglee": "no limit set",
  "planifier.wipReglageAVenir": "Setting each column limit (SRF-PRJ-031): not supported by this gateway — no limit is stored. The counts above already follow the rule.",
  "planifier.wipRegle": "Reached: amber; exceeded: red, a warning — moving a card is still possible. The Backlog (Board display) shows these limits read-only.",
  "planifier.wipTitre": "Work-in-progress limit, per column of the project board",
  "progSwitch.all": "All projects",
  "progSwitch.label": "Program",
  "programs.attachButton": "Attach",
  "programs.attachLabel": "Attach a project",
  "programs.attachPlaceholder": "Choose a project…",
  "programs.colAction": "Action",
  "programs.colApprovals": "Approvals",
  "programs.colDocuments": "Documents",
  "programs.colJobs": "Jobs",
  "programs.colProject": "Project",
  "programs.createButton": "Create program",
  "programs.createdToast": "Program created",
  "programs.descLabel": "Description",
  "programs.descPlaceholder": "What is this program for?",
  "programs.description": "Group projects under a program and steer them at the portfolio level: create, attach projects, and see the aggregate of the attached projects.",
  "programs.detach": "Detach",
  "programs.emptyHint": "Create a program, then attach projects to it.",
  "programs.emptyTitle": "No program",
  "programs.initiativeDesc": "Description",
  "programs.initiativeDescPlaceholder": "The context, goals, constraints…",
  "programs.initiativeGenerate": "Generate epics",
  "programs.initiativeHeading": "Initiative → epics (AI)",
  "programs.initiativeIntro": "Describe a program initiative; the AI breaks it down into epics in the chosen project's list (to accept).",
  "programs.initiativeLaunched": "Generation started — the epics will appear in the project's list (to accept).",
  "programs.initiativeOpenList": "Open the list",
  "programs.initiativeTarget": "Target project",
  "programs.initiativeTargetPlaceholder": "Choose a project of the program…",
  "programs.initiativeTargetRequired": "Pick the project that will receive the generated epics.",
  "programs.initiativeTitle": "Initiative title",
  "programs.initiativeTitlePlaceholder": "E.g. CIMA regulatory compliance",
  "programs.initiativeTitleTooShort": "The initiative title is at least three characters long.",
  "programs.kpiApprovals": "Pending approvals",
  "programs.kpiDocuments": "Documents",
  "programs.kpiJobs": "Jobs in progress",
  "programs.kpiProjects": "Projects",
  "programs.listHeading": "Your programs",
  "programs.loading": "Loading programs…",
  "programs.loadingRoadmap": "Loading roadmap…",
  "programs.loadingRollup": "Aggregating projects…",
  "programs.nameLabel": "Name",
  "programs.namePlaceholder": "E.g. Insurance core modernization",
  "programs.nameTooShort": "The programme name is at least three characters long.",
  "programs.newHeading": "New program",
  "programs.noProjectHint": "Attach a project below to see it appear here.",
  "programs.noProjectTitle": "No project attached",
  "programs.pickHint": "Choose a program on the left to see its projects and aggregate.",
  "programs.pickTitle": "Select a program",
  "programs.projectsHeading": "Program projects",
  "programs.quoi": "projects",
  "programs.roadmapEmptyHint": "Date sprints in the attached projects to see them aligned here.",
  "programs.roadmapEmptyTitle": "No dated sprint",
  "programs.roadmapHeading": "Program roadmap",
  "programs.templateDefaultOption": "Default (built-in)",
  "programs.templateHint": "The way of working (item types, workflow, links) for this program.",
  "programs.templateLabel": "Configuration template",
  "programs.title": "Programs",
  "projet.about": "About",
  "projet.axes": "Attachment axes",
  "projet.byStatus": "Breakdown by status",
  "projet.description": "The project's items and their different views. The chosen view is in the address: it can be shared and comes back on browser back.",
  "projet.emptyBacklog": "The backlog is empty.",
  "projet.itemsDone": "item(s) done",
  "projet.loading": "Loading project…",
  "projet.noAxis": "No axis declared for this project.",
  "projet.noDescription": "This project has no description yet.",
  "projet.noWorkspace": "No project selected",
  "projet.noWorkspaceHint": "Pick a project in the left panel.",
  "projet.progress": "Progress",
  "projet.title": "Project",
  "projet.viewsLabel": "Project views",
  "projet.vue.apercu": "Overview",
  "projet.vue.graphe": "Graph",
  "projet.vue.hierarchie": "Hierarchy",
  "projet.vue.liste": "List",
  "projet.vue.pret-colonie": "Ready for the colony",
  "projet.vue.roadmap": "Roadmap",
  "projet.vue.sprints": "Sprints",
  "projet.vue.tableau": "Board",
  "rail.etape": "step",
  "rail.etapes": "steps",
  "review.announceSubmitted": "Independent review submitted.",
  "review.approvalBlocked.commentaireRisqueRequis": "The reviewer flagged a risk: approving despite it requires a decision comment.",
  "review.approvalBlocked.decidee": "This request has already been decided.",
  "review.approvalBlocked.demandeur": "You are the requester: separation of duties forbids approving your own artefact.",
  "review.approvalBlocked.planRisqueAbsent": "The reviewer flagged a risk: a mitigation plan (owner, measure, due date) must be recorded before approval.",
  "review.approvalBlocked.relecteur": "You submitted the independent review of this artefact: someone else must approve it.",
  "review.approvalBlocked.role": "Your role does not allow deciding in this workspace.",
  "review.approvalBlocked.verdictBloquant": "The independent reviewer returned an adverse verdict: approval is impossible, with no workaround. Revise the artefact, then have it reviewed again.",
  "review.approvalBlocked.revueRequise": "An independent review by a third person is required — neither the requester nor the approver. Have the review submitted above, then approve.",
  "review.approver": "Approver",
  "review.approverRule": "a third party: neither the requester nor the reviewer.",
  "review.blocked.decidee": "The request is already decided: submitting a review would no longer unblock anything.",
  "review.blocked.dejaRelu": "The independent review is already submitted; it cannot be submitted twice.",
  "review.blocked.demandeur": "You are the requester: the independent review must come from someone else (separation of duties).",
  "review.blocked.role": "Your role does not allow reviewing: only a workspace owner or contributor can.",
  "review.by": "by",
  "review.hint": "Three distinct roles: the one who requests, the one who reviews, the one who approves. An AI-generated artefact can only be approved after a third party has submitted a review verdict.",
  "review.justificationHint": "What you checked, and what grounds your verdict. The text is kept and its fingerprint sealed by the server.",
  "review.justificationLabel": "Justification (required)",
  "review.justificationRequired": "A review requires a justification: a verdict without grounds is not a review.",
  "review.missingWarning": "No review is attached. If this artefact comes from an AI generation, the server will refuse any approval until the review is submitted.",
  "review.none": "Independent review: not submitted",
  "review.openApprovalCenter": "Open in the Approval Center",
  "review.openForm": "Review",
  "review.requester": "Requester",
  "review.reviewer": "Reviewer",
  "review.serverErrorHint": "This request carries no independent review verdict. If the artefact comes from an AI generation, that is the most likely cause of the refusal: have a third party submit the review above, then approve.",
  "review.submit": "Submit review",
  "review.submittedToast": "Independent review submitted",
  "review.title": "Independent review",
  "review.unknownReviewer": "unknown reviewer",
  "review.verdictApprove": "Review passed",
  "review.verdictApproveConsequence": "A third party — neither you nor the requester — will be able to approve.",
  "review.verdictLegend": "Your verdict",
  "review.verdictReject": "Review failed",
  "review.verdictRejectConsequence": "Approval becomes impossible, with no workaround: the artefact must be revised and reviewed again.",
  "review.verdictRisk": "Reservation — risk flagged",
  "review.verdictRiskConsequence": "Approval stays possible, but will require a comment and a recorded mitigation plan.",
  "review.verdictUnknown": "unknown verdict",
  "review.you": "you",
  "roadmap.description": "Sprints on a shared timeline — planning and progress at a glance.",
  "roadmap.emptyHint": "Give your sprints start and end dates to see them on the roadmap.",
  "roadmap.emptyTitle": "No dated sprint",
  "roadmap.legendActive": "Active",
  "roadmap.legendClosed": "Closed",
  "roadmap.legendPlanned": "Planned",
  "roadmap.loading": "Loading the roadmap…",
  "roadmap.statusActive": "active",
  "roadmap.statusClosed": "closed",
  "roadmap.statusPlanned": "planned",
  "roadmap.title": "Roadmap",
  "roadmap.today": "today",
  "role.admin": "Platform administrator",
  "role.contributor": "Contributor",
  "role.owner": "Owner",
  "role.unknown": "Unknown role",
  "role.viewer": "Reader",
  "role.auditor": "Auditor",
  "role.orgAdmin": "Organisation administrator",
  "runops.deployedToast": "Deployment recorded",
  "runops.deploymentPending": "Promotion in progress",
  "runops.deploymentPendingDetail": "Deploying {{release}} to {{environment}}…",
  "runops.description": "What is running, where it runs, and from which code. A release progresses through stages in order.",
  "runops.envCreate": "Declare",
  "runops.envCreatedToast": "Environment declared",
  "runops.envName": "Stage name",
  "runops.envNameAide": "For example: dev, staging, production.",
  "runops.envRank": "Promotion rank",
  "runops.envUrl": "Stage address",
  "runops.envUrlAide": "Optional. Shown next to the current version.",
  "runops.environments": "Environments",
  "runops.history": "Deployment history",
  "runops.neverDeployed": "never deployed",
  "runops.newEnvironment": "Declare a stage",
  "runops.newEnvironmentTitle": "Declare an environment",
  "runops.newRelease": "Create a release",
  "runops.newReleaseTitle": "Create a release",
  "runops.noDeployment": "No deployment recorded.",
  "runops.noEnvironment": "No environment declared",
  "runops.noEnvironmentHelp": "Declare your stages (dev, staging, production) to track what is running.",
  "runops.noRelease": "No release",
  "runops.noReleaseHelp": "A release ties a version to a precise commit — without it, it would not be traceable.",
  "runops.noWorkspaceHelp": "Choose a project first.",
  "runops.nothingDeployed": "No version deployed",
  "runops.passedStages": "stages passed",
  "runops.rank": "rank",
  "runops.relCommit": "Source commit",
  "runops.relCreate": "Create",
  "runops.relCreatedToast": "Release created",
  "runops.relNotes": "Release notes",
  "runops.relVersion": "Version",
  "runops.relVersionAide": "Unique within this workspace. For example: 1.4.0.",
  "runops.releases": "Releases",
  "savedFilters.delete": "Delete",
  "savedFilters.nameLabel": "Name of the filter to save",
  "savedFilters.namePlaceholder": "Name this filter",
  "savedFilters.save": "Save",
  "savedFilters.selectPlaceholder": "Saved filters…",
  "scorecard.approvalRate": "Approval rate",
  "scorecard.cycle": "Avg cycle time",
  "scorecard.decided": "Decided",
  "scorecard.delivery": "Delivery",
  "scorecard.desc": "Delivery, generation and governance indicators, computed from current data.",
  "scorecard.done": "Done",
  "scorecard.failed": "Failed",
  "scorecard.generatedAt": "Generated on",
  "scorecard.generation": "AI generation",
  "scorecard.governance": "Governance",
  "scorecard.items": "Items",
  "scorecard.jobs": "Jobs",
  "scorecard.latency": "Avg decision latency",
  "scorecard.loading": "Computing indicators…",
  "scorecard.met": "met",
  "scorecard.na": "n/a",
  "scorecard.noWs": "No workspace selected",
  "scorecard.pending": "Pending",
  "scorecard.pickWs": "Choose a workspace.",
  "scorecard.progress": "Progress",
  "scorecard.slo": "Service objectives (SLI / SLO)",
  "scorecard.succeeded": "Succeeded",
  "scorecard.successRate": "Success rate",
  "scorecard.target": "target",
  "scorecard.title": "KPI / SLI-SLO scorecard",
  "scorecard.unmet": "not met",
  "scorecard.value": "value",
  "shell.skipToContent": "Skip to main content",
  "slo.actif": "active",
  "slo.actifLibelle": "Active objective (measured during a compensating rollback)",
  "slo.auMoins": "at least (≥)",
  "slo.auPlus": "at most (≤)",
  "slo.budgetIllisible": "Budget unreadable: the gateway did not respond.",
  "slo.catalogueReserve": "The objectives catalogue (target, direction, window) is read by the project owner; the budget stays visible below.",
  "slo.chargement": "Reading objectives and error budget…",
  "slo.cible": "Target",
  "slo.cibleInvalide": "Give a numeric target (e.g. 0.95).",
  "slo.cle": "Objective identifier",
  "slo.cleAide": "Today only generation_success_rate is measured by the runtime; another objective is saved without being measured.",
  "slo.cleInvalide": "Identifier: lowercase letters, digits and _ (e.g. generation_success_rate).",
  "slo.colActions": "actions",
  "slo.colCible": "target",
  "slo.colConsomme": "consumed / total",
  "slo.colEtat": "state",
  "slo.colFenetre": "window",
  "slo.colIncidents": "incidents",
  "slo.colObjectif": "objective",
  "slo.colRestant": "remaining",
  "slo.dans": "within budget",
  "slo.derniereMesure": "Last measurement: {{quand}}",
  "slo.description": "Each project objective's target, its window, and the error budget consumed by confirmed incidents.",
  "slo.enregistre": "Objective {{cle}} saved — version {{v}}.",
  "slo.enregistrer": "Save the objective",
  "slo.epuise": "exhausted",
  "slo.fenetreBudget": "budget measured over {{f}}",
  "slo.fenetreInvalide": "The window is a strictly positive number of minutes.",
  "slo.fenetreMinutes": "Window (minutes)",
  "slo.formTitre": "Declare or edit an objective",
  "slo.inactif": "inactive",
  "slo.jauge": "{{pct}} % of the budget consumed",
  "slo.legende": "The project's service objectives and their error budget",
  "slo.modifier": "Edit",
  "slo.nonMesure": "never measured",
  "slo.presque": "nearly exhausted",
  "slo.regle": "Each confirmed SLO incident (compensating rollback, Environments and deployments) consumes its share of its objective's budget. An exhausted budget warns at production promotion; it does not block it.",
  "slo.sansProjet": "Service objectives belong to a project.",
  "slo.sens": "Direction",
  "slo.titre": "Service objectives",
  "slo.vide": "No service objective",
  "slo.videIndice": "Budget intact: no declared objective and no SLO incident on this project.",
  "slo.voirIncidents": "See deployments and rollbacks",
  "sprints.avgVelocity": "Average velocity (closed sprints):",
  "sprints.bandDone": "Done",
  "sprints.bandProgress": "In progress",
  "sprints.bandReview": "In review",
  "sprints.bandTodo": "To do",
  "sprints.burndown": "Burndown",
  "sprints.burndownAxisLabel": "Remaining points over time",
  "sprints.cancel": "Cancel",
  "sprints.cfdAxisLabel": "Items by status, cumulative over time",
  "sprints.createSprint": "Create sprint",
  "sprints.createdToast": "Sprint created",
  "sprints.creating": "Creating…",
  "sprints.cumulativeFlow": "Cumulative flow (items by status over time)",
  "sprints.description": "Plan iterations, sort items into them, and track velocity — committed vs completed points.",
  "sprints.formEnd": "End",
  "sprints.formGoal": "Goal (optional)",
  "sprints.formGoalAide": "What this sprint must have proven by the end.",
  "sprints.formName": "Sprint name",
  "sprints.formStart": "Start",
  "sprints.hideBurndown": "Hide burndown",
  "sprints.hideCumulativeFlow": "Hide cumulative flow",
  "sprints.hidePlanner": "Hide assisted planning",
  "sprints.items": "items",
  "sprints.legendIdeal": "Ideal",
  "sprints.legendRemaining": "Remaining",
  "sprints.loading": "Loading…",
  "sprints.loadingSprints": "Loading sprints…",
  "sprints.newSprint": "New sprint",
  "sprints.noHistoryHint": "Create items and change their status: the flow is built from the transition journal.",
  "sprints.noHistoryTitle": "No history yet",
  "sprints.noSprintHint": "Create a sprint, then sort stories into it from the board.",
  "sprints.noSprintTitle": "No sprint",
  "sprints.planner": "Propose a sprint breakdown (AI, checked by the runtime)",
  "sprints.pts": "pts",
  "sprints.ptsDone": "pts completed",
  "sprints.statusActive": "Active",
  "sprints.statusClosed": "Closed",
  "sprints.statusPlanned": "Planned",
  "sprints.title": "Sprints",
  "state.empty": "Nothing here yet",
  "state.loading": "Loading…",
  "state.retry": "Retry",
  "status.blocked": "Blocked",
  "status.error": "Failed",
  "status.info": "Information",
  "status.pending": "Pending",
  "status.running": "In progress",
  "status.success": "Validated",
  "status.warning": "Needs review",
  "tableau.annoncePage": "Page {{page}} of {{pages}}, {{n}} rows shown",
  "tableau.annonceTri": "Sorted by {{colonne}}, {{sens}} order, {{n}} rows",
  "tableau.annonceTriUne": "Sorted by {{colonne}}, {{sens}} order, {{n}} row",
  "tableau.compteur": "{{n}} items",
  "tableau.compteurAucun": "No items",
  "tableau.compteurFiltre": "{{affiches}} of {{total}} items",
  "tableau.compteurUn": "{{n}} item",
  "tableau.ordreCroissant": "ascending",
  "tableau.ordreDecroissant": "descending",
  "tableau.pagePrecedente": "Previous page",
  "tableau.pageSuivante": "Next page",
  "tableau.pageSur": "Page {{page}} of {{pages}}",
  "tableau.paginationLabel": "Table pagination",
  "tableau.rechercher": "Search…",
  "tableau.rechercherDans": "Search {{quoi}}…",
  "tableau.trierCroissant": "sort in ascending order",
  "tableau.trierDecroissant": "sort in descending order",
  "tableau.trierDefaut": "return to the default order",
  "taxonomy.attachedWork": "Attached work (including descendants)",
  "taxonomy.axes": "Declared axes",
  "taxonomy.create": "Declare axis",
  "taxonomy.createdToast": "Axis created",
  "taxonomy.description": "Your organisation's graph — portfolio, domain, capability, application. An item attaches to several axes: that is what enables impact analysis, de-duplication, and composing an offer from a domain's components.",
  "taxonomy.items": "item(s)",
  "taxonomy.kind": "Kind",
  "taxonomy.name": "Name",
  "taxonomy.namePlaceholder": "e.g. Claims",
  "taxonomy.nameRequired": "The axis name is required.",
  "taxonomy.noAxis": "No axis declared",
  "taxonomy.noAxisHint": "Declare your portfolios, domains and capabilities to attach work to them.",
  "taxonomy.noParent": "— root —",
  "taxonomy.nothingAttached": "Nothing is attached to this axis or its descendants.",
  "taxonomy.parent": "Attached to",
  "taxonomy.pickAxis": "Pick an axis to see what depends on it.",
  "taxonomy.title": "Attachment axes",
  "taxonomy.via": "via",
  "technical.toggle": "Technical details",
  "theme.dark": "Dark",
  "theme.light": "Light",
  "theme.system": "System",
  "timeline.description": "The workspace's activity, across all jobs, from most recent to oldest.",
  "timeline.emptyHint": "Events from this workspace's jobs will appear here.",
  "timeline.emptyTitle": "No activity",
  "timeline.eventApprovalRequested": "Approval requested",
  "timeline.eventArtifactDiscarded": "Artifact removed (rejected)",
  "timeline.eventArtifactWritten": "Artifact written",
  "timeline.eventBacklogItemsInserted": "Backlog inserted into database",
  "timeline.eventChangeApplied": "Change applied (worktree)",
  "timeline.eventChangeApplySkipped": "Apply not enabled",
  "timeline.eventCommitted": "Published (commit)",
  "timeline.eventGenerationFinished": "Generation finished",
  "timeline.eventGenerationStarted": "Generation started",
  "timeline.eventJobClaimed": "Picked up by the worker",
  "timeline.eventJobDone": "Job done",
  "timeline.eventJobEnqueued": "Request recorded",
  "timeline.eventJobFailed": "Failed",
  "timeline.eventPublicationBlocked": "Publication blocked (dependency)",
  "timeline.jobPrefix": "job",
  "timeline.loading": "Loading the timeline…",
  "timeline.title": "Timeline",
  "trace.code": "Code",
  "trace.coverage": "Coverage",
  "trace.gapsOnly": "Show only gaps",
  "trace.loading": "Analysing traceability…",
  "trace.quoi": "requirements",
  "trace.requirement": "Requirement",
  "trace.requirements": "Requirements",
  "trace.status": "Status",
  "trace.tests": "Tests",
  "trace.type": "Type",
  "trace.withCode": "With code",
  "trace.withTests": "With tests",
  "traceLink.copied": "Copied",
  "traceLink.copyAction": "Copy",
  "traceLink.copyFailed": "Copy failed",
  "tree.accept": "Accept",
  "tree.acceptByOther": "modified — to be accepted by someone else",
  "tree.actions": "Actions",
  "tree.approvalsCenter": "Approvals center",
  "tree.cancel": "Cancel",
  "tree.description": "The unified Epic → Feature → US → Task hierarchy, AI-augmented: generate the children of any item and accept them under separation of duties.",
  "tree.edit": "Edit",
  "tree.editTitleLabel": "Title",
  "tree.emptyHint": "Generate epics from an approved framing, or create a story on the board.",
  "tree.emptyTitle": "No work item",
  "tree.genStarted": "Generation started — the children will appear here once generated (to accept).",
  "tree.generateChildren": "Generate {{enfants}}",
  "tree.generateReadOnly": "Reader: generating is reserved to contributors.",
  "tree.kindBug": "Bug",
  "tree.kindCadrage": "Framing",
  "tree.kindEpic": "Epic",
  "tree.kindFeature": "Feature",
  "tree.kindIdea": "Idea",
  "tree.kindStory": "US",
  "tree.kindTask": "Task",
  "tree.loading": "Loading the tree…",
  "tree.prioCritical": "Critical",
  "tree.prioHigh": "High",
  "tree.prioLow": "Low",
  "tree.prioMedium": "Medium",
  "tree.save": "Save",
  "tree.sodTooltip": "Separation of duties: a human OTHER than the generator must accept",
  "tree.title": "Work items tree",
  "tree.toAccept": "to accept",
  "user.menu": "Account and preferences",
  "wi.kindBug": "Bug",
  "wi.kindCadrage": "Framing",
  "wi.kindEpic": "Epic",
  "wi.kindFeature": "Feature",
  "wi.kindIdea": "Idea",
  "wi.kindStory": "US",
  "wi.kindTask": "Task",
  "wi.prioCritical": "Critical",
  "wi.prioHigh": "High",
  "wi.prioLow": "Low",
  "wi.prioMedium": "Medium",
  "wi.priority": "Priority",
  "wi.status": "Status",
  "wi.statusDone": "Done",
  "wi.statusInProgress": "In progress",
  "wi.statusInReview": "In review",
  "wi.statusTodo": "To do",
  "worker.active": "Worker running",
  "worker.engine": "Engine",
  "worker.inactive": "Generation service paused — try again shortly",
  "worker.processedNoun": "processed",
  "workflow.agentWorking": "The agent is working…",
  "workflow.annuler": "Cancel",
  "workflow.chargement": "Reading the template's workflows…",
  "workflow.choose": "— choose —",
  "workflow.consoleDescription": "Run an agent on the active workspace and track its trace and output.",
  "workflow.consoleTitle": "Orchestration console",
  "workflow.contraintes": "Constraints (optional)",
  "workflow.declares": "Workflows declared by the project's template",
  "workflow.declencheurPush": "trigger: GitLab push",
  "workflow.done": "Completed",
  "workflow.duration": "Duration",
  "workflow.enterInstructionError": "Enter an instruction",
  "workflow.erreurLecture": "The template's workflows could not be read.",
  "workflow.etapes": "{{n}} step(s): {{chaine}}",
  "workflow.execute": "Run",
  "workflow.executing": "Running…",
  "workflow.executionLabel": "Execution",
  "workflow.explication": "A workflow chains the steps declared by the project's template; each produces an artefact to approve, like an AI action launched on its own. It stops at the first failing step.",
  "workflow.fichiers": "Files the workflow may work on (required)",
  "workflow.fichiersAide": "The workflow only touches this scope, step after step (comma-separated).",
  "workflow.fichiersRequis": "Enter at least one file: the workflow only works within this scope.",
  "workflow.instructionLabel": "Instruction",
  "workflow.instructionPlaceholder": "Write a user story for document ingestion.",
  "workflow.lance": "Workflow “{{nom}}” launched: each step produces an artefact to approve; it stops at the first failing step.",
  "workflow.lancer": "Launch “{{nom}}”",
  "workflow.lancerSans": "Launch",
  "workflow.loadingAgents": "Loading agents…",
  "workflow.motifPush": "A workflow triggered by a GitLab push cannot be launched from an item.",
  "workflow.noExecutionHint": "Run an agent to see its trace and output.",
  "workflow.noExecutionTitle": "No execution",
  "workflow.noWorkspaceError": "No workspace selected",
  "workflow.output": "Output",
  "workflow.ouvrir": "Launch a workflow…",
  "workflow.readOnly": "Read-only — your role does not allow running an agent.",
  "workflow.refusArret": "AI stop: new AI requests are suspended; the launch will wait until it is lifted.",
  "workflow.refusAucun": "The project's template declares no workflow. An administrator declares them in Templates › Platform.",
  "workflow.refusAucunManuel": "The template's workflows are triggered by a GitLab push: none can be launched from an item.",
  "workflow.refusLecteur": "Reader: AI actions are visible but reserved for the project's contributors.",
  "workflow.resultTitle": "Execution result",
  "workflow.noModelsTitle": "No model is allowed in this workspace",
  "workflow.noModelsHint": "An owner must allow a model before starting an agent.",
  "workflow.configureModels": "Configure models",
  "workflow.noModelsError": "No model is allowed in this workspace. Configure models before starting an agent.",
  "workflow.runAgent": "Run an agent",
  "workflow.selectAgentError": "Select an agent",
  "workflow.startedToast": "Agent started",
  "workflow.titre": "Launch a workflow on {{ref}}",
  "workflow.tokensUsed": "Tokens used",
  "wsExport.buttonLabel": "Export workspace (ZIP)",
  "wsExport.description": "Exports the workspace data (items, decisions, comments, sprints, journal, attachments) as a sovereign ZIP archive — assembled locally.",
  "wsExport.pending": "Exporting…",
  "wsExport.title": "Workspace portability",
  "wsSwitch.empty": "No workspace",
  "wsSwitch.label": "Workspace",
  "wsSwitch.loading": "Loading workspaces…",
  "wsSwitch.noneInProgram": "No project in this programme",
  "wsSwitch.showAll": "Show all projects",
  "wsSwitch.unavailable": "Workspaces unavailable",
  "chat.observabilityPending": "Waiting for Langfuse correlation…",
  "chat.observabilityDegraded": "AI call completed without Langfuse correlation proof — observability degraded.",
  "tests.title": "Tests",
  "tests.description": "Design test cases, run executions, and keep their results over time.",
  "tests.noWorkspace": "Select a project",
  "tests.noWorkspaceHint": "Cases and runs always belong to a workspace.",
  "tests.readOnly": "Read-only — creation and publishing are reserved for contributors.",
  "tests.casesTitle": "Test cases",
  "tests.newCase": "New test case",
  "tests.key": "Key",
  "tests.name": "Name",
  "tests.type": "Type",
  "tests.expected": "Expected result",
  "tests.creating": "Creating…",
  "tests.createCase": "Add case",
  "tests.loadingCases": "Loading cases…",
  "tests.emptyCases": "No test cases",
  "tests.emptyCasesHint": "Add a case or generate one from a requirement.",
  "tests.emptyCasesAction": "Use the form above to create the first case.",
  "tests.select": "Select",
  "tests.runsTitle": "Runs",
  "tests.newRun": "New run",
  "tests.runName": "Run name",
  "tests.runPlaceholder": "Sprint 12 regression",
  "tests.startRun": "Start",
  "tests.loadingRuns": "Loading runs…",
  "tests.emptyRuns": "No runs",
  "tests.emptyRunsHint": "Start a run to publish results for selected cases.",
  "tests.emptyRunsAction": "Use the form above to start the first run.",
  "tests.publishResult": "Publish a result",
  "tests.publishTitle": "Result for selected case",
  "tests.resultStatus": "Verdict",
  "tests.publishing": "Publishing…",
  "tests.publish": "Publish result",
  "tests.caseCreated": "Test case added",
  "tests.runCreated": "Run started",
  "tests.resultPublished": "Result published",
  "backlog.testsImport": "Import into Tests",
  "backlog.testsImporting": "Importing…",
  "backlog.testsImported": "Draft test cases created",
  "tests.planCreated": "Test plan created",
  "tests.caseAttached": "Case attached to plan",
  "tests.campaignCreated": "Campaign opened",
  "tests.executionCreated": "Execution and evidence recorded",
  "tests.campaignsTitle": "Plans and campaigns",
  "tests.newPlan": "New test plan",
  "tests.planName": "Plan name",
  "tests.planPlaceholder": "Release 0.1 regression",
  "tests.createPlan": "Create plan",
  "tests.loadingPlans": "Loading plans…",
  "tests.emptyPlans": "No test plans",
  "tests.emptyPlansHint": "A plan groups cases to execute together.",
  "tests.emptyPlansAction": "Use the form above to create the first plan.",
  "tests.attachCase": "Attach selected case",
  "tests.environment": "Environment",
  "tests.chooseEnvironment": "Choose…",
  "tests.createCampaign": "Open campaign",
  "tests.openCampaigns": "Campaigns",
  "tests.evidenceForm": "Record an execution with evidence",
  "tests.evidenceOutput": "Output or evidence",
  "tests.evidencePlaceholder": "Summary of observed output",
  "tests.executing": "Recording…",
  "tests.recordExecution": "Record with evidence",
  "tests.automatedStarted": "Docker execution started",
  "tests.campaignExecutionStarted": "Campaign Docker executions started",
  "tests.campaignStarting": "Queuing…",
  "tests.executeCampaign": "Run entire campaign",
  "tests.campaignPolling": "Docker executions running — updating automatically",
  "tests.executionDetails": "Execution details",
  "tests.noCampaignExecutions": "No executions yet.",
  "tests.evidenceCount": "evidence item(s)",
  "tests.statusRunning": "Running",
  "tests.statusPassed": "Passed",
  "tests.statusFailed": "Failed",
  "tests.statusSkipped": "Skipped",
  "tests.statusBlocked": "Blocked",
  "tests.junitForm": "Import a JUnit report",
  "tests.junitTitle": "Import a JUnit report",
  "tests.junitHint": "Testcase names must match test case keys. Importing closes this run.",
  "tests.junitXml": "XML report",
  "tests.junitImporting": "Importing…",
  "tests.junitImport": "Import and close",
  "tests.junitImported": "JUnit report imported and run closed",
  "tests.junitRequired": "Paste a JUnit XML report before importing it.",
  "tests.loadingResults": "Loading results…",
  "tests.resultsList": "Run results",
  "tests.resultsTitle": "Run results",
  "tests.noResults": "No results received for this run.",
  "tests.executorAgent": "Automated",
  "tests.executorHuman": "Manual",
  "tests.campaignStatusOpen": "Open",
  "tests.campaignStatusClosed": "Closed",
  "tests.campaignStatusCancelled": "Cancelled",
  "tests.cancelReason": "Cancellation reason",
  "tests.cancelReasonPlaceholder": "Required reason",
  "tests.cancelling": "Cancelling…",
  "tests.cancelCampaign": "Cancel",
  "tests.campaignCancelled": "Campaign cancelled",
  "deliveryOverview.title": "Delivery state",
  "deliveryOverview.description": "GitLab remains the source for branches and builds; RunOps remains the source for observed environments.",
  "deliveryOverview.source": "GitLab source",
  "deliveryOverview.noWorkspace": "Select a project.",
  "deliveryOverview.loading": "Reading…",
  "deliveryOverview.connectionError": "The GitLab connection cannot be verified.",
  "deliveryOverview.notConfigured": "Not configured",
  "deliveryOverview.branches": "branches",
  "deliveryOverview.branchesUnknown": "branches unverified",
  "deliveryOverview.build": "Latest observed build",
  "deliveryOverview.environments": "Environments",
  "deliveryOverview.version": "Version",
  "deliveryOverview.signature": "Signature",
  "deliveryOverview.observationMissing": "No version observed",
  "deliveryOverview.observedAt": "Observed",
  "deliveryOverview.openEnvironment": "Open",
  "deliveryOverview.unavailable": "Source unavailable",
  "deliveryOverview.none": "No observed data",
  "deliveryOverview.release": "Release",
  "deliveryOverview.noRelease": "No observed release",
  "deliveryOverview.lastDeployment": "Latest deployment",
  "deliveryOverview.noDeployment": "No observed deployment",
  "itemDeliveryProof.title": "Delivery proof",
  "itemDeliveryProof.description": "Observed relation between this item, GitLab and the latest known CI state.",
  "itemDeliveryProof.openCockpit": "Open cockpit",
  "itemDeliveryProof.loading": "Reading provenance…",
  "itemDeliveryProof.unavailable": "This item's provenance cannot be verified.",
  "itemDeliveryProof.notObserved": "No commit proof observed",
  "itemDeliveryProof.notObservedHint": "An MR or deployment is not inferred from the item's status. Propose an MR from the permitted actions to create proof.",
  "itemDeliveryProof.observed": "Commit observed",
  "itemDeliveryProof.gitlabUnavailable": "GitLab is unavailable; MR and pipeline are not verified.",
  "itemDeliveryProof.gitlabNotConfigured": "GitLab is not configured; MR and pipeline are not verified.",
  "itemDeliveryProof.mergeRequest": "Merge request",
  "itemDeliveryProof.pipeline": "Pipeline",
  "itemDeliveryProof.checking": "Checking…",
  "itemDeliveryProof.unavailableShort": "Unavailable",
  "itemDeliveryProof.notObservedShort": "Not observed for this branch",
  "itemDeliveryProof.jobs": "Jobs and logs",
  "itemDeliveryProof.noJobs": "No observed jobs",
  "itemDeliveryProof.loadingLogs": "Reading logs…",
  "itemDeliveryProof.logsUnavailable": "Logs unavailable",
  "itemDeliveryProof.runtime": "Release and environment",
  "itemDeliveryProof.noRelease": "No release observed for this commit",
  "itemDeliveryProof.release": "Release",
  "itemDeliveryProof.notDeployed": "No deployment observed for this release",
  "itemDeliveryProof.health": "Health",
  "itemDeliveryProof.artifact": "Digest",
  "auditRoadmap.title": "Audit recommendations roadmap",
  "auditRoadmap.description": "A decision register linking each finding to an action, lead discipline, gate, dependencies, and an evidence criterion.",
  "auditRoadmap.loading": "Loading the audit register…",
  "auditRoadmap.corpusLanguage": "The historical audit corpus is versioned in French; the navigation chrome remains available in French and English.",
  "auditRoadmap.disclaimerTitle": "Honest audit reading",
  "auditRoadmap.disclaimer": "56 recommendations, 8 cycles and 28 indicators come from the versioned audit baseline. Tracking is not delivery evidence; the 10/10 target remains a trajectory.",
  "auditRoadmap.summary": "Audit baseline summary",
  "auditRoadmap.baseline": "Initial baseline",
  "auditRoadmap.baselineHint": "historical audit, not current state",
  "auditRoadmap.accessDeniedTitle": "Governance access only.",
  "auditRoadmap.accessDeniedDescription": "Your role cannot view internal findings and their remediation trajectory.",
  "auditRoadmap.target": "Target",
  "auditRoadmap.targetHint": "trajectory, not achieved",
  "auditRoadmap.p0": "P0 to protect",
  "auditRoadmap.p0Hint": "priority gates",
  "auditRoadmap.tracked": "Tracked",
  "auditRoadmap.trackedHint": "evidence to verify",
  "auditRoadmap.activeCycle": "Active-cycle recommendations",
  "auditRoadmap.activeCycleHint": "C01 cycle",
  "auditRoadmap.criticalPath": "Work-item coverage by cycle",
  "auditRoadmap.criticalPathHint": "Each bar measures work-item linkage only. Select a cycle to filter.",
  "auditRoadmap.cycleActive": "Active",
  "auditRoadmap.cycleConditional": "Conditional",
  "auditRoadmap.cycleOption": "Optional",
  "auditRoadmap.cyclePlanned": "Planned",
  "auditRoadmap.cycleProgress": "Recommendations linked to a work item",
  "auditRoadmap.noProofInferred": "no evidence inferred",
  "auditRoadmap.filters": "Recommendation filters",
  "auditRoadmap.search": "Search recommendations",
  "auditRoadmap.searchPlaceholder": "ID, finding, action, or work item…",
  "auditRoadmap.priority": "Priority",
  "auditRoadmap.allPriorities": "All",
  "auditRoadmap.cycle": "Cycle",
  "auditRoadmap.allCycles": "All",
  "auditRoadmap.tracking": "Tracking",
  "auditRoadmap.allTracking": "All",
  "auditRoadmap.withWorkItem": "With work item",
  "auditRoadmap.withoutWorkItem": "Without work item",
  "auditRoadmap.reset": "Reset",
  "auditRoadmap.listTitle": "Actionable recommendation register",
  "auditRoadmap.resultCount": "Visible results:",
  "auditRoadmap.colRecommendation": "Recommendation",
  "auditRoadmap.colFinding": "Finding / action",
  "auditRoadmap.colGovernance": "Governance",
  "auditRoadmap.tableRegion": "Recommendations table",
  "auditRoadmap.proofLabel": "Evidence",
  "auditRoadmap.detail": "Detail",
  "auditRoadmap.open": "Open",
  "auditRoadmap.openDetail": "Open detail",
  "auditRoadmap.noResults": "No recommendation matches these filters.",
  "auditRoadmap.trackingReview": "Tracked · evidence to verify",
  "auditRoadmap.trackingFrame": "Needs framing",
  "auditRoadmap.trackingPlanned": "Planned",
  "auditRoadmap.detailDisclaimer": "An audit recommendation is an objective to deliver. This screen does not turn it into a shipped capability.",
  "auditRoadmap.finding": "Audit finding",
  "auditRoadmap.action": "Recommended action",
  "auditRoadmap.owner": "Lead discipline",
  "auditRoadmap.gate": "Gate",
  "auditRoadmap.milestone": "Milestone",
  "auditRoadmap.effort": "Indicative effort",
  "auditRoadmap.value": "Value",
  "auditRoadmap.risk": "Risk if untreated",
  "auditRoadmap.dependencies": "Dependencies",
  "auditRoadmap.noDependencies": "No explicit dependency in the manifest.",
  "auditRoadmap.acceptance": "Acceptance criterion",
  "auditRoadmap.workItems": "Concrete work",
  "auditRoadmap.linkedCountLabel": "Linked references:",
  "auditRoadmap.workItemCount": "Linked work items:",
  "auditRoadmap.filterByWorkItem": "Filter the roadmap by work item",
  "auditRoadmap.noWorkItem": "No work item is linked to this recommendation yet.",
  "auditRoadmap.sourceBoundary": "Analysis source: audit_codex. The active normative baseline remains docs/doit-specification/; implementation evidence lives in the execution register.",
  "auditRoadmap.footerSource": "Analysis source: roadmap_manifest.json and 09_recommandations_et_backlog.md. Active normative reference: docs/doit-specification/.",
  "nav./audit-roadmap": "Audit recommendations",
  "navdesc./audit-roadmap": "Audit recommendations, cycles, work items and evidence level",
  "runops.actionsCompensation": "This row is a compensation; no implicit follow-up action is available.",
  "runops.actionsFor": "Actions for",
  "runops.actionsNotSucceeded": "Actions are available only after a successful deployment.",
  "runops.actionsReadOnly": "Read-only view: no deployment action is available.",
  "runops.actionsRollbackActive": "The rollback cycle must reach a terminal state before another action can start.",
  "runops.actionsRollbackFailed": "Rollback failed: only a redeploy or a controlled publication is available.",
  "runops.actionsRolledBack": "This target has been restored and no longer offers a direct action.",
  "runops.backupTitle": "Continuity and backups",
  "runops.compensatedBy": "Compensated by",
  "runops.composePipeline": "Publish + CI",
  "runops.composePipelineTriggered": "Compose pipeline triggered",
  "runops.confirmSloRollback": "Trigger rollback with SLO evidence",
  "runops.deployedBy": "Deployed by",
  "runops.executionDetails": "Execution details",
  "runops.finishedAt": "Finished",
  "runops.operationRedeploy": "Redeploy",
  "runops.operationRollback": "Compensating rollback",
  "runops.pipelineChoose": "No pipeline selected",
  "runops.pipelineId": "GitLab pipeline (optional)",
  "runops.pipelineIdHelp": "Only successful pipelines for this commit are available.",
  "runops.pipelineIdInvalid": "The selected GitLab pipeline is not eligible for this commit.",
  "runops.pipelineLoading": "Loading GitLab pipelines…",
  "runops.pipelineNoneForCommit": "No successful pipeline exists for this commit.",
  "runops.pollingInterrupted": "Automatic tracking stopped",
  "runops.pollingInterruptedDetail": "The last persisted state is preserved. Refresh manually to retrieve the latest state.",
  "runops.provenance": "Provenance",
  "runops.redeploy": "Redeploy",
  "runops.redeployAuditConsequence": "A new deployment will be recorded with an idempotency key.",
  "runops.redeployConfirm": "Start redeploy",
  "runops.redeployConsequence": "Version {{version}} will be started again on {{environment}}.",
  "runops.redeployQueued": "Redeploy started",
  "runops.redeployReversibility": "A rollback will remain available if the new execution fails.",
  "runops.redeployTitle": "Redeploy this version?",
  "runops.refreshStatus": "Refresh status",
  "runops.rollback": "Rollback",
  "runops.rollbackAlreadyTerminal": "This rollback has already finished. Refresh the history to view its persisted state.",
  "runops.rollbackAuditConsequence": "The operation, its commits, and artifact evidence will be recorded in the RunOps audit.",
  "runops.rollbackCompensationConsequence": "A separate compensation will be created; the current deployment will remain in the history.",
  "runops.rollbackConfirm": "Start rollback",
  "runops.rollbackConsequence": "Stage {{environment}} will be restored to the previously known version.",
  "runops.rollbackCycle": "Rollback cycle",
  "runops.rollbackFinishedAt": "Cycle finished",
  "runops.rollbackOf": "Rollback of",
  "runops.rollbackPlanConsequence": "Stage {{environment}} will move from {{currentVersion}} (commit {{currentCommit}}) to {{previousVersion}} (commit {{previousCommit}}).",
  "runops.rollbackPlanMissing": "The server did not provide a confirmable rollback plan. Refresh and try again.",
  "runops.rollbackPreviewFailed": "Unable to preview the rollback. Refresh and try again.",
  "runops.rollbackPreviewLoading": "Previewing…",
  "runops.rollbackPreviewLoadingDetail": "Loading rollback plan",
  "runops.rollbackQueued": "Rollback started",
  "runops.rollbackReversibility": "A new promotion will be required to return to {{version}}.",
  "runops.rollbackTitle": "Return to a previous version?",
  "runops.sloFieldsRequired": "Enter the SLO, reason, observed value, and threshold before continuing.",
  "runops.sloKey": "SLO",
  "runops.sloObserved": "Observed value",
  "runops.sloReason": "Reason",
  "runops.sloRollback": "SLO rollback",
  "runops.sloRollbackQueued": "SLO rollback started",
  "runops.sloThreshold": "Threshold",
  "runops.startedAt": "Started",
  "runops.statusRolledBack": "Restored",
  "runops.provenanceWorker": "Proof: worker execution",
  "runops.provenanceManual": "Declared manually",
  "runops.deliverySucceeded": "GitLab pipeline succeeded, worker execution pending",
  "runops.deliveryFailed": "GitLab pipeline failed",
  "runops.deliveryInProgress": "GitLab pipeline in progress",
  "runops.deliveryUnknown": "GitLab pipeline state unknown",
  "runops.correlation": "Correlation",
  "common.close": "Close",
  "nav./projet": "Project view",
  "navdesc./projet": "Health, cycle, team, missions and next action of the project",
  "nav./taxonomy": "Portfolio axes",
  "navdesc./taxonomy": "Portfolio, domain, capability — the work attached to them and the health spread per axis",
  "nav./tests": "Tests",
  "navdesc./tests": "Cases, plans, regression, campaigns and results",
  "nav./delivery": "Delivery cockpit",
  "navdesc./delivery": "Deployments and pipelines in progress",
  "nav./runops": "Environments and deployments",
  "navdesc./runops": "Environments, deployments, rollback, error budget and continuity",
  "nav./runops?vue=slo": "Service objectives",
  "navdesc./runops?vue=slo": "Target, window and error budget of each project service objective",
  "projet.vue.processus": "Lifecycle and process",
  "admin.section.plateformes": "AI platforms",
  "admin.section.sante": "Platform health",
  "config.onglet.processus": "Process",
  "nav./hitl-cockpit": "Decision delays",
  "navdesc./hitl-cockpit": "All pending human decisions, sorted by age, and their decision time",
  "hitl.announceApproved": "Decision approved.",
  "hitl.announceRejected": "Decision rejected.",
  "hitl.approve": "Approve",
  "hitl.execution.titre": "AI tool execution awaiting a decision",
  "hitl.execution.chargement": "Reading the pending decision…",
  "hitl.execution.decidee": "Decision recorded: this execution no longer awaits a decision.",
  "hitl.execution.absente": "This AI tool execution does not await a decision in this project (already decided, or not found).",
  "hitl.execution.outil": "Proposed tool",
  "hitl.execution.auteur": "You proposed this execution: another project member decides it (separation of duties).",
  "hitl.execution.lectureSeule": "Your role in this project lets you read this request, not decide it.",
  "hitl.cancel": "Cancel",
  "hitl.colAction": "Action",
  "hitl.colKind": "Type",
  "hitl.colWaiting": "Waiting since",
  "hitl.colWhat": "What",
  "hitl.colWho": "Who",
  "hitl.colWhy": "Why",
  "hitl.confirmReject": "Confirm rejection",
  "hitl.durationHoursMinutes": "{{h}} h {{m}} min",
  "hitl.durationMinutes": "{{n}} min",
  "hitl.durationSeconds": "{{n}} s",
  "hitl.emptyHint": "Today's queue is empty: nothing is waiting on your decision for this workspace.",
  "hitl.emptyTitle": "No pending decision",
  "hitl.kindAiToolExecution": "AI tool execution",
  "hitl.kindApproval": "Approval",
  "hitl.loading": "Loading the queue…",
  "hitl.metricsEmpty": "No decision made in this window — nothing to measure.",
  "hitl.metricsLoading": "Computing…",
  "hitl.metricsP50": "p50",
  "hitl.metricsP95": "p95",
  "hitl.metricsSampleCount": "Measured decisions",
  "hitl.metricsTitle": "Decision time",
  "hitl.metricsWindow": "Window",
  "hitl.metricsWindowDays": "{{n}}d",
  "hitl.pageDescription": "Every pending human decision — approvals and AI tool executions — sorted oldest first.",
  "hitl.pageTitle": "Daily HITL cockpit",
  "hitl.reject": "Reject",
  "hitl.rejectReasonLabel": "Rejection reason",
  "hitl.rejectReasonRequired": "A rejection requires a reason.",
  "hitl.tableCaption": "Pending decisions, sorted from oldest to most recent",
  "hitl.platformAdminOnly": "Decision reserved to the platform administrator",
  "etat.loading": "Loading…",
  "etat.pending": "Pending",
  "etat.processing": "Running",
  "etat.workerLost": "Worker lost",
  "etat.failed": "Failed",
  "etat.timeout": "Timed out",
  "etat.done": "Done",
  "etat.workerLostHint": "The worker running this job stopped responding. You can restart it.",
  "etat.workerLostHintLectureSeule": "The worker running this job stopped responding. A workspace manager can restart it.",
  "etat.relancer": "Restart",
  "etat.relanceEnCours": "Restarting…",
  "etat.relanceRefusee": "Your role does not allow restarting this job.",
  "quota.unlimited": "Unlimited",
  "quota.atLimit": "Quota reached",
  "quota.atWarning": "Quota nearly reached",
  "quota.noWorkspace": "Select a workspace.",
  "quota.loading": "Loading quotas…",
  "quota.none": "No quota configured.",
  "quota.resourcesTitle": "Workspace quotas",
  "quota.aiModelsTitle": "AI call quota (per organisation)",
  "quota.tabTitle": "Quotas",
  "quota.resource.requests_per_minute": "Requests per minute",
  "quota.resource.tokens_per_day": "Tokens per day",
  "quota.resource.documents_count": "Knowledge documents",
  "quota.resource.document_size_mb": "Document size (MiB)",
  "quota.plan.title": "Organisation plan",
  "quota.plan.loading": "Loading plan…",
  "quota.plan.noOrganisation": "No active organisation.",
  "quota.plan.aiCallsPerDay": "AI calls per day",
  "quota.plan.free": "Free",
  "quota.plan.team": "Team",
  "quota.plan.enterprise": "Enterprise",
  "quota.plan.limiteCatalogue": "Plan limits (not applied)",
  "quota.plan.limiteEffective": "Effective limits",
  "quota.plan.limiteIllimitee": "unlimited (no quota applied)",
  "quota.piedAide": "The open project's quota closest to its limit (documents, tokens, AI calls…); click to see all the project's quotas.",
  "quota.piedContexte": "Open project quota",
  "admin.section.organisations": "Organisations",
  "admin.organisationsTitle": "Organisations",
  "admin.organisationsDescription": "Provision a new organisation for an account that already exists in Keycloak, which becomes its owner.",
  "org.admin.createButton": "Provision an organisation",
  "org.admin.createTitle": "Provision an organisation",
  "org.admin.createDescription": "The account designated below — already created in Keycloak — will become owner; a primary workspace is created automatically.",
  "org.admin.ownerEmail": "Owner email (existing Keycloak account)",
  "org.admin.submit": "Provision",
  "org.admin.createdToast": "Organisation provisioned",
  "accueil.sansEspaceHint": "Ask a workspace owner for an invitation: their projects will then show up here.",
  "accueil.sansEspaceTitre": "No workspace is assigned to you",
  "admin.sansEspaceDescription": "Workspace-bound sections (members, quotas, models) require membership: ask an owner for an invitation, or create a workspace from the selector.",
  "admin.sansEspaceTitre": "You administer the platform; no workspace is assigned to you.",
  "contexte.aucunEspaceAttribue": "No workspace is assigned to you — ask for an invitation.",
  "wsSwitch.noneAssigned": "No workspace is assigned to you — ask for an invitation.",
  "anomalies.form.titleRequired": "Give the defect a title: what is wrong, in one sentence.",
  "anomalies.form.fromExecution": "Report a defect from the execution",
  "anomalies.form.human": "Report a defect",
  "anomalies.form.prefilledFrom": "Prefilled from execution #{{execution}} of case {{key}} · {{name}}",
  "anomalies.field.title": "Title",
  "anomalies.form.possibleDuplicates": "Similar defects already reported",
  "anomalies.similarity": "similarity {{score}}",
  "anomalies.field.severity": "Severity (impact)",
  "anomalies.field.priority": "Priority (urgency)",
  "anomalies.field.steps": "Steps to reproduce",
  "anomalies.field.expected": "Expected",
  "anomalies.field.actual": "Actual",
  "anomalies.field.version": "Affected version",
  "anomalies.field.environment": "Environment",
  "anomalies.field.requirement": "Violated requirement",
  "anomalies.field.evidence": "Evidence (execution, screenshot, log)",
  "anomalies.form.creating": "Creating…",
  "anomalies.form.create": "Create the defect",
  "anomalies.form.cancel": "Cancel",
  "anomalies.rerun.none": "No open campaign to rerun this case.",
  "anomalies.rerun.started": "Reproduction started — verification opens as soon as it is green",
  "anomalies.loadingDetail": "Loading the defect…",
  "anomalies.form.resolutionRequired": "Provide the fix reference (commit, merge request, “Fixes {{ref}}”).",
  "anomalies.form.verificationRequired": "Choose the green execution that verifies the fix.",
  "anomalies.form.closureRequired": "Provide the delivery evidence (version, release, note).",
  "anomalies.form.duplicateRequired": "Choose the original defect.",
  "anomalies.form.reasonRequired": "Write the reason for this decision.",
  "anomalies.field.description": "Description",
  "anomalies.lifecycle": "Lifecycle",
  "anomalies.stepDone": "passed",
  "anomalies.badge.state": "state: {{v}}",
  "anomalies.badge.severity": "severity: {{v}}",
  "anomalies.badge.priority": "priority: {{v}}",
  "anomalies.badge.version": "version: {{v}}",
  "anomalies.badge.requirement": "requirement: {{v}}",
  "anomalies.badge.failureClass": "failure: {{v}}",
  "anomalies.field.reportedBy": "Reported by",
  "anomalies.field.resolution": "Fix",
  "anomalies.field.verifiedBy": "Verified by",
  "anomalies.field.duplicateOf": "Duplicate of",
  "anomalies.duplicates.title": "Possible duplicates",
  "anomalies.duplicates.hint": "Suggested by text similarity; only a human marks a duplicate.",
  "anomalies.duplicates.sameCase": "same test case",
  "anomalies.duplicates.mark": "Mark as duplicate of {{ref}}",
  "anomalies.verify.title": "Verify then close",
  "anomalies.verify.none": "No green execution of the reproduction case since the fix.",
  "anomalies.verify.some": "{{n}} green execution(s) available for verification.",
  "anomalies.rerun.starting": "Queuing…",
  "anomalies.rerun.action": "Run the reproduction",
  "anomalies.rerun.closed": "The originating campaign is no longer open: rerun the case in a new campaign (Tests screen).",
  "anomalies.rerun.recette": "Automatic reproduction is not possible: this case comes from a business acceptance campaign, which a person replays. Replay it in the acceptance campaign (Tests or Acceptance screen), then verify.",
  "anomalies.rerun.polling": "Execution running — refreshing automatically.",
  "anomalies.actions": "Actions",
  "anomalies.noAction": "No transition from this state.",
  "anomalies.field.failureClass": "Failure classification",
  "anomalies.field.resolutionRef": "Fix reference",
  "anomalies.field.verificationExecution": "Green execution that verifies",
  "anomalies.field.closureEvidence": "Delivery evidence",
  "anomalies.duplicates.target": "Duplicate of ANO-{{id}}",
  "anomalies.field.reason": "Reason",
  "anomalies.form.confirm": "Confirm: {{action}}",
  "anomalies.executions": "Linked executions",
  "anomalies.noExecution": "No linked execution.",
  "anomalies.link.origin": "origin",
  "anomalies.link.verification": "verification",
  "anomalies.history": "Transition history",
  "anomalies.noWorkspace": "Select a project",
  "anomalies.noWorkspaceHint": "Defects always belong to a workspace.",
  "anomalies.title": "Defects",
  "anomalies.description": "Report, triage, fix, verify then close — every step with its evidence.",
  "anomalies.declare": "Report a defect",
  "tests.requiredContributor": "Contributor",
  "anomalies.listTitle": "Project defects",
  "anomalies.filters": "Filters",
  "anomalies.filter.state": "State",
  "anomalies.filter.all": "All",
  "anomalies.filter.severity": "Severity",
  "anomalies.filter.version": "Version",
  "anomalies.loading": "Loading defects…",
  "anomalies.empty": "No defects",
  "anomalies.emptyFiltered": "No defect matches these filters.",
  "anomalies.emptyHint": "A red execution on the Tests screen becomes a defect in two gestures.",
  "anomalies.detailTitle": "Details",
  "anomalies.pick": "Choose a defect from the list.",
  "tests.rerunStarted": "Case rerun — its latest verdict prevails",
  "tests.superseded": "superseded by a more recent execution",
  "tests.defectLink": "Defect ANO-{{id}}",
  "tests.defectLinked": "Linked bug",
  "tests.declareDefect": "Report a defect",
  "tests.rerunCase": "Rerun the case",
  "anomalies.refusal.role": "Reserved to the workspace contributors and owners.",
  "anomalies.refusal.triage": "Classify the failure first (product, test, environment or flaky): triage the defect.",
  "anomalies.refusal.fixCommitUnknown": "The fix reference cites no commit or revision recorded by the pipeline: nothing links a green execution to the fix. Reopen the defect, then resolve it citing the delivered commit SHA (at least 7 characters) or the id of the revision that contains it.",
  "anomalies.refusal.fixNotAttested": "The fix commit is missing from this project’s pipeline registry: deliver it through a mission, a publication or “Build and sign the revision”, then verify.",
  "anomalies.refusal.executionRevisionUnknown": "The green execution does not say which revision it ran on: replay the case in a campaign opened on a revision (or tied to a release that retains one).",
  "anomalies.refusal.executionRevisionNotAttested": "The executed revision is not attested by the pipeline (no recorded image, no lineage): a declared revision proves nothing.",
  "anomalies.refusal.unknown": "Step refused by the server (code {{code}}).",
  "anomalies.verify.greensRefused": "{{n}} green execution(s) of the reproduction case, but none verifies this fix:",
  "anomalies.field.resolutionRefHint": "To allow verification, cite the delivered commit SHA (at least 7 characters) or the id of the revision that contains it: verification links the green execution to the fix through the pipeline registry.",
  "anomalies.field.testCase": "Acceptance test case it came from (optional)",
  "anomalies.field.testCaseHelp": "The case executed as “not compliant”: it defines what verification will require, and its validated test will be used as is for the fix.",
  "anomalies.field.testCaseNone": "No case",
  "erreurs.code.SPEC_GATE_REQUIRED": "Specification evidence required: the source specification has no current Spec Gate evidence (the attested receipt expires 24 h after its evaluation). Open the specification in the Approval Center, click “Re-evaluate the evidence”, then, once the PASS evidence is available, “Attach the renewed evidence” (by an owner or contributor other than the author). If the specification is not approved yet, get it approved first. For a backlog item without a source specification, link it to a published specification.",
  "erreurs.code.SPEC_GATE_RENEWAL_SELF_REFUSED": "You requested this specification: another owner or contributor must attest its renewed evidence.",
  "erreurs.code.SPEC_GATE_RENEWAL_APPROVAL_NOT_APPROVED": "Only an approved specification can have its evidence renewed; a pending request is decided with its current evidence.",
  "erreurs.code.SPEC_GATE_RENEWAL_APPROVAL_SUPERSEDED": "This specification version has been superseded: its evidence can no longer be renewed. Work on the current version.",
  "erreurs.code.SPEC_GATE_RENEWAL_PUBLICATION_IN_PROGRESS": "The specification is being published: retry attaching once the publication has finished.",
  "erreurs.code.SPEC_GATE_RENEWAL_RECEIPT_NOT_FOUND": "Spec Gate receipt not found: run “Re-evaluate the evidence” again, then attach the resulting receipt.",
  "erreurs.code.SPEC_GATE_RENEWAL_RECEIPT_OTHER_SPECIFICATION": "This receipt evaluates another specification or another version: only a receipt of the exact approved content can be attached.",
  "erreurs.code.SPEC_GATE_RENEWAL_RECEIPT_NOT_PASS": "This receipt is not a current PASS (13/13 grounded checks, no blocker, current card and policy): it cannot be attached.",
  "erreurs.code.SPEC_GATE_RENEWAL_RECEIPT_EXPIRED": "This receipt has expired too: run “Re-evaluate the evidence” to obtain a fresh one.",
  "erreurs.code.SPEC_GATE_RENEWAL_BUNDLE_MISMATCH": "The attested bundle is not this receipt's bundle: reload the displayed evidence and attest it again.",
  "erreurs.code.SPEC_GATE_RENEWAL_ALREADY_CURRENT": "This receipt is already the specification's pinned evidence: nothing to attach.",
  "erreurs.code.SPEC_GATE_RENEWAL_CONFLICT": "The specification changed during the attachment: reload the screen and try again.",
  "anomalies.refusal.green": "No green execution of the reproduction case since the fix: run the reproduction.",
  "anomalies.refusal.sod": "You resolved this defect: verification belongs to someone else.",
  "anomalies.refusal.order": "This step cannot be reached from the current state.",
  "tests.versionPublished": "Plan version published",
  "tests.planArchived": "Plan archived",
  "tests.campaignClosed": "Campaign closed",
  "tests.planVersion": "Plan version",
  "tests.currentPlan": "Current plan (unversioned)",
  "tests.publishingVersion": "Publishing…",
  "tests.publishVersion": "Publish a version",
  "tests.archiving": "Archiving…",
  "tests.archivePlan": "Archive",
  "tests.release": "Certified release",
  "tests.noRelease": "None (free campaign)",
  "tests.archivedPlanCampaignBlocked": "Archived plan — no new campaign can be opened. Existing campaigns remain viewable.",
  "tests.coverage": "Campaign coverage",
  "tests.closing": "Closing…",
  "tests.closeCampaign": "Close",
  "tests.automatedStarting": "Starting…",
  "tests.executeDocker": "Run in Docker",
  "anomalies.state.new": "new",
  "anomalies.state.triaged": "triaged",
  "anomalies.state.in_progress": "in progress",
  "anomalies.state.resolved": "resolved",
  "anomalies.state.verified": "verified",
  "anomalies.state.closed": "closed",
  "anomalies.state.duplicate": "duplicate",
  "anomalies.state.rejected": "rejected",
  "anomalies.state.not_reproducible": "not reproducible",
  "anomalies.state.reopened": "reopened",
  "anomalies.severity.blocker": "blocker",
  "anomalies.severity.major": "major",
  "anomalies.severity.minor": "minor",
  "anomalies.severity.cosmetic": "cosmetic",
  "anomalies.priority.critical": "critical",
  "anomalies.priority.high": "high",
  "anomalies.priority.medium": "medium",
  "anomalies.priority.low": "low",
  "anomalies.failureClass.product": "product",
  "anomalies.failureClass.test": "test",
  "anomalies.failureClass.environment": "environment",
  "anomalies.failureClass.flaky": "flaky",
  "anomalies.source.execution": "test execution",
  "anomalies.source.preview_annotation": "preview annotation",
  "anomalies.source.review": "review verdict",
  "anomalies.source.verifier": "verifier",
  "anomalies.source.human": "human report",
  "anomalies.action.new": "Report",
  "anomalies.action.triaged": "Triage",
  "anomalies.action.in_progress": "Take over",
  "anomalies.action.resolved": "Mark resolved",
  "anomalies.action.verified": "Mark verified",
  "anomalies.action.closed": "Close",
  "anomalies.action.duplicate": "Mark duplicate",
  "anomalies.action.rejected": "Reject",
  "anomalies.action.not_reproducible": "Not reproducible",
  "anomalies.action.reopened": "Reopen",
  "nav./anomalies": "Defects",
  "navdesc./anomalies": "Report, triage, fix, verify then close each defect with its evidence",
  "adr.card.chosenOption": "Chosen option",
  "adr.card.comment": "Comment",
  "adr.card.decideRequired": "Choose the retained option and write the decision.",
  "adr.card.g4": "G4 gate: at least 3 options",
  "adr.card.oneWay": "one-way decision: triangle required",
  "adr.card.requestApproval": "Request approval",
  "adr.card.review": "Review",
  "adr.card.reviewJustify": "A review must be justified.",
  "adr.card.reviewedBy": "Reviewed by {{who}} — {{verdict}}",
  "adr.card.save": "Save",
  "adr.card.submitDecision": "Decide",
  "adr.card.submitReview": "Save the review",
  "adr.card.supersede": "Supersede an ADR",
  "adr.card.twoPerson": "decided in two-person mode",
  "adr.caste.badge": "ADVICE",
  "adr.caste.note": "Labelled advice: it does not count in the score; a human scores and decides.",
  "adr.caste.title": "Architects caste proposal",
  "adr.create.g4": "G4 gate (at least 3 options)",
  "adr.create.open": "New ADR",
  "adr.create.required": "Title and context are required.",
  "adr.create.subject": "Subject",
  "adr.create.submit": "Create the ADR",
  "adr.create.supersedes": "Supersedes {{n}} — the former ADR stays readable, marked “superseded by”.",
  "adr.create.titleLabel": "Title",
  "adr.description": "Architecture decisions (ADR) of the project and of the tool: options compared on criteria fixed before scoring, traced decision, never a silent replacement.",
  "adr.fields.compliance": "Compliance",
  "adr.fields.consequencesMinus": "Consequences −",
  "adr.fields.consequencesPlus": "Consequences +",
  "adr.fields.context": "Context",
  "adr.fields.deciders": "Deciders",
  "adr.fields.decision": "Decision",
  "adr.list.empty": "No ADR",
  "adr.list.emptyHint": "An ADR is born from an existing gesture: G4 gate, stack change, waiver.",
  "adr.list.noWorkspaceHint": "Open a project to see its decisions.",
  "adr.list.project": "Project",
  "adr.list.scope": "Decision scope",
  "adr.list.supersededBy": "superseded by {{n}}",
  "adr.list.supersedes": "supersedes {{n}}",
  "adr.list.title": "Decisions",
  "adr.list.tool": "The tool (DoIt)",
  "adr.matrix.addCriterion": "Add a criterion",
  "adr.matrix.addOption": "Add an option",
  "adr.matrix.changeWeight": "Change a weight",
  "adr.matrix.choose": "Choose…",
  "adr.matrix.criterion": "criterion",
  "adr.matrix.empty": "Add options and criteria to compare.",
  "adr.matrix.excluded": "excluded (mandatory)",
  "adr.matrix.fieldsRequired": "All fields are required (a score must be justified).",
  "adr.matrix.frozen": "weights fixed on {{date}}, before scoring · scores 1 to 5",
  "adr.matrix.justification": "Justification",
  "adr.matrix.key": "Key (lowercase)",
  "adr.matrix.kind": "Kind",
  "adr.matrix.label": "Label",
  "adr.matrix.mandatory": "mandatory",
  "adr.matrix.no": "no",
  "adr.matrix.noStack": "— none —",
  "adr.matrix.notFrozen": "weights editable until the first score — they will then be frozen",
  "adr.matrix.option": "Option",
  "adr.matrix.passed": "Passed?",
  "adr.matrix.rule": "A stack without qualified golden cases on the model in service cannot be proposed: it stays visible, greyed out, with its reason.",
  "adr.matrix.save": "Save",
  "adr.matrix.score": "Score an option",
  "adr.matrix.scoreLabel": "Score (1 to 5)",
  "adr.matrix.stack": "Catalogue stack (stack ADR)",
  "adr.matrix.title": "Comparison matrix",
  "adr.matrix.weight": "weight",
  "adr.matrix.weightPercent": "Weight (%)",
  "adr.matrix.weighted": "weighted",
  "adr.matrix.weightedScore": "Weighted score",
  "adr.matrix.weightsTotal": "total weight: {{n}} % (100 % expected)",
  "adr.matrix.yes": "yes",
  "adr.noSelection": "Choose a decision to see its matrix and its record.",
  "adr.stack.fromAdr": "decided by",
  "adr.stack.measured": "{{passed}} / {{total}} golden cases · {{model}}",
  "adr.stack.none": "No stack decided: the stack profile comes from a decided stack ADR.",
  "adr.stack.notProposable": "cannot be proposed",
  "adr.stack.proposable": "can be proposed",
  "adr.stack.title": "Project stack profile",
  "adr.stack.unmeasured": "generability not measured",
  "adr.status.decided": "decided",
  "adr.status.deprecated": "deprecated",
  "adr.status.proposed": "proposed",
  "adr.status.superseded": "superseded",
  "adr.subject.database": "database",
  "adr.subject.engine": "inference engine",
  "adr.subject.other": "other",
  "adr.subject.stack": "technology stack",
  "adr.title": "Decisions",
  "nav./decisions": "Decisions and stack profile",
  "nav./organisation": "Requirements framework",
  "navdesc./decisions": "Architecture decisions (ADR), matrix and stack profile of the project",
  "navdesc./organisation": "Definition of done, requirements and controls of the organisation",
  "org.cancel": "Cancel",
  "org.category.accessibilite": "accessibility",
  "org.category.compatibilite": "compatibility",
  "org.category.donneesPersonnelles": "personal data",
  "org.category.fiabilite": "reliability",
  "org.category.licences": "licences",
  "org.category.maintenabilite": "maintainability",
  "org.category.performance": "performance",
  "org.category.pile": "technology stack",
  "org.category.portabilite": "portability",
  "org.category.qualite": "quality",
  "org.category.securite": "security",
  "org.category.tracabilite": "traceability",
  "org.category.utilisabilite": "usability",
  "org.page.description": "What the organisation requires from every project, what a project inherits, and waivers — always dated, never silently extended.",
  "org.heritage.add": "Add the criterion",
  "org.heritage.addLabel": "Strengthen: add a criterion",
  "org.heritage.addRequired": "Identifier, criterion and named control are required.",
  "org.heritage.addedByProject": "added by the project",
  "org.heritage.code": "Identifier (e.g. DOD-PRJ-001)",
  "org.heritage.control": "control",
  "org.heritage.countAVerifier": "{{n}} to verify",
  "org.heritage.countConforme": "{{n}} compliant",
  "org.heritage.countDerogation": "{{n}} under waiver",
  "org.heritage.countNonConforme": "{{n}} non-compliant",
  "org.heritage.empty": "No requirement carried by this project",
  "org.heritage.emptyHint": "The organisation's in-force or observed requirements are inherited when the project is created.",
  "org.heritage.enforce": "enforce",
  "org.heritage.fromOrganisation": "inherited from the organisation",
  "org.heritage.fromProgram": "inherited from programme {{id}}",
  "org.heritage.modeEnforce": "Mode: enforce — a missing inherited requirement blocks the specification approval.",
  "org.heritage.modeLabel": "Enforcement mode",
  "org.heritage.modeObserve": "Mode: observe — non-compliances are reported, nothing is blocked.",
  "org.heritage.modeSave": "Apply the mode",
  "org.heritage.noneRemoved": "none removed",
  "org.heritage.observe": "observe",
  "org.heritage.receivedOn": "received on {{date}}",
  "org.heritage.remove": "Remove",
  "org.heritage.removedUnderWaiver": "{{n}} removed under waiver",
  "org.heritage.statement": "Criterion",
  "org.heritage.summary": "{{total}} criteria · strengthened by the project (+{{added}}) · {{removed}}",
  "org.heritage.title": "Project inheritance",
  "org.noWorkspace": "No project open",
  "org.noWorkspaceHint": "Open a project to see what it inherits and its waivers.",
  "org.presence.content": "Specification text",
  "org.presence.contentRequired": "Paste the text to check.",
  "org.presence.digest": "Digest",
  "org.presence.hint": "Every project requirement must be cited by its identifier, or covered by a waiver in force. Deterministic check: never the Spec Gate.",
  "org.presence.missing": "Missing:",
  "org.presence.observed": "missing ones reported (observe mode)",
  "org.presence.pass": "all requirements are present or covered",
  "org.presence.refused": "refused — inherited requirement missing",
  "org.presence.run": "Check",
  "org.presence.title": "Presence check of inherited requirements",
  "org.ref.add": "Add a requirement",
  "org.ref.category": "Category",
  "org.ref.changeStatus": "Change the status of {{code}}",
  "org.ref.code": "Identifier (e.g. NFR-PERF-001)",
  "org.ref.colControl": "control that verifies it",
  "org.ref.colId": "identifier",
  "org.ref.colMeasure": "measurement",
  "org.ref.colStatement": "requirement",
  "org.ref.colStatus": "status",
  "org.ref.control": "Control that verifies it",
  "org.ref.controlRequired": "A requirement without a named control can be neither observed nor in force.",
  "org.ref.created": "Requirement added to the reference catalogue",
  "org.ref.empty": "No reference requirement",
  "org.ref.emptyHint": "The organisation administration defines the DoD and the reference non-functional requirements.",
  "org.ref.formLabel": "New reference requirement",
  "org.ref.initialStatus": "Initial status",
  "org.ref.method": "Measurement method",
  "org.ref.moveTo": "Move to…",
  "org.ref.noControl": "no named control",
  "org.ref.note": "A requirement without a named control does not go “in force”. A new rule starts in “observe”.",
  "org.ref.owner": "Owner",
  "org.ref.readOnly": "Read only — the reference catalogue is administered by the organisation.",
  "org.ref.requiredFields": "Identifier, requirement and owner are required.",
  "org.ref.statement": "Requirement",
  "org.ref.submit": "Add",
  "org.ref.threshold": "Threshold",
  "org.ref.title": "Organisation reference catalogue",
  "org.request.controls": "Compensating controls (testable)",
  "org.request.controlsRequired": "At least one testable compensating control is required.",
  "org.request.expiry": "Expires on (required)",
  "org.request.expiryRequired": "The expiry date is required: a waiver without a deadline is refused.",
  "org.request.justification": "Justification",
  "org.request.justificationRequired": "The justification is required.",
  "org.request.owner": "Owner",
  "org.request.ownerRequired": "The owner is required.",
  "org.request.readOnly": "Read only — requesting a waiver is reserved to the project contributors.",
  "org.request.requirement": "Targeted requirement",
  "org.request.requirementRequired": "Choose the targeted requirement.",
  "org.request.riskFixed": "{{risk}} risk — set by the category",
  "org.request.riskLevel": "Risk (can be raised, never lowered)",
  "org.request.ruleHigh": "High risk: approval by the triangle. Beyond 90 days, review required. Never a silent extension.",
  "org.request.ruleLow": "Low risk: approval by the project owner. Never a silent extension.",
  "org.request.ruleMedium": "Medium risk: approval by a designated architect. Never a silent extension.",
  "org.request.securityNote": "Security review (beyond 90 days)",
  "org.request.securityReviewRequired": "Beyond 90 days, a security waiver requires a recorded security review.",
  "org.request.sent": "Waiver requested — awaiting approval",
  "org.request.submit": "Request approval",
  "org.request.title": "Waiver request",
  "org.risk.high": "high",
  "org.risk.low": "low",
  "org.risk.medium": "medium",
  "org.risk.unclassified": "unclassified",
  "org.state.aVerifier": "to verify",
  "org.state.conforme": "compliant",
  "org.state.enDerogation": "under waiver",
  "org.state.nonConforme": "non-compliant",
  "org.state.perimee": "obsolete",
  "org.status.inForce": "in force",
  "org.status.observe": "observe",
  "org.status.proposed": "proposed",
  "org.status.retired": "retired",
  "org.page.title": "Requirements and waivers",
  "org.twoPerson.alwaysThree": "Always keep three people:",
  "org.twoPerson.disabled": "disabled",
  "org.twoPerson.disabledRule": "The requester never approves their own object: three distinct people (requester, reviewer, approver).",
  "org.twoPerson.enabled": "enabled",
  "org.twoPerson.enabledRule": "For a low-risk object only, the approver may be the requester; the reviewer stays distinct and the approval carries the “two-person mode” mention in the audit.",
  "org.twoPerson.excludedOneWay": "one-way decisions (stack, engine, database)",
  "org.twoPerson.excludedProduction": "promotion to production",
  "org.twoPerson.excludedSecurity": "security",
  "org.twoPerson.excludedWaiver": "waivers",
  "org.twoPerson.setting": "Template setting",
  "org.twoPerson.title": "Two-person mode",
  "org.waiver.dueIn": "in {{n}} d",
  "org.waiver.expiredNonCompliant": "expired — non-compliant",
  "org.waiver.lifted": "lifted",
  "org.waiver.refused": "refused",
  "org.waiver.requested": "requested",
  "org.waiver.routeArchitect": "architect",
  "org.waiver.routeOwner": "project owner",
  "org.waiver.routeTriangle": "triangle (three people)",
  "org.waivers.age": "requested {{n}} d ago",
  "org.waivers.colDue": "due",
  "org.waivers.colGranted": "granted",
  "org.waivers.colRequirement": "requirement",
  "org.waivers.colRisk": "risk",
  "org.waivers.colState": "state",
  "org.waivers.comment": "Comment (required for a review or a refusal)",
  "org.waivers.confirm": "Save",
  "org.waivers.decide": "Decide",
  "org.waivers.decision": "Decision",
  "org.waivers.empty": "No active waiver",
  "org.waivers.emptyHint": "A waiver is requested from the “Waiver request” form.",
  "org.waivers.grant": "grant",
  "org.waivers.lift": "Lift",
  "org.waivers.refuse": "refuse",
  "org.waivers.review": "Review",
  "org.waivers.reviewApprove": "favourable",
  "org.waivers.reviewReject": "unfavourable",
  "org.waivers.reviewVerdict": "Review verdict",
  "org.waivers.title": "Active waivers",
  "org.settings.title": "Organisation settings",
  "org.settings.edit": "Edit",
  "org.settings.enforce": "enforce",
  "org.settings.observe": "observe",
  "org.settings.newProjectMode": "New projects:",
  "org.settings.modeHint": "applies to projects created afterwards; existing projects stay in observe until the deadline set by the administration",
  "org.settings.architects": "Designated architects:",
  "org.settings.noArchitect": "no designated architect",
  "org.settings.architectsHint": "medium-risk waivers are decided by a designated architect",
  "org.settings.readOnly": "Read only — these settings are changed by the organisation administration.",
  "org.settings.modeLabel": "New projects mode",
  "org.settings.architectsLabel": "Designated architects (identifiers, comma-separated or one per line)",
  "org.settings.save": "Save the settings",
  "admin.aiConnectionAdd": "Save connection",
  "admin.aiConnectionDisable": "Disable",
  "admin.aiConnectionEnable": "Enable",
  "admin.aiConnectionName": "Name",
  "admin.aiConnectionsHeading": "AI provider connections",
  "admin.aiConnectionsHint": "Keys stay in the secret store: only a secret_ref is recorded.",
  "admin.aiConnectorConnected": "active connector",
  "admin.aiConnectorDisabled": "disabled connector",
  "admin.aiConnectorLocal": "local runtime",
  "admin.aiConnectorMissing": "connector not found",
  "admin.aiEndpoint": "Endpoint",
  "admin.aiProvider": "Provider",
  "admin.aiSecretRef": "Secret reference (optional)",
  "admin.disabled": "disabled",
  "admin.enabled": "enabled",
  "admin.globalAiActivate": "Enable for this organisation",
  "admin.globalAiChooseOrg": "Choose an organisation",
  "admin.globalAiConnectionRequired": "Connection required",
  "admin.globalAiCreate": "Add the platform",
  "admin.globalAiDeactivate": "Disable for this organisation",
  "admin.globalAiDefaultConnection": "Default local runtime",
  "admin.globalAiDisable": "Disable the connection",
  "admin.globalAiDisabledBinding": "The linked connector is disabled: re-enable it or choose another one.",
  "admin.globalAiDiscoverModels": "Discover models",
  "admin.globalAiDiscoveryResult": "Discovery: {{count}} model(s) added or updated.",
  "admin.globalAiEnable": "Enable the connection",
  "admin.globalAiHeading": "Global AI platforms",
  "admin.globalAiHint": "Declare providers once, then enable them organisation by organisation. Secrets stay referenced, never displayed.",
  "admin.globalAiKillSwitchDisable": "Stop AI requests",
  "admin.globalAiKillSwitchEnable": "Re-enable AI requests",
  "admin.globalAiKillSwitchHint": "Immediately blocks new generations for all organisations.",
  "admin.globalAiKillSwitchReason": "Reason",
  "admin.globalAiKillSwitchReasonPlaceholder": "Reason (required, kept in the history)",
  "admin.globalAiKillSwitchReasonRequired": "Enter a reason (at least 3 characters): it is kept in the history.",
  "admin.globalAiKillSwitchConfirmation": "Confirmation: type « plateforme »",
  "admin.globalAiKillSwitchConfirmationPlaceholder": "Type « plateforme » to confirm",
  "admin.globalAiKillSwitchConfirmationRequired": "Type « plateforme » to confirm switching the whole platform.",
  "admin.globalAiKillSwitchTitle": "Global AI request kill switch",
  "admin.globalAiLocalRuntime": "default local runtime",
  "admin.globalAiMissingBinding": "No active connector matches this model.",
  "admin.globalAiModelCapabilities": "Model capabilities",
  "admin.globalAiModelConnection": "Model connection",
  "admin.globalAiModelName": "Display name",
  "admin.globalAiModelsHeading": "Model wiring",
  "admin.globalAiModelsHint": "Choose the connection actually used by each model in the catalog.",
  "admin.globalAiModelType": "Model type",
  "admin.globalAiNoCompatibleConnection": "No connector enabled for this provider",
  "admin.globalAiOrganisation": "Target organisation",
  "admin.globalAiOrganisationRequired": "Choose an organisation before changing its activation.",
  "admin.globalAiProbe": "Probe",
  "admin.globalAiRegisterModel": "Register the model",
  "admin.globalAiRegisterModelHeading": "Register a model",
  "admin.globalAiRegisterModelHint": "For protected cloud providers or models missing from the automatic catalog. A compatible connection can be selected.",
  "admin.globalAiResolvedConnection": "resolved connector",
  "admin.langfuseProbe": "Test ingestion",
  "admin.langfuseProbeHint": "Verifies a real ingestion without displaying any key or business content.",
  "admin.langfuseProbeTitle": "Langfuse observability",
  "admin.notificationAdd": "Add the channel",
  "admin.notificationChannelsHeading": "Notification channels",
  "admin.notificationChannelsHint": "Configure the destinations used for generation failures. Secrets stay in the external manager.",
  "admin.notificationEndpoint": "Endpoint or address",
  "admin.notificationName": "Channel name",
  "admin.notificationProvider": "Channel type",
  "admin.notificationSecretRef": "Secret reference (optional)",
  "admin.operationsHealthDescription": "Operational status by organisation, refreshed automatically.",
  "admin.operationsHealthScrollRegion": "Scrollable health table",
  "admin.operationsHealthTable": "Organisations health status",
  "admin.operationsHealthTitle": "Platform health",
  "admin.organisationAiActivate": "Enable",
  "admin.organisationAiDeactivate": "Disable",
  "admin.organisationAiModelsHeading": "AI models enabled for the organisation",
  "admin.organisationAiModelsHint": "Only enable models that workspaces can use. The provider and connector are those from the global catalog.",
  "admin.teamCreate": "Create the team",
  "admin.teamCreatedToast": "Team created",
  "admin.teamDescriptionPlaceholder": "Description (optional)",
  "admin.teamMemberAddedToast": "Member added to the team",
  "admin.teamMemberChoose": "Choose a member",
  "admin.teamMemberSelect": "Member to add to the team",
  "admin.teamMemberAdd": "Add the selected member to the team",
  "admin.teamNameError": "Enter at least 2 characters.",
  "admin.teamNamePlaceholder": "Team name",
  "admin.teamsHeading": "Work teams",
  "admin.teamsHint": "Group project members by team without changing their access roles.",
  "approvals.appPort": "Listening port",
  "approvals.appPortInvalide": "Invalid port: an integer between 1 and 65535.",
  "approvals.appSlug": "Technical name",
  "approvals.appSlugInvalide": "Invalid technical name: lowercase letters, digits and hyphens, 3 to 41 characters, not starting with a hyphen.",
  "approvals.attestationRequired": "Review the content before rejecting.",
  "approvals.compareExtraction": "Compare this extraction",
  "approvals.generateApp": "Generate the application",
  "approvals.generateAppDesc": "produces the complete file tree of a standalone application covering this approved specification. The report comes back for approval like any other artifact; nothing is deployed.",
  "approvals.historicalEvidenceAttested": "A historical human attestation is recorded for this exact piece of evidence.",
  "approvals.historicalEvidenceNotAttested": "This historical evidence is not attested by a human.",
  "approvals.latestEvaluationEvidence": "Evidence from the latest evaluation",
  "approvals.noPriorVersion": "No comparable prior version: consult the available source above; no diff is fabricated.",
  "approvals.openSource": "View the source",
  "approvals.originalPrompt": "Prompt / original source",
  "approvals.reasonHint": "Add a reason to enable rejection.",
  "approvals.recordedDecisionEvidence": "Evidence for the recorded decision",
  "approvals.sourceContextApprovalBlocked": "Approval stays unavailable until the required source context is loaded.",
  "approvals.sourceContextHint": "The original prompt and the comparison are shown before any decision.",
  "approvals.sourceContextTitle": "Source context of the decision",
  "approvals.sourceContextUnavailable": "The required source context cannot be loaded; approval is blocked.",
  "approvals.specGateEvidenceConsultationUnavailable": "The historical evidence cannot be loaded at this time.",
  "approvals.specGateEvidenceEmpty": "No detailed reference in this evidence.",
  "approvals.specGateEvidenceLoading": "Loading evidence references…",
  "approvals.specGateEvidenceReferences": "Evidence references",
  "approvals.specGateTerminalError": "The latest evaluation did not complete. This case is closed.",
  "approvals.specGateTerminalFailed": "The latest evaluation found issues to correct. This case is closed.",
  "approvals.specGateTerminalFailedLabel": "Issues found",
  "approvals.specGateTerminalNotRequested": "No evaluation was recorded before the decision. This case is closed.",
  "approvals.specGateTerminalNotRequestedLabel": "No evaluation recorded",
  "approvals.specGateTerminalStale": "The latest recorded evaluation is stale. This case is closed.",
  "approvals.unifiedDiff": "Unified diff: current version → proposal",
  "backlog.bulkFieldTeam": "the team",
  "backlog.bulkTeamLabel": "Team (bulk)",
  "backlog.bulkTeamPlaceholder": "Team…",
  "backlog.filterTeamAll": "All",
  "backlog.noTeam": "No team",
  "backlog.reviewStoryHint": "The review will check the latest approved change linked to this item.",
  "backlog.sprint": "Sprint",
  "backlog.sprintSelect": "Assign to sprint",
  "backlog.sprintUpdated": "Sprint updated",
  "backlog.team": "Team",
  "backlog.teamSelect": "Assign to a team",
  "classement.etiquettes": "Labels",
  "classement.aucuneEtiquette": "No label",
  "classement.etiquette": "Label",
  "classement.composants": "Components",
  "classement.aucunComposant": "No component",
  "classement.composant": "Component",
  "classement.versions": "Fix versions",
  "classement.aucuneVersion": "No fix version",
  "classement.version": "Fix version",
  "classement.cree": "Classification created",
  "classement.sansProjet": "No project open",
  "classement.sansProjetAide": "The classification belongs to a project: open it in the context bar.",
  "classement.titre": "Project classification",
  "classement.description": "Labels, components and fix versions: what organises items across the hierarchy.",
  "classement.versBacklog": "Back to the backlog",
  "classement.chargement": "Loading…",
  "classement.videAide": "Create one below, or from an item's page.",
  "classement.formulaireDessous": "The form below creates it.",
  "classement.nItems": "{{n}} item(s)",
  "classement.creer": "Create: {{nature}}",
  "classement.nom": "Name",
  "classement.ajouter": "Add",
  "classement.modifie": "Fix version updated",
  "classement.supprime": "Classification deleted; items are kept",
  "classement.versListe": "The whole project classification",
  "classement.introuvable": "Classification not found",
  "classement.introuvableAide": "It does not (or no longer) exist in the open project.",
  "classement.supprimerTitre": "Delete “{{nom}}”?",
  "classement.supprimerConsequence": "{{n}} item(s) lose this classification; no item is deleted.",
  "classement.supprimerReversible": "You can recreate the classification, but it will have to be set on the items again.",
  "classement.supprimer": "Delete",
  "classement.ficheDescription": "The items carrying this classification, and what can be done with it.",
  "classement.date": "Planned date",
  "classement.livree": "Released",
  "classement.oui": "yes",
  "classement.non": "no",
  "classement.itemsPortant": "Items carrying it ({{n}})",
  "classement.chargementItems": "Loading items…",
  "classement.aucunItem": "No item carries it",
  "classement.aucunItemAide": "It is set from an item's page.",
  "classement.modifierVersion": "Edit the fix version",
  "classement.enregistrer": "Save",
  "classement.marquerNonLivree": "Mark as not released",
  "classement.marquerLivree": "Mark as released",
  "classement.lectureSeule": "Read only: reserved for project owners and contributors.",
  "classement.nomManquant": "Give a name.",
  "chat.latency": "Latency",
  "chat.messageRequired": "Write a message before sending.",
  "chat.modelRequired": "Choose a model before sending.",
  "chat.provider": "Provider",
  "classif.versionSelect": "Assign to version",
  "classif.versionUpdatedToast": "Version updated",
  "compare.approve": "Approve",
  "compare.executionFailed": "The comparison stopped before producing usable outputs.",
  "compare.executionFailedDetail": "You can retry it after checking AI capacity.",
  "compare.insufficientModelsTitle": "Two allowed models are required",
  "compare.linkedDocument": "Linked document",
  "compare.modelsUnavailable": "The model catalog is unavailable.",
  "compare.reject": "Reject",
  "compare.retry": "Retry the comparison",
  "compare.retrying": "Retrying…",
  "compare.reviewComment": "Comment (required for a rejection)",
  "compare.reviewCommentRequired": "A rejection must be justified.",
  "compare.reviewedBy": "Decision recorded by",
  "compare.reviewSaved": "Review decision recorded",
  "compare.reviewStatus": "Status",
  "compare.reviewTitle": "Human review",
  "compare.sectionEmpty": "The selected section is empty.",
  "compare.sectionLabel": "Section to compare",
  "config.agentRoleChoose": "Choose a role",
  "config.agentUnavailable": "unavailable",
  "config.apiAuthUnavailable": "inherited/unsupported",
  "config.apiUnavailable": "inherited/unsupported",
  "config.bindWorkspaceTemplate": "Use for this workspace",
  "config.editTemplate": "Edit this template",
  "config.exitEdit": "Exit edit mode",
  "config.lifecycle.keyFormat": "Start with a lowercase letter, then use only a-z, 0-9, _ or - (2 to 64 characters).",
  "config.lifecycle.routeDefault": "(route inherited from the key)",
  "config.lifecycle.routeLegacy": "inherited",
  "config.llmRoutingChoose": "Choose a policy",
  "config.llmRoutingLegacy": "inherited/unsupported",
  "config.mcpAgent": "MCP agent",
  "config.mcpApprove": "Approve",
  "config.mcpBindAgent": "Bind",
  "config.mcpChooseAgent": "Choose an agent",
  "config.mcpDisable": "Disable",
  "config.mcpEnable": "Enable",
  "config.mcpImportHint": "Import an MCP ZIP. The manifest is checked before any activation.",
  "config.mcpImporting": "Validating…",
  "config.mcpImportReadOnly": "Import available in an editable organisational template.",
  "config.mcpImportSource": "Import",
  "config.mcpSourceGitlab": "GitLab repository",
  "config.mcpSourceInvalid": "The MCP URL must be a valid HTTP(S) URL.",
  "config.mcpSourceRequired": "Enter an MCP source URL.",
  "config.mcpSourceRevision": "GitLab branch or tag",
  "config.mcpSourceType": "MCP source",
  "config.mcpSourceUpload": "Local ZIP",
  "config.mcpSourceUrl": "ZIP URL",
  "config.mcpSourceUrlLabel": "MCP source URL",
  "config.mcpToolUnavailable": "inherited",
  "config.mcpUnavailable": "unavailable",
  "config.mcpUseInTemplate": "Use in this template",
  "config.mcpZip": "MCP ZIP archive",
  "config.modeChoose": "Choose a policy",
  "config.model.gates": "Entry gates",
  "config.modelChoose": "Choose a configured model",
  "config.modelEmbeddingMismatch": "This role expects an embedding model, but this model does not advertise it.",
  "config.modelPoolChoose": "Choose a pool",
  "config.modelRoleChoose": "Choose a role",
  "config.modelUnavailable": "unavailable",
  "config.modelVisionMismatch": "This role expects vision, but this model does not advertise it.",
  "config.modeUnavailable": "inherited/undeclared",
  "config.modeUnavailableDescription": "Policy not supported by this version.",
  "config.noActiveModelsHint": "No runnable model is available. Enable a connector and grant at least one model in AI administration.",
  "config.noWorkspaceTemplate": "Select a workspace and a template.",
  "config.processAdd": "Add a step",
  "config.processAgentWorkflow": "Agent workflow",
  "config.processApproval": "Validation",
  "config.processApprovalReason": "Approval reason",
  "config.processApprovalReasonHint": "Reason (required)",
  "config.processApprovalRequired": "Enter a reason of at least 3 characters to approve.",
  "config.processApprove": "Approve and continue",
  "config.processApproveConfirmed": "Approval confirmed — status: {{status}}.",
  "config.processBlocked": "Prerequisites to complete",
  "config.processEmpty": "No step declared. The built-in cycle remains available.",
  "config.processEnvironment": "Docker environment",
  "config.processGates": "Gates",
  "config.processGitlabRef": "GitLab reference",
  "config.processHint": "Order your organisation's actions, gates and human validations.",
  "config.processInputs": "Inputs",
  "config.processKey": "Key",
  "config.processKeyFormat": "Start with a lowercase letter, then use only a-z, 0-9 or _ (2 to 64 characters).",
  "config.processKind": "Step type",
  "config.processLabel": "Label",
  "config.processNoBlockers": "All declared capabilities are available.",
  "config.processOutputs": "Outputs",
  "config.processPipelineId": "Project pipeline",
  "config.processReadOnlyApproval": "This step is waiting for approval from an owner or reviewer.",
  "config.processReadOnlyResume": "Read-only: an owner or contributor can resume the process.",
  "config.processReadOnlyRun": "Read-only: an owner or contributor must launch the process.",
  "config.processReadOnlyStep": "Read-only: an owner or contributor can run this step.",
  "config.processReady": "Process ready",
  "config.processRelease": "Release to deploy",
  "config.processRemove": "Remove the step",
  "config.processResume": "Resume execution",
  "config.processResumeConfirmed": "Resume confirmed — status: {{status}}.",
  "config.processRoles": "Roles",
  "config.processRun": "Run this step",
  "config.processRunAll": "Launch the process",
  "config.processSave": "Save the process",
  "config.processSaved": "Process saved",
  "config.processStartConfirmed": "Start confirmed — status: {{status}}.",
  "config.processTitle": "Idea → production process",
  "config.publicationBlocked": "Publication to prepare",
  "config.published": "Published · v{{v}}",
  "config.publishedToast": "Version published",
  "config.publishTemplate": "Publish v{{v}}",
  "config.retryBackoffMaxSeconds": "Backoff ceiling (s)",
  "config.retryBackoffSeconds": "Initial backoff (s)",
  "config.retryMaxAttempts": "Maximum attempts",
  "config.retryPolicy": "Tool retry policy",
  "config.retryPolicyHint": "Transport errors and timeouts follow this bounded retry; business errors remain terminal.",
  "config.technologiesProjectHint": "Implementation technologies are configured in RunOps for each project/environment, not in the template.",
  "config.templateBoundToast": "Template bound to the workspace",
  "config.templateMigrate": "Preview and migrate",
  "config.templateMigrationAttest": "I have reviewed the change preview",
  "config.templateMigrationAvailable": "Migration available",
  "config.templateMigrationC1": "The new configuration will become this project's pinned version.",
  "config.templateMigrationC2": "The change will be recorded in the audit log and will not be automatic.",
  "config.templateMigrationSummary": "Project version v{{from}} → v{{to}} · {{n}} section(s) changed",
  "config.templateMigrationTitle": "Migrate the project to v{{v}}?",
  "config.templateMigrationToast": "Project migrated to the new version",
  "config.templateMigrationVerb": "Migrate the project",
  "config.templateVersionPinned": "Project version v{{v}}",
  "config.workflowIdFormat": "Start with a lowercase letter, then use only a-z, 0-9, _ or - (2 to 64 characters).",
  "config.workflowStepUnavailable": "inherited",
  "config.workflowTriggerChoose": "Choose a trigger",
  "config.workflowTriggerUnavailable": "inherited/unsupported",
  "confirm.graceRemaining": "Confirmation available in {{seconds}} s",
  "dashboard.archivedWorkspace": "Archived · read-only",
  "dashboard.createOrganisation": "Create my organisation",
  "dashboard.noOrganisation": "Your organisation has not been created yet",
  "dashboard.recentDecisionsRegion": "List of recent decisions",
  "dashboard.servedModelsList": "List of served models",
  "delivery.description": "Track GitLab code and promote the same release to your Docker environments from a single flow.",
  "delivery.title": "Delivery cockpit",
  "gen.appToast": "Application generation started",
  "gitlab.pipelineTriggered": "GitLab pipeline triggered",
  "gitlab.refLabel": "Branch or ref",
  "gitlab.refRequired": "Enter a GitLab branch or ref.",
  "gitlab.refresh": "Refresh GitLab data",
  "gitlab.trigger": "Trigger",
  "graph.children": "Children",
  "graph.dataTable": "Graph data table",
  "graph.dataTableCaption": "Data, hierarchy and relations of the work item graph",
  "graph.keyboardHelp": "Use Tab to move through the graph items, then Enter or Space to open the item. The data table below provides the complete text equivalent.",
  "graph.noRelation": "No relation",
  "graph.parent": "Parent",
  "graph.tableId": "ID",
  "graph.tableItem": "Item",
  "graph.tableKind": "Type",
  "graph.tableRelations": "Relations",
  "graph.tableStatus": "Status",
  "history.semanticEmpty": "No nearby event found.",
  "history.semanticLoading": "Semantic search…",
  "history.semanticQueryRequired": "Enter a term before running the semantic search.",
  "history.semanticResults": "Semantic results",
  "history.semanticSearch": "Semantic search",
  "ideas.draftRestored": "Draft restored — resuming your previous input.",
  "ideas.openHistory": "Open history",
  "ideas.queuedWithoutTimeline": "Your idea has been recorded and generation is queued. The timeline will appear as soon as the worker publishes the job. You can stay on this page or check the history.",
  "ingestion.columnActions": "Actions",
  "ingestion.compareAcrossModels": "Compare this question across several models",
  "ingestion.delete": "Delete",
  "ingestion.documentScopeAll": "The entire document base",
  "ingestion.documentScopeLabel": "Document (optional)",
  "ingestion.loadingSources": "Loading ingested sources…",
  "ingestion.missingChecksum": "The persisted SHA-256 fingerprint is not available: the document has not been validated yet.",
  "ingestion.uploadProgress": "Upload progress",
  "ingestion.uploadProgressComplete": "Upload complete — fingerprint validation in progress.",
  "ingestion.uploadStage": "Step: uploading the document",
  "ingestion.verificationStage": "Step: verifying the persisted fingerprint",
  "ingestion.verifySourceError": "Unable to verify the persisted fingerprint. Try loading the sources again.",
  "item.cancelEdit": "Cancel",
  "item.criteriaHint": "One criterion per line",
  "item.description": "Description",
  "item.edit": "Edit",
  "item.editHint": "Changes are saved on this record.",
  "item.editTitle": "Edit the item",
  "item.executableAfterDecomposition": "This story describes the need. Generate then accept its tasks before producing code.",
  "item.invalidEffort": "Effort must be a positive integer.",
  "item.noTeam": "No team",
  "item.save": "Save",
  "item.saving": "Saving…",
  "item.team": "Team",
  "item.title": "Title",
  "item.titleRequired": "The title is required.",
  "job.agentCompleted": "Agent execution completed",
  "login.demoHint": "Demo accounts are configured in your local environment.",
  "login.otherMethod": "Other sign-in method",
  "login.username": "Username",
  "notif.approvalRequested": "is requesting your approval",
  "notif.digest": "digest of unread notifications",
  "notif.digestActeur": "Digest",
  "notif.reglages": "Settings",
  "notif.reglagesDesc": "All, mentions only or muted, by default then per project; digest three times a day.",
  "notif.reglagesTitre": "Notification settings",
  "notif.retourFil": "Back to notifications",
  "org.createButton": "Create my organisation",
  "org.createDescription": "Your account will become owner and a main workspace will be created automatically.",
  "org.createdToast": "Organisation created",
  "org.createTitle": "Create your organisation",
  "org.creating": "Creating…",
  "org.description": "Description (optional)",
  "org.name": "Organisation name",
  "org.submit": "Create the organisation",
  "processView.description": "The steps and prerequisites actually applicable to this project, before any execution.",
  "processView.title": "Effective process",
  "programs.initiativeFrame": "Scope then specify",
  "programs.initiativeFramingLaunched": "Scoping started. It will go through human review before the specification and the code.",
  "programs.initiativeNextStep": "Next steps: approve the scoping, draft the specification, pass the Spec Gate, then generate the code.",
  "programs.initiativeObjective": "Objective (optional)",
  "programs.initiativeObjectiveFailed": "The initiative is launched, but its objective was not saved: set it from the log.",
  "programs.initiativeObjectiveHint": "Applied to the initiative as soon as it is launched; it can then be edited from the log.",
  "programs.initiativeObjectivePlaceholder": "E.g. +10% returning customers",
  "programs.initiativeObjectiveSet": "Objective saved on the initiative.",
  "programs.initiativeOpenApprovals": "Open approvals",
  "runops.autoStop": "Automatic stop (minutes)",
  "runops.autoStopAide": "Required for a preview, between 5 minutes and 30 days.",
  "runops.composeFile": "Compose file",
  "runops.composeFileAide": "Relative path within the repository; no free-form shell command.",
  "runops.editEnvironment": "Edit",
  "runops.editEnvironmentHelp": "Deployments already run remain unchanged.",
  "runops.editEnvironmentTitle": "Edit the environment",
  "runops.envUpdatedToast": "Environment updated",
  "runops.healthcheck": "Healthcheck URL",
  "runops.healthcheckAide": "Optional. HTTP(S), used to check availability.",
  "runops.lifetimeType": "Lifecycle",
  "runops.lifetimeTypeAide": "Persistent stays active; ephemeral stops automatically.",
  "runops.postgresSecretRef": "PostgreSQL secret reference",
  "runops.postgresSecretRefAide": "Opaque reference resolved by the runner, for example project/db-password. Never enter the value here.",
  "runops.relSourceRef": "Branch or tag",
  "runops.relSourceRefHelp": "E.g. main, preprod or feature/my-feature.",
  "runops.requireGitlabPipeline": "Require a successful GitLab pipeline before promotion",
  "runops.saveEnvironment": "Save",
  "runops.sourceDir": "Repository directory",
  "runops.sourceDirAide": "Optional. Relative path allowed on the Docker runner.",
  "runops.sourceRefPattern": "Allowed branches/tags",
  "runops.sourceRefPatternAide": "Optional. E.g. main, preprod or feature/*.",
  "runops.technologies": "Selected technologies",
  "runops.technologiesAide": "E.g. fastapi,postgres,redis. The Compose file is generated if the repository does not provide one.",
  "scorecard.changeFailure": "Change failure rate",
  "scorecard.deployFrequency": "Deployments / 30 days",
  "scorecard.deploymentsTotal": "Total deployments",
  "scorecard.dora": "DORA",
  "scorecard.mttr": "Average MTTR",
  "sprints.addStory": "Add a story",
  "sprints.barreAria": "{{fait}} points done out of {{engage}} committed",
  "sprints.capaciteResume": "Declared capacity: {{n}} person-days",
  "sprints.chooseStory": "Choose a story to add…",
  "sprints.groupeActif": "Active",
  "sprints.groupeClos": "Closed",
  "sprints.groupePlanifies": "Planned",
  "sprints.noAvailableStory": "No story available",
  "sprints.ouvrir": "Open the sprint",
  "sprints.ouvrirAria": "Open sprint “{{nom}}”: content, capacity, burndown, review",
  "sprints.storyAdded": "Story added to the sprint",
  "tests.createDefect": "Create a bug",
  "tests.defectCreated": "Bug created from the test failure",
  "tests.generatedDefectDescription": "Failure observed in the test campaign.",
  "tests.generatedDefectTitle": "Defect detected by a test",
  "trace.openItem": "Open the item",
  "trace.openProof": "Explore the evidence",
  "trace.proof": "Evidence",
  "trace.proofTitle": "Evidence explorer",
  "tree.noSprint": "No sprint",
  "tree.sprintSelect": "Assign to sprint",
  "tree.sprintUpdated": "Sprint updated",
  "wi.priorityCritical": "Critical",
  "wi.priorityHigh": "High",
  "wi.priorityLow": "Low",
  "wi.priorityMedium": "Medium",
  "workflow.agentAccessError": "Unable to load agent authorizations.",
  "workflow.agentAccessHint": "A disabled row is refused for any new execution. Without a row, the catalog stays allowed.",
  "workflow.agentAccessTitle": "Agents allowed in this workspace",
  "workflow.agentAccessToggle": "allowed",
  "workflow.agentStatusEmpty": "No agent status observed",
  "workflow.agentStatusEmptyHint": "Launch an agent to track its status here.",
  "workflow.agentStatusHint": "Real-time tracking of Idle, Running or Error agents.",
  "workflow.agentStatusLoading": "Loading statuses…",
  "workflow.agentStatusTitle": "Agent status",
  "workflow.loadingAgentAccess": "Loading authorizations…",
  "workflow.model": "Model",
  "workflow.resumeAgent": "Resume",
  "workflow.resumeBudget": "Resumes",
  "workflow.resumeBudgetExhausted": "Relaunch limit reached (QUOTA_EXCEEDED)",
  "approvals.regenAriaLabel": "Regenerate with instructions",
  "approvals.consequencesAriaLabel": "Consequences",
  "approvals.generateOptionsAriaLabel": "Generating options",
  "approvals.generateBacklogAriaLabel": "Breaking down into backlog",
  "approvals.generateAppAriaLabel": "Generating the application",
  "pipelines.authorCannotRunHint": "You are the author of this pipeline: separation of duties requires another member to launch it.",
  "versions.noWorkspace": "Select a project",
  "versions.noWorkspaceHint": "A version always belongs to a workspace.",
  "versions.title": "Versions",
  "versions.description": "Prepare a version, know whether it is ready and why, approve it per environment, deploy it, deliver it and document it.",
  "versions.create": "Prepare a version",
  "versions.listTitle": "Project versions",
  "versions.loading": "Loading versions…",
  "versions.empty": "No version",
  "versions.emptyHint": "Prepare a version: its revisions, its delivered items and the campaigns that certify it.",
  "versions.ready": "ready",
  "versions.notReady": "not ready",
  "versions.detailTitle": "Version record",
  "versions.pick": "Pick a version from the list.",
  "versions.createForm": "New version",
  "versions.field.version": "Version",
  "versions.field.title": "Product name",
  "versions.field.titlePlaceholder": "Shop till",
  "versions.field.commit": "Commit",
  "versions.field.sourceRef": "Branch or tag",
  "versions.createSubmit": "Create as draft",
  "versions.cancel": "Cancel",
  "versions.summary": "Version preparation",
  "versions.summaryReady": "{{nom}}: ready",
  "versions.summaryNotReady": "{{nom}}: not ready",
  "versions.summaryMore": "(+{{n}} more)",
  "versions.summarySeeWhy": "See what blocks it",
  "versions.summaryTests": "Version tests",
  "versions.summaryDefects": "Open blocking defects",
  "versions.summaryMinor": "{{n}} minor",
  "versions.summaryApprovals": "Approvals per environment",
  "versions.loadingDetail": "Loading the version…",
  "versions.withdrawTitle": "Withdraw version {{version}}?",
  "versions.withdrawConsequence": "The version can no longer be deployed; pending approvals are withdrawn.",
  "versions.withdrawAudit": "The withdrawal, its author and its reason are recorded in the audit log.",
  "versions.withdrawReversibility": "A rollback to this version remains possible during an incident.",
  "versions.withdrawVerb": "Withdraw the version",
  "versions.withdrawReason": "Reason for withdrawal",
  "versions.transition.adopt": "Prepare this release as a version",
  "versions.transition.candidate": "Freeze the content (candidate)",
  "versions.transition.draft": "Reopen as draft",
  "versions.transition.released": "Declare delivered",
  "versions.transition.withdrawn": "Withdraw the version",
  "versions.headerSection": "Version status",
  "versions.twoPersonMode": "Two-person mode active (never for production)",
  "versions.withdrawnBecause": "Withdrawn: {{motif}}",
  "versions.openApp": "Open the delivered application ({{env}})",
  "versions.transitions": "Transitions",
  "versions.readinessSection": "Ready?",
  "versions.readinessTitle": "Ready?",
  "versions.readinessTarget": "For environment {{env}}{{prod}}",
  "versions.production": "production",
  "versions.removeContent": "Remove from content: {{objet}}",
  "versions.contentSection": "Content",
  "versions.contentTitle": "Content of {{version}}",
  "versions.contentFrozen": "Content frozen: reopen as draft to change it.",
  "versions.revisions": "Application revisions",
  "versions.none": "none",
  "versions.items": "Delivered items",
  "versions.defects": "Fixed defects",
  "versions.campaigns": "Campaigns certifying it",
  "versions.contentKind": "Add",
  "versions.kind.revision": "a revision",
  "versions.kind.item": "a delivered item",
  "versions.kind.defect": "a fixed defect",
  "versions.kind.campaign": "a certifying campaign",
  "versions.contentChoice": "Object",
  "versions.choose": "Choose…",
  "versions.add": "Add",
  "versions.envSection": "Environments",
  "versions.envTitle": "Approvals, deployment and rollback",
  "versions.noEnv": "No environment: create one in RunOps.",
  "versions.rejectTitle": "Reject version {{version}} for {{env}}?",
  "versions.withdrawApprovalTitle": "Withdraw the approval for {{env}}?",
  "versions.rejectConsequence": "The request is closed; a new request remains possible.",
  "versions.withdrawApprovalConsequence": "The version can no longer be deployed to this environment without a new approval.",
  "versions.rejectVerb": "Reject",
  "versions.withdrawApprovalVerb": "Withdraw the approval",
  "versions.reason": "Reason",
  "versions.deployTitle": "Deploy {{version}} to {{env}}?",
  "versions.deployConsequence": "A RunOps deployment is created (deploy_docker job) and tracked in the history.",
  "versions.deployAudit": "The request, its author and the approval allowing it are recorded in the audit log.",
  "versions.deployReversibility": "A rollback to the previous version remains available.",
  "versions.deployVerb": "Deploy",
  "versions.rollbackUnavailable": "No confirmable rollback plan for this deployment.",
  "versions.requestedBy": "requested by {{who}}",
  "versions.reviewedBy": "reviewed by {{who}}",
  "versions.decidedBy": "decided by {{who}}",
  "versions.twoPersonUsed": "two-person mode",
  "versions.lastDeployment": "deployment {{status}} by {{who}}",
  "versions.deploy": "Deploy to {{env}}",
  "versions.rollback": "Roll back to the previous version",
  "versions.action.request": "Request approval",
  "versions.action.review": "Review (two-person mode)",
  "versions.action.approve": "Approve",
  "versions.action.reject": "Reject",
  "versions.action.withdraw": "Withdraw the approval",
  "versions.twoPersonNotice": "You are approving your own request in two-person mode (outside production, reviewed by a third party): this is recorded in the audit log.",
  "versions.notesSection": "Release notes",
  "versions.notesTitle": "Release notes",
  "versions.notesState": "v{{n}} ({{origine}}, {{auteur}}) · published: {{publiee}}",
  "versions.notesGenerated": "written from the objects",
  "versions.notesEdited": "edited",
  "versions.notesUnpublished": "no",
  "versions.notesNone": "No notes yet: generate them from the objects.",
  "versions.notesBody": "Text (Markdown), reviewable and editable before publication",
  "versions.notesGenerate": "Generate from the objects",
  "versions.notesSave": "Save the edit (new version)",
  "versions.notesPublish": "Publish v{{n}}",
  "versions.notesHistory": "History ({{n}} versions kept)",
  "versions.docsSection": "Delivery documentation",
  "versions.docsTitle": "Delivery documentation",
  "versions.docsHint": "Generated from the objects, without a language model: same objects, same text.",
  "versions.docsGenerate": "Generate the documentation",
  "versions.docsDownload": "Download {{doc}} ({{format}})",
  "versions.doc.user_guide": "User guide",
  "versions.doc.operations_guide": "Operations guide",
  "versions.doc.release_notes": "Release notes",
  "versions.status.unmanaged": "outside the lifecycle (RunOps)",
  "versions.approval.none": "not requested",
  "nav./versions": "Versions",
  "navdesc./versions": "Prepare a version, know whether it is ready, approve it per environment and deliver it",
  "versions.status.draft": "draft",
  "versions.status.candidate": "candidate",
  "versions.status.approved": "approved",
  "versions.status.released": "delivered",
  "versions.status.withdrawn": "withdrawn",
  "versions.readiness.ok": "green",
  "versions.readiness.blocking": "blocking",
  "versions.readiness.warning": "warning",
  "versions.readiness.info": "information",
  "versions.approval.requested": "requested",
  "versions.approval.approved": "granted",
  "versions.approval.rejected": "rejected",
  "versions.approval.withdrawn": "withdrawn",
  "versions.architecture": "Architecture, SBOM and vulnerabilities of the version",
  "versions.key.status": "Status",
  "versions.key.revisions": "Revision checks",
  "versions.key.spec_gate": "Spec Gate",
  "versions.key.items": "Delivered items",
  "versions.key.campaigns": "Version tests",
  "versions.key.defects": "Defects",
  "versions.key.requirements": "Requirements",
  "versions.key.waivers": "Waivers in force",
  "versions.key.notes": "Release notes",
  "versions.key.approvals": "Approval",
  "versions.code.RELEASE_NOT_MANAGED": "Version outside the lifecycle: prepare it first",
  "versions.code.RELEASE_DRAFT": "In preparation: make the version a candidate to freeze its content",
  "versions.code.RELEASE_WITHDRAWN": "Version withdrawn",
  "versions.code.RELEASE_STATUS_OK": "Content frozen",
  "versions.code.REVISION_MISSING": "No revision of the generated application is attached",
  "versions.code.REVISION_NOT_AVAILABLE": "A revision is not finished or cannot be found",
  "versions.code.REVISION_CHECKS_FAILED": "Some revision checks are red",
  "versions.code.REVISION_CHECKS_MISSING": "A revision has no checks record",
  "versions.code.REVISION_CHECKS_GREEN": "Revision checks green",
  "versions.code.SPEC_GATE_SOURCE_MISSING": "No source specification attached to the content",
  "versions.code.SPEC_GATE_NOT_PASSED": "A source specification has no published, passed and fresh Spec Gate",
  "versions.code.SPEC_GATE_PASSED": "Spec Gate passed",
  "versions.code.ITEMS_NONE": "No backlog item in the content",
  "versions.code.ITEMS_NOT_DELIVERED": "Some items are not accepted or not delivered",
  "versions.code.ITEMS_DELIVERED": "Items accepted and delivered",
  "versions.code.CAMPAIGN_MISSING": "No test campaign certifies the version",
  "versions.code.CAMPAIGN_OPEN": "A campaign is still open",
  "versions.code.CAMPAIGN_NOT_GREEN": "A closed campaign is not green (red, blocked, skipped or not covered)",
  "versions.code.CAMPAIGN_GREEN": "Version tests green",
  "versions.code.DEFECTS_BLOCKING_OPEN": "Blocking or major defects are open",
  "versions.code.DEFECTS_FIX_UNVERIFIED": "Defects declared fixed are not verified",
  "versions.code.DEFECTS_NONE_BLOCKING": "No open blocking defect",
  "versions.code.REQUIREMENTS_CONFORMING": "No non-conforming requirement",
  "versions.code.REQUIREMENTS_NON_CONFORMING": "Some requirements are non-conforming (expired waiver)",
  "versions.code.REQUIREMENTS_NON_CONFORMING_OBSERVED": "Some requirements are non-conforming — project in observe mode",
  "versions.code.WAIVERS_NONE": "No waiver in force",
  "versions.code.WAIVERS_IN_FORCE": "Waivers are in force",
  "versions.code.NOTES_NOT_PUBLISHED": "Release notes not published (generate, review, publish)",
  "versions.code.NOTES_PUBLISHED": "Release notes reviewed and published",
  "versions.code.APPROVAL_TARGET_MISSING": "No target environment in this workspace",
  "versions.code.APPROVAL_GRANTED": "Approval granted for the target environment",
  "versions.code.APPROVAL_PENDING": "Approval requested, awaiting decision",
  "versions.code.APPROVAL_MISSING": "Approval missing for the target environment",
  "versions.code.ACCESS_DENIED": "Read only: owner or contributor role required",
  "versions.code.RELEASE_STATUS_INVALID": "The version status does not allow it",
  "versions.code.SELF_APPROVAL_REFUSED": "You requested this approval: another approver is required",
  "versions.code.TWO_PERSON_MODE_EXCLUDED_PRODUCTION": "Production keeps three people, even in two-person mode",
  "versions.code.TWO_PERSON_MODE_REVIEWER_REQUIRED": "Two-person mode first requires a review by a third party",
  "versions.code.TWO_PERSON_MODE_RISK_NOT_LOW": "Two-person mode only applies to low risks",
  "versions.code.REVIEWER_CANNOT_APPROVE_OWN_REVIEW": "You reviewed this request: another decision-maker is required",
  "versions.code.RELEASE_APPROVAL_STATE_INVALID": "This approval is no longer pending",
  "versions.code.RELEASE_APPROVAL_ALREADY_REVIEWED": "This request has already been reviewed",
  "versions.code.RELEASE_APPROVAL_REVIEWER_IS_REQUESTER": "You requested this approval: another reviewer is required",
  "versions.code.RELEASE_APPROVAL_NOTE_REQUIRED": "A rejection requires a reason",
  "versions.code.RELEASE_NOT_READY": "The version is not ready: see “Ready?”",
  "versions.code.RELEASE_NOT_APPROVED_FOR_ENVIRONMENT": "The version is not approved for this environment",
  "versions.code.DEPLOYER_CANNOT_BE_RELEASE_APPROVER": "SoD-02: the approver or creator of the version does not deploy it; a third party deploys",
  "versions.code.RELEASE_TRANSITION_FORBIDDEN": "Transition refused from this status",
  "versions.code.RELEASE_CONTENT_EMPTY": "Add at least one revision, item or defect",
  "versions.code.RELEASE_NOT_DEPLOYED": "No successful deployment on an approved environment",
  "versions.code.RELEASE_WITHDRAWAL_REASON_REQUIRED": "Withdrawal requires a reason",
  "versions.code.DEPLOYED_LINK_NO_URL": "Delivered to an environment without a URL",
  "versions.toastCreated": "Version created as draft",
  "versions.toastStatus": "Version status updated",
  "versions.toastApproval": "Approval recorded",
  "versions.toastDeploy": "Deployment started by RunOps",
  "versions.toastRollback": "Rollback started",
  "versions.toastNotes": "Release notes published",
  "versions.code.REVISION_REJECTED": "A revision was rejected at approval",
  "versions.code.SCM_PIPELINE_REQUIRED": "This environment requires proof of a successful GitLab pipeline",
  "apercu.annotate.becomes": "will become a defect",
  "apercu.annotate.cancel": "Cancel",
  "apercu.annotate.create": "Create the defect",
  "apercu.annotate.created": "Annotation saved:",
  "apercu.annotate.defectLink": "Defect ANO-{{id}}",
  "apercu.annotate.defectRef": "Defect {{ref}}",
  "apercu.annotate.dismiss": "Close",
  "apercu.annotate.element": "Element",
  "apercu.annotate.elementFree": "Selector (free text)",
  "apercu.annotate.elementNone": "None, or free text",
  "apercu.annotate.heading": "Annotation {{n}}",
  "apercu.annotate.listTitle": "Annotations on this preview",
  "apercu.annotate.noPin": "Click in the frame to pin the spot (optional).",
  "apercu.annotate.otherRoute": "Other route (free text)",
  "apercu.annotate.overlay": "Pin an annotation at this spot of the frame",
  "apercu.annotate.pinned": "Pin {{n}} placed at {{x}} % × {{y}} % of the frame",
  "apercu.annotate.route": "Route",
  "apercu.annotate.screen": "Screen",
  "apercu.annotate.severity": "Severity",
  "apercu.annotate.size": "Screen · size",
  "apercu.annotate.text": "What is wrong",
  "apercu.app": "Application",
  "apercu.capacity": "{{count}} live preview(s) out of {{cap}} in this project · proxy ports {{pool}}",
  "apercu.capture.alt": "Screenshot of {{screen}}, revision {{short}}, {{width}} px",
  "apercu.capture.loading": "Loading screenshot…",
  "apercu.capture.missing": "Screenshot unavailable",
  "apercu.compare.absent": "absent",
  "apercu.compare.added": "{{n}} new screens",
  "apercu.compare.added_one": "{{n}} new screen",
  "apercu.compare.added_other": "{{n}} new screens",
  "apercu.compare.captures": "Screenshots",
  "apercu.compare.changed": "{{n}} changed screens",
  "apercu.compare.changedWidths": "changed screenshots: {{widths}} px",
  "apercu.compare.changed_one": "{{n}} changed screen",
  "apercu.compare.changed_other": "{{n}} changed screens",
  "apercu.compare.gap": "Difference",
  "apercu.compare.heading": "Revision {{base}} ↔ revision {{head}}",
  "apercu.compare.hideCaptures": "Hide",
  "apercu.compare.identical": "{{n}} identical screens",
  "apercu.compare.identical_one": "{{n}} identical screen",
  "apercu.compare.identical_other": "{{n}} identical screens",
  "apercu.compare.loading": "Comparing the surveys…",
  "apercu.compare.noSurvey": "survey not produced yet",
  "apercu.compare.none": "This application has a single revision: nothing to compare.",
  "apercu.compare.notRunning": "Preview not started: the paired screenshots below stand in for it.",
  "apercu.compare.pick": "Pick another revision…",
  "apercu.compare.present": "present",
  "apercu.compare.removed": "{{n}} screens gone",
  "apercu.compare.removed_one": "{{n}} screen gone",
  "apercu.compare.removed_other": "{{n}} screens gone",
  "apercu.compare.rule": "A different screenshot says “has changed”, never “is correct”: the visual reference only changes with an approval.",
  "apercu.compare.screen": "Screen",
  "apercu.compare.showCaptures": "Screenshots",
  "apercu.compare.side": "Revision {{short}}",
  "apercu.compare.tableCaption": "Paired screens of both revisions",
  "apercu.compare.title": "Compare two revisions",
  "apercu.compare.with": "Compare with revision",
  "apercu.controls.failed": "checks {{passed}}/{{total}} — failing: {{names}}",
  "apercu.controls.passed": "checks {{passed}}/{{total}}",
  "apercu.controls.unknown": "checks not measured",
  "apercu.count.interactive": "{{n}} interactive elements",
  "apercu.count.interactive_one": "{{n}} interactive element",
  "apercu.count.interactive_other": "{{n}} interactive elements",
  "apercu.count.routes": "{{n}} routes",
  "apercu.count.routes_one": "{{n}} route",
  "apercu.count.routes_other": "{{n}} routes",
  "apercu.count.screens": "{{n}} screens",
  "apercu.count.screens_one": "{{n}} screen",
  "apercu.count.screens_other": "{{n}} screens",
  "apercu.description": "Launch a generated revision, view it at phone, tablet or desktop size, compare it and annotate it.",
  "apercu.diff.absent": "absent from both",
  "apercu.diff.added": "new",
  "apercu.diff.changed": "has changed",
  "apercu.diff.identical": "identical",
  "apercu.diff.removed": "gone",
  "apercu.empty": "No generated application",
  "apercu.emptyHint": "A revision is born from an application generation off an approved specification (Approvals screen).",
  "apercu.error.allLogs": "Logs of all services",
  "apercu.error.composeUp": "docker compose up output",
  "apercu.error.emptyLog": "(empty log)",
  "apercu.error.failedService": "Failed service: {{service}}",
  "apercu.error.lastLines": "Last lines of its log:",
  "apercu.error.otherServices": "Other services",
  "apercu.frame.emulated": "Emulated width: {{width}} px",
  "apercu.frame.loading": "Opening the preview…",
  "apercu.frame.refusedInvalid": "Preview not shown: the access address received from the gateway is invalid.",
  "apercu.frame.refusedSameHost": "Preview not shown: its host is the tool’s host. Configure a distinct preview host name (DOIT_PREVIEW_HOST).",
  "apercu.frame.reload": "Reload",
  "apercu.frame.scaled": "shown at {{pct}} %",
  "apercu.frame.titleRevision": "Preview of revision {{short}}",
  "apercu.identity.builtAt": "built on {{date}}",
  "apercu.identity.container": "container: {{status}}",
  "apercu.identity.expires": "expires on {{date}}",
  "apercu.identity.isolated": "isolated · no port published beyond 127.0.0.1",
  "apercu.identity.job": "job {{job}}",
  "apercu.identity.label": "Revision identity",
  "apercu.identity.model": "model {{model}}",
  "apercu.identity.revision": "revision {{short}}",
  "apercu.loading": "Loading revisions…",
  "apercu.mode.annotate": "Annotate",
  "apercu.mode.compare": "Compare two revisions",
  "apercu.noWorkspace": "Select a project",
  "apercu.noWorkspaceHint": "Previews belong to a workspace.",
  "apercu.notRunning": "No live preview for this revision.",
  "apercu.openTab": "Open in a tab",
  "apercu.openTabFallback": "The tab did not open? Use this link (valid until the token expires).",
  "apercu.openTabHint": "An application that keeps its session in a cookie is tested in a full tab",
  "apercu.revision": "Revision",
  "apercu.revisionRefused": "checks not passed",
  "apercu.selection": "Displayed revision",
  "apercu.start.refused": "Preview refused: {{reason}}",
  "apercu.start.refusedDefault": "This revision did not pass its checks.",
  "apercu.startAction": "Start the preview",
  "apercu.starting": "Starting: building the image, then starting the isolated container…",
  "apercu.status.failed": "failed",
  "apercu.status.requested": "requested",
  "apercu.status.running": "ready",
  "apercu.status.starting": "starting",
  "apercu.status.stopped": "stopped",
  "apercu.stop": "Stop",
  "apercu.stopRequested": "Stop requested: the container is stopping.",
  "apercu.title": "Application preview",
  "apercu.viewport.desktop": "Desktop",
  "apercu.viewport.label": "Emulated screen size",
  "apercu.viewport.phone": "Phone",
  "apercu.viewport.tablet": "Tablet",
  "apercu.writeActions": "Start, stop or annotate a preview",
  "nav./apercu": "Previews",
  "nav./architecture": "Architecture",
  "navdesc./apercu": "View, compare and annotate a revision of the application",
  "navdesc./architecture": "Components, API, dependencies (SBOM) and vulnerabilities of the delivered application, per version",
  "apercu.annotate.loadingSurvey": "Loading the revision survey…",
  "nav./tableau-de-bord": "Overview",
  "navdesc./tableau-de-bord": "Health spread, quality, delivery and attention of the organisation's projects",
  "nav./projet?vue=processus": "Cycle and process",
  "navdesc./projet?vue=processus": "Project process runs: gates, approvals and resumptions",
  "grp.Accueil": "Home",
  "grp.Boîte d’attention": "Attention inbox",
  "grp.Demandes": "Requests",
  "grp.Produit": "Product",
  "grp.Missions": "Missions",
  "grp.Application": "Application",
  "grp.Organisation": "Organisation",
  "nav.attentionCount": "{{n}} decision(s) waiting",
  "nav.sectionUnread": "{{n}} unread notification(s)",
  "nav.sectionToggle": "Screens in the {{section}} section",
  "demande.niveau.prefixe": "Approval · level",
  "demande.ligne.action": "Action",
  "demande.ligne.cible": "Target",
  "demande.ligne.contenu": "Content",
  "demande.ligne.raison": "Reason",
  "demande.ligne.impact": "Impact",
  "demande.ligne.retour": "Way back",
  "demande.sod.deuxPersonnes": "Two-person mode: you requested this low-risk object, reviewed by {{r}} — you may decide it; the decision will carry the “two-person mode” mention.",
  "demande.sod.libre": "Separation of duties: you neither requested nor reviewed this object — you may approve it.",
  "demande.deuxPersonnesActif": "Two-person mode is active in this project (low risk only).",
  "demande.approuverPorte": "Approve (gate)",
  "demande.preuves": "Evidence",
  "demande.gate.ok": "passed",
  "demande.gate.ko": "failed",
  "demande.gate.absent": "not evaluated",
  "demande.gate.controles": "{{n}} check(s) passed",
  "demande.gate.echecs": "failing: {{c}}",
  "demande.revueIndependante": "Independent review",
  "demande.revueAbsente": "not reviewed yet",
  "demande.avisJuge": "Judge’s opinion",
  "demande.avis": "OPINION",
  "demande.score": "score {{s}}",
  "demande.provenance": "Provenance",
  "demande.detail": "Content detail",
  "lectureSpec.aucuneExigence": "No numbered requirement was found: the full text is in the technical register.",
  "lectureSpec.detailTechnique": "Technical detail",
  "lectureSpec.registreMetier": "Business register: the technical header ({{carte}}, model, paths) is hidden; “Technical details” shows it.",
  "demande.objet.spec": "the specification{{nom}}{{v}}",
  "demande.objet.cadrage": "the framing{{nom}}{{v}}",
  "demande.objet.autre": "the artefact “{{nom}}”{{v}}",
  "demande.contenu.diff": " · +{{a}} −{{r}} lines since v{{p}}",
  "demande.contenu.exigences": "{{n}} requirement(s) · {{l}} lines",
  "demande.contenu.lignes": "{{l}} lines",
  "demande.gate.reussi": "{{g}}: passed{{s}}",
  "demande.gate.echoue": "{{g}}: failed",
  "demande.revue": "reviewed by {{r}} ({{v}})",
  "demande.demandeePar": "Requested by {{u}}",
  "demande.impact.specMetier": "It becomes the basis for building the application and the backlog",
  "demande.impact.spec": "Basis of the scaffold_app job and of backlog generation",
  "demande.impact.cadrage": "The specification can be generated from this framing",
  "demande.impact.autre": "The artefact is published in the project",
  "demande.retour.spec": "A new version of the specification replaces it; what was built stays traced",
  "demande.retour.autre": "A new version can replace it; the decision stays in the log",
  "demande.titre": "Approve {{objet}}",
  "demande.action.spec": "Freeze {{objet}}",
  "demande.action.autre": "Approve {{objet}}",
  "profil.vueLabel": "View",
  "profil.suggeree": "View suggested from your role: choose your own.",
  "profil.roleAcces": "Access role: {{role}}",
  "accueil.synthese": "Project summary",
  "accueil.vueDe": "Home · {{vue}} view{{projet}}",
  "accueil.vueSuggeree": "View suggested from your access role ({{role}}): choose your own under “View”, at the bottom of the navigation. Changing the view changes no permission.",
  "accueil.profilsExerces": "The profiles I work in",
  "accueil.profilsExercesAide": "The combined view shows the first block of each; with none chosen, all five.",
  "demande.resumeAria": "Request summary",
  "demande.allerDecision": "Go to the decision",
  "demande.preuvesEtDetail": "Evidence and detail",
  "attention.defectSubtitle": "resolved by {{w}} · severity {{s}} · the reproduction must turn green again",
  "attention.waiverSubtitle": "requested by {{w}} · to review then decide",
  "attention.waiverExpiredSubtitle": "expired: the requirement is non-compliant again · owner {{w}}",
  "attention.detail.defectWhy": "Fix delivered: rerun the reproduction; whoever resolved it cannot verify it.",
  "attention.openDefect": "Verify the defect",
  "attention.openWaivers": "Open the waivers",
  "attention.kind.defect_to_verify": "Defect to verify",
  "attention.kind.waiver_to_decide": "Waiver to decide",
  "attention.kind.waiver_expired": "Expired waiver",
  "accueil.dev.aRevoir": "To review",
  "accueil.dev.aRevoirAide": "Generated artefacts awaiting review, and the latest revisions with their checks.",
  "accueil.dev.rienARevoir": "Nothing to review right now.",
  "accueil.dev.gateReussi": "passed",
  "accueil.dev.gateEchoue": "failed",
  "accueil.dev.gateAbsent": "not evaluated",
  "accueil.dev.revoir": "Review",
  "accueil.dev.controles": "checks {{p}}/{{n}}",
  "accueil.dev.montrable": "showable",
  "accueil.dev.aCorriger": "to fix",
  "accueil.dev.ouvrir": "Open",
  "accueil.dev.arretees": "Tasks where the colony stopped",
  "accueil.dev.aucuneArretee": "No stopped task: the colony is waiting for nobody.",
  "accueil.dev.motif": "Reason:",
  "accueil.dev.prendreLaMain": "Take over",
  "accueil.dev.echecs": "Failed jobs",
  "accueil.dev.aucunEchec": "No failed job.",
  "accueil.metier.livreeLe": "delivered on {{d}}",
  "accueil.metier.aVoir": "version {{r}} to review · built on {{d}}",
  "accueil.metier.constructionRefusee": "the latest build cannot be shown: {{m}}",
  "accueil.metier.enConstruction": "being built since {{d}}",
  "accueil.metier.aApprouver": "to approve · requested on {{d}}",
  "accueil.metier.approuvee": "approved on {{d}}",
  "accueil.metier.ideeDeposee": "idea submitted on {{d}}",
  "accueil.metier.etapesAria": "Stage: {{e}}",
  "accueil.metier.aDecider": "What awaits my decision",
  "accueil.metier.rienADecider": "Nothing awaits your decision right now.",
  "accueil.metier.mesDemandesAide": "Each request at its stage, from the idea to delivery.",
  "accueil.metier.aucuneDemande": "No request yet",
  "accueil.metier.aucuneDemandeAide": "Submit an idea: it will show here at every stage, up to the delivered application.",
  "accueil.metier.derniereVersion": "The latest version of the application",
  "accueil.metier.versionConstruite": "{{v}} {{r}} · {{c}} of {{n}} checks passed",
  "accueil.metier.voir": "View",
  "accueil.metier.aucuneVersion": "No showable version yet: it will appear as soon as its build passes its checks.",
  "accueil.po.sprint": "Current sprint",
  "accueil.po.ouvrirSprints": "Open the sprints",
  "accueil.po.aucunSprint": "No active or planned sprint: plan one from the project.",
  "accueil.po.vraimentFini": "Really done?",
  "accueil.po.vraimentFiniAide": "A requirement is only done when tests cover it and no defect remains open.",
  "accueil.po.aucuneExigence": "No traced requirement in this project.",
  "accueil.po.nonCouverte": "not covered",
  "accueil.po.anomaliesOuvertes": "{{n}} defect(s) still open in the project: a requirement they touch is not done",
  "accueil.po.decisions": "Decisions to make",
  "accueil.po.aucuneDecision": "No architecture decision or waiver pending.",
  "accueil.po.decider": "Decide",
  "accueil.po.derogation": "Waiver · {{c}} — risk {{r}}",
  "accueil.po.examiner": "Examine",
  "accueil.release.prete": "ready",
  "accueil.release.pasPrete": "not ready: {{n}} blocking reason(s)",
  "accueil.release.approbationsDetail": "{{a}} of {{n}} environment(s) approved",
  "accueil.release.deployeSur": "deployed on {{e}}",
  "accueil.release.deployable": "deployable",
  "accueil.release.nonDeployable": "no environment accepts it yet (reasons in the release page)",
  "accueil.release.livraisonDetail": "link {{l}} · {{n}} document(s) · notes {{p}}",
  "accueil.release.lienPublie": "published",
  "accueil.release.lienAbsent": "missing",
  "accueil.release.notesPubliees": "published",
  "accueil.release.notesNonPubliees": "not published",
  "accueil.release.preparation": "Release preparation",
  "accueil.release.ouvrirVersion": "Open the release",
  "accueil.release.aucuneVersion": "No release prepared: start by preparing one.",
  "accueil.release.parcours": "Delivery journey",
  "accueil.release.parcoursAide": "Each step opens its section of the release page.",
  "accueil.release.parcoursVide": "The journey appears as soon as a release is prepared.",
  "accueil.release.fait": "done",
  "accueil.release.bloque": "blocked",
  "accueil.release.aFaire": "to do",
  "accueil.release.ouvrir": "Open",
  "accueil.release.livre": "What was delivered, to whom, with which evidence",
  "accueil.release.rienLivre": "No release delivered yet.",
  "accueil.release.preuves": "Evidence",
  "accueil.testeur.campagne": "Campaign “{{n}}”",
  "accueil.testeur.campagneEnCours": "Current campaign",
  "accueil.testeur.campagneAide": "{{n}} cases · {{e}} · verdict of the latest run per case",
  "accueil.testeur.executer": "Run the campaign",
  "accueil.testeur.verts": "green",
  "accueil.testeur.rouges": "red or blocked",
  "accueil.testeur.nonExecutes": "not run",
  "accueil.testeur.aucuneCampagne": "No open campaign: open one from the Tests screen.",
  "accueil.testeur.executionsRouges": "Red runs",
  "accueil.testeur.aucuneRouge": "No red run in the current campaign.",
  "accueil.testeur.voirAnomalie": "See defect ANO-{{n}}",
  "accueil.testeur.declarer": "Report a defect",
  "accueil.testeur.aVerifier": "Resolved, to verify",
  "accueil.testeur.rienAVerifier": "No resolved defect awaits verification.",
  "accueil.testeur.verifier": "Verify",
  "accueil.testeur.sansTest": "Requirements without a test",
  "accueil.testeur.toutesTestees": "Every traced requirement has at least one test.",
  "accueil.testeur.traceabilite": "See traceability",
  "accueil.colonie.titreMetier": "What the automated team is doing right now",
  "accueil.colonie.titre": "Colony missions in progress",
  "accueil.colonie.aucuneMetier": "No automated work in progress.",
  "accueil.colonie.aucune": "No colony mission in progress.",
  "accueil.colonie.progression": "{{f}} of {{n}} task(s) done",
  "accueil.colonie.budget": "GPU minutes: {{c}} / {{b}} · escalations: {{e}} / {{me}}",
  "accueil.colonie.decisions": "{{n}} decision(s) await you",
  "accueil.colonie.rienDemande": "Nothing is asked of you right now.",
  "attention.kind.mission_task_stopped.metier": "Automated team stopped",
  "attention.kind.defect_to_verify.metier": "Fixed problem to check",
  "attention.kind.waiver_to_decide.metier": "Requested exception to decide",
  "attention.kind.waiver_expired.metier": "Expired exception",
  "profil.metier": "Business",
  "profil.po": "Product owner",
  "profil.dev": "Developer",
  "profil.testeur": "Tester",
  "profil.release": "Release manager",
  "profil.combinee": "Combined view",
  "profil.role.owner": "owner",
  "profil.role.contributor": "contributor",
  "profil.role.viewer": "viewer",
  "accueil.titre.metier": "The project’s requests and what awaits my decision",
  "accueil.titre.po": "The current sprint, the colony missions and what is really done",
  "accueil.titre.dev": "What the colony produced to review, and the tasks where it stopped",
  "accueil.titre.testeur": "The current campaign, the defects to verify and the requirements without a test",
  "accueil.titre.release": "Is the release ready? What was delivered, to whom, with which evidence",
  "accueil.titre.combinee": "The blocks of each of your profiles, on a single page",
  "accueil.metier.etape.idee": "idea",
  "accueil.metier.etape.cadree": "framed",
  "accueil.metier.etape.specifiee": "specified",
  "accueil.metier.etape.construction": "being built",
  "accueil.metier.etape.a_voir": "to review",
  "accueil.metier.etape.livree": "delivered",
  "accueil.po.etat.todo": "to do",
  "accueil.po.etat.in_progress": "in progress",
  "accueil.po.etat.in_review": "in review",
  "accueil.po.etat.done": "done",
  "accueil.release.etape.version": "Ready?",
  "accueil.release.etape.approbations": "Approvals per environment",
  "accueil.release.etape.deploiement": "Deployment",
  "accueil.release.etape.livraison": "Link and documentation",
  "demande.niveau.reversible": "reversible on your own",
  "demande.niveau.reversible_aide": "reversible with help",
  "demande.niveau.irreversible": "irreversible — gate",
  "deuxPersonnes.refus.SELF_APPROVAL_REFUSED": "You requested this object and two-person mode is not active in this project: another member must approve it.",
  "deuxPersonnes.refus.TWO_PERSON_MODE_EXCLUDED_PRODUCTION": "Promotion to production: three distinct people are still required, even in two-person mode.",
  "deuxPersonnes.refus.TWO_PERSON_MODE_EXCLUDED_SECURITY": "Security object: three distinct people are still required, even in two-person mode.",
  "deuxPersonnes.refus.TWO_PERSON_MODE_EXCLUDED_WAIVER": "Waiver: three distinct people are still required, even in two-person mode.",
  "deuxPersonnes.refus.TWO_PERSON_MODE_EXCLUDED_ONE_WAY_DECISION": "One-way decision: three distinct people are still required, even in two-person mode.",
  "deuxPersonnes.refus.TWO_PERSON_MODE_RISK_NOT_LOW": "Two-person mode only applies to low risk: this object is rated higher.",
  "deuxPersonnes.refus.TWO_PERSON_MODE_REVIEWER_REQUIRED": "Two-person mode first requires a review by another member: have this object reviewed.",
  "registre.scaffold_app.technique": "scaffold_app job",
  "registre.scaffold_app.metier": "application build",
  "registre.revision.technique": "revision",
  "registre.revision.metier": "application version",
  "registre.prompt_card.technique": "prompt card",
  "registre.prompt_card.metier": "work template",
  "registre.spec_gate.technique": "Spec Gate",
  "registre.spec_gate.metier": "specification check",
  "registre.anomalie.technique": "defect",
  "registre.anomalie.metier": "reported problem",
  "registre.mission.technique": "mission",
  "registre.mission.metier": "automated work",
  "registre.caste.technique": "caste",
  "registre.caste.metier": "automated team",
  "registre.colonie.technique": "colony",
  "registre.colonie.metier": "automated team",
  "registre.promotion.technique": "promotion",
  "registre.promotion.metier": "release to users",
  "registre.job.technique": "job",
  "registre.job.metier": "processing",
  "registre.plan_mission.technique": "mission plan",
  "registre.plan_mission.metier": "automated work plan",
  "registre.derogation.technique": "waiver",
  "registre.derogation.metier": "granted exception",
  "registre.exigence.technique": "requirement",
  "registre.exigence.metier": "rule to follow",
  "registre.deploiement.technique": "deployment",
  "registre.deploiement.metier": "go-live",
  "lectureSpec.affichage": "Display",
  "lectureSpec.registre.metier": "Business register",
  "lectureSpec.registre.technique": "Technical register",
  "demande.risqueAuCentre": "Decide it in the Approval center, which holds these fields.",
  "risque.releve": "Risk category raised",
  "risque.faible": "low",
  "risque.moyen": "medium",
  "risque.eleve": "high",
  "risque.actuel": "Risk category: {{c}}",
  "risque.maximum": "Already at the highest level: nothing to raise.",
  "risque.releverForm": "Raise the risk category",
  "risque.releverA": "Raise to",
  "risque.choisir": "Choose…",
  "risque.relever": "Raise",
  "risque.aide": "It can be raised, never lowered; above “low”, three distinct people are required again.",
  "profil.revenirSuggestion": "Back to the suggested view",
  "profil.erreurConcurrente": "Your view was changed elsewhere in the meantime: the saved value is shown, choose again.",
  "accueil.metier.rienADeciderLecteur": "Your access role makes no decision in this project: you follow the requests below.",
  "accueil.metier.demandesProjet": "The project’s requests",
  "profil.role.admin": "platform administrator",
  "profil.roleOrganisation": "Role in the organisation: {{role}}",
  "design.charter.colorPicker": "Pick the colour from the colour picker",
  "design.charter.createdBy": "by {{author}} on {{date}}",
  "design.charter.customLabel": "Colour (#rrggbb)",
  "design.charter.density": "Density",
  "design.charter.designMd": "DESIGN.md: layout, components, label voice",
  "design.charter.hexInvalid": "Enter a colour in #rrggbb format (for example #0a5f63).",
  "design.charter.hexRequired": "Enter the main colour in #rrggbb format (for example #0a5f63).",
  "design.charter.hideJson": "Hide the token JSON",
  "design.charter.history": "Version history",
  "design.charter.historyEmpty": "No version saved for this project.",
  "design.charter.json": "JSON",
  "design.charter.jsonLabel": "Token JSON",
  "design.charter.jsonOf": "W3C DTCG tokens of version v{{version}} · digest {{sha}}",
  "design.charter.loading": "Loading the charter…",
  "design.charter.loadingJson": "Loading the tokens…",
  "design.charter.logo": "Logo (text)",
  "design.charter.logoCount": "{{count}} / {{max}} characters",
  "design.charter.logoStyle": "Logo display",
  "design.charter.noneValidated": "No validated version: generation applies the default charter.",
  "design.charter.originOrganisation": "inherited from the organisation",
  "design.charter.originProject": "specific to the project",
  "design.charter.primary": "Main colour",
  "design.charter.save": "Save the version",
  "design.charter.saved": "Version v{{version}} saved as a draft: another person in the workspace must validate it.",
  "design.charter.showJson": "View the token JSON",
  "design.charter.showJsonOf": "View the token JSON of version v{{version}}",
  "design.charter.title": "Charter, without jargon",
  "design.charter.typography": "Typography",
  "design.charter.validate": "Validate this version",
  "design.charter.validatedBy": "validated by {{who}} on {{date}}",
  "design.charter.validatedInfo": "Validated version: v{{version}} ({{semver}}). Only a validated version goes to generation.",
  "design.charter.voice": "Label voice",
  "design.conformance.axe": "axe AA",
  "design.conformance.axeCount": "{{count}} violation(s)",
  "design.conformance.axeUnavailable": "axe did not run on this revision",
  "design.conformance.axeVersion": "axe-core {{version}}",
  "design.conformance.charterDefault": "Charter applied: default charter (no validated version at generation time).",
  "design.conformance.charterUnknown": "Charter applied: unknown.",
  "design.conformance.charterValidated": "Charter applied: validated version v{{version}} ({{semver}}).",
  "design.conformance.colorOn": "{{value}} on “{{screen}}” ({{count}} element(s))",
  "design.conformance.colors": "Colours outside tokens",
  "design.conformance.colorsMeasured": "Colours measured on the values computed by the browser:",
  "design.conformance.colorsNoDetail": "{{count}} colour(s) outside tokens, with no per-element detail in the survey.",
  "design.conformance.colorsNone": "No colour outside tokens in the values computed by the browser.",
  "design.conformance.colorsPartial": "Partial colour check on {{screens}}: the page exceeds the cap of examined elements, the rest is not measured.",
  "design.conformance.digestMismatch": "different digest",
  "design.conformance.exampleScreen": "“{{screen}}” ({{property}})",
  "design.conformance.examples": "Examples of violations",
  "design.conformance.floor": "Automation is a floor, not proof of conformance: the rest needs a human review.",
  "design.conformance.flowScreens": "Flow screens",
  "design.conformance.loading": "Loading conformance…",
  "design.conformance.loadingRevisions": "Loading revisions…",
  "design.conformance.missing": "Flow screens missing from the application ({{count}}):",
  "design.conformance.noFlow": "no validated flow to compare with",
  "design.conformance.noRevision": "No generated revision",
  "design.conformance.noRevisionHint": "Conformance is measured on a running application: generate the application from an approved specification, then start its preview.",
  "design.conformance.noSurvey": "no survey",
  "design.conformance.notMeasured": "not measured",
  "design.conformance.outside": "Screens outside the flow",
  "design.conformance.outsideList": "Screens outside the flow: {{routes}}",
  "design.conformance.perScreen": "Detail per screen ({{count}})",
  "design.conformance.revision": "Revision",
  "design.conformance.screenAxe": "axe: {{count}} violation(s)",
  "design.conformance.screenAxeNot": "axe not measured ({{reason}})",
  "design.conformance.screenColors": "{{count}} colour(s) outside tokens",
  "design.conformance.screenColorsNot": "colours not measured ({{reason}})",
  "design.conformance.screenColorsPartial": "(partial check: {{checked}} elements)",
  "design.conformance.title": "Interface conformance — revision {{short}} (running application)",
  "design.conformance.titleNone": "Interface conformance (running application)",
  "design.conformance.tokensMismatch": "tokens.css stylesheet served (HTTP {{status}}), but it is NOT the stylesheet of this revision: {{reason}}.",
  "design.conformance.tokensNotServed": "tokens.css stylesheet NOT served (HTTP {{status}}): {{reason}}. Colours of a page that did not load its tokens are not measured.",
  "design.conformance.tokensOk": "tokens.css stylesheet served (HTTP {{status}}): it is indeed the stylesheet of this revision.",
  "design.conformance.tokensUnknown": "tokens.css stylesheet: not checked for this revision.",
  "design.conformance.unavailable": "No conformance survey for this revision yet: it is produced once its preview has run.",
  "design.contrast.failedPair": "{{label}}: {{ratio}} (minimum {{minimum}})",
  "design.contrast.insufficient": "insufficient contrast",
  "design.contrast.notComputed": "contrast not computed: colour to complete",
  "design.contrast.ok": "contrast {{ratio}} — AA compliant",
  "design.contrast.scope": "{{count}} pairs checked on every choice: text, links, buttons, focus, field borders, messages (WCAG 2.2 AA).",
  "design.density.aeree": "Airy",
  "design.density.compacte": "Compact",
  "design.density.standard": "Standard",
  "design.description": "The screen flow, wireframes and charter of the generated application, then its conformance once running. Only validated versions go to generation.",
  "design.flow.byCaste": "the designer caste",
  "design.flow.caption": "Each screen carries the requirements it serves. A screen without a requirement is flagged.",
  "design.flow.chooseSpec": "Choose an approved specification.",
  "design.flow.empty": "No flow for this project",
  "design.flow.emptyHint": "Propose one from an approved specification: the designer caste derives the screens and the requirements they serve.",
  "design.flow.jobFailed": "failed",
  "design.flow.jobRunning": "running",
  "design.flow.jobs": "Designer caste proposals",
  "design.flow.loading": "Loading flows…",
  "design.flow.loadingDetail": "Loading the flow…",
  "design.flow.loadingSpecs": "Loading approved specifications…",
  "design.flow.meta": "v{{version}} · {{screens}} screens · {{transitions}} transitions · by {{author}} on {{date}}",
  "design.flow.model": "model {{model}}",
  "design.flow.noRequirement": "no requirement",
  "design.flow.noSpec": "No approved specification: approve one in the Approvals screen, then come back to propose the flow.",
  "design.flow.propose": "Propose the flow",
  "design.flow.proposeAction": "Propose the flow",
  "design.flow.proposed": "Proposal started (job {{job}}): the flow will appear here once the designer caste has finished.",
  "design.flow.screensWithout": "Screens serving no requirement: {{names}}",
  "design.flow.spec": "Approved specification",
  "design.flow.title": "Screen flow",
  "design.flow.traced": "every requirement has its screen, every screen its requirement",
  "design.flow.unserved": "Requirements served by no screen ({{count}}):",
  "design.flow.validate": "Validate the flow",
  "design.flow.version": "Displayed version",
  "design.flow.versionOption": "v{{version}} · {{status}} · {{count}} screens",
  "design.logo.style.aucun": "None",
  "design.logo.style.initiales": "Initials",
  "design.logo.style.nom": "Name",
  "design.noWorkspace": "Select a project",
  "design.noWorkspaceHint": "The charter, the flow and the wireframes belong to a workspace.",
  "design.pair.control-border-on-background": "field borders on card backgrounds",
  "design.pair.control-border-on-canvas": "field borders on the page background",
  "design.pair.danger-on-background": "error message on card backgrounds",
  "design.pair.focus-on-canvas": "focus ring on the page background",
  "design.pair.link-on-background": "links on card backgrounds",
  "design.pair.link-on-canvas": "links on the page background",
  "design.pair.muted-on-background": "secondary text on card backgrounds",
  "design.pair.muted-on-canvas": "secondary text on the page background",
  "design.pair.on-primary": "button text on the main colour",
  "design.pair.on-primary-strong": "text of hovered buttons",
  "design.pair.success-on-background": "success message on card backgrounds",
  "design.pair.text-on-background": "text on card backgrounds",
  "design.pair.text-on-canvas": "text on the page background",
  "design.pair.warning-on-background": "warning message on card backgrounds",
  "design.palette.custom": "Other colour",
  "design.palette.label": "{{name}} palette",
  "design.palette.name.bleu-nuit": "midnight blue",
  "design.palette.name.brique": "brick",
  "design.palette.name.olive": "olive",
  "design.palette.name.personnalisee": "other colour",
  "design.palette.name.sarcelle": "teal",
  "design.status.draft": "draft",
  "design.status.supersededF": "superseded",
  "design.status.supersededM": "superseded",
  "design.status.validatedF": "validated",
  "design.status.validatedM": "validated",
  "design.title": "Interface design",
  "design.typography.chaleureuse": "Warm",
  "design.typography.sobre": "Plain",
  "design.typography.technique": "Technical",
  "design.validate.selfRefused": "You are its author: the author of a version never validates it themselves. Another person in the workspace (contributor or owner) must validate it.",
  "design.voice.tutoiement": "Informal (tu)",
  "design.voice.vouvoiement": "Formal (vous)",
  "design.wireframe.annotations": "Annotations of the “{{name}}” wireframe",
  "design.wireframe.byCaste": "designer caste",
  "design.wireframe.byHuman": "human input",
  "design.wireframe.caption": "Deliberately plain: polish steers feedback towards the superficial.",
  "design.wireframe.drafts": "{{count}} draft(s)",
  "design.wireframe.empty": "No wireframe for this flow",
  "design.wireframe.emptyHint": "The designer caste produces one wireframe per screen along with the flow.",
  "design.wireframe.frameTitle": "“{{name}}” wireframe",
  "design.wireframe.invalidUrl": "Wireframe not displayed: the render address received from the gateway is invalid.",
  "design.wireframe.isolation": "Each wireframe is displayed with no script and no access to the tool: it is model output.",
  "design.wireframe.loading": "Opening the wireframe…",
  "design.wireframe.loadingList": "Loading wireframes…",
  "design.wireframe.noFlow": "No wireframe",
  "design.wireframe.noFlowHint": "Wireframes come with a screen flow: propose the flow first.",
  "design.wireframe.title": "Low-fidelity wireframes",
  "design.writeActions": "Edit the design",
  "nav./design": "Design",
  "navdesc./design": "Screen flows, wireframes and style guide, then the conformance of a revision",
  "design.wireframe.meta": "v{{version}} · {{author}}",
  "design.you": "you",
  "design.wireframe.validateShort": "Validate",
  "design.wireframe.validateNamed": "Validate the “{{name}}” wireframe",
  "missions.col.criteria": "Criteria covered",
  "missions.plan.noCriteria": "none (skeleton)",
  "missions.decision.approveDossier": "Approve the evidence file and merge",
  "missions.decision.rejectDossier": "Reject the evidence file",
  "missions.decision.errRejectDossier": "Rejecting the evidence file requires a reason.",
  "missions.decision.dossierSod": "You launched this mission: another member must approve its evidence file (separation of duties).",
  "missions.decision.dossierRef": "Evidence file: {{ref}} · fingerprint {{sha}}",
  "missions.decision.dossierReason": "Reason (to reject the evidence file)",
  "missions.decision.dossierTitle": "Mission evidence file to approve",
  "missions.reason.tests_refused": "test suite refused twice",
  "missions.reason.task_not_converged": "task stopped without converging",
  "missions.reason.dossier_approval": "mission evidence file to approve",
  "missions.reason.control_inconsistent": "inconsistent check (defect on the check)",
  "missions.form.modeUnavailable": "not available in this version",
  "missions.decision.dossierView": "Evidence file and consolidated diff, to review before deciding",
  "missions.decision.dossierNoView": "The evidence file is not served: it cannot be approved blind.",
  "missions.suspension.executor": "application executor unavailable (Docker daemon, Docker command or revision that does not start)",
  "missions.reason.executor_unavailable": "application executor repeatedly unavailable",
  "nav./technologies": "Choices and baseline",
  "navdesc./technologies": "Project technology baseline, inheritance by category and generation profile",
  "nav./technologies/changements": "Change requests",
  "navdesc./technologies/changements": "Change a technology value: change request or propagation",
  "nav./exigences": "Inherited requirements",
  "navdesc./exigences": "Framework inheritance, strengthening, presence check and project waivers",
  "nav./projet?vue=tableau": "Backlog",
  "navdesc./projet?vue=tableau": "Project items: board, list, hierarchy, graph and ready for the colony",
  "nav./projet?vue=sprints": "Sprints",
  "navdesc./projet?vue=sprints": "Sprints, planner and burndown",
  "nav./projet?vue=roadmap": "Roadmap",
  "navdesc./projet?vue=roadmap": "Dated epics and features, releases as milestones, sprints",
  "nav./supervision": "Agent supervision",
  "navdesc./supervision": "What is running in the project: missions, castes at work, agents; estimated and consumed cost labelled separately",
  "nav./recette": "Business acceptance",
  "navdesc./recette": "Acceptance of a version by the business: accept or refuse, remarks become defects",
  "nav./qualite": "Quality dashboard",
  "navdesc./qualite": "Escape, reopen, time to fix",
  "nav./publication": "Code publication",
  "navdesc./publication": "GitLab repository per revision, precondition, linked environments",
  "nav./exploitation": "Application in service",
  "navdesc./exploitation": "Version in production, probe and documentation",
  "nav./programme": "Programme view",
  "navdesc./programme": "Goal, milestone, health spread, project stages, train and blocking dependencies",
  "nav./programme/membres": "Programme members",
  "navdesc./programme/membres": "List, add, remove members and their roles",
  "nav./programme/projets": "Programme projects",
  "navdesc./programme/projets": "Attach, detach; stage, stack and health of the projects",
  "nav./programme/roadmap": "Roadmap and train",
  "navdesc./programme/roadmap": "Sprints, milestones and versions of the programme",
  "nav./programme/backlog": "Backlog and initiatives",
  "navdesc./programme/backlog": "Framing or epic generation and trace of launched initiatives",
  "nav./programme/dependances": "Cross-project dependencies",
  "navdesc./programme/dependances": "Map of dependencies between the programme projects",
  "nav./programme/gouvernance": "Governance and standards",
  "navdesc./programme/gouvernance": "Programme framework, which strengthens the organisation one",
  "nav./programme/technologies": "Programme technology choices",
  "navdesc./programme/technologies": "Catalogue inheritance, programme standard and baseline",
  "nav./programme/technologies?vue=changements": "Programme change requests",
  "navdesc./programme/technologies?vue=changements": "Portfolio of change requests of the programme projects",
  "nav./programme/versions": "Programme versions",
  "navdesc./programme/versions": "The version train, aggregated read-only",
  "nav./programme/capacite": "Cost and capacity",
  "navdesc./programme/capacite": "GPU minutes consumed and estimated, missions in progress per project",
  "nav./programme/reglages": "Programme settings",
  "navdesc./programme/reglages": "Name, owner, status, default template",
  "nav./org/projets": "Projects",
  "navdesc./org/projets": "Organisation projects: programme, health, stack; create, attach, archive",
  "nav./org/technologies": "Technology catalogue",
  "navdesc./org/technologies": "The organisation's dynamic technology choices: catalogue, categories, radar",
  "nav./org/derogations": "Waivers",
  "navdesc./org/derogations": "All organisation waivers: by project, risk, due date and state",
  "nav./org/gouvernance": "Governance and approvals",
  "navdesc./org/gouvernance": "Approval modes and AI emergency stop at organisation scope",
  "nav./org/harnais": "Harness and agents",
  "navdesc./org/harnais": "Castes, custom agents and their promotion, AI purposes, MCP servers, connections and models, supervision",
  "nav./org/acces": "Access: roles and policies",
  "navdesc./org/acces": "Role matrix, access policies and simulator",
  "nav./org/conformite": "Compliance and audit",
  "navdesc./org/conformite": "Retention, purge, audit export and emergency stop history",
  "nav./plateforme/sante": "Platform health",
  "navdesc./plateforme/sante": "Health per organisation, versions and workstation profile (GPU, engine, models)",
  "nav./plateforme/file-gpu": "Platform GPU queue",
  "navdesc./plateforme/file-gpu": "Who uses the GPU now, in what order, and what is suspended",
  "nav./plateforme/organisations": "Organisations",
  "navdesc./plateforme/organisations": "Provision, tier, suspend",
  "nav./plateforme/ia": "AI providers and models",
  "navdesc./plateforme/ia": "Connections, models, bindings, observability, channels",
  "nav./plateforme/arret-ia": "AI emergency stop",
  "navdesc./plateforme/arret-ia": "Platform scope, active stops per organisation and shared history",
  "nav./plateforme/executants": "Workers and queue",
  "navdesc./plateforme/executants": "Workers, liveness and quarantine",
  "nav./plateforme/harnais": "Cards, castes and workstation models",
  "navdesc./plateforme/harnais": "Card registry per caste, promotion, receipts, VRAM budget",
  "nav./plateforme/generation": "Qualified generation profiles",
  "navdesc./plateforme/generation": "Qualified profiles, golden cases and age of the last valid receipt",
  "nav./plateforme/continuite": "DoIt platform continuity",
  "navdesc./plateforme/continuite": "Backup of the state of DoIt itself, retention, restore test",
  "nav./plateforme/journal": "Super-administrator log",
  "navdesc./plateforme/journal": "Every platform action on an organisation",
  "nav./plateforme/acces-exceptionnels": "Active exceptional access",
  "navdesc./plateforme/acces-exceptionnels": "Exceptional access sessions in progress and revocation",
  "nav./plateforme/decisions": "Tool decisions",
  "navdesc./plateforme/decisions": "Architecture decisions of DoIt",
  "grp.Planifier": "Plan",
  "grp.Construire": "Build",
  "grp.Vérifier": "Verify",
  "grp.Livrer et exploiter": "Deliver and operate",
  "grp.Référentiel et technologies": "Framework and technologies",
  "grp.Harnais": "Harness",
  "acces.description": "Role matrix, access policies and simulator. Reserved for administration.",
  "acces.onglets": "Access sections",
  "acces.roles": "Roles and permissions",
  "acces.politiques": "Access policies",
  "admin.globalAiKillSwitchActif": "Active at platform scope: new AI requests are interrupted.",
  "admin.globalAiKillSwitchInactif": "Inactive at platform scope.",
  "admin.globalAiKillSwitchLien": "Open the AI emergency stop",
  "app.attention": "Attention inbox",
  "app.attentionAria": "Attention inbox: {{n}} pending decision(s)",
  "app.notificationsAria": "Notifications: {{n}} unread",
  "arret.active": "stop enabled",
  "arret.activer": "Stop the AI",
  "arret.bandeauRegion": "AI emergency stop",
  "arret.chargement": "Reading the emergency stop…",
  "arret.confirmationOrganisation": "Confirmation: type the organisation name ({{org}})",
  "arret.confirmationPlateforme": "Confirmation: type “plateforme”",
  "arret.confirmationRequiseOrganisation": "Type the organisation name to confirm.",
  "arret.confirmationRequisePlateforme": "Type “plateforme” to confirm switching the whole platform.",
  "arret.constateDetail": "— refusal observed at {{instant}}; the cause is readable by your organisation administration.",
  "arret.constateTitre": "AI requests interrupted",
  "arret.etatActif": "Stop ACTIVE since {{depuis}} — reason: “{{motif}}”.",
  "arret.etatInactif": "No stop at this scope: AI requests are allowed by it.",
  "arret.historique": "Shared history",
  "arret.historiqueVide": "No switch recorded.",
  "arret.interrompu": "Interrupted",
  "arret.leve": "stop lifted",
  "arret.lever": "Lift the AI stop",
  "arret.lienOrganisation": "Organisation › Governance and approvals",
  "arret.lienPlateforme": "Platform › AI emergency stop",
  "arret.motif": "Reason (required, kept in the history)",
  "arret.motifRequis": "Give a reason of 3 to 500 characters: it stays in the history.",
  "arret.orgsArretees": "Still stopped by their own decision: {{n}} ({{liste}}). Lifting the platform does not restore them.",
  "arret.pourquoi": "Why? Cause and effects",
  "arret.regle": "AI is stopped if the platform OR your organisation stopped it: lifting one restores nothing while the other stays active.",
  "arret.restePlateforme": "AI remains stopped by the platform since {{depuis}}: lifting the organisation stop does not restore it.",
  "arret.restePossible": "Still possible",
  "arret.restreintOrganisation": "Reserved for the organisation administration: the state is shown to you by the banner.",
  "arret.restreintPlateforme": "Reserved for the platform administration.",
  "arret.titreOrganisation": "AI emergency stop — organisation scope",
  "arret.titrePlateforme": "AI emergency stop — platform scope",
  "arret.restentPossibles": "Still possible: stop a preview, roll back, deploy, run test campaigns and pipelines.",
  "avenir.05x": "This entry is {{marque}}: it is visible so you know where it will live.",
  "avenir.beta": "This screen is part of v0.5.0; it is delivered by wave {{vague}} of the new interface.",
  "avenir.enAttendant": "Meanwhile:",
  "avenir.inconnu": "Screen not found",
  "cmdk.general": "General",
  "conformite.description": "Retention, purge, audit export and emergency stop history.",
  "conformite.sansEspace": "Open a project in the context switcher: the audit export is still read per space.",
  "contexte.plateforme": "Platform",
  "contexte.vueEnsemble": "Overview",
  "contexte.vueProgramme": "Programme view",
  "contexte.vueProjet": "Project view",
  "demenagement.avis": "This screen has moved: the address {{ancienne}} now leads here. Update your bookmarks.",
  "demenagement.fermer": "Close the relocation notice",
  "fil.region": "Breadcrumb",
  "gouvernance.description": "Approval modes and AI emergency stop at organisation scope.",
  "gouvernance.modes": "Approval modes, two or three people and designated architects: set today in the",
  "nav.affichageProjet": "Project navigation display",
  "nav.itemUnread": "{{n}} unread notification(s)",
  "nav.modeComplet": "Complete",
  "nav.modeDecouverte": "Discovery",
  "nav.reserveAdministration": "reserved for administration",
  "nav.marque05x": "designed, delivered after v0.5.0",
  "nav.niveau.projet": "Project navigation",
  "nav.niveau.programme": "Programme navigation",
  "nav.niveau.organisation": "Organisation navigation",
  "nav.niveau.plateforme": "Platform navigation",
  "nav.titreNiveau.projet": "Project",
  "nav.titreNiveau.programme": "Programme",
  "nav.titreNiveau.organisation": "Organisation",
  "nav.titreNiveau.plateforme": "Platform",
  "plateforme.reserve": "The Platform level is reserved for the super-administrator.",
  "reglages.pageDescription": "Allowed models, quotas and integrations of the project. The selected section is in the address.",
  "reglages.title": "Project settings",
  "vueProjet.chargement": "Loading…",
  "vueProjet.blocIndisponible": "{{titre}} unavailable: the read did not answer; the other blocks remain displayed.",
  "vueProjet.reessayer": "Retry this block",
  "vueProjet.sansProjet": "Choose a project in the context selector; the Project view always concerns one project.",
  "vueProjet.indicateurs05x": "Indicators (technology change flow, idea → delivered lead time, efficiency by caste and model): designed, delivered after v0.5.0 — none of these measures exists on the gateway yet.",
  "vueProjet.commence": "This project is starting.",
  "vueProjet.troisEtapes": "Three steps to get started; they disappear with the first request.",
  "vueProjet.etape1": "Submit a first request",
  "vueProjet.etape2": "Decide the stack (ADR)",
  "vueProjet.etape3": "Invite the team",
  "vueProjet.sante": "Project health",
  "vueProjet.santeCouleur": "Health: {{c}}",
  "vueProjet.signaux": "The 7 signals",
  "vueProjet.detailSignaux": "See the detail of the 7 signals",
  "vueProjet.formule": "formula {{v}} · worst signal, never an average",
  "vueProjet.detailCaption": "Health — detail of the 7 signals",
  "vueProjet.prochaineAction": "Next action for you",
  "vueProjet.equipe": "Team",
  "vueProjet.colonie": "the colony · harness castes",
  "vueProjet.membres": "Members and teams",
  "vueProjet.pile": "Stack and profile",
  "vueProjet.decideePar": "decided by",
  "vueProjet.profil": "profile",
  "vueProjet.baseline": "technology baseline summarised here after v0.5.0",
  "vueProjet.pileAucune": "No stack decided: an ADR enables the “Generability” signal.",
  "vueProjet.jauge": "Cycle gauge — requests per step",
  "vueProjet.jaugeTableau": "See the gauge as a table",
  "vueProjet.jaugeCaption": "Cycle gauge as a table",
  "vueProjet.jaugeRegle": "each request counts at the most advanced step reached by one of its items (ARB-r2-09) · {{n}} request(s) in the project",
  "vueProjet.missions": "Missions in progress",
  "vueProjet.aucuneMission": "No mission in progress.",
  "vueProjet.version": "Version in preparation",
  "vueProjet.prete": "Ready?",
  "vueProjet.ouvrirVersion": "Open the version",
  "vueProjet.aucuneVersion": "No version in preparation.",
  "vueProjet.decisions": "Latest decisions",
  "vueProjet.aucuneDecision": "No decision recorded.",
  "vueProjet.attention": "Project attention",
  "vueProjet.boite": "Attention inbox (scope: this project)",
  "vueProjet.couleurVert": "green",
  "vueProjet.couleurAmbre": "amber",
  "vueProjet.couleurRouge": "red",
  "vueProjet.couleurSansObjet": "not applicable",
  "vueProjet.signalQualite": "Quality",
  "vueProjet.signalLivraison": "Delivery",
  "vueProjet.signalDecisions": "Decisions",
  "vueProjet.signalConformite": "Compliance",
  "vueProjet.signalColonie": "Colony",
  "vueProjet.signalExploitation": "Operations",
  "vueProjet.signalGenerabilite": "Generability",
  "vueProjet.santeSansObjet": "Not applicable: no signal has data.",
  "vueProjet.santeVert": "Green: all available signals are green.",
  "vueProjet.santeDeterminant": "{{signal}}: {{raison}}",
  "vueProjet.santeSeparateur": "; ",
  "vueProjet.santeSignaux": "{{titre}}: {{nb}} signals — {{detail}}.",
  "vueProjet.santeUnSignal": "{{titre}}: 1 signal — {{detail}}.",
  "vueProjet.etapeCadrage": "Framing",
  "vueProjet.etapeChoixTechno": "Technology choices",
  "vueProjet.etapeDesign": "Design",
  "vueProjet.etapeSpecification": "Specification",
  "vueProjet.etapePlanification": "Planning",
  "vueProjet.etapeDeveloppement": "Development by the agents",
  "vueProjet.etapeTests": "Tests and quality",
  "vueProjet.etapeLivraison": "Delivery",
  "vueProjet.etapeExploitation": "Operations",
  "vueProjet.etatEnCours": "in progress",
  "vueProjet.etatRouverte": "reopened",
  "vueProjet.etatFaite": "done",
  "vueProjet.etatNonActivee": "not activated",
  "vueProjet.etatAVenir": "upcoming",
  "vueProjet.jaugeAucune": "No request: all steps are upcoming.",
  "vueProjet.jaugeElement": "{{etape}} ({{nb}})",
  "vueProjet.jaugeElementPremier": "{{etape}} ({{nb}} requests)",
  "vueProjet.jaugeElementPremierUn": "{{etape}} ({{nb}} request)",
  "vueProjet.jaugeElementRouverte": "{{element}} reopened",
  "vueProjet.jaugeEnCoursNonActivees": "In progress: {{liste}}; not activated: {{inactives}}.",
  "vueProjet.jaugeEnCours": "In progress: {{liste}}.",
  "vueProjet.colSignal": "signal",
  "vueProjet.colEtat": "state",
  "vueProjet.colDetermine": "what determines it",
  "vueProjet.colSource": "source",
  "vueProjet.colEtape": "step",
  "vueProjet.colDemandes": "requests",
  "n28.titre": "Next action",
  "n28.depuis": "for",
  "n28.enAttente": "waiting for",
  "n28.agir": "Go",
  "n28.egalite": "on a tie, the oldest wins",
  "n28.rien": "Nothing is waiting for you here.",
  "n28.autreRole": "The {{role}} can act: {{action}}.",
  "nav./demandes": "Requests",
  "navdesc./demandes": "File a request — its first state is the idea — and start its framing",
  "nav./specifications": "Specifications",
  "nav./specifications/modifications": "Change requests",
  "nav./projet/classement": "Project classification",
  "navdesc./specifications": "Approved specifications, Spec Gate receipt, editing as a new version and next steps",
  "navdesc./specifications/modifications": "Change requests on approved specifications: justification, estimated impact, decision",
  "navdesc./projet/classement": "Labels, components and fix versions: rename, date, delete",
  "arret.refusAction": "New AI requests are temporarily suspended.",
  "arret.refusPorteePlateforme": "AI stopped on the platform: the generation will wait until it is lifted.",
  "arret.refusPorteeOrganisation": "AI stopped in your organisation: the generation will wait until it is lifted.",
  "arret.detailTechnique": "Technical detail",
  "concevoir.etapesSuivantes": "Next steps (generate the backlog)",
  "concevoir.genererApplication": "Open “Generate the application”",
  "concevoir.suiteRefusPerime": "Spec Gate receipt stale (outdated evaluation): re-evaluate the specification before moving on.",
  "concevoir.suiteRefusSansRecu": "No fresh Spec Gate receipt: re-evaluate the specification before moving on.",
  "concevoir.suiteArretIA": "The AI stop refuses any generation before the click; the screen opens, the generation will wait until it is lifted.",
  "demandes.sansProjet": "No project selected",
  "demandes.sansProjetHint": "Choose a project in the context bar.",
  "demandes.title": "Requests",
  "demandes.description": "Each request has its state, from idea to delivered version: idea, framed, specified, in construction, to review, delivered (§ 4.2). The name opens the request thread.",
  "demandes.deposer": "Submit an idea",
  "demandes.chargement": "Loading requests…",
  "demandes.erreurGardee": "The list could not be read; the previous one is still shown.",
  "demandes.vide": "No request in this project",
  "demandes.videHint": "A request is born from a submitted idea; it then goes through its states.",
  "demandes.filtreEtat": "Filter by state",
  "demandes.toutes": "All",
  "demandes.etatAVenir": "Coming: the request → specification → version lineage does not exist in the APIs yet.",
  "demandes.filtreDemandeur": "Requester",
  "demandes.tousDemandeurs": "All requesters",
  "demandes.colDemande": "request",
  "demandes.colEtat": "request state",
  "demandes.colDemandeur": "requester",
  "demandes.colAge": "age",
  "demandes.colItems": "resulting items",
  "demandes.colActivite": "last activity",
  "demandes.colAttend": "waiting for",
  "demandes.itemsAVenir": "Coming: no request → items link in the APIs.",
  "demandes.pied": "{{n}} requests · sorted by last activity",
  "demandes.filiationAVenir": "Coming: the idea → framing → specification → application lineage does not exist in the APIs yet. A request is read here from its framing; the states “specified” to “delivered” and the resulting items will show once the server carries that link.",
  "demandes.filOuEnEst": "Where my request stands",
  "demandes.filDeposee": "submitted by {{qui}} on {{quand}} · framing v{{v}}",
  "demandes.cadrageRefuse": "framing rejected",
  "demandes.filEtats": "Request states",
  "demandes.filEtatsNote": "Clicking a state opens the entry that carries it; filtering on this request is coming.",
  "demandes.filItems": "Items resulting from this request",
  "demandes.filItemsAVenir": "Coming: the request → items link does not exist in the APIs yet (ASM-IA-10).",
  "demandes.ouvrirBacklog": "Open the Backlog",
  "demandes.filInitiative": "Originating initiative",
  "demandes.filInitiativeAVenir": "Coming: the originating initiative is not kept with the request.",
  "demandes.filSuite": "Next steps",
  "demandes.filSuiteCadree": "Framing approved: options, personas, processes, epics or specification start from its next steps.",
  "demandes.filOuvrirSuite": "Next steps of the request",
  "demandes.filSuiteArret": "The AI stop refuses any generation before the click; the screen opens, the generation will wait until it is lifted.",
  "demandes.filSuiteRefuse": "The framing was rejected: submit the idea again, reworded.",
  "demandes.filSuiteIdee": "The framing awaits its decision in the approval center.",
  "demandes.filVoirCadrage": "See the framing to decide",
  "demandes.filTitre": "Request",
  "demandes.filDescription": "The request thread: where it stands, what resulted from it, and what comes next.",
  "demandes.retour": "All requests",
  "demandes.chargementFil": "Loading the request…",
  "demandes.introuvable": "Request not found",
  "demandes.introuvableHint": "It does not belong to this project, or its framing was replaced.",
  "specs.perimeMotif": "Outdated evaluation: the Spec Gate receipt no longer counts for “Ready for the colony”.",
  "specs.sansRecuMotif": "No fresh Spec Gate receipt for this version.",
  "specs.reevaluer": "Re-evaluate (Spec Gate)",
  "specs.ouvrirVersion": "Open version v{{v}}",
  "specs.reevaluerArret": "The Spec Gate queries a model: refused while the AI is stopped; re-evaluate once it is lifted.",
  "specs.title": "Specifications",
  "specs.description": "The approved specifications of the project, their Spec Gate receipt and the next steps: generate the backlog or the application.",
  "specs.editer": "Edit a specification",
  "specs.sansProjet": "No project open",
  "specs.sansProjetHint": "Specifications belong to a project: open it in the context bar.",
  "specs.chargement": "Loading specifications…",
  "specs.erreurGardee": "The gateway did not answer; the previous list is still shown.",
  "specs.vide": "No specification",
  "specs.videHint": "A specification is born from a framed request; submit an idea first.",
  "specs.region1": "Project specifications",
  "specs.filtre": "Filter specifications",
  "specs.toutes": "All",
  "specs.perimes": "Stale receipt",
  "specs.colSpec": "specification",
  "specs.colVersion": "version",
  "specs.colDemande": "originating request",
  "specs.colGate": "Spec Gate",
  "specs.colApprouvee": "approved by",
  "specs.colCouverture": "coverage",
  "specs.demandeAVenir": "Coming: specification → request link absent from the APIs.",
  "specs.couverture": "Coverage and traceability",
  "specs.couvertureAVenir": "Coming: “N criteria / M linked cases” per specification and the originating request need traceability filtered by specification, absent from the APIs; coverage opens unfiltered.",
  "specs.suiteIntro": "On an approved specification whose Spec Gate receipt is fresh, two actions open the next steps:",
  "editor.noProject": "No project open",
  "editor.noProjectHint": "Specifications belong to a project: open it in the context bar.",
  "editor.approved": "approved",
  "editor.suiteTitre": "Next steps for this approved specification:",
  "editor.dmsDemander": "Request a specification modification",
  "editor.dmsAVenir": "Coming: the specification modification request (DMS-n) — justification, estimated impact on requirements, tests and backlog, architect review — has no API yet. It is distinct from the change request (CHG-n), reserved for technology changes. Comparing two versions follows the same path.",
  "dms.statut.open": "open",
  "dms.statut.accepted": "accepted",
  "dms.statut.refused": "refused",
  "dms.statut.withdrawn": "withdrawn",
  "dms.comparerTitre": "Compare two versions",
  "dms.chargementVersions": "Loading the specification's versions…",
  "dms.uneSeuleVersion": "A single version of this specification",
  "dms.uneSeuleVersionAide": "Nothing to compare: a new version comes from editing and then approval.",
  "dms.versionA": "Starting version",
  "dms.choisirVersion": "Choose a version…",
  "dms.versionB": "Compared version",
  "dms.memeVersion": "Choose two different versions.",
  "dms.chargementDiff": "Comparing…",
  "dms.diffCompte": "{{ajouts}} line(s) added, {{retraits}} removed",
  "dms.envoyee": "Change request recorded: it is awaiting a decision",
  "dms.demandeTitre": "Request a change to the specification",
  "dms.demandeAide": "A DMS-n request states what must change and why; someone other than you decides it (project owner or designated architect). It is not the technology change request (CHG-n).",
  "dms.chargement": "Loading change requests…",
  "dms.lectureSeule": "Read only: requesting a change is reserved for project owners and contributors.",
  "dms.dejaOuverte": "{{ref}} is already open on this specification: decide or withdraw it before opening another one.",
  "dms.formulaire": "Change request",
  "dms.justification": "Justification (required): what must change and why",
  "dms.justificationCourte": "Justify in at least {{n}} characters.",
  "dms.niveau": "Estimated impact",
  "dms.niveauMineur": "Minor: clarification, no effect on scope",
  "dms.niveauMajeur": "Major: requirements, tests or backlog to rework",
  "dms.note": "Impact note (optional)",
  "dms.impactCalcule": "On submission, the gateway computes the impact from what it knows: the version's requirements, items derived from the specification, linked test cases.",
  "dms.toutes": "All change requests of the project",
  "dms.listeTitre": "Specification change requests",
  "dms.listeDescription": "Each DMS-n: the targeted specification, the justification, the estimated impact and the decision.",
  "dms.versSpecs": "Back to specifications",
  "dms.filtre": "Status",
  "dms.tous": "All",
  "dms.aucuneFiltre": "No request with this status",
  "dms.aucune": "No change request",
  "dms.aucuneAide": "A request is made from the editor, on an approved specification.",
  "dms.majeur": "major impact",
  "dms.mineur": "minor impact",
  "dms.decisionEnregistree": "Decision recorded",
  "dms.retiree": "Request withdrawn",
  "dms.versListe": "All change requests",
  "dms.introuvable": "Request not found",
  "dms.chargementFiche": "Loading the request…",
  "dms.introuvableAide": "It does not exist in the open project.",
  "dms.retirerTitre": "Withdraw {{ref}}?",
  "dms.retirerConsequence": "The request is closed without a decision; it remains readable in the history.",
  "dms.retirerReversible": "You can open a new one on the same specification.",
  "dms.retirer": "Withdraw the request",
  "dms.ficheTitre": "{{ref}} — change request",
  "dms.statut": "Status",
  "dms.source": "Targeted version",
  "dms.demandeur": "Requested by",
  "dms.justificationCourt": "Justification",
  "dms.retireePar": "Withdrawn by",
  "dms.decideePar": "Decided by",
  "dms.impactTitre": "Impact computed at request time",
  "dms.exigences": "requirement(s) in the version",
  "dms.items": "item(s) derived from the specification",
  "dms.cas": "linked test cases",
  "dms.enAttente": "version(s) already pending",
  "dms.itemsTouches": "Affected items",
  "dms.versTracabilite": "See requirement → test traceability",
  "dms.realisationTitre": "Implementation",
  "dms.realiseePar": "Implemented by version",
  "dms.aRealiser": "Accepted, not implemented yet:",
  "dms.realiser": "edit the specification",
  "dms.decisionTitre": "Decide",
  "dms.decisionNote": "Note (required to refuse)",
  "dms.refusSansNote": "Say why you refuse (at least 5 characters).",
  "dms.accepter": "Accept the request",
  "dms.refuser": "Refuse the request",
  "dms.pasDecideur": "The decision belongs to the project owner or a designated architect, never to the requester.",
  "ideas.arretIA": "New AI requests are temporarily suspended: your text stays as a draft on this device.",
  "ideas.voirDemandes": "See the request in Requests",
  "adr.noProject": "No project open",
  "adr.noProjectHint": "Open a project to see its decisions; the Tool scope remains readable.",
  "adr.baseline05x": "In 0.5.x: this entry becomes “Choices and baseline” — versioned technology baseline, inheritance per category (organisation → programme → project), change request (CHG-n) or propagation. ADRs and the matrix remain the path for a category defined for this project.",
  "adr.voirBaseline": "See Choices and baseline (0.5.x)",
  "design.revisionEntiere": "Conformance always applies to the whole revision: it is not filtered by request — a gap on one screen affects the whole application.",
  "design.voirApercus": "View and annotate in Previews",
  "fileGpu.attente": "wait",
  "fileGpu.aVenir": "VRAM per task, served model and proposed qualification slot: the gateway does not expose them yet.",
  "fileGpu.carte": "card",
  "fileGpu.chargement": "Reading the GPU queue…",
  "fileGpu.compteurs": "{{q}} queued · {{r}} served · refreshed every 10 s · {{a}}",
  "fileGpu.erreur": "The GPU queue could not be read.",
  "fileGpu.etat": "state",
  "fileGpu.legende": "Served and waiting tasks, by rank",
  "fileGpu.organisation": "organisation",
  "fileGpu.plateforme": "platform",
  "fileGpu.rang": "rank",
  "fileGpu.refus": "The platform GPU queue is reserved to the super-administrator.",
  "fileGpu.tache": "task",
  "fileGpu.titre": "Admission queue — all organisations",
  "fileGpu.tronquee": "List truncated: the counters above cover the whole queue.",
  "fileGpu.vide": "The GPU queue is empty",
  "fileGpu.videIndice": "No task served or waiting, across all organisations.",
  "gouvernance.derogations": "Who approves a waiver depends on its risk: the summary, due dates and counts are kept on the Waivers screen.",
  "gouvernance.voirDerogations": "Open waivers",
  "journal.action": "action",
  "journal.arret": "emergency stop ({{portee}})",
  "journal.arrets": "AI emergency stops — all scopes",
  "journal.aVenir": "Suspensions, tiers, AI connections and deletions: the gateway does not expose the log of platform actions on an organisation yet. Only AI emergency stops are logged below.",
  "journal.chargement": "Reading the log…",
  "journal.detail": "detail",
  "journal.erreur": "The log could not be read.",
  "journal.evenement": "event",
  "journal.legende": "Emergency stop log, most recent first",
  "journal.levee": "stop lifted ({{portee}})",
  "journal.organisation": "organisation",
  "journal.par": "by",
  "journal.quand": "when",
  "journal.refus": "The platform log is reserved to the super-administrator.",
  "journal.toutes": "all",
  "journal.vide": "No action logged",
  "journal.videIndice": "No emergency stop has been decided yet.",
  "niveaux.aVenir": "coming",
  "niveaux.nonAccessibles1": "1 project is not open to you — no name, health or milestone: a count only.",
  "niveaux.nonAccessiblesN": "{{n}} projects are not open to you — no name, health or milestone: a count only.",
  "orgProjets.actif": "active",
  "orgProjets.archive": "archived",
  "orgProjets.autreProgramme": "a programme you are not a member of",
  "orgProjets.aVenir": "Current stages, stack and health per project: the gateway does not aggregate them at organisation level yet.",
  "orgProjets.chargement": "Reading projects…",
  "orgProjets.description": "Organisation projects you are a member of; the others are counted, never named.",
  "orgProjets.erreur": "Projects could not be read.",
  "orgProjets.filtre": "Programme",
  "orgProjets.horsProgramme": "no programme",
  "orgProjets.horsProgrammeOption": "No programme",
  "orgProjets.legende": "Projects you are a member of",
  "orgProjets.monRole": "my role",
  "orgProjets.ouvrir": "Open",
  "orgProjets.programme": "programme",
  "orgProjets.projet": "project",
  "orgProjets.refus": "Your role does not allow listing the organisation's projects.",
  "orgProjets.statut": "status",
  "orgProjets.tous": "All programmes",
  "orgProjets.vide": "No project to show",
  "orgProjets.videFiltre": "None of your projects matches this programme.",
  "orgProjets.videIndice": "You are not a member of any project of this organisation.",
  "orgQualite.aucune": "none",
  "orgQualite.aVenir": "Open campaigns, latest regression run, « ready? » and failed deployments: not yet aggregated at organisation level; each project shows them in Verify and Deliver.",
  "orgQualite.bloquantes": "open blockers",
  "orgQualite.chargement": "Reading projects…",
  "orgQualite.compteur": "Open blocking defects: {{n}} — {{p}} project(s) affected",
  "orgQualite.deployee": "deployed on",
  "orgQualite.description": "Quality and delivery of the projects you are a member of.",
  "orgQualite.erreur": "Projects could not be read.",
  "orgQualite.legende": "Quality and delivery per project",
  "orgQualite.nonLu": "not read",
  "orgQualite.partiel": "Partial view: {{noms}} not read.",
  "orgQualite.projet": "project",
  "orgQualite.refus": "Your role does not allow listing the organisation's projects.",
  "orgQualite.titre": "Quality and delivery",
  "orgQualite.version": "latest version",
  "orgQualite.vide": "No active project to follow",
  "orgQualite.videIndice": "You are not a member of any active project of this organisation.",
  "pgmMembres.actions": "actions",
  "pgmMembres.ajouter": "Add",
  "pgmMembres.chargement": "Reading members…",
  "pgmMembres.de": "Members of {{nom}}",
  "pgmMembres.depuis": "since",
  "pgmMembres.dernier": "Last owner: appoint another owner first.",
  "pgmMembres.detail": "Technical detail",
  "pgmMembres.erreur": "Members could not be read.",
  "pgmMembres.identifiant": "User identifier",
  "pgmMembres.legende": "Programme members and their role",
  "pgmMembres.membre": "member",
  "pgmMembres.refus": "You are not a member of this programme: its member list is not open to you.",
  "pgmMembres.regle": "Owner and contributor see all attached projects (aggregates); a viewer, only the projects they are a member of. Opening a project requires being a member of it.",
  "pgmMembres.requis": "Enter the identifier of the user to add.",
  "pgmMembres.reserve": "Reserved to a programme owner.",
  "pgmMembres.retirer": "Remove",
  "pgmMembres.role": "role in the programme",
  "pgmMembres.roleDe": "Role of {{nom}}",
  "pgmMembres.roleNouveau": "Role",
  "pgmMembres.vide": "No member",
  "pgmMembres.videIndice": "The programme has no declared member yet.",
  "pgmProjets.agregat": "aggregate only",
  "pgmProjets.aucunCandidat": "No other project you are a member of to attach.",
  "pgmProjets.chargement": "Reading programme projects…",
  "pgmProjets.de": "Projects attached to {{nom}} (0 or 1 programme per project)",
  "pgmProjets.dejaAutre": "Already attached to another programme: detach it first.",
  "pgmProjets.dejaNomme": "Already attached to programme « {{nom}} »: detach it from that programme first.",
  "pgmProjets.detacher": "Detach",
  "pgmProjets.erreur": "Programme projects could not be read.",
  "pgmProjets.legende": "Projects attached to the programme",
  "pgmProjets.monRole": "my role",
  "pgmProjets.projet": "project",
  "pgmProjets.raisonProprietaire": "Only the owner of this project, or the platform administrator, can attach or detach it.",
  "pgmProjets.rattacher": "Attach",
  "pgmProjets.rattacherTitre": "Attach a project",
  "pgmProjets.refus": "You are not a member of this programme: its projects are not open to you.",
  "pgmProjets.version": "version in preparation",
  "pgmProjets.vide": "No attached project",
  "pgmProjets.videIndice": "Attach below a project you own.",
  "pgmRoadmap.aVenir": "Graphical timeline and programme target milestone: not built yet; the same information is given as a table.",
  "pgmRoadmap.chargement": "Reading the roadmap…",
  "pgmRoadmap.dates": "dates",
  "pgmRoadmap.dependances": "Cross-project dependencies of the train",
  "pgmRoadmap.description": "Sprints, milestones and versions of attached projects",
  "pgmRoadmap.erreur": "The programme roadmap could not be read.",
  "pgmRoadmap.etat": "state",
  "pgmRoadmap.jalons": "Versions in preparation:",
  "pgmRoadmap.legende": "Sprints of attached projects",
  "pgmRoadmap.points": "committed / completed points",
  "pgmRoadmap.projet": "project",
  "pgmRoadmap.sprint": "sprint",
  "pgmRoadmap.vide": "No dated sprint",
  "pgmRoadmap.videIndice": "Sprints of attached projects will appear here once planned.",
  "pgmVersions.aVenir": "Target date, « ready? » reason and dependencies per version: not yet aggregated at programme level.",
  "pgmVersions.chargement": "Loading the train…",
  "pgmVersions.description": "Release train — aggregated reading",
  "pgmVersions.legende": "Versions of attached projects",
  "pgmVersions.lireProjet": "read in the project",
  "pgmVersions.livree": "latest released",
  "pgmVersions.preparation": "in preparation",
  "pgmVersions.pret": "ready?",
  "pgmVersions.projet": "project",
  "pgmVersions.regle": "« Ready? » belongs to each project (Versions): here you read; you decide in the project.",
  "pgmVersions.sansObjet": "not applicable",
  "pgmVersions.vide": "No version prepared",
  "pgmVersions.videIndice": "Versions of attached projects will appear here.",
  "pgmVue.aller": "Go further",
  "pgmVue.chargement": "Reading the train…",
  "pgmVue.erreur": "The programme train could not be read.",
  "pgmVue.livree": "latest released: {{v}}",
  "pgmVue.objectif": "Programme objective and target milestone.",
  "pgmVue.preparation": "in preparation: {{v}}",
  "pgmVue.projets": "Attached projects",
  "pgmVue.sante": "Spread health and current stages per project: the gateway does not aggregate them at programme level yet.",
  "pgmVue.statut": "Status: {{s}}",
  "programme.aucun": "No programme selected",
  "programme.aucunIndice": "Choose a programme in the context selector or in the programme list.",
  "missions.pageDescriptionHarnais": "Harness regime: the colony works between two human gates — plan and budget at the start, evidence dossier at the end.",
  "construire.sansProjet": "No project selected",
  "construire.sansProjetAide": "Choose a project in the selector to see its missions.",
  "missions.filtres": "Filter missions",
  "missions.refus": "Restricted access: missions are readable by project members. Ask the owner for access.",
  "missions.emptyTitleProjet": "No mission in this project",
  "missions.filtreVide": "No mission in this filter.",
  "missions.filtreToutes": "See all missions",
  "missions.tableau": "Project missions",
  "missions.tableauLegende": "Project missions · refreshed every 10 s",
  "missions.col.mission": "Mission",
  "missions.col.statusReason": "Status and reason",
  "missions.col.gpuEscalations": "GPU consumed · escalations",
  "missions.modesTitre": "Harness modes (ADR-0108)",
  "missions.modeDefaut": "template default",
  "missions.modePermis": "allowed by the template",
  "missions.modeNonPermis": "not allowed by this template",
  "missions.modesNote": "All three modes ship in beta; A and B remain experimental until bench h has passed. A mode that is not allowed is shown disabled with its reason — never silently downgraded to C.",
  "missions.attenteTitre": "Waiting for a human ({{n}})",
  "missions.attenteVide": "No pending decision.",
  "missions.attentePlan": "plan to approve",
  "missions.attenteEscalades": "{{n}} open decision(s)",
  "missions.relirePlan": "Review the plan",
  "missions.ouvrirPoste": "Open the cockpit",
  "missions.attenteBoite": "The same entries, with their age, in the attention inbox.",
  "missions.status.attenteArretIA": "Waiting (AI stop)",
  "missions.attenteArretIA": "AI requests are stopped: the current step finishes, the rest waits for the stop to be lifted without consuming the budget.",
  "missions.status.fileGpu": "Plan approved · in GPU queue",
  "missions.fileGpu": "The mission will start when the AI stop is lifted.",
  "missions.planAAutre": "To be approved by a member other than the requester, on the fingerprint of the reviewed plan.",
  "missions.escaladesCourt": "escalations {{n}}/{{max}}",
  "missions.form.readOnlyProjet": "Your role in this project does not allow launching a mission.",
  "missions.form.modeNotAllowed": "Not allowed by the project template (ADR-0108: the template chooses the mode); never silently downgraded to C.",
  "missions.form.stopsRules": "Stops: {{n}} round(s) · 2 unproductive rounds · same tree · oscillation · budget · test suite refused twice.",
  "missions.form.appBusy": "This project's application already has an iteration mission in progress: “{{m}}”. Only one at a time, otherwise the merge would carry a tree that was never tested.",
  "missions.form.aiStopped": "New AI requests are temporarily stopped: the plan would not be proposed.",
  "missions.plan.changed": "The plan changed since you read it: review it again before approving.",
  "missions.plan.selfRefused": "You launched this mission: another member must approve its plan and budget (separation of duties).",
  "missions.col.casteCarteModele": "Caste · card · model",
  "missions.sansCarte": "no card",
  "missions.sansModele": "no model",
  "missions.plan.total": "Estimated total: {{e}} GPU min out of {{b}} · {{r}} rounds · {{x}} escalations · reviewed plan fingerprint {{h}}",
  "missions.plan.instanciation": "Per-task instantiation: castes, cards, models, context",
  "missions.plan.noEdit": "“Edit the plan” does not exist: to replan, reject with a reason, then relaunch.",
  "missions.plan.readOnlyProjet": "A contributor or the project owner approves the plan.",
  "missions.plan.sodReject": "“Reject with reason” remains possible.",
  "missions.plan.aiStopped": "While AI is stopped, approving remains possible: no model is called, the mission waits in the GPU queue until it resumes.",
  "missions.inst.loading": "Reading the instantiation…",
  "missions.inst.title": "Per-task instantiation",
  "missions.inst.back": "Back to the plan",
  "missions.inst.avis": "proposed by the queen until your approval",
  "missions.inst.lie": "plan approved: the instantiation binds the mission",
  "missions.inst.empty": "The queen has not proposed a plan yet",
  "missions.inst.emptyHint": "The instantiation appears with the plan.",
  "missions.inst.caption": "Agent instantiation, per task",
  "missions.inst.total": "Estimated total: {{e}} GPU min out of {{b}} · reviewed plan fingerprint {{h}}",
  "missions.inst.ecart": "Not yet exposed by the gateway: the context window, the routing source and one row per caste (verifier, guard) for each task. They are not guessed here.",
  "missions.inst.changeModel": "Change a caste's model",
  "missions.inst.static": "Routing is static in v0.5.0 (card → role → model); changing it is not specified (DIA-16).",
  "missions.inst.reader": "Reader: the instantiation is readable; approving the plan is reserved to contributors and the owner.",
  "construire.orch.supervisionCourt": "Agent supervision",
  "missions.pause.button": "Pause",
  "missions.pause.later": "Pause and “Resume the mission”: voluntary pause ships after v0.5.0 (DIA-15) — today “Stop” only.",
  "missions.cockpit.fileGpuTitre": "In GPU queue: the mission waits for the AI stop to be lifted",
  "missions.cockpit.fileGpu": "No task starts until the stop is lifted: no GPU minute is consumed, no round is counted.",
  "missions.cockpit.baseMoved": "Nothing is merged: main moved since the mission started. The merge would not fast-forward the approved and tested tree; a new mission will start from the head of main.",
  "missions.cockpit.instanciation": "Per-task instantiation: card, model, estimate",
  "construire.agentsPerso": "Custom agents",
  "missions.transcript.later": "Transcript per caste and round: 0.5.x (B-408); today, the blackboard log.",
  "missions.cockpit.estimeNote": "Plan estimate and consumption are two distinct measures, never added together.",
  "missions.cockpit.estimated": "Plan estimate",
  "missions.decision.otherFamilyUsed": "Already handed to general_agent for this task.",
  "missions.decision.reopenedTwice": "Task already reopened twice: “Reorient”, “Have the hidden tests redesigned” and “Hand to general_agent” are refused. “Take over” and “Acknowledge the stop” remain.",
  "missions.decision.generalAgent": "Hand to general_agent",
  "missions.decision.aiStopped": "Reorient and hand to general_agent call a model: refused while AI is stopped. Taking over and acknowledging remain possible.",
  "missions.decision.dossierChanged": "The dossier changed since you read it: review it again before deciding.",
  "missions.betaExperimental": "beta · experimental",
  "supervision.title": "Agent supervision",
  "supervision.description": "Everything running in the project: missions, castes at work, custom agents. Read-only — controls (stop, take over, reorient) stay in each mission's cockpit.",
  "supervision.sansProjetAide": "Choose a project to see what runs in it.",
  "supervision.loading": "Reading missions, castes and jobs…",
  "supervision.refus": "Restricted access: supervision is readable by project members. Ask the owner for access.",
  "supervision.refresh": "refreshed every 10 s",
  "supervision.iaTitre": "AI stopped",
  "supervision.ia": "Missions finish their current step and wait for the stop to be lifted; supervision remains readable.",
  "supervision.executeurTitre": "No executor responds",
  "supervision.executeur": "Steps stay queued until an executor picks them up; missions are not lost.",
  "supervision.suspendue": "Suspended",
  "supervision.repriseAuto": "Resumes automatically as soon as a slot frees up.",
  "supervision.vide": "Nothing is running in this project",
  "supervision.videAide": "No active mission, no agent or job running.",
  "supervision.missionsActives": "Active missions ({{n}})",
  "supervision.toutesMissions": "All missions",
  "supervision.missionsActivesLabel": "Active project missions",
  "supervision.castesAuTravail": "Castes at work",
  "supervision.aucuneCaste": "none",
  "supervision.estime": "plan estimate: {{n}}",
  "supervision.consomme": "consumed: {{c}} / {{b}} min",
  "supervision.estimeConsomme": "GPU minutes: “plan estimate” (the queen, per task) and “consumed” (the mission) are two distinct measures, labelled separately and never added together.",
  "supervision.castesDe": "Castes at work — {{m}}",
  "construire.orch.pilotageCourt": "Cockpit",
  "supervision.modele": "Model",
  "supervision.dernierSignal": "Last signal",
  "supervision.age": "Age",
  "supervision.agentsPerso": "Custom agents ({{n}} running)",
  "supervision.agentsErreur": "Custom agent status unreadable for now.",
  "supervision.ouvrirAgents": "Open custom agents",
  "supervision.cout05x": "Cost and traces: cost is read mission by mission today (cockpit budget); the breakdown by caste, task and round and the link to traces come in 0.5.x (B-408, KPI-07).",
  "construire.carteBrouillon": "draft · no qualification receipt",
  "construire.carteBrouillonNote": "Allowed in beta (QST-F-03): bench qualification precedes the stable release, not the beta; the mission dossier records it. The generation profile receipt does not cover the card.",
  "construire.orch.plan": "Queen's plan (tasks, castes, criteria)",
  "construire.orch.instanciation": "Per-task instantiation (card, model, context)",
  "construire.orch.pilotage": "Cockpit: task graph, harness castes",
  "construire.orch.supervision": "Project agent supervision",
  "construire.orch.registre": "Blackboard log",
  "construire.orch.titre": "Agent orchestration: where to see it",
  "construire.orch.aide": "The harness, agent monitoring, instantiation and orchestration each have their own screen; this console only runs custom agents, outside the colony.",
  "construire.orch.sansMission": "No active mission: the plan, instantiation and log open from the mission list.",
  "workflow.titreAgentsPerso": "Custom agents",
  "workflow.descriptionAgentsPerso": "Run a custom agent on the project, outside the colony, and follow its trace and output.",
  "workflow.relancerApresErreur": "Relaunch after error",
  "livrer.pourEnv": "for {{env}}",
  "livrer.douzeRaisons": "{{n}} reasons",
  "livrer.vertes": "green: {{liste}}",
  "livrer.approbationPasRaison": "Go-live approval is not a reason: it follows, once the version is ready.",
  "livrer.repli": "Fallback computation: the gateway does not expose the 12 reasons yet; reasons it does not compute are “not computed”, never counted green.",
  "livrer.nonCalculee": "not computed by this server",
  "livrer.objets": "Objects at stake",
  "livrer.retourTitre": "Rollback",
  "livrer.decisionEnregistree": "Go-live decision recorded",
  "livrer.recetteAFaireRefus": "Business acceptance of {{version}} is not granted yet (required by the template).",
  "livrer.refuserTitre": "Refuse the go-live of {{nom}}?",
  "livrer.refuserConsequence": "The reason is sent to the person who requested the go-live.",
  "livrer.refuser": "Refuse",
  "livrer.refuserMotif": "Why do you refuse? (required)",
  "livrer.miseEnLigne": "Go-live",
  "livrer.mettreEnLigneQ": "Put {{nom}} live?",
  "livrer.quoi": "What",
  "livrer.quoiTexte": "Put {{nom}} live.",
  "livrer.ou": "Where",
  "livrer.quand": "When",
  "livrer.quandTexte": "After your decision, when the release manager deploys.",
  "livrer.qui": "Who",
  "livrer.quiTexte": "Requested by {{par}} · you decide · a third person deploys it.",
  "livrer.quiSansDemande": "Not requested yet: the release manager requests it from “Approvals, deployment and rollback”.",
  "livrer.retourPossible": "Possible rollback",
  "livrer.preuves": "Evidence",
  "livrer.voirRecette": "See the acceptance",
  "livrer.approuveePar": "Approved by {{par}} on {{quand}}.",
  "livrer.ouvrirApp": "Open the application",
  "livrer.refuseeMotif": "Refused: “{{motif}}”",
  "livrer.mettreEnLigne": "Put live",
  "livrer.trace": "What you approve is recorded with your name, the time and the exact version.",
  "livrer.enServiceTitre": "Application in service",
  "livrer.sansProjet": "Choose a project first",
  "livrer.sansProjetAide": "The application in service belongs to a project.",
  "livrer.chargement": "Loading the application in service…",
  "livrer.refus403": "Access denied",
  "livrer.refus403Aide": "You are not a member of this project: ask its owner for access.",
  "livrer.rienEnService": "No version in service",
  "livrer.rienEnServiceAide": "No tier has a successful deployment yet: prepare a version, then deploy it.",
  "livrer.allerVersions": "Open Versions",
  "livrer.sondeSaine": "probe healthy{{detail}}",
  "livrer.sondeEchec": "probe failing",
  "livrer.sondeNonConfiguree": "probe not configured",
  "livrer.sondeNonMesuree": "probe not measured",
  "livrer.enServiceBadge": "in service",
  "livrer.candidatDe": "candidate rc{{n}} of {{base}}",
  "livrer.surPalier": "On {{env}} (rank {{rang}})",
  "livrer.depuis": "since {{quand}}",
  "livrer.observee": "observed on {{quand}}",
  "livrer.acces": "Access",
  "livrer.documentation": "Documentation",
  "livrer.ficheVersion": "Version sheet",
  "livrer.retourProd": "Production rollback",
  "livrer.nonMesure": "not measured",
  "livrer.continuiteTitre": "Application continuity",
  "livrer.continuitePortee": "Components of the delivered application, not DoIt’s; backing up DoIt itself is not tooled in beta (DIA3-26).",
  "livrer.continuiteChargement": "Loading backup status…",
  "livrer.continuiteErreur": "Unable to read backup status: {{message}}",
  "livrer.base": "Database",
  "livrer.composantsAbsents": "not provided by the server for the delivered application",
  "livrer.composantsPlateforme": "{{n}} DoIt component(s) set aside: they do not describe the application.",
  "livrer.sauvegarde": "Backup",
  "livrer.derniereSauvegarde": "last on {{quand}}",
  "livrer.aucuneSauvegarde": "no successful backup",
  "livrer.cible": "target",
  "livrer.rtoNonMesure": "not measured: last tested restore: never",
  "livrer.continuiteNonMesure": "Test a restore to measure the RTO: until it is measured, continuity is not called healthy.",
  "livrer.continuiteNonSaine": "An unhealthy state blocks continuity certification; check the scheduler and the journal before going to production.",
  "livrer.apercuEnProduction": "This trial version is in production: {{version}} on {{env}}.",
  "livrer.apercuManuel": "Preview unavailable: manual delivery",
  "livrer.apercuManuelAide": "This project is delivered by hand: no trial version is built by the tool. The “in production” banner then relies on the deployed commit.",
  "livrer.docVivante": "Read the project documentation on screen",
  "livrer.summaryNonEtablie": "{{nom}}: “ready?” not established (reasons not computed)",
  "verifier.recetteSansProjet": "Business acceptance always belongs to a project.",
  "verifier.permissionLecture": "Reading your permissions…",
  "verifier.permissionIllisible": "Your permissions could not be read: the verdict stays disabled.",
  "verifier.recetteSansPermission": "You do not have the “run an acceptance test” permission in this project: ask the project owner or the organisation’s administration (Project members).",
  "verifier.recetteFermee": "This acceptance is no longer open: its verdict is frozen.",
  "verifier.recetteTitre": "Business acceptance",
  "verifier.recetteDescription": "You try the version and say whether each scenario complies. A remark comes with a “does not comply”.",
  "verifier.recetteChargement": "Loading acceptances…",
  "verifier.recetteErreur": "Acceptances unreadable: the gateway did not respond.",
  "verifier.recetteVide": "No version to accept",
  "verifier.recetteVideAide": "The team opens a campaign of nature “Business acceptance” from Tests › Plans and campaigns; it appears here.",
  "verifier.recetteVideAction": "Plans and campaigns",
  "verifier.versionsARecetter": "Versions to accept",
  "verifier.enCours": "in progress",
  "verifier.close": "closed",
  "verifier.recetteDe": "Acceptance of {{v}}",
  "verifier.recetteEnvironnement": "Environment: {{e}}",
  "verifier.recetteAvecPermission": "You have the “run a business acceptance” permission.",
  "verifier.recetteScenariosChargement": "Loading scenarios…",
  "verifier.recetteScenariosErreur": "Scenarios unreadable: the gateway did not respond.",
  "verifier.recetteSansScenario": "No scenario",
  "verifier.recetteSansScenarioAide": "The plan of this acceptance does not contain any case yet.",
  "verifier.recetteAvancement": "{{vus}} scenario(s) seen out of {{total}}",
  "verifier.aVoir": "to see",
  "verifier.conforme": "complies",
  "verifier.pasConforme": "does not comply",
  "verifier.conformeAction": "Complies",
  "verifier.pasConformeAction": "Does not comply",
  "verifier.votreRemarque": "Your remark",
  "verifier.remarqueRequise": "Say what is wrong: the remark is attached to the verdict for the team.",
  "verifier.annuler": "Cancel",
  "verifier.envoyerRemarque": "Send the remark",
  "verifier.remarqueDevenueAnomalie": "Remark turned into defect ANO-{{a}}",
  "verifier.remarqueATrier": "Remark attached to the verdict: the team declares it as a defect from result EXE-{{e}}",
  "verifier.verdictVersion": "Your verdict on the version",
  "verifier.verdictRefusee": "At least one scenario “does not comply”: no acceptance with reservations. Your remarks go to the team; a new acceptance will follow the fix.",
  "verifier.verdictAccordee": "All scenarios comply: the acceptance is granted. Going live remains the sponsor’s act.",
  "verifier.verdictEnCours": "Not all scenarios have been seen yet: the version cannot be accepted yet.",
  "verifier.voirVersions": "See the version in Versions",
  "verifier.ecartRecette": "The overall verdict of the version (accepted / refused) is derived from the scenarios; the gateway does not record it as a separate act yet, and the list of plan cases is not published: a case outside the plan is refused by the gateway (TEST_SCOPE_MISMATCH).",
  "verifier.ongletCas": "Cases, plans and campaigns",
  "verifier.ongletNonRegression": "Non-regression",
  "verifier.ongletsTests": "Test sections",
  "verifier.etapeCas": "Case",
  "verifier.etapeScenario": "Scenario",
  "verifier.etapeCampagne": "Campaign",
  "verifier.etapeResultat": "Result",
  "verifier.etapeAnomalie": "Defect",
  "verifier.etapeVerification": "Fix verification",
  "verifier.etapeNonRegression": "Non-regression",
  "verifier.parcoursTesteur": "Tester journey",
  "verifier.concevoirTests": "Propose cases with AI",
  "verifier.concevoirTestsAide": "From coverage: pick a requirement without tests, then “Design tests” on its page.",
  "verifier.concevoirTestsRefus": "Proposing cases with AI is suspended while AI is stopped. Running campaigns remains possible.",
  "verifier.aVenir": "Coming (0.5.x)",
  "verifier.scenarioEnregistre": "Scenario saved",
  "verifier.casIntrouvable": "Case not found",
  "verifier.casIntrouvableAide": "This case does not exist in this project.",
  "verifier.retourTests": "Back to tests",
  "verifier.scenarioVide": "A scenario has at least one step.",
  "verifier.etapeSansAttendu": "Each step states what is expected: step {{n}} is incomplete.",
  "verifier.casFicheDescription": "Scenario, links and history of the case.",
  "verifier.genereIA": "generated by AI",
  "verifier.elementLie": "linked item #{{id}}",
  "verifier.scenarioTitre": "Scenario — steps and expected result",
  "verifier.scenarioAucun": "No step written: the case has no scenario yet.",
  "verifier.attendu": "expected: {{v}}",
  "verifier.editeurScenario": "Scenario editor",
  "verifier.etapeAction": "Step {{n}} — action",
  "verifier.etapeAttendu": "Step {{n}} — expected result",
  "verifier.monter": "Move step {{n}} up",
  "verifier.descendre": "Move step {{n}} down",
  "verifier.retirer": "Remove step {{n}}",
  "verifier.ajouterEtape": "Add a step",
  "verifier.enregistrerScenario": "Save the scenario",
  "verifier.resultatAttendu": "Expected result: {{v}}",
  "verifier.modifierScenario": "Edit the scenario",
  "verifier.executerDansCampagne": "Run in a campaign",
  "verifier.historiqueTitre": "Case history — latest execution per campaign",
  "verifier.historiqueChargement": "Reading the case results…",
  "verifier.historiqueErreur": "History unreadable: the gateway did not respond; the page stays displayed.",
  "verifier.jamaisExecute": "Never run: add this case to a campaign.",
  "verifier.lienResultat": "Result EXE-{{id}}",
  "verifier.nonRegressionTitre": "Non-regression",
  "verifier.nonRegressionDescription": "The current campaign compared with the last closed campaign: does what worked still work?",
  "verifier.nonRegressionChargementCampagnes": "Loading campaigns…",
  "verifier.nonRegressionErreur": "Comparison impossible: a campaign could not be read.",
  "verifier.nonRegressionVide": "No campaign to compare",
  "verifier.nonRegressionVideAide": "Open a campaign on a plan: its report is then compared with the previous one.",
  "verifier.ouvrirCampagne": "Open a campaign",
  "verifier.campagnesComparees": "Compared campaigns",
  "verifier.campagneCourante": "Current campaign",
  "verifier.campagneReference": "Reference (last closed)",
  "verifier.aucuneReference": "None",
  "verifier.rienAComparer": "Nothing to compare",
  "verifier.rienAComparerAide": "No campaign closed before this one: it becomes the reference once closed.",
  "verifier.comparaisonChargement": "Comparing campaigns #{{a}} and #{{b}}…",
  "verifier.syntheseNonRegression": "Summary",
  "verifier.regressionsNonAcceptees": "{{n}} regression(s) not accepted: “tests passed” cannot be written. Fix them, or accept them with a reason and a deadline.",
  "verifier.casNonExecutes": "No regression, but {{n}} case(s) not run: the comparison is incomplete.",
  "verifier.aucuneRegression": "No regression compared with campaign #{{r}}.",
  "verifier.avantApres": "campaign #{{r}}: {{a}} → campaign #{{c}}: {{b}}",
  "verifier.accepterMotif": "Accept (reason, deadline)",
  "verifier.accepterRegression": "Accept the regression",
  "verifier.motifObligatoire": "Reason (required)",
  "verifier.echeance": "Fix deadline (required)",
  "verifier.motifManquant": "Write the reason for the acceptance.",
  "verifier.echeanceManquante": "Set the fix deadline.",
  "verifier.echeancePassee": "The deadline cannot be in the past.",
  "verifier.verifierSaisie": "Check the entry",
  "verifier.acceptationNonEnregistree": "Entry complete, but the gateway does not record the acceptance of a regression yet (author, reason, deadline): nothing is accepted. The regression is still counted.",
  "verifier.ecartNonRegression": "Marked non-regression suite, reasoned acceptance of a regression and requirement at each candidate version: not carried by the gateway yet. The report above is computed from the real executions of both campaigns.",
  "verifier.resultatChargement": "Loading the result…",
  "verifier.resultatErreur": "Result unreadable: the gateway did not respond.",
  "verifier.resultatIntrouvable": "Execution not found",
  "verifier.resultatIntrouvableAide": "This execution does not belong to campaign #{{c}}.",
  "verifier.dejaDeclaree": "EXE-{{e}} already gave rise to ANO-{{a}}: a red execution gives rise to only one defect.",
  "verifier.executionVerte": "EXE-{{e}} is not red: nothing to declare from it. A free declaration is possible from the Defects screen.",
  "verifier.resultatTitre": "Result EXE-{{id}} — {{cas}}",
  "verifier.resultatDescription": "Campaign #{{c}} · verdict, duration, executor and next steps.",
  "verifier.verdict": "Verdict",
  "verifier.duree": "Duration",
  "verifier.executant": "Executor",
  "verifier.executantAgent": "colony · Docker runner",
  "verifier.executantHumain": "person",
  "verifier.executee": "Executed",
  "verifier.preuves": "Evidence",
  "verifier.etapesDuCas": "Case steps",
  "verifier.etapeEnEchecAVenir": "The failing step and the per-step actual result are not published by the runner yet: the verdict covers the whole case.",
  "verifier.suites": "Next steps",
  "verifier.ficheDuCas": "Case page {{cle}}",
  "verifier.anomalieLiee": "Linked defect: ANO-{{a}}",
  "verifier.voirNonRegression": "See non-regression",
  "verifier.natureCampagne": "Nature",
  "verifier.natureTechnique": "Regression or free campaign — run by the team",
  "verifier.natureRecette": "Business acceptance — run by the business",
  "verifier.natureRecetteAide": "Business acceptance is a campaign like the others: it counts in the case history and quality aggregates. Only a holder of “run a business acceptance” gives its verdict; no agent runs it.",
  "verifier.campagneLibreAide": "A free campaign certifies no version: it does not count for “ready?”.",
  "verifier.badgeRecette": "business acceptance",
  "verifier.ouvrirRecette": "Open the business acceptance",
  "verifier.rapportNonRegression": "Non-regression report",
  "verifier.anomaliesOuvertes": "{{n}} open, including {{v}} resolved to verify — a resolved defect counts as open until its reproduction is green again.",
  "verifier.regleCorrectif": "Rule: only a green execution of the reproduction case on a revision that contains the fix commit verifies the defect — never the date. Until verified, it counts as open.",
  "verifier.correctif": "Fix: {{ref}}",
  "verifier.ficheCasRepro": "Reproduction case page",
  "verifier.refusCorrectifAbsent": "No green execution of the reproduction case on a revision that contains the fix commit: the date is not enough (ARB-r2-13). Replay the case on a deployed revision that contains it.",
  "verifier.categorie.regression": "regression",
  "verifier.categorie.corrige": "fixed",
  "verifier.categorie.toujours-en-echec": "still failing",
  "verifier.categorie.nouveau": "new case",
  "verifier.categorie.non-execute": "not run",
  "verifier.categorie.stable": "stable",
  "verifier.etatRecette.a-faire": "to do",
  "verifier.etatRecette.en-cours": "in progress",
  "verifier.etatRecette.refusee": "refused",
  "verifier.etatRecette.accordee": "granted",
  "verifier.etatResolue": "resolved, to verify",
  "verifier.formAcceptationRegression": "Accept a regression",
  "planifier.porteeSprintServeur": "Counted by the gateway on the active sprint.",
  "planifier.wipReglageErreur": "Not computed by the gateway (reading the limits failed): setting unavailable. The counts above already follow the rule.",
  "planifier.wipInvalide": "{{col}}: a whole-number limit from 1 to 999, or empty for no limit.",
  "planifier.wipEnregistrer": "Save limits",
  "planifier.wipRefus": "Setting limits is reserved to the project owner or the holder of “backlog.wip_limits” (product owner).",
  "planifier.wipEnregistre": "Limits saved.",
  "vueProjet.repliErreur": "reading the gateway failed",
  "vueProjet.repliAbsent": "the gateway does not expose this aggregate",
  "vueProjet.santeNonCalculee": "Not computed by the gateway ({{raison}}): local estimate from the project reads; a signal without data stays “not applicable”, never green.",
  "vueProjet.jaugeNonCalculee": "Not computed by the gateway ({{raison}}): gauge estimated from the backlog only; “reopened” cannot be computed here.",
  "demandes.filiationRepli": "Not computed by the gateway: DEM-n requests (idea → framing → specification → application lineage) cannot be read there. A request is read here from its framing; the states “specified” to “delivered” and the resulting items are not established.",
  "pgmVue.santeTitre": "Health, stage and stack per project",
  "pgmVue.santeAucun": "No visible project in this programme.",
  "pgmVue.santeCaption": "Health, steps in progress and stack of the visible projects",
  "pgmVue.colProjet": "project",
  "pgmVue.colSante": "health",
  "pgmVue.colEtape": "steps in progress",
  "pgmVue.colPile": "stack",
  "pgmVue.pileAucune": "no stack decided",
  "pgmVue.partiel": "{{n}} project(s) could not be evaluated: the overview is partial.",
  "pgmVue.santeErreur": "Health and steps per project: not computed — the programme overview could not be read.",
  "planifier.dorServeur": "Definition of ready computed by the gateway: {{n}} / {{total}} feature(s) and stories ready. Size ≤ 32 K context and ≤ 400 lines: not evaluated yet.",
  "planifier.etatPrete": "ready",
  "planifier.etatNonPrete": "not ready",
  "verifier.regressionsToutesAcceptees": "{{n}} regression(s), all accepted with a reason and a deadline: they stay listed until fixed.",
  "verifier.regressionAcceptee": "accepted by {{qui}} ({{qualite}}) until {{date}}: {{motif}}",
  "verifier.motifCourt": "The reason must be at least 10 characters long.",
  "verifier.accepterRefus": "Refused: accepting a regression is reserved to the project owner or the holder of “regression.accept”.",
  "demandes.colEtape": "stage",
  "demandes.piedServeur": "{{n}} requests · numbered DEM-n by the gateway, in filing order",
  "demandes.filDeposeeServeur": "filed by {{qui}} on {{quand}}",
  "demandes.abandon": "abandoned: {{m}}",
  "demandes.filEtapes": "Lifecycle steps of the request",
  "demandes.filItemsAucun": "No item has come out of this request yet.",
  "demandes.filSpecs": "{{n}} linked specification(s)",
  "demandes.ouvrirSpecs": "Specifications",
  "demandes.filMissions": "Missions",
  "demandes.filVersions": "Versions",
  "demandes.filAttend": "Waiting for: {{a}}.",
  "demandes.filOuvrirEtape": "Open: {{e}}",
  "demandes.introuvableHintServeur": "It does not exist, or you are not a member of its project.",
  "nav.vueProjet": "Project view",
  "projet.onglets": "Project views",
  "app.marqueAria": "DoIt — {{org}}: go to home",
  "app.deployeLe": "deployed on",
  "n28.objet": "object:",
  "projet.vue.activite": "Activity",
  "projet.vue.indicateurs": "Indicators",
  "admin.operationsHealthBlockedPublications": "Blocked publications",
  "adr.card.ruleOptions": "Rule: an ADR compares at least 2 options (currently: {{n}}).",
  "adr.card.ruleOptionsAdd": "Add an option to the matrix before deciding.",
  "adr.card.ruleOptionsG4": "Rule: the G4 gate requires at least 3 compared options (currently: {{n}}).",
  "adr.stack.askPlatformAdmin": "The platform administrator records it in Platform › Qualified generation profiles.",
  "adr.stack.noneProposable": "No stack can be proposed yet: a stack ADR cannot be decided until a measured qualification is recorded.",
  "adr.stack.toQualification": "Record a qualification (Platform › Qualified generation profiles)",
  "design.flow.prerequis": "Prerequisite: ACCEPTED backlog items derived from this specification (generate the backlog from the approved specification, then accept its items). Without them, the proposal fails.",
  "design.flow.prerequisManquant": "Missing prerequisite: no accepted backlog item in this project. The screen flow serves ACCEPTED requirements: generate the backlog from the approved specification, accept its items, then come back to propose the flow.",
  "generation.carte": "Generation card",
  "generation.catalogue": "Catalogue stacks and measured generability",
  "generation.enregistrer": "Record a measured qualification",
  "generation.envoyer": "Record the qualification",
  "generation.invalid": "invalid receipt",
  "generation.modele": "Measured model",
  "generation.notQualified": "not qualified",
  "generation.ok": "Qualification recorded: the catalogue above is reloaded.",
  "generation.passes": "Passed cases",
  "generation.pile": "Stack",
  "generation.qualified": "qualified (all golden cases pass)",
  "generation.recu": "Measurement receipt (report fingerprint)",
  "generation.regle": "A stack can be proposed in a stack ADR if and only if its latest measured qualification is “qualified”: all its draws pass every judge, except the generated application’s delivered tests, which must pass in at least 75% of draws after repair (same rule as the card).",
  "generation.source": "Report the result of the generability bench (scripts/doit/mesurer_generabilite.py): the receipt is the fingerprint of its report. Each record is appended to the history, never modified.",
  "generation.statut": "Measured status",
  "generation.total": "Executed cases",
  "generation.version": "Card version",
  "specs.publicationAttente": "not published — publication pending",
  "specs.publicationBloquee": "not published — publication blocked",
  "specs.publicationEchec": "not published — publication failing",
  "specs.demandesModification": "Change requests",
  "specs.videCadree": "No approved specification yet",
  "specs.videCadreeHint": "{{n}} approved framing document(s) await their specification: draft it from the request, or decide the pending one in the approval center.",
  "specs.versDemandes": "See framed requests",
  "specs.versApprobations": "Approval center",
  "approvals.publicationBlockedAt": "Blocked on {{date}}",
  "missions.plan.normCreated": "(task created by the normalisation)",
  "missions.plan.normMove": "criterion {{c}} moved from {{de}} to {{vers}}",
  "missions.plan.normTask": "task {{rang}} “{{titre}}”",
  "missions.plan.normTaskId": "task {{id}}",
  "missions.plan.normTitle": "The plan was normalised by the runtime before your review",
  "missions.plan.normWhy": "An acceptance criterion is tested in the task that builds its item: those the queen had placed elsewhere were moved. Nothing else was changed.",
  "tests.campaignDeclareEnvironment": "Declare an environment",
  "tests.campaignEnvironmentsUnreadable": "Environments could not be read: the campaign cannot choose where to run. Reload the page; if the refusal persists, see “Environments and deployments”.",
  "tests.campaignNoEnvironment": "No environment declared in this project: a campaign, business acceptance included, always runs on an environment.",
  "tests.campaignNoEnvironmentHow": "Declare one in “Environments and deployments” (“Declare a tier” button): the tier needs a Compose file, and an active application executor on a host worker to start it.",
  "tests.noEnvironmentOption": "No environment declared",
  "versions.field.commitHelp": "Filled in by the chosen revision; can be edited by hand.",
  "versions.field.publishedChoose": "Choose a published revision…",
  "versions.field.publishedError": "Published revisions could not be read: type the commit by hand.",
  "versions.field.publishedLoading": "Loading published revisions…",
  "versions.field.publishedNone": "No published revision in this project: a revision is published when its approval is published (“Published — commit …”). Type the commit by hand.",
  "versions.field.publishedRevision": "Published revision",
  "admin.colRecette": "Run an acceptance",
  "admin.recetteAttributionsIllisibles": "The project’s permission grants (run an acceptance test, accept a regression, work-in-progress limits) could not be read.",
  "admin.recetteCaseAria": "Run an acceptance: {{u}}",
  "admin.recetteAide": "“Run an acceptance”: record the verdict of a business acceptance. No role grants it by default; tick it for a member, viewers included (business profile). Every grant is audited.",
  "admin.rbacLectureSeule": "Read only: an organisation’s matrix is changed by its administrator. For business acceptance, the project owner or the organisation’s administration grants “run an acceptance test” to a member in Project settings › Members.",
  "runops.refusVersionNonApprouvee": "Version “{{s}}”: only an approved version can be deployed. Move it to candidate, then get its deployment approved (Versions screen).",
  "runops.refusVersionNonApprouveeEnv": "Version not approved for this environment: request its approval (Versions screen).",
  "verifier.ecartRecetteVerdict": "The overall verdict of the version (accepted / refused) is derived from the scenarios; the gateway does not record it as a separate act yet.",
  "missions.evidence.notBuiltShort": "None: the application was not built",
  "missions.evidence.notStartedShort": "None: the application did not start",
  "missions.evidence.notBuilt": "The application was not built in round {{r}}: the hidden tests could not run.",
  "missions.evidence.notStarted": "The application did not start in round {{r}}: the hidden tests could not run.",
  "missions.evidence.startNoDetail": "The runtime posted no reason for this round.",
  "missions.evidence.failedTests": "Red tests of the last round · {{n}}",
  "missions.evidence.attemptCurrent": "Attempt {{n}} (current)",
  "missions.evidence.attempt": "Attempt {{n}}",
  "missions.evidence.reopenedOtherFamily": "Reopened by a human: handed to another model family.",
  "missions.evidence.reopenedReorient": "Reopened by a human (reorientation), instruction:",
  "missions.evidence.roundNotBuilt": "not built: no test",
  "missions.evidence.roundNotStarted": "application did not start: no test",
  "missions.evidence.admission": "admission refused: {{m}}",
  "missions.evidence.designRefusedThenAccepted": "Hidden test design, attempt {{a}}: suite refused by the judges; redesigned and accepted at attempt {{b}}.",
  "missions.evidence.designRefused": "Hidden test design, attempt {{a}}: suite refused by the judges.",
  "missions.evidence.judgesProblems": "Judges’ reasons",
  "missions.decision.closed": "Mission ended: no decision is expected any more. {{n}} stopped task(s) stay as they are.",
  "missions.cockpit.escalationsLeft": "Escalations left: {{r}} of {{n}}",
  "dod.aucunCandidat": "No unlinked case in this project: create one in ",
  "dod.chargementCas": "Loading cases…",
  "dod.choisirCas": "Choose an unlinked case",
  "dod.derniereExecution": "latest run: {{v}}",
  "dod.jamaisExecute": "never run",
  "dod.manquant": "missing",
  "dod.nonRemplie": "not met",
  "dod.refusAvantClic": "Moving to “{{fin}}” will be refused while a criterion is missing.",
  "dod.relier": "Link this case to the story",
  "dod.relierLibelle": "Acceptance case or test that proves the story",
  "dod.rempli": "met",
  "dod.remplie": "met",
  "dod.tests": "Tests",
  "dod.titre": "Definition of Done",
  "livrer.signatureEchec": "Build or signing failed: {{erreur}}",
  "livrer.signatureEnCours": "Build requested (job {{job}}): the worker builds the image, produces the SBOM and signs the provenance.",
  "livrer.signatureFaite": "Image, SBOM and signature recorded in the revision registry.",
  "livrer.signatureRefus": "Reserved to members who act on the project (owner or contributor).",
  "livrer.signerRevision": "Build and sign revision {{rev}}",
  "tests.clotureEchec": "Closing refused by the gateway: {{motif}}",
  "tests.clotureRefusee": "Cannot close, exit criteria not met: {{liste}}.",
  "verifier.envoyerConforme": "Declare compliant",
  "verifier.etapes": "Steps",
  "verifier.preuveExemple": "For example: {{attendu}} — obtained as is",
  "verifier.preuveLien": "Link to a screenshot or document (optional)",
  "verifier.preuveLienInvalide": "The link must start with http:// or https://.",
  "verifier.preuveRequise": "A “compliant” verdict needs proof: describe what you observed, or attach a link to a screenshot.",
  "verifier.preuveRequiseServeur": "The gateway requires proof: describe what you observed or attach a link.",
  "verifier.resultatAttenduAbsent": "Expected result not set on the case: ask the team before judging.",
  "verifier.votrePreuve": "What you observed",
  "anomalies.missionFix.title": "Fix in a mission",
  "anomalies.missionFix.help": "The colony reproduces the defect (red test), fixes the delivered application, then marks it “resolved” when the fix is delivered; verification stays yours.",
  "anomalies.missionFix.base": "Base: application “{{app}}”, last delivered revision {{rev}}.",
  "anomalies.missionFix.launch": "Fix in a mission",
  "anomalies.missionFix.missions": "Missions that carried it",
  "anomalies.missionFix.task": "task: {{s}}",
  "missions.form.errApplication": "Choose the application to evolve.",
  "missions.form.defectsToTriage": "{{n}} “new” defect(s) to triage first (Defects screen): a mission only fixes a defect triaged as “product”.",
  "missions.form.application": "Application to evolve",
  "missions.form.baseChoice": "Base revision",
  "missions.form.baseDefault": "Default: the revision of the version where the defects were found, otherwise the latest",
  "missions.form.baseRevision": "Works on application “{{app}}”, starting from its last delivered revision {{rev}}.",
  "missions.form.noApplication": "No delivered application in this project: a sprint or a fix evolves an application that was already generated and delivered.",
  "approvals.humanEditTitle": "Manual edit — no prompt",
  "approvals.humanEditAuthor": "Written by hand by {{author}}, from",
  "approvals.humanEditHint": "The source of this version is the artifact it was edited from: the comparison below shows what the author changed. The author cannot approve their own edit.",
  "approvals.humanEditNoJob": "No generation: content written by hand by {{author}}. There is no job to run; publication follows approval.",
  "approvals.regenFailed": "Regeneration failed: no new version will come back for approval.",
  "approvals.regenFailedUnknown": "The worker did not report a cause.",
  "approvals.regenKeptDrift": "The instructions asked to keep these items; this version changed them:",
  "approvals.regenKeptRemoved": "removed",
  "approvals.regenKeptChanged": "changed",
  "approvals.regenLimit": "{{n}} / {{max}} characters — beyond that the instructions are refused; long instructions can also exceed the model context window.",
  "approvals.specGateAxisBelow": "below 9",
  "approvals.specGateFindingLines": "document, lines {{lines}}",
  "approvals.specGateReasonScore": "Overall score {{score}} below the threshold of 9 (see the axes above)",
  "approvals.specGateReasonVerdict": "The model reviewer did not return a “pass” verdict",
  "approvals.specGateReasonCritical": "At least one critical finding (listed below)",
  "approvals.specGateReasonChecks": "At least one of the 13 checks failed",
  "approvals.specGateReasonSourceBlockers": "The source carries blocking points",
  "approvals.specGateReasonBlockers": "Blocking points are not resolved in the document",
  "approvals.specGateSeverityCritical": "Critical",
  "approvals.specGateSeverityHigh": "High",
  "missions.form.specOption": "{{fichier}} — v{{version}} · approval #{{id}} · approved on {{date}}{{dossier}}",
  "missions.decision.redesignTests": "Have the hidden tests redesigned",
  "missions.decision.effect.takeOver": "The task is cancelled and leaves the colony: you carry it out yourself, outside the tool. {{n}} task(s) depending on it will be cancelled.",
  "missions.decision.effect.reorient": "The task is reopened: the worker resumes with your instruction, against the SAME hidden tests. One more reopening (two at most); a new stop uses one escalation.",
  "missions.decision.effect.redesignTests": "The task is reopened: the verifier redesigns the hidden tests from the red tests (and your optional instruction), then the worker resumes. Choose it when tests contradict each other, depend on their order or drive the screen wrongly.",
  "missions.decision.effect.otherFamily": "The task is reopened and handed, once, to a model of another family (general_agent), against the same hidden tests.",
  "missions.decision.effect.acceptStop": "The task stays stopped, with no new attempt. {{n}} task(s) depending on it will be cancelled.",
  "missions.decision.effect.acknowledge": "The escalation is closed; the mission resumes where it was.",
  "missions.decision.errReorientTask": "Reorienting “{{titre}}” requires an instruction: write it in this task’s box, nothing was sent.",
  "missions.decision.effect.refusedCap": "Refused: task already reopened twice.",
  "missions.decision.effect.acceptAllStops": "All stopped tasks stay stopped, with no new attempt; {{c}} task(s) blocked by these stops are cancelled; the mission is closed without merging and the application is freed for a new mission.",
  "missions.decision.suiteSuspectNoReco": "The hidden tests look at fault ({{r}}): {{tests}}. Redesign is no longer possible (task already reopened twice).",
  "missions.evidence.suiteSuspectRefused": "Redesign is no longer possible: task already reopened twice.",
  "missions.evidence.suiteAppSide": "Attributed to the application (it answered an error): {{tests}}.",
  "missions.decision.suiteSuspect": "The hidden tests look at fault ({{r}}): {{tests}}. Recommended decision: “Have the hidden tests redesigned”.",
  "missions.decision.confirmTitle": "Confirm “{{d}}”?",
  "missions.decision.confirmCancelled": "These tasks, which depend on it, will be CANCELLED:",
  "missions.decision.confirmNoCancel": "No task depends on this one.",
  "missions.decision.confirmMissionEnds": "No other task can succeed any more: the mission will stop. Its cause will remain this task’s stop without convergence.",
  "missions.decision.confirmYes": "Confirm",
  "missions.decision.confirmNo": "Cancel",
  "missions.decision.suspect.order_dependent": "tests depend on their order",
  "missions.decision.suspect.test_defect": "a test fails by its own fault",
  "missions.decision.suspect.red_every_attempt": "same test red at every attempt",
  "missions.decision.suspect.reds_trade_places": "fixing one test breaks another",
  "missions.evidence.failedTestsRedFirst": "Red tests measured before the first round (red first) · {{n}}",
  "missions.evidence.isolationTitle": "Isolation of the hidden tests",
  "missions.evidence.isolationRerun": "{{n}} red test(s) re-run alone on a fresh application.",
  "missions.evidence.orderDependent": "Red with the other tests, green alone: they depend on the order. Defect of the suite, not of the application — counted green.",
  "missions.evidence.isolationInterrupted": "Re-runs interrupted: {{m}}",
  "missions.evidence.suiteSuspect": "The hidden tests look at fault: {{r}}.",
  "missions.evidence.suiteSuspectAction": "Recommended decision in the cockpit: “Have the hidden tests redesigned”.",
  "missions.evidence.hiddenSuite": "Hidden tests designed by the verifier · {{n}}",
  "missions.evidence.hiddenSuiteNone": "No hidden suite admitted for this task.",
  "missions.evidence.kindBrowser": "browser",
  "missions.evidence.kindHttp": "HTTP",
  "missions.evidence.interfaceUsed": "Interface used: {{i}}",
  "missions.evidence.uncovered": "Criteria declared uncovered: {{u}}",
  "missions.evidence.none": "none",
  "missions.evidence.suiteModel": "Designed by {{m}} · fingerprint {{s}}",
  "missions.evidence.hiddenSuiteRecette": "Hidden tests: the case's acceptance test, validated by a person · {{n}}",
  "missions.evidence.kindRecette": "acceptance",
  "missions.evidence.recetteOrigin": "Acceptance test of case {{k}} “{{nom}}”, validated by {{v}} on {{d}} — used as is: no design by the model, no design judge; only red-first is required.",
  "missions.evidence.recetteRefusal": "Refused as hidden test: {{c}} — {{m}}",
  "missions.evidence.suiteSuspectRecette": "The suite is the validated acceptance test of case {{k}}: the model does not redesign it. Review it (and fix it if needed) from the case page, have it validated, then reopen the task.",
  "missions.obj.testsDesign": "{{n}} hidden test(s) designed · criteria {{c}} · interface {{i}}",
  "missions.obj.stopCause": "stop: {{r}} — cause: {{c}}",
  "missions.obj.stopCauseItem": "task {{k}} ({{m}})",
  "missions.obj.testsRecette": "acceptance test of case {{k}}, validated by {{v}} on {{d}} · {{n}} hidden test(s) as is",
  "missions.reason.withCause": "{{m}} — cause: {{c}}",
  "missions.reason.causeItem": "task {{k}} stopped ({{r}})",
  "missions.form.specBacklog": "{{n}} accepted backlog item(s) from this specification: the queen plans from them.",
  "missions.form.backlogPending": "The backlog of this specification awaits approval ({{n}} pending item(s)): have it approved, then launch the mission.",
  "missions.form.backlogMissing": "No accepted backlog item from this specification: generate the backlog from its approval (“Generate the backlog”), have it approved, then launch the mission.",
  "missions.form.openApprovals": "Open the approvals",
  "missions.form.generateBacklog": "Generate the backlog of this specification",
  "livrer.resignerRevision": "Rebuild and re-sign revision {{rev}}",
  "livrer.resignerTitreOk": "Rebuild and re-sign (if the image was purged from the host since this check)",
  "livrer.imageAbsente": "Image missing from the host",
  "runops.ouvrirApplication": "Open the application",
  "runops.conteneur": "container",
  "runops.composeTargetBranche": "Git branch the Compose file is published to",
  "runops.composeTargetAide": "Git branch where “Publish the Compose file” writes it; unrelated to tier names.",
  "livrer.enServiceDescriptionPalier": "The version in service on the highest deployed tier, its probe, its documentation and its continuity.",
  "verifier.candidatsRevision": "{{n}} green execution(s) of the reproduction case on a revision that contains the fix:",
  "anomalies.preuveRevision": "revision {{rev}} · tree {{arbre}}",
  "anomalies.preuveArbre": "tree {{arbre}}",
  "verifier.correctifRevision": "Fix revision: {{rev}}",
  "verifier.versSuiteTnr": "The cases required for every candidate version make up the",
  "verifier.suiteTnrLien": "regression suite",
  "verifier.ecartNonRegressionAcceptation": "This gateway does not record the reasoned acceptance of a regression. The report above is computed from the actual executions of both campaigns.",
  "verifier.ongletSuiteTnr": "Regression suite",
  "tnr.ouvrirVersions": "Open versions",
  "tnr.designee": "Regression suite saved",
  "tnr.nCas": "{{n}} case(s)",
  "tnr.origineAnomalie": "Fixed defect",
  "tnr.origineExigence": "Delivered requirement",
  "tnr.livreeDans": "delivered in {{v}}",
  "tnr.origineManuelle": "Manual addition",
  "tnr.origineInconnue": "Origin not traced (existing plan)",
  "tnr.casAjoute": "Case added to the regression suite",
  "tnr.casRetire": "Case removed from the suite",
  "tnr.retirerTitre": "Remove {{cas}} from the regression suite?",
  "tnr.retirerConsequence": "The case will no longer be required for every candidate version. Its execution history stays intact.",
  "tnr.retirerReversible": "You can add it again, with its origin.",
  "tnr.retirer": "Remove from the suite",
  "tnr.retirerMotif": "Why is this case leaving the suite? (required)",
  "tnr.retirerDesignationTitre": "Should the “{{plan}}” plan stop being the regression suite?",
  "tnr.retirerDesignationConsequence": "No candidate version will require a regression run until another plan is designated.",
  "tnr.retirerDesignationReversible": "The plan and its cases stay intact; you can designate it again.",
  "tnr.retirerDesignation": "Remove the designation",
  "tnr.designerForm": "Designate the suite's plan",
  "tnr.planPorteur": "Plan carrying the suite",
  "tnr.choisirPlan": "Choose a plan…",
  "tnr.changerPlan": "Make this plan the suite",
  "tnr.designer": "Designate as regression suite",
  "tnr.titre": "Regression suite",
  "tnr.description": "The cases replayed for every candidate version: what was delivered or fixed must not break again.",
  "tnr.chargement": "Loading the regression suite…",
  "tnr.erreur": "Regression suite unreadable: the gateway did not respond.",
  "tnr.lectureSeule": "Read only: the suite is edited by a project owner or contributor.",
  "tnr.aucuneSuite": "No regression suite designated",
  "tnr.aucuneSuiteAide": "Designate the test plan that carries it: its cases will be required for every candidate version.",
  "tnr.planTitre": "Carrying plan",
  "tnr.casTitre": "Suite cases",
  "tnr.suiteVide": "The suite contains no case yet",
  "tnr.suiteVideAide": "Add the cases proposed below, or a case chosen by hand.",
  "tnr.colCas": "Case",
  "tnr.colOrigine": "Origin",
  "tnr.colAjout": "Added",
  "tnr.colDerniere": "Last execution on the suite",
  "tnr.colActions": "Actions",
  "tnr.jamaisExecute": "never run on the suite",
  "tnr.ajoutManuel": "Add a case by hand",
  "tnr.choisirCas": "Choose a case…",
  "tnr.ajouter": "Add to the suite",
  "tnr.propositionsTitre": "Cases proposed for addition",
  "tnr.propositionsAide": "The case of a verified defect protects its fix; the case of a delivered and verified requirement protects the delivery. Nothing enters the suite without your action.",
  "tnr.aucuneProposition": "No proposal",
  "tnr.aucunePropositionAide": "They come from the verification of a defect and the certification of a version.",
  "tnr.ajoutSansSuite": "Designate the suite's plan first.",
  "tnr.versionsTitre": "Required for every candidate version",
  "tnr.aucuneVersion": "No version in preparation",
  "tnr.aucuneVersionAide": "A version is prepared in Delivery › Versions.",
  "tnr.horsCycle": "outside the cycle",
  "tnr.executee": "suite started",
  "tnr.campagne": "Campaign #{{id}} ({{statut}})",
  "tnr.aExecuter": "to run: “Ready?” blocks",
  "tnr.dejaDansSuite": "The case that verified the fix is in the",
  "tnr.anomalieSansSuite": "The project has no regression suite yet to protect this fix:",
  "tnr.designerLien": "designate it",
  "tnr.proposerAnomalie": "Protect this fix: add the case that verified it to the regression suite.",
  "tnr.proposeLecture": "This case is proposed for the regression suite; a contributor can add it.",
  "tnr.refAnomalie": "ANO-{{id}}",
  "adr.card.decideOpen": "Decide…",
  "adr.card.decidedBy": "Decided by {{who}} on {{when}}",
  "adr.card.decisionComment": "Decision comment: {{c}}",
  "adr.card.optionExcluded": "This option is excluded by a mandatory criterion: it cannot be chosen.",
  "adr.matrix.outOfCatalog": "out of catalogue",
  "adr.matrix.reason.mandatoryFailed": "Fails the mandatory criterion “{{criterion}}”",
  "adr.matrix.reason.outOfCatalog": "Option outside the stack catalogue",
  "adr.matrix.unmeasured": "not qualified",
  "adr.stack.batch": "batch {{lot}}",
  "adr.stack.bench": "bench {{rev}}",
  "adr.stack.draws": "{{cases}} cases × {{draws}} draw(s)",
  "adr.stack.deliveredRate": "qualified — delivered tests {{passed}}/{{total}} ({{pct}}% ≥ {{seuil}}%)",
  "adr.stack.deliveredAbove": "delivered tests {{passed}}/{{total}} ({{pct}}% ≥ {{seuil}}%)",
  "adr.stack.deliveredBelow": "delivered tests {{passed}}/{{total}} ({{pct}}% < {{seuil}}%)",
  "adr.stack.drawsOnly": "{{draws}} draw(s) per case",
  "adr.stack.noneQualified": "No stack has passed all its golden cases: a stack ADR cannot be decided yet. Fix the generation of the target stack, then re-measure it on the bench and record the new qualification.",
  "adr.stack.reason.invalid": "Last qualification receipt is invalid ({{mesure}})",
  "adr.stack.reason.measure": "{{passed}}/{{total}} golden cases, {{model}}",
  "adr.stack.reason.notQualified": "Stack not qualified ({{mesure}})",
  "adr.stack.reason.unmeasured": "No qualified golden case for this stack (generability not measured)",
  "approvals.attestationRequiredApprove": "Tick “I have reviewed the content” before approving.",
  "approvals.attestationRequiredReject": "Tick “I have reviewed the content” before rejecting: a rejection commits your review.",
  "approvals.regenHint2": "Describe the expected revision; the job receives the original input, your instruction and THIS version as the previous version (manual edits included). The new version will replace this one.",
  "approvals.statusSuperseded": "Superseded",
  "approvals.supersededPending": "This version was superseded by a newer one (regeneration or edit): decide the latest version instead, in the list.",
  "approvals.commentLabelRisk": "Comment (required to approve despite the reservation, and for a rejection)",
  "approvals.reasonHintRisk": "Add a reason: it is required to approve despite the reservation, as for a rejection.",
  "approvals.regenEtat.pending": "Status: queued — the worker has not picked it up yet.",
  "approvals.regenEtat.processing": "Status: generation in progress.",
  "approvals.regenEtat.workerLost": "Status: the worker no longer responds — the generation can be relaunched from the history.",
  "approvals.regenEtat.done": "Status: finished — the new version awaits its decision in the list.",
  "approvals.regenEtat.failed": "Status: failed.",
  "approvals.regenEtat.unknown": "Status: reading…",
  "generation.distincts": "Distinct cases (optional)",
  "generation.lot": "Batch (optional)",
  "generation.revisionBanc": "Bench source revision (optional)",
  "generation.tirages": "Draws per case (optional)",
  "item.statusFinal": "No transition is allowed from “{{actuel}}”.",
  "item.statusNext": "From “{{actuel}}”, the workflow allows: {{suivants}}.",
  "item.gererClassement": "Manage the project's labels, components and versions",
  "axesItem.titre": "Portfolio axes",
  "axesItem.chargement": "Loading axes…",
  "axesItem.vide": "Attached to no axis: it appears in no impact analysis or duplicate search.",
  "axesItem.detacher": "Detach from the {{nom}} axis",
  "axesItem.rattacher": "Attach to an axis",
  "axesItem.choisir": "Choose an axis…",
  "axesItem.ajouter": "Attach",
  "axesItem.gerer": "Manage axes and see probable duplicates",
  "gestes.raisons": "What prevents it",
  "gestes.supprime": "Item deleted",
  "gestes.supprConsequence": "Item #{{id}} “{{titre}}”, its comments, attachments and links are deleted.",
  "gestes.supprDescendants": "Its {{n}} descendant(s) are deleted with it.",
  "gestes.supprCas": "{{n}} test case(s) will no longer be attached to an item.",
  "gestes.supprTitre": "Delete item #{{id}}?",
  "gestes.supprIrreversible": "No restore: the deletion is recorded in the audit log.",
  "gestes.supprimer": "Delete the item",
  "gestes.supprAttestation": "I am also deleting the {{n}} descendant(s).",
  "gestes.supprSection": "Delete the item",
  "gestes.verification": "Checking…",
  "gestes.descendants": "{{n}} descendant(s) will be deleted with it.",
  "gestes.lectureSeule": "Reserved for project owners and contributors.",
  "gestes.fusionne": "Duplicate merged: the kept item took over everything",
  "gestes.fusionTitre": "Merge #{{source}} into #{{cible}}?",
  "gestes.fusionDeplace": "#{{cible}} “{{titre}}” takes over {{enfants}} child(ren), {{com}} comment(s), labels, axes, links and test cases.",
  "gestes.fusionSupprime": "#{{source}} “{{titre}}” is deleted; its snapshot (title, description, criteria, author, reason) is kept.",
  "gestes.fusionIrreversible": "No automatic un-merge: the snapshot lets you recreate the item by hand.",
  "gestes.fusionner": "Merge",
  "gestes.fusionSection": "Merge this duplicate into another item",
  "gestes.fusionAucunCandidat": "No other item of the same type in this project: nothing to merge.",
  "gestes.fusionCible": "Kept item (same type)",
  "gestes.fusionChoisir": "Choose the kept item…",
  "gestes.apercu": "Merge preview…",
  "gestes.fusionVers": "Into",
  "gestes.fusionCompte": "Moved: {{enfants}} child(ren), {{com}} comment(s), {{pj}} attachment(s), {{lab}} label(s), {{axes}} axis(es), {{liens}} link(s), {{cas}} test case(s), {{ano}} defect(s).",
  "gestes.fusionMotif": "Why is it a duplicate? (required)",
  "gestes.fusionMotifCourt": "Write the reason (at least 5 characters).",
  "gestes.absorbes": "Duplicates absorbed by this item",
  "gestes.code.BACKLOG_ITEM_IN_ACTIVE_SPRINT": "The item or a descendant is committed to an active sprint: remove it from the sprint first",
  "gestes.code.BACKLOG_ITEM_IN_RELEASE": "The item or a descendant is part of a version's content: remove it from the version first",
  "gestes.code.BACKLOG_ITEM_REFERENCED": "The item or a descendant is referenced by a service incident",
  "job.appTreeWritten": "Application written",
  "job.backlogInserted": "Backlog items added",
  "job.badgePublicationBlocked": "Publication blocked",
  "job.block.git": "diverging repository",
  "job.block.other": "reason not specified",
  "job.block.plan": "diverging publication plan",
  "job.block.projection": "diverging version kept",
  "job.block.snapshot": "invalid approved content",
  "job.deploymentStarted": "Deployment in progress",
  "job.deploymentSucceeded": "Deployment succeeded",
  "job.files": "file(s)",
  "job.keptChanged": "Requirements to keep have changed (see the warning)",
  "job.otherStep": "Technical step: {{code}}",
  "job.previewFailed": "Preview failed",
  "job.previewRunning": "Preview running",
  "job.previewStarting": "Preview starting",
  "job.previewStopped": "Preview stopped",
  "job.publicationBlocked": "Publication blocked, another attempt is scheduled",
  "job.publicationTerminalBlocked": "Publication permanently blocked",
  "job.reviewSubmitted": "Independent review submitted",
  "job.signed": "Revision signed",
  "job.signingStarted": "Building and signing the revision",
  "job.specGateDone": "Spec Gate evaluated",
  "job.specGateStarted": "Spec Gate evaluation in progress",
  "job.stackResolved": "Stack selected",
  "job.revisionInstructionsOmitted": "(left out by the limit: {{versions}})",
  "job.revisionInstructionsResolved": "Previous instructions attached",
  "job.templateLeakRefused": "Output refused: unresolved template lines",
  "job.templateLeakRepair": "Template lines detected: repair attempted",
  "job.terminalFailed": "Processing ended in failure",
  "job.terminalSucceeded": "Processing finished",
  "launchedJobs.cause": "Cause: {{cause}}",
  "launchedJobs.causeUnknown": "not reported by the worker",
  "launchedJobs.done": "Done",
  "launchedJobs.failed": "Failed",
  "launchedJobs.failedAppHint": "No application will come back for approval from this launch; you can launch the generation again.",
  "launchedJobs.failedHint": "No new version will come back for approval from this launch.",
  "launchedJobs.running": "In progress",
  "launchedJobs.title": "Work launched from this request",
  "launchedJobs.type.backlog": "Backlog generation",
  "launchedJobs.type.designFlow": "Screen flow",
  "launchedJobs.type.epics": "Epic generation",
  "launchedJobs.type.framing": "Framing",
  "launchedJobs.type.options": "Options proposal",
  "launchedJobs.type.other": "Job {{type}}",
  "launchedJobs.type.personas": "Persona generation",
  "launchedJobs.type.processes": "Process mapping",
  "launchedJobs.type.scaffoldApp": "Application generation",
  "launchedJobs.type.spec": "Specification drafting",
  "launchedJobs.type.specGate": "Spec Gate evaluation",
  "launchedJobs.workerLost": "Worker lost",
  "revision.rejected": "approval rejected",
  "revision.rejectedInReview": "rejected in review",
  "tests.cancelEchec": "Cancellation refused by the gateway: {{motif}}",
  "tests.cancelReasonRequired": "Enter the cancellation reason: it is mandatory and stays in the campaign log.",
  "tests.ouvrirPlan": "Open the {{nom}} plan page",
  "planFiche.campagne": "Campaign #{{id}}",
  "planFiche.masquerExecutions": "Hide executions",
  "planFiche.voirExecutions": "Show executions",
  "planFiche.chargementExecutions": "Loading executions…",
  "planFiche.aucuneExecution": "No execution in this campaign",
  "planFiche.aucuneExecutionAide": "Executions come from the step-by-step runner or the automated runner.",
  "planFiche.executions": "Executions",
  "planFiche.retour": "Back to plans and campaigns",
  "planFiche.invalide": "Plan not found",
  "planFiche.invalideAide": "The link does not point to a plan.",
  "planFiche.chargement": "Loading the plan…",
  "planFiche.introuvable": "Plan not found",
  "planFiche.introuvableAide": "This plan does not exist in the open project.",
  "planFiche.erreur": "Plan unreadable: the gateway did not respond.",
  "planFiche.titre": "Test plan — {{nom}}",
  "planFiche.description": "The plan's cases, published versions and campaigns opened on this plan.",
  "planFiche.estSuite": "This plan is the project's regression suite",
  "planFiche.designerSuite": "Make it the regression suite",
  "planFiche.cas": "Plan cases ({{n}})",
  "planFiche.aucunCas": "No case in this plan",
  "planFiche.aucunCasAide": "Attach cases from the case list (Tests › Cases, plans and campaigns).",
  "planFiche.versCas": "Open cases",
  "planFiche.versions": "Published versions",
  "planFiche.chargementVersions": "Loading versions…",
  "planFiche.aucuneVersion": "No published version",
  "planFiche.aucuneVersionAide": "A version freezes the list of cases for a campaign: “Publish a version” in Tests.",
  "planFiche.campagnes": "Campaigns on this plan",
  "planFiche.chargementCampagnes": "Loading campaigns…",
  "planFiche.aucuneCampagne": "No campaign on this plan",
  "planFiche.aucuneCampagneAide": "Open a campaign from Tests › Plans and campaigns.",
  "versions.removeConfirmConsequence": "The item will no longer be part of this version; it remains available to be attached again.",
  "versions.removeConfirmTitle": "Remove “{{objet}}” from the content of {{version}}?",
  "versions.removeConfirmVerb": "Remove",
  "vueProjet.casDores": "{{passed}} / {{total}} golden cases",
  "vueProjet.indicateursFlux05x": "Indicators: the technology change flow is designed and delivered after v0.5.0 — this measurement does not exist in the gateway yet.",
  "vueProjet.pileNonQualifiee": "not qualified",
  "vueProjet.pileQualifiee": "qualified",
  "apercu.restart.action": "Restart",
  "apercu.restart.failed": "Restart failed: {{cause}}",
  "apercu.restart.hint": "Recreates the preview containers while keeping its data volume: to test “data survives a restart”.",
  "apercu.restart.noCause": "cause not reported",
  "apercu.restart.noVolume": "No data volume: this preview's data was lost on restart.",
  "apercu.restart.recreated": "Containers recreated (proven): {{avant}} → {{apres}}.",
  "apercu.restart.running": "Restart in progress: the preview containers are being recreated…",
  "apercu.restart.unverified": "Recreation could not be verified (containers unreadable): {{avant}} → {{apres}}.",
  "apercu.restart.volume": "Data kept in volume {{volume}}.",
  "apercu.share.action": "Share (24 h)",
  "apercu.share.active": "Active links",
  "apercu.share.close": "Close sharing",
  "apercu.share.copy": "Copy",
  "apercu.share.create": "Create the link ({{count}} h)",
  "apercu.share.createRestricted": "Create or revoke a share link",
  "apercu.share.createdCopied": "Link created and copied · expires on {{date}} ({{count}} h)",
  "apercu.share.createdNotCopied": "Link created · expires on {{date}} ({{count}} h). Automatic copy failed: select the link.",
  "apercu.share.duration": "Link duration",
  "apercu.share.empty": "No active link for this preview.",
  "apercu.share.hours": "{{count}} h",
  "apercu.share.item": "Link {{short}} · by {{author}} · expires on {{date}}",
  "apercu.share.link": "Link to send",
  "apercu.share.loading": "Loading share links…",
  "apercu.share.revoke": "Revoke",
  "apercu.share.rule": "The link points to this preview: it only opens it for a signed-in project member, until it expires, and it carries no access token. Creation, opening and revocation are recorded in the audit log.",
  "apercu.share.title": "Share the preview",
  "apercu.shareOpen.back": "Go to my project’s previews",
  "apercu.shareOpen.description": "Opening a preview shared by link: restricted to signed-in project members.",
  "apercu.shareOpen.error": "The share link could not be opened",
  "apercu.shareOpen.expired": "This share link has expired",
  "apercu.shareOpen.expiredHint": "A share link is only valid until it expires. Ask for a new link.",
  "apercu.shareOpen.forbidden": "This link points to the preview of a project you are not a member of",
  "apercu.shareOpen.forbiddenHint": "A share link only opens the preview for project members. Ask its owner for access.",
  "apercu.shareOpen.loading": "Opening the share link…",
  "apercu.shareOpen.notFound": "Share link not found",
  "apercu.shareOpen.notFoundHint": "It does not exist, or it belongs to another organisation. Check the address you received.",
  "apercu.shareOpen.notLive": "The linked preview is no longer running.",
  "apercu.shareOpen.opened": "Preview opened from a share link by {{author}}, valid until {{date}}.",
  "apercu.shareOpen.revoked": "This share link has been revoked",
  "apercu.shareOpen.revokedHint": "It no longer leads to the preview. Ask the person who sent it for a new link.",
  "apercu.viewport.emulation": "Emulation: the frame takes the width and height of the chosen device ({{width}} × {{height}} px). It is not a real device: browser engine, touch input and pixel density remain those of this computer.",
  "runops.redeploy.containers": "before {{avant}} → after {{apres}}",
  "runops.redeploy.notRecreated": "Containers NOT recreated: {{services}}",
  "runops.redeploy.recreated": "Containers recreated (proven)",
  "runops.redeploy.unverified": "Recreation could not be verified (containers unreadable)",
  "invitations.aucune": "No invitation awaits your answer. A space owner can send you one.",
  "invitations.description": "Join a space you have been invited to.",
  "invitations.detail": "Offered role: {{role}}{{par}}{{echeance}}",
  "invitations.echeance": " · valid until {{date}}",
  "invitations.ignorer": "Ignore this link",
  "invitations.lienAide": "The invitation is personal: it only works for the account whose e-mail address was invited. By joining, you become a member of the space with the offered role.",
  "invitations.lienTitre": "You opened an invitation link",
  "invitations.par": " · invited by {{nom}}",
  "invitations.recues": "Invitations received",
  "invitations.refus.consommee": "This invitation has already been accepted.",
  "invitations.refus.echue": "This invitation has expired: ask the space owner for a new one.",
  "invitations.refus.emailNonAtteste": "Your e-mail address is not verified: open the invitation link you were sent to join the space.",
  "invitations.refus.inconnu": "Acceptance failed.",
  "invitations.refus.indisponible": "This invitation does not exist or is not addressed to the signed-in account (check the account e-mail address).",
  "invitations.refus.revoquee": "This invitation was revoked by a space owner or by the organisation’s administration.",
  "invitations.rejoindre": "Join the space",
  "invitations.rejointe": "Space joined",
  "invitations.titre": "Invitations",
  "runops.clotureEffet1": "The deployment is closed with this outcome; only a “Succeeded” outcome opens the next stage.",
  "runops.clotureEffet2": "The outcome is recorded as a manual entry, with your identity, in the audit log.",
  "runops.clotureGroupe": "Declare the observed outcome of {{version}}",
  "runops.clotureIrreversible": "A declared outcome is never rewritten: a new deployment will supersede it.",
  "runops.clotureTitre": "Declare “{{issue}}” for {{version}} on {{env}}?",
  "runops.clotureVerbe": "Declare the outcome",
  "runops.issue.failed": "Failed",
  "runops.issue.rolledBack": "Cancelled (rolled back)",
  "runops.issue.succeeded": "Succeeded",
  "runops.issueDeclaree": "Deployment outcome declared",
  "runops.issueObservee": "Observed outcome",
  "missions.plan.sodTwoPerson": "This project's two-person mode does not apply to missions: their plan and dossier commit a GPU budget and the execution of generated code.",
  "missions.plan.twoPersonExcluded": "You launched this mission: even in two-person mode, another member approves its plan and budget (GPU budget and execution of generated code).",
  "planifier.lancerSprintNote": "A sprint mission iterates on this project's already delivered application, from its latest delivered revision: the form shows them, and refuses before launch if no application has been delivered.",
  "planifier.lancerTrancheNom": "Launch a mission on slice #{{id}} “{{titre}}”",
  "planifier.lancerTrancheNote": "A mission on a slice is a sprint mission on a READY feature and its stories: “Launch a mission on this slice” opens the pre-filled launcher. The queen then proposes the plan, which another member approves.",
  "planifier.trancheEvaluationEnCours": "Readiness check in progress: launching waits until we know whether the slice is ready.",
  "planifier.trancheEvaluationIndisponible": "Readiness not evaluated by the gateway: no slice can be called ready, so launching is disabled.",
  "planifier.trancheNonPrete": "The slice is not ready: {{n}} gap(s).",
  "runops.production": "Stage type",
  "runops.productionDeduite": "Not declared — non-production unless the name says “production”",
  "runops.productionDeduiteNon": "Not declared — inferred: non-production (to declare)",
  "runops.productionDeduiteOui": "Not declared — inferred: production (to declare)",
  "runops.productionNon": "Non-production — dev, acceptance, pre-production",
  "runops.productionOui": "Production — used by real customers",
  "runops.refusVersionHorsCycle": "Out-of-cycle release: adopt it into the release cycle, then get its deployment to this environment approved (Releases screen).",
  "import.tropGros": "File too large ({{taille}} KiB): 1 MiB at most. Split the baseline into several files.",
  "import.encodage": "This file is not UTF-8: some characters are unreadable. Save it again as “CSV UTF-8”, then choose it again.",
  "import.tropDeLignes": "{{n}} rows: 5,000 at most per import. Split the baseline into several files.",
  "import.titre": "Import a baseline",
  "import.de": "Organisation axes from a spreadsheet CSV or a Jira export: a dry run first, nothing is written before “Apply”.",
  "import.retour": "Back to axes",
  "import.etapes": "Import steps",
  "import.etape1": "Choose the file",
  "import.etape2": "Dry run — nothing is written",
  "import.etape3": "Apply",
  "import.choisirTitre": "1. Choose the file",
  "import.fichier": "CSV file",
  "import.limites": "UTF-8 CSV (spreadsheets call it “CSV UTF-8”), 1 MiB and 5,000 rows at most, one axis per row. Kind: 40 characters at most; name: 120.",
  "import.nLignes": "{{n}} row(s) after the header",
  "import.separateur": "File separator",
  "import.virgule": "Comma “,” (Jira export)",
  "import.pointVirgule": "Semicolon “;” (spreadsheet)",
  "import.tabulation": "Tab",
  "import.colonnesAttendues": "Expected columns",
  "import.colonne": "column",
  "import.sens": "meaning",
  "import.kindSens": "kind of axis (portfolio, domain, capability… or your own)",
  "import.obligatoire": "required",
  "import.nameSens": "axis name",
  "import.parentSens": "name of the parent axis (in the file or already present)",
  "import.facultative": "optional",
  "import.descriptionSens": "free text",
  "import.guillemets": "Quotes protect a label that contains the separator or a line break (“Claims, car and home”).",
  "import.jiraTitre": "Map the columns (Jira export)",
  "import.jiraAide": "This file has no “kind” and “name” columns: choose the ones that stand for them. Only the header row is rewritten before sending.",
  "import.mapKind": "Kind (kind) ←",
  "import.mapName": "Name (name) ←",
  "import.mapParent": "Parent ←",
  "import.mapDescription": "Description ←",
  "import.aucune": "— none —",
  "import.mapManque": "Kind and name are required.",
  "import.analyser": "Analyse without writing anything",
  "import.refusLecteur": "Viewer: analysis and import are reserved to the project’s contributors; you can see the axes.",
  "import.analyseEnCours": "Analysing {{nom}}… looking for axes already present in the organisation.",
  "import.refusFichier": "File refused",
  "import.refusTaille": "File too large",
  "import.refusEncodage": "Unsupported encoding",
  "import.erreurAnalyse": "Analysis failed; nothing was written.",
  "import.constatTitre": "2. Dry run before applying — nothing was written",
  "import.constatVide": "Choose a file then “Analyse without writing anything”: the dry run says what the import would create, reuse and refuse, row by row.",
  "import.appliquer": "Apply: create {{n}} axis/axes",
  "import.changer": "Change file",
  "import.rienACreer": "Nothing to create: every valid axis in the file already exists.",
  "import.motifAppliquer": "Axes are shared by the whole organisation: only an organisation administrator applies the import. The dry run stays open to every contributor.",
  "import.succes": "Import applied: {{crees}} axis/axes created, {{rattaches}} linked to their parent.",
  "import.rejouable": "Re-runnable: axes already present are reused, never duplicated. The import is recorded in the organisation’s audit log.",
  "import.voirAxes": "See the axes",
  "import.autre": "Import another file",
  "import.aCreer": "To create",
  "import.nouveaux": "new axes",
  "import.deja": "Already present",
  "import.reutilises": "reused as is, never duplicated",
  "import.refusees": "Refused rows",
  "import.surN": "out of {{n}} read",
  "import.partages": "These axes are shared by the whole organisation (every project), not only by “{{projet}}”: review before applying.",
  "import.apercuTitre": "Preview of creations — the first {{n}} of {{total}}",
  "import.ligne": "row",
  "import.nature": "kind",
  "import.nom": "name",
  "import.parent": "parent",
  "import.description": "description",
  "import.parentIntrouvable": "parent not found",
  "import.avertissementsTitre": "Warnings",
  "import.ligneN": "Row {{n}}",
  "import.erreursTitre": "Row errors",
  "import.motif": "reason",
  "import.refusesNonDetailles": "… and {{n}} other refused row(s), not detailed.",
  "import.corriger": "These rows are ignored. Fix the file and run the analysis again: the import replays without duplicates.",
  "harnais.ongletCastes": "Castes",
  "harnais.ongletAgents": "Custom agents",
  "harnais.ongletMcp": "MCP servers",
  "harnais.ongletModeles": "Connections and models",
  "harnais.ongletSupervision": "Supervision",
  "harnais.titre": "Harness and agents",
  "harnais.de": "Harness castes, custom agents and their promotion, MCP servers, models",
  "harnais.onglets": "Harness views",
  "harnais.aVenir": "This view has no dedicated screen yet. Castes, MCP servers and models are set today in",
  "harnais.gabarits": "Templates",
  "agentsPerso.plateforme": "platform catalogue",
  "agentsPerso.enRevue": "in review",
  "agentsPerso.promu": "promoted by the organisation",
  "agentsPerso.refuse": "promotion refused",
  "agentsPerso.brouillon": "project draft",
  "agentsPerso.brouillonAncien": "draft (predates review)",
  "agentsPerso.r.catalogue": "Platform catalogue agent: readable by all, not editable here.",
  "agentsPerso.r.enRevue": "In review: the content is frozen until the reviewer decides.",
  "agentsPerso.r.promu": "Promoted: every project sees it, it is frozen. The organisation administration withdraws the promotion first.",
  "agentsPerso.r.proprietaire": "Only the owner of the origin project edits a draft.",
  "agentsPerso.r.admin": "Promotion belongs to the organisation administration.",
  "agentsPerso.r.sansModele": "No default model: no project could run it. Choose one first.",
  "agentsPerso.r.modele": "Its default model is not granted to the organisation: choose a granted model before the review.",
  "agentsPerso.r.etat": "This action does not apply to the agent’s current state.",
  "agentsPerso.r.auteur": "You are the author of this agent: another reviewer decides its promotion.",
  "agentsPerso.r.relecteur": "Only the designated reviewer decides this promotion.",
  "agentsPerso.retire": "“{{nom}}” is a draft of its project again.",
  "agentsPerso.chargement": "Reading custom agents…",
  "agentsPerso.refusLecture": "Custom agents are not open to you.",
  "agentsPerso.erreur": "Custom agents could not be read; nothing changed.",
  "agentsPerso.titre": "Custom agents — provenance and status",
  "agentsPerso.regle": "A draft is visible only from its origin project; once promoted by the organisation, it is visible from every project. Promotion goes through review by a reviewer other than the author.",
  "agentsPerso.vide": "No custom agent",
  "agentsPerso.videIndice": "A project owner creates an agent; it starts as a draft of that project.",
  "agentsPerso.creer": "Create an agent in “{{projet}}”",
  "agentsPerso.refusCreer": "Only the owner of the active project creates an agent; it starts as a draft of that project.",
  "agentsPerso.cycle": "Life cycle of an agent",
  "agentsPerso.c1": "Draft: created by a project owner, visible from that project only.",
  "agentsPerso.c2": "In review: sent by the organisation administration, reviewer other than the author, granted model; content frozen.",
  "agentsPerso.c3": "Promoted or refused: decided by the reviewer alone; a refusal is justified, the author fixes and the draft starts again.",
  "agentsPerso.c4": "Withdrawal: the administration turns a promoted agent back into a draft of its project.",
  "agentsPerso.outils": "A custom agent has no tools: granting them is refused (TOOLS_NOT_SUPPORTED).",
  "agentsPerso.provPlateforme": "platform catalogue",
  "agentsPerso.provenance": "created by project {{projet}} · {{auteur}}",
  "agentsPerso.provInconnue": "unknown provenance (created before agent review)",
  "agentsPerso.relecteurDe": "reviewer: {{r}}",
  "agentsPerso.cestVous": "that’s you",
  "agentsPerso.refusePar": "Promotion refused by {{r}}: “{{motif}}”",
  "agentsPerso.modifier": "Edit",
  "agentsPerso.promouvoir": "Promote…",
  "agentsPerso.trancher": "Review and decide…",
  "agentsPerso.annulerRevue": "Cancel the review",
  "agentsPerso.retirer": "Withdraw the promotion",
  "agentsPerso.modifie": "Agent saved — {{nom}}",
  "agentsPerso.cree": "Agent created — {{nom}}, draft of this project",
  "agentsPerso.modifierTitre": "Edit agent “{{nom}}”",
  "agentsPerso.creerTitre": "Create a custom agent",
  "agentsPerso.creerAide": "It starts as a draft of its origin project, visible from that project only, until the organisation promotes it.",
  "agentsPerso.nom": "Name",
  "agentsPerso.nomRequis": "Give the agent a name.",
  "agentsPerso.persona": "Persona",
  "agentsPerso.personaRequis": "Name the persona (100 characters at most).",
  "agentsPerso.description": "Description",
  "agentsPerso.prompt": "System prompt (required)",
  "agentsPerso.promptRequis": "The system prompt is required.",
  "agentsPerso.modele": "Default model",
  "agentsPerso.aucunModele": "— none —",
  "agentsPerso.modeleAide": "A model granted to the organisation is required for the review and at launch (MODEL_NOT_GRANTED otherwise).",
  "agentsPerso.annuler": "Cancel",
  "agentsPerso.enregistrer": "Save",
  "agentsPerso.envoye": "“{{nom}}” sent for review to {{r}}.",
  "agentsPerso.promouvoirTitre": "Promote “{{nom}}” to the organisation catalogue",
  "agentsPerso.promouvoirAide": "Once promoted, the agent becomes readable by every project; its origin project can no longer edit it alone.",
  "agentsPerso.provenanceCle": "Provenance",
  "agentsPerso.modeleCle": "Model",
  "agentsPerso.accorde": "granted to the organisation",
  "agentsPerso.nonAccorde": "not granted",
  "agentsPerso.outilsCle": "Tools",
  "agentsPerso.aucunOutil": "none (granting tools remains refused)",
  "agentsPerso.relecteur": "Reviewer (other than the author)",
  "agentsPerso.lectureRelecteurs": "Reading…",
  "agentsPerso.choisir": "— choose —",
  "agentsPerso.relecteurRequis": "Designate a reviewer.",
  "agentsPerso.note": "Note for the reviewer (optional)",
  "agentsPerso.envoyer": "Send for review",
  "agentsPerso.promuAnnonce": "“{{nom}}” promoted to the organisation catalogue.",
  "agentsPerso.refuseAnnonce": "Promotion of “{{nom}}” refused; the author reads your reason.",
  "agentsPerso.trancherTitre": "Review “{{nom}}”",
  "agentsPerso.trancherAide": "You are the designated reviewer. Once promoted, the agent becomes readable by every project in the organisation.",
  "agentsPerso.motif": "Reason (required to refuse, at least 10 characters)",
  "agentsPerso.motifRequis": "Justify the refusal: the author reads it to fix the agent (at least 10 characters).",
  "agentsPerso.refuserBouton": "Refuse",
  "agentsPerso.promouvoirBouton": "Promote",
  "taxonomy.importer": "Import a baseline",
  "missions.replan.changed": "The proposal changed since you read it: review it again before approving.",
  "missions.replan.stale": "The remaining tasks changed since the proposal: it no longer applies as is.",
  "missions.replan.selfRefused": "You launched this mission: another member must approve its replanning (separation of duties).",
  "missions.replan.announceApproved": "New split approved: the colony resumes on the parts.",
  "missions.replan.announceRejected": "Replanning rejected: the stopped task awaits your decision.",
  "missions.replan.title": "Replanning proposed by the queen",
  "missions.replan.unreadable": "The proposal is not served readably: it cannot be approved blindly.",
  "missions.replan.errReason": "Rejecting the replanning requires a reason.",
  "missions.replan.index": "replanning {{i}} of at most {{max}}",
  "missions.replan.stopped": "Task {{rang}} “{{titre}}” stopped without converging ({{cause}}): {{detail}}",
  "missions.replan.split": "Proposed split (each part is judged against ITS criteria only)",
  "missions.replan.part": "Task {{rang}} — {{titre}}",
  "missions.replan.partMeta": "card {{carte}} · depends on {{deps}}",
  "missions.replan.rewiredTitle": "Remaining tasks rewired",
  "missions.replan.rewired": "Task {{rang}} “{{titre}}”: depended on {{avant}}, will depend on {{apres}}",
  "missions.replan.effect": "Approving cancels task {{rang}} (replaced) and inserts the parts; deciding the stopped task otherwise, in “Waiting for a human”, declines this proposal. Fingerprint of the proposal read: {{sha}}",
  "missions.replan.readOnly": "A contributor or the project owner decides on the replanning.",
  "missions.replan.approve": "Approve the new split",
  "missions.replan.sod": "You launched this mission: another member must approve its replanning, like its plan (separation of duties). “Reject with reason” remains possible.",
  "missions.replan.reason": "Reason for rejection",
  "missions.replan.confirmReject": "Confirm rejection",
  "missions.replan.reject": "Reject with reason",
  "missions.diff.added": "added",
  "missions.diff.removed": "removed",
  "missions.diff.dossier": "Rendered evidence file",
  "missions.diff.truncated": "Excerpt truncated by the clerk: files marked “outside excerpt” are not shown here. Full diff: {{ref}}, fingerprint {{sha}}.",
  "missions.diff.tree": "Changed files ({{n}})",
  "missions.diff.outOfExcerpt": "outside excerpt",
  "missions.diff.new": "new",
  "missions.diff.deleted": "deleted",
  "missions.diff.previous": "Previous file",
  "missions.diff.next": "Next file",
  "missions.diff.outOfExcerptDetail": "This file is beyond the served excerpt: its diff is in the full file {{ref}} (fingerprint {{sha}}).",
  "missions.diff.binary": "Binary file: no textual diff.",
  "missions.diff.region": "Diff of {{f}}",
  "missions.diff.caption": "Lines: old number, new number, content",
  "missions.diff.rawText": "Full served text (rendered file and diff excerpt, the one the fingerprint covers)",
  "missions.decision.replanPending": "The queen proposes a new split of this task (section “Replanning proposed by the queen”): approving it replaces the task; a decision below declines the proposal.",
  "missions.decision.openStops": "{{n}} task stop(s) awaiting a decision: while one remains, the mission stays suspended and its application cannot take any other mission.",
  "missions.decision.acceptAllStops": "Acknowledge all stops and close the mission",
  "missions.decision.closeAllBlocked": "Other tasks of the mission can still succeed: decide these stops one by one.",
  "missions.replan.cause.generation_timeout": "repeated generation timeouts",
  "missions.replan.cause.task_tokens": "task token cap reached",
  "missions.reason.replan_proposed": "new split proposed by the queen",
  "missions.reason.replanned": "replaced by a new split",
  "missions.reason.recette_test_invalid": "acceptance test unusable as a hidden test",
  "missions.reason.recette_test_not_reproduced": "acceptance test green on the starting version: defect not reproduced",
  "missions.diff.opened": "Opened file: {{f}}",
  "missions.form.launching": "Launching: the mission is being created, then the queen prepares the plan…",
  "missions.form.slice": "Slice: feature #{{id}} “{{titre}}” and its open stories.",
  "missions.form.sliceBacklog": "See “Ready for the colony”",
  "missions.form.sliceDefaultTitle": "Slice — {{titre}}",
  "missions.form.sliceNotEvaluated": "Slice readiness could not be read here: the gateway checks it at launch (SLICE_NOT_READY if it is not ready).",
  "missions.form.sliceNotReady": "The slice is not ready: {{n}} gap(s).",
  "missions.form.sliceOpen": "Open the item",
  "missions.form.sliceReady": "Ready for the colony according to the gateway: the queen plans from its stories.",
  "missions.form.sliceUnknown": "Slice: feature #{{id}} and its open stories.",
  "missions.pause.alreadySuspended": "No need to pause: the mission is already suspended by the system; it will resume on its own when a slot frees up. Stop it if you do not want it to resume.",
  "missions.pause.alreadySuspendedExecutor": "No need to pause: the mission is already suspended by the system; it will resume on its own when an executor responds. Stop it if you do not want it to resume.",
  "missions.pause.alreadySuspendedHuman": "No need to pause: the mission is already suspended, waiting for a decision in the Attention inbox; it will resume as soon as that decision is made. Stop it if you do not want it to resume.",
  "missions.pause.announce": "Mission paused: no more GPU minutes are being consumed.",
  "missions.pause.announceFinishing": "Pause requested: the current step finishes, then the mission stops.",
  "missions.pause.bannerHelp": "No GPU minutes are being consumed; pending decisions stay in the Attention inbox.",
  "missions.pause.bannerTitle": "Paused",
  "missions.pause.confirmTitle": "Pause the mission “{{t}}”?",
  "missions.pause.currentStep": "{{caste}} · task {{k}} “{{titre}}”, round {{r}}",
  "missions.pause.effectDecisions": "Any pending decisions stay in the Attention inbox.",
  "missions.pause.effectDecisionsN": "Pending decisions ({{n}}) stay in the Attention inbox.",
  "missions.pause.effectGpu": "No GPU minutes are consumed while paused; the mission gives up its place in the queue.",
  "missions.pause.effectStep": "The current step finishes, then the mission stops: no work is discarded.",
  "missions.pause.effectStepNamed": "The current step finishes ({{e}}), then the mission stops: no work is discarded.",
  "missions.pause.finishing": "Pause requested: the current step is finishing…",
  "missions.pause.finishingNamed": "Pause requested: the current step is finishing ({{e}})…",
  "missions.pause.finishingOthers": "The other castes no longer accept new steps.",
  "missions.pause.pending": "Pausing…",
  "missions.pause.reason": "Reason (optional)",
  "missions.pause.reasonHelp": "Shown on the mission cockpit, 500 characters at most.",
  "missions.pause.refusedEnded": "The mission has ended: there is nothing left to pause.",
  "missions.pause.reversibility": "“Resume mission” restarts at the next round, with the same castes and the same remaining budget ({{n}} min).",
  "missions.pause.since": "since {{h}} · by {{nom}}",
  "missions.resume.announce": "Mission resumed: it restarts at the next round.",
  "missions.resume.button": "Resume mission",
  "missions.resume.distinction": "Resuming a mission after a voluntary pause is not the same as relaunching a custom agent after an error (capped):",
  "missions.resume.pending": "Resuming…",
  "missions.suspension.paused": "paused",
  "rejoindre.succes": "You joined “{{nom}}” as owner (action logged).",
  "rejoindre.dejaMembre": "You are already a member of “{{nom}}” ({{role}}): nothing changed.",
  "rejoindre.echec": "Could not join “{{nom}}”: {{detail}}",
  "contexte.nonMembreRejoindre": "not a member — join",
  "contexte.rejoindreEnCours": "Joining the project…",
  "contexte.fermer": "Close",
  "dashboard.nonMembre": "Not a member",
  "dashboard.rejoindre": "Join",
  "menu.administrationPlateforme": "Platform administration",
  "menu.reglagesNotifications": "Notification settings",
  "contexte.rejoindreCeProjet": "Join “{{nom}}” as owner",
  "dashboard.archivesHorsPortefeuille": "{{n}} archived project(s), read-only:",
  "dashboard.voirProjetsOrganisation": "see the organisation's projects",
  "dashboard.rejoindreEnCours": "Joining…",
  "dashboard.rejoindreAria": "Join project “{{nom}}” as owner",
  "pgmReglages.de": "Identity and governance of {{nom}}",
  "pgmReglages.chargement": "Reading settings…",
  "pgmReglages.refus": "You are not a member of this programme: its settings are not open to you.",
  "pgmReglages.erreur": "The programme settings could not be read.",
  "pgmReglages.succes": "Programme settings saved.",
  "pgmReglages.nomRequis": "The name is required.",
  "pgmReglages.nomLongueur": "The name must be {{min}} to {{max}} characters long.",
  "pgmReglages.descriptionLongueur": "The description must be at most {{max}} characters long.",
  "pgmReglages.lecture": "Reserved to a programme owner (or the platform administrator): you can read these settings but not change them.",
  "pgmReglages.gabaritDefaut": "Default (built-in)",
  "pgmReglages.identite": "Identity and governance",
  "pgmReglages.conflitTitre": "Concurrent change",
  "pgmReglages.conflit": "The programme was changed in the meantime: reload its settings before saving.",
  "pgmReglages.recharger": "Reload",
  "pgmReglages.nom": "Name",
  "pgmReglages.description": "Description",
  "pgmReglages.proprietaires": "Owner(s)",
  "pgmReglages.proprietairesIndice": "Owners are appointed through roles, on the screen",
  "pgmReglages.statut": "Status",
  "pgmReglages.gabarit": "Default template for new projects",
  "pgmReglages.gabaritsErreur": "The template catalogue could not be read; the saved template is kept.",
  "pgmReglages.enregistrement": "Saving…",
  "pgmReglages.enregistrer": "Save",
  "pgmBacklog.de": "Initiatives of {{nom}}: framing or epics, and their trace",
  "pgmBacklog.refus": "You are not a member of this programme: its initiatives are not open to you.",
  "pgmBacklog.chargementProjets": "Reading the programme projects…",
  "pgmBacklog.lancer": "Launch an initiative",
  "pgmBacklog.sansDroit": "Launching an initiative requires a write role (owner or contributor) in a project of the programme; initiatives remain readable below.",
  "pgmBacklog.lancees": "Launched initiatives",
  "pgmBacklog.chargement": "Reading initiatives…",
  "pgmBacklog.erreur": "The initiatives could not be read.",
  "pgmBacklog.nonAccessibles1": "1 initiative targets a project that is not open to you: a count only.",
  "pgmBacklog.nonAccessiblesN": "{{n}} initiatives target projects that are not open to you: a count only.",
  "pgmBacklog.vide": "No initiative launched",
  "pgmBacklog.videIndice": "Initiatives are recorded here as soon as they are launched, from the form above.",
  "pgmBacklog.legende": "Initiatives launched in the programme, most recent first",
  "pgmBacklog.colInitiative": "initiative",
  "pgmBacklog.colAuteur": "author",
  "pgmBacklog.colProjet": "target project",
  "pgmBacklog.colJob": "job",
  "pgmBacklog.colResultat": "result",
  "pgmBacklog.colDate": "launched on",
  "pgmBacklog.limite": "The trace is read from the programme jobs and documents: an initiative whose job was purged by retention no longer appears.",
  "pgmBacklog.epics": "{{n}} epic(s), {{m}} to accept",
  "pgmBacklog.ouvrirBacklog": "Open in the backlog",
  "pgmBacklog.aucunEpic": "no epic created",
  "pgmBacklog.avancement": "{{n}} / {{m}} epics done",
  "pgmBacklog.cadrageEnRevue": "framing under review",
  "pgmBacklog.cadrageApprouve": "framing approved",
  "pgmBacklog.cadrageRefuse": "framing rejected",
  "pgmBacklog.cadrageAttendu": "framing not produced yet",
  "pgmBacklog.cheminEpics": "epics",
  "pgmBacklog.cheminCadrage": "framing",
  "pgmBacklog.colAvancement": "progress (actual epics)",
  "pgmBacklog.colObjectif": "objective",
  "pgmBacklog.colStatut": "status",
  "pgmBacklog.echecObjet": "Generation failed: the initiative stays “proposed”.",
  "programs.initiativeTargetReadOnly": "{{nom}} (read-only: write role required)",
  "pgmBacklog.erreurProjets": "The programme projects could not be read: launching an initiative is unavailable.",
  "pgmBacklog.objectifAnnuler": "Cancel",
  "pgmBacklog.objectifAucun": "no objective",
  "pgmBacklog.objectifDe": "Objective of “{{titre}}”",
  "pgmBacklog.objectifDefinir": "Set the objective",
  "pgmBacklog.objectifDefinirDe": "Set the objective of “{{titre}}”",
  "pgmBacklog.objectifEnregistrer": "Save",
  "pgmBacklog.objectifLecture": "Read only: an initiative’s objective is set by its author or a programme pilot (owner or contributor).",
  "pgmBacklog.objectifLongueur": "The objective must be {{min}} to {{max}} characters long.",
  "pgmBacklog.objectifModifier": "Edit the objective",
  "pgmBacklog.statutCadree": "framed",
  "pgmBacklog.statutEnCours": "in progress",
  "pgmBacklog.statutEnRevue": "in review",
  "pgmBacklog.statutProposee": "proposed",
  "pgmBacklog.statutTerminee": "done",
  "catalogueTech.ongletCatalogueN": "Catalogue ({{n}})",
  "catalogueTech.ongletCatalogue": "Catalogue",
  "catalogueTech.ongletCategoriesN": "Categories ({{n}})",
  "catalogueTech.ongletCategories": "Categories",
  "catalogueTech.ongletRadar": "Radar",
  "catalogueTech.chargement": "Loading the catalogue…",
  "catalogueTech.refusLecture": "The organisation's technology catalogue is not open to you.",
  "catalogueTech.erreur": "Catalogue unreadable: the gateway did not respond; nothing has changed.",
  "catalogueTech.titre": "Technology catalogue",
  "catalogueTech.de": "The organisation's technology choices, from languages to platform utilities, and their measured generability by the colony.",
  "catalogueTech.lectureSeule": "Read only: the organisation's administration (platform administrator) edits the catalogue.",
  "catalogueTech.onglets": "Catalogue views",
  "catalogueTech.changementsAVenir": "Change requests and propagation: coming with the next batch.",
  "catalogueTech.ongletChangements": "Changes",
  "catalogueTech.aVenir": "coming",
  "catalogueTech.jeuApplique": "Starter set applied: {{n}} category(ies) added. Now add your entries.",
  "catalogueTech.utiliserJeu": "Use the starter set ({{n}} categories)",
  "catalogueTech.filtrer": "Category",
  "catalogueTech.toutes": "All categories",
  "catalogueTech.nouvelleEntree": "New entry",
  "catalogueTech.vide": "Empty catalogue",
  "catalogueTech.videAide": "Start with the starter set of categories, then add your entries. The floor categories (identity and access, secrets vault) already exist.",
  "catalogueTech.videAction": "Add an entry with “New entry”.",
  "catalogueTech.videLecture": "The organisation's administration has not registered any entry yet.",
  "catalogueTech.videFiltre": "No entry in this category",
  "catalogueTech.videFiltreAide": "Choose “All categories” or add an entry.",
  "catalogueTech.entreesCaption": "Technology catalogue entries",
  "catalogueTech.categorie": "Category",
  "catalogueTech.produitVersion": "Product · version",
  "catalogueTech.licenceCol": "Licence (SPDX)",
  "catalogueTech.choisie": "Chosen by the organisation",
  "catalogueTech.generable": "Generable by the colony",
  "catalogueTech.actions": "Actions",
  "catalogueTech.anneauDe": "radar: {{anneau}}",
  "catalogueTech.fondeePar": "based on {{adr}}",
  "catalogueTech.modifier": "Edit",
  "catalogueTech.changerStatut": "Change status",
  "catalogueTech.deuxAttributs": "Two attributes side by side: chosen by the organisation (governance) and generable by the colony (measured fact: a qualified generation profile covers it). The ASVS baseline and allowed licences stay in the",
  "catalogueTech.referentiel": "Requirements referential",
  "catalogueTech.profils": "Qualified generation profiles",
  "catalogueTech.entreeModifiee": "Entry saved — {{produit}}",
  "catalogueTech.entreeCreee": "Entry added — {{produit}}, {{statut}}",
  "catalogueTech.modifierTitre": "Entry — {{produit}}",
  "catalogueTech.nouvelleTitre": "New catalogue entry",
  "catalogueTech.modifierAide": "Product and category do not change; the status is changed separately, with its effect on projects.",
  "catalogueTech.nouvelleAide": "An entry is born “under review” or “allowed”; imposing it is a status change, with its effect on projects.",
  "catalogueTech.produit": "Product",
  "catalogueTech.produitRequis": "Name the product (e.g. Valkey).",
  "catalogueTech.version": "Version or range",
  "catalogueTech.versionInvalide": "A version (8.1) or a range (8.x, ≥ 8.0).",
  "catalogueTech.licence": "Licence (SPDX)",
  "catalogueTech.statutInitial": "Status",
  "catalogueTech.anneauRadar": "Radar ring (optional)",
  "catalogueTech.sansAnneau": "— none —",
  "catalogueTech.adrLiee": "Linked organisation ADR (optional)",
  "catalogueTech.sansAdr": "— none —",
  "catalogueTech.note": "Note",
  "catalogueTech.enregistrer": "Save",
  "catalogueTech.statutChange": "“{{produit}}” is now {{statut}}.",
  "catalogueTech.statutTitre": "Change status — {{produit}}",
  "catalogueTech.statutActuel": "Current status: {{statut}}. Chosen by the organisation (governance); generable by the colony: {{gen}} (measured fact).",
  "catalogueTech.retireeFinale": "A retired entry no longer changes status: add a new entry.",
  "catalogueTech.nouveauStatut": "New status",
  "catalogueTech.avertNonGenerable": "No qualified generation profile covers it: projects inheriting it will not be able to launch a generation by the colony. This is allowed: generability conditions generation, not the choice (D3).",
  "catalogueTech.refusSensible": "“{{categorie}}” is a sensitive category: moving “{{produit}}” to “{{statut}}” relaxes its protection. This requires reinforced confirmation and two people, through an organisation change request.",
  "catalogueTech.impactCalcul": "Computing the effect on projects…",
  "catalogueTech.impactTouche": "This change affects {{n}} project(s) out of {{total}} in the organisation.",
  "catalogueTech.impactAucun": "No project is affected ({{total}} project(s) in the organisation).",
  "catalogueTech.impactBase": "Counted on the projects' current stack profile ({{utilisent}} use it), without naming projects. Until technology baselines exist, nothing is propagated to projects.",
  "catalogueTech.impactConfirmer": "I have read the effect on projects and I confirm.",
  "catalogueTech.statutValider": "Move to “{{statut}}”",
  "catalogueTech.radarResumeAnneau": "{{anneau}} {{n}}",
  "catalogueTech.radar": "Radar",
  "catalogueTech.radarVide": "No entry on the radar",
  "catalogueTech.radarVideAide": "The radar fills in when an entry carries a ring (adopt, trial, assess, hold); it is set in the Catalogue view.",
  "catalogueTech.radarEnTexte": "As text: {{resume}}.",
  "catalogueTech.radarCaption": "Catalogue entries by radar ring",
  "catalogueTech.anneauCol": "Ring",
  "catalogueTech.entrees": "Entries",
  "catalogueTech.aucune": "none",
  "catalogueTech.radarNote": "The ring guides; it does not make an entry generable.",
  "catalogueTech.adrsOrg": "Organisation ADRs",
  "catalogueTech.adrsChargement": "Reading organisation ADRs…",
  "catalogueTech.adrsErreur": "Organisation ADRs could not be read.",
  "catalogueTech.adrsVide": "No organisation ADR",
  "catalogueTech.adrsVideAide": "An organisation ADR grounds a decision that applies to every application (e.g. Keycloak for identity).",
  "catalogueTech.adrsCaption": "Organisation-scoped ADRs",
  "catalogueTech.titreAdr": "Title",
  "catalogueTech.statutCol": "Status",
  "catalogueTech.nouvelleAdr": "New organisation ADR",
  "catalogueTech.cardinalite": "Cardinality",
  "catalogueTech.choixUnique": "single choice",
  "catalogueTech.choixMultiple": "multiple choice",
  "catalogueTech.obligatoire": "Mandatory",
  "catalogueTech.sensible": "Sensitive",
  "catalogueTech.categorieAjoutee": "Category “{{libelle}}” added — {{obligatoire}}, {{cardinalite}}",
  "catalogueTech.obligatoireMin": "mandatory",
  "catalogueTech.facultative": "optional",
  "catalogueTech.categorieSupprimee": "Category “{{libelle}}” deleted.",
  "catalogueTech.categoriesCaption": "Categories of the organisation's catalogue",
  "catalogueTech.oui": "yes",
  "catalogueTech.non": "no",
  "catalogueTech.unique": "single",
  "catalogueTech.multiple": "multiple",
  "catalogueTech.sensiblePlancher": "sensitive · floor",
  "catalogueTech.sensibleMin": "sensitive",
  "catalogueTech.supprimer": "Delete",
  "catalogueTech.plancherNote": "{{categories}}: platform floor — mandatory and sensitive for every organisation, never deletable.",
  "catalogueTech.nouvelleCategorie": "New category",
  "catalogueTech.libelle": "Label",
  "catalogueTech.ajouter": "Add",
  "catalogueTech.libelleRequis": "The label is required.",
  "catalogueTech.categorieModifiee": "Category “{{libelle}}” saved.",
  "catalogueTech.categorieTitre": "Category — {{libelle}}",
  "catalogueTech.plancherAide": "Platform floor: mandatory and sensitive for every organisation (A5).",
  "catalogueTech.categorieAide": "A mandatory category must have a value in every project before its launch is completed.",
  "catalogueTech.statut.proposed": "under review",
  "catalogueTech.statut.allowed": "allowed",
  "catalogueTech.statut.inForce": "imposed",
  "catalogueTech.statut.retired": "retired",
  "catalogueTech.anneau.adopt": "adopt",
  "catalogueTech.anneau.trial": "trial",
  "catalogueTech.anneau.assess": "assess",
  "catalogueTech.anneau.hold": "hold",
  "catalogueTech.gen.generable": "generable",
  "catalogueTech.gen.nonQualifiee": "not measured",
  "catalogueTech.gen.nonCouverte": "not generable",
  "catalogueTech.gen.aucunProfil": "no generation profile covers it: the colony cannot integrate it yet",
  "catalogueTech.gen.profilQualifie": "profile {{profil}} ({{passes}}/{{total}} golden cases, {{modele}})",
  "catalogueTech.gen.profilNonQualifie": "profile {{profil}}: {{motif}}",
  "catalogueTech.r.admin": "Reserved to the organisation's administration (platform administrator): you are viewing the catalogue read-only.",
  "catalogueTech.r.plancher": "Platform floor: this category stays mandatory and sensitive for every organisation, and is never deleted.",
  "catalogueTech.r.utilisee": "Category used by catalogue entries (retired ones included): it stays.",
  "catalogueTech.r.existe": "This category already exists.",
  "catalogueTech.r.unique": "Single-choice category: it already has an imposed entry. Make it allowed or retire it first.",
  "catalogueTech.r.sensible": "Sensitive category: relaxing an entry requires reinforced confirmation and two people. Use a change request (coming).",
  "catalogueTech.r.impact": "This change affects projects: confirm it after reading its effect.",
  "catalogueTech.r.doublon": "This product, in this version, is already in the catalogue for this category.",
  "catalogueTech.r.retiree": "A retired entry can no longer be edited.",
  "catalogueTech.r.transition": "This status change is not allowed from the current state.",
  "catalogueTech.jeuCompletApplique": "Starter set applied: {{c}} category(ies) and {{e}} entry(ies) added, allowed (selectable at launch, never imposed).",
  "catalogueTech.jeuResteCoffre": "Your secrets vault still has to be registered.",
  "catalogueTech.lectureSeuleOrg": "Read-only: the organisation administration (organisation administrator) maintains the catalogue.",
  "catalogueTech.ouvrirCatalogue": "Open the technology catalogue",
  "catalogueTech.plancherCoffre": "Secrets vault",
  "catalogueTech.plancherCoffreAide": "to be defined by the organisation: the platform deploys none. Register yours (for example HashiCorp Vault, OpenBao, or your orchestrator's encrypted secrets) with “New entry”. Until then, each project defines it at launch (“Define” then “Outside the catalogue…”).",
  "catalogueTech.plancherIdentite": "Identity and access",
  "catalogueTech.plancherTitre": "Platform floor still without an entry",
  "catalogueTech.r.adminOrg": "Reserved to the organisation administration (organisation administrator): you are viewing the catalogue read-only.",
  "catalogueTech.utiliserJeuComplet": "Use the starter set ({{c}} category(ies), {{e}} entry(ies))",
  "catalogueTech.videAideComplet": "The starter set adds in one step the categories and the technologies the platform can generate (languages, frameworks, databases, web, mobile or desktop target platform), each with its measured generability. You then add or retire what you want.",
  "qualite.duree.jours": "{{n}} d",
  "qualite.duree.heures": "{{n}} h",
  "qualite.duree.minutes": "{{n}} min",
  "qualite.motif.echappement": "No defect reported in the period with its environment recorded.",
  "qualite.motif.reouverture": "No defect resolved for the first time in the period.",
  "qualite.motif.mttr": "No defect closed in the period.",
  "qualite.motif.inconnu": "Cannot be measured (code {{code}}).",
  "qualite.detail.echappement": "{{n}} found in production out of {{d}} genuine defect(s) reported in the period",
  "qualite.detail.reouverture": "{{n}} reopened out of {{d}} fixed",
  "qualite.def.echappement": "Defects found in production ÷ genuine defects reported in the period whose environment is known (duplicates, rejected and not reproducible excluded).",
  "qualite.def.reouverture": "Defects reopened after a fix (resolved, verified or closed → reopened) ÷ defects resolved for the first time in the period.",
  "qualite.def.mttr": "Mean time from report to closure, over the defects closed during the period.",
  "qualite.def.ouvertes": "New, triaged, in progress, resolved awaiting verification and reopened — now, all periods.",
  "qualite.lecon.refus.fermee": "A lesson comes from a closed defect (verified by a green run, then delivered): refused without a linked closed defect (B-108).",
  "qualite.lecon.refus.existe": "This defect already has a proposed or validated lesson.",
  "qualite.lecon.refus.auteur": "You proposed this lesson: someone else must validate it.",
  "qualite.lecon.refus.decidee": "This lesson has already been decided.",
  "qualite.lecon.refus.echue": "This lesson has expired: propose a new one.",
  "qualite.lecon.refus.expiration": "The expiry date must fall between tomorrow and 366 days.",
  "qualite.lecon.refus.champs": "Symptom, cause and fix are all required.",
  "qualite.lecon.refus.motif": "Dismissing a lesson requires a written reason.",
  "qualite.lecon.refus.humain": "A lesson is decided in a human session: a service token is refused.",
  "qualite.lecon.statut.ecartee": "dismissed",
  "qualite.lecon.statut.echue": "expired",
  "qualite.lecon.statut.avis": "ADVICE — to be validated by a human",
  "qualite.lecon.statut.active": "validated, active",
  "qualite.lecon.statut.valideeEchue": "validated, expired",
  "qualite.lecon.statut.suspendue": "validated, suspended: the defect is no longer closed",
  "qualite.lecon.titre": "Lesson #{{id}}",
  "qualite.lecon.origineColonie": "proposed by the colony",
  "qualite.lecon.symptome": "Symptom",
  "qualite.lecon.cause": "Cause",
  "qualite.lecon.correctif": "Fix",
  "qualite.lecon.expire": "Expires",
  "qualite.lecon.preuve": "Evidence",
  "qualite.lecon.preuveExecution": "{{ano}} closed, verified by green run #{{exe}}",
  "qualite.lecon.preuveAnomalie": "{{ano}} closed",
  "qualite.lecon.auteur": "Proposed by",
  "qualite.lecon.decidee": "Decided by",
  "qualite.lecon.valider": "Validate the lesson",
  "qualite.lecon.ecarter": "Dismiss",
  "qualite.lecon.motif": "Reason (required)",
  "qualite.lecon.ecarterConfirmer": "Confirm: dismiss",
  "qualite.lecon.expiration": "Expiry",
  "qualite.lecon.proposer": "Propose the lesson",
  "qualite.lecon.panneau": "Proposed lesson",
  "qualite.lecon.aide": "Symptom → cause → fix, linked to this closed defect and its verification, with an expiry date. Once proposed it is advice: the colony only uses it after someone else validates it.",
  "qualite.lecon.chargement": "Loading lessons…",
  "qualite.insuffisant": "Insufficient data",
  "qualite.exclues": "{{n}} defect(s) without an environment excluded: we do not know where they were found.",
  "qualite.echappement": "Escape",
  "qualite.reouverture": "Reopening",
  "qualite.mttr": "MTTR",
  "qualite.mttrDetail": "over {{n}} closed defect(s)",
  "qualite.ouvertes": "Open",
  "qualite.aVerifier": "including {{n}} resolved awaiting verification",
  "qualite.parVersion": "Defects by severity and version",
  "qualite.parVersionPortee": "Defects counted",
  "qualite.parVersionOuvertes": "Open",
  "qualite.parVersionToutes": "All",
  "qualite.parVersionVide": "No genuine defect",
  "qualite.parVersionVideAide": "Duplicates, rejected and not reproducible do not count.",
  "qualite.version": "Version",
  "qualite.total": "Total",
  "qualite.sansVersion": "no version",
  "qualite.anciennes": "Oldest not closed",
  "qualite.anciennesVide": "No open defect",
  "qualite.anciennesVideAide": "A red run on the Tests screen becomes a defect in two steps.",
  "qualite.ouvrirAnomalies": "Open defects",
  "qualite.mttrParSeverite": "MTTR by severity",
  "qualite.severite": "Severity",
  "qualite.fermees": "Closed",
  "qualite.lecons": "Lessons",
  "qualite.leconsCompte": "{{p}} to validate, {{a}} active — an active lesson is validated, not expired, and its defect stays closed.",
  "qualite.leconsVide": "No lesson to validate",
  "qualite.leconsVideAide": "A lesson is proposed from the detail of a closed defect.",
  "qualite.titre": "Quality dashboard",
  "qualite.description": "Escape, reopening, time to fix and defects by severity and version — computed by the gateway from the project's defects.",
  "qualite.sansProjet": "The quality dashboard is about a project.",
  "qualite.periode": "Period",
  "qualite.periodeJours": "Last {{n}} days",
  "qualite.versionVue": "Version (release view)",
  "qualite.toutesVersions": "All versions",
  "qualite.chargement": "Computing quality indicators…",
  "qualite.refus": "This project is not accessible with your account: ask its owner for access.",
  "qualite.vide": "No measurement yet",
  "qualite.videVersion": "No defect for this version.",
  "qualite.videAide": "MTTR and reopening will show after the first closed defect.",
  "cmdk.title": "Command palette",
  "cmdk.description": "Search for a screen or an action",
  "app.chargement": "Loading…",
  "app.cetEcran": "this screen",
  "app.chargementEcran": "Loading the screen…",
  "app.refusAdministration": "Your role does not allow you to administer this space.",
  "app.refusOrganisation": "Reserved to the organisation administration.",
  "acces.restreint": "Restricted access",
  "acces.retourTableauDeBord": "Back to the dashboard",
  "echecEcran.region": "{{ecran}} failed",
  "echecEcran.titre": "Unable to open {{ecran}}.",
  "echecEcran.indice": "Navigation is still available. Try again or go back to the dashboard.",
  "echecEcran.reessayer": "Try again",
  "echecEcran.indiceRelance": "The connection seems interrupted. Trying again automatically…",
  "echecEcran.indiceHorsLigne": "You appear to be offline. The screen will reload by itself when the network returns.",
  "echecEcran.indiceEpuise": "The connection seems interrupted. Check it, then try again.",
  "livrer.ouvrirRaison": "Open: {{titre}}",
  "livrer.preuveCampagnes": "{{titre}}: {{etat}}",
  "livrer.preuveRecetteAccordee": "acceptance granted",
  "livrer.preuveRecetteAFaire": "acceptance to do",
  "livrer.preuveRecetteNonCalculee": "acceptance not computed",
  "livrer.preuveRevision": "revision {{sha}}",
  "scorecard.sloNom.generation_success_rate": "Generation success rate",
  "scorecard.sloNom.decision_latency": "Decision latency (avg.)",
  "scorecard.sloNom.backlog_progress": "Backlog progress",
  "repartition.titre": "Backlog breakdown by status",
  "repartition.aide": "Stories and defects, count and points per column of the project's workflow.",
  "repartition.chargement": "Computing the breakdown…",
  "repartition.vide": "No story or defect in the backlog",
  "repartition.videAide": "The backlog is generated from an approved specification or filled by hand.",
  "repartition.versBacklog": "Open the backlog",
  "repartition.statut": "Status",
  "repartition.nombre": "Count",
  "repartition.points": "Points",
  "versions.code.NON_REGRESSION_NO_BASELINE": "No previous campaign to compare",
  "versions.code.NO_REGRESSION": "No regression",
  "versions.code.REGRESSIONS_ACCEPTED": "Regression(s) accepted",
  "versions.code.REGRESSION_NOT_ACCEPTED": "Regression(s) not accepted",
  "versions.code.RECETTE_GRANTED": "Business acceptance granted",
  "versions.code.RECETTE_MISSING": "Business acceptance to do: no acceptance campaign certifies the version",
  "versions.code.RECETTE_NOT_GRANTED": "Business acceptance not granted",
  "versions.code.SIGNED_ARTEFACTS_MISSING": "Revision(s) without a recorded signed image and SBOM",
  "versions.code.SIGNED_ARTEFACTS_NO_REVISION": "No revision retained: nothing to sign",
  "versions.code.SIGNED_ARTEFACTS_PRESENT": "Image, signature and SBOM recorded",
  "versions.code.SIGNED_IMAGE_MISSING_FROM_HOST": "Signed image missing from the host: rebuild and re-sign the revision",
  "vueProjet.versionItems": "{{n}} item(s)",
  "vueProjet.preteOui": "yes",
  "vueProjet.preteNon": "no",
  "vueProjet.raisonsBloquantes": "{{n}} blocking reason(s)",
  "vueProjet.dontPremiere": ", including: {{raison}}",
  "n28.role.metier": "business",
  "n28.role.po": "product owner",
  "n28.role.dev": "developer",
  "n28.role.testeur": "tester",
  "n28.role.release": "release manager",
  "n28.role.proprietaire": "owner",
  "n28.action.planMission": "Approve the plan of mission {{objet}}",
  "n28.action.decider": "Decide: {{objet}}",
  "n28.action.approuver": "Approve {{nature}}",
  "n28.action.approuverProjet": "Approve {{nature}} — {{projet}}",
  "n28.action.trancherTache": "Settle the stopped task {{objet}}",
  "n28.action.tacheArretee": "Colony task stopped: {{objet}}",
  "n28.action.verifierAnomalie": "Verify the resolved defect {{objet}}",
  "n28.action.rendreDerogation": "Close the expired waiver {{objet}}",
  "n28.action.approbationAncienne": "Decide the oldest pending approval",
  "n28.action.executerCampagne": "Run the remaining cases of campaign #{{id}}",
  "n28.action.retablirDeploiement": "Restore the failed deployment {{version}} ({{env}})",
  "n28.action.approuverVersion": "Approve the ready version {{version}}",
  "n28.action.approuverMiseEnLigne": "Approve the go-live of {{version}}",
  "n28.action.budgetErreur": "Error budget {{slo}} at {{pct}} %",
  "n28.action.voirApercu": "See the preview of revision {{revision}}",
  "n28.action.accepterItem": "Accept the generated item “{{titre}}”",
  "n28.action.specifierDemande": "Specify the framed request “{{titre}}”",
  "n28.action.poursuivre": "Continue “{{titre}}”",
  "n28.nature.specification": "the specification",
  "n28.nature.decision": "the decision",
  "n28.nature.plan": "the plan",
  "n28.nature.design": "the design",
  "n28.nature.backlog": "the backlog",
  "n28.nature.campagne": "the test campaign",
  "n28.nature.version": "the version",
  "n28.nature.code": "the generated code",
  "n28.nature.artefact": "the artifact",
  "n28.regleN": "rule {{n}}: {{regle}}",
  "n28.regleSautees": "{{base}}; {{n}} action(s) skipped: refused before the click",
  "n28.regle.metier.1": "business acceptance or go-live to approve",
  "n28.regle.metier.2": "specification to review in business register",
  "n28.regle.metier.3": "new preview to see",
  "n28.regle.metier.4": "request “to see”",
  "n28.regle.po.1": "mission plan to approve",
  "n28.regle.po.2": "pending approval",
  "n28.regle.po.2_5": "rework items of an approved change request",
  "n28.regle.po.3": "colony task stopped for more than 24 h",
  "n28.regle.po.4": "generated items to accept",
  "n28.regle.po.5": "framed request not specified",
  "n28.regle.po.6": "technology change request to examine",
  "n28.regle.dev.1": "stopped task to settle",
  "n28.regle.dev.2": "mission file to review",
  "n28.regle.dev.3": "item assigned to me in progress",
  "n28.regle.testeur.1": "resolved defect to verify",
  "n28.regle.testeur.2": "open campaign with runs to do",
  "n28.regle.testeur.3": "requirement without a test",
  "n28.regle.release.1": "failed deployment",
  "n28.regle.release.2": "stage approval pending",
  "n28.regle.release.3": "ready version not approved",
  "n28.regle.release.4": "error budget ≥ 80 %",
  "n28.regle.proprietaire.1": "expired waiver",
  "n28.regle.proprietaire.2": "technology change request to approve",
  "n28.regle.proprietaire.3": "template migration available",
  "grp.Projet": "Project",
  "demandes.etat.idee": "Idea",
  "demandes.etat.cadree": "Framed",
  "demandes.etat.specifiee": "Specified",
  "demandes.etat.en-construction": "Being built",
  "demandes.etat.a-voir": "To see",
  "demandes.etat.livree": "Delivered",
  "demandes.etat.abandonnee": "Abandoned",
  "demandes.attente.idee": "the decision on the framing",
  "demandes.attente.cadree": "the writing of the specification",
  "demandes.attente.specifiee": "planning and construction",
  "demandes.attente.enConstruction": "the end of construction by the colony",
  "demandes.attente.aVoir": "verification and delivery",
  "demandes.attente.livree": "nothing: delivered",
  "demandes.attente.abandonneeMotif": "nothing: abandoned ({{motif}})",
  "demandes.attente.abandonnee": "nothing: abandoned",
  "demandes.age.minutes": "{{n}} min",
  "demandes.age.heures": "{{n}} h",
  "demandes.age.jours": "{{n}} d",
  "demandes.suite.etapeEchec": "failed",
  "demandes.suite.attente.cadrageEnCours": "the framing generation",
  "demandes.suite.attente.cadrageEchoue": "relaunching the framing, which failed",
  "demandes.suite.attente.redactionEnCours": "the end of the specification drafting",
  "demandes.suite.attente.redactionEchouee": "a new specification draft, the previous one failed",
  "demandes.suite.attente.specADecider": "the decision on the drafted specification",
  "demandes.suite.relanceToast": "Framing relaunched",
  "demandes.suite.cadrageEnCours": "The framing is being generated; this page updates itself.",
  "demandes.suite.cadrageEchoue": "The framing of this request failed: no framing awaits a decision.",
  "demandes.suite.redactionEchouee": "The specification drafting failed: no specification awaits a decision.",
  "demandes.suite.workerPerdu": "The worker no longer responds for this job.",
  "demandes.suite.causeInconnue": "Cause not reported by the worker.",
  "demandes.suite.redactionEnCours": "The specification is being drafted; it will come back for approval.",
  "demandes.suite.voirSpec": "Open the decisions to make",
  "demandes.suite.relancerCadrage": "Relaunch the framing",
  "demandes.suite.autres": "Other next steps of the framing (options, personas, processes, epics)",
  "gitlab.indisponible": "GitLab is temporarily unavailable. Check the SCM connection, then try again.",
  "gitlab.connexionActive": "GitLab connection active",
  "gitlab.nonConfigure": "GitLab not configured",
  "gitlab.configAilleurs": "Configuration and tokens are managed in Administration → Integrations.",
  "gitlab.proprietaireDoitConnecter": "An owner must connect GitLab before pipelines can be followed here.",
  "gitlab.ouvrirConfiguration": "Open the GitLab configuration",
  "gitlab.filtrerPipelines": "Filter pipelines by status",
  "gitlab.statut.tous": "All statuses",
  "gitlab.statut.succes": "Success",
  "gitlab.statut.echec": "Failed",
  "gitlab.statut.enCours": "Running",
  "gitlab.statut.enAttente": "Pending",
  "gitlab.rechercherPipeline": "Search a pipeline branch or SHA",
  "gitlab.brancheOuSha": "Branch or SHA…",
  "gitlab.jobsDuPipeline": "Jobs of pipeline #{{n}}",
  "gitlab.branches": "Branches",
  "gitlab.rechercherBranche": "Search a branch or SHA",
  "gitlab.rechercherBrancheIndice": "Search a branch or SHA…",
  "gitlab.brancheDefaut": "default",
  "gitlab.brancheProtegee": "protected",
  "gitlab.deconnecte": "GitLab connection removed",
  "gitlab.deconnecterTitre": "Remove this project's GitLab connection?",
  "gitlab.deconnecterConsequence": "The address, project and encrypted token are erased; pipelines, branches and merge requests can no longer be read.",
  "gitlab.deconnecterLivraison": "A version that requires a GitLab pipeline cannot be promoted until the connection is set up again.",
  "gitlab.deconnecterReversible": "You can reconnect the project with a new token.",
  "gitlab.deconnecter": "Remove the connection",
  "deliveryOverview.sante.sain": "Healthy",
  "deliveryOverview.sante.malade": "Unhealthy",
  "deliveryOverview.sante.nonConfigure": "Not configured",
  "deliveryOverview.sante.nonVerifie": "Not checked",
  "runops.portee.programme": "Programme",
  "runops.portee.projet": "Project",
  "runops.duree.ephemere": "ephemeral",
  "runops.duree.persistant": "persistent",
  "runops.arretAuto": "{{n}} min before automatic stop",
  "admin.confirmerDepart": "Confirm departure",
  "admin.invitationCreee": "Invitation created",
  "admin.invitationRevoquee": "Invitation revoked",
  "admin.departConfirme": "Departure confirmed",
  "admin.invitations": "Invitations",
  "admin.inviterParEmail": "Invite by email",
  "admin.invitationEmail": "Invitation email",
  "admin.invitationRole": "Invitation role",
  "admin.inviter": "Invite",
  "admin.lienInvitationPour": "Invitation link for {{email}} — send it to this person; it will not be shown again. They will also find the invitation in their attention box once signed in.",
  "admin.lienInvitation": "Invitation link",
  "admin.copierLien": "Copy the link",
  "admin.masquer": "Hide",
  "admin.revoquer": "Revoke",
  "admin.nMembres": "{{n}} member(s)",
  "config.model.tone.pending": "Pending (grey)",
  "config.model.tone.running": "Running (blue)",
  "config.model.tone.info": "Information (neutral)",
  "config.model.tone.success": "Success (green)",
  "config.model.tone.warning": "To review (amber)",
  "config.model.tone.blocked": "Blocked (red)",
  "config.model.tone.error": "Failed (red)",
  "planifier.dor.NON_ACCEPTEE": "story not accepted",
  "planifier.dor.CRITERES_ABSENTS": "acceptance criteria missing",
  "planifier.dor.LIEN_REQ_ABSENT": "no link to a requirement",
  "planifier.dor.RECU_SPEC_GATE_ABSENT": "Spec Gate receipt missing",
  "planifier.dor.ESTIMATION_ABSENTE": "estimate missing",
  "planifier.dor.TESTS_NON_CONCUS": "tests not designed",
  "planifier.dor.DEPENDANCE_OUVERTE": "blocking dependency open",
  "planifier.dor.OBJECTIF_ABSENT": "objective missing",
  "planifier.dor.PERIMETRE_NON_VALIDE": "scope not validated",
  "planifier.dor.RISQUES_NON_IDENTIFIES": "risks not identified",
  "planifier.dor.TRACABILITE_ABSENTE": "traceability missing",
  "planifier.dor.US_ABSENTES": "no story",
  "planifier.dor.US_NON_PRETES": "stories not ready",
  "planifier.dor.TAILLE_CONTEXTE_32K": "size ≤ 32 K of context",
  "planifier.dor.LIGNES_REVUE_400": "≤ 400 lines of review",
  "missions.filtre.toutes": "All",
  "missions.filtre.a-approuver": "Plan to approve",
  "missions.filtre.en-cours": "Running",
  "missions.filtre.en-attente": "Waiting",
  "missions.filtre.arretees": "Stopped",
  "missions.filtre.reussies": "Succeeded",
  "missions.filtre.echouees": "Failed",
  "livrer.continuite.sain": "Healthy",
  "livrer.continuite.non-mesure": "not measured — restore never tested",
  "livrer.continuite.perime": "Stale",
  "livrer.continuite.echec": "Failed",
  "livrer.continuite.absent": "Missing",
  "livrer.continuite.hors-cible": "Off target",
  "livrer.verdict.prete": "ready",
  "livrer.verdict.pas-prete": "not ready",
  "livrer.verdict.non-etablie": "not established",
  "livrer.etat.ok": "green",
  "livrer.etat.bloquant": "blocking",
  "livrer.etat.avertissement": "warning",
  "livrer.etat.information": "information",
  "livrer.etat.non-calcule": "not computed",
  "livrer.raison.status": "Status",
  "livrer.raison.revisions": "Revision checks",
  "livrer.raison.spec_gate": "Spec Gate",
  "livrer.raison.items": "Delivered items",
  "livrer.raison.campaigns": "Version tests",
  "livrer.raison.acceptance": "Business acceptance",
  "livrer.raison.defects": "Defects",
  "livrer.raison.requirements": "Requirements",
  "livrer.raison.waivers": "Waivers in force",
  "livrer.raison.non_regression": "Non-regression",
  "livrer.raison.notes": "Release notes",
  "livrer.raison.signed_artifacts": "Signed artifacts",
  "livrer.miseEnLigneEtat.approuvee": "approved",
  "livrer.miseEnLigneEtat.refusee": "refused",
  "livrer.miseEnLigneEtat.a-approuver": "to approve",
  "livrer.miseEnLigneEtat.aucune": "not requested",
  "livrer.recette.accordee": "Acceptance: granted",
  "livrer.recette.a-faire": "Acceptance: to do",
  "livrer.recette.inconnue": "Acceptance: not computed by this server",
  "audit.pseudonymiseHint": "For an external auditor: they check that the creator differs from the approver without receiving the staff directory. The integrity check remains valid.",
  "config.model.workflowHint": "Key, label and allowed transitions (target status keys, comma-separated). The order defines the display.",
  "config.modeHint": "“Manual” mode refuses any AI generation; light auto-acceptance brings in generated items already accepted.",
  "config.modeSinglePolicyHint": "A single mode is applied at publication. The other rows are only the policies available in the catalogue, not competing configurations.",
  "runops.envRankAide": "A release reaches a rank only after succeeding on a LOWER rank. Two stages of the same rank are parallel, not successive.",
  "runops.newEnvironmentDesc": "A stage is a promotion step: it answers “which version runs here, and since when?”.",
  "runops.relCommitAide": "The commit the release comes from. Without it the release would not be traceable — which is why the gateway requires it.",
  "runops.newReleaseDesc": "A release ties a version to a precise commit. It is then promoted stage by stage, in rank order.",
  "runops.voirTrace": "End-to-end trace",
  "envFiche.champ.source_scope": "Defined at level",
  "envFiche.champ.url": "Address",
  "envFiche.champ.target_type": "Target",
  "envFiche.champ.compose_file": "Compose file",
  "envFiche.champ.healthcheck_url": "Health check",
  "envFiche.champ.image_policy": "Image policy",
  "envFiche.champ.auto_stop_minutes": "Automatic stop (min)",
  "envFiche.champ.source_dir": "Source directory",
  "envFiche.champ.source_ref_pattern": "Allowed branches and tags",
  "envFiche.champ.require_gitlab_pipeline": "GitLab pipeline required",
  "envFiche.champ.technologies": "Technologies",
  "envFiche.champ.test_command": "Test command",
  "envFiche.champ.lifetime_type": "Lifetime",
  "envFiche.champ.contract_version": "Contract version",
  "envFiche.champ.source_verified": "Source verified",
  "envFiche.chargement": "Loading the environment…",
  "envFiche.introuvable": "Environment not found",
  "envFiche.introuvableAide": "It is neither declared in this project nor inherited from its programme.",
  "envFiche.titre": "Environment {{nom}}",
  "envFiche.description": "What runs there, the effective resolution contract and the deployments on this stage.",
  "envFiche.enService": "In service",
  "envFiche.vide": "empty stage",
  "envFiche.sante": "Health",
  "envFiche.effectif": "Effective resolution contract",
  "envFiche.chargementEffectif": "Resolving the environment…",
  "envFiche.deploiements": "Deployments on this stage",
  "envFiche.chargementDeploiements": "Loading deployments…",
  "envFiche.aucunDeploiement": "No deployment",
  "envFiche.aucunDeploiementAide": "A deployment is started from a ready version (Delivery › Versions).",
  "traceDeploiement.chargement": "Loading the deployment trace…",
  "traceDeploiement.introuvable": "Deployment not found",
  "traceDeploiement.introuvableAide": "It does not exist in the open project.",
  "traceDeploiement.titre": "Trace of deployment {{v}} on {{env}}",
  "traceDeploiement.description": "From item to stage: version, commit, published items, pipeline, events and status provenance.",
  "traceDeploiement.statut": "Status",
  "traceDeploiement.provenance": "Status provenance",
  "traceDeploiement.parWorker": "worker execution proof",
  "traceDeploiement.manuel": "traced manual entry",
  "traceDeploiement.environnement": "Environment",
  "traceDeploiement.version": "Version",
  "traceDeploiement.commit": "Commit",
  "traceDeploiement.correlation": "Correlation",
  "traceDeploiement.pipeline": "Pipeline",
  "traceDeploiement.sansPipeline": "no pipeline attached",
  "traceDeploiement.livraison": "delivery: {{s}}",
  "traceDeploiement.items": "Items published in this commit",
  "traceDeploiement.aucunItem": "No item attached to this commit",
  "traceDeploiement.aucunItemAide": "An item is attached to a commit when its branch is published (SCM provenance).",
  "traceDeploiement.itemSupprime": "deleted item",
  "traceDeploiement.evenements": "Provider events",
  "traceDeploiement.aucunEvenement": "No event ingested",
  "traceDeploiement.aucunEvenementAide": "Pipeline events arrive through GitLab synchronisation.",
  "runopsFiche.sansProjet": "No project open",
  "runopsFiche.sansProjetAide": "Operations are read per project: open it in the context bar.",
  "config.desc": "How your organisation works, arranged by topic: the work-item model, statuses, links, platform and lifecycle.",
  "login.intro": "A complete, governed and traceable cycle — every artifact generated, reviewed and approved (creator ≠ approver), with model transparency.",
  "markdown.hint": "Markdown supported (headings, lists, tables, links, code); a ```mermaid``` block is rendered as a diagram in the preview.",
  "accueil.po.nonConforme": "failed",
  "accueil.po.nonExecutee": "never run",
  "accueil.po.testsConformes": "tests passing",
  "anomalies.badge.colony": "origin: colony failure",
  "anomalies.badge.product": "origin: product",
  "anomalies.origine.all": "All",
  "anomalies.origine.badge": "colony",
  "anomalies.origine.colony": "Colony failures",
  "anomalies.origine.colonyAide": "A colony task that did not converge is not a product defect: it counts neither in health nor in the quality dashboard. Fix it by relaunching or replanning the mission.",
  "anomalies.origine.compte": "{{o}} open / {{n}}",
  "anomalies.origine.label": "Defect origin",
  "anomalies.origine.product": "Product",
  "anomalies.case.aucun": "No acceptance test case linked: verification and the fix cannot rely on the executed case.",
  "anomalies.case.choisir": "Case the defect came from",
  "anomalies.case.choisirVide": "Choose a case…",
  "anomalies.case.definitif": "The case defines what verification will require: once linked, it no longer changes.",
  "anomalies.case.lie": "Defect linked to its acceptance test case",
  "anomalies.case.rattacher": "Link (final)",
  "anomalies.case.testAValider": "The case's executable test is awaiting validation by another project member. Without a validated test, the verifier designs the hidden tests from the executed case (steps, expected, observed).",
  "anomalies.case.testAbsent": "The case has no executable test. Without a validated test, the verifier designs the hidden tests from the executed case (steps, expected, observed).",
  "anomalies.case.testValide": "test validated by {{qui}} on {{quand}}",
  "anomalies.case.testValideAide": "A fix mission uses it AS IS as its hidden test: it must fail on the current version and pass once the defect is fixed.",
  "anomalies.case.titre": "Acceptance test case and hidden test of the fix",
  "cas.classementEnregistre": "Priority and risk saved",
  "cas.classementTitre": "Priority and risk",
  "cas.classer": "Edit",
  "cas.enregistrer": "Save",
  "cas.priorite": "Priority",
  "cas.priorite.critical": "critical",
  "cas.priorite.high": "high",
  "cas.priorite.low": "low",
  "cas.priorite.medium": "medium",
  "cas.prioriteLue": "Priority: {{v}}",
  "cas.risque": "Risk",
  "cas.risque.high": "high",
  "cas.risque.low": "low",
  "cas.risque.medium": "medium",
  "cas.risque.none": "not assessed",
  "cas.risqueLu": "Risk: {{v}}",
  "cas.test.aValider": "To validate — written by {{qui}}",
  "cas.test.aide": "Written with pytest + httpx. The platform provides the fixtures client_connecte (first account, signed in through the application's own flow), client_second_role (second role), executer_en_parallele(n, function) and the BASE_URL variable. Once validated by another project member, this test becomes, AS IS, the hidden test of any mission that fixes a defect of this case: it must fail on the version that has the defect and pass once it is fixed.",
  "cas.test.aucun": "No executable test",
  "cas.test.auteurNeValidePas": "You wrote it: another project member reviews and validates it.",
  "cas.test.code": "Pytest code of the case",
  "cas.test.ecrire": "Write the test",
  "cas.test.editeur": "Executable test editor",
  "cas.test.empreinte": "fingerprint {{s}}",
  "cas.test.enregistre": "Test saved: another project member must validate it",
  "cas.test.enregistrer": "Save the test",
  "cas.test.lectureSeule": "Read only: only a project contributor writes or validates a test.",
  "cas.test.modifier": "Edit the test",
  "cas.test.modifierRetire": "Saving a change removes the validation: another member will have to review and validate the new version.",
  "cas.test.refusAuteur": "You are the author of this test: another project member reviews and validates it.",
  "cas.test.refusChange": "The test changed since you read it: review the displayed version, then validate it.",
  "cas.test.refusInvalide": "The test must contain at least one pytest function “def test_…()”.",
  "cas.test.titre": "Executable test (acceptance test)",
  "cas.test.valide": "Test validated: it will be used as is as the hidden test of fixes",
  "cas.test.validePar": "Test validated by {{qui}} on {{quand}}",
  "cas.test.validerAction": "Validate this test (I reviewed it)",
  "pas.assigneA": "Assigned to",
  "pas.assigneLu": "assigned to {{u}}",
  "pas.assignesMoi": "Assigned to me",
  "pas.attendu": "Expected: {{v}}",
  "pas.aucunAssigne": "No case is assigned to you in this campaign",
  "pas.aucunCas": "No case in this campaign",
  "pas.aucunCasAide": "Cases come from the campaign plan.",
  "pas.bilan": "Case verdict: {{v}} in {{d}}",
  "pas.campagneFermee": "This campaign is {{s}}: its executions can be read, no longer run.",
  "pas.casDeLaCampagne": "Campaign cases",
  "pas.casHorsCampagne": "This case is not in the campaign",
  "pas.casHorsCampagneAide": "Pick a case from the list.",
  "pas.chargement": "Reading the campaign…",
  "pas.chargementExecution": "Reading the execution…",
  "pas.choisirVerdict": "Choose a verdict for this step.",
  "pas.declarer": "Report the defect (prefilled from step {{n}})",
  "pas.demarrer": "Start the execution",
  "pas.description": "One verdict and one piece of evidence per step; the defect is reported from the red step.",
  "pas.ecrireScenario": "No step: write the scenario",
  "pas.enregistrerEtape": "Save step",
  "pas.etape": "Step {{n}}",
  "pas.executer": "Run step by step",
  "pas.jamaisExecute": "never run",
  "pas.lienCampagne": "Run step by step and assign",
  "pas.nbEtapes": "{{n}} step(s)",
  "pas.nonAssigne": "Unassigned",
  "pas.obtenu": "Observed",
  "pas.obtenuLu": "Observed: {{v}}",
  "pas.obtenuObligatoire": "Observed (required)",
  "pas.obtenuRequis": "Red step: say what was observed.",
  "pas.ouvrirPlans": "Open plans",
  "pas.pasExecutant": "Only the executor ({{u}}) records the verdicts of this execution.",
  "pas.preconditions": "Preconditions: {{v}}",
  "pas.preuve": "Evidence (screenshot, link, output)",
  "pas.preuveLue": "Evidence: {{v}}",
  "pas.priorite": "priority {{v}}",
  "pas.prioriteRisque": "Priority {{p}} · risk {{r}}",
  "pas.retourCas": "← All campaign cases",
  "pas.risque": "risk {{v}}",
  "pas.rougeAide": "Step {{n}} is red: finish the execution, the following steps will be skipped.",
  "pas.statut.cancelled": "cancelled",
  "pas.statut.closed": "closed",
  "pas.termine": "Execution finished: its verdict now counts in the campaign",
  "pas.terminer": "Finish the execution",
  "pas.titre": "Run campaign #{{id}} step by step",
  "pas.verdict.blocked": "Blocked",
  "pas.verdict.failed": "Failed",
  "pas.verdict.passed": "Passed",
  "pas.verdict.running": "Running",
  "pas.verdict.skipped": "Skipped",
  "pas.verdictEtape": "Verdict of step {{n}}",
  "pas.voirCas": "See the cases",
  "qualite.echecsColonie": "{{n}} colony failure(s), {{o}} of them open, are tracked separately.",
  "qualite.perimetreProduit": "Product defects only.",
  "trace.anomalies": "Defects",
  "trace.aucunCas": "No linked test case.",
  "trace.aucunCritere": "The specification cites no criterion for this requirement.",
  "trace.aucuneAnomalie": "No linked defect.",
  "trace.aucunItem": "No backlog item cites this requirement.",
  "trace.cases": "Cases",
  "trace.casEtExecutions": "Cases and latest execution",
  "trace.casGenere": "generated",
  "trace.conformes": "Passed",
  "trace.criteres": "Acceptance criteria",
  "trace.critereSansCas": "(no case cites it)",
  "trace.desc": "Each REQ requirement of the approved specification, its items, the cases that prove it, their latest execution and the defects. Gaps are named.",
  "admin.retentionJoursAide": "Events of the same job leave TOGETHER, judged on the most recent one: cutting a job at the date would break its hash chain and look like tampering.",
  "admin.pseudoHint": "The identifier → pseudonym mapping is never exposed, not even here: revealing it to an administrator would undo what pseudonymisation protects. A pseudonym stays stable across a whole export, which is enough to prove that the creator differs from the approver.",
  "admin.purgeC1": "These events cannot be recovered from any screen: no restore point exists on the server.",
  "admin.purgeC2": "An audit export produced afterwards will no longer contain them — even if an auditor asks for them.",
  "admin.purgeRev": "Irreversible. Generate and download an audit export first if these logs must be kept outside the product.",
  "admin.purgeObsolete": "If the volume changed since the simulation, the server refuses the purge: destroying a volume different from the one you were shown would not be the same operation.",
  "admin.addMemberHint": "Existing users only (identifier or user name). Email invitation and Keycloak provisioning are out of scope.",
  "admin.noModelRestrictionWarn": "Choose a model in the catalogue below to allow generations in this space. The model must also be enabled for the organisation.",
  "admin.modelRemoveDernier": "This is the LAST one in the list: removing it blocks generations until another model is explicitly allowed.",
  "admin.polCleAide": "An attribute ABSENT at decision time never satisfies the condition: the rule then does not apply.",
  "admin.policiesDesc": "Rules on the resource attributes, not only on the role. This is what expresses separation of duties — “the approver is not the creator” — without multiplying roles.",
  "admin.polVideHint": "Only the role decides today. Add a rule below to set a condition a role cannot express.",
  "admin.polDeleteDeny": "This is a DENY: deleting it ALLOWS what it forbade, for every caller concerned.",
  "admin.polDeleteAllow": "This is an exception grant: deleting it brings the decision back to the role alone.",
  "admin.simDesc": "Queries the server's REAL decision, not a reconstruction: what this simulator answers is what the product will do.",
  "admin.quotaResetC1": "The counter restarts from zero: consumption already made stops being counted.",
  "admin.quotaNoCatalogHint": "The gateway did not return the list of resources: without it, free input would create a quota that nothing reads.",
  "admin.quotaUpsertHint": "A resource already limited gets its value replaced: there can be only one limit per resource and per space.",
  "admin.rbacScopeDesc": "The matrix is not attached to a space: granting a permission to a role gives it in every project of the tenant, not only this one. Roles themselves come from the realm and are not created here.",
  "admin.workersScopeDesc": "The heartbeat table carries no tenant: these workers serve the whole installation. What you see and purge here concerns everyone. Only technical data is exposed — identifier, freshness, engine.",
  "admin.workersVideHint": "The worker runs on the host, where the GPU lives: no container starts it. Launch it with “make worker”.",
  "admin.workerPurgeC1": "The row disappears from the supervision of the WHOLE installation, not only this organisation.",
  "admin.workerPurgeC2Vivant": "This worker is still beating: it will re-register its row within seconds. The server will refuse.",
  "admin.workerPurgeRev": "A restarting worker recreates its row, but its job history starts again from zero.",
  "config.viewingOnly": "Default is the built-in model, read-only. To adapt it, duplicate it: the copy (organisation template) becomes fully editable.",
  "chat.admissionWait": "Engine busy — retrying in {{s}} s.",
  "dashboard.archiveWorkspace": "Archive {{nom}}",
  "ingestion.uploadProgressValue": "Progress: {{progress}} %",
  "ingestion.confirmDelete": "Permanently delete {{fichier}} and its vectors?",
  "admin.rbacDernierAdminC1": "Removing “{{permission}}” from the last role that holds it would close administration to the whole organisation, with no way to reopen it from the product.",
  "equipe.membreRetire": "Member removed from the team",
  "equipe.supprimee": "Team deleted; its items are kept, without a team",
  "equipe.versEquipes": "Project members and teams",
  "equipe.sansProjet": "No project open",
  "equipe.sansProjetAide": "A team belongs to a project: open it in the context bar.",
  "equipe.chargement": "Loading the team…",
  "equipe.introuvable": "Team not found",
  "equipe.introuvableAide": "It does not (or no longer) exist in the open project.",
  "equipe.retirerTitre": "Remove {{nom}} from the {{equipe}} team?",
  "equipe.retirerConsequence": "{{nom}} remains a project member with the same role; only their team membership disappears.",
  "equipe.retirerReversible": "You can add them again from Members and teams.",
  "equipe.retirer": "Remove from the team",
  "equipe.supprimerTitre": "Delete the {{equipe}} team?",
  "equipe.supprimerMembres": "Its {{n}} member(s) remain project members.",
  "equipe.supprimerItems": "Its {{n}} item(s) are kept and become “no team”.",
  "equipe.supprimerIrreversible": "The team cannot be restored; the deletion is recorded in the audit log.",
  "equipe.supprimer": "Delete the team",
  "equipe.titre": "Team — {{nom}}",
  "equipe.sansDescription": "Members, work assigned to the team and active sprint load.",
  "equipe.lectureSeule": "Read only: managing a team is reserved for the project owner or the organisation's administration.",
  "equipe.charge": "Load and capacity",
  "equipe.items": "item(s) in the team",
  "equipe.points": "estimated point(s)",
  "equipe.membres": "member(s)",
  "equipe.sansSprint": "No active sprint in the project.",
  "equipe.chargeSprint": "{{items}} item(s), {{points}} point(s) for the team",
  "equipe.capaciteSprint": "declared sprint capacity: {{j}} person-day(s)",
  "equipe.capaciteNonDeclaree": "sprint capacity not declared",
  "equipe.membresTitre": "Members",
  "equipe.aucunMembre": "No member",
  "equipe.aucunMembreAide": "A project member is added from Members and teams.",
  "equipe.horsProjet": "no longer a project member",
  "equipe.compteInactif": "account deactivated",
  "equipe.assignes": "{{n}} item(s) assigned in the team",
  "equipe.itemsTitre": "Work assigned to the team",
  "equipe.aucunItem": "No item",
  "equipe.aucunItemAide": "An item is assigned to a team from its page (Team field).",
  "equipe.role.owner": "owner",
  "equipe.role.contributor": "contributor",
  "equipe.role.viewer": "viewer",
  "livrer.budgetEpuise": "The application’s incident margin is exhausted. You can still go live: this is a warning, no justification is required.",
  "versions.summaryLivree": "Last delivered: {{version}} ({{envs}})",
  "versions.summaryAucuneLivree": "Last delivered: none",
  "versions.summaryDeployeeNonLivree": "Deployed: {{version}} ({{envs}}), not yet declared delivered",
  "pgmVue.deployeeNonLivree": "deployed: {{v}} ({{env}}), not yet declared delivered",
  "pgmVersions.regleLivree": "“Delivered”: declared delivered in the project, which requires a successful deployment on an approved environment; an undeclared deployment is shown as “deployed”.",
  "trace.emptyItems": "No implementable item",
  "trace.emptyItemsHint": "Break a specification down into features, stories and tasks.",
  "trace.item": "Item",
  "trace.items": "Items",
  "trace.itemsConformes": "Passing tests",
  "trace.itemsImplementables": "Items",
  "trace.itemsRelies": "Linked items",
  "trace.nonConformes": "Failed",
  "trace.nonCouvertes": "Without test case",
  "trace.nonExecutees": "Never run",
  "trace.noWorkspaceHint": "Traceability is read within a project.",
  "trace.openDefects": "Open defects",
  "trace.openProofShort": "Explore",
  "trace.origineColonie": "colony",
  "trace.origineProduit": "product",
  "trace.orphelins": "Cases linked to no requirement ({{n}})",
  "trace.ouvrirSpecs": "Open specifications",
  "trace.quoiItems": "items",
  "trace.source": "Approved specification: version {{v}} (approval #{{id}})",
  "trace.sourceAucune": "No approved specification",
  "trace.statut.failed": "failed",
  "trace.statut.notCovered": "not covered",
  "trace.statut.notRun": "never run",
  "trace.statut.passed": "passed",
  "trace.testsDetail": "{{cas}} linked case(s), {{jobs}} test design job(s)",
  "trace.titre": "Coverage and traceability",
  "trace.trous": "Coverage gaps",
  "trace.verdict.failed": "failed",
  "trace.verdict.notRun": "never run",
  "trace.verdict.passed": "passed",
  "trace.via.child": "child of an item that cites it",
  "trace.via.cites": "cites the requirement",
  "trace.via.parent": "holds the task that cites it",
  "trace.videReq": "No REQ requirement in the approved specification",
  "trace.videReqAide": "Requirements come from the « REQ-01 — … » headings of the approved specification: get a specification approved.",
  "trace.vueExigences": "By requirement",
  "trace.vueItems": "By backlog item",
  "trace.vues": "Traceability views",
  "versions.parCorrectif": "fix delivered by this version",
  "versions.code.REGRESSION_SUITE_NOT_RUN": "The regression suite has not been run on this version",
  "preteEnv.titre": "Ready for which environment?",
  "preteEnv.aucunEnv": "No environment declared",
  "preteEnv.cible": "Target environment",
  "preteEnv.choisir": "Choose an environment…",
  "preteEnv.chargement": "Evaluating for this environment…",
  "preteEnv.prete": "ready",
  "preteEnv.pasPrete": "not ready: {{n}} blocking reason(s)",
  "preteEnv.approbation": "approval: {{s}}",
  "preteEnv.nonDemandee": "not requested",
  "preteEnv.deployable": "Deployable to this environment",
  "preteEnv.nonDeployable": "Not yet deployable to this environment:",
  "docLivraison.retour": "Back to the version",
  "docLivraison.sansProjet": "No project open",
  "docLivraison.sansProjetAide": "A version belongs to a project: open it in the context bar.",
  "docLivraison.inconnu": "Unknown document",
  "docLivraison.chargement": "Loading delivery documents…",
  "docLivraison.versionIntrouvable": "Version not found",
  "docLivraison.versionIntrouvableAide": "It does not exist in the open project.",
  "docLivraison.description": "Delivery document generated from the version's objects, without a language model.",
  "docLivraison.nonGenere": "Not generated yet",
  "docLivraison.nonGenereAide": "Generate the documentation from the version page (Delivery documentation).",
  "docLivraison.version": "Document version",
  "docLivraison.generePar": "Generated by",
  "docLivraison.generateur": "Generator",
  "docLivraison.empreinte": "Fingerprint",
  "docLivraison.telecharger": "Download ({{f}})",
  "docLivraison.lecture": "Reading the document…",
  "agile.bulkFieldAssigne": "the assignee",
  "agile.sprintDeLUs": "Story's sprint: {{nom}}",
  "agile.bulkAssigneLabel": "Assignee (bulk)",
  "agile.bulkAssignePlaceholder": "Assignee…",
  "agile.aucunResultat": "No item matches the filters",
  "agile.aucunResultatHint": "Widen or clear the filters: the backlog itself is not empty.",
  "agile.effacer": "Clear filters",
  "agile.rangPose": "“{{titre}}” dropped at position {{pos}} of {{n}}.",
  "agile.rangSaisi": "“{{titre}}” grabbed, position {{pos}} of {{n}}. Arrows to move, Space to drop, Escape to cancel.",
  "agile.rangDeplace": "Position {{pos}} of {{n}}.",
  "agile.rangAnnule": "Move cancelled.",
  "agile.rangAide": "Handle: Space to grab the row, up and down arrows to move it, Space or Enter to drop it, Escape to cancel.",
  "agile.rangListe": "Rows of {{groupe}}, in backlog order",
  "agile.rangPoignee": "Move “{{titre}}”",
  "monTravail.echeanceDepassee": "overdue: {{d}}",
  "monTravail.echeance": "due: {{d}}",
  "monTravail.titre": "My work",
  "monTravail.toutVoir": "See all, every project",
  "monTravail.chargement": "Reading your work…",
  "monTravail.erreur": "Your work could not be read.",
  "monTravail.nItems": "{{n}} assigned item(s)",
  "monTravail.nAnomalies": "{{n}} defect(s)",
  "monTravail.nDecisions": "{{n}} decision(s) to make",
  "monTravail.aucunItem": "No item is assigned to you.",
  "monTravail.description": "What is assigned to you and what awaits your decision, across all your projects.",
  "monTravail.sansProjet": "You are not a member of any project",
  "monTravail.sansProjetHint": "Ask an owner to add you, or open your invitations.",
  "monTravail.invitations": "My invitations",
  "monTravail.vide": "Nothing is waiting for you",
  "monTravail.videHint": "No item or defect is assigned to you, and no decision awaits your opinion.",
  "monTravail.mesItems": "My items",
  "monTravail.mesAnomalies": "My defects",
  "monTravail.decisions": "Decisions to make",
  "monTravail.demandePar": "requested by {{qui}}",
  "monTravail.campagnes": "Campaigns to run",
  "monTravail.nonAccessibles": "{{n}} other project(s) of the organisation are not open to you.",
  "agile.sprintHeriteTitre": "Sprint of its parent story: the item has no sprint of its own.",
  "agile.viaUs": "(via story #{{id}})",
  "agile.assigneLabel": "Assignee",
  "agile.assigneMisAJour": "Assignment updated",
  "agile.changerAssigne": "Change the assignee",
  "agile.decomposerAvantCode": "This item breaks down into smaller ones; code is produced from a task.",
  "agile.assigneAgent": "Assigned to an agent: {{ref}}",
  "agile.agent": "Agent",
  "agile.assigneParti": "{{nom}} is no longer an active member of the project: reassign the item.",
  "agile.membreParti": "(former member)",
  "agile.assigneA": "Assigned to {{nom}}",
  "agile.moi": "(me)",
  "agile.assignerMoi": "Me",
  "agile.membresIllisibles": "Members unreadable",
  "agile.annuaireRetirer": "Choose someone else",
  "agile.annuairePlaceholder": "Name, username or e-mail…",
  "agile.annuaireChargement": "Searching…",
  "agile.annuaireRefus": "Reserved to a project owner or the organisation’s administration: you cannot add members here.",
  "agile.annuaireErreur": "The directory could not be read.",
  "agile.annuaireListe": "Users of the organisation",
  "agile.annuaireAucun": "No user of the organisation matches, or they are already a member.",
  "agile.annuaireTous": "Every active user of the organisation is already a member.",
  "agile.avancementLibelle": "{{faites}} / {{total}} done · {{pct}} %",
  "agile.avancement": "Progress",
  "agile.statutCalculeTitre": "Status computed from the children",
  "agile.statutEnregistre": "(recorded: {{statut}})",
  "agile.filtresTravail": "Work filters",
  "agile.filtreTexte": "Text or #id",
  "agile.filtreTextePlaceholder": "ticket, #9…",
  "agile.tousSprints": "All",
  "agile.sansSprint": "No sprint",
  "agile.tous": "All",
  "agile.assigneAMoi": "Me",
  "agile.unAgent": "An agent",
  "agile.effacerFiltres": "Clear filters ({{n}})",
  "agile.anomalieAssignee": "Defect assignment updated",
  "agile.assigneAnomalie": "Assigned to",
  "agile.parentClos": "Status aligned with its children",
  "agile.hierarchie": "Hierarchy",
  "agile.hierarchieChargement": "Reading the hierarchy…",
  "agile.hierarchieErreur": "The hierarchy could not be read.",
  "agile.parent": "Parent",
  "agile.sansParent": "No parent: this item is at the root of the backlog.",
  "agile.filParents": "Parents of the item",
  "agile.enfants": "Children",
  "agile.sansEnfant": "No child yet: add one below or generate them from “AI actions”.",
  "agile.sansEnfantFeuille": "No child: this item is a leaf of the backlog.",
  "agile.tousTermines": "Every child is done, but this item is still open.",
  "agile.clore": "Move to the final status",
  "agile.cloreLecteur": "A contributor can align it.",
  "agile.enfantCree": "Child added",
  "agile.enfantTitreRequis": "A title of at least 3 characters.",
  "agile.nouvelEnfant": "New child",
  "agile.typeEnfant": "Type of the child",
  "agile.ajouterEnfant": "Add",
  "agile.epicSansEnfant": "no child",
  "agile.avancementEpics": "Epic progress",
  "agile.avancementChargement": "Computing progress…",
  "agile.avancementErreur": "Progress could not be read.",
  "agile.aucunEpic": "No epic",
  "agile.aucunEpicHint": "Epics are born from the backlog generated from an approved specification.",
  "agile.avancementEpicsProgramme": "Epic progress by project",
  "agile.aucunProjetMembre": "No project you are a member of",
  "agile.aucunProjetMembreHint": "A project's detail is shown to its members only.",
  "agile.projetsNonAccessibles": "{{n}} project(s) of the programme are not open to you.",
  "agile.addMemberHint": "Search for someone in the organisation by name, username or e-mail. Someone outside the organisation is invited by e-mail below.",
  "agile.personneAAjouter": "Person to add",
  "agile.personneRequise": "Choose the person to add.",
  "nav./mon-travail": "My work",
  "navdesc./mon-travail": "My items, defects, decisions and campaigns, across all my projects, by status and due date",
  "agile.cloreEtapes": "Move to the final status ({{n}} steps)",
  "agile.cloreImpossible": "The workflow does not lead from this status to the final status: change the item with “Edit”.",
  "continuite.statut.reussie": "succeeded",
  "continuite.statut.echec": "failed",
  "continuite.refus.motif": "A reason of at least 10 characters is required.",
  "continuite.refus.inconnue": "This backup is no longer in the journal.",
  "continuite.refus.echec": "A failed backup cannot be restored.",
  "continuite.refus.chemin": "The journal does not say where this backup is stored (entry older than this version).",
  "continuite.refus.nomCible": "Target environment name: 3 to 63 characters a-z, 0-9, - or _.",
  "continuite.refus.doubleConfirmation": "In-place restore: tick the confirmation AND type exactly the requested phrase.",
  "continuite.refus.essaiRequis": "In-place restore refused: no successful restore drill of this backup. Run a restore on a disposable stack first.",
  "continuite.refus.admin": "Reserved to platform administration.",
  "continuite.refus.inattendu": "The gateway refused the request.",
  "continuite.jamais": "DoIt has never been backed up on this host.",
  "continuite.jamaisAide": "Risk accepted in v0.5.0 (DEC-054): DoIt's tooled backup is now available. Request a first backup, then a restore drill.",
  "continuite.demanderSauvegarde": "Request a backup",
  "continuite.derniereEchec": "The last backup failed ({{quand}}). The last successful one dates from {{reussie}}.",
  "continuite.aucune": "none",
  "continuite.ancienne": "Last successful backup on {{quand}}: beyond the target of one backup every {{h}} h.",
  "continuite.essaiJamais": "No restore drill in the journal: a backup that was never restored is not a backup.",
  "continuite.essaiEchecTitre": "Restore drill failed ({{quand}})",
  "continuite.essaiEchecSansMotif": "Content differences after restore.",
  "continuite.ecarts": "{{n}} difference(s)",
  "continuite.essaiOk": "Last restore drill: {{quand}}, target {{cible}}, in {{duree}} s — {{tables}} tables and {{lignes}} rows checked.",
  "continuite.aucuneSauvegarde": "No backup in the journal",
  "continuite.aucuneSauvegardeIndice": "The journal is written by every backup run on the host (make db-backup-once).",
  "continuite.legendeSauvegardes": "DoIt backups: date, state, size, fingerprint, retention and last drill",
  "continuite.col.sauvegarde": "backup",
  "continuite.col.etat": "state",
  "continuite.col.taille": "size",
  "continuite.col.empreinte": "fingerprint (database)",
  "continuite.col.retention": "retention",
  "continuite.col.essai": "last drill",
  "continuite.col.action": "action",
  "continuite.porteeBase": "whole database",
  "continuite.retentionInconnue": "not registered",
  "continuite.retentionRotee": "rotated on {{d}}",
  "continuite.retentionGel": "legal hold",
  "continuite.retentionJusque": "until {{d}}",
  "continuite.retentionIllimitee": "no expiry",
  "continuite.jamaisEssayee": "never drilled",
  "continuite.restaurer": "Restore…",
  "continuite.controles": "{{tables}} tables, {{lignes}} rows",
  "continuite.aucuneDemande": "No request",
  "continuite.aucuneDemandeIndice": "A backup or restore request gives the exact command to run on the host.",
  "continuite.demandeSauvegarde": "Backup",
  "continuite.demandeEnPlace": "IN-PLACE restore",
  "continuite.demandeCible": "Restore onto environment {{nom}}",
  "continuite.demandeJetable": "Restore onto a disposable stack",
  "continuite.executee": "executed",
  "continuite.enAttente": "waiting to be run on the host",
  "continuite.sauvegardeAide": "Gateway PostgreSQL database and MinIO objects, whole database. The gateway runs nothing: it records the request and gives the command to run on the host.",
  "continuite.demandeEnregistree": "Request recorded. Run this command on the host; the backup will appear here, linked to the request.",
  "continuite.motif": "Reason (required, written to the request and to the audit)",
  "continuite.fermer": "Close",
  "continuite.demander": "Request",
  "continuite.cible.jetable": "Disposable stack (drill)",
  "continuite.cible.jetableAide": "Fresh container, destroyed at the end; every table is recounted against the dump. Recommended.",
  "continuite.cible.cible": "Target environment",
  "continuite.cible.cibleAide": "Container kept (standby host), never the current instance.",
  "continuite.cible.enPlace": "In place (current instance)",
  "continuite.cible.enPlaceAide": "Overwrites this installation's database. Double confirmation and a successful drill required.",
  "continuite.restaurerTitre": "Restore backup {{label}}",
  "continuite.restaurerDescription": "Fingerprint {{sha}} · {{taille}} · whole database",
  "continuite.restaurationEnregistree": "Request recorded. To be run on the host; the evidence will appear here, linked to the request.",
  "continuite.cibleLegende": "Where to restore?",
  "continuite.nomCible": "Target environment name",
  "continuite.enPlaceCoche": "I understand that THIS installation's database will be overwritten by backup {{label}}; everything written since will be lost.",
  "continuite.enPlacePhrase": "Type exactly: {{phrase}}",
  "continuite.demanderRestauration": "Request the restore",
  "continuite.chargement": "Reading the backup journal…",
  "continuite.refusAcces": "Platform continuity is reserved to platform administration.",
  "continuite.erreur": "The backup state could not be read.",
  "continuite.journalAbsent": "The backup journal is not readable by the gateway (DOIT_BACKUP_JOURNAL_PATH, mounted read-only from .doit/runtime).",
  "continuite.titreSauvegardes": "Backups of DoIt itself",
  "continuite.lignesInvalides": "{{n}} unreadable journal line(s), ignored and counted.",
  "continuite.nePasConfondre": "Not to be confused with a project's « Application continuity » (Deliver and operate), which backs up the generated application.",
  "continuite.versJournal": "Super-administrator journal",
  "continuite.titreEssais": "Restore drills",
  "continuite.titreDemandes": "Requests",
  "accesExceptionnels.statut.active": "active",
  "accesExceptionnels.statut.revoquee": "revoked",
  "accesExceptionnels.statut.expiree": "expired",
  "accesExceptionnels.refus.motif": "The reason must be at least 20 characters long.",
  "accesExceptionnels.refus.duree": "Duration: 5 to 120 minutes.",
  "accesExceptionnels.refus.propre": "Your own organisation does not call for an exceptional access: join the project.",
  "accesExceptionnels.refus.sansProprietaire": "No project owner to notify in this organisation: an exceptional access is never silent.",
  "accesExceptionnels.refus.dejaActive": "You already have an active session on this organisation.",
  "accesExceptionnels.refus.expiree": "The window is closed: no tacit extension, a new session requires a new reason.",
  "accesExceptionnels.refus.revoquee": "This session has been revoked.",
  "accesExceptionnels.refus.pasLaVotre": "Only the administrator who opened the session can read through it.",
  "accesExceptionnels.refus.dejaRevoquee": "Session already revoked.",
  "accesExceptionnels.refus.inactive": "Session already ended: nothing to revoke.",
  "accesExceptionnels.refus.admin": "Reserved to platform administration.",
  "accesExceptionnels.refus.introuvable": "Organisation not found.",
  "accesExceptionnels.refus.inattendu": "The gateway refused the action.",
  "accesExceptionnels.restantH": "in {{h}} h {{m}} min",
  "accesExceptionnels.restantMin": "in {{m}} min",
  "accesExceptionnels.choisirOrg": "Choose the target organisation.",
  "accesExceptionnels.ouvrirTitre": "Open an exceptional access",
  "accesExceptionnels.ouvrirAide": "Read-only access to a third-party organisation, for an incident its owner cannot handle. Project owners are notified when it opens; every read is written to the audit of both organisations; the session closes by itself at the planned end, with no tacit extension.",
  "accesExceptionnels.organisation": "Target organisation",
  "accesExceptionnels.chargementOrgs": "Loading…",
  "accesExceptionnels.choisir": "— choose —",
  "accesExceptionnels.duree": "Duration (planned end set by the database)",
  "accesExceptionnels.minutes": "{{n}} minutes",
  "accesExceptionnels.motif": "Reason (at least {{n}} characters, shown to the notified owners)",
  "accesExceptionnels.ouverte": "Session open until {{fin}}; {{n}} owner(s) notified.",
  "accesExceptionnels.ouvrir": "Open the exceptional access",
  "accesExceptionnels.lectureTitre": "Reading {{org}} (exceptional access)",
  "accesExceptionnels.fermerLecture": "Close the reading",
  "accesExceptionnels.lectureBandeau": "Read-only until {{fin}}. This read is written to the target organisation's audit.",
  "accesExceptionnels.lectureChargement": "Reading the organisation…",
  "accesExceptionnels.palier": "plan {{p}}",
  "accesExceptionnels.projets": "Projects ({{n}})",
  "accesExceptionnels.aucunProjet": "No project.",
  "accesExceptionnels.programmes": "Programmes ({{n}})",
  "accesExceptionnels.aucunProgramme": "No programme.",
  "accesExceptionnels.missions": "Running missions ({{n}})",
  "accesExceptionnels.aucuneMission": "No running mission.",
  "accesExceptionnels.vous": "you",
  "accesExceptionnels.revoqueeA": "revoked {{quand}} by {{qui}}",
  "accesExceptionnels.notifies": "{{n}} notified",
  "accesExceptionnels.consulter": "Read the organisation",
  "accesExceptionnels.revoquerMienne": "Revoke my session",
  "accesExceptionnels.revoquer": "Revoke now",
  "accesExceptionnels.sansProlongation": "no tacit extension",
  "accesExceptionnels.chargement": "Reading exceptional accesses…",
  "accesExceptionnels.refusAcces": "Exceptional accesses are reserved to platform administration.",
  "accesExceptionnels.erreur": "Exceptional accesses could not be read.",
  "accesExceptionnels.sessionsTitre": "Sessions ({{n}} active)",
  "accesExceptionnels.sessionsAide": "The planned end is set and enforced by the database. A revoked or expired session reads nothing more.",
  "accesExceptionnels.vide": "No exceptional access",
  "accesExceptionnels.videIndice": "Before opening an access, contact the organisation's owner: they act themselves (rollback, stopping a mission). Failing that, suspend the organisation or stop AI at its scope.",
  "accesExceptionnels.legende": "Exceptional access sessions: who, organisation, reason, start, planned end, status",
  "accesExceptionnels.col.qui": "who",
  "accesExceptionnels.col.organisation": "organisation",
  "accesExceptionnels.col.motif": "reason",
  "accesExceptionnels.col.debut": "start",
  "accesExceptionnels.col.fin": "planned end",
  "accesExceptionnels.col.statut": "status",
  "accesExceptionnels.col.action": "action",
  "palier.ressource.documents": "Documents",
  "palier.ressource.taille": "Document size (MB)",
  "palier.ressource.jetons": "Tokens per day",
  "palier.ressource.requetes": "Requests per minute",
  "palier.ressource.appelsIa": "AI calls per day",
  "palier.chargement": "Reading the plan…",
  "palier.refus": "Reserved to the super-administrator (platform administration).",
  "palier.erreur": "The plan could not be read.",
  "palier.choisirNouveau": "Choose a plan different from the current one.",
  "palier.motifObligatoire": "The reason is required.",
  "palier.titre": "Plan of {{org}}",
  "palier.depuis": "since {{quand}} · by {{qui}}",
  "palier.parDefaut": "default plan (never changed)",
  "palier.legendeLimites": "Limits of each plan",
  "palier.col.ressource": "resource",
  "palier.nouveau": "New plan",
  "palier.choisir": "— choose —",
  "palier.actuel": "{{libelle}} (current)",
  "palier.motif": "Reason (required, written to the plan history)",
  "palier.nonChange": "Plan not changed: the gateway refused.",
  "palier.change": "Plan changed: {{palier}} · written to the history and to the audit of {{org}}.",
  "palier.changer": "Change plan",
  "palier.releveTitre": "Monthly statement",
  "palier.mois": "Month",
  "palier.releveChargement": "Reading the statement…",
  "palier.releveErreur": "The statement could not be read.",
  "palier.releveVide": "No usage recorded this month",
  "palier.releveVideIndice": "The statement is filled from the organisation's daily counters (usage_ledger).",
  "palier.legendeReleve": "Usage of the month by counter",
  "palier.col.compteur": "counter",
  "palier.col.total": "month total",
  "palier.col.max": "daily peak",
  "palier.col.jours": "days",
  "palier.historique": "Plan history",
  "palier.historiqueVide": "No change: default plan since creation.",
  "palier.legendeHistorique": "Plan changes: when, from, to, by, reason",
  "palier.col.quand": "when",
  "palier.col.deA": "from → to",
  "palier.col.par": "by",
  "palier.col.motif": "reason",
  "palier.carteTitre": "Plan and statement of an organisation",
  "palier.organisation": "Organisation",
  "palier.chargementOrgs": "Loading…",
  "palier.erreurOrgs": "The organisation list could not be read.",
  "palier.choisirOrg": "Choose an organisation to read and change its plan.",
  "accesBandeau.region": "Platform exceptional access",
  "accesBandeau.titre": "Platform exceptional access in progress until {{fin}}",
  "accesBandeau.detail": "read-only, by {{qui}}: « {{motif}} ». Every read is written to your audit.",
  "organisationsPlateforme.refus.motif": "A reason of at least 10 characters is required.",
  "organisationsPlateforme.refus.missions": "Choose what happens to running missions.",
  "organisationsPlateforme.refus.dejaSuspendue": "Organisation already suspended.",
  "organisationsPlateforme.refus.pasSuspendue": "Organisation already active.",
  "organisationsPlateforme.refus.admin": "Reserved to platform administration.",
  "organisationsPlateforme.refus.introuvable": "Organisation not found.",
  "organisationsPlateforme.refus.inattendu": "The gateway refused the action.",
  "organisationsPlateforme.statut.active": "active",
  "organisationsPlateforme.statut.suspendue": "suspended",
  "organisationsPlateforme.statut.provisionnement": "provisioning",
  "organisationsPlateforme.sante.ok": "healthy",
  "organisationsPlateforme.sante.degradee": "degraded",
  "organisationsPlateforme.sante.indisponible": "unavailable",
  "organisationsPlateforme.suspendreTitre": "Suspend {{nom}}",
  "organisationsPlateforme.reactiverTitre": "Reactivate {{nom}}",
  "organisationsPlateforme.suspendreAide": "Reversible. Members become read-only immediately: every write, new missions included, is refused. {{n}} running mission(s).",
  "organisationsPlateforme.reactiverAide": "Members get write access back. Stopped missions do not resume by themselves.",
  "organisationsPlateforme.suspendue": "Organisation suspended; {{n}} mission(s) stopped. Written to its audit.",
  "organisationsPlateforme.reactivee": "Organisation reactivated. Written to its audit.",
  "organisationsPlateforme.fermer": "Close",
  "organisationsPlateforme.missionsLegende": "Running missions",
  "organisationsPlateforme.laisserFinir": "Let them finish ({{n}} min at most, then stop)",
  "organisationsPlateforme.arreterMaintenant": "Stop now (the current step finishes, nothing else starts)",
  "organisationsPlateforme.motif": "Reason (required, written to the history and to the organisation's audit)",
  "organisationsPlateforme.suspendre": "Suspend",
  "organisationsPlateforme.reactiver": "Reactivate",
  "organisationsPlateforme.chargement": "Reading organisations…",
  "organisationsPlateforme.refusAcces": "The organisation list is reserved to platform administration.",
  "organisationsPlateforme.erreur": "Organisations could not be read.",
  "organisationsPlateforme.titre": "Organisations ({{n}})",
  "organisationsPlateforme.aide": "Attributes and aggregates only, never a project's content. Every action requires a reason and is written to the target organisation's audit.",
  "organisationsPlateforme.vide": "No organisation",
  "organisationsPlateforme.videIndice": "Provision the first one below.",
  "organisationsPlateforme.legende": "Organisations: status, plan, projects, members, missions, month usage, health",
  "organisationsPlateforme.col.organisation": "organisation",
  "organisationsPlateforme.col.statut": "status",
  "organisationsPlateforme.col.palier": "plan",
  "organisationsPlateforme.col.projets": "projects · members",
  "organisationsPlateforme.col.missions": "running missions",
  "organisationsPlateforme.col.conso": "this month (tokens · AI calls)",
  "organisationsPlateforme.col.sante": "health",
  "organisationsPlateforme.col.actions": "actions",
  "organisationsPlateforme.depuis": "since {{quand}} · « {{motif}} »",
  "organisationsPlateforme.palierReleve": "Plan and statement",
  "organisationsPlateforme.suspendreAction": "Suspend…",
  "journalAudit.acteur": "Actor",
  "journalAudit.typeAction": "Action type",
  "journalAudit.toutes": "all",
  "journalAudit.objet": "Object (type:id or id)",
  "journalAudit.du": "From",
  "journalAudit.au": "To (excluded)",
  "journalAudit.masquerBruit": "Hide environment auto-stop",
  "journalAudit.appliquer": "Filter",
  "journalAudit.legende": "Audit journal, most recent first",
  "journalAudit.col.quand": "when",
  "journalAudit.col.organisation": "organisation",
  "journalAudit.col.acteur": "actor",
  "journalAudit.col.action": "action",
  "journalAudit.col.objet": "object",
  "journalAudit.col.detail": "detail",
  "journalAudit.activite": "job activity",
  "journalAudit.exporter": "Export (CSV)",
  "journalAudit.exportEchec": "Export refused or impossible.",
  "journalAudit.chargement": "Reading the journal…",
  "journalAudit.refusProjet": "A project's journal is reserved to its owner.",
  "journalAudit.refusOrganisation": "The whole organisation's journal is reserved to its administration; choose a project you own.",
  "journalAudit.erreur": "The audit journal could not be read.",
  "journalAudit.vide": "No entry for these filters",
  "journalAudit.videIndice": "The journal is written by every action; widen the period or remove a filter.",
  "journalAudit.plage": "{{debut}}–{{fin}} of {{total}}",
  "journalAudit.plusRecents": "More recent",
  "journalAudit.plusAnciens": "Older",
  "journalAudit.sansProjet": "Open a project you own to read its audit journal; the whole organisation's journal is reserved to its administration.",
  "journalAudit.portee": "Scope",
  "journalAudit.porteeOrganisation": "whole organisation",
  "journalAudit.porteeProjet": "open project ({{id}})",
  "journalAudit.titre": "Audit journal",
  "journalAudit.organisation": "Organisation",
  "journalAudit.toutesOrganisations": "all",
  "journalAudit.titrePlateforme": "Platform actions on organisations",
  "provisionner.refus.emailExiste": "An account already exists for this e-mail: enrolment requires a NEW address.",
  "provisionner.refus.emailInvalide": "Invalid e-mail.",
  "provisionner.refus.identifiantPris": "This organisation identifier is already taken.",
  "provisionner.refus.identifiantInvalide": "Identifier: 3 to 50 characters a-z, 0-9 and -, starting with a letter.",
  "provisionner.refus.conflit": "The database refused: nothing was created, the account was deleted.",
  "provisionner.refus.echec": "Provisioning interrupted: nothing was created.",
  "provisionner.refus.dejaActive": "The administrator has already activated their account.",
  "provisionner.refus.nonRevocable": "Link already used or already revoked.",
  "provisionner.refus.admin": "Reserved to platform administration.",
  "provisionner.refus.inattendu": "The gateway refused the action.",
  "provisionner.statut.attente": "pending",
  "provisionner.statut.active": "account activated",
  "provisionner.statut.revoque": "revoked",
  "provisionner.statut.expire": "expired",
  "provisionner.emailEnvoye": "Keycloak sends the activation link to the administrator's address (valid until {{fin}}).",
  "provisionner.lienTitre": "Activation link — shown ONLY ONCE",
  "provisionner.lienAide": "Send it to the administrator through a safe channel. They will choose their password; the link works once and expires on {{fin}}. Lost? Generate a new one: the old one will be revoked.",
  "provisionner.copierLien": "Copy link",
  "provisionner.nomRequis": "Name: at least 3 characters.",
  "provisionner.prenomRequis": "First name required.",
  "provisionner.nomFamilleRequis": "Last name required.",
  "provisionner.titre": "Provision an organisation",
  "provisionner.aide": "The organisation's administrator is created with a NEW e-mail (an existing account is refused). They choose their own password through a single-use activation link.",
  "provisionner.cree": "Organisation {{org}} created; administrator {{email}} enrolled (owner of workspace {{ws}}).",
  "provisionner.emailNonEnvoye": "The activation e-mail could not be sent: generate a link from the list.",
  "provisionner.autre": "Provision another organisation",
  "provisionner.nom": "Organisation name",
  "provisionner.identifiant": "Identifier (optional, e.g. org-essai)",
  "provisionner.email": "Administrator e-mail (new)",
  "provisionner.prenom": "First name",
  "provisionner.nomFamille": "Last name",
  "provisionner.envoyer": "Provision and enrol the administrator",
  "provisionner.liensTitre": "Administrator activation — {{nom}}",
  "provisionner.liensAide": "A link works once and expires. The token can never be read again: only a new link can be shown.",
  "provisionner.liensChargement": "Reading links…",
  "provisionner.liensAucun": "No administrator enrolled by the platform for this organisation.",
  "provisionner.expireLe": "expires on {{fin}}",
  "provisionner.revoquer": "Revoke",
  "provisionner.fermer": "Close",
  "provisionner.nouveauLien": "Generate a new link",
  "activation.trop_court": "At least {{n}} characters.",
  "activation.differents": "The two entries differ.",
  "activation.chargement": "Checking the link…",
  "activation.inconnu": "This activation link is unknown. Ask platform administration for a new link.",
  "activation.erreur": "The link could not be checked.",
  "activation.ok": "Account activated. Sign in with {{identifiant}} and the chosen password.",
  "activation.seConnecter": "Sign in",
  "activation.expire": "This link has expired.",
  "activation.revoque": "This link has been revoked.",
  "activation.utilise": "This link has already been used: the account is activated.",
  "activation.demander": "Ask platform administration for a new link.",
  "activation.intro": "Administrator of {{org}} ({{email}}): choose your password. Link valid until {{fin}}.",
  "activation.motDePasse": "Password (at least 12 characters)",
  "activation.confirmation": "Confirm the password",
  "activation.politique": "The directory refuses this password (security policy): choose a stronger one.",
  "activation.refus": "Activation refused: the link is no longer valid.",
  "activation.envoyer": "Activate my account",
  "activation.titre": "Activate your DoIt account",
  "organisationsPlateforme.activation": "Activation link",
  "newWs.createdLaunchToast": "Project created — launch incomplete: continue with the wizard",
  "newWs.descriptionLancement": "Step 1 of 5: identity and template. The project exists from this step, as an “incomplete launch”; you become its owner and continue the launch (programme, technology choices, team).",
  "newWs.createAndLaunch": "Create and continue the launch",
  "programs.techPlusTard": "Technology choices postponed: the programme inherits the whole organisation catalogue.",
  "adr.stack.fromBaseline": "Profile retained by the project’s technology baseline v{{v}}: it only changes through a change request.",
  "adr.stack.toBaseline": "See “Choices and baseline”",
  "missions.form.reprendreLancement": "Resume the launch",
  "missions.form.voirBaseline": "See “Choices and baseline”",
  "missions.form.appBusySuspended": "It is suspended, waiting for a human decision ({{n}} pending): open it to decide its stops — “Acknowledge all stops and close the mission” ends it — or stop it.",
  "orgProjets.lancementsErreur": "Incomplete launches could not be read.",
  "orgProjets.lancementsTitre": "Incomplete launches",
  "orgProjets.enPreparation": "project in preparation",
  "orgProjets.pasAtteint": "step {{n}} of 5",
  "orgProjets.reprendre": "Resume the launch",
  "orgProjets.nouveau": "New project",
  "lancement.sansProjet": "No project to launch",
  "lancement.sansProjetIndice": "Create a project (“New project”) or resume an incomplete launch from the project list.",
  "lancement.chargement": "Reading the launch…",
  "lancement.refus": "This project is not open to you.",
  "lancement.erreur": "The launch could not be read; nothing changed.",
  "lancement.termine": "Launch completed",
  "lancement.termineIndice": "This project’s technology baseline v1 exists; it only changes through a change request.",
  "lancement.voirBaseline": "See “Choices and baseline”",
  "lancement.titre": "New project — launch",
  "lancement.description": "The project exists from the first step, as an “incomplete launch”; generation and delivery stay refused until the launch is completed.",
  "lancement.pas1": "Identity",
  "lancement.pas2": "Programme and template",
  "lancement.pas3": "Technology choices",
  "lancement.pas4": "Team",
  "lancement.pas5": "Summary",
  "lancement.succes": "Launch completed — baseline v1 created",
  "lancement.annoncePas": "Step {{n}} of {{total}}: {{nom}}",
  "lancement.parentProgramme": "the baseline of programme {{nom}}",
  "lancement.parentOrganisation": "the organisation catalogue",
  "lancement.enPreparation": "project in preparation — incomplete launch",
  "lancement.herite": "inherits from ◆ {{programme}}",
  "lancement.progression": "Launch progress",
  "lancement.titrePas": "Step {{n}} of {{total}}: {{nom}}",
  "lancement.echecBrouillon": "The draft could not be saved: {{message}}",
  "lancement.precedent": "Previous",
  "lancement.enregistrerQuitter": "Save and exit",
  "lancement.suivant": "Next: {{nom}}",
  "lancement.terminer": "Complete the launch",
  "lancement.inacheveAide": "Until the launch is completed, the project stays “in preparation”: Design and Plan are open (sprint 0 possible), generation and delivery are refused.",
  "lancement.retourListe": "Back to projects",
  "lancement.nom": "Project name",
  "lancement.identifiant": "Identifier",
  "lancement.etat": "State",
  "lancement.etatInacheve": "incomplete launch: the project exists, its members can frame and plan; generating and delivering wait for the end of the launch.",
  "lancement.rattacheA": "Attached to programme",
  "lancement.heriteProgramme": "the “Technology choices” step inherits from its baseline (or from the organisation catalogue if the programme has none).",
  "lancement.detacher": "Detach",
  "lancement.programme": "Programme (optional)",
  "lancement.horsProgramme": "No programme: inherit from the organisation catalogue",
  "lancement.rattacher": "Attach",
  "lancement.rattacherRefus": "Attaching a project to this programme belongs to its owner: ask them, or launch the project outside any programme.",
  "lancement.gabarit": "Configuration template",
  "lancement.gabaritDefaut": "Default (built-in)",
  "lancement.gabaritAide": "Chosen at creation; it is changed later in the project settings (migration previewed).",
  "lancement.quiObligatoire": "Enter the member’s identifier or user name.",
  "lancement.membre": "Member (identifier or user name)",
  "lancement.role": "Role",
  "lancement.ajouter": "Add",
  "lancement.equipeAide": "Optional: the team can also be completed later (Project settings).",
  "lancement.heritageChoisi": "Chosen inheritance",
  "lancement.recapCaption": "Baseline v1 that will be created",
  "baseline.colCategorie": "Category",
  "baseline.colValeur": "Value",
  "baseline.colSource": "Source",
  "baseline.colGenerabilite": "Generability",
  "baseline.aDefinir": "Mandatory category: to be defined.",
  "lancement.profilRetenu": "Retained generation profile",
  "lancement.aucunProfil": "none (combination not covered)",
  "lancement.catalogueIncompletAdmin": "The starter set still offers {{n}} entry(ies) your catalogue does not have.",
  "lancement.catalogueVide": "Your organisation has no technology in its catalogue yet.",
  "lancement.catalogueVideAdmin": "Use the starter set: the languages, frameworks, databases and target platforms (web, mobile, desktop) the platform can generate, with their measured generability. You stay in the wizard.",
  "lancement.catalogueVideMembre": "Ask your organisation administrator to apply the technology catalogue starter set. Meanwhile, “Define” lets you enter a value outside the catalogue for this project.",
  "lancement.voirCatalogue": "View the organisation technology catalogue",
  "pgmTech.cree": "Technology choices of programme “{{nom}}” set — baseline v1",
  "pgmTech.pasTitre": "Technology choices of programme “{{nom}}”",
  "pgmTech.parentOrganisation": "the organisation catalogue",
  "pgmTech.plusTard": "Later (inherit everything from the organisation)",
  "pgmTech.valider": "Set the choices (baseline v1)",
  "pgmTech.chargement": "Reading the programme’s technology choices…",
  "pgmTech.refus": "This programme is not open to you: its members read its technology choices.",
  "pgmTech.erreur": "Technology choices unreadable: the gateway did not answer.",
  "pgmTech.titre": "Programme technology choices",
  "pgmTech.description": "The programme standard per category, inherited from the organisation catalogue; attached projects inherit it, or define the category themselves.",
  "pgmTech.baselineTitre": "Baseline — {{nom}} · v{{v}}",
  "pgmTech.versionDe": "v{{v}} of {{date}} · author {{auteur}}",
  "pgmTech.tableCaption": "Programme standard per category",
  "pgmTech.ouverte": "not set by the programme: each project defines it",
  "pgmTech.standard": "programme standard",
  "pgmTech.modifierAVenir": "Change the standard (change request or propagation to inheriting projects): next 0.5.x batch.",
  "pgmTech.vide": "No programme-specific choice",
  "pgmTech.videIndice": "Everything is inherited from the organisation catalogue; each attached project chooses at launch.",
  "pgmTech.definir": "Set the programme choices (v1)",
  "pgmTech.ecartsTitre": "Project deviations",
  "pgmTech.ecartsSansStandard": "Without a programme standard, there is no deviation to measure.",
  "pgmTech.aucunEcart": "No attached project deviates from the standard.",
  "pgmTech.ecartsCaption": "Projects deviating from the programme standard",
  "pgmTech.colProjet": "project",
  "pgmTech.colEcart": "deviation",
  "pgmTech.colEtat": "state",
  "pgmTech.ecartLigne": "{{categorie}}: {{projet}} instead of {{programme}}",
  "pgmTech.ecartsMasques": "{{n}} project(s) not open to you also deviate from the standard — counted, never named.",
  "baseline.combinaisonTitre": "Generability of the combination",
  "baseline.generableColonie": "generable by the colony",
  "baseline.profilCouvrant": "generation profile {{profil}}",
  "baseline.profilNonQualifie": "profile not qualified",
  "baseline.nonGenerable": "not generable",
  "baseline.nonQualifieDetail": "profile {{profil}} covers the combination but is not qualified: {{motif}}",
  "baseline.nonCouvertDetail": "no generation profile covers: {{produits}}",
  "baseline.nonCombineDetail": "no profile covers these products together: {{produits}}",
  "baseline.consequences": "Consequences, stated before the launch:",
  "baseline.consequence1": "no “Generate the application” mission (refused: “combination not covered by a qualified generation profile”);",
  "baseline.consequence2": "framing, specification, backlog, tests and manual delivery (publication, pipelines, deployment) remain possible;",
  "baseline.consequence3": "mode A (agent adapter, experimental) only if the template and governance allow it.",
  "baseline.proche": "Nearest generable combination: {{profil}} without {{sans}} (suggested, never imposed).",
  "baseline.procheProfil": "Nearest generable combination: {{profil}} (suggested, never imposed).",
  "baseline.livraisonManuelle": "Manual delivery accepted (sets the “Generability” health signal)",
  "baseline.sansProjet": "No project selected",
  "baseline.sansProjetIndice": "Choose a project in the context selector.",
  "baseline.chargement": "Reading the technology baseline…",
  "baseline.refus": "This project’s baseline is not open to you.",
  "baseline.erreur": "Baseline unreadable: the gateway did not answer; nothing changed.",
  "baseline.titre": "Choices and baseline",
  "baseline.description": "The project’s technology baseline: per category, the retained value, its source, its generability; it only changes through a change request.",
  "baseline.inachevee": "Incomplete launch: no baseline yet",
  "baseline.inacheveeIndice": "Baseline v1 is created at the end of the launch. Until then, generation and delivery are refused; Design and Plan stay open.",
  "baseline.reprendre": "Resume the launch",
  "baseline.reprendreProprietaire": "The owner or a contributor resumes the launch.",
  "baseline.absente": "No technology baseline",
  "baseline.absenteIndice": "Project created outside the launch wizard: its generation still follows its stack profile (ADR). Defining its baseline v1 goes through the “Technology choices” step.",
  "baseline.definirV1": "Define baseline v1",
  "baseline.region1": "① Current baseline v{{v}}",
  "baseline.versionDu": "baseline v{{v}} · {{date}}",
  "baseline.produitePar": "produced by: {{origine}}, author {{auteur}}",
  "baseline.heritageChoisi": "Inheritance chosen at launch: {{h}}",
  "baseline.profilRetenu": "Retained generation profile (read by the generator)",
  "baseline.aucunProfil": "none — combination not covered",
  "baseline.livraisonAssumee": "manual delivery accepted",
  "baseline.repriseManques": "Takeover of an existing project: the stack comes from its profile ({{base}}); the mandatory categories it did not provide remain to be completed through a change request — no value was invented.",
  "baseline.baseDefaut": "generator default profile",
  "baseline.baseAdr": "decided stack ADR",
  "baseline.modifier": "Change…",
  "baseline.changementsAVenir": "Change requests, category lock and propagation: next 0.5.x batch. No request in progress on this project.",
  "baseline.tableCaption": "Technology baseline per category",
  "baseline.colRetenue": "Retained value",
  "baseline.colCatalogue": "Catalogue",
  "baseline.colEcart": "Deviation",
  "baseline.obligatoire": "mandatory",
  "baseline.horsCatalogueCourt": "outside the catalogue",
  "baseline.aCompleter": "mandatory, to be completed",
  "baseline.ecartImposee": "deviates from the imposed entry {{p}}: waiver expected",
  "baseline.region2": "② Inheritance per category — organisation → programme → project",
  "baseline.sansProgramme": "Project outside any programme: organisation → project, no programme standard.",
  "baseline.chaineCaption": "Inheritance chain per category",
  "baseline.colOrganisation": "Organisation (imposed)",
  "baseline.colProgramme": "Programme {{nom}}",
  "baseline.colProjet": "Project",
  "baseline.auChoix": "free choice",
  "baseline.region3": "③ History and difference",
  "baseline.historiqueCaption": "Baseline versions",
  "baseline.colVersion": "version",
  "baseline.colDate": "date",
  "baseline.colProduitePar": "produced by",
  "baseline.colAuteur": "author",
  "baseline.v1Seule": "A single version: the launch v1, nothing to compare.",
  "baseline.versionDepart": "From version",
  "baseline.versionArrivee": "To version",
  "baseline.comparer": "Compare",
  "baseline.aucuneDifference": "No difference between these versions.",
  "baseline.differenceCaption": "Difference between two versions",
  "baseline.heriterDe": "Inherit from {{parent}}",
  "baseline.aideProjet": "“Do not inherit” does not exempt the project from an imposed entry: replacing it requires a waiver. A defined category can cite the project ADR that founds it.",
  "baseline.aideProgramme": "The programme standard is an allowed or imposed catalogue entry; an inherited category without an imposed value remains each project’s choice.",
  "baseline.choixCaption": "Technology choices per category",
  "baseline.valeursPour": "Values for {{categorie}}",
  "baseline.aucuneEntree": "No catalogue entry for this category.",
  "baseline.valeurPour": "Value for {{categorie}}",
  "baseline.laisserAuxProjets": "Not set by the programme: each project defines it",
  "baseline.choisir": "Choose an entry…",
  "baseline.integre": "Built into the generated stack (no third-party product)",
  "baseline.horsCatalogue": "Outside the catalogue…",
  "baseline.produitPour": "Product for {{categorie}}",
  "baseline.produitExemple": "e.g. Authentik",
  "baseline.versionPour": "Version for {{categorie}}",
  "baseline.versionExemple": "e.g. 2024.8",
  "baseline.facultative": "optional",
  "baseline.sensible": "sensitive",
  "baseline.plancher": "platform floor",
  "baseline.horsGeneration": "outside generation",
  "baseline.imposeePar": "imposed by the organisation: {{produits}}",
  "baseline.sourcePour": "Source for {{categorie}}",
  "baseline.heriter": "Inherit",
  "baseline.definir": "Define",
  "baseline.aDefinirCourt": "to be defined",
  "baseline.heritage.all": "Inherit everything",
  "baseline.heritage.partial": "Inherit in part (per category)",
  "baseline.heritage.none": "Do not inherit",
  "baseline.source.organisation": "inherited from the organisation",
  "baseline.source.programme": "inherited from the programme",
  "baseline.source.projet": "project choice",
  "baseline.source.reprise": "takeover from ADR-0109",
  "baseline.gen.generable": "generable",
  "baseline.gen.nonQualifiee": "profile not qualified",
  "baseline.gen.nonCouverte": "not generable",
  "baseline.gen.integre": "built into the stack",
  "baseline.gen.execution": "provided at runtime",
  "baseline.origine.lancement": "project launch",
  "baseline.origine.reprise": "takeover from ADR-0109 (project older than 0.5.x)",
  "baseline.origine.chg": "change request {{ref}}",
  "baseline.origine.prop": "received propagation {{ref}}",
  "baseline.r.manquante": "Mandatory category without a value: {{categories}}. Define it before completing.",
  "baseline.r.unique": "Single-choice category: only one value.",
  "baseline.r.imposee": "“{{produit}}” is imposed by the organisation: replacing it requires a waiver (reason, deadline, approval).",
  "baseline.r.retiree": "Entry retired from the catalogue: keeping it requires a waiver.",
  "baseline.r.nonAutorisee": "Entry not allowed by the organisation for this category (under study), or an off-catalogue value where only the catalogue is permitted.",
  "baseline.r.nonAssumee": "Combination not covered by a qualified generation profile: tick “Manual delivery accepted” to complete.",
  "baseline.r.immuable": "The baseline exists: it only changes through an approved change request or a propagation.",
  "baseline.r.changement": "The baseline is never written directly: “Change…” opens a change request.",
  "baseline.r.inacheve": "Incomplete launch: complete the launch before generating; framing, specification and backlog remain open.",
  "baseline.r.nonGenerable": "Combination not covered by a qualified generation profile: generation by the colony is refused; framing, specification, backlog, tests and manual delivery remain possible.",
  "baseline.r.horsBaseline": "Generation outside the baseline: the requested stack is not the profile retained by the baseline.",
  "baseline.r.ecriture": "Read-only: the project owner or a contributor runs the launch.",
  "baseline.r.programme": "Read-only: the programme owner sets its technology choices.",
  "pgmTech.adrs": "Programme ADRs",
  "pgmTech.adrsChargement": "Reading the programme ADRs…",
  "pgmTech.adrsErreur": "The programme ADRs could not be read.",
  "pgmTech.adrsVide": "No programme ADR",
  "pgmTech.adrsVideAide": "A programme ADR founds a programme standard (e.g. SQLite for the tills).",
  "pgmTech.adrsCaption": "Programme-scope ADRs",
  "pgmTech.adrTitre": "Title",
  "pgmTech.adrStatut": "Status",
  "pgmTech.nouvelleAdr": "New programme ADR",
  "cout.aide": "GPU minutes measured from the blackboard “cost” events. “Estimated in plan” (the queen) and “consumed” are two columns, never added together.",
  "cout.casteCaption": "GPU minutes per caste: estimated, consumed and gap",
  "cout.casteVide": "No caste has worked on this mission yet.",
  "cout.chargement": "Aggregating “cost” events…",
  "cout.colCaste": "Caste",
  "cout.colEcart": "Gap (consumed − estimated)",
  "cout.colEtat": "Status",
  "cout.colModele": "Model",
  "cout.colModeles": "Models",
  "cout.colRang": "Rank",
  "cout.colTache": "Task",
  "cout.colTaches": "Tasks",
  "cout.colTour": "Round",
  "cout.colTours": "Rounds",
  "cout.colTrace": "Trace",
  "cout.consomme": "Consumed",
  "cout.consommeNote": "measured from the blackboard “cost” events · budget {{b}} min",
  "cout.erreur": "Project cost unreadable: {{m}}",
  "cout.estime": "Estimated in plan",
  "cout.estimeIncomplet": "sum of the queen’s estimates for {{n}} task(s); {{s}} without an estimate",
  "cout.estimeNote": "sum of the queen’s estimates for the {{n}} task(s)",
  "cout.minutes": "{{n}} min",
  "cout.mission": "Mission",
  "cout.missionsCaption": "GPU minutes per mission: estimated in plan and consumed",
  "cout.onglet.caste": "By caste",
  "cout.onglet.mission": "By mission",
  "cout.onglet.tache": "By task",
  "cout.onglet.tour": "By round",
  "cout.onglets": "Cost breakdown",
  "cout.outilTraces": "Open the tracing tool",
  "cout.tacheCaption": "GPU minutes per task; choosing a task opens its per-round view",
  "cout.tacheVide": "The queen has not planned any task for this mission yet.",
  "cout.titre": "Cost and traces",
  "cout.totaux": "Totals, each in its own column: {{e}} min estimated, {{c}} min consumed — never a sum of the two.",
  "cout.tourCaption": "GPU minutes per round and link to the trace",
  "cout.tourSansTache": "No task has consumed minutes yet: choose a task under “By task”.",
  "cout.tourVide": "No measured round for this task.",
  "cout.toursTitre": "Task {{k}} “{{titre}}” — by round",
  "cout.trace": "Trace",
  "cout.traceDuTour": "Trace of round {{n}}",
  "cout.tracesNonConfigurees": "The tracing service is not configured on this installation: “Trace” links are disabled; minutes are still read from the blackboard.",
  "cout.tracesNonInstrumentees": "The tracing service is configured, but no round is linked to it yet: “Trace” links are disabled; minutes are still read from the blackboard.",
  "cout.tracesTitre": "Traces unavailable",
  "cout.vide": "No GPU minutes consumed",
  "cout.videAide": "No mission has run in this project yet: costs will show here from the first one.",
  "design.background.blanc": "White",
  "design.background.chaud": "Warm beige",
  "design.background.froid": "Bluish grey",
  "design.background.neutre": "Neutral grey",
  "design.background.personnalisee": "Other background",
  "design.backToDesign": "← Back to design",
  "design.charter.background": "Page background",
  "design.charter.canvasLabel": "Background colour (#rrggbb)",
  "design.charter.canvasRequired": "Enter the page background colour as #rrggbb (for example #f3f1ec).",
  "design.charter.corners": "Corners",
  "design.charter.inheritanceUnknown": "The organisation charter inheritance could not be read: validation waits until it is (see “Organisation charter” above).",
  "design.charter.originOverride": "project's own (override)",
  "design.charter.saveRefused2": "Cannot save: insufficient contrast on {{count}} pair(s) above. Choose a darker main colour or a lighter page background.",
  "design.charter.validateNeedsOverride": "The organisation's charter (v{{version}}, {{mode}}) applies to this project: first request an override, with its reason, under “Organisation charter” above.",
  "design.charter.warningsCount": "{{count}} barely legible pair(s)",
  "design.comparison.application": "Running application",
  "design.comparison.captureAlt": "Screenshot of the application's “{{name}}” screen",
  "design.comparison.counts": "{{major}} major, {{minor}} minor, {{info}} info · {{compared}}/{{expected}} screen(s) compared · {{who}}, {{date}}",
  "design.comparison.detailDescription": "Each screen of the validated flow, side by side, and its gaps. An opinion filed with the evidence: it blocks nothing.",
  "design.comparison.detailTitle": "Wireframe ↔ application",
  "design.comparison.elements": "Elements read on both sides",
  "design.comparison.empty": "No comparison filed yet.",
  "design.comparison.emptyHint": "Choose a running revision, then “Compare with the wireframe”.",
  "design.comparison.emptyHintReader": "A project contributor files the comparisons.",
  "design.comparison.filed": "Filed by {{who}} on {{date}} — an opinion, never a gate.",
  "design.comparison.gaps": "Gaps",
  "design.comparison.intro": "Each screen of the validated flow, wireframe and application side by side: missing or extra buttons, links and fields, title, computed colours outside the charter. The opinion is filed with the evidence; it blocks nothing.",
  "design.comparison.invalidId": "Invalid address: no comparison has this identifier.",
  "design.comparison.line": "{{app}} · revision {{rev}} · flow v{{flow}}",
  "design.comparison.loading": "Loading comparisons…",
  "design.comparison.loadingOne": "Loading the comparison…",
  "design.comparison.needFlow": "No validated screen flow: there is no reference wireframe. Validate the flow and its wireframes first.",
  "design.comparison.needSurvey": "No surveyed revision: start the preview of a revision — the survey measures the running application.",
  "design.comparison.noGap": "no gap",
  "design.comparison.noGapLong": "No gap found on this screen.",
  "design.comparison.noScreen": "The screen does not respond in the application.",
  "design.comparison.noWireframe": "No validated wireframe for this screen.",
  "design.comparison.noWorkspaceHint": "A comparison belongs to a project.",
  "design.comparison.opinion.aligned": "matches the wireframe",
  "design.comparison.opinion.major": "major gaps",
  "design.comparison.opinion.minor": "minor gaps",
  "design.comparison.opinion.nothing": "nothing to compare",
  "design.comparison.pageTitle": "Title: {{title}}",
  "design.comparison.revision": "Running revision",
  "design.comparison.run": "Compare with the wireframe",
  "design.comparison.severity.info": "info",
  "design.comparison.severity.major": "major",
  "design.comparison.severity.minor": "minor",
  "design.comparison.sideMissing": "Nothing read on this side.",
  "design.comparison.summaryTitle": "{{app}} · revision {{rev}} · flow v{{flow}}",
  "design.comparison.title": "Wireframe ↔ application",
  "design.comparison.width": "Screenshot width",
  "design.comparison.wireframe": "Validated wireframe",
  "design.contrast.marginalPair": "Barely legible — {{label}}: {{ratio}} (minimum {{minimum}}). Compliant, but hard to read in bright sunlight or on a poorly adjusted screen.",
  "design.corners.auto": "Following the typography",
  "design.corners.doux": "Rounded",
  "design.corners.droits": "Square corners",
  "design.corners.legers": "Slightly rounded",
  "design.corners.ronds": "Very rounded",
  "design.enforcement.allowed": "recommended",
  "design.enforcement.allowedShort": "recommended",
  "design.enforcement.inForce": "mandatory",
  "design.enforcement.inForceShort": "mandatory",
  "design.inheritance.askOverride": "Override the organisation's charter",
  "design.inheritance.askWaiver": "Request a waiver from the mandatory charter",
  "design.inheritance.effective": "Generation applies {{source}}.",
  "design.inheritance.expiryOptionalLabel": "Expiry date (optional, 180 days at most)",
  "design.inheritance.expiryRequiredLabel": "Expiry date (required, 180 days at most)",
  "design.inheritance.history": "Project override history",
  "design.inheritance.historyEmpty": "No override: the project has never departed from the organisation's charter.",
  "design.inheritance.lapsed": "The project's waiver has expired: the organisation's charter applies again. Request a new one if the reason still holds.",
  "design.inheritance.loading": "Loading charter inheritance…",
  "design.inheritance.none": "The organisation has no validated charter: the project's charter applies as is.",
  "design.inheritance.open": "Current override",
  "design.inheritance.openOrg": "See the organisation's charter",
  "design.inheritance.openVersion": "See this version",
  "design.inheritance.orgAllowed": "The organisation recommends its charter v{{version}} ({{semver}}): the project inherits it; overriding it is possible, with a recorded reason.",
  "design.inheritance.orgInForce": "The organisation mandates its charter v{{version}} ({{semver}}): overriding it is a waiver, with an expiry date, decided by the organisation's administration.",
  "design.inheritance.readOnly": "Requesting or ending an override is reserved for the project's contributors and owners.",
  "design.inheritance.reasonLabel": "Reason (why this project has its own charter)",
  "design.inheritance.return": "Go back to the organisation's charter",
  "design.inheritance.sourceDefault": "the platform's default charter (no validated charter)",
  "design.inheritance.sourceOrganisation": "the organisation's charter (v{{version}}, {{semver}}), inherited",
  "design.inheritance.sourceOverride": "the project's charter (v{{version}}, {{semver}}), under override",
  "design.inheritance.sourceProject": "the project's charter (v{{version}}, {{semver}})",
  "design.inheritance.submitOverride": "Override",
  "design.inheritance.submitWaiver": "Request the waiver",
  "design.inheritance.title": "Organisation charter",
  "design.inheritance.waiting": "Awaiting the decision of the organisation's administration; meanwhile, the organisation's charter applies.",
  "design.inheritance.withdraw": "Withdraw the request",
  "design.override.decided": "Decided by {{who}} on {{date}}",
  "design.override.decisionComment": "Decision comment (required to refuse)",
  "design.override.end.expired": "expiry date passed",
  "design.override.end.returned": "back to the organisation's charter",
  "design.override.end.superseded": "lapsed: the organisation's charter changed",
  "design.override.end.withdrawn": "request withdrawn",
  "design.override.ended": "Closed on {{date}} by {{who}}: {{reason}}",
  "design.override.expires": "expires {{date}}",
  "design.override.expiryPast": "The expiry date must be in the future (tomorrow at the earliest).",
  "design.override.expiryRequired": "The organisation's charter is mandatory: a waiver needs an expiry date.",
  "design.override.expiryTooFar": "An override lasts 180 days at most: the question is asked again when it expires.",
  "design.override.grant": "Grant the waiver",
  "design.override.kindOverride": "Override",
  "design.override.kindWaiver": "Waiver",
  "design.override.meta": "Targets the organisation's charter v{{version}} ({{mode}}) · requested by {{who}} on {{date}}",
  "design.override.reason": "Reason: {{reason}}",
  "design.override.reasonTooShort": "Write the reason (at least 10 characters): why the organisation's charter does not suit this project.",
  "design.override.refuse": "Refuse",
  "design.override.refuseNeedsComment": "A refusal needs a reason: write the comment before refusing.",
  "design.override.selfDecision": "You requested this waiver: another person from the organisation's administration must decide on it.",
  "design.override.status.active": "override active",
  "design.override.status.activeWaiver": "waiver granted",
  "design.override.status.ended": "closed",
  "design.override.status.lapsed": "expired",
  "design.override.status.refused": "refused",
  "design.override.status.requested": "waiver requested",
  "design.usability.addObservation": "Add an observation",
  "design.usability.anyTask": "all",
  "design.usability.cancel": "Cancel",
  "design.usability.chooseRequirement": "— choose a requirement of the validated flow —",
  "design.usability.chooseVerdict": "— choose —",
  "design.usability.conclusion": "Conclusion (optional)",
  "design.usability.counts": "{{planned}} planned · {{completed}} completed · {{waived}} waived",
  "design.usability.createdLine": "Planned by {{who}} on {{date}}",
  "design.usability.criterion": "Success criterion (optional)",
  "design.usability.criterionLine": "Success criterion: {{c}}",
  "design.usability.date": "Session date",
  "design.usability.dateFuture": "A session cannot be recorded before it has taken place.",
  "design.usability.detailDescription": "Short protocol, session result or reasoned waiver (ART-0172 DES-09).",
  "design.usability.detailTitle": "Usability test",
  "design.usability.empty": "No usability test for this project.",
  "design.usability.emptyHint": "Plan one for each usability requirement.",
  "design.usability.intro": "A short protocol: 3 to 5 business users perform the tasks of a usability requirement, and you note what happens. If it does not take place, the waiver states its reason.",
  "design.usability.invalidId": "Invalid address: no usability test has this identifier.",
  "design.usability.line": "Requirement {{ref}}{{label}} · {{count}} participant(s) planned · created on {{date}}",
  "design.usability.loading": "Loading usability tests…",
  "design.usability.loadingOne": "Loading the usability test…",
  "design.usability.needDate": "Enter the session date.",
  "design.usability.needObservation": "Note at least one observation: what participants did, said or looked for.",
  "design.usability.needProfile": "Say who the participants are (for example “seasonal sales staff”).",
  "design.usability.needRequirement": "Choose the usability requirement this test checks (for example REQ-12).",
  "design.usability.needResults": "For each task, enter how many participants succeeded (0 to {{max}}).",
  "design.usability.needScenario": "Describe the scenario (at least 10 characters): the situation participants are in.",
  "design.usability.needTasks": "Write 1 to 10 tasks, one per line.",
  "design.usability.needTitle": "Give the test a title.",
  "design.usability.needVerdict": "Choose the verdict.",
  "design.usability.notesCol": "Notes",
  "design.usability.noWorkspaceHint": "A usability test belongs to a project.",
  "design.usability.observation": "Observation {{n}}",
  "design.usability.observations": "Observations",
  "design.usability.observationTask": "Task",
  "design.usability.outcome": "Result",
  "design.usability.outcomeLine": "Session on {{date}}, {{count}} participant(s); recorded by {{who}} on {{at}}.",
  "design.usability.participants": "Planned participants",
  "design.usability.participantsActual": "Actual participants",
  "design.usability.participantsLine": "{{count}} participant(s) planned: {{profile}}",
  "design.usability.perTask": "Successes per task",
  "design.usability.plan": "Plan a usability test",
  "design.usability.profile": "Participant profile",
  "design.usability.protocol": "Protocol",
  "design.usability.recordResult": "Record the result or waive",
  "design.usability.requirement": "Usability requirement checked",
  "design.usability.requirementLine": "Usability requirement: {{ref}}{{label}}",
  "design.usability.requirementPlaceholder": "REQ-12",
  "design.usability.resultTitle": "Session result",
  "design.usability.save": "Save the planned test",
  "design.usability.saveResult": "Save the result (final)",
  "design.usability.scenario": "Scenario (the participants' situation)",
  "design.usability.severity.blocking": "blocking",
  "design.usability.severity.info": "information",
  "design.usability.severity.major": "major hindrance",
  "design.usability.severity.minor": "minor hindrance",
  "design.usability.severityLabel": "Severity",
  "design.usability.status.completed": "completed",
  "design.usability.status.planned": "planned",
  "design.usability.status.waived": "waived",
  "design.usability.succeeded": "Succeeded (out of {{max}})",
  "design.usability.successCol": "Successes",
  "design.usability.taskCol": "Task",
  "design.usability.taskNotes": "Notes (optional)",
  "design.usability.tasks": "Tasks, one per line (10 at most)",
  "design.usability.title": "Usability tests",
  "design.usability.titleLabel": "Title",
  "design.usability.verdict.failed": "failed",
  "design.usability.verdict.partial": "partial",
  "design.usability.verdict.passed": "passed",
  "design.usability.verdictLabel": "Verdict",
  "design.usability.waive": "Waive (final)",
  "design.usability.waived": "Waiver",
  "design.usability.waivedLine": "Waived by {{who}} on {{date}}",
  "design.usability.waiverIntro": "If the session will not take place, say so with its reason: the requirement is not silently deemed verified.",
  "design.usability.waiverReason": "Waiver reason",
  "design.usability.waiverTitle": "Waive the test",
  "design.usability.waiverTooShort": "A waiver reason is at least 20 characters: why the test does not take place, and what stands in for it.",
  "indicateurs.delai.chargement": "Computing idea-to-delivery lead time…",
  "indicateurs.delai.delai": "Lead time",
  "indicateurs.delai.demande": "Request",
  "indicateurs.delai.deployee": "Deployed to highest stage",
  "indicateurs.delai.deposee": "Idea submitted",
  "indicateurs.delai.enCours": "in progress",
  "indicateurs.delai.enCoursAge": "in progress ({{age}})",
  "indicateurs.delai.erreur": "The idea-to-delivery lead time could not be computed.",
  "indicateurs.delai.livrees": "Requests delivered over {{jours}} d: {{nombre}}",
  "indicateurs.delai.mediane": "Median idea → delivered",
  "indicateurs.delai.p85": "85th percentile",
  "indicateurs.delai.tableau": "Delivered and in-progress requests",
  "indicateurs.delai.titre": "Idea → delivered lead time",
  "indicateurs.delai.vide": "No request delivered",
  "indicateurs.delai.videIndice": "The request → deployment lineage has not linked anything yet.",
  "indicateurs.detailTechnique": "Technical detail",
  "indicateurs.efficacite.caste": "Caste",
  "indicateurs.efficacite.chargement": "Computing efficiency by caste and model…",
  "indicateurs.efficacite.erreur": "Efficiency by caste and model could not be computed.",
  "indicateurs.efficacite.mention": "GPU minutes consumed (never added to estimates) · last {{jours}} days · missions: {{missions}}.",
  "indicateurs.efficacite.minutes": "GPU minutes consumed",
  "indicateurs.efficacite.modele": "Model",
  "indicateurs.efficacite.premierTour": "Passed on 1st round",
  "indicateurs.efficacite.tableau": "Efficiency by caste and model",
  "indicateurs.efficacite.taches": "Tasks",
  "indicateurs.efficacite.tauxDetail": "{{num}} of {{den}}",
  "indicateurs.efficacite.titre": "Efficiency by caste and model",
  "indicateurs.efficacite.toursMoyens": "Average rounds",
  "indicateurs.efficacite.vide": "No mission finished",
  "indicateurs.efficacite.videIndice": "Tasks are counted when each mission ends.",
  "indicateurs.jours": "{{valeur}} d",
  "indicateurs.mesuresPasObjectifs": "These are measurements, not service objectives: no green, amber or red.",
  "indicateurs.minutes": "{{valeur}} min",
  "indicateurs.na": "n/a",
  "indicateurs.periode": "Period",
  "indicateurs.periodeJours": "Last {{jours}} days",
  "indicateurs.pourcent": "{{valeur}}%",
  "nav./org/charte": "Organisation charter",
  "navdesc./org/charte": "The visual charter projects inherit: recommended or mandatory, and its waivers",
  "org.charter.back": "← All versions",
  "org.charter.changeWarning": "Current overrides under the other rule lapse: their projects go back to the organisation's charter.",
  "org.charter.choicesLine": "Main colour: {{primary}} · page background: {{canvas}} · typography: {{typo}} · density: {{density}} · corners: {{corners}} · voice: {{voice}}",
  "org.charter.contrast": "Contrast checked (WCAG 2.2 AA)",
  "org.charter.current": "Version applied to projects",
  "org.charter.description": "The visual charter projects inherit by default: chosen in plain words, contrast checked as you choose, recommended or mandatory.",
  "org.charter.designMdLabel": "DESIGN.md",
  "org.charter.editor": "New version, in plain words",
  "org.charter.empty": "No version of the organisation's charter.",
  "org.charter.emptyHint": "Compose it on the left, then have another person validate it.",
  "org.charter.invalidId": "Invalid address: no charter version has this identifier.",
  "org.charter.loading": "Loading the organisation's charter…",
  "org.charter.loadingOne": "Loading the version…",
  "org.charter.makeAllowed": "Make recommended",
  "org.charter.makeInForce": "Make mandatory",
  "org.charter.minimum": "Minimum",
  "org.charter.none": "No validated version: each project applies its own charter (or the default charter).",
  "org.charter.overrides": "Project overrides and waivers",
  "org.charter.overridesEmpty": "No project has overridden the organisation's charter.",
  "org.charter.pair": "Pair",
  "org.charter.pending": "{{count}} waiver(s) to decide",
  "org.charter.ratio": "Ratio",
  "org.charter.requiredRole": "Organisation administration",
  "org.charter.ruleAllowed": "departing from it is possible, with a recorded reason.",
  "org.charter.ruleInForce": "departing from it is a waiver with an expiry date, decided by the administration.",
  "org.charter.saved": "Version v{{version}} saved as a draft: another person from the administration must validate it.",
  "org.charter.selfRefused": "You are the author: the author of a version never validates it. Another person from the organisation's administration must validate it.",
  "org.charter.title": "Organisation charter",
  "org.charter.trace": "Written by {{author}} on {{date}}; validated by {{validator}}; token fingerprint {{sha}}",
  "org.charter.validateAllowed": "Validate — recommended",
  "org.charter.validatedInfo": "v{{version}} ({{semver}}), validated by {{who}} on {{date}}. Projects inherit it; {{rule}}",
  "org.charter.validateInForce": "Validate — mandatory",
  "org.charter.validationEffect": "Validating a version applies it to every project without an active override, including those that had validated their own charter: their next generation will use the organisation's.",
  "org.charter.versionDescription": "The choices in plain words, the contrast checked pair by pair, and what the platform generated from them.",
  "org.charter.versions": "Versions",
  "org.charter.versionTitle": "Organisation charter v{{version}}",
  "org.charter.writeActions": "Edit the organisation's charter",
  "pgmCapacite.agregat": "aggregate — no name, no mission: you are not a member of these projects",
  "pgmCapacite.agregatRepli": "{{n}} project(s) not open to you",
  "pgmCapacite.carteConsomme": "consumed {{v}}",
  "pgmCapacite.carteEstime": "estimated {{v}}",
  "pgmCapacite.carteMissions": "{{n}} mission(s) in progress",
  "pgmCapacite.chargement": "Reading cost and capacity…",
  "pgmCapacite.colConsomme": "consumed",
  "pgmCapacite.colEstime": "estimated",
  "pgmCapacite.colMissions": "missions in progress",
  "pgmCapacite.colProjet": "project",
  "pgmCapacite.colRemarque": "note",
  "pgmCapacite.consommees": "Consumed (measured)",
  "pgmCapacite.de": "GPU minutes consumed and estimated for the projects of {{nom}}",
  "pgmCapacite.enPause": "paused",
  "pgmCapacite.erreur": "The programme’s cost and capacity could not be read.",
  "pgmCapacite.estimees": "Estimated (active missions)",
  "pgmCapacite.jamaisAdditionnees": "never added together",
  "pgmCapacite.legende": "Per attached project: missions in progress, estimated and consumed minutes, note",
  "pgmCapacite.mois": "Month",
  "pgmCapacite.periode": "GPU minutes — {{mois}}",
  "pgmCapacite.projetsRattaches": "{{n}} attached project(s)",
  "pgmCapacite.refus": "You are not a member of this programme: its cost and capacity are not open to you.",
  "pgmCapacite.regle": "Estimated ≠ consumed: two columns, never a combined total. Estimated is the remaining work of active missions; consumed, the minutes measured this month.",
  "pgmCapacite.sansProjetIndice": "The statement is computed over the projects attached to the programme.",
  "pgmCapacite.vide": "No minutes consumed",
  "pgmCapacite.videIndice": "Missions of the attached projects will feed this statement.",
  "pgmObjectif.ajoutEnCours": "Adding…",
  "pgmObjectif.ajouter": "Add a risk",
  "pgmObjectif.ajouterBouton": "Add the risk",
  "pgmObjectif.aucunOuvert": "No open risk.",
  "pgmObjectif.aucunRisque": "No risk in the register.",
  "pgmObjectif.chargement": "Reading the programme’s objective…",
  "pgmObjectif.clore": "Close",
  "pgmObjectif.cloreDe": "Close “{{titre}}”",
  "pgmObjectif.clos": "closed on {{d}}",
  "pgmObjectif.colActions": "actions",
  "pgmObjectif.colImpact": "impact",
  "pgmObjectif.colPorteur": "owner",
  "pgmObjectif.colRisque": "risk",
  "pgmObjectif.colStatut": "status",
  "pgmObjectif.conflit": "The objective was changed in the meantime: reload before saving.",
  "pgmObjectif.date": "Target date",
  "pgmObjectif.dateSansJalon": "A target date belongs to a milestone: name the milestone.",
  "pgmObjectif.enregistrer": "Save the objective",
  "pgmObjectif.erreur": "The objective and the risk register could not be read.",
  "pgmObjectif.impact": "Impact",
  "pgmObjectif.impactDe": "Impact of “{{titre}}”",
  "pgmObjectif.impactHigh": "high",
  "pgmObjectif.impactLow": "low",
  "pgmObjectif.impactMedium": "medium",
  "pgmObjectif.intitule": "Title",
  "pgmObjectif.jalon": "Target milestone",
  "pgmObjectif.jalonLongueur": "The milestone must be at most {{max}} characters long.",
  "pgmObjectif.legende": "Programme risk register: open first, from highest to lowest impact",
  "pgmObjectif.legendeOuverts": "Open programme risks, from highest to lowest impact",
  "pgmObjectif.membresErreur": "The programme members could not be read: no owner can be chosen.",
  "pgmObjectif.nonFixe": "not set",
  "pgmObjectif.objectifLongueur": "The objective must be at most {{max}} characters long.",
  "pgmObjectif.ouvert": "open",
  "pgmObjectif.ouverts": "{{n}} open",
  "pgmObjectif.parade": "Mitigation",
  "pgmObjectif.paradeChamp": "Mitigation (optional)",
  "pgmObjectif.paradeLongueur": "The mitigation must be at most {{max}} characters long.",
  "pgmObjectif.porteur": "Owner",
  "pgmObjectif.porteurDe": "Owner of “{{titre}}”",
  "pgmObjectif.porteurNonMembre": "A risk owner must be a member of the programme.",
  "pgmObjectif.registre": "Risk register",
  "pgmObjectif.registreCompte": "Risk register: {{n}} risk(s), {{o}} open",
  "pgmObjectif.risqueAjoute": "Risk “{{titre}}” added to the register.",
  "pgmObjectif.risqueClos": "Risk “{{titre}}” closed.",
  "pgmObjectif.risqueModifie": "Risk “{{titre}}” saved.",
  "pgmObjectif.risqueRouvert": "Risk “{{titre}}” reopened.",
  "pgmObjectif.rouvrir": "Reopen",
  "pgmObjectif.rouvrirDe": "Reopen “{{titre}}”",
  "pgmObjectif.sansDroit": "Programme reader: objective and risks are read-only — a programme owner or contributor edits them.",
  "pgmObjectif.sansPorteur": "no owner",
  "pgmObjectif.section": "Objective, target milestone, risks",
  "pgmObjectif.succes": "Objective and target milestone saved.",
  "pgmObjectif.titre": "Objective",
  "pgmObjectif.titreRisqueLongueur": "The risk title must be {{min}} to {{max}} characters long.",
  "pgmObjectif.vide": "No objective",
  "pgmObjectif.videAction": "Set the objective in the settings",
  "pgmObjectif.videIndice": "Give the programme an objective and a target milestone.",
  "pgmObjectif.videLecteur": "A programme pilot (owner or contributor) sets it.",
  "reglagesNotif.annuler": "Cancel",
  "reglagesNotif.ceQuiNotifie": "What notifies you",
  "reglagesNotif.chargement": "Loading your notification settings…",
  "reglagesNotif.detailTechnique": "Technical detail",
  "reglagesNotif.enregistrement": "Saving…",
  "reglagesNotif.enregistrer": "Save",
  "reglagesNotif.erreur": "Your notification settings could not be loaded.",
  "reglagesNotif.et": "and",
  "reglagesNotif.fuseau": "Times in the {{fuseau}} time zone.",
  "reglagesNotif.heriter": "Inherit default ({{niveau}})",
  "reglagesNotif.intro": "Default for all your projects, then per project. “Muted” never silences the Attention inbox: a decision waiting for you stays there.",
  "reglagesNotif.niveau.all": "All",
  "reglagesNotif.niveau.mentions": "Mentions only",
  "reglagesNotif.niveau.mute": "Muted",
  "reglagesNotif.parDefaut": "Default",
  "reglagesNotif.resumeCreneaux": "Receive a digest at each slot: {{creneaux}}",
  "reglagesNotif.resumeNote": "The digest groups notifications left unread since the previous one; it is delivered in the application (email delivery is out of scope).",
  "reglagesNotif.resumeTitre": "Digest",
  "reglagesNotif.resumeTroisFois": "Receive a digest three times a day: {{creneaux}}",
  "reglagesNotif.sansProjet": "You are not a member of any project: only the default level applies.",
  "reglagesNotif.succes": "Notification settings saved",
  "reglagesNotif.titre": "Notification settings",
  "sprint.aAmeliorer": "To improve",
  "sprint.aGarder": "Keep doing",
  "sprint.actionChamp": "New action",
  "sprint.actionCreee": "Action created in the backlog.",
  "sprint.actionCreeeBadge": "item created",
  "sprint.actionCreer": "Create the action",
  "sprint.actionFaite": "done",
  "sprint.actionInvalide": "An action title must be at least 3 characters long.",
  "sprint.actionsAucune": "No action created yet.",
  "sprint.actionsTitre": "Retrospective actions (backlog items)",
  "sprint.ajoutAuDela": "The commitment already exceeds capacity: this is a warning — you can still add a story.",
  "sprint.ajouter": "Add to sprint",
  "sprint.assigne": "assignee: {{qui}}",
  "sprint.aucunCritere": "No acceptance criteria entered.",
  "sprint.aucuneTache": "No task under this item.",
  "sprint.burn.burndownAria": "Burndown from {{debut}} to {{fin}}: {{reste}} points remaining on {{jour}}",
  "sprint.burn.burndownTitre": "Burndown — remaining points (actual up to today, ideal dashed)",
  "sprint.burn.burnupAria": "Burn-up: {{fait}} points done out of a scope of {{perimetre}} on {{jour}}",
  "sprint.burn.burnupTitre": "Burn-up — scope and done",
  "sprint.burn.noteInstantanes": "{{n}} daily snapshot(s) since {{premier}}; today: {{jour}}. The future is never plotted.",
  "sprint.burn.noteSansInstantane": "No daily snapshot yet: past days are reconstructed from the transition log. The future is never plotted.",
  "sprint.burn.pasCommence": "The sprint has not started yet (starts on {{debut}}): only the ideal line is plotted; the actual remaining work will appear from the first day.",
  "sprint.burn.pasDeValeur": "no value",
  "sprint.burn.perimetre": "Scope",
  "sprint.burn.reconstitue": "reconstructed from the log (before the first snapshot)",
  "sprint.burn.tachesAria": "{{n}} task(s) remaining out of {{total}} on {{jour}}",
  "sprint.burn.tachesRestantes": "Remaining tasks",
  "sprint.burn.tachesTitre": "Remaining tasks (counted)",
  "sprint.burn.termine": "Done",
  "sprint.burn.titre": "Burndown, burn-up and tasks of this sprint",
  "sprint.burn.unitesTaches": "tasks",
  "sprint.burndownSansDates": "The burndown needs a start and an end date: this sprint has none.",
  "sprint.burndownTitre": "Burndown of this sprint — remaining points",
  "sprint.capaciteAide": "Optional: without a value, only the velocity is shown. From 0.1 to 999 person-days.",
  "sprint.capaciteChamp": "Declared capacity (person-days)",
  "sprint.capaciteChargement": "Reading the capacity…",
  "sprint.capaciteDans": "{{j}} person-days · {{e}} pts committed: within capacity.",
  "sprint.capaciteDeclaree": "Declared capacity",
  "sprint.capaciteDepassee": "{{e}} pts committed for ≈ {{c}} pts of capacity: a warning; you can still add a story.",
  "sprint.capaciteEnregistree": "Capacity saved.",
  "sprint.capaciteEnregistrer": "Save capacity",
  "sprint.capaciteErreur": "Capacity unreadable: {{m}}",
  "sprint.capaciteInsuffisante": "Insufficient data",
  "sprint.capaciteInvalide": "Enter a number of person-days between 0.1 and 999, or leave it empty to clear it.",
  "sprint.capacitePoints": "capacity ≈ {{n}} pts",
  "sprint.capaciteTiret": "Capacity —",
  "sprint.capaciteTitre": "Declared capacity — next to the velocity, never blocking",
  "sprint.capaciteVide": "Capacity not declared: only the velocity is shown.",
  "sprint.chargement": "Loading the sprint…",
  "sprint.choisirUneUs": "Choose the story to add to the sprint.",
  "sprint.closLe": "closed on {{date}}",
  "sprint.closNote": "Closed sprint: its content no longer changes. The review and retrospective are entered below.",
  "sprint.cloture.aucunSprint": "No other planned or active sprint",
  "sprint.cloture.choisirSprint": "Choose a sprint…",
  "sprint.cloture.choixManque": "Choose where the {{n}} unfinished item(s) go: to another sprint, or back to the backlog.",
  "sprint.cloture.cibleManque": "Choose the sprint that receives the carried-over items.",
  "sprint.cloture.cloturerEtReporter": "Close and carry over",
  "sprint.cloture.confirmer": "Confirm closing",
  "sprint.cloture.direct": "All items in the sprint are done: nothing to carry over. Confirm closing.",
  "sprint.cloture.ouVont": "Where do they go? (required)",
  "sprint.cloture.restants": "{{n}} unfinished item(s):",
  "sprint.cloture.sprintCible": "Sprint that receives the items",
  "sprint.cloture.succesBacklog": "Sprint closed: {{n}} item(s) returned to the backlog. The review is open.",
  "sprint.cloture.succesDirect": "Sprint closed. The review and retrospective are open.",
  "sprint.cloture.succesSprint": "Sprint closed: {{n}} item(s) carried over to {{cible}}. The review is open.",
  "sprint.cloture.titre": "Close the sprint",
  "sprint.cloture.versBacklog": "Return to the backlog (no sprint)",
  "sprint.cloture.versSprint": "Carry over to sprint:",
  "sprint.contenuChargement": "Reading the sprint content…",
  "sprint.contenuTitre": "Sprint content — stories, tasks, status, points, assignee",
  "sprint.contenuVideHint": "Add an available story below, or move one in from the board.",
  "sprint.contenuVideLecture": "Stories are added to a sprint from the board or from this page, by a contributor.",
  "sprint.contenuVideTitre": "No story in this sprint",
  "sprint.criteres": "Acceptance criteria ({{n}})",
  "sprint.criteresEtDod": "Acceptance criteria ({{n}}) and Definition of Done",
  "sprint.engage": "Committed",
  "sprint.erreurInconnue": "Unexpected error",
  "sprint.fluxTitre": "Cumulative flow of this sprint — items by status",
  "sprint.fluxVideHint": "Add items to this sprint and change their status: the flow is built from the transition log.",
  "sprint.introuvable": "Sprint not found",
  "sprint.introuvableHint": "This sprint does not exist, or it belongs to a project you cannot access. Go back to the project's sprint list.",
  "sprint.joursRestants": "{{n}} day(s) left",
  "sprint.joursRestantsInconnu": "days left: — (no end date)",
  "sprint.jp": "{{n}} person-days",
  "sprint.lancerClos": "Closed sprint: no mission can be launched on it any more.",
  "sprint.lectureSeule": "Read only — changing the status, adding or removing a story and declaring capacity are reserved for contributors.",
  "sprint.nonAssigne": "unassigned",
  "sprint.nonEstime": "not estimated",
  "sprint.objectif": "Goal:",
  "sprint.objectifAtteint": "met",
  "sprint.objectifAucun": "no goal entered",
  "sprint.objectifNonAtteint": "not met",
  "sprint.objectifPartiel": "partially met",
  "sprint.pasDeCourbe": "No curve yet",
  "sprint.pasDeCourbeHint": "Add items to the sprint and change their status: the curve is built from the transition log.",
  "sprint.points": "{{n}} pts",
  "sprint.projet": "Project: {{nom}}",
  "sprint.ratio": "≈ {{r}} pt per person-day ({{n}} sprint(s) with a declared capacity)",
  "sprint.resumePoints": "{{fait}} / {{engage}} pts done · {{faits}} / {{total}} items · {{pct}} %",
  "sprint.retirer": "Remove from sprint",
  "sprint.retirerAria": "Remove “{{titre}}” from the sprint",
  "sprint.revueChargement": "Reading the review…",
  "sprint.revueDemo": "Demonstration",
  "sprint.revueDemoA": "Demonstrated to",
  "sprint.revueDemoLe": "Demonstrated on",
  "sprint.revueDemoValeur": "on {{date}} to {{qui}}",
  "sprint.revueEcart": "Gap: {{n}} item(s) done without evidence (missing test case).",
  "sprint.revueEnregistree": "Review and retrospective saved.",
  "sprint.revueEnregistrer": "Save the review",
  "sprint.revueErreur": "Review unreadable: {{m}}",
  "sprint.revueFaits": "{{fait}} / {{total}} items done, {{preuve}} truly finished (with evidence).",
  "sprint.revueLectureSeule": "Read only — entering the review and retrospective is reserved for the project's contributors.",
  "sprint.revueNonClos": "The sprint is not closed: the review and retrospective open when it closes.",
  "sprint.revueNotes": "Review notes",
  "sprint.revueObjectif": "Sprint goal",
  "sprint.revueReportes": "Carried over at closing ({{n}}):",
  "sprint.revueTitre": "Review and retrospective",
  "sprint.revueVersBacklog": "backlog",
  "sprint.revueVide": "No review entered",
  "sprint.sansDates": "no dates",
  "sprint.statut": "Status",
  "sprint.tacheAutreSprint": "in another sprint",
  "sprint.taches": "Tasks ({{n}})",
  "sprint.tousLesSprints": "All sprints",
  "sprint.usAjoutee": "“{{titre}}” added to the sprint.",
  "sprint.usRetiree": "“{{titre}}” removed from the sprint.",
  "sprint.velocite": "Velocity ({{n}} closed sprints)",
  "sprint.velociteAucune": "no closed sprint",
  "sprint.wipAbsente": "This gateway does not serve the limits: only the counts are shown.",
  "sprint.wipActif": "Counted on the items of this sprint, the active sprint.",
  "sprint.wipErreur": "Limits unreadable (the gateway did not respond): only the counts are shown.",
  "sprint.wipNonActif": "The limit applies to the active sprint; this sprint is not active: its counts are shown for information.",
  "sprint.wipRegler": "Set the limits",
  "sprint.wipTitre": "Work-in-progress limit, per column — read only",
  "velocite.aria": "Velocity of {{n}} sprint(s): {{detail}}. Average of closed sprints: {{m}} points.",
  "velocite.ariaSprint": "{{nom}} {{fait}} done out of {{engage}} committed",
  "velocite.ceSprint": "this sprint",
  "velocite.chargement": "Reading sprints…",
  "velocite.colCapacite": "Declared capacity",
  "velocite.colEngage": "Committed (pts)",
  "velocite.colSprint": "Sprint",
  "velocite.colTermine": "Done (pts)",
  "velocite.engage": "Committed",
  "velocite.erreur": "Velocity unreadable: {{m}}",
  "velocite.legendeCapacite": "Under each sprint: declared capacity (person-days), “—” if not declared.",
  "velocite.legendeMoyenne": "Average of closed sprints",
  "velocite.moyenne": "Average velocity ({{n}} closed sprint(s)): {{v}} pts",
  "velocite.tableCaption": "Velocity per sprint: committed, done, declared capacity",
  "velocite.termine": "Done",
  "velocite.titre": "Velocity — committed and done points per sprint",
  "velocite.vide": "No closed sprint: velocity will appear after the first closing",
  "velocite.videIndice": "Velocity is the average of points done in closed sprints.",
  "publication.application": "Application",
  "publication.chargement": "Loading revisions and publications…",
  "publication.code.APP_REPOSITORY_MISSING": "No repository for this application: publish a revision first.",
  "publication.code.ENVIRONMENT_CONFLICT": "An environment with this name exists and is not this application's.",
  "publication.code.GITLAB_EGRESS_REFUSED": "The GitLab host is not in the allowed outbound list.",
  "publication.code.GITLAB_GROUP_CONFLICT": "The organisation's GitLab subgroup exists without its marker: refused.",
  "publication.code.GITLAB_NOT_CONFIGURED": "No GitLab known for this project: configure the project's GitLab connection, or publish a first revision.",
  "publication.code.GITLAB_PROJECT_CONFLICT": "A GitLab project with this name exists and does not belong to this application.",
  "publication.code.GITLAB_PROVISION_TOKEN_MISSING": "The worker has no GitLab provisioning token: operations must provide it.",
  "publication.code.GITLAB_RUNNER_MISSING": "No runner online for the repository: register the hardened runner (make v050-gitlab-runner-register).",
  "publication.code.GITLAB_RUNNER_UNVERIFIABLE": "Runners cannot be listed with this token: precondition cannot be checked.",
  "publication.code.GITLAB_TOKEN_REFUSED": "GitLab refused the token.",
  "publication.code.GITLAB_UNREACHABLE": "Local GitLab unreachable: start it (make v050-gitlab-up).",
  "publication.code.HOST_PORT_TAKEN": "This port is already assigned to another environment.",
  "publication.code.REVISION_NOT_DONE": "Only a successful generation is published.",
  "publication.code.REVISION_NOT_FOUND": "Revision not found for this application.",
  "publication.code.REVISION_REQUIREMENTS_UNSAFE": "requirements.txt contains an option, a URL or a path: refused.",
  "publication.code.REVISION_UNATTESTED": "The revision tree no longer matches the one attested by its generation.",
  "publication.code.SCM_KEY_UNAVAILABLE": "Encrypted token unreadable: the gateway SCM key is missing or differs from the worker's.",
  "publication.code.STACK_DELIVERY_RUNNER_NOT_HARDENED": "This stack runs generated code in CI: an attested hardened runner is required.",
  "publication.code.STACK_PROFILE_UNKNOWN": "Unknown stack profile: the revision's infrastructure files are not the template's.",
  "publication.code.STACK_PROFILE_UNSUPPORTED": "The published stack profile is not deployable.",
  "publication.code.VALIDATION_ERROR": "Value refused by the server.",
  "publication.col.action": "Action",
  "publication.col.commit": "Commit",
  "publication.col.etat": "Status",
  "publication.col.pipeline": "Pipeline or reason",
  "publication.col.revision": "Revision",
  "publication.commit.aide": "Author: DoIt runtime. The push triggers the pipeline: template (Dockerfile = template), build, test.",
  "publication.commit.rafraichi": "Pipeline not refreshed: {{e}}",
  "publication.commit.titre": "Revision {{rev}} — commit {{sha}}",
  "publication.dejaDemandee": "Revision {{rev}} is already requested or published: nothing more.",
  "publication.demandee": "Publication of revision {{rev}} queued.",
  "publication.deploiement.failed": "failed",
  "publication.deploiement.pending": "in progress",
  "publication.deploiement.rolled_back": "rolled back",
  "publication.deploiement.stopped": "stopped",
  "publication.deploiement.succeeded": "succeeded",
  "publication.depot.branche": "Branch",
  "publication.depot.brancheValeur": "main, protected · one commit per revision",
  "publication.depot.dec039": "One GitLab subgroup per organisation (DEC-039).",
  "publication.depot.jeton": "Token",
  "publication.depot.jetonValeur": "doit-publication · {{portees}} · expires {{date}} · encrypted, never shown",
  "publication.depot.ouvrir": "Open in GitLab",
  "publication.depot.prive": "private",
  "publication.depot.projet": "Project",
  "publication.depot.titre": "Application repository",
  "publication.depot.vide": "No repository yet",
  "publication.depot.videAide": "The private GitLab repository of the application is created at its first publication.",
  "publication.description": "Each green revision of the application becomes a commit in its private GitLab repository; the push triggers its pipeline. Linked environments are deployed from Versions.",
  "publication.enCoursAide": "push in progress; the pipeline will be looked up by its SHA",
  "publication.env.adresse": "Address",
  "publication.env.chargement": "Loading environments…",
  "publication.env.cree": "Environment “{{nom}}” linked: {{url}} (pipeline required, branch main).",
  "publication.env.deployable": "Deployable: a commit published by DoIt (APP_COMMIT_NOT_PUBLISHED), with the template Dockerfile (APP_DOCKERFILE_NOT_TEMPLATE).",
  "publication.env.deploye": "Deployed",
  "publication.env.environnement": "Environment",
  "publication.env.etat": "Status",
  "publication.env.jamais": "never deployed",
  "publication.env.misAJour": "Environment “{{nom}}” updated: {{url}}.",
  "publication.env.nom": "Name",
  "publication.env.nomInvalide": "Name required: letters, digits, space, dot, dash; at most 50 characters.",
  "publication.env.port": "Published port ({{min}}–{{max}})",
  "publication.env.portHorsPlage": "Published port outside the reserved range {{min}}–{{max}}.",
  "publication.env.production": "production",
  "publication.env.rang": "rank {{r}}",
  "publication.env.regle": "Branch main · pipeline required · port published on 127.0.0.1",
  "publication.env.relier": "Link an environment",
  "publication.env.relierAction": "Link",
  "publication.env.titre": "Environments linked to the repository",
  "publication.env.versions": "Deploy from Versions",
  "publication.env.vide": "No linked environment",
  "publication.env.videAide": "Link an environment below once the repository exists; it will be deployable from Versions.",
  "publication.etat.failed": "failed",
  "publication.etat.nonPubliee": "not published",
  "publication.etat.published": "published",
  "publication.etat.publishing": "publishing",
  "publication.etat.requested": "requested",
  "publication.pipeline.canceled": "canceled",
  "publication.pipeline.failed": "failed",
  "publication.pipeline.manual": "manual",
  "publication.pipeline.pending": "pending",
  "publication.pipeline.running": "running",
  "publication.pipeline.searching": "looked up by its SHA",
  "publication.pipeline.skipped": "skipped",
  "publication.pipeline.success": "passed",
  "publication.pipelineRouge": "not deployable",
  "publication.pre.aide": "Otherwise, a named refusal, never simulated: the worker checks again when publishing.",
  "publication.pre.chargement": "Checking GitLab…",
  "publication.pre.dernierRefus": "Last worker refusal ({{date}}, revision {{rev}}):",
  "publication.pre.inconnu": "not checked",
  "publication.pre.jeton": "Token accepted",
  "publication.pre.joignable": "GitLab reachable",
  "publication.pre.ko": "not met",
  "publication.pre.nonRemplie": "not met",
  "publication.pre.ok": "met",
  "publication.pre.remplie": "met",
  "publication.pre.runner": "Runner online for the repository",
  "publication.pre.runnerCompte": "{{n}} runner(s) online",
  "publication.pre.runnerInconnu": "checked by the worker at the first publication (runner of the doit-apps group)",
  "publication.pre.sourceDepot": "token of the application repository",
  "publication.pre.sourceScm": "GitLab connection of the project",
  "publication.pre.titre": "Precondition: local GitLab running and runner",
  "publication.pre.version": "version {{v}}",
  "publication.publier": "Publish",
  "publication.publierUne": "Publish a revision",
  "publication.refus": "This project is not accessible with your account: ask its owner for access.",
  "publication.refus.controles": "{{ok}} checks out of {{total}}: only a green revision is published.",
  "publication.refus.nonTerminee": "Generation not successful (status: {{etat}}): nothing to publish.",
  "publication.relancer": "Retry",
  "publication.revisions": "Publications per revision",
  "publication.revisionsRegle": "Only a green revision is published: 10 checks out of 10, attested tree.",
  "publication.roleContributeur": "contributor",
  "publication.sansProjet": "The GitLab repository belongs to an application of a project.",
  "publication.titre": "Code publication",
  "publication.vide": "No generated application",
  "publication.videAide": "A revision is born from an application generation from an approved specification (Approvals screen); it is published here once green.",
  "accueil.archi.aucuneDecision": "No architecture decision pending.",
  "accueil.archi.aucuneDerogation": "No waiver request pending.",
  "accueil.archi.baseline": "Technology choices and baseline",
  "accueil.archi.decisions": "Decisions to make",
  "accueil.archi.dependances": "Cross-project dependencies",
  "accueil.archi.derogationDetail": "requested by {{qui}} · risk {{r}} · expires {{e}}",
  "accueil.archi.derogations": "Waivers to decide",
  "accueil.archi.irreversible": "one-way",
  "accueil.archi.ouvrirDecisions": "Open decisions",
  "accueil.archi.ouvrirExigences": "Open requirements and waivers",
  "accueil.archi.pile": "Stack profile and generability",
  "accueil.archi.proposeePar": "proposed by {{qui}} on {{quand}} · {{n}} option(s)",
  "accueil.archi.technologies": "Project technology",
  "accueil.sm.atteinte": "limit reached",
  "accueil.sm.aucunObstacle": "No impediment reported in the sprint.",
  "accueil.sm.aucunSprint": "No active sprint: start the next one from Sprints.",
  "accueil.sm.bloque": "blocked",
  "accueil.sm.bloquePar": "by {{liste}}",
  "accueil.sm.colonne": "{{c}}: {{n}} / {{l}}",
  "accueil.sm.dates": "from {{a}} to {{b}}",
  "accueil.sm.depassee": "limit exceeded",
  "accueil.sm.depuis": "status unchanged for {{n}} day(s)",
  "accueil.sm.items": "items done",
  "accueil.sm.joursRestants": "day(s) left",
  "accueil.sm.obstacles": "Impediments",
  "accueil.sm.obstaclesAide": "Sprint items blocked by a “blocks” link, or not moving for {{n}} days.",
  "accueil.sm.obstaclesSansSprint": "No active sprint: nothing to clear.",
  "accueil.sm.ouvrirSprint": "Open the sprint page",
  "accueil.sm.ouvrirTableau": "Open the board",
  "accueil.sm.points": "points done / committed",
  "accueil.sm.sprint": "Active sprint",
  "accueil.sm.stagnant": "not moving",
  "accueil.sm.wip": "Work in progress",
  "accueil.sm.wipAbsent": "Work-in-progress limits are not served by the gateway.",
  "accueil.sm.wipOk": "Every column is under its limit.",
  "accueil.sm.wipSansLimite": "No work-in-progress limit is set.",
  "accueil.sponsor.aDecider": "to decide",
  "accueil.sponsor.aucuneVersion": "No release in preparation.",
  "accueil.sponsor.calendrier": "Open the calendar",
  "accueil.sponsor.demande": "{{v}} on {{e}}",
  "accueil.sponsor.demandeePar": "requested by {{qui}} on {{quand}}",
  "accueil.sponsor.jalon": "Target milestone",
  "accueil.sponsor.liens": "Go further",
  "accueil.sponsor.miseEnLigne": "Go-live to approve",
  "accueil.sponsor.objectif": "Objective",
  "accueil.sponsor.ouvrirVersion": "Open the release",
  "accueil.sponsor.prochaines": "Upcoming production releases",
  "accueil.sponsor.production": "go-live (production)",
  "accueil.sponsor.programme": "Programme",
  "accueil.sponsor.rapport": "Progress report",
  "accueil.sponsor.rienAApprouver": "Nothing awaits your approval for release {{v}}.",
  "accueil.sponsor.risques": "Open risks",
  "accueil.sponsor.sansProgramme": "This project belongs to no programme: follow it through its roadmap.",
  "accueil.titre.architecte": "Decisions and waivers awaiting your opinion",
  "accueil.titre.scrum_master": "The active sprint, its impediments and work in progress",
  "accueil.titre.sponsor": "What awaits your approval, and where the programme stands",
  "calendrier.aVenir": "Upcoming production releases",
  "calendrier.actionsTitre": "Plan",
  "calendrier.agenda": "Month agenda",
  "calendrier.annuleePar": "Cancelled by",
  "calendrier.annulerGel": "Cancel this freeze",
  "calendrier.annulerPlan": "Cancel this production release",
  "calendrier.annules": "Cancelled this month ({{n}})",
  "calendrier.au": "To",
  "calendrier.aucunDeploiement": "None yet: deployment is started from the release page.",
  "calendrier.aucuneAVenir": "No production release planned ahead.",
  "calendrier.ceMois": "This month",
  "calendrier.chargement": "Reading the calendar…",
  "calendrier.choisir": "— choose —",
  "calendrier.cibleAide": "It places the release as a milestone on the product roadmap.",
  "calendrier.cibleOk": "Target date saved.",
  "calendrier.codeRefus": "Reason: {{c}}",
  "calendrier.dateCible": "Target date",
  "calendrier.datePrevue": "Planned date",
  "calendrier.declarePar": "Declared by",
  "calendrier.deploiement.failed": "failed",
  "calendrier.deploiement.pending": "in progress",
  "calendrier.deploiement.rolled_back": "rolled back",
  "calendrier.deploiement.succeeded": "succeeded",
  "calendrier.deploiementsReels": "Actual deployments of this release to this environment",
  "calendrier.description": "Deployments done and planned, release target dates and freeze periods, month by month.",
  "calendrier.detailErreur": "This detail could not be read.",
  "calendrier.dim": "Sun",
  "calendrier.du": "From",
  "calendrier.effacerCible": "Clear the date",
  "calendrier.enregistrerCible": "Save",
  "calendrier.environnement": "Environment",
  "calendrier.erreur": "The calendar could not be read.",
  "calendrier.evtCible": "target date of {{v}}",
  "calendrier.evtDeploiement": "{{v}} deployed to {{e}} ({{s}})",
  "calendrier.evtPlan": "{{v}} → {{e}}: {{s}}",
  "calendrier.formCible": "Target date of a release",
  "calendrier.formGel": "Declare a freeze period",
  "calendrier.formPlan": "Plan a production release",
  "calendrier.gelActif": "active",
  "calendrier.gelAnnule": "cancelled",
  "calendrier.gelAucunDeploiement": "None.",
  "calendrier.gelAucunPlan": "None.",
  "calendrier.gelAvertit": "A freeze warns: it does not block a deployment (organisation policy).",
  "calendrier.gelCourt": "freeze",
  "calendrier.gelDeploiements": "Deployments done during this freeze ({{n}})",
  "calendrier.gelDuAu": "Freeze from {{a}} to {{b}}",
  "calendrier.gelDuAuJours": "from {{a}} to {{b}} ({{n}} day(s))",
  "calendrier.gelIntrouvable": "Freeze period not found",
  "calendrier.gelOk": "Freeze period declared; {{n}} planned production release(s) affected.",
  "calendrier.gelPlans": "Production releases planned during this freeze ({{n}})",
  "calendrier.gelTitre": "Freeze period",
  "calendrier.geler": "Declare the freeze",
  "calendrier.grilleLegende": "Production releases of the month, day by day",
  "calendrier.introuvableIndice": "It does not exist in this project, or it belongs to another project.",
  "calendrier.jeu": "Thu",
  "calendrier.lectureSeule": "Read only: planning, freezing or dating a release requires an owner or contributor role in the project.",
  "calendrier.lun": "Mon",
  "calendrier.manqueCible": "Choose the release and its date.",
  "calendrier.manqueGel": "Enter both dates and a reason of at least 5 characters.",
  "calendrier.manquePlan": "Choose the release, the environment and the date.",
  "calendrier.mar": "Tue",
  "calendrier.mer": "Wed",
  "calendrier.motif": "Reason",
  "calendrier.motifAnnulation": "Reason for cancelling",
  "calendrier.motifCourt": "A reason of at least 5 characters is required.",
  "calendrier.note": "Note (optional)",
  "calendrier.parLe": "{{qui}}, on {{quand}}",
  "calendrier.parLeMotif": "{{qui}}, on {{quand}}: {{motif}}",
  "calendrier.periode": "Period",
  "calendrier.plan.annule": "cancelled",
  "calendrier.plan.en_retard": "late",
  "calendrier.plan.prevu": "planned",
  "calendrier.plan.prevu_en_gel": "planned during a freeze",
  "calendrier.plan.realise": "done",
  "calendrier.planEnGel": "Production release planned — warning: it falls within a freeze period.",
  "calendrier.planIntrouvable": "Planned production release not found",
  "calendrier.planOk": "Production release planned.",
  "calendrier.planPendantGel": "This date falls within a freeze period: the production release remains possible, it is flagged.",
  "calendrier.planTitre": "Planned production release",
  "calendrier.planVers": "{{v}} → {{e}}",
  "calendrier.planifiePar": "Planned by",
  "calendrier.planifier": "Plan",
  "calendrier.precedent": "Previous month",
  "calendrier.production": "production",
  "calendrier.realiseeLe": "Done on",
  "calendrier.refus": "You are not a member of this project: its calendar is not open to you.",
  "calendrier.retour": "Back to the calendar",
  "calendrier.sam": "Sat",
  "calendrier.suivant": "Next month",
  "calendrier.tousEnvironnements": "All environments",
  "calendrier.ven": "Fri",
  "calendrier.version": "Release",
  "calendrier.vide": "Nothing planned or done this month",
  "calendrier.videIndice": "Plan a production release or declare a freeze period below.",
  "frise.aPlanifier": "To plan: no dated sprint ({{n}})",
  "frise.aucunEpic": "No epic: epics come from the backlog generated from an approved specification.",
  "frise.aucuneVersion": "No release prepared: milestones appear as soon as a release has a target date or is delivered.",
  "frise.aujourdhui": "today: {{d}}",
  "frise.avancementSuffixe": ", {{pct}} % done",
  "frise.barreLibelle": "{{titre}}: {{etat}}, from {{debut}} to {{fin}}{{avancement}}",
  "frise.enRetardCompte": "{{n}} late",
  "frise.epics": "Epics and features",
  "frise.etat.a_venir": "upcoming",
  "frise.etat.en_cours": "in progress",
  "frise.etat.en_retard": "late",
  "frise.etat.livre": "delivered",
  "frise.etat.non_date": "undated (to plan)",
  "frise.etat.termine": "done, not delivered",
  "frise.jalon.en_retard": "target date passed",
  "frise.jalon.livre": "delivered",
  "frise.jalon.non_date": "undated",
  "frise.jalon.prevu": "planned",
  "frise.jalonLibelle": "Release {{v}}: {{etat}}, {{d}}",
  "frise.legende": "Legend",
  "frise.legendeJalon": "release (milestone)",
  "frise.livreDans": "in {{v}}",
  "frise.sprintLibelle": "{{n}}: from {{a}} to {{b}}, {{f}} / {{e}} points",
  "frise.sprints": "Sprints",
  "frise.versions": "Releases",
  "nav./calendrier": "Production release calendar",
  "nav./programme/rapport": "Progress report",
  "navdesc./calendrier": "Deployments done and planned, release target dates and freeze periods",
  "navdesc./programme/rapport": "Objective, risks, actual velocity and completion forecast; CSV export and print",
  "pgmRoadmap.friseChargement": "Reading the product timeline…",
  "pgmRoadmap.friseErreur": "The programme’s product timeline could not be read.",
  "pgmRoadmap.friseTitre": "Product roadmap of the projects",
  "pgmRoadmap.jalonCible": "Programme target milestone: {{j}}{{d}}",
  "pgmRoadmap.sansJalon": "No target milestone: set it in the programme settings.",
  "pgmRoadmap.tableauTitre": "Sprints of the attached projects",
  "rapport.aucunRisque": "No open risk.",
  "rapport.aucunSprintActif": "none",
  "rapport.avancementMoyen": ", average progress {{p}} %",
  "rapport.cadenceDefaut": "default cadence (undated sprints)",
  "rapport.chargement": "Computing the progress report…",
  "rapport.cible": "target {{d}}",
  "rapport.colEngage": "committed",
  "rapport.colFin": "end",
  "rapport.colSprint": "sprint",
  "rapport.colTermine": "done",
  "rapport.csv.dateProbable": "Likely date",
  "rapport.csv.derniereLivree": "Last delivered release",
  "rapport.csv.ecart": "Gap to target (days)",
  "rapport.csv.enPreparation": "Release in preparation",
  "rapport.csv.engageTermine": "Committed / done (active sprint)",
  "rapport.csv.epics": "Epics done / total",
  "rapport.csv.fourchette": "Range",
  "rapport.csv.genere": "Generated on",
  "rapport.csv.impact": "Impact",
  "rapport.csv.jalon": "Target milestone",
  "rapport.csv.nonAccessibles": "Projects not detailed (not a member)",
  "rapport.csv.nonEstimes": "Unestimated items",
  "rapport.csv.objectif": "Objective",
  "rapport.csv.parade": "Mitigation",
  "rapport.csv.porteur": "Owner",
  "rapport.csv.prevision": "Forecast",
  "rapport.csv.programme": "Programme",
  "rapport.csv.projet": "Project",
  "rapport.csv.reste": "Remaining (points)",
  "rapport.csv.risque": "Open risk",
  "rapport.csv.sprintActif": "Active sprint",
  "rapport.csv.synthese": "Summary",
  "rapport.csv.tendance": "Trend",
  "rapport.csv.velocite": "Average velocity",
  "rapport.derniereLivree": "last delivered: {{v}}",
  "rapport.description": "Objective, risks, actual velocity and completion forecast, project by project — exportable.",
  "rapport.ecartAvance": "{{n}} day(s) before the target",
  "rapport.ecartRetard": "{{n}} day(s) after the target",
  "rapport.enPreparation": "in preparation: {{v}}",
  "rapport.epics": "Epics",
  "rapport.epicsValeur": "{{f}} done out of {{n}}{{m}}",
  "rapport.erreur": "The progress report could not be computed.",
  "rapport.exporterCsv": "Export as CSV",
  "rapport.fourchette": "range: {{a}} → {{b}}",
  "rapport.genereLe": "Report of {{d}}",
  "rapport.impact": "impact {{i}}",
  "rapport.impact.high": "high",
  "rapport.impact.low": "low",
  "rapport.impact.medium": "medium",
  "rapport.imprimer": "Print or save as PDF",
  "rapport.jalon": "Target milestone: {{j}}{{d}}",
  "rapport.motif.AUCUN_SPRINT_CLOS": "no closed sprint: velocity is not measured yet",
  "rapport.motif.RESTE_NON_ESTIME": "the remaining work is not estimated in points",
  "rapport.motif.VELOCITE_NULLE": "the last closed sprints finished nothing: no velocity",
  "rapport.objectif": "Objective: {{o}}",
  "rapport.parade": "mitigation: {{p}}",
  "rapport.porteur": "owner: {{p}}",
  "rapport.prevision": "Forecast",
  "rapport.previsionInsuffisante": "insufficient data: {{m}}",
  "rapport.previsionTermine": "remaining work done",
  "rapport.previsionValeur": "likely end on {{d}} ({{n}} sprint(s) of {{c}} days)",
  "rapport.projetsTitre": "Progress by project",
  "rapport.regle": "Velocity: average points done over the last 3 closed sprints; likely date = today + ⌈remaining ÷ velocity⌉ sprints; range with the highest and the lowest velocity.",
  "rapport.reste": "Remaining work",
  "rapport.resteValeur": "{{p}} pts over {{n}} item(s), {{e}} of them unestimated",
  "rapport.risquesTitre": "Open risks ({{n}}, {{h}} with high impact)",
  "rapport.sansJalon": "Target milestone: not set",
  "rapport.sansObjectif": "Objective: not set",
  "rapport.sourceInstantane": "last snapshot of the active sprint",
  "rapport.sourceItems": "items attached to the sprint and carried over at closing",
  "rapport.sprintActif": "Active sprint",
  "rapport.sprintActifDetail": "{{n}} — {{f}} / {{e}} pts done, {{j}} day(s) left",
  "rapport.synthese.aucun_projet": "No open project: nothing to forecast.",
  "rapport.synthese.dans_les_temps": "Likely end on {{d}}: on time ({{n}} day(s) ahead).",
  "rapport.synthese.donnees_insuffisantes": "Programme forecast impossible: {{n}} project(s) without sufficient data (see below).",
  "rapport.synthese.en_retard": "Likely end on {{d}}: {{n}} day(s) after the target date.",
  "rapport.synthese.sans_cible": "Likely end on {{d}}; the programme has no target date.",
  "rapport.synthese.termine": "All estimated remaining work is done.",
  "rapport.tendance.baisse": "decreasing",
  "rapport.tendance.donnees_insuffisantes": "insufficient data (fewer than 2 closed sprints)",
  "rapport.tendance.hausse": "increasing",
  "rapport.tendance.stable": "stable",
  "rapport.velocite": "Average velocity (last 3 closed sprints)",
  "rapport.velociteTitre": "Closed sprints, most recent first",
  "rapport.velociteValeur": "{{v}} pts per sprint, {{tendance}}",
  "rapport.versions": "Releases",
  "roadmap.descriptionProduit": "Epics and features dated by their sprints, releases as milestones, sprints as a band.",
  "roadmap.erreur": "The roadmap could not be read.",
  "roadmap.filtreDemande": "Request",
  "roadmap.refus": "You are not a member of this project: its roadmap is not open to you.",
  "roadmap.toutesDemandes": "All requests",
  "roadmap.videDemande": "No epic linked to this request",
  "roadmap.videProduit": "Nothing to place on the roadmap",
  "roadmap.videProduitIndice": "Epics come from an approved specification; give your sprints dates and your releases a target date.",
  "roadmap.voirDemande": "Open {{ref}}",
  "pgmTech.changementsTitre": "Programme change requests",
  "pgmTech.changementsDescription": "Change requests and propagations of the programme and its projects, with the flow indicators.",
  "pgmTech.modifier": "Change the standard: change request or propagation to inheriting projects",
  "baseline.modifierAide": "“Change…” opens a change request: impact analysis, review, then baseline vN+1 on approval.",
  "baseline.demandesOuvertes": "Open change requests",
  "chg.liste.chargement": "Reading change requests…",
  "baseline.demandesIllisibles": "Change requests unreadable for now.",
  "baseline.aucuneDemande": "No change request in progress on this project.",
  "baseline.toutesDemandes": "All change requests",
  "baseline.colActions": "Actions",
  "baseline.completer": "Complete through a request",
  "baseline.demanderDerogation": "Request a waiver",
  "baseline.filtreesPlateforme": "{{n}} entry(ies) hidden: no stack for the chosen platform generates them.",
  "baseline.pileNonQualifiee": "not qualified: generability still to be measured",
  "baseline.pileQualifiee": "qualified",
  "baseline.pileTitre": "Generation stack",
  "baseline.pileAide": "The AI builds the application with a stack validated by the platform: only validated stacks can be selected; the others will come in a later version.",
  "baseline.pileAucune": "No generation stack for this platform: choose custom, category by category.",
  "baseline.pileAucuneValidee": "No stack is validated for this platform yet: AI generation will come with them; you can still launch with a custom choice.",
  "baseline.pileValidee": "validated",
  "baseline.pileAVenir": "Coming soon",
  "baseline.pileNonSelectionnable": "Not selectable yet: {{motif}}",
  "baseline.pileSurMesure": "Custom (choose by category below)",
  "baseline.pileErreur": "The stack catalogue could not be read: {{message}}",
  "baseline.pileChargement": "Reading generation stacks…",
  "baseline.plateforme.desktop": "Desktop",
  "baseline.plateforme.mobile": "Mobile",
  "baseline.plateforme.web": "Web",
  "baseline.plateformeAide": "Web, mobile or desktop: it determines the possible generation stacks and filters the languages, frameworks and databases offered below.",
  "baseline.plateformeAucune": "Not specified",
  "baseline.plateformePiles": "Generation stacks for this platform:",
  "baseline.plateformeTitre": "Target platform",
  "baseline.plateformeVide": "No platform in the organisation catalogue: the starter set offers three (web, mobile, desktop).",
  "chg.liste.refus": "This project’s change requests are not open to you: its members read them.",
  "chg.liste.erreur": "Requests unreadable: the gateway did not answer; nothing changed.",
  "chg.liste.titre": "Change requests",
  "chg.liste.description": "Change a technology value of the project: draft, impact analysis, review by another person, baseline vN+1 on approval, rework tracked until closure.",
  "chg.liste.baseline": "Current baseline: v{{v}}.",
  "chg.liste.voirBaseline": "See the baseline",
  "chg.liste.nouvelle": "New request",
  "chg.liste.verrous": "Locked categories",
  "chg.liste.verrou": "{{c}}: {{ref}} is in progress — another request on this category stays a draft.",
  "chg.liste.vide": "No change request",
  "chg.liste.videLecture": "The project owner or a contributor opens a request from the baseline (“Change…”).",
  "chg.liste.videAide": "The baseline has never changed. “New request” or “Change…” on a baseline category opens one.",
  "chg.det.chargementBaseline": "Reading the baseline…",
  "chg.liste.erreurBaseline": "Baseline unreadable: no value can be proposed.",
  "chg.det.refus": "This request is not open to you, or it does not exist in this scope.",
  "chg.det.chargement": "Reading the request…",
  "chg.det.erreur": "Request unreadable: the gateway did not answer; nothing changed.",
  "chg.det.retour": "← All requests",
  "chg.det.niveauPropose": "level proposed by the tool: {{n}}",
  "chg.sensible": "sensitive",
  "chg.det.valeurs": "Current value: {{avant}} → proposed: {{apres}}",
  "chg.det.aucune": "none",
  "chg.det.motif": "Reason: {{m}}",
  "chg.det.meta": "Opened by {{auteur}} on {{date}} · urgency {{u}}",
  "chg.det.echeance": "due {{date}}",
  "chg.det.baseline": "baseline v{{v}} written on {{date}}",
  "chg.det.echue": "Due date passed: the propagation is not verified — compliance red until the non-regression is green.",
  "chg.det.parent": "Inherited from",
  "chg.det.rapprocher": "To reconcile with the open request",
  "chg.det.refusee": "Refused: {{m}}",
  "chg.det.close": "Closed by {{qui}}: {{note}}",
  "chg.det.cycle": "Request lifecycle",
  "chg.act.modifier": "Edit the draft",
  "chg.act.analyser": "Analyse the impact",
  "chg.ann.analyse": "Analysis done: the impact report is up to date and the category is locked.",
  "chg.act.reprendre": "Resume the propagation",
  "chg.ann.reprise": "Propagation resumed: the heirs not yet applied have been processed.",
  "chg.act.abandonner": "Withdraw",
  "chg.act.motifAbandon": "Reason for withdrawal",
  "chg.ann.abandon": "Request withdrawn.",
  "chg.det.decision": "Review and decision",
  "chg.det.sansApprobation": "No approval required: propagation is an act of the source holder.",
  "chg.det.approbations": "Approvals: {{k}} of {{n}} required — never the author",
  "chg.det.approuve": "approved",
  "chg.det.refuse": "refused",
  "chg.det.par": "by {{qui}} on {{date}}",
  "chg.act.approuver": "Approve",
  "chg.act.motifApprobation": "Decision comment",
  "chg.ann.approuve": "Approval recorded.",
  "chg.act.refuser": "Refuse",
  "chg.act.motifRefus": "Reason for refusal",
  "chg.ann.refuse": "Request refused, reason recorded.",
  "chg.ann.modifie": "Draft saved.",
  "chg.act.adr": "Change ADR (major)",
  "chg.act.sansAdr": "— none —",
  "chg.act.soumettre": "Send to review",
  "chg.ann.soumis": "Request in review: a distinct approver decides.",
  "chg.ann.confirme": "Confirmation “{{d}}” recorded in your name.",
  "chg.conf.titre": "Named human confirmations",
  "chg.conf.faite": "“{{texte}}” — {{qui}}, {{date}}",
  "chg.conf.attendue": "not analysed, confirmation expected",
  "chg.conf.dimension": "Dimension",
  "chg.conf.texte": "What you checked",
  "chg.champRequis": "This field is required.",
  "chg.conf.exemple": "For example: “I checked the environments: staging, production”. For a sensitive category, name the category.",
  "chg.conf.envoyer": "Confirm in my name",
  "chg.rep.titre": "Rework",
  "chg.rep.aucun": "No rework item: add some to track the affected elements.",
  "chg.rep.avancement": "Rework · {{ref}} · {{k}}/{{m}} items done",
  "chg.rep.fait": "done",
  "chg.rep.aFaire": "to do",
  "chg.act.ajouterItem": "Add a rework item",
  "chg.act.titreItem": "Item title",
  "chg.ann.item": "Rework item added to the backlog.",
  "chg.act.clore": "Close the request",
  "chg.act.nonRegression": "Non-regression (report scope, attested environment)",
  "chg.ann.close": "Request closed.",
  "chg.act.garderEcart": "Keep the deviation",
  "chg.act.motifEcart": "Reason for keeping the deviation",
  "chg.ann.ecart": "Deviation kept, reason recorded.",
  "chg.act.valider": "Validate the rework",
  "chg.ann.verifiee": "Rework validated: the propagation is verified.",
  "chg.ann.propage": "Propagation started: each affected heir receives its “propagated” baseline and an attention item.",
  "chg.prop.titre": "Propagation to heirs",
  "chg.prop.lu": "I have read the impact: the value will be written immediately into the baseline of each affected heir.",
  "chg.prop.nom": "Type the name of the sensitive category: “{{c}}”",
  "chg.act.propager": "Propagate to heirs",
  "chg.dlg.modifierTitre": "Draft {{ref}}",
  "chg.dlg.nouvelleTitre": "New change request",
  "chg.dlg.aide": "The baseline never changes directly: the request is analysed (impact), reviewed, then approved by another person; baseline vN+1 is written on approval.",
  "chg.dlg.categorie": "Category",
  "chg.dlg.actuelle": "Current value: {{v}}",
  "chg.dlg.aucune": "none (category to complete)",
  "chg.dlg.sensible": "sensitive category: major change, two approvals",
  "chg.dlg.verrou": "{{ref}} is already in progress on this category: your request will stay a draft; its analysis will be refused until {{ref}} is closed.",
  "chg.dlg.voir": "See {{ref}}",
  "chg.dlg.valeurProposee": "Proposed value",
  "chg.dlg.natCatalogue": "Catalogue entry",
  "chg.dlg.natHors": "Outside the catalogue (traced by an ADR)",
  "chg.dlg.natIntegre": "Built into the generated stack",
  "chg.dlg.entree": "Entry",
  "chg.dlg.choisir": "— choose —",
  "chg.dlg.aucuneEntree": "No catalogue entry in this category: propose a value outside the catalogue.",
  "chg.dlg.entreeRequise": "Choose an entry.",
  "chg.dlg.produit": "Product",
  "chg.dlg.produitRequis": "Name the product.",
  "chg.dlg.version": "Version or range",
  "chg.dlg.motif": "Reason",
  "chg.dlg.motifRequis": "The reason is required.",
  "chg.dlg.urgence": "Urgency",
  "chg.dlg.niveau": "Level",
  "chg.dlg.niveauOutil": "proposed by the tool",
  "chg.dlg.niveauMajeur": "major (change ADR, separation of duties)",
  "chg.dlg.enregistrer": "Save the draft",
  "chg.dlg.creer": "Create the draft",
  "chg.dlg.titreOrg": "Change a value of the organisation catalogue",
  "chg.dlg.titrePgm": "Change the programme standard",
  "chg.dlg.aideMode": "Choose the mode first. Heirs that defined the category themselves or hold a waiver are never overwritten: they are only informed.",
  "chg.dlg.mode": "1. Mode",
  "chg.dlg.modeA": "Impact analysis, review and approval by another person; each heir receives a “to examine” request that it accepts or whose deviation it keeps.",
  "chg.dlg.modeB": "The value is written immediately into the baseline of each heir that inherits it (“rework to validate”, amber then red at the due date).",
  "chg.dlg.sensibleDeux": "Sensitive category: major, reinforced confirmation and two people.",
  "chg.dlg.entreeProposee": "Proposed entry",
  "chg.dlg.remplacee": "Replaced entry (optional)",
  "chg.dlg.aucuneRemplacee": "— none —",
  "chg.dlg.apres": "Status of the replaced entry after application",
  "chg.dlg.echeance": "Rework due date (days)",
  "chg.dlg.delaiInvalide": "From 1 to 365 days (30 by default).",
  "chg.der.faite": "Waiver requested (no. {{id}}): it follows the waiver circuit — review, then decision by another person.",
  "chg.der.titre": "Request a waiver — {{p}}",
  "chg.der.aide": "“{{p}}” is imposed by the organisation for “{{c}}”. Deviating from it requires a justified, dated and approved waiver (ORG-05).",
  "chg.der.justification": "Justification",
  "chg.der.controles": "Compensating controls (one per line)",
  "chg.der.responsable": "Owner",
  "chg.der.echeance": "Due date",
  "chg.der.envoyer": "Request the waiver",
  "chg.pf.chargement": "Reading the change portfolio…",
  "chg.pf.refusProgramme": "This programme is not open to you: its members read its change requests.",
  "chg.pf.refusOrganisation": "The organisation change portfolio is not open to you.",
  "chg.pf.erreur": "Portfolio unreadable: the gateway did not answer; nothing changed.",
  "chg.pf.aidePgm": "Requests of the programme and of its projects. To change the standard: a change request (mode A) or, for the programme owner, a propagation to inheriting projects (mode B).",
  "chg.pf.aideOrg": "Requests of the organisation, its programmes and its projects. An organisation request computes the impact project by project and never overwrites a project that defined the category or holds a waiver.",
  "chg.pf.videLecture": "No request or propagation in this scope yet.",
  "chg.pf.videAide": "No request or propagation yet: “New request” opens one, choosing the mode first.",
  "chg.pf.filtreEtat": "Status",
  "chg.pf.tous": "All",
  "chg.pf.filtreCategorie": "Category",
  "chg.pf.toutes": "All",
  "chg.pf.filtreProjet": "Project",
  "chg.pf.filtreVide": "No request matches these filters.",
  "chg.pf.chargementCatalogue": "Reading the catalogue…",
  "chg.pf.erreurCatalogue": "Catalogue unreadable: no entry can be proposed.",
  "chg.echue": "overdue",
  "chg.fermer": "Close",
  "chg.tableCaption": "Technology change requests",
  "chg.col.ref": "Request",
  "chg.col.portee": "Scope",
  "chg.col.categorie": "Category",
  "chg.col.valeurs": "Current → proposed",
  "chg.col.niveauMode": "Level · mode",
  "chg.col.etat": "Status",
  "chg.col.reprise": "Rework",
  "chg.col.echeance": "Due date",
  "chg.heriteeDe": "inherited from {{ref}}",
  "chg.repriseKm": "{{k}}/{{m}}",
  "chg.ind.titre": "Change flow indicators",
  "chg.ind.vide": "No data: no change request yet. Indicators are computed from the first one.",
  "chg.ind.caption": "Indicators by level and mode",
  "chg.ind.niveauMode": "Level · mode",
  "chg.ind.ouvertes": "Open",
  "chg.ind.refus": "Refusal rate",
  "chg.ind.delai": "Lead time to baseline (median · 85th pct.)",
  "chg.ind.reprise": "Rework time (median · 85th pct.)",
  "chg.ind.partPropagation": "Share of automatic propagations (mode B): {{p}}",
  "chg.imp.aucun": "No element affected.",
  "chg.imp.titre": "Impact report",
  "chg.imp.absent": "Not analysed yet: “Analyse the impact” produces the report and locks the category.",
  "chg.imp.du": "Analysed on {{date}}",
  "chg.imp.exigences": "Requirements",
  "chg.imp.adrs": "ADRs",
  "chg.imp.items": "Backlog items",
  "chg.imp.tests": "Tests",
  "chg.imp.projets": "Projects",
  "chg.imp.programmes": "Programmes",
  "chg.imp.vide": "No element affected among what is analysed.",
  "chg.imp.risque": "Regression risk",
  "chg.imp.analyse": "Analysed: {{liste}}",
  "chg.imp.nonAnalyse": "not analysed: {{liste}} — named human confirmation required",
  "chg.imp.generabilite": "Generability after the change",
  "chg.imp.generable": "generable ({{profil}})",
  "chg.imp.nonQualifie": "profile not qualified — its requalification belongs to the platform",
  "chg.imp.nonCouvert": "not generable: no “Generate the application” mission will be possible",
  "chg.imp.nonCouverts": "not covered: {{p}}",
  "chg.imp.proche": "nearest generable: {{p}} (without {{sans}})",
  "chg.imp.heritiersTitre": "Impact heir by heir",
  "chg.imp.devientNonGenerable": "will no longer be generable",
  "chg.imp.masques": "{{n}} heir(s) not open to you: counted, never named.",
  "chg.her.total": "{{n}} heir(s)",
  "chg.her.pending": "{{n}} not applied",
  "chg.her.to_validate": "{{n}} rework(s) to validate",
  "chg.her.verified": "{{n}} verified",
  "chg.her.to_examine": "{{n}} to examine",
  "chg.her.deviation_kept": "{{n}} deviation(s) kept",
  "chg.her.excluded": "{{n}} not affected",
  "chg.her.to_reconcile": "{{n}} to reconcile",
  "chg.her.titre": "Heirs",
  "chg.her.aucun": "No heir affected.",
  "chg.her.version": "baseline v{{v}}",
  "chg.her.rapprocher": "to reconcile with {{ref}}",
  "chg.etat.draft": "draft",
  "chg.etat.analysis": "analysed — confirmations expected",
  "chg.etat.in_review": "in review",
  "chg.etat.refused": "refused",
  "chg.etat.rework": "approved — rework in progress",
  "chg.etat.closed": "closed",
  "chg.etat.cancelled": "withdrawn",
  "chg.etat.propagating": "propagation in progress",
  "chg.etat.propagated": "propagated",
  "chg.etat.to_examine": "to examine",
  "chg.etat.deviation_kept": "deviation kept",
  "chg.etat.pending": "propagation not applied",
  "chg.etat.to_validate": "rework to validate",
  "chg.etat.verified": "verified",
  "chg.etat.excluded": "not affected (defined or waived)",
  "chg.etat.to_reconcile": "to reconcile",
  "chg.niveau.major": "major",
  "chg.niveau.minor": "minor",
  "chg.mode.propagation": "propagation to heirs (mode B)",
  "chg.mode.change": "change request (mode A)",
  "chg.modeCourt.propagation": "B · propagation",
  "chg.modeCourt.change": "A · request",
  "chg.urgence.low": "low",
  "chg.urgence.normal": "normal",
  "chg.urgence.high": "high",
  "chg.portee.project": "project",
  "chg.portee.program": "programme",
  "chg.portee.organisation": "organisation",
  "chg.dim.code": "code and revisions",
  "chg.dim.environments": "environments",
  "chg.dim.versions": "versions and deliveries",
  "chg.dim.design": "Design (brand, mock-ups, journeys)",
  "chg.couv.requirements": "requirements",
  "chg.couv.adrs": "ADRs",
  "chg.couv.backlog": "backlog items",
  "chg.couv.tests": "tests",
  "chg.couv.generability": "generability",
  "chg.couv.heirs": "heirs",
  "chg.issue.touched": "affected",
  "chg.issue.excluded_defined": "not affected: category defined by the heir",
  "chg.issue.excluded_waiver": "not affected: waiver",
  "chg.issue.to_reconcile": "to reconcile: a request is open there",
  "chg.issue.no_baseline": "no baseline",
  "chg.risque.low": "low",
  "chg.risque.medium": "medium",
  "chg.risque.high": "high",
  "chg.r.verrou": "A request is already in progress on this category: the category is locked until it is closed.",
  "chg.r.confirmation": "First confirm, in your name, each dimension the tool does not analyse (code, environments, versions, Design).",
  "chg.r.adr": "Major change: link a change ADR before the review.",
  "chg.r.autoApprobation": "The author of a request does not decide it: a distinct approver is required.",
  "chg.r.dejaDecide": "You have already given your decision on this request.",
  "chg.r.decideur": "Only the owner of the scope decides this request.",
  "chg.r.repriseOuverte": "All rework items must be done before closure.",
  "chg.r.etat": "This action is not possible in the current status of the request.",
  "chg.r.motif": "A reason is required.",
  "chg.r.source": "Propagation is reserved to the source holder (organisation administration, programme owner).",
  "chg.r.sensible": "Sensitive category: type the exact category name and get a second person’s agreement.",
  "chg.r.impact": "Confirm you have read the impact before propagating.",
  "chg.r.baseline": "A new baseline version requires a decided request that references it.",
  "chg.r.sansBaseline": "This project has no baseline yet: finish its launch first.",
  "chg.r.inacheve": "Launch incomplete: finish the launch before requesting a change.",
  "chg.r.ecriture": "Read only: the project owner or a contributor opens a request.",
  "chg.r.admin": "Read only: the organisation administration (platform administrator) opens and decides organisation requests.",
  "chg.r.programme": "Read only: the programme owner or a contributor opens a request; its owner decides it.",
  "chg.r.imposee": "Entry imposed by the organisation: replacing it requires a granted waiver.",
  "chg.r.unique": "Single-choice category: one value only.",
  "chg.r.manquante": "Mandatory category: it cannot stay empty.",
  "chg.jours": "{{n}} d",
  "chg.clo.titre": "Closure",
  "chg.act.cloturer": "Close",
  "chg.r.heritiersOuverts": "Some heirs have not finished (not applied, to examine, rework to validate or to reconcile): close once each one is done.",
  "architecture.api.confirmee": "Served",
  "architecture.api.nonRelevee": "Not surveyed",
  "architecture.api.pasDeReleve": "no survey",
  "architecture.api.releve": "{{c}} of {{n}} route(s) confirmed by the preview survey (routes actually served by the running application).",
  "architecture.api.sansReleve": "No preview survey for this revision: routes are read from the code, not confirmed by a run.",
  "architecture.api.titre": "Exposed routes",
  "architecture.api.vide": "No route to show",
  "architecture.arbre.aucune": "No revision retained",
  "architecture.arbre.missing": "Revision not found on disk",
  "architecture.arbre.unavailable": "Applications not mounted",
  "architecture.arbre.unverified": "Tree does not match its manifest",
  "architecture.arbre.verified": "Tree verified",
  "architecture.baseline.absente": "Not found in the revision",
  "architecture.baseline.aide": "Baseline v{{v}}: each value is searched BY NAME (whole word) in the revision's technologies and dependencies — a hint, not a proof.",
  "architecture.baseline.nonDerivee": "Revision not analysed",
  "architecture.baseline.ouvrir": "Open Choices and baseline",
  "architecture.baseline.retrouvee": "Found in the revision",
  "architecture.baseline.titre": "Technology baseline and delivered revision",
  "architecture.baseline.vide": "The project has no technology baseline",
  "architecture.chargement": "Reading versions and their revisions…",
  "architecture.chargementVersion": "Reading the revision and its SBOM…",
  "architecture.col.analyseLe": "Scanned on",
  "architecture.col.chemin": "Path",
  "architecture.col.composant": "Component",
  "architecture.col.composants": "Components",
  "architecture.col.constats": "Findings",
  "architecture.col.dependDe": "Depends on",
  "architecture.col.dependance": "Dependency",
  "architecture.col.dependances": "Dependencies",
  "architecture.col.ecosysteme": "Ecosystem",
  "architecture.col.empreinte": "Digest",
  "architecture.col.etat": "Status",
  "architecture.col.fichiers": "Files",
  "architecture.col.gestionnaire": "Handler",
  "architecture.col.licences": "Licenses",
  "architecture.col.lignes": "Lines",
  "architecture.col.methode": "Method",
  "architecture.col.outil": "Tool and database",
  "architecture.col.pile": "Stack",
  "architecture.col.provenance": "Written by",
  "architecture.col.relation": "Relation",
  "architecture.col.releve": "Survey",
  "architecture.col.revision": "Revision",
  "architecture.col.routes": "Routes",
  "architecture.col.sbom": "SBOM",
  "architecture.col.source": "Source",
  "architecture.col.technologie": "Technology",
  "architecture.col.type": "Type",
  "architecture.col.version": "Version",
  "architecture.col.versionLivree": "Version",
  "architecture.col.vulnerabilites": "Vulnerabilities",
  "architecture.composant.aucun": "None",
  "architecture.composant.aucune": "None",
  "architecture.composant.baseSansFichier": "Stack database: no schema file delivered, tables are created by the code.",
  "architecture.composant.dependDe": "Depends on",
  "architecture.composant.dependances": "Imported dependencies",
  "architecture.composant.description": "Component of the application delivered by a version",
  "architecture.composant.entree": "Entry point {{e}} · port {{p}}",
  "architecture.composant.fichiers": "Files ({{n}})",
  "architecture.composant.fichiersListe": "Component files",
  "architecture.composant.liens": "Links",
  "architecture.composant.routes": "Declared routes ({{n}})",
  "architecture.composant.sansRoute": "This component declares no route.",
  "architecture.composant.serviceSansFichier": "Stack service: its image is built by the template from the modules.",
  "architecture.composant.tables": "Tables: {{l}}",
  "architecture.composant.titre": "Component",
  "architecture.composant.utilisePar": "Used by",
  "architecture.composant.version": "version {{v}}, revision {{r}}",
  "architecture.composants.aide": "Services, database, code modules and groups, derived from the revision's verified files; “depends on” comes from the imports read in the code.",
  "architecture.composants.baseInutilisee": "(provided by the stack, not used by the code)",
  "architecture.composants.titre": "Components of the delivered application",
  "architecture.composants.vide": "No component derived",
  "architecture.composants.videAide": "This needs a revision retained by the version whose tree matches its manifest.",
  "architecture.dependance.absente": "absent",
  "architecture.dependance.courante": "(this version)",
  "architecture.dependance.declaree": "Declared in {{f}}{{s}}",
  "architecture.dependance.description": "Dependency of the application delivered by a version",
  "architecture.dependance.emplacements": "Locations in the image ({{n}})",
  "architecture.dependance.fixee": "Pinned by the stack template: delivered, not chosen.",
  "architecture.dependance.gabarit": "the stack template",
  "architecture.dependance.identite": "Identity and license",
  "architecture.dependance.indirecte": "Indirect dependency: the code does not import it itself.",
  "architecture.dependance.licence": "License: {{l}} ({{s}})",
  "architecture.dependance.licenceCatalogue": "The stack catalogue declares it under {{l}}.",
  "architecture.dependance.licenceInconnue": "Unknown license: neither the SBOM nor the stack catalogue gives it.",
  "architecture.dependance.nonDeclaree": "Not declared by the revision: pulled in when the image was built.",
  "architecture.dependance.nonImportee": "No module imports it in the delivered code.",
  "architecture.dependance.nonResolue": "Version not resolved: the image has not been built and signed.",
  "architecture.dependance.resolue": "Version in the image: {{v}}",
  "architecture.dependance.titre": "Dependency",
  "architecture.dependance.utilisee": "Imported by",
  "architecture.dependance.version": "version {{v}}",
  "architecture.dependance.versions": "In the project's versions",
  "architecture.deps.chercher": "Name contains",
  "architecture.deps.declaree": "declared {{s}}",
  "architecture.deps.filtres": "Dependency filters",
  "architecture.deps.nonResolue": "not resolved",
  "architecture.deps.relation": "Relation",
  "architecture.deps.sourceAucune": "No dependency inventoried for this version.",
  "architecture.deps.sourceDeclarees": "{{d}} direct dependency(ies) declared by the revision. The image has not been built and signed: resolved versions and transitive dependencies are unknown.",
  "architecture.deps.sourceImage": "{{total}} dependency(ies): {{d}} direct, {{tr}} transitive, {{sy}} system package(s) — resolved versions and licenses read from the built image's SBOM.",
  "architecture.deps.titre": "Dependency inventory (SBOM)",
  "architecture.deps.toutes": "All",
  "architecture.deps.vide": "No dependency",
  "architecture.deps.videAide": "The version retains no analysable revision.",
  "architecture.deps.videFiltre": "No dependency matches the filters.",
  "architecture.description": "Components, API, dependencies (SBOM) and vulnerabilities of the delivered application, per version — derived from the retained revision.",
  "architecture.fiche.chargement": "Reading the revision…",
  "architecture.fiche.introuvable": "Not found in this version",
  "architecture.fiche.introuvableAide": "The object does not exist in the revision retained by this version (or the version is not from this project).",
  "architecture.fiche.nonDesigne": "No object designated",
  "architecture.fiche.nonDesigneAide": "Open a component or a dependency from a version's Architecture view.",
  "architecture.fiche.ouvrirArchitecture": "Open Architecture",
  "architecture.fiche.retour": "Back to the version's architecture",
  "architecture.fiche.retourDeps": "Back to the version's dependencies",
  "architecture.groupe.assets": "Resources (styles, images, templates)",
  "architecture.groupe.configuration": "Configuration and manifests",
  "architecture.groupe.infrastructure": "Infrastructure (template)",
  "architecture.groupe.tests": "Delivered tests",
  "architecture.licence.catalogue": "stack catalogue",
  "architecture.licence.inconnue": "unknown",
  "architecture.licence.sbom": "read from the image (SBOM)",
  "architecture.licences.controleKo": "License check at generation (mode {{m}}): {{n}} dependency(ies) outside the allowed list — {{l}}.",
  "architecture.licences.controleOk": "License check at generation (mode {{m}}): no direct dependency outside the organisation's allowed list.",
  "architecture.licences.inconnues": "{{n}} dependency(ies) with no known license: neither the SBOM nor the stack catalogue gives it.",
  "architecture.licences.titre": "Licenses",
  "architecture.licences.vide": "No known license",
  "architecture.licences.videAide": "Licenses come from the image SBOM or the closed stack catalogue.",
  "architecture.ouvrirVersions": "Open Versions",
  "architecture.provenance.charte": "charter",
  "architecture.provenance.gabarit": "template",
  "architecture.provenance.inconnue": "unknown",
  "architecture.provenance.mixte": "model + template",
  "architecture.provenance.modele": "model",
  "architecture.refus": "This project is not accessible with your account: ask its owner for access.",
  "architecture.relation.direct": "Direct",
  "architecture.relation.system": "System",
  "architecture.relation.transitive": "Transitive",
  "architecture.revision.detail": "{{f}} file(s) · stack {{p}} · generated by {{c}} ({{m}})",
  "architecture.revision.inconnue": "origin not found",
  "architecture.revision.mission": "mission deliverable",
  "architecture.revision.sansSbom": "Image not built or signed: no image SBOM (declared dependencies only).",
  "architecture.revision.sbom": "SBOM of service {{s}}: {{n}} package(s), {{o}}",
  "architecture.revision.scaffold": "application generation",
  "architecture.revision.titre": "Revision {{r}}",
  "architecture.routes.derived": "Routes derived from the revision's code.",
  "architecture.routes.no_revision": "The version retains no revision: nothing to derive.",
  "architecture.routes.none_found": "No route recognised by reading the code: the stack declares none in a form that is read (FastAPI decorators, Express, JAX-RS, Odoo).",
  "architecture.routes.not_supported": "Routes cannot be derived: no file in a language that is read (Python, JavaScript, Java).",
  "architecture.routes.note.include": "A router is included with a prefix (include_router): that prefix is not added to the paths read.",
  "architecture.routes.note.use": "An Express router is mounted under a prefix (app.use): that prefix is not added to the paths read.",
  "architecture.routes.tree_unverified": "Routes not derived: the revision's tree is not verified.",
  "architecture.sansProjet": "Architecture is about a project's delivered application.",
  "architecture.sbom.absent": "Declared only",
  "architecture.sbom.atteste": "Attested in the registry",
  "architecture.sbom.image": "Signed image",
  "architecture.sbom.nonAtteste": "Not attested in the registry",
  "architecture.sbom.nonVerifie": "Not verified",
  "architecture.sbom.telecharger": "Download the SBOM",
  "architecture.severite.critical": "Critical",
  "architecture.severite.high": "High",
  "architecture.severite.low": "Low",
  "architecture.severite.medium": "Medium",
  "architecture.severite.negligible": "Negligible",
  "architecture.severite.unknown": "Unknown",
  "architecture.titre": "Architecture",
  "architecture.type.assets": "Resources",
  "architecture.type.configuration": "Configuration",
  "architecture.type.database": "Database",
  "architecture.type.infrastructure": "Infrastructure",
  "architecture.type.module": "Module",
  "architecture.type.service": "Service",
  "architecture.type.test": "Tests",
  "architecture.version.ouvrirFiche": "Open the version page",
  "architecture.version.racine": "The applications directory is not mounted on the gateway: no revision can be read.",
  "architecture.version.sansRevision": "This version retains no revision",
  "architecture.version.sansRevisionAide": "Architecture is derived from the delivered revision: retain a revision on the version page.",
  "architecture.version.titre": "Version {{v}}",
  "architecture.versionIntrouvable": "Version not found in this project",
  "architecture.versionIntrouvableAide": "Choose a version in the list above.",
  "architecture.versions.deps": "{{d}} direct / {{n}}",
  "architecture.versions.titre": "Versions and delivered architecture",
  "architecture.versions.vulnNombre": "{{e}} · {{n}}",
  "architecture.vide": "No version in this project",
  "architecture.videAide": "Architecture is read per version: prepare a version that retains a revision of the application.",
  "architecture.vue.api": "API",
  "architecture.vue.composants": "Components",
  "architecture.vue.dependances": "Dependencies and SBOM",
  "architecture.vue.vulnerabilites": "Vulnerabilities",
  "architecture.vues": "Architecture views",
  "architecture.vuln.analysed": "Analysed",
  "architecture.vuln.analysedAide": "Latest offline scan recorded for each SBOM of the version.",
  "architecture.vuln.analyses": "Scans per SBOM",
  "architecture.vuln.aucune": "None known",
  "architecture.vuln.aucuneAide": "Result of the recorded scan, valid as of its vulnerability database date.",
  "architecture.vuln.aucuneDep": "No vulnerability known to the database used for this package version.",
  "architecture.vuln.aucuneTitre": "No vulnerability known to the database used",
  "architecture.vuln.corrigeeEn": "fixed in {{v}}",
  "architecture.vuln.no_sbom": "No image SBOM",
  "architecture.vuln.no_sbomAide": "The image of this version has not been built and signed: without an image SBOM, no scan is possible. “Build and sign” is requested from the version page.",
  "architecture.vuln.nombre": "{{n}} · max {{s}}",
  "architecture.vuln.nonAtteste": "(not attested in the registry: cannot be scanned)",
  "architecture.vuln.not_analysed": "Not analysed",
  "architecture.vuln.not_analysedAide": "No offline scan is recorded for this SBOM: no vulnerability is asserted, and no absence either. A scan is recorded by the pipeline (Grype and its imported database, offline).",
  "architecture.vuln.partial": "Partially analysed",
  "architecture.vuln.partialAide": "Only some of the version's SBOMs have been scanned.",
  "architecture.vuln.titre": "Known vulnerabilities of the dependencies",
  "architecture.vuln.titreCourt": "Vulnerabilities",
  "axesSante.aucunProjet": "No attached project",
  "axesSante.aucunProjetAide": "No project item is attached to this axis or its descendants.",
  "axesSante.col.axe": "axis",
  "axesSante.col.nature": "kind",
  "axesSante.col.projets": "attached projects",
  "axesSante.col.sante": "health spread",
  "axesSante.declarer": "Declare an axis",
  "axesSante.description": "Health spread of the projects attached to each shared axis: cross-programme reporting.",
  "axesSante.introuvable": "This axis does not exist in your organisation.",
  "axesSante.items": "{{n}} attached item(s)",
  "axesSante.ongletAxes": "Axes and attached work",
  "axesSante.onglets": "Axis views",
  "axesSante.ongletSante": "“Axis” view — health",
  "axesSante.plusMasques": "+ {{n}} not accessible",
  "axesSante.retour": "← All axes",
  "axesSante.sansDroit": "The organisation's axes are not accessible to you.",
  "axesSante.titre": "Portfolio axes — “Axis” view",
  "axesSante.vide": "No shared axis",
  "axesSante.videAide": "Declare a shared axis (portfolio, domain, capability) and attach work to it to see the health spread.",
  "chemin.absente": "absent",
  "chemin.aJour": "identical to v{{v}}",
  "chemin.apercu": "Migration preview (since the latest version)",
  "chemin.aucunChangement": "No change.",
  "chemin.aucunEcart": "No visible project drifting",
  "chemin.aucunEcartAide": "Every project you can see follows the reference.",
  "chemin.aucuneRecommandation": "no recommendation (neither mandated nor “adopt”)",
  "chemin.aucuneVersion": "No published version",
  "chemin.aucuneVersionAide": "Until a version is published, projects are measured against the draft.",
  "chemin.brouillon": "Draft (live catalogue and referential)",
  "chemin.col.categorie": "category",
  "chemin.col.recommande": "recommended",
  "chemin.depuisPrecedente": "Changes since the previous version",
  "chemin.description": "The organisation's recommended configuration, versioned, and the inherited projects that drift from it.",
  "chemin.differe": "differs from v{{v}}",
  "chemin.empreinteBrouillon": "draft digest",
  "chemin.impose": "mandated",
  "chemin.jamaisPublie": "never published",
  "chemin.mesureBrouillon": "Reference: the draft (no published version). {{a}} aligned project(s).",
  "chemin.mesureVersion": "Reference: published version {{v}}. {{a}} aligned project(s).",
  "chemin.motif": "Reason for publishing",
  "chemin.obligatoire": "(mandatory)",
  "chemin.ongletEcarts": "Drifting projects",
  "chemin.ongletReference": "Reference and publishing",
  "chemin.onglets": "Golden path views",
  "chemin.ongletVersions": "Versions",
  "chemin.proposer": "Propose alignment (change request)",
  "chemin.proposerAVenir": "Propose alignment — change request (lot T3, coming)",
  "chemin.publie": "New golden path version published.",
  "chemin.publieePar": "{{qui}}, {{quand}} — {{c}} category(ies), {{r}} rule(s)",
  "chemin.publierAide": "The version freezes the draft (SHA-256 digest); projects are then measured against it. The content is computed, never typed.",
  "chemin.publierBouton": "Publish",
  "chemin.publierTitre": "Publish a version",
  "chemin.regles": "Active organisation rules",
  "chemin.reserve": "Reserved to the organisation's administration (platform administrator).",
  "chemin.retiree": "retired",
  "chemin.retourVersions": "← All versions",
  "chemin.rien": "nothing",
  "chemin.rienAPublier": "The draft is identical to the latest version: nothing to publish.",
  "chemin.sansCategorie": "The technology catalogue has no category yet.",
  "chemin.sansDroit": "The organisation's golden path is not accessible to you.",
  "chemin.sansRegle": "No active rule.",
  "chemin.titre": "Golden path",
  "chemin.valeurs": "project: {{p}} — recommended: {{r}}",
  "chemin.versCatalogue": "Open the technology catalogue",
  "chemin.versionIntrouvable": "This version does not exist in your organisation.",
  "chemin.versionMeta": "{{qui}}, {{quand}} — digest",
  "chemin.versionTitre": "Version {{v}}",
  "chemin.vide": "Nothing to recommend yet",
  "chemin.videAide": "The golden path is computed from the technology catalogue and the active rules: fill them in first.",
  "gouv.ecart.imposed": "mandated entry not followed",
  "gouv.ecart.mandatoryMissing": "mandatory category not chosen",
  "gouv.ecart.noBaseline": "no technology baseline",
  "gouv.ecart.notRecommended": "outside the recommendation",
  "gouv.ecart.retired": "retired entry still in use",
  "gouv.ecart.ruleNotInherited": "organisation rule not inherited",
  "gouv.effet.none": "no effect",
  "gouv.effet.observed": "observed",
  "gouv.effet.refused": "refused",
  "gouv.effet.warned": "warned",
  "gouv.nonAccessibles": "{{n}} project(s) not accessible: counted, never named — you are not a member.",
  "gouv.refus.admin": "Decision reserved to the organisation's administration (platform administrator).",
  "gouv.refus.controle": "A rule without a named control does not change stage.",
  "gouv.refus.inactive": "Inactive rule: first activate it in “observe” in the referential.",
  "gouv.refus.inattendu": "The gateway refused the request.",
  "gouv.refus.inchange": "The rule is already at this stage.",
  "gouv.refus.inchangeChemin": "The golden path has not changed since the latest version: nothing to publish.",
  "gouv.refus.motif": "The reason is mandatory: at least 20 characters, in light of the measurement.",
  "gouv.refus.motifChemin": "The reason for publishing is mandatory (at least 10 characters).",
  "gouv.refus.saut": "Rules move up one stage at a time: go through “warn” first.",
  "gouv.sante.amber": "to watch",
  "gouv.sante.green": "good",
  "gouv.sante.na": "not applicable",
  "gouv.sante.red": "degraded",
  "gouv.sante.unknown": "unknown",
  "gouv.temps.added": "project criterion",
  "gouv.temps.inForce": "block",
  "gouv.temps.observe": "observe",
  "gouv.temps.proposed": "proposed",
  "gouv.temps.retired": "retired",
  "gouv.temps.warn": "warn",
  "org.presence.warned": "warning — a “warn” rule is missing (the approval goes through)",
  "org.ref.troisTemps": "Move a rule to “warn” then “block”: Three-stage rules.",
  "org.status.warn": "warn",
  "regles.aucuneDecision": "No decision: the rule is at its initial stage.",
  "regles.col.absences": "absences",
  "regles.col.decision": "latest decision",
  "regles.col.effets": "warned / refused",
  "regles.col.evaluations": "evaluations",
  "regles.col.projets": "projects inheriting it",
  "regles.col.regle": "rule",
  "regles.col.temps": "stage",
  "regles.controle": "control",
  "regles.decide": "Decision recorded: the rule changed stage.",
  "regles.decidePar": "by {{qui}} on {{quand}}",
  "regles.deciderBouton": "Decide",
  "regles.deciderTitre": "Change stage",
  "regles.decisions": "Recorded decisions",
  "regles.description": "Observe, warn, block: each organisation rule changes stage through a recorded decision, in light of its measurement.",
  "regles.detailDescription": "Stage, recorded decisions and measurement per project",
  "regles.detailTitre": "Rule",
  "regles.etat": "Stage and measurement ({{j}} days)",
  "regles.inactive": "First activate the rule in “observe” in the Requirements referential.",
  "regles.instantane": "Measurement at decision time: {{m}} absence(s) out of {{e}} evaluation(s), {{p}} project(s), {{j}} days.",
  "regles.introuvable": "This rule does not exist in your organisation, or is not accessible to you.",
  "regles.lectureSeule": "Read only: deciding a rule's stage is reserved to the organisation's administration (platform administrator).",
  "regles.ligneProjet": "{{e}} eval. · {{m}} abs. · {{w}} warn. · {{f}} refused",
  "regles.liste": "Rules and measurement over {{j}} days",
  "regles.mesure": "{{e}} evaluation(s), {{m}} absence(s) in {{p}} project(s); {{w}} warned, {{f}} refused.",
  "regles.motif": "Reason (in light of the measurement)",
  "regles.parProjet": "Measurement per project",
  "regles.parProjetVide": "No evaluation in the window",
  "regles.parProjetVideAide": "The rule is measured at every specification approval of a project that inherits it.",
  "regles.parTemps": "observe {{o}} · warn {{a}} · block {{b}} · proposed {{p}}",
  "regles.reserve": "Reserved to the organisation's administration (platform administrator): the decision binds every project that applies inheritance.",
  "regles.retour": "← All rules",
  "regles.sansDroit": "The organisation's rules are not accessible to you.",
  "regles.temps.avertir": "2. Warn",
  "regles.temps.avertirAide": "the absence is flagged (INHERITED_REQUIREMENT_WARNING); the approval goes through.",
  "regles.temps.bloquer": "3. Block",
  "regles.temps.bloquerAide": "the approval is refused (INHERITED_REQUIREMENT_MISSING) in a project that applies inheritance.",
  "regles.temps.legende": "The three stages of a rule",
  "regles.temps.observer": "1. Observe",
  "regles.temps.observerAide": "every absence is measured at approval, without getting in the way.",
  "regles.titre": "Three-stage rules",
  "regles.unTemps": "Rules move up one stage at a time; they can move back down.",
  "regles.vers": "New stage",
  "regles.versReferentiel": "Open the Requirements referential",
  "regles.vide": "No active rule in the referential",
  "regles.videAide": "A rule is born in the Requirements referential, in “observe”; it shows up here as soon as it is proposed or active.",
  "santeOrg.accordee": "granted",
  "santeOrg.adoption": "in adoption (observe)",
  "santeOrg.aligne": "Aligned with the reference.",
  "santeOrg.applique": "applies inheritance",
  "santeOrg.aucuneAnomalie": "No open defect.",
  "santeOrg.aucuneDerogation": "No ongoing waiver.",
  "santeOrg.aucuneEvaluation": "No specification approval in the window.",
  "santeOrg.aucuneFrequente": "none",
  "santeOrg.aucuneLivraison": "No delivered version.",
  "santeOrg.aucuneRegle": "no active rule",
  "santeOrg.col.anomalies": "open defects (blocking)",
  "santeOrg.col.contournements": "bypasses",
  "santeOrg.col.derogations": "waivers (oldest)",
  "santeOrg.col.ecarts": "golden path drift",
  "santeOrg.col.livraisons": "deliveries 90 d",
  "santeOrg.col.projet": "project",
  "santeOrg.col.regles": "rules warned / refused",
  "santeOrg.col.sante": "health",
  "santeOrg.contournement": "bypass",
  "santeOrg.dansNProjets": "in {{n}} projects — the rule or the golden path must change",
  "santeOrg.demandee": "requested",
  "santeOrg.derogationLigne": "{{s}}, {{a}} d, due {{e}}",
  "santeOrg.derogationsTitre": "Requested or granted waivers",
  "santeOrg.description": "Per project: golden path drift, rules that warn or block, waivers and bypasses, deliveries, defects.",
  "santeOrg.detailDescription": "Project compliance with the organisation: drift, rules, waivers, deliveries, defects.",
  "santeOrg.detailTitre": "Project health",
  "santeOrg.dontBloquants": "({{n}} blocking)",
  "santeOrg.ecartsTitre": "Golden path drift",
  "santeOrg.frequentes": "Frequent waivers (≥ 2 projects)",
  "santeOrg.introuvable": "This project does not exist in your organisation, or you are not a member.",
  "santeOrg.jours": "({{n}} d)",
  "santeOrg.livraisonsTitre": "Deliveries and defects",
  "santeOrg.ouvrirProjet": "Open the project",
  "santeOrg.parProjet": "Per project ({{j}}-day window for rules)",
  "santeOrg.partiel": "{{n}} unreadable project(s): partial view.",
  "santeOrg.reglesParTemps": "Rules per stage",
  "santeOrg.reglesTitre": "Evaluated rules ({{j}} days)",
  "santeOrg.repartition": "Health spread",
  "santeOrg.retour": "← All projects",
  "santeOrg.sansDroit": "The organisation's health dashboard is not accessible to you.",
  "santeOrg.titre": "Compliance health",
  "santeOrg.versRegles": "Three-stage rules",
  "santeOrg.vide": "No visible project",
  "santeOrg.videAide": "You are not a member of any project of the organisation; the others are counted below.",
  "supervisionOrg.avancement": "{{f}}/{{n}} tasks · GPU {{g}} / {{b}} min",
  "supervisionOrg.colonie": "colony:",
  "supervisionOrg.enCours": "running",
  "supervisionOrg.enPause": "paused",
  "supervisionOrg.nonAccessibles": "{{m}} live mission(s) in {{p}} project(s) you are not a member of: counted, never named.",
  "supervisionOrg.planApprouve": "plan approved",
  "supervisionOrg.planPropose": "plan to approve",
  "supervisionOrg.rienVisible": "No live mission in the projects you are a member of.",
  "supervisionOrg.sansDroit": "The organisation's agent supervision is not accessible to you.",
  "supervisionOrg.suspendueCapacite": "suspended (capacity)",
  "supervisionOrg.totaux": "{{v}} live mission(s) in the organisation: {{r}} running, {{s}} suspended including {{c}} for capacity, {{a}} plan(s) to approve. GPU queue: {{p}} pending, {{e}} processing.",
  "supervisionOrg.vide": "Nothing is running",
  "supervisionOrg.videAide": "No live mission in the organisation: missions are launched from a project (Build).",
  "taxonomy.vueSante": "“Axis” view — health",
  "doublons.titre": "Probable duplicates under this axis",
  "doublons.chargement": "Looking for duplicates…",
  "doublons.aucun": "No probable duplicate",
  "doublons.aucunAide": "No pair of items under this axis has close enough titles (similarity ≥ 0.45).",
  "doublons.similarite": "similarity {{s}}",
  "doublons.fusionner": "Merge #{{b}} into #{{a}}…",
  "nav./org/regles": "Three-stage rules",
  "navdesc./org/regles": "Observe, warn, block: each rule's stage, its measurement and its recorded decisions",
  "nav./org/chemin-dore": "Golden path",
  "navdesc./org/chemin-dore": "Versioned recommended configuration and drifting inherited projects (alignment proposed)",
  "nav./org/sante": "Compliance health",
  "navdesc./org/sante": "Per project: drift, rules that warn or block, waivers, deliveries, defects",
  "incidents.sev.sev1": "SEV1 · critical",
  "incidents.sev.sev2": "SEV2 · major",
  "incidents.sev.sev3": "SEV3 · minor",
  "incidents.sev.sev4": "SEV4 · low",
  "incidents.sevAide.sev1": "service down for everyone",
  "incidents.sevAide.sev2": "major function affected",
  "incidents.sevAide.sev3": "partial disruption, workaround available",
  "incidents.sevAide.sev4": "minor disruption",
  "incidents.statut.open": "open",
  "incidents.statut.mitigated": "mitigated",
  "incidents.statut.resolved": "resolved",
  "incidents.statut.closed": "closed",
  "incidents.nature.outage": "outage",
  "incidents.nature.degraded": "degradation",
  "incidents.nature.limited": "limited impact",
  "incidents.geste.rouvrir": "Reopen",
  "incidents.geste.attenuer": "Mark mitigated",
  "incidents.geste.resoudre": "Resolve",
  "incidents.geste.clore": "Close",
  "supervisionApp.etat.intact": "untouched",
  "supervisionApp.etat.dans": "within budget",
  "supervisionApp.etat.presque": "nearly exhausted",
  "supervisionApp.etat.epuise": "exhausted",
  "supervisionApp.etat.nonMesure": "not measured",
  "supervisionApp.sante.outage": "down (open incident)",
  "supervisionApp.sante.incident": "incident in progress",
  "supervisionApp.sante.healthy": "probe healthy",
  "supervisionApp.sante.unhealthy": "probe failing",
  "supervisionApp.sante.notMeasured": "not measured",
  "objectif.modifie": "Objective updated",
  "objectif.declare": "Objective declared",
  "objectif.nomCourt": "Name the objective the way the business says it (at least 3 characters).",
  "objectif.cibleInvalide": "The target is a percentage strictly between 0 and 100 (e.g. 99.5).",
  "objectif.fenetreInvalide": "The window spans 1 to 90 days.",
  "objectif.seuilInvalide": "The latency threshold is a number of milliseconds (1 to 600,000).",
  "incidents.envRequis": "Choose the affected environment.",
  "objectif.formModifier": "Edit the objective",
  "objectif.formDeclarer": "Declare a business service objective",
  "objectif.nom": "Business name",
  "objectif.nomExemple": "Checkout available",
  "objectif.indicateur": "Indicator",
  "objectif.dispo": "availability",
  "objectif.latence": "latency",
  "objectif.dispoAide": "Share of time without outage; consumed by the environment's “outage” incidents.",
  "objectif.latenceAide": "Share of healthy probes under the threshold; consumed by slow or failing deployment probes.",
  "objectif.environnement": "Environment",
  "incidents.production": "production",
  "objectif.cible": "Target (%)",
  "objectif.fenetre": "Window (days)",
  "objectif.seuil": "Latency threshold (ms)",
  "objectif.descriptionChamp": "What the objective promises (optional)",
  "objectif.actif": "Active objective",
  "objectif.enregistrer": "Save",
  "objectif.declarer": "Declare the objective",
  "incidentFiche.description": "Timeline, resolution and blameless post-mortem of a production incident.",
  "incidentFiche.retour": "← All incidents",
  "incidents.titre": "Incidents",
  "incidents.sansProjet": "Incidents belong to a project's application.",
  "incidentFiche.chargement": "Loading the incident…",
  "incidentFiche.introuvable": "Incident not found",
  "incidentFiche.introuvableAide": "This incident does not exist in this project, or the project is not open to you.",
  "incidentFiche.env": "Environment",
  "incidentFiche.version": "Version",
  "incidents.nonPrecise": "not specified",
  "incidentFiche.deploiement": "Deployment at fault",
  "incidentFiche.retourArriere": "Rollback triggered",
  "incidentFiche.aucunRetour": "none",
  "incidentFiche.responsable": "Owner",
  "incidentFiche.declarePar": "Declared by",
  "incidentFiche.debut": "Impact start",
  "incidentFiche.attenue": "Mitigated",
  "incidentFiche.resolu": "Resolved",
  "incidentFiche.clos": "Closed",
  "incidentFiche.duree": "Impact duration",
  "incidents.enCours": "ongoing",
  "incidentFiche.impact": "Impact",
  "incidentFiche.resolution": "Resolution",
  "incidentFiche.statutChange": "Incident status updated",
  "incidentFiche.closLecture": "Incident closed: its record is read-only.",
  "incidentFiche.resolutionRequise": "Write what restored the service.",
  "incidentFiche.motifRequis": "Write why the incident is being reopened.",
  "incidentFiche.faireAvancer": "Move the incident forward",
  "incidents.reserve": "Declaring or moving an incident forward requires being an owner or contributor of the project; you keep read access.",
  "incidentFiche.refusPostMortem": "Closing requires the published post-mortem (Post-mortem section below).",
  "incidentFiche.refusAutre": "This action is not allowed in the incident's current state.",
  "incidentFiche.champResolution": "What restored the service",
  "incidentFiche.champMotif": "Reason for reopening",
  "incidents.annuler": "Cancel",
  "incidentFiche.marge": "Incident budget consumed",
  "incidentFiche.margeSansObjectif": "No active availability objective on this environment: nothing is counted.",
  "incidentFiche.margeNonIndispo": "This is not an outage: it does not consume the budget of availability objectives.",
  "incidentFiche.margePart": "{{d}} out of a budget of {{m}}",
  "incidentFiche.fait.declared": "Incident declared",
  "incidentFiche.fait.status": "{{de}} → {{vers}}",
  "incidentFiche.fait.note": "Note",
  "incidentFiche.fait.updated": "Record updated",
  "incidentFiche.fait.defect": "Defect linked",
  "incidentFiche.fait.pmSaved": "Post-mortem saved",
  "incidentFiche.fait.pmPublished": "Post-mortem published",
  "incidentFiche.fait.action": "Corrective action created",
  "incidentFiche.noteVide": "Write the fact to record.",
  "incidentFiche.chronologie": "Timeline",
  "incidentFiche.ajouterFait": "Add a fact",
  "incidentFiche.noteExemple": "Alert received from the store's support",
  "incidentFiche.quand": "When (optional)",
  "incidentFiche.consigner": "Record",
  "incidentFiche.anomalieInvalide": "Give the number of a defect of the project (e.g. ANO-17).",
  "incidentFiche.anomalies": "Linked defects",
  "incidentFiche.aucuneAnomalie": "No linked defect. A defect states the product gap that caused or worsened the outage.",
  "incidentFiche.relierAnomalie": "Link a defect",
  "incidentFiche.relier": "Link",
  "incidentFiche.modifie": "Incident updated",
  "incidentFiche.qualifier": "Qualify the incident",
  "incidentFiche.modifier": "Edit",
  "incidents.champSeverite": "Severity",
  "incidents.champNature": "Kind of impact",
  "incidents.champResponsable": "Owner",
  "incidentFiche.retourAide": "A rollback is started from Environments and deployments, behind its gate; it is linked here.",
  "incidentFiche.enregistrer": "Save",
  "incidents.declare": "Incident declared",
  "incidents.description": "Outages experienced by the users of the delivered application: declaration, timeline, resolution and blameless post-mortem.",
  "incidents.chargement": "Loading incidents…",
  "incidents.titreCourt": "Give a title of at least 3 characters: what users are experiencing.",
  "incidents.impactRequis": "Describe the impact: who is affected, and how.",
  "incidents.regle": "An incident is declared as soon as users are disrupted. It goes through “mitigated” (service restored, the cause may remain), then “resolved”, and is closed once its post-mortem is published.",
  "incidents.filtreStatut": "Status",
  "incidents.actifs": "ongoing (open and mitigated)",
  "incidents.tous": "all",
  "incidents.filtreSeverite": "Severity",
  "incidents.toutes": "all",
  "incidents.declarer": "Declare an incident",
  "incidents.formTitre": "Declare a production incident",
  "incidents.optionsChargement": "Loading environments and members…",
  "incidents.champTitre": "What users are experiencing",
  "incidents.champTitreExemple": "Card payment refused at checkout",
  "incidents.champImpact": "Impact",
  "incidents.champImpactExemple": "All checkouts of the store, since 9:40 am; cash payments go through.",
  "incidents.natureAide": "An outage consumes the budget of the environment's availability objectives.",
  "incidents.champEnv": "Affected environment",
  "incidents.champVersion": "Version at fault (optional)",
  "incidents.champDebut": "Impact start (optional)",
  "incidents.enregistrer": "Declare",
  "incidents.videActifs": "No ongoing incident",
  "incidents.vide": "No incident",
  "incidents.videIndice": "No outage declared for this filter. Resolved and closed incidents remain available with the “all” filter.",
  "incidents.legende": "Production incidents of the project",
  "incidents.colIncident": "incident",
  "incidents.colSeverite": "severity",
  "incidents.colStatut": "status",
  "incidents.colEnv": "environment · version",
  "incidents.colResponsable": "owner",
  "incidents.colDebut": "start",
  "incidents.colDuree": "impact",
  "incidents.colPostMortem": "post-mortem",
  "incidents.pmPublie": "published",
  "incidents.pmBrouillon": "draft",
  "incidents.pmAucun": "to write",
  "incidents.voirSupervision": "See monitoring and the incident budget of service objectives",
  "objectif.retour": "← Application monitoring",
  "supervisionApp.sansProjet": "Monitoring covers a project's application.",
  "objectif.chargement": "Loading the objective…",
  "objectif.introuvable": "Objective not found",
  "objectif.introuvableAide": "This objective does not exist in this project, or the project is not open to you.",
  "objectif.descriptionDefaut": "Business service objective of the delivered application.",
  "objectif.versionMaj": "version {{v}} · edited on {{quand}} by {{qui}}",
  "objectif.avertEpuise": "Budget exhausted over the window. This is a warning: no promotion or go-live is blocked.",
  "objectif.avertPresque": "Budget nearly exhausted (80% or more). Nothing is blocked.",
  "objectif.cibleFenetre": "Target over the window",
  "supervisionApp.colAtteint": "achieved",
  "objectif.marge": "Incident budget",
  "objectif.margeMinutes": "Budget = (100% − target) × window = {{m}} of tolerated downtime; {{r}} left.",
  "objectif.margeSondes": "Budget = (100% − target) × {{n}} observed probes = {{m}} slow or failing probes tolerated; {{r}} left.",
  "objectif.incidents": "Incidents of the window on this environment",
  "objectif.aucunIncident": "No incident over the window: the budget is untouched.",
  "objectif.consomme": "consumes {{d}}",
  "objectif.neConsommePas": "does not consume (not an outage)",
  "objectif.sondes": "Probes of the window",
  "objectif.aucuneSonde": "No probe recorded over the window: a deployment with a health URL records one.",
  "objectif.sondesLegende": "HTTP probes recorded by deployments",
  "objectif.colQuand": "recorded on",
  "objectif.colStatut": "status",
  "objectif.colHttp": "HTTP",
  "objectif.colLatence": "latency",
  "objectif.modifier": "Edit the objective",
  "supervisionApp.reserve": "Declaring or editing an objective requires being an owner or contributor of the project; you keep read access.",
  "postMortem.resume": "Summary",
  "postMortem.resumeAide": "What happened, to whom, for how long.",
  "postMortem.cause": "Cause",
  "postMortem.causeAide": "The technical or organisational mechanism, not a person.",
  "postMortem.facteurs": "Contributing factors",
  "postMortem.facteursAide": "What let the cause produce the outage, or prolonged it.",
  "postMortem.bien": "What went well",
  "postMortem.bienAide": "Detection, workaround, communication.",
  "postMortem.lecons": "Lessons learned",
  "postMortem.leconsAide": "What the team changes in the way it works.",
  "postMortem.enregistre": "Post-mortem saved",
  "postMortem.publieToast": "Post-mortem published: the incident can be closed",
  "postMortem.actionCourte": "Describe the action in at least 3 characters.",
  "postMortem.titre": "Post-mortem",
  "postMortem.publie": "published",
  "postMortem.brouillon": "draft",
  "postMortem.aRediger": "to write",
  "postMortem.sansBlame": "Blameless: we describe facts and mechanisms, never a person's fault. Everyone acted as best they could with what they knew; the question is what made the error possible.",
  "postMortem.mentions": "This text names {{noms}}. Rephrase around the mechanism rather than the person — this is a warning, publishing remains possible.",
  "postMortem.publiePar": "Published by {{qui}} on {{quand}}",
  "postMortem.enregistrer": "Save the draft",
  "postMortem.publier": "Publish",
  "postMortem.refusResolu": "The post-mortem is published once the incident is resolved; save the draft until then.",
  "postMortem.refusAutre": "Publishing is not allowed in the current state.",
  "postMortem.actions": "Corrective actions",
  "postMortem.aucuneAction": "No action. Each action becomes a backlog task, tracked like the others.",
  "postMortem.itemSupprime": "item deleted",
  "postMortem.nouvelleAction": "New corrective action",
  "postMortem.actionExemple": "Alert 30 days before a certificate expires",
  "postMortem.creerAction": "Create the task",
  "supervisionApp.sansSonde": "no probe in the window",
  "supervisionApp.sondes": "{{n}} probes",
  "supervisionApp.titre": "Application monitoring",
  "supervisionApp.description": "The health of each environment of the delivered application, its ongoing incidents, and the business service objectives with their incident budget.",
  "supervisionApp.chargement": "Loading environments, probes and objectives…",
  "supervisionApp.avertEpuise": "The incident budget of “{{nom}}” is exhausted. This is a warning: nothing is blocked, go-live remains possible.",
  "supervisionApp.avertPresque": "The incident budget of “{{nom}}” is nearly exhausted (80% or more). Nothing is blocked.",
  "supervisionApp.voirObjectif": "See the objective",
  "supervisionApp.environnements": "Application environments",
  "supervisionApp.aucunEnv": "No environment",
  "supervisionApp.aucunEnvAide": "Environments are declared in Environments and deployments; monitoring then follows their deployments and incidents.",
  "supervisionApp.ouvrirRunops": "Open Environments and deployments",
  "supervisionApp.version": "In service",
  "supervisionApp.aucuneVersion": "no version deployed",
  "supervisionApp.dernierDeploiement": "Last deployment",
  "supervisionApp.derniereSonde": "Last probe",
  "supervisionApp.jamaisSondee": "never probed",
  "supervisionApp.sondes7j": "Probes ({{j}} d)",
  "supervisionApp.aucuneSondeFenetre": "none",
  "supervisionApp.sondesSaines": "{{s}} healthy out of {{n}}{{p}}",
  "supervisionApp.mediane": "median {{ms}} ms",
  "supervisionApp.incidentsEnCours": "Ongoing incidents",
  "supervisionApp.aucun": "none",
  "supervisionApp.source": "Measurements: the HTTP probe recorded at each deployment (as in Environments and deployments) and declared incidents. No periodic probe or container log is collected yet: an environment without a probe is “not measured”, never “healthy”.",
  "supervisionApp.objectifs": "Business service objectives",
  "supervisionApp.declarerObjectif": "Declare an objective",
  "supervisionApp.aucunObjectif": "No business service objective",
  "supervisionApp.aucunObjectifAide": "An objective states what the application promises its users (e.g. “Checkout available 99.5% over 30 days”); its budget is consumed by incidents and probes.",
  "supervisionApp.legende": "Business service objectives and incident budget",
  "supervisionApp.colObjectif": "objective",
  "supervisionApp.colCible": "target · window",
  "supervisionApp.colMarge": "budget consumed",
  "supervisionApp.colEtat": "state",
  "supervisionApp.voirIncidents": "See incidents",
  "supervisionApp.voirEnService": "Application in service",
  "supervisionApp.voirSloRuntime": "Runtime service objectives (generation)",
  "nav./incidents": "Incidents",
  "navdesc./incidents": "Production incidents: declaration, timeline, resolution and blameless post-mortem",
  "nav./exploitation/supervision": "Application monitoring",
  "navdesc./exploitation/supervision": "Health of delivered environments, business service objectives and incident budget",
  "cmdk.descriptionObjets": "Search for a screen, an action or an object (identifier or text)",
  "rech.aide": "Objects: type at least 2 characters, or an identifier (#12, ANO-3, ADR-1).",
  "rech.aucunObjet": "No object matches “{{q}}”.",
  "rech.chargement": "Searching objects…",
  "rech.contexteOrganisation": "Organisation",
  "rech.contexteProgramme": "Programme {{nom}}",
  "rech.erreur": "Object search failed: {{message}}",
  "rech.groupeTronque": "{{type}} — first results, refine your search",
  "rech.nObjets": "{{n}} objects found.",
  "rech.partiel": "Partial results: {{types}} could not be read for now.",
  "rech.reessayer": "Retry",
  "rech.tropLong": "Search is limited to 100 characters.",
  "rech.type.adr": "Decisions (ADR)",
  "rech.type.defect": "Defects",
  "rech.type.deployment": "Deployments",
  "rech.type.item": "Backlog items",
  "rech.type.mission": "Missions",
  "rech.type.program": "Programmes",
  "rech.type.project": "Projects",
  "rech.type.release": "Releases",
  "rech.type.requirement": "Requirements",
  "rech.type.sprint": "Sprints",
  "rech.type.test_campaign": "Test campaigns",
  "rech.type.test_case": "Test cases",
  "rech.unObjet": "1 object found.",
  "activation.classes": "At least {{n}} kinds of characters among lowercase, uppercase, digits and symbols.",
  "activation.inconnuLien": "This activation link is unknown. Ask the administration that sent it for a new link.",
  "activation.okReinit": "Password changed. Sign in with {{identifiant}} and the new password.",
  "activation.demanderOrganisation": "Ask your organisation's administration for a new link.",
  "activation.introMembre": "You are invited to {{org}} ({{email}}) as {{role}}: choose your password. Link valid until {{fin}}.",
  "activation.introReinit": "Resetting your access to {{org}} ({{email}}): choose a new password; your open sessions will be closed. Link valid until {{fin}}.",
  "activation.mfa": "Your organisation requires a second factor: at your first sign-in, the sign-in screen will ask you to set up an authenticator app (OTP).",
  "activation.motDePasseMin": "Password (at least {{n}} characters)",
  "activation.desactive": "This account has been deactivated by your organisation: the link can no longer be used.",
  "login.motifSessionMax": "Your session reached the maximum duration set by your organisation: please sign in again.",
  "agile.addMemberHintAnnuaire": "Search for a person of the organisation by name, identifier or e-mail. Someone who has no account yet is invited into the organisation (Organisation › Invitations).",
  "admin.gererAnnuaire": "Manage in the directory",
  "usr.role.org_admin": "Organisation administrator",
  "usr.role.auditor": "Auditor (read-only)",
  "usr.matrice.admin": "Platform administrator",
  "usr.acces.lienRevue": "Authorisation refusal review",
  "usr.annuaire.chargement": "Reading the directory…",
  "usr.annuaire.erreur": "The directory could not be read.",
  "usr.annuaire.aucunResultat": "No one matches these filters",
  "usr.annuaire.effacer": "Clear filters",
  "usr.annuaire.vide": "No one in the organisation",
  "usr.annuaire.videIndice": "Invite the first person by e-mail.",
  "usr.annuaire.inviter": "Invite someone",
  "usr.annuaire.legende": "People of the organisation: name, e-mail, organisation role, status, projects, programmes, last access",
  "usr.col.personne": "Person",
  "usr.col.role": "Organisation role",
  "usr.col.statut": "Status",
  "usr.col.projets": "Projects · programmes",
  "usr.col.dernierAcces": "Last access",
  "nav./org/utilisateurs": "Users",
  "usr.annuaire.descriptionTierce": "People of organisation {{o}} (platform administration: every action is written to its journal).",
  "usr.annuaire.description": "The people of the organisation, their role, their status and their memberships.",
  "usr.annuaire.compteurs": "{{a}} active · {{i}} invited · {{d}} deactivated · {{adm}} organisation administrator(s)",
  "usr.annuaire.voirInvitations": "See invitations",
  "usr.annuaire.rechercheAria": "Search the directory",
  "usr.annuaire.recherche": "Name or e-mail",
  "usr.annuaire.chercher": "Search",
  "usr.annuaire.tous": "All",
  "usr.role.aucun": "Not observed",
  "usr.annuaire.projet": "Project",
  "usr.lectureSeule": "Read-only: the directory is managed by the organisation's administration.",
  "usr.mode.bloquantTitre": "Blocking mode: matrix refusals are enforced",
  "usr.mode.observationTitre": "Observation mode: matrix refusals are NOT enforced",
  "usr.mode.bloquant": "A permission removed here immediately refuses the matching action, and every refusal is logged.",
  "usr.mode.observation": "A computed refusal is only logged: removing a permission here protects nothing yet. The refusal review tells when the matrix can block.",
  "usr.fiche.retour": "← User directory",
  "usr.fiche.chargement": "Reading the profile…",
  "usr.fiche.erreur": "The profile could not be read.",
  "usr.fiche.reactive": "Account reactivated",
  "usr.fiche.deconnecte": "Sessions closed",
  "usr.fiche.superAdmin": "Platform administrator",
  "usr.fiche.vous": "You",
  "usr.fiche.identite": "Identity",
  "usr.fiche.identifiant": "Sign-in identifier",
  "usr.fiche.email": "E-mail",
  "usr.fiche.reference": "Technical reference",
  "usr.fiche.creation": "Joined the organisation",
  "usr.fiche.desactive": "Deactivated on",
  "usr.fiche.connexion": "Sign-in account (Keycloak)",
  "usr.fiche.kcActif": "Sign-in",
  "usr.fiche.autorisee": "allowed",
  "usr.fiche.bloquee": "blocked",
  "usr.fiche.mdp": "Password",
  "usr.fiche.defini": "set",
  "usr.fiche.nonDefini": "not chosen yet",
  "usr.fiche.mfa": "Second factor (OTP)",
  "usr.fiche.configure": "configured",
  "usr.fiche.nonConfigure": "not configured",
  "usr.fiche.actions": "Required actions",
  "usr.fiche.roleEffectif": "Effective role",
  "usr.fiche.kcInconnu": "The directory does not answer or does not know this account: the sign-in state cannot be read.",
  "usr.fiche.equipes": "Teams",
  "usr.fiche.actionsTitre": "Access and departure",
  "usr.fiche.resetOtp": "Also reset the second factor (OTP)",
  "usr.fiche.reinitialiser": "Reset access",
  "usr.fiche.deconnecterTitre": "Close all sessions of {{n}}?",
  "usr.fiche.deconnecterC1": "The person is signed out everywhere; tokens already issued are refused.",
  "usr.fiche.deconnecterRev": "They can sign in again right away with their credentials.",
  "usr.fiche.deconnecterVerbe": "Sign out",
  "usr.fiche.deconnecter": "Force sign-out",
  "usr.fiche.desactiver": "Deactivate…",
  "usr.fiche.emailEnvoye": "The directory sent a reset e-mail to {{e}}.",
  "usr.fiche.reactiverTitre": "Reactivate {{n}}?",
  "usr.fiche.reactiverC1": "Sign-in is allowed again. Memberships removed at departure do not come back: add them above.",
  "usr.fiche.motif": "Reason (written to the journal)",
  "usr.fiche.reactiverVerbe": "Reactivate",
  "usr.fiche.reactiver": "Reactivate the account",
  "usr.fiche.invitations": "Invitations and links",
  "usr.fiche.aucuneInvitation": "No invitation or link for this person",
  "usr.fiche.lienReinit": "Access reset",
  "usr.fiche.lienInvit": "Invitation ({{r}})",
  "usr.fiche.historique": "History",
  "usr.fiche.aucunHistorique": "No journal event for this person",
  "usr.fiche.par": "by {{a}}",
  "usr.fiche.roleChange": "Organisation role changed",
  "usr.fiche.nouveauRole": "Role",
  "usr.fiche.motifFacultatif": "Reason (optional, written to the journal)",
  "usr.fiche.immediat": "Apply immediately (signs the person out)",
  "usr.fiche.immediatAide": "Without this box, tokens issued before the change are refused by the gateway: the person is asked to sign in again at their next action.",
  "usr.fiche.changerRole": "Change role",
  "usr.fiche.appartenanceAjoutee": "Membership added",
  "usr.fiche.appartenanceRetiree": "Membership removed",
  "usr.fiche.choisirCible": "Choose a project or a programme.",
  "usr.fiche.aucune": "None.",
  "usr.fiche.membresProjet": "project members",
  "usr.fiche.roleDans": "Role in {{n}}",
  "usr.fiche.dernierProprio": "last active owner",
  "usr.fiche.depuis": "since {{d}}",
  "usr.fiche.retirerDe": "Remove from {{n}}",
  "usr.fiche.retirerTitre": "Remove {{p}} from {{n}}?",
  "usr.fiche.retirerC1": "Access to this project or programme is revoked immediately; the account stays active.",
  "usr.fiche.retirerRev": "You can add them again from this profile.",
  "usr.fiche.retirerVerbe": "Remove",
  "usr.fiche.retirer": "Remove",
  "usr.fiche.appartenances": "Memberships",
  "usr.fiche.projets": "Projects",
  "usr.fiche.programmes": "Programmes",
  "usr.fiche.portee": "Type",
  "usr.fiche.projet": "Project",
  "usr.fiche.programme": "Programme",
  "usr.fiche.cible": "Project or programme",
  "usr.fiche.choisir": "Choose…",
  "usr.fiche.role": "Role",
  "usr.fiche.ajouter": "Add",
  "usr.depart.fait": "Account deactivated",
  "usr.refus.DEACTIVATION_REASON_REQUIRED": "Departure reason: at least 5 characters.",
  "usr.depart.transfertManquant": "Choose a new owner for each listed project and programme.",
  "usr.depart.attester": "Tick the confirmation to continue.",
  "usr.depart.titre": "Deactivate {{n}}",
  "usr.depart.aide": "The person loses all access to the organisation: sign-in blocked in the directory, sessions closed, all memberships removed, pending invitations revoked. Can be reactivated later (memberships do not come back).",
  "usr.depart.transferts": "Ownership transfer (required)",
  "usr.depart.aucunCandidat": "No other active person can take over these ownerships: invite or reactivate someone first.",
  "usr.depart.projet": "Project “{{n}}”",
  "usr.depart.programme": "Programme “{{n}}”",
  "usr.depart.nouveauProprio": "New owner…",
  "usr.depart.aucuneExclusive": "No project or programme of which the person would be the last owner: no transfer required.",
  "usr.depart.motif": "Departure reason (required, written to the journal)",
  "usr.depart.attestation": "I confirm deactivating this account across the whole organisation",
  "usr.depart.annuler": "Cancel",
  "usr.depart.confirmer": "Deactivate the account",
  "usr.inv.revoquee": "Invitation revoked, account deleted",
  "usr.inv.chargement": "Reading invitations…",
  "usr.inv.erreur": "Invitations could not be read.",
  "usr.inv.aucunResultat": "No invitation in this state",
  "usr.inv.vide": "No invitation sent",
  "usr.inv.videIndice": "Invite someone with the form above.",
  "usr.inv.legende": "Invitations: person, role, projects, status, deadline, actions",
  "usr.inv.colAttributions": "Projects and programmes",
  "usr.inv.colEcheance": "Sent · deadline",
  "usr.inv.colActions": "Actions",
  "usr.inv.renouveler": "New link",
  "usr.inv.revoquerTitre": "Revoke the invitation of {{e}}?",
  "usr.inv.revoquerC1": "The link stops working; the never-activated account and its memberships are deleted.",
  "usr.inv.revoquerRev": "The address can be invited again.",
  "usr.inv.motif": "Reason (optional)",
  "usr.inv.revoquer": "Revoke",
  "nav./org/invitations": "Invitations",
  "usr.inv.description": "Bring a new person into the organisation: their account is created and they choose their password through a single-use link.",
  "usr.inv.emailNonEnvoye": "Invitation created, but the directory could not send the e-mail: use “New link”.",
  "usr.inv.emailEnvoye": "The directory sent the invitation e-mail to {{e}}.",
  "usr.inv.liste": "Invitations of the organisation",
  "usr.inv.creee": "Invitation created",
  "usr.refus.INVITATION_EMAIL_INVALID": "Invalid e-mail address.",
  "usr.inv.nouvelle": "Invite someone",
  "usr.inv.email": "E-mail (new address)",
  "usr.inv.prenom": "First name",
  "usr.inv.nom": "Last name",
  "usr.inv.validite": "Link validity (hours, 1 to 168)",
  "usr.inv.attributions": "Projects and programmes (optional)",
  "usr.inv.lectureSeuleAide": "An organisation viewer or auditor is only a viewer of projects and programmes.",
  "usr.inv.ajouterAttribution": "Add",
  "usr.inv.retirerAttribution": "Remove {{n}}",
  "usr.inv.envoyer": "Invite",
  "usr.revue.legitime": "legitimate: to fix",
  "usr.revue.corrige": "fixed since",
  "usr.revue.attendu": "expected (intended refusal)",
  "usr.revue.chargement": "Reading the review…",
  "usr.revue.erreur": "The review could not be read.",
  "usr.revue.pret": "Ready for blocking mode: no legitimate role is missing from the matrix and no legitimate refusal was observed over {{j}} days.",
  "usr.revue.pasPret": "Not ready yet: {{m}} legitimate role(s) missing, {{l}} legitimate refusal(s) observed over {{j}} days. Fix the matrix before blocking.",
  "usr.revue.chemins": "Paths guarded by the matrix",
  "usr.revue.horsCatalogue": "missing from the catalogue",
  "usr.revue.manquent": "missing for: {{r}}",
  "usr.revue.complet": "legitimate roles covered",
  "usr.revue.porteurs": "Held by: {{r}}",
  "usr.revue.observes": "Observed refusals",
  "usr.revue.periode": "Period",
  "usr.revue.jours": "{{j}} days",
  "usr.revue.aucunRefus": "No refusal observed over the period",
  "usr.revue.legende": "Observed refusals: permission, roles, route, count, verdict",
  "usr.revue.colPermission": "Permission",
  "usr.revue.colRoles": "Caller roles",
  "usr.revue.colRoute": "Route",
  "usr.revue.colNombre": "Times · people",
  "usr.revue.colDernier": "Last",
  "usr.revue.colVerdict": "Verdict",
  "usr.revue.retour": "← Access: roles and policies",
  "nav./org/acces/revue": "Authorisation refusal review",
  "usr.revue.description": "What the authorisation matrix refuses or would refuse, and whether it can block without hindering legitimate use.",
  "usr.secu.chargement": "Reading the policy…",
  "usr.secu.erreur": "The policy could not be read.",
  "usr.secu.effectif": "Effective setting, account by account",
  "usr.secu.effectifChargement": "Reading accounts in the directory…",
  "usr.secu.effectifErreur": "The account state could not be read.",
  "usr.secu.aucunCompte": "No account in the organisation",
  "usr.secu.resume": "{{o}} account(s) with OTP configured · {{p}} awaiting setup · {{u}} unknown to the directory",
  "usr.secu.legende": "Accounts: sign-in, password, second factor",
  "usr.secu.inconnu": "unknown to the directory",
  "usr.secu.enAttente": "to set up at next sign-in",
  "usr.secu.tronque": "List limited to the first 200 accounts.",
  "nav./org/securite": "Sign-in security",
  "usr.secu.description": "Authentication policy of the organisation: second factor, session duration, allowed domains, password.",
  "usr.secu.enregistree": "Policy saved and applied",
  "usr.secu.sessionInvalide": "Session duration: 15 to 43,200 minutes (30 days), or empty.",
  "usr.secu.longueurInvalide": "Password length: 12 to 128.",
  "usr.secu.politique": "Organisation policy",
  "usr.secu.version": "Version {{v}}, changed on {{q}} by {{a}}",
  "usr.secu.defaut": "No saved policy: default values (only the realm applies).",
  "usr.secu.lectureSeule": "Read-only: the policy is set by the organisation's administration.",
  "usr.secu.mfa": "Second factor (OTP) required for all members",
  "usr.secu.mfaAide": "Applied by the directory: every account without OTP gets the “configure OTP” action at its next sign-in, then the code is asked at every sign-in.",
  "usr.secu.session": "Maximum session duration (minutes, empty = the realm's)",
  "usr.secu.sessionAide": "Applied by the gateway from the sign-in time: beyond it, the person must sign in again.",
  "usr.secu.domaines": "E-mail domains allowed for invitations (one per line, empty = all)",
  "usr.secu.domainesAide": "Applied to every invitation (subdomains included).",
  "usr.secu.longueur": "Minimum password length",
  "usr.secu.classes": "Required character classes (1 to 4)",
  "usr.secu.mdpAide": "Applied to any password chosen through a DoIt link (activation, reset); the directory policy remains the floor.",
  "usr.secu.application": "MFA applied: {{u}} account(s) updated, {{d}} already configured, {{e}} failure(s).",
  "usr.secu.enregistrer": "Save and apply",
  "usr.role.owner": "Project lead",
  "usr.role.contributor": "Contributor",
  "usr.role.viewer": "Viewer",
  "usr.roleDesc.org_admin": "Manages users, roles, catalogue, rules, charters, connectors, models and the journal of the organisation.",
  "usr.roleDesc.owner": "Creates and owns projects; does not administer the organisation.",
  "usr.roleDesc.contributor": "Writes in the projects and programmes they belong to.",
  "usr.roleDesc.viewer": "Reads the projects and programmes they belong to.",
  "usr.roleDesc.auditor": "Reads the journal, the matrix and the directory of the organisation; never writes.",
  "usr.rolePortee.owner": "Owner",
  "usr.rolePortee.contributor": "Contributor",
  "usr.rolePortee.viewer": "Viewer",
  "usr.statut.active": "Active",
  "usr.statut.invited": "Invited",
  "usr.statut.deactivated": "Deactivated",
  "usr.inv.statut.pending": "Pending",
  "usr.inv.statut.expired": "Expired",
  "usr.inv.statut.accepted": "Accepted",
  "usr.inv.statut.revoked": "Revoked",
  "usr.refus.ORG_ADMIN_REQUIRED": "Reserved to the organisation's administration.",
  "usr.refus.RESOURCE_UNAVAILABLE": "Organisation or resource not found.",
  "usr.refus.USER_NOT_FOUND": "This person does not belong to the organisation.",
  "usr.refus.LAST_ORG_ADMIN": "This is the last active administrator of the organisation: appoint another one first.",
  "usr.refus.LAST_OWNER": "This is the last active owner of the project: appoint another owner first.",
  "usr.refus.PROGRAM_LAST_OWNER": "This is the last active owner of the programme: appoint another owner first.",
  "usr.refus.OWNERSHIP_TRANSFER_REQUIRED": "Ownership transfer required: choose a new owner for each project or programme of which the person is the last owner.",
  "usr.refus.SELF_DEACTIVATION_FORBIDDEN": "You cannot deactivate your own account.",
  "usr.refus.SELF_ROLE_CHANGE_FORBIDDEN": "You cannot change your own organisation role: another administrator does it.",
  "usr.refus.USER_ALREADY_DEACTIVATED": "This account is already deactivated.",
  "usr.refus.USER_NOT_DEACTIVATED": "This account is already active.",
  "usr.refus.USER_DEACTIVATED": "This account is deactivated: reactivate it first.",
  "usr.refus.MEMBERSHIP_ROLE_EXCEEDS_ORG_ROLE": "An organisation viewer or auditor is only a viewer of a project or programme: change their organisation role first.",
  "usr.refus.ALREADY_MEMBER": "This person is already a member.",
  "usr.refus.MEMBERSHIP_NOT_FOUND": "This person is not a member.",
  "usr.refus.TRANSFER_TARGET_INVALID": "Invalid new owner: another active person, neither viewer nor auditor.",
  "usr.refus.REACTIVATION_REASON_REQUIRED": "Reactivation reason: at least 5 characters.",
  "usr.refus.ORG_ROLE_INVALID": "Unknown organisation role.",
  "usr.refus.INVITATION_EMAIL_ALREADY_EXISTS": "An account already exists for this address: invite a new address, or add the person from their profile.",
  "usr.refus.INVITATION_EMAIL_DOMAIN_NOT_ALLOWED": "This e-mail domain is not allowed by the organisation's policy.",
  "usr.refus.INVITATION_SCOPE_NOT_FOUND": "A chosen project or programme does not exist in the organisation.",
  "usr.refus.INVITATION_NOT_REVOCABLE": "Invitation already accepted or revoked.",
  "usr.refus.INVITATION_NOT_RENEWABLE": "Invitation already accepted or revoked: nothing to renew.",
  "usr.refus.WORKSPACE_ARCHIVED": "This project is archived.",
  "usr.refus.KEYCLOAK_UNAVAILABLE": "The directory (Keycloak) does not answer: nothing was changed, try again.",
  "usr.refus.AUTH_POLICY_INVALID": "Invalid policy: check the values entered.",
  "usr.refus.AUTH_POLICY_STALE": "The policy changed in the meantime: reload it before saving.",
  "usr.refus.PASSWORD_POLICY": "Password refused by the security policy.",
  "usr.refus.INVITATION_FAILED": "Invitation interrupted: nothing was created.",
  "usr.refus.inconnu": "Operation refused.",
  "usr.lien.pour": "Single-use link for {{email}}: pass it on to this person. It will not be shown again.",
  "usr.lien.aria": "Single-use link",
  "usr.lien.copie": "Copied",
  "usr.lien.copier": "Copy link",
  "usr.lien.masquer": "Hide",
  "erreurs.code.TOKEN_ROLE_STALE": "Your rights have changed: your session is being renewed, please try again.",
  "erreurs.code.SESSION_MAX_DURATION_EXCEEDED": "Your organisation’s maximum session duration was reached: please sign in again.",
  "erreurs.code.SPEC_GATE_HUMAN_VERIFIED_PROVENANCE_REQUIRED": "Story refused: the parent epic belongs to an approved specification whose Spec Gate evidence is no longer valid (an attested receipt expires 24 h after its evaluation). Re-evaluate the specification, then attach the renewed evidence, or create the story without a parent epic.",
  "erreurs.code.MISSION_TASKS_STILL_ACTIVE": "Tasks of this mission can still succeed: decide the stops one by one, or stop the mission.",
  "erreurs.code.MISSION_NO_STOP_TO_ACKNOWLEDGE": "No stopped task is awaiting a decision in this mission.",
  "erreurs.code.MISSION_STEP_IN_PROGRESS": "A mission step is in progress: wait for it to finish, or stop the mission.",
  "navdesc./org/utilisateurs": "Organisation directory: roles, statuses, memberships, departures and reactivations",
  "navdesc./org/invitations": "Bring in a new person: e-mail invitation and activation link",
  "navdesc./org/securite": "Mandatory second factor, session duration, allowed domains, password",
  "navdesc./org/acces/revue": "What the matrix refuses or would refuse, before and after blocking mode",
  "grp.Utilisateurs et accès": "Users and access",
  "cycle.refus.adminOrg": "Reserved to the organisation's administration.",
  "cycle.refus.adminPlateforme": "Reserved to the platform administration.",
  "cycle.refus.proprietaire": "Reserved to the project owner or the organisation's administration.",
  "cycle.refus.confirmation": "The confirmation does not match: type the exact name.",
  "cycle.refus.motif": "A reason of 10 to 1000 characters is required.",
  "cycle.refus.delai": "Delay outside the allowed range.",
  "cycle.refus.dejaProgrammee": "A deletion is already scheduled.",
  "cycle.refus.close": "This request is closed: nothing left to cancel.",
  "cycle.refus.suppressionEnCours": "Deletion scheduled: cancel it first.",
  "cycle.refus.pasArchive": "This project is not archived.",
  "cycle.refus.archive": "Archived project: unarchive it first.",
  "cycle.refus.soiMeme": "The platform never deletes its own organisation.",
  "cycle.refus.supprimee": "Organisation already deleted.",
  "cycle.refus.suspendue": "Organisation suspended: read only.",
  "cycle.refus.exportPasPret": "The archive is not ready yet.",
  "cycle.refus.introuvable": "Not found.",
  "cycle.refus.validation": "Value refused by the gateway.",
  "cycle.refus.inattendu": "The gateway refused the action.",
  "cycle.motif": "Reason (required, written on the request, to the audit log and in the notification)",
  "cycle.delai": "Delay before the final purge, in days ({{min}} to {{max}})",
  "cycle.fermer": "Close",
  "cycle.programmerSuppression": "Schedule the deletion",
  "cycle.consequence.export": "A complete export is produced first: data, artefacts, evidence and log, in a downloadable archive with its SHA-256 fingerprint.",
  "cycle.consequence.lectureSeuleProjet": "The project becomes read only at once; its running missions are stopped.",
  "cycle.consequence.lectureSeuleOrganisation": "The organisation is suspended at once: its members become read only; its missions are stopped.",
  "cycle.consequence.delai": "The final purge happens after {{n}} day(s), only if the export is ready. Until then, the deletion can be cancelled.",
  "cycle.consequence.notificationProjet": "The project owners are notified; everything is written to the organisation's audit log.",
  "cycle.consequence.notificationOrganisation": "The organisation's project owners are notified; everything is written to the platform log. Its users' accounts will be deleted at purge time.",
  "cycle.archiverTitre": "Archive “{{nom}}”?",
  "cycle.archiverEffet1": "The project becomes read only: no writes, no new mission.",
  "cycle.archiverEffet2": "Its data, log and members are kept.",
  "cycle.archiverReversible": "Can be unarchived at any time by its owner or the organisation's administration.",
  "cycle.archiver": "Archive",
  "cycle.desarchiverTitre": "Unarchive “{{nom}}”?",
  "cycle.desarchiverEffet": "Its members can modify the project again.",
  "cycle.desarchiverReversible": "It can be archived again at any time.",
  "cycle.desarchiver": "Unarchive",
  "cycle.voirDemande": "Deletion scheduled — see the request",
  "cycle.renommer": "Rename…",
  "cycle.desarchiverAction": "Unarchive…",
  "cycle.archiverAction": "Archive…",
  "cycle.supprimerAction": "Delete…",
  "cycle.renommerTitre": "Rename “{{nom}}”",
  "cycle.renommerAide": "The new name shows everywhere; the project identifier does not change. Written to the audit log.",
  "cycle.nom": "Name (3 to 255 characters)",
  "cycle.description": "Description",
  "cycle.nomCourt": "The name must have at least 3 characters.",
  "cycle.renommerValider": "Rename",
  "cycle.supprimerTitre": "Delete the project “{{nom}}”",
  "cycle.supprimerAide": "Deferred and cancellable deletion: nothing is erased before the delay ends.",
  "cycle.supprimerOk": "Deletion scheduled: purge after {{quand}}. The complete export is being prepared.",
  "cycle.ouvrirDemande": "Open request #{{id}}",
  "cycle.confirmationProjet": "To confirm, type the exact project name: {{nom}}",
  "cycleBandeau.region": "Deletion scheduled",
  "cycleBandeau.organisation": "Organisation deletion scheduled: final purge after {{quand}}.",
  "cycleBandeau.organisationDetail": "The organisation is suspended, read only. Only the platform can cancel.",
  "cycleBandeau.voirExport": "See the request and the export",
  "cycleBandeau.projet": "Deletion of the project “{{nom}}” scheduled: final purge after {{quand}}.",
  "cycleBandeau.projetDetail": "The project is read only.",
  "cycleBandeau.voirDemande": "See the request (cancel, export)",
  "cycle.orgSuppressionLe": "Deletion on {{quand}}",
  "cycle.supprimerOrgTitre": "Delete the organisation “{{nom}}”",
  "cycle.supprimerOrgOk": "Deletion scheduled, organisation suspended: purge after {{quand}}.",
  "cycle.confirmationOrganisation": "To confirm, type the exact organisation identifier: {{id}}",
  "cycle.annulerTitre": "Cancel the deletion of “{{nom}}”",
  "cycle.annulerAideProjet": "Nothing will be purged; the project gets back its status from before the request ({{statut}}). Written to the audit log, owners notified.",
  "cycle.annulerAideOrganisation": "Nothing will be purged; the organisation is reactivated if it was active before the request. Written to the platform log.",
  "cycle.annulerMotif": "Reason for cancelling (at least 10 characters)",
  "cycle.annulerValider": "Cancel the deletion",
  "cycle.retourListe": "All requests",
  "cycle.chargementFiche": "Reading the request…",
  "cycle.introuvable": "Request not found in your organisation.",
  "cycle.refusFiche": "Reserved to the organisation's or the platform's administration.",
  "cycle.erreurFiche": "The request could not be read.",
  "cycle.ficheTitre": "Deletion of “{{nom}}”",
  "cycle.ficheAideProjet": "Project {{ws}} — request #{{id}}",
  "cycle.ficheAideOrganisation": "Organisation {{org}} — request #{{id}}",
  "cycle.purgePrevue": "Final purge after {{quand}}, only if the archive is ready.",
  "cycle.annuler": "Cancel the deletion…",
  "cycle.demandeePar": "Requested by",
  "cycle.motifLu": "Reason",
  "cycle.delaiLu": "Delay",
  "cycle.jours": "{{n}} day(s)",
  "cycle.statutAvant": "Status before the request",
  "cycle.annuleePar": "Cancelled by",
  "cycle.absorbeePar": "Superseded by",
  "cycle.numero": "#{{id}}",
  "cycle.exportTitre": "Complete export (archive)",
  "cycle.exportPreteLe": "ready on {{quand}}",
  "cycle.empreinte": "SHA-256 fingerprint:",
  "cycle.exportEchec": "Export failed ({{n}} attempt(s)), retried automatically; the purge waits for a ready archive.",
  "cycle.exportEnCours": "The archive is being prepared (a few minutes). The purge cannot happen without it.",
  "cycle.exportConservation": "Archive kept until {{quand}}.",
  "cycle.telecharger": "Download the archive",
  "cycle.telechargeOk": "Downloaded; announced fingerprint identical to the request's.",
  "cycle.telechargeEcart": "Downloaded; announced fingerprint DIFFERENT: check the archive before any use.",
  "cycle.perimetrePurge": "Purged",
  "cycle.perimetreAPurger": "Will be purged: {{n}} row(s) in {{tables}} table(s)",
  "cycle.perimetreVide": "No row left.",
  "cycle.perimetreConserve": "Kept (evidence and audit)",
  "cycle.rapportTitre": "Purge report",
  "cycle.rapport": "{{n}} row(s) purged in {{tables}} table(s), on {{quand}}; receipt kept in the lifecycle log.",
  "cycle.purgeEchec": "Last purge attempt failed ({{n}}), retried automatically:",
  "cycle.etat.programmee": "scheduled",
  "cycle.etat.annulee": "cancelled",
  "cycle.etat.purgee": "purged",
  "cycle.etat.absorbee": "superseded by the organisation's deletion",
  "cycle.export.enPreparation": "being prepared",
  "cycle.export.pret": "ready",
  "cycle.export.echec": "failed (retried)",
  "cycle.export.expiree": "expired",
  "cycle.listeTitre": "Deletion requests",
  "cycle.listeAidePlateforme": "Projects and organisations: complete export, deferred purge, cancellable during the delay. All organisations.",
  "cycle.listeAideOrganisation": "The organisation's projects (and the organisation itself): complete export, deferred purge, cancellable during the delay.",
  "cycle.retourProjets": "Organisation projects",
  "cycle.retourOrganisations": "Organisations",
  "cycle.chargement": "Reading the requests…",
  "cycle.refusListePlateforme": "Reserved to the platform administration.",
  "cycle.refusListe": "Reserved to the organisation's administration.",
  "cycle.erreurListe": "The requests could not be read.",
  "cycle.vide": "No deletion request",
  "cycle.videIndice": "A deletion is scheduled from the project list (or the organisation list).",
  "cycle.listeLegende": "Requests: target, scope, state, archive, scheduled purge, requester",
  "cycle.col.cible": "target",
  "cycle.col.portee": "scope",
  "cycle.col.etat": "state",
  "cycle.col.export": "archive",
  "cycle.col.purge": "scheduled purge",
  "cycle.col.demande": "requested by",
  "cycle.porteeProjet": "project",
  "cycle.porteeOrganisation": "organisation",
  "orgProjetsAdmin.refus": "The complete project list is reserved to the organisation's administration.",
  "orgProjetsAdmin.videFiltre": "No project of the organisation matches this programme.",
  "orgProjetsAdmin.videIndice": "The organisation has no project yet: create the first one.",
  "orgProjetsAdmin.suppressionLe": "deletion on {{quand}}",
  "orgProjetsAdmin.legende": "All projects of the organisation",
  "orgProjetsAdmin.proprietaires": "owners · members",
  "orgProjetsAdmin.gestes": "lifecycle",
  "orgProjetsAdmin.nonMembre": "not a member",
  "orgProjets.descriptionAdmin": "All projects of the organisation: rename, archive, unarchive, delete (complete export then deferred, cancellable purge).",
  "orgProjets.suppressions": "Deletion requests",
  "organisationsPlateforme.statut.supprimee": "deleted",
  "organisationsPlateforme.suppressions": "Deletion requests",
  "organisationsPlateforme.sante.battementPerime": "Last worker heartbeat {{n}} s ago: it no longer processes the queue. See platform health.",
  "organisationsPlateforme.sante.nonMesuree": "not measured",
  "organisationsPlateforme.sante.pasDeBattement": "No worker heartbeat received so far: health is measured as soon as it runs. AI missions wait for the worker.",
  "organisationsPlateforme.sante.pasDeDonnee": "no data yet",
  "fonA.mcp.sansProjet": "Choose an active project to run it.",
  "fonA.mcp.inactif": "Server not enabled.",
  "fonA.mcp.nonLie": "Bind an agent to this server first.",
  "fonA.mcp.executer": "Run now",
  "fonA.mcp.supprimerTitre": "Delete the MCP server “{{nom}}”?",
  "fonA.mcp.supprimerConsequence": "The package and its agent bindings are removed; templates that use it can no longer launch it.",
  "fonA.mcp.supprimerReversible": "You can import it again, then have it approved again.",
  "fonA.mcp.supprimer": "Delete",
  "fonA.mcp.enFile": "Run queued: job {{id}} (follow it in Executors and queue).",
  "fonA.webhooks.titre": "Public webhooks",
  "fonA.webhooks.aide": "A third-party tool (GitLab, CI) notifies DoIt with a signed (HMAC) request; each event is accepted only once.",
  "fonA.webhooks.chargement": "Reading webhooks…",
  "fonA.webhooks.refus": "The project's webhooks are managed by its owner.",
  "fonA.webhooks.erreur": "Webhooks could not be read.",
  "fonA.webhooks.vide": "No public webhook",
  "fonA.webhooks.videAide": "Create one below to receive a third-party tool's events.",
  "fonA.webhooks.creer": "Create a webhook",
  "fonA.webhooks.recus": "{{n}} event(s) received",
  "fonA.webhooks.dernier": "last on {{date}}",
  "fonA.connexions.active": "active",
  "fonA.connexions.inactive": "disabled",
  "fonA.connexions.desactiver": "Disable",
  "fonA.connexions.activer": "Enable",
  "fonA.webhooks.secretUneFois": "Signing secret — copy it now, it will never be shown again:",
  "fonA.webhooks.adresse": "Receiving address:",
  "fonA.webhooks.masquer": "I have copied the secret",
  "fonA.connexions.nom": "Name",
  "fonA.webhooks.type": "Event type",
  "fonA.webhooks.workflow": "Triggered workflow (required for gitlab_push)",
  "fonA.finalite.proposee": "proposed, to decide",
  "fonA.finalite.approuvee": "approved",
  "fonA.finalite.refusee": "refused",
  "fonA.finalite.retiree": "withdrawn",
  "fonA.finalite.remplacee": "superseded by a newer version",
  "fonA.prep.sansFinalite": "No approved AI processing purpose covers this agent in this project.",
  "fonA.prep.enAttente": "A purpose has been declared and awaits the organisation administration's decision.",
  "fonA.prep.sansConsentement": "The purpose is approved, but you have not consented to it.",
  "fonA.prep.ok": "Ready: purpose approved and consent given.",
  "fonA.refus.proprietaire": "Only the project owner declares or withdraws a purpose.",
  "fonA.refus.admin": "This decision belongs to the organisation administration.",
  "fonA.refus.auto": "You declared this purpose: someone else decides it.",
  "fonA.refus.dejaProposee": "A declaration of this purpose is already awaiting its decision.",
  "fonA.refus.etat": "This action does not apply to the purpose's current state.",
  "fonA.refus.inconnue": "No purpose with this code is declared in the organisation.",
  "fonA.prep.chargement": "Checking purpose and consent…",
  "fonA.prep.erreur": "The run readiness could not be read.",
  "fonA.prep.pret": "ready",
  "fonA.prep.bloque": "blocked",
  "fonA.prep.consentir": "Give my consent to “{{code}}” (180 days)",
  "fonA.prep.demanderProprietaire": "The project owner declares the purpose; the organisation administration approves it.",
  "fonA.finalites.chargement": "Reading the project's purposes…",
  "fonA.finalites.refus": "This project's purposes are not open to you.",
  "fonA.finalites.erreur": "Purposes could not be read.",
  "fonA.finalites.vide": "No purpose declared in this project",
  "fonA.finalites.videAide": "Declare an agent's purpose below: the organisation administration will approve it.",
  "fonA.finalites.declarerLien": "Declare a purpose",
  "fonA.finalites.videLecture": "The project owner declares purposes.",
  "fonA.finalite.echue": "expired",
  "fonA.finalites.ligne": "{{agent}} · expires {{date}}",
  "fonA.finalites.declarerTitre": "Declare an AI processing purpose",
  "fonA.finalites.choisir": "— choose —",
  "fonA.finalites.code": "Purpose code",
  "fonA.finalites.codeExemple": "summary.meeting-notes",
  "fonA.finalites.codeAide": "Lowercase letters, digits, “.”, “_” or “-”; 3 to 96 characters. Each person consents to this code.",
  "fonA.finalites.justification": "Justification (why this processing)",
  "fonA.finalites.duree": "Validity (days, at most 365)",
  "fonA.finalites.declarer": "Declare",
  "fonA.finalites.codeInvalide": "Invalid code.",
  "fonA.finalites.declaree": "Purpose declared: it awaits the organisation administration's decision.",
  "fonA.finalites.ligneOrg": "{{projet}} · {{agent}} · declared by {{qui}}",
  "fonA.attention.recetteSousTitre": "campaign opened by {{w}} · version {{v}}",
  "fonA.attention.descriptionProgramme": "What awaits a decision in this programme's projects, with its age.",
  "fonA.attention.descriptionOrganisation": "What awaits a decision in all your projects of the organisation, with its age.",
  "fonA.attention.portee": "Attention box scope",
  "fonA.attention.projet": "This project",
  "fonA.attention.sansProgramme": "The active project belongs to no programme.",
  "fonA.attention.programme": "Its programme",
  "fonA.attention.organisation": "The whole organisation",
  "fonA.attention.resume": "{{n}} item(s) in {{p}} project(s)",
  "fonA.attention.partiel": "{{n}} project(s) unreadable for now",
  "fonA.attention.dansProjet": "Project: {{p}}",
  "fonA.attention.autreProjet": "This item belongs to project {{p}}: it is decided in that project.",
  "fonA.attention.ouvrirProjet": "Open in project {{p}}",
  "fonA.attention.recette": "A version awaits its business acceptance: run the scenarios and give the verdict (accepted or refused).",
  "fonA.attention.ouvrirRecette": "Open the acceptance",
  "fonA.decisionsOutil.titre": "Tool decisions",
  "fonA.decisionsOutil.description": "Architecture decisions of DoIt itself (engine, stack, security), kept apart from project ADRs.",
  "attention.kind.recette_to_run": "Version to accept",
  "fonA.finalites.titre": "Project AI processing purposes",
  "fonA.finalites.aide": "An agent runs only for a purpose declared by the project owner, approved by the organisation administration, and consented to by the person running it.",
  "fonA.gouvernance.autres": "The rest of the template (item types, lifecycle, agents, models and routing) is set in",
  "fonA.deleg.roleOwner": "owner",
  "fonA.deleg.roleContrib": "contributor",
  "fonA.deleg.roleViewer": "viewer",
  "fonA.deleg.active": "active",
  "fonA.deleg.programmee": "scheduled",
  "fonA.deleg.expiree": "expired",
  "fonA.deleg.revoquee": "revoked",
  "fonA.raci.decideur": "decides",
  "fonA.raci.consulte": "consulted",
  "fonA.raci.informe": "informed",
  "fonA.deleg.r.role": "The delegator does not hold this role in this project.",
  "fonA.deleg.r.autrui": "Delegating someone else's role belongs to the organisation administration.",
  "fonA.deleg.r.fenetre": "The end must be in the future and the delegation last at most 90 days.",
  "fonA.deleg.r.soi": "You cannot delegate a role to yourself.",
  "fonA.deleg.r.delegue": "The delegate is not an active person of the organisation.",
  "fonA.deleg.r.revocation": "Only the delegator, the delegate or the administration revoke this delegation.",
  "fonA.deleg.r.ecriture": "Your role does not allow delegating.",
  "fonA.raci.r.decideur": "A decision keeps at least one deciding role.",
  "fonA.deleg.titre": "Delegations and RACI",
  "fonA.deleg.description": "Who may act on behalf of a decision maker, and who decides, is consulted or informed for each decision.",
  "fonA.deleg.onglets": "Delegation views",
  "fonA.deleg.ongletDelegations": "Delegations",
  "fonA.deleg.ongletRaci": "RACI matrix",
  "fonA.deleg.chargement": "Reading delegations…",
  "fonA.deleg.erreur": "Delegations could not be read.",
  "fonA.deleg.portee": "All delegations of the organisation.",
  "fonA.deleg.porteeMoi": "Delegations where you are delegator or delegate.",
  "fonA.deleg.vide": "No delegation",
  "fonA.deleg.videAide": "Declare a delegation below before an absence.",
  "fonA.deleg.declarer": "Declare a delegation",
  "fonA.deleg.ligne": "{{role}} from {{de}} → {{a}}",
  "fonA.deleg.ligneProjet": "{{projet}} · until {{date}}",
  "fonA.derog.col.projet": "Project",
  "fonA.deleg.role": "Delegated role",
  "fonA.deleg.delegant": "Delegator (empty: you)",
  "fonA.deleg.moi": "me ({{id}})",
  "fonA.deleg.delegue": "Delegate",
  "fonA.deleg.fin": "Until (at most 90 days)",
  "fonA.deleg.motif": "Reason (at least 5 characters)",
  "fonA.deleg.enregistrer": "Declare",
  "fonA.deleg.declaree": "Delegation declared and recorded.",
  "fonA.deleg.ficheChargement": "Reading the delegation…",
  "fonA.deleg.introuvable": "This delegation does not exist or is not open to you.",
  "fonA.deleg.ficheTitre": "Delegation of the {{role}} role",
  "fonA.fiche.fil": "Breadcrumb",
  "fonA.deleg.retour": "All delegations",
  "fonA.fiche.etat": "State",
  "fonA.deleg.delegantSeul": "Delegator",
  "fonA.deleg.fenetre": "Window",
  "fonA.deleg.motifSeul": "Reason",
  "fonA.deleg.declareePar": "Declared by",
  "fonA.deleg.revoqueePar": "Revoked by",
  "fonA.deleg.revoquerTitre": "Revoke this delegation?",
  "fonA.deleg.revoquerConsequence": "The delegate can no longer act on behalf of the delegator in this project, starting now.",
  "fonA.deleg.revoquerReversible": "A new delegation can be declared afterwards.",
  "fonA.deleg.revoquer": "Revoke",
  "fonA.raci.chargement": "Reading the RACI matrix…",
  "fonA.raci.erreur": "The RACI matrix could not be read.",
  "fonA.raci.aideAdmin": "Each decision keeps at least one deciding role. A change is recorded in the audit log.",
  "fonA.raci.lecture": "Read only: the matrix is set by the organisation administration.",
  "fonA.raci.vide": "No decision in the catalogue",
  "fonA.raci.videAide": "The permission catalogue is empty.",
  "fonA.raci.region": "RACI matrix, horizontal scrolling",
  "fonA.raci.legende": "Decisions and roles: decides, consulted, informed",
  "fonA.raci.decision": "Decision",
  "fonA.raci.actions": "Actions",
  "fonA.raci.modifiee": "changed by {{qui}}",
  "fonA.raci.choix": "{{decision}} — {{role}}",
  "fonA.raci.enregistrer": "Save",
  "fonA.fiche.parLe": "by {{qui}} on {{date}}",
  "fonA.fiche.decision": "Decision",
  "fonA.mcp.aide": "An imported MCP server stays quarantined until approved by someone other than its author; it is enabled, bound to an agent, tested, run in the active project or deleted here.",
  "fonA.mcp.refus": "The organisation's MCP servers are managed by its administration.",
  "harnais.ongletFinalites": "AI purposes",
  "fonA.gabarits.chargement": "Reading the organisation's templates…",
  "fonA.gabarits.erreur": "Templates could not be read.",
  "fonA.gabarits.titre": "Harness mode and two-person mode, per template",
  "fonA.gabarits.aide": "The template sets the missions' execution mode and the modes a launch may choose; two-person mode lets the requester approve a low-risk object after review by a separate reviewer.",
  "fonA.gabarits.lecture": "Read only: setting templates belongs to the organisation administration.",
  "fonA.gabarits.vide": "No organisation-specific template",
  "fonA.gabarits.videAide": "The built-in template applies (mode C, two-person mode off). Create a template to set these modes.",
  "fonA.gabarits.sansPlateforme": "This template has no platform section: open it once in Templates.",
  "fonA.gabarits.publie": "published",
  "fonA.gabarits.brouillon": "draft",
  "fonA.gabarits.modeDefaut": "Default mode",
  "fonA.gabarits.permis": "Modes allowed at launch",
  "fonA.gabarits.agent": "Wrapped agent (mode A)",
  "fonA.gabarits.nonLivre": "not delivered",
  "fonA.gabarits.externe": "external AI",
  "fonA.gabarits.agentRequis": "Mode A requires an agent.",
  "fonA.gabarits.deuxPersonnes": "Two-person mode",
  "fonA.gabarits.deuxPersonnesAide": "Allowed: low-risk object, after review by a separate reviewer (risk can be raised, never lowered). Never: production promotion, security, waivers, one-way decisions, missions.",
  "fonA.gabarits.enregistrer": "Save (draft)",
  "fonA.gabarits.publier": "Publish",
  "fonA.gabarits.enregistre": "Saved as draft: projects keep the published version until publication.",
  "fonA.castes.chargement": "Reading harness castes…",
  "fonA.castes.refus": "Harness castes are not open to you.",
  "fonA.castes.erreur": "Castes could not be read; nothing changed.",
  "fonA.castes.activeDeterministe": "active (no model)",
  "fonA.castes.active": "active",
  "fonA.castes.beta": "in beta",
  "fonA.castes.prevue": "planned",
  "fonA.castes.sansRegistre": "The worker has published no registry snapshot: cards in service are unknown. Castes without a model remain active.",
  "fonA.castes.publie": "Cards in service according to the snapshot published on {{date}}.",
  "fonA.castes.region": "Harness castes, horizontal scrolling",
  "fonA.castes.legende": "Castes: role, right, deposit, state and card in service",
  "fonA.castes.col.caste": "Caste",
  "fonA.castes.col.droit": "Right",
  "fonA.castes.col.depose": "Deposits",
  "fonA.castes.col.etat": "State",
  "fonA.castes.col.carte": "Card in service and model",
  "fonA.castes.modesTitre": "Harness modes per template",
  "fonA.castes.experimental": "experimental",
  "fonA.castes.defaut": "default",
  "fonA.castes.gabaritModes": "mode {{mode}} ({{source}}), allowed: {{permis}}",
  "fonA.castes.fixe": "set by the template",
  "fonA.castes.parDefaut": "default",
  "fonA.castes.gabaritInvalide": "invalid harness section",
  "fonA.castes.reglerModes": "The mode and allowed modes are set per template in",
  "fonA.connexions.refus": "The organisation's AI connections are managed by its administration.",
  "fonA.connexions.sondee": "probed on {{date}}",
  "fonA.connexions.joignable": "reachable",
  "fonA.connexions.injoignable": "unreachable",
  "fonA.connexions.inconnu": "not tested",
  "fonA.connexions.tester": "Test the connection",
  "fonA.fiche.chargement": "Reading the purpose…",
  "fonA.fiche.introuvable": "This purpose does not exist or is not open to you.",
  "fonA.fiche.erreur": "The purpose could not be read.",
  "fonA.fiche.titre": "Purpose “{{code}}” v{{v}}",
  "fonA.fiche.description": "Project {{projet}} · agent {{agent}}",
  "fonA.fiche.retourOrg": "Organisation purposes",
  "fonA.fiche.retourAgents": "Custom agents",
  "fonA.fiche.justification": "Justification",
  "fonA.fiche.declaree": "Declared",
  "fonA.fiche.echeance": "Expiry",
  "fonA.fiche.retrait": "Withdrawal reason",
  "fonA.fiche.consentement": "My consent",
  "fonA.fiche.consentiJusqua": "given until {{date}}",
  "fonA.fiche.nonConsenti": "not given",
  "fonA.fiche.motif": "Reason (refusal or withdrawal, at least 5 characters)",
  "fonA.fiche.approuver": "Approve",
  "fonA.fiche.refuser": "Refuse",
  "fonA.fiche.retirer": "Withdraw the purpose",
  "fonA.fiche.retirerConsentement": "Withdraw my consent",
  "fonA.fiche.donnerConsentement": "Give my consent (180 days)",
  "fonA.fiche.consentementPersonnel": "Nobody consents on your behalf.",
  "fonA.fiche.enregistre": "Saved and recorded in the audit log.",
  "fonA.finalitesOrg.aDecider": "To decide",
  "fonA.finalitesOrg.approuvees": "Approved",
  "fonA.finalitesOrg.toutes": "All",
  "fonA.finalitesOrg.aide": "A project owner declares an agent's purpose; the organisation administration approves or refuses it — never the person who declared it. Each person then consents personally before running the agent.",
  "fonA.finalitesOrg.filtres": "Filter purposes",
  "fonA.finalitesOrg.chargement": "Reading the organisation's purposes…",
  "fonA.finalitesOrg.refus": "Deciding AI purposes belongs to the organisation administration.",
  "fonA.finalitesOrg.erreur": "Purposes could not be read.",
  "fonA.finalitesOrg.vide": "No purpose in this filter",
  "fonA.finalitesOrg.videAide": "Project owners declare purposes from Custom agents.",
  "fonA.sante.chargement": "Reading platform health…",
  "fonA.sante.refus": "Platform health is reserved for its administration.",
  "fonA.sante.erreur": "Platform health could not be read.",
  "fonA.sante.sain": "healthy",
  "fonA.sante.attention": "to watch",
  "fonA.sante.degrade": "degraded",
  "fonA.sante.inconnu": "unknown",
  "fonA.sante.gpuDetecte": "detected",
  "fonA.sante.gpuNonDetecte": "not detected",
  "fonA.sante.verifie": "checked on {{date}}",
  "fonA.sante.etatsDegrades": "Degraded states and repair procedure",
  "fonA.sante.procedure": "Out-of-tool procedure:",
  "fonA.sante.composants": "Component versions",
  "fonA.sante.interface": "Interface",
  "fonA.sante.migrations": "{{n}} migrations",
  "fonA.sante.poste": "Station profile",
  "fonA.sante.gpu": "GPU: {{etat}}",
  "fonA.sante.budget": "Declared card: {{carte}} · budget {{budget}} MiB of {{total}} MiB",
  "fonA.sante.residentsInconnus": "Resident models: unknown ({{code}})",
  "fonA.sante.aucunResident": "No model resident in VRAM.",
  "fonA.sante.residents": "Resident: {{liste}}",
  "fonA.sante.modeleOk": "installed, digest matches",
  "fonA.sante.modeleManquant": "missing",
  "fonA.sante.modeleCorrompu": "different digest",
  "fonA.sante.moteurs": "AI engines and workers",
  "fonA.sante.aucunWorker": "No worker has shown a sign of life for a day.",
  "fonA.sante.vivant": "alive",
  "fonA.sante.perime": "silent",
  "fonA.sante.sansMoteur": "no engine",
  "fonA.sante.travaux": "{{n}} jobs",
  "fonA.sante.connexions": "Platform AI connections",
  "fonA.exigence.chargement": "Reading the requirement…",
  "fonA.exigence.introuvable": "This requirement does not exist in your organisation.",
  "fonA.exigence.erreur": "The requirement could not be read.",
  "fonA.exigence.titre": "Requirement {{code}}",
  "fonA.exigence.description": "{{categorie}} · version {{v}} · inherited by {{p}} project(s) and {{g}} programme(s)",
  "fonA.exigence.retour": "Requirements reference",
  "fonA.exigence.creee": "created by {{qui}} on {{date}}",
  "fonA.exigence.modifiee": "changed by {{qui}} on {{date}}",
  "fonA.exigence.retiree": "A retired requirement can no longer be changed.",
  "fonA.exigence.enonce": "Statement",
  "fonA.exigence.seuil": "Threshold",
  "fonA.exigence.mesure": "Measurement method",
  "fonA.exigence.controle": "Control that verifies it",
  "fonA.exigence.proprietaire": "Owner",
  "fonA.exigence.enregistrer": "Save (new version)",
  "fonA.exigence.enregistree": "Requirement changed: version {{v}}, recorded in the log.",
  "fonA.sante.vram": "{{u}} / {{n}} MiB",
  "fonA.webhooks.nomRequis": "Give the webhook a name.",
  "fonA.webhooks.workflowRequis": "A gitlab_push webhook triggers a workflow: enter it.",
  "fonA.finalites.agentRequis": "Choose the agent concerned.",
  "fonA.finalites.justificationCourte": "The justification has at least 10 characters.",
  "fonA.finalites.dureeInvalide": "The validity ranges from 1 to 365 days.",
  "fonA.deleg.projetRequis": "Choose the project.",
  "fonA.deleg.delegueRequis": "Choose the delegate.",
  "fonA.deleg.finRequise": "Enter the end date.",
  "fonA.deleg.motifRequis": "The reason has at least 5 characters.",
  "fonA.fiche.motifRequis": "A refusal or withdrawal carries a reason of at least 5 characters.",
  "fonA.exigence.requis": "Statement and owner are required.",
  "fonA.gouvernance.onglets": "Governance views",
  "fonA.gouvernance.ongletReglages": "Settings and emergency stop",
  "accueil.titre.administration": "What awaits an administration decision, and the shortcuts",
  "accueilAdmin.degradee": "degraded",
  "accueilAdmin.demandeLigne": "{{qui}} requests access to “{{projet}}”",
  "accueilAdmin.demandes": "Access requests to decide",
  "accueilAdmin.demandesChargement": "Reading access requests…",
  "accueilAdmin.demandesErreur": "Access requests could not be read.",
  "accueilAdmin.demandesVide": "No pending access request",
  "accueilAdmin.demandesVideIndice": "Someone who opens a project without being a member can request access; the request appears here.",
  "accueilAdmin.description": "What awaits an administration decision, then the organisation{{plateforme}} shortcuts.",
  "accueilAdmin.emetteurCoherent": "Token issuer consistent with Keycloak.",
  "accueilAdmin.emetteurIncoherent": "Token issuer mismatch: the gateway expects “{{attendu}}”, Keycloak issues “{{servi}}” — no sign-in can succeed.",
  "accueilAdmin.emetteurNonVerifie": "Token issuer not verified ({{statut}}).",
  "accueilAdmin.etPlateforme": " and platform",
  "accueilAdmin.gererInvitations": "Manage invitations",
  "accueilAdmin.indisponible": "unavailable",
  "accueilAdmin.invitations": "Pending invitations — current project",
  "accueilAdmin.invitationsChargement": "Reading invitations…",
  "accueilAdmin.invitationsErreur": "Invitations could not be read.",
  "accueilAdmin.invitationsSansProjet": "No project open",
  "accueilAdmin.invitationsSansProjetIndice": "Invitations are read per project: open one in the context selector.",
  "accueilAdmin.invitationsVide": "No pending invitation",
  "accueilAdmin.invitationsVideIndice": "Invitations are created in the project settings, Members section.",
  "accueilAdmin.inviter": "Invite to “{{projet}}”",
  "accueilAdmin.membresProjet": "Current project members",
  "accueilAdmin.ouvrirOrganisations": "Open organisations",
  "accueilAdmin.ouvrirSante": "Open platform health",
  "accueilAdmin.raccourcis": "Shortcuts",
  "accueilAdmin.refus": "This is the administration view",
  "accueilAdmin.refusIndice": "Your role has no administration task: choose another view in “View”, at the bottom of the navigation.",
  "accueilAdmin.saine": "healthy",
  "accueilAdmin.sante": "Platform health",
  "accueilAdmin.santeChargement": "Reading health…",
  "accueilAdmin.santeErreur": "Platform health could not be read.",
  "accueilAdmin.santeEtat": "Platform: {{etat}}",
  "accueilAdmin.suspensions": "Suspended organisations",
  "accueilAdmin.suspensionsChargement": "Reading organisations…",
  "accueilAdmin.suspensionsErreur": "Organisations could not be read.",
  "accueilAdmin.suspensionsVide": "No suspended organisation",
  "accueilAdmin.suspensionsVideIndice": "{{n}} active organisation(s) on the platform.",
  "accueilAdmin.titre": "Administration home",
  "admin.demanderProprietaire": "Ask a project owner",
  "admin.emetteurCoherent": "consistent",
  "admin.emetteurIncoherent": "mismatch: no sign-in can succeed",
  "admin.emetteurNonVerifie": "not verified",
  "admin.emetteurRemede": "Align the gateway KEYCLOAK_ISSUER_URI with Keycloak KC_HOSTNAME (same Compose files for both), then recreate the gateway.",
  "admin.emetteurTitre": "Token issuer (Keycloak)",
  "admin.emetteurValeurs": "expected: {{attendu}} · served: {{servi}}",
  "adr.baselineLivree": "The project technology baseline (inheritance per category, change requests, propagation) lives in “Choices and baseline”; the ADR and the matrix remain the path for a category defined for this project.",
  "adr.ouvrirBaseline": "Open Choices and baseline",
  "adr.vuePile": "Project stack profile",
  "adr.vueToutes": "All decisions",
  "attention.voisins": "Related screens",
  "deliveryOverview.gitlabNonConnecte": "GitLab is not connected to this project.",
  "membres.accorder": "Grant",
  "membres.chargement": "Reading members…",
  "membres.colIdentifiant": "username",
  "membres.colNom": "name",
  "membres.colRole": "role",
  "membres.decisionEnregistree": "Decision recorded; the person is notified.",
  "membres.dejaDecidee": "This request has already been decided.",
  "membres.demandes": "Pending access requests",
  "membres.demandesChargement": "Reading access requests…",
  "membres.demandesErreur": "Access requests could not be read.",
  "membres.demandesVide": "No pending access request",
  "membres.demandesVideIndice": "Someone in the organisation who opens this project without being a member can request access; you are notified.",
  "membres.description": "Who works on “{{projet}}”, with which role. For a higher role, ask an owner.",
  "membres.equipeMembres": "{{n}} member(s)",
  "membres.equipes": "Teams",
  "membres.equipesChargement": "Reading teams…",
  "membres.equipesErreur": "Teams could not be read.",
  "membres.equipesVide": "No team in this project",
  "membres.equipesVideIndice": "A project owner or the organisation’s administration creates teams from this screen.",
  "membres.erreur": "Members could not be read.",
  "membres.gerer": "Manage members and invitations",
  "membres.annuaire": "Organisation directory",
  "membres.liste": "Members",
  "membres.motifRefus": "Reason for refusal (optional)",
  "membres.proprietaires": "Owners: {{noms}}.",
  "membres.refuser": "Refuse",
  "membres.role.contributor": "contributor",
  "membres.role.owner": "owner",
  "membres.role.viewer": "viewer",
  "membres.roleAccorde": "Role granted",
  "membres.sansProjet": "No project open",
  "membres.sansProjetIndice": "Choose a project in the context selector to see its members.",
  "membres.sansProprietaire": "This project has no active owner.",
  "membres.titre": "Project members",
  "membres.vide": "No member",
  "membres.videIndice": "A project owner or the organisation’s administration adds members from this screen.",
  "menu.accueilAdministration": "Administration home",
  "menu.invitations": "My invitations",
  "nonMembre.accordee": "Your request is granted: the project opens as soon as your project list is re-read.",
  "nonMembre.adminIndisponible": "This project cannot be joined: it is archived or does not belong to your organisation.",
  "nonMembre.adminRejoindre": "As platform administrator, you can join “{{nom}}” as owner: the action is recorded in the journal.",
  "nonMembre.annuler": "Cancel my request",
  "nonMembre.archive": "This project is archived: it no longer accepts new members.",
  "nonMembre.chargement": "Reading your access requests…",
  "nonMembre.compteInconnu": "Your account is not an active user of this organisation.",
  "nonMembre.dejaEnAttente": "A request is already awaiting an owner's decision.",
  "nonMembre.dejaMembre": "You are already a member of this project: reload the page.",
  "nonMembre.demander": "Request access",
  "nonMembre.description": "Project {{id}} belongs to your organisation, but you have no role in it: its content is not shown to you.",
  "nonMembre.enAttente": "Request sent on {{date}}: it awaits the decision of a project owner, who has been notified.",
  "nonMembre.erreurLecture": "Your access requests could not be read.",
  "nonMembre.introuvable": "This project cannot be found in your organisation.",
  "nonMembre.mesProjets": "Back to my projects",
  "nonMembre.messageExemple": "Why do you need this project?",
  "nonMembre.messageLabel": "Message to the owner (optional)",
  "nonMembre.ouvrir": "Open the project",
  "nonMembre.redemander": "You can submit a new one.",
  "nonMembre.refusee": "Your request of {{date}} was refused",
  "nonMembre.rejoindre": "Join this project",
  "nonMembre.titre": "You are not a member of this project",
  "orgProjets.lancement": "Launch",
  "programs.ouvrirVue": "Open the programme view",
  "programs.ouvrirVueAria": "Open the programme view of {{nom}}",
  "projet.ouvrirPleinePage": "Open full page",
  "projetArchive.choisir": "Choose another project in the context selector, or from the organisation's project list.",
  "projetArchive.description": "“{{nom}}” is no longer a workplace: the gateway no longer serves its content, and its screens are not shown.",
  "projetArchive.titre": "This project is archived",
  "roleRestreint.lien": "See the project owners to request this role",
  "roleRestreint.motif": "Action not allowed for your current role. The {{role}} role is required to {{action}}.",
  "runops.gitlabNonConnecte": "GitLab is not connected to this project: no pipeline to offer.",
  "vueProjet.voirBaseline": "See the project technology baseline",
  "nav./projet/membres": "Project members",
  "navdesc./projet/membres": "Who works on this project, with which role; teams; access requests to decide",
  "nav./administration": "Administration home",
  "navdesc./administration": "Access requests, invitations, suspended organisations, health and administration shortcuts",
  "menu.monOrganisation": "My organisation",
  "org.settings.demenage": "New-project mode and designated architects: they bind the whole organisation and are set on its profile. Waivers of all projects have their own list.",
  "org.settings.versFiche": "My organisation › Governance",
  "org.settings.versDerogations": "Waivers of the whole organisation",
  "admin.organisationAiLecture": "Read-only here: AI provider connections and organisation models are managed in My organisation › Integrations. This project picks, below, which of them it allows.",
  "admin.organisationAiAucunActif": "No model is enabled for the organisation.",
  "admin.versIntegrationsOrganisation": "Manage in My organisation › Integrations",
  "derogationsOrg.titre": "Organisation waivers",
  "derogationsOrg.description": "All waivers, by project, risk, due date and state — never silently extended.",
  "derogationsOrg.chargement": "Loading waivers…",
  "derogationsOrg.erreur": "Waivers could not be loaded.",
  "derogationsOrg.aDecider": "to decide",
  "derogationsOrg.accordees": "granted",
  "derogationsOrg.echues": "expired — non-compliant",
  "derogationsOrg.levees": "lifted or refused",
  "derogationsOrg.masquees": "You see the waivers of the projects you belong to; {{n}} more exist in projects you are not a member of.",
  "derogationsOrg.porteeMembre": "You see the waivers of the projects you belong to.",
  "derogationsOrg.liste": "Waivers ({{n}})",
  "derogationsOrg.filtre": "Show",
  "derogationsOrg.filtreActives": "ongoing (to decide, granted, expired)",
  "derogationsOrg.filtreADecider": "to decide",
  "derogationsOrg.filtreEchues": "expired",
  "derogationsOrg.filtreToutes": "all",
  "derogationsOrg.vide": "No waiver",
  "derogationsOrg.videIndice": "A waiver is requested from a project's Requirements and waivers screen.",
  "derogationsOrg.filtreVide": "No waiver for this filter",
  "derogationsOrg.filtreVideIndice": "Choose “all” to see lifted or refused waivers again.",
  "derogationsOrg.legende": "Waivers: requirement, project, risk, due date, state, owner",
  "derogationsOrg.col.exigence": "requirement",
  "derogationsOrg.col.projet": "project",
  "derogationsOrg.col.risque": "risk",
  "derogationsOrg.col.echeance": "due date",
  "derogationsOrg.col.etat": "state",
  "derogationsOrg.col.responsable": "owner",
  "derogationsOrg.retour": "← Organisation waivers",
  "derogationsOrg.introuvable": "Waiver not found",
  "derogationsOrg.introuvableIndice": "It does not exist, or belongs to a project you are not a member of.",
  "derogationsOrg.ficheChargement": "Loading the waiver…",
  "derogationsOrg.ficheErreur": "The waiver could not be loaded.",
  "derogationsOrg.ficheTitre": "Waiver to {{code}}",
  "derogationsOrg.ficheEtat": "State and due date",
  "derogationsOrg.parcours": "approval",
  "derogationsOrg.demandee": "requested",
  "derogationsOrg.ficheJustification": "Justification and controls",
  "derogationsOrg.relue": "Reviewed by {{qui}}: {{verdict}} — “{{commentaire}}”",
  "derogationsOrg.decidee": "Decided by {{qui}} on {{quand}}",
  "derogationsOrg.agir": "Reviewing, deciding or lifting this waiver happens in its project:",
  "derogationsOrg.agirNonMembre": "You are not a member of this project: its members review and decide the waiver there.",
  "derogationsOrg.ouvrirProjet": "Project requirements and waivers",
  "ficheMonOrg.section.apercu": "Overview",
  "ficheMonOrg.section.gouvernance": "Governance",
  "ficheMonOrg.section.derogations": "Waivers",
  "ficheMonOrg.section.integrations": "Integrations",
  "ficheMonOrg.refus.nom": "The name must be 2 to 120 characters long.",
  "ficheMonOrg.refus.description": "The description holds 2,000 characters at most.",
  "ficheMonOrg.refus.inchange": "Nothing to save: name and description are unchanged.",
  "ficheMonOrg.refus.identifiant": "An organisation identifier cannot be changed.",
  "ficheMonOrg.refus.admin": "Reserved to the organisation's administration.",
  "ficheMonOrg.refus.suspendue": "Organisation suspended by the platform: read-only.",
  "ficheMonOrg.refus.inattendu": "The gateway refused the change.",
  "ficheOrg.identite": "Identity and status",
  "ficheMonOrg.modifier": "Edit name and description",
  "ficheOrg.nom": "Name",
  "ficheOrg.description": "Description",
  "ficheMonOrg.identifiantFige": "The identifier {{id}} stays fixed: tokens, links and the audit trail carry it.",
  "ficheMonOrg.annuler": "Cancel",
  "ficheMonOrg.enregistrer": "Save",
  "ficheOrg.identifiant": "Identifier",
  "ficheOrg.sansDescription": "No description.",
  "ficheOrg.statut": "Status",
  "ficheOrg.palier": "Plan",
  "ficheMonOrg.quotas": "quotas and usage",
  "ficheOrg.creee": "Created on",
  "ficheMonOrg.modifiee": "Modified on",
  "ficheMonOrg.modifieePar": "{{quand}} by {{qui}}",
  "ficheMonOrg.enregistre": "Identity saved and written to the organisation's audit trail.",
  "ficheMonOrg.lectureSeule": "Read-only: identity and integrations are changed by the organisation's administration.",
  "ficheOrg.administrateurs": "Administrators",
  "ficheMonOrg.adminsVide": "No administrator enrolled by the platform",
  "ficheMonOrg.adminsVideIndice": "The organisation was self-created: its administration is held by the administrator role of its members.",
  "ficheOrg.compteurs": "Counters",
  "ficheMonOrg.versProjets": "Projects",
  "ficheMonOrg.versProjetsAide": "{{n}} project(s): create, open, attach",
  "ficheMonOrg.versProgrammes": "Programmes",
  "ficheMonOrg.versProgrammesAide": "{{n}} programme(s)",
  "ficheMonOrg.versUtilisateurs": "Users",
  "ficheMonOrg.versUtilisateursAide": "{{n}} person(s): directory, roles, memberships",
  "ficheMonOrg.versQuotas": "Quotas and plan",
  "ficheMonOrg.versQuotasAide": "Plan {{p}}: limits and usage",
  "ficheMonOrg.reglagesTitre": "Where the organisation's governance is set",
  "ficheMonOrg.reglagesAide": "Each setting has its own screen; all of them bind every project of the organisation.",
  "ficheMonOrg.referentielAide": "Definition of done, requirements and controls inherited by projects",
  "ficheMonOrg.reglesAide": "Observe, warn, block: the stage of each rule",
  "ficheMonOrg.gouvernanceAide": "Approval modes and AI emergency stop",
  "ficheMonOrg.derogationsAide": "All organisation waivers, by project and due date",
  "ficheMonOrg.cheminAide": "Recommended configuration and drifting projects",
  "ficheMonOrg.charteAide": "Design charter inherited by projects",
  "ficheMonOrg.catalogueAide": "Technology choices offered to projects",
  "ficheMonOrg.accesAide": "Role matrix and access policies",
  "ficheMonOrg.voirDerogations": "Open the list of waivers",
  "ficheMonOrg.chargement": "Loading your organisation's profile…",
  "ficheMonOrg.titre": "My organisation",
  "ficheMonOrg.sansOrganisation": "Your account is not attached to any organisation.",
  "ficheMonOrg.erreur": "The organisation's profile could not be loaded.",
  "ficheMonOrg.description": "My organisation: identity, governance, waivers and integrations shared by all its projects.",
  "ficheMonOrg.sections": "Sections of the organisation's profile",
  "ficheOrg.onglet.apercu": "Overview",
  "ficheOrg.onglet.projets": "Projects and programmes",
  "ficheOrg.onglet.utilisateurs": "Users",
  "ficheOrg.onglet.consommation": "Usage",
  "ficheOrg.onglet.palier": "Plan",
  "ficheOrg.onglet.acces": "Exceptional access",
  "ficheOrg.onglet.activation": "Activation links",
  "ficheOrg.onglet.journal": "Log",
  "ficheOrg.sante": "Health",
  "ficheOrg.santeInconnue": "not measured",
  "ficheOrg.voirSante": "platform health",
  "ficheOrg.adminsVide": "No administrator enrolled by the platform",
  "ficheOrg.adminsVideIndice": "Organisation self-created or created before enrolment: generate an activation link for an administrator.",
  "ficheOrg.versActivation": "Activation links",
  "ficheOrg.projetsTitre": "Projects and programmes",
  "ficheOrg.besoinDeConnaitre": "Third-party organisation: the profile shows how many, never the names or the content. For an incident its administrator cannot handle, open an exceptional access: justified, time-limited, notified to its owners and written to its audit trail.",
  "ficheOrg.compteur.projets": "Projects",
  "ficheOrg.compteur.archives": "of which {{n}} archived",
  "ficheOrg.compteur.programmes": "Programmes",
  "ficheOrg.compteur.missions": "Ongoing missions",
  "ficheOrg.versAcces": "Exceptional access",
  "ficheOrg.projetsN": "Projects ({{n}})",
  "ficheOrg.aucunProjet": "No project",
  "ficheOrg.aucunProjetIndice": "Projects are created from Organisation › Projects.",
  "ficheOrg.archive": "archived",
  "ficheOrg.programmesN": "Programmes ({{n}})",
  "ficheOrg.aucunProgramme": "No programme",
  "ficheOrg.aucunProgrammeIndice": "Programmes are created from Organisation › Programmes.",
  "ficheOrg.utilisateursTitre": "Users of the organisation",
  "ficheOrg.utilisateursAide": "The directory (people, roles, memberships, invitations) is kept on its own screen.",
  "ficheOrg.compteur.membres": "Users",
  "ficheOrg.compteur.actifsSeul": "Active",
  "ficheOrg.compteur.proprietaires": "Project owners",
  "ficheOrg.versAnnuaire": "Open the user directory",
  "ficheOrg.retour": "← All organisations",
  "ficheOrg.chargement": "Loading the organisation's profile…",
  "ficheOrg.refus": "An organisation's profile is reserved to the platform's administration.",
  "ficheOrg.introuvable": "Organisation not found",
  "ficheOrg.introuvableIndice": "This identifier names no organisation. Go back to the list.",
  "ficheOrg.erreur": "The profile could not be loaded.",
  "ficheOrg.sousTitre": "Profile of organisation {{id}} — attributes and aggregates, never the content of a project.",
  "ficheOrg.palierCourt": "plan {{p}}",
  "ficheOrg.sienne": "your organisation",
  "ficheOrg.onglets": "Sections of the profile",
  "ficheOrg.accesSienne": "This is your organisation: you already see it, without exceptional access.",
  "ficheOrg.activationTitre": "Administrator activation links",
  "ficheMonOrg.connexionsVide": "No connection of the organisation's own: only those the platform shares with it apply.",
  "ficheMonOrg.exempleConnexion": "Local Ollama GPU",
  "ficheMonOrg.type.ia": "AI provider",
  "ficheMonOrg.type.gitlab": "GitLab",
  "ficheMonOrg.type.odoo": "Odoo",
  "ficheMonOrg.inventaireTitre": "Connector inventory",
  "ficheMonOrg.inventaireAide": "The organisation's AI connections, plus each project's GitLab and Odoo. No secret is ever shown: only whether it is set. A project connector is configured in its project's settings.",
  "ficheMonOrg.inventaireChargement": "Loading the inventory…",
  "ficheMonOrg.inventaireRefus": "The connector inventory is reserved to the organisation's administration.",
  "ficheMonOrg.inventaireErreur": "The inventory could not be loaded.",
  "ficheMonOrg.inventaireVide": "No connector",
  "ficheMonOrg.inventaireVideIndice": "Register an AI connection above, or link GitLab or Odoo from a project's settings.",
  "ficheMonOrg.inventaireLegende": "Connectors: type, name, scope, endpoint, secret, last change",
  "ficheMonOrg.col.type": "type",
  "ficheMonOrg.col.nom": "name",
  "ficheMonOrg.col.portee": "scope",
  "ficheMonOrg.col.acces": "endpoint",
  "ficheMonOrg.col.secret": "secret",
  "ficheMonOrg.col.modifie": "changed",
  "ficheMonOrg.desactive": "disabled",
  "ficheMonOrg.porteeOrganisation": "organisation",
  "ficheMonOrg.secretRef": "referenced: {{r}}",
  "ficheMonOrg.secretPose": "set",
  "ficheMonOrg.secretAbsent": "none",
  "ficheMonOrg.integrationsSansDroit": "The organisation's integrations (AI connections, models, connectors) are reserved to its administration.",
  "ficheMonOrg.canauxTitre": "Notification channels",
  "ficheMonOrg.canauxAide": "Channels (webhook, messaging) are currently set by the platform and relayed for every organisation; each person chooses what notifies them in their preferences.",
  "ficheMonOrg.versNotifications": "My notifications",
  "ficheOrg.admin.active": "account activated",
  "ficheOrg.admin.attente": "activation pending",
  "ficheOrg.admin.expire": "link expired",
  "ficheOrg.admin.revoque": "link revoked",
  "ficheOrg.compteur.actifs": "{{n}} active · {{p}} project owner(s)",
  "ficheOrg.compteur.conso": "This month: tokens · AI calls",
  "ficheOrg.compteur.acces": "Active exceptional accesses",
  "ficheOrg.compteur.liens": "{{n}} activation link(s) pending",
  "ficheOrg.admin.activeLe": "activated on {{quand}}",
  "nav./org/fiche": "My organisation",
  "navdesc./org/fiche": "Organisation identity, governance settings, waivers and integrations (AI, connectors)",
  "ficheMonOrg.exempleSecret": "secret/llm/openai",
  "admin.accessDeniedProjetActif": "These settings belong to the owner of the open project and to the organisation's administration. Owning another project is not enough: open one of your projects in the selector.",
  "admin.purgeReservee": "Purging destroys audit evidence: it is reserved to the organisation's administration.",
  "arret.basculeReserveeOrganisation": "Stopping or restarting the organisation's AI is reserved to its administration.",
  "config.mcpGestionReservee": "Importing, approving, enabling or deleting an MCP server is reserved to the organisation's administration.",
  "conformite.exportReserve": "This project's audit export is reserved to its owner, auditors and the organisation's administration.",
  "premiersPas.aFaire": "to do",
  "premiersPas.acces": "Set the access policies",
  "premiersPas.accesAction": "Set sign-in security",
  "premiersPas.accesAide": "Mandatory second factor, session duration, allowed e-mail domains; then the role matrix.",
  "premiersPas.catalogue": "Build the technology catalogue",
  "premiersPas.catalogueAction": "Open the catalogue",
  "premiersPas.catalogueAide": "The starter set adds in one step the languages, frameworks, databases and platforms (web, mobile, desktop) the platform can generate; your secrets vault remains to be registered.",
  "premiersPas.equipe": "Invite the team",
  "premiersPas.equipeAction": "Invite someone",
  "premiersPas.equipeAide": "Each person receives a single-use activation link, with their organisation role and projects.",
  "premiersPas.fait": "done",
  "premiersPas.masquer": "Hide",
  "premiersPas.progression": "{{faits}} of {{total}} done — each step is checked from the organisation's actual state.",
  "premiersPas.projet": "Create the first project",
  "premiersPas.projetAction": "Open projects",
  "premiersPas.projetAide": "The launch wizard: identity, programme, technology choices (including the target platform), team.",
  "premiersPas.titre": "Your organisation's first steps",
  "risquePlan.enregistre": "Mitigation plan recorded",
  "risquePlan.titre": "Risk mitigation plan",
  "risquePlan.proprietaireLu": "Owner: {{p}}",
  "risquePlan.mesureLue": "Measure: {{m}}",
  "risquePlan.echeanceLue": "Due date: {{e}}",
  "risquePlan.incomplet": "Choose the owner, describe the measure and set the due date.",
  "risquePlan.echeancePassee": "The due date must be in the future.",
  "risquePlan.aide": "The reviewer flagged a risk. To approve despite this risk, first record who owns it, what will be done and by when; then justify your decision in the comment.",
  "risquePlan.proprietaire": "Owner",
  "risquePlan.choisir": "Choose a project member…",
  "risquePlan.mesure": "Measure",
  "risquePlan.echeance": "Due date",
  "risquePlan.enregistrer": "Record the plan",
  "job.remedeModele.titre": "The model {{modele}} is not granted to your organisation.",
  "job.remedeModele.org": "An organisation administrator activates it in",
  "job.remedeModele.orgLien": "My organisation › Integrations",
  "job.remedeModele.orgFin": ", then resubmits the request.",
  "job.remedeModele.plateforme": "If the “Activate” button is greyed out there (“connector not found”), the connection serving this model is not granted to the organisation: only a super administrator can grant it, in",
  "job.remedeModele.plateformeLien": "Platform › AI",
  "premiersPas.modelesIa": "Activate the platform AI models",
  "premiersPas.modelesIaAction": "Open integrations",
  "premiersPas.modelesIaAide": "Models run by the platform (framing, specification, review) not activated: {{modeles}}. Without them, the first idea submission fails.",
  "premiersPas.modelesIaConnecteur": "Models run by the platform without a granted connector: {{modeles}}. Only a super administrator grants the connection (Platform › AI); then activate the models here.",
  "premiersPas.modelesIaIllisible": "The AI model status could not be read: check My organisation › Integrations.",
  "versions.docsPerimee": "Documentation out of date: the objects it describes (delivered items, deployments, acceptance evidence, notes) have changed since it was generated. Regenerate it before sharing it.",
  "versions.docsRegenerate": "Regenerate the documentation",
  "versions.docsGenerePar": "generated by {{qui}}",
  "versions.docPerimee": "out of date",
  "catalogueTech.plancherIdentiteAideV2": "no entry: the starter set offers Keycloak, the platform identity provider. No generation profile integrates it: a project that selects it is not generable. For a generated application, select “Built into the generated stack” — authentication is then whatever the generated code writes; require it in the specification if it matters.",
  "baseline.optionNonGenerable": "not generable",
  "baseline.nonGenerableAide": "Not generable: {{produits}} — no generation profile integrates it, the project would not be generable. For a generated application, choose “Built into the generated stack”.",
  "approvals.appSlugExemple": "cash-register",
  "chat.conversationLibre": "Free conversation: nothing said here is recorded as a decision. Reviews and decisions are made in",
  "decisions.afficherConsignes": "Show the instructions",
  "decisions.age.heures": "{{n}} h",
  "decisions.age.jours": "{{n}} d",
  "decisions.age.minutes": "{{n}} min",
  "decisions.agir": "Act",
  "decisions.aide": "How is a decision made?",
  "decisions.apresDecision": "After your decision",
  "decisions.aVous": "Your turn to act",
  "decisions.col.action": "Action",
  "decisions.col.depuis": "Since",
  "decisions.col.document": "Document",
  "decisions.col.etape": "Required step",
  "decisions.col.qui": "Who must act",
  "decisions.consigne": "What must change",
  "decisions.consignesIA": "AI instructions (original prompt)",
  "decisions.controleALancer": "The specification must pass its quality check on this version before any approval.",
  "decisions.demanderChangement": "Request a change to this specification",
  "decisions.demanderVersion": "Request the new version",
  "decisions.description": "What awaits a review, a check or a decision in this project — and who must act. One row per document; its versions are in the detail.",
  "decisions.erreurLecture": "The document could not be read.",
  "decisions.etape.approved": "Approved",
  "decisions.etape.attendPrecedente": "Possible after the previous step — {{qui}}.",
  "decisions.etape.decision": "Decision",
  "decisions.etape.enCours": "In progress…",
  "decisions.etape.expired": "Expired",
  "decisions.etape.planRequis": "· mitigation plan required",
  "decisions.etape.qualityCheck": "Quality check to run",
  "decisions.etape.qualityCheckRunning": "Quality check running",
  "decisions.etape.rejected": "Rejected",
  "decisions.etape.reussi": "Passed on this version.",
  "decisions.etape.review": "Third-party review",
  "decisions.etape.revision": "New version requested",
  "decisions.etape.revueFaite": "{{qui}} — {{verdict}}",
  "decisions.etape.superseded": "Superseded",
  "decisions.etapesRequises": "Required steps",
  "decisions.etat.aVenir": "upcoming",
  "decisions.etat.bloque": "waiting for the previous step",
  "decisions.etat.courant": "current",
  "decisions.etat.fait": "done",
  "decisions.filAriane": "Breadcrumb",
  "decisions.filtre.demande": "Request",
  "decisions.filtre.etape": "Step",
  "decisions.filtre.recherche": "Search",
  "decisions.filtre.rechercherDocument": "Title, request or person…",
  "decisions.filtre.tousTypes": "All documents",
  "decisions.filtre.toutes": "All",
  "decisions.filtre.type": "Type",
  "decisions.filtres": "Filter decisions",
  "decisions.introuvable": "This document does not exist or you are not a member of the project.",
  "decisions.lancerControle": "Run the quality check",
  "decisions.meta.demandePar": "requested by {{qui}}",
  "decisions.meta.editee": "edited by {{qui}}",
  "decisions.meta.le": "on {{date}}",
  "decisions.meta.redigeeIA": "written by the AI",
  "decisions.meta.remplace": "replaces v{{n}}",
  "decisions.meta.version": "version {{n}}",
  "decisions.methodeIA": "AI method",
  "decisions.motif.accessDenied": "Your role in this project lets you read, not act ({{qui}} can act).",
  "decisions.motif.autre": "Another person must act: {{qui}}.",
  "decisions.motif.expired": "This request has expired: a new request is needed.",
  "decisions.motif.qualityRunning": "The quality check is running; the decision will be possible afterwards.",
  "decisions.motif.reviewer": "You reviewed this document: another person will decide ({{qui}}).",
  "decisions.motif.reviewRequired": "A third-party review is needed before any decision ({{qui}}).",
  "decisions.motif.selfApproval": "You requested this document: another person will decide ({{qui}}).",
  "decisions.motif.selfReview": "You requested this document: a third-party review is needed ({{qui}}).",
  "decisions.motif.specGate": "The specification must first pass its quality check on this version.",
  "decisions.motif.twoPersonExcluded": "Two-person mode: this kind of decision keeps three distinct people ({{qui}} will decide).",
  "decisions.motif.twoPersonReviewer": "Two-person mode: a review by another person is needed first.",
  "decisions.motif.twoPersonRisk": "Two-person mode: only for low-risk objects; another person will decide ({{qui}}).",
  "decisions.nouvelleVersion": "Request a new version…",
  "decisions.othersAide": "You can read them; the named person must act.",
  "decisions.ou": " or ",
  "decisions.pour": "For {{qui}}",
  "decisions.precision.controle": "Automatic check running",
  "decisions.precision.lecture": "Read-only for your role",
  "decisions.precision.plan": "Reviewer flagged a risk: mitigation plan required",
  "decisions.precision.relu": "Reviewed by {{qui}} — {{verdict}}",
  "decisions.precision.reviewer": "You reviewed it: another person decides",
  "decisions.precision.selfApproval": "You cannot decide your own request",
  "decisions.precision.selfReview": "You cannot review your own request",
  "decisions.qui.etAutres": "{{debut}} and {{n}} others",
  "decisions.qui.ou": "{{debut}} or {{dernier}}",
  "decisions.qui.personne": "Nobody else in this project can do it",
  "decisions.qui.systeme": "Automatic check running",
  "decisions.qui.vous": "You",
  "decisions.rail.titre": "Your decision",
  "decisions.rail.titreTermine": "Decision made",
  "decisions.remplaceesExclues": "{{n}} superseded version(s) are never “to do”: they can be viewed in the document detail.",
  "decisions.retourListe": "Back to decisions to make",
  "decisions.rienAFaire": "Nothing for you to do in this project.",
  "decisions.rienPourVous": "Nothing for you to do; {{n}} document(s) are waiting for {{qui}}.",
  "decisions.role.approbateur": "decision",
  "decisions.role.membre": "project member",
  "decisions.role.relecteur": "review",
  "decisions.section.controle": "Quality check",
  "decisions.section.document": "Document",
  "decisions.section.done": "Done",
  "decisions.section.mine": "Your turn to act",
  "decisions.section.others": "Waiting for another person",
  "decisions.section.technique": "Technical",
  "decisions.section.versions": "Versions",
  "decisions.sections": "Document sections",
  "decisions.suiteProposee": "Suggested next step",
  "decisions.titreListe": "Decisions to make",
  "decisions.uneAutrePersonne": "another person",
  "decisions.verbe.decider": "Decide",
  "decisions.verbe.evaluer": "Check",
  "decisions.verbe.lire": "Read",
  "decisions.verbe.ouvrir": "Open",
  "decisions.verbe.relire": "Review",
  "decisions.verbe.reviser": "Request a version",
  "decisions.verbe.suivre": "Follow",
  "decisions.verdict.approve": "favourable",
  "decisions.verdict.reject": "revision requested",
  "decisions.verdict.risk": "reservation",
  "decisions.videTitre": "Nothing awaits a decision in this project",
  "decisions.voirControle": "See the quality check",
  "decisions.voirEtapes": "See the steps",
  "decisions.vousPouvezLire": "You can read the document.",
  "demandes.documents": "Documents of this request",
  "demandes.documentsAucun": "No document awaits a decision for this request.",
  "demandes.prochaine.ensuite": "The other documents of the request are listed below.",
  "demandes.prochaine.pourAutre": "Next action — for {{qui}}",
  "demandes.prochaine.pourVous": "Next action — for you",
  "demandes.prochaine.titre": "Next action",
  "lecture.alors": "Then",
  "lecture.applicationTechnique": "Fingerprints and file tree: in the technical sheet.",
  "lecture.aucunChangement": "No content change (only the technical header differs).",
  "lecture.aucuneQuestion": "No question: the AI found no unclear area.",
  "lecture.backlogResume": "{{e}} epics, {{s}} stories",
  "lecture.changements": "What changed since the previous version",
  "lecture.changementsDepuis": "What changed since version {{n}}",
  "lecture.chiffre.couverture": "Requirements covered by a criterion",
  "lecture.chiffre.criteres": "Acceptance criteria",
  "lecture.chiffre.exigences": "Requirements",
  "lecture.col.couverture": "Coverage",
  "lecture.col.criteres": "Criteria",
  "lecture.col.exigence": "Requirement",
  "lecture.comparerTexte": "Compare the full text, line by line",
  "lecture.criteres": "Acceptance criteria",
  "lecture.criteresAjoutes": "criteria added",
  "lecture.criteresModifies": "criteria changed",
  "lecture.criteresN": "Criteria ({{n}})",
  "lecture.criteresRetires": "criteria removed",
  "lecture.criteresSansExigence": "Criteria without a requirement: {{n}}",
  "lecture.enTete": "Document header",
  "lecture.epic": "Epic",
  "lecture.etantDonne": "Given",
  "lecture.exigences": "Requirements",
  "lecture.exigencesAjoutees": "requirements added",
  "lecture.exigencesModifiees": "requirements changed",
  "lecture.exigencesN": "Requirements ({{n}})",
  "lecture.exigencesRetirees": "requirements removed",
  "lecture.ficheTechnique": "Technical sheet (provenance, machine references, AI instructions)",
  "lecture.introuvable": "{{c}} not found",
  "lecture.langueDifferente": "{{n}} of {{total}} title(s) seem written in a language other than the project's (automatic hint).",
  "lecture.lignesMachine": "Verification examples (machine lines)",
  "lecture.modifiee": "Changed",
  "lecture.modifieeEn": "Changed in v{{n}}",
  "lecture.nCriteres": "{{n}} criterion(s)",
  "lecture.nouvelle": "New",
  "lecture.nouvelleEn": "New in v{{n}}",
  "lecture.origine.ia": "inferred by the AI",
  "lecture.origine.idee": "written in the idea",
  "lecture.quand": "When",
  "lecture.questionN": "Question {{n}}",
  "lecture.questionsN": "Open questions ({{n}})",
  "lecture.questionsOuvertes": "Open questions",
  "lecture.referencesIntrouvables": "references not found: {{l}}",
  "lecture.registre.metier": "Reading",
  "lecture.registre.technique": "Raw text",
  "lecture.reglesBesoin": "Rules of the need",
  "lecture.reglesBesoinN": "Rules of the need ({{n}})",
  "lecture.sansCritere": "No criterion verifies this requirement.",
  "lecture.sectionsAjoutees": "sections added",
  "lecture.sectionsModifiees": "sections changed",
  "lecture.sectionsRetirees": "sections removed",
  "lecture.sommaire": "Document outline",
  "lecture.titreGenere": "Generated title:",
  "lecture.tracabilite": "Traceability",
  "lecture.tracabiliteResume": "Each requirement and the criteria that verify it — {{c}} of {{n}} requirements covered.",
  "lecture.type.application": "Application",
  "lecture.type.autre": "Document",
  "lecture.type.backlog": "Backlog",
  "lecture.type.cadrage": "Framing",
  "lecture.type.idee": "Idea",
  "lecture.type.options": "Options",
  "lecture.type.personas": "Personas",
  "lecture.type.processus": "Processes",
  "lecture.type.specification": "Specification",
  "lecture.verifie": "Verifies",
  "lecture.verifieePar": "Verified by",
  "nav.decisionsPourMoi": "{{n}} decision(s) for you to make",
  "review.openDecisionPage": "Open the decision page",
  "decisions.etape.qualityCheckDone": "Quality check",
  "points.etat.ouverteBloquante": "Open · blocking",
  "points.etat.ouverte": "Open",
  "points.etat.reporteeSpec": "Deferred to the specification",
  "points.etat.reportee": "Deferred ({{etape}})",
  "points.etat.repondueTransmise": "Answered — sent to the AI",
  "points.etat.repondue": "Answered — will be sent with the next version",
  "points.etat.aVerifier": "To check in the new version",
  "points.etat.integree": "Integrated",
  "points.etat.sansObjet": "Not applicable",
  "points.etape.backlog": "backlog",
  "points.etape.application": "application",
  "points.etape.specification": "specification",
  "points.doc.cadrage": "the framing",
  "points.doc.specification": "the specification",
  "points.doc.document": "the document",
  "points.origine.cadrage": "Asked by the AI in {{doc}}{{v}} — “Open questions”.",
  "points.origine.spec": "Blocking point raised by the AI in {{doc}}{{v}}.",
  "points.origine.humain": "Added by {{qui}} on {{date}}.",
  "points.origine.ia": "Asked by the AI.",
  "points.evt.created": "asked",
  "points.evt.raisedAgain": "asked again by a new version",
  "points.evt.blocking": "became blocking",
  "points.evt.answered": "answered",
  "points.evt.answerChanged": "answer changed",
  "points.evt.deferred": "deferred",
  "points.evt.reposed": "asked again at the planned stage",
  "points.evt.notApplicable": "marked not applicable",
  "points.evt.reopened": "reopened",
  "points.evt.sent": "sent to the AI",
  "points.evt.versionProduced": "new version produced",
  "points.evt.integrated": "integrated (checked)",
  "points.evt.notFound": "not found — reopened",
  "points.evt.linked": "linked",
  "points.erreur.conflit": "Someone else changed this point while you were typing: it has just been reloaded. Your text is kept.",
  "points.erreur.generique": "Saving failed. Your input is kept; try again.",
  "points.statut.enregistre": "{{code}}: {{etat}}.",
  "points.relanceDe": "Follow-up of {{code}}.",
  "points.avis": "opinion — does not decide",
  "points.suggestion": "Looks like {{code}}: same question?",
  "points.confirmerRattachement": "Confirm the link to {{code}}",
  "points.propositionRetenue": "AI proposal kept",
  "points.reporteeTexte": "It will be asked again at the “{{etape}}” stage.",
  "points.motifSansObjet": "Reason:",
  "points.verifiePar": "Checked by {{qui}} on {{date}}",
  "points.aVerifierTexte": "A new version was produced with this answer. A person must confirm it is there — the AI never ticks this.",
  "points.refs": "Where is it? (e.g. REQ-11, C-12 — optional)",
  "points.retrouvee": "Found in the version",
  "points.nonRetrouvee": "Not found — reopen",
  "points.verifAutre": "You wrote this answer: another project member will check that it was integrated.",
  "points.verifLecture": "A member who can act will check that it was integrated.",
  "points.votreReponse": "Your answer",
  "points.aideReponse": "Your answer is saved under your name and sent to the AI as data with the next version. {{n}} / 2,000 characters.",
  "points.motifObligatoire": "Reason (required)",
  "points.motifRouvrir": "Reason for reopening",
  "points.reponseVide": "Write an answer before saving it.",
  "points.enregistrer": "Save the answer",
  "points.annuler": "Cancel",
  "points.motifRequis": "A reason is required to mark a point not applicable.",
  "points.motifRequisRouvrir": "A reason is required to reopen a not-applicable point.",
  "points.confirmerSansObjet": "Mark not applicable",
  "points.confirmerRouvrir": "Reopen",
  "points.modifier": "Change the answer",
  "points.repondre": "Answer",
  "points.reporter": "Defer to the specification",
  "points.sansObjet": "Not applicable…",
  "points.rouvrir": "Reopen…",
  "points.historique": "History ({{n}})",
  "points.acteur.ia": "AI",
  "points.acteur.systeme": "Platform",
  "points.erreurLecture": "The open points could not be read.",
  "points.sansDemande": "This document is not attached to any request: it has no open points.",
  "points.intro": "Unclear areas become questions — never assumptions. Each answer is saved under your name and sent to the next version as data.",
  "points.nouvelleQuestion": "New question",
  "points.questionVide": "Write the question.",
  "points.ajouter": "Add the question",
  "points.ajouterQuestion": "Add a question",
  "points.lectureSeule": "Your role lets you read the points, not answer them.",
  "points.vide": "No questions: the AI found no unclear area.",
  "points.compte.ouvertes": "Open",
  "points.compte.reportees": "Deferred",
  "points.compte.repondues": "Answered",
  "points.compte.aVerifier": "To check",
  "points.compte.integrees": "Integrated",
  "points.compte.sansObjet": "Not applicable",
  "points.compte.titre": "Open points by status",
  "points.compte.etat": "Status",
  "points.compte.nombre": "Count",
  "echanges.doc.cadrage": "the framing",
  "echanges.doc.specification": "the specification",
  "echanges.doc.document": "the document",
  "echanges.idee": "Idea submitted",
  "echanges.versionIA": "Wrote",
  "echanges.versionHumaine": "Edited",
  "echanges.remplacee": "since replaced",
  "echanges.consigne": "Additional instruction",
  "echanges.bloquant": "blocking",
  "echanges.relecture": "Review",
  "echanges.approuve": "Approved",
  "echanges.rejete": "Rejected",
  "echanges.controle": "Quality check",
  "echanges.reussi": "passed",
  "echanges.corrections": "corrections needed",
  "echanges.score": "score {{s}} (opinion — does not decide)",
  "echanges.reponseModifiee": "answer changed",
  "echanges.reponse": "answer",
  "echanges.repondue": "answered",
  "echanges.reporte": "Deferred {{code}} to the specification",
  "echanges.sansObjet": "not applicable",
  "echanges.rouvert": "Reopened {{code}}",
  "echanges.repose": "{{code}} is asked again: the specification stage has started.",
  "echanges.devenuBloquant": "{{code}} is raised again as a blocking point of the specification.",
  "echanges.transmis": "Requested a new version with the answers to {{codes}} ({{n}} characters sent as data).",
  "echanges.produite": "New version produced with the answer to {{code}}: to be checked by a person.",
  "echanges.voirVersion": "See the version",
  "echanges.integre": "Checked {{code}}: found in the version",
  "echanges.integree": "integrated",
  "echanges.nonRetrouve": "The answer to {{code}} was not found in the version: reopened.",
  "echanges.rattache": "Linked {{code}} to {{cible}}.",
  "echanges.ajoute": "Added the question {{code}}: “{{q}}”",
  "echanges.filtre.tout": "All",
  "echanges.filtre.questions": "Questions",
  "echanges.filtre.reponses": "Answers and decisions",
  "echanges.filtre.versions": "Versions",
  "echanges.filtres": "Filter the thread",
  "echanges.vide": "Nothing in this filter yet.",
  "echanges.liste": "Exchanges, oldest first",
  "echanges.acteur.ia": "AI",
  "echanges.acteur.systeme": "Automatic check",
  "echanges.acteur.personne": "A person",
  "echanges.introuvable": "This request does not exist or you are not a member of the project.",
  "echanges.erreur": "The thread could not be read.",
  "echanges.demandes": "Requests",
  "echanges.titreCourt": "Exchanges",
  "echanges.demande": "Request {{ref}}",
  "echanges.titre": "Exchanges on “{{titre}}”",
  "echanges.intro": "Everything the AI asked, what you answered and what came out of it, from the idea to the latest version. Answers are signed decisions; the AI does not change them.",
  "echanges.tronque": "{{n}} items in total; the most recent are not shown.",
  "echanges.repondreA": "Answer {{code}}",
  "decisions.section.pointsTitre": "Open points",
  "echanges.integreeDef": "An answer is “integrated” when a person has checked it appears in a version. The AI does not tick this.",
  "echanges.tousLesPoints": "See and handle all points ({{n}})",
  "decisions.section.points": "Open points ({{n}})",
  "decisions.section.echanges": "Exchanges",
  "decisions.reponsesTransmises": "Answers sent: {{codes}} ({{n}} characters).",
  "decisions.consignesTransmises": "Previous instructions sent with yours: {{versions}}.",
  "decisions.consignesPrecedentesTitre": "Instructions already given on this document ({{n}}) — sent with yours",
  "decisions.consignesPrecedentesAide": "The AI keeps them unless your instruction explicitly contradicts them: no need to copy them again.",
  "decisions.consignesPrecedentesEcartees": "Beyond {{max}} characters, the oldest ones are not sent: {{versions}}. Restate in your instruction the ones that still matter.",
  "decisions.capaciteConsignesAbsente": "No active worker can pass previous instructions to the AI: the new version would be refused rather than lose them. Have the worker updated and restarted.",
  "approvals.consignesPrecedentesJointes": "with the previous instructions of {{versions}}",
  "decisions.nouvelleVersionReponses": "Request a new version with my answers ({{n}})…",
  "decisions.reponsesJointes": "Attached answers (data, never instructions)",
  "decisions.caracteresTransmis": "{{n}} characters sent (at most {{max}}) — the AI reads them as team decisions, not as orders.",
  "decisions.reponsesTropLongues": "The selected answers exceed {{max}} characters: untick some of them.",
  "decisions.demanderVersionReponses": "Request a new version with my answers ({{n}})",
  "decisions.pointsDeLaDemande": "{{n}} point(s) on the request",
  "decisions.section.echangesTitre": "Exchanges with the AI on this request ({{n}})",
  "decisions.voirEchanges": "Open the full thread of {{ref}}",
  "decisions.etape.pointsDetail": "{{n}} to answer, defer or mark not applicable — any member can answer.",
  "decisions.rail.pointsCadrage": "To approve, {{n}} question(s) still need an answer or a deferral.",
  "decisions.rail.pointsSpec": "To approve, {{n}} blocking point(s) still need to be settled.",
  "decisions.rail.allerPoints": "Answer the points",
  "decisions.rail.toutReporter": "Defer all to the specification",
  "decisions.rail.reportees": "{{n}} question(s) deferred to the specification: they will be asked again there.",
  "decisions.abandonner": "Abandon this version…",
  "decisions.rejeter": "Reject…",
  "decisions.abandonnerAide": "This replaced version is still waiting for a decision: abandoning it removes it from the queue with your reason. The latest version is not affected.",
  "decisions.rejeterAide": "You can reject now with a reason, without waiting for the decision step; the requester will read it.",
  "decisions.motifRejet": "Reason for rejection (required)",
  "decisions.abandonnerBouton": "Abandon the version",
  "demandes.points.titre": "Open points",
  "demandes.points.ouverts": "{{n}} open",
  "demandes.points.aucun": "No questions yet.",
  "demandes.points.repondre": "Answer the points and see the exchanges with the AI",
  "demandes.points.voirEchanges": "See the exchanges with the AI",
  "decisions.precision.pointsCadrage": "{{n}} question(s) to answer or defer",
  "decisions.precision.pointsSpec": "{{n}} blocking point(s) open",
  "decisions.etape.points": "Open points",
  "decisions.verbe.repondre": "Answer the points",
  "decisions.motif.cadragePoints": "Some framing questions have neither an answer nor a deferral: answer them or defer them to the specification before any approval.",
  "decisions.motif.specPoints": "Some blocking points are still open: answer them or mark them not applicable before any approval.",
  "echanges.questionsPosees2": "Asked {{n}} question(s):",
  "demandes.livraisons.aucune": "No release containing an item of this request has been successfully deployed yet.",
  "demandes.livraisons.horsProd": "non-production stage",
  "demandes.livraisons.manque": "Not delivered yet: none of these deployments is on a production stage or covered by a granted business acceptance.",
  "demandes.livraisons.prod": "production stage",
  "demandes.livraisons.prodDeduite": "production stage (inferred, not declared)",
  "demandes.livraisons.recetteNon": "business acceptance not granted",
  "demandes.livraisons.recetteOk": "business acceptance granted",
  "demandes.livraisons.sur": "deployed to {{p}}",
  "demandes.livraisons.titre": "Delivery",
  "palier.type.deduitHorsProduction": "non-production (inferred, to declare)",
  "palier.type.deduitProduction": "production (inferred, to declare)",
  "palier.type.horsProduction": "non-production",
  "palier.type.production": "production",
  "runops.productionAide": "Production: used by real customers (two-person approval, go-live by the sponsor). Non-production: dev, acceptance, pre-production. Can be changed later; the change is audited.",
  "runops.productionChoisir": "— Choose the type —",
  "runops.productionCorrection": "Changing the type changes the approval mode and the “Delivered” state of requests; the change is recorded in the audit log.",
  "backlog.testsCriteresParent": "A task carries no criteria: the tests will cover the criteria of its story “{{s}}”.",
  "backlog.testsSansCriteresStory": "This story has no acceptance criteria yet: add some, otherwise test design will be refused.",
  "backlog.testsSansCriteresItem": "This item has no acceptance criteria and no parent story: test design will be refused.",
  "backlog.provenance.expired": "The Spec Gate evidence of specification #{{id}} expired on {{date}}: a receipt is valid for 24 h. To attach the story to this epic, re-evaluate the specification, then attach the renewed evidence (an owner or contributor other than its requester). Otherwise, choose “None” as the parent epic.",
  "backlog.provenance.superseded": "Specification #{{id}} of this epic has been replaced by a newer version: choose an epic of the current version, or “None” as the parent epic.",
  "backlog.provenance.other": "This epic’s specification has no current Spec Gate evidence: complete its approval and evidence, or choose “None” as the parent epic.",
  "backlog.provenance.link": "Open specification #{{id}}",
  "planFiche.aucunCasAideGeste": "Tick one or more of the project's cases, then attach them in one go.",
  "planFiche.aucunCasAideLecture": "Cases are attached by a member who can write in the project.",
  "planFiche.rattacherAucun": "All active cases of the project are already in this plan.",
  "planFiche.rattacherBilan": "{{n}} case(s) attached to the plan.",
  "planFiche.rattacherChargement": "Loading the project's cases…",
  "planFiche.rattacherEnCours": "Attaching…",
  "planFiche.rattacherFermer": "Close",
  "planFiche.rattacherLegende": "Project cases not in this plan ({{n}})",
  "planFiche.rattacherN": "Attach {{n}} case(s)",
  "planFiche.rattacherOuvrir": "Attach cases",
  "planFiche.rattacherTous": "Select all",
  "planFiche.rattacherAucunChoisi": "Tick at least one case to attach.",
  "membres.colRecette": "run an acceptance test",
  "membres.gestionChargement": "Loading member management…",
  "membres.gestionErreur": "Member management could not be loaded.",
  "membres.gestionTitre": "Manage members, invitations and member permissions",
  "membres.recetteNon": "no",
  "membres.recetteOui": "yes",
  "membres.recettePersonne": "Nobody holds the “run an acceptance test” permission yet: only a project owner or the organisation’s administration can grant it, right here.",
  "points.attenteVersion": "Sent to the AI: verification will open once the new version is produced.",
  "points.dejaIntegree": "Already in this version",
  "points.refsObligatoires": "Where is it found in this version? (required, e.g. REQ-04, § Contracts)",
  "points.refsRequises": "Say where the answer is already found in this version: without a new version, that is the only proof it is integrated.",
  "points.verifCouranteAuteur": "You wrote this answer: another project member can confirm it is already in this version.",
  "points.verifCouranteDecision": "To confirm it is already in a version, open that version’s decision.",
  "points.versionCouranteTexte": "It will be sent with the next requested version. If this version already contains it, another project member can confirm it, without a new version.",
  "reglages.versMembres": "Members, invitations, teams and the “run an acceptance test” permission:",
  "reglages.versMembresLien": "Project members",
  "verifier.recetteDemanderPermission": "Only a project owner or the organisation’s administration can grant it.",
  "verifier.recetteDetenteurs": "Holding this permission: {{noms}}.",
  "verifier.recetteDonnerPermission": "Grant the “run an acceptance test” permission (Project members)",
  "verifier.recettePersonne": "Nobody holds this permission in this project yet.",
  "decisions.versionRemplaceeAbandon": "It is still awaiting a decision: you can only abandon it.",
  "decisions.versionRemplaceeEnCours": "Superseded version — the new version is being produced",
  "decisions.versionRemplaceeTexte": "This page is read-only: a superseded version is no longer decided, regenerated or edited.",
  "decisions.versionRemplaceeTitre": "Superseded version — see version {{n}}",
  "decisions.voirVersionCourante": "Open version {{n}} (current)",
  "baseline.sansObjet": "Not applicable to the selected stack ({{pile}})",
  "baseline.sansObjetCourt": "not applicable",
  "decisions.capaciteReponsesAbsente": "No active worker can pass your answers to the AI: the new version would contain none of them. Have the worker updated and restarted, or untick the answers to relaunch with the instruction only.",
  "decisions.section.pointsCompte": "Open points ({{n}} to handle / {{total}})",
  "decisions.section.pointsCompteAria": "Open points: {{n}} to handle out of {{total}} point(s) on the request",
  "job.artifactWritten.analysis": "Repository analysis written",
  "job.artifactWritten.app": "Application report written",
  "job.artifactWritten.backlog": "Backlog written",
  "job.artifactWritten.change": "Change written",
  "job.artifactWritten.framing": "Framing written",
  "job.artifactWritten.options": "Options written",
  "job.artifactWritten.other": "Artifact written",
  "job.artifactWritten.personas": "Personas written",
  "job.artifactWritten.processes": "Processes written",
  "job.artifactWritten.review": "Code review written",
  "job.artifactWritten.tests": "Test design written",
  "points.editionManuelleTexte": "A manual edit (version {{n}}) followed this answer: it is the next version, the answer will not be sent to the AI. Another project member confirms it is reflected there, citing where.",
  "points.etat.repondueEditee": "Answered — to verify in v{{n}} (manual edit)",
  "points.retrouveeDansVersion": "Found in version {{n}}",
  "revision.origin.mission": "mission “{{title}}”",
  "revision.origin.missionUntitled": "mission",
  "revision.origin.fixes": "fixes {{refs}}",
  "revision.origin.generation": "generation",
  "apercu.identity.base": "base {{base}}",
  "versions.replacesBase": "This revision fixes revision {{base}}, already included: remove it — a version deploys a single revision.",
  "cas.attendu": "Expected result",
  "cas.criteres": "Covered criteria",
  "cas.criteresAide": "Comma-separated, for example: C-04, C-12.",
  "cas.identiteAide": "Name, expected result and covered criteria: a name that cites a requirement (REQ-nn) proves it in the user guide.",
  "cas.identiteEnregistree": "Case updated",
  "cas.identiteModifier": "Edit the name, expected result and criteria",
  "cas.identiteTitre": "Case identity",
  "cas.nom": "Case name",
  "cas.nomObligatoire": "The case name is required.",
  "cas.statut.active": "active",
  "cas.statut.deprecated": "deprecated",
  "cas.statut.draft": "draft",
  "cas.type.e2e": "end-to-end",
  "cas.type.functional": "functional",
  "cas.type.integration": "integration",
  "cas.type.manual": "manual",
  "cas.type.unit": "unit",
  "job.generatedTestsFailedN": "{{n}} failed",
  "job.generatedTestsNotCovered": "not run for this stack (not covered)",
  "job.generatedTestsPassedN": "{{n}} passed",
  "versions.key.requirements_proven": "Proven specification requirements",
  "versions.key.pipeline": "Revision pipeline",
  "livrer.objet.publication": "revision {{quoi}} · {{etat}}",
  "livrer.publication.nonPubliee": "not published",
  "livrer.publication.echouee": "publication failed",
  "livrer.publication.demandee": "publication requested",
  "livrer.publication.enCours": "publication in progress",
  "livrer.publication.sansPipeline": "no pipeline",
  "livrer.publication.nonRelu": "not re-read from GitLab",
  "livrer.objet.exigenceDeclaree": "{{quoi}} (declared)",
  "livrer.objet.exigenceProuvee": "{{quoi}} (proven)",
  "livrer.objet.exigenceEnEchec_one": "{{quoi}} (declared, {{n}} failing case)",
  "livrer.objet.exigenceEnEchec_other": "{{quoi}} (declared, {{n}} failing cases)",
  "versions.code.REQUIREMENTS_NO_REVISION": "No revision: no specification requirement to prove",
  "versions.code.REQUIREMENTS_NOT_PROVEN": "Some specification requirements are not proven by a passed case",
  "versions.code.REQUIREMENTS_SOURCE_MISSING": "Source specification not found for a revision: its requirements are not verified",
  "versions.code.REQUIREMENTS_NOT_FOUND": "No readable REQ-xx requirement in the source specification: nothing is proven",
  "versions.code.REQUIREMENTS_PROVEN": "Specification requirements proven",
  "versions.code.PIPELINE_NO_REVISION": "No revision: no pipeline expected",
  "versions.code.PIPELINE_RED": "A pipeline is red: blocking unless a signed waiver (14 days at most from its signature) covers it, on a project requirement whose control is ci_pipeline_green",
  "versions.code.PIPELINE_MISSING": "A revision has no pipeline (not published, publication failed or pipeline missing): blocking unless a signed waiver (14 days at most from its signature) covers it, on a project requirement whose control is ci_pipeline_green",
  "versions.code.PIPELINE_RUNNING": "A publication or pipeline is still running: its result is awaited",
  "versions.code.PIPELINE_WAIVED": "Pipeline red or missing, under a signed waiver in force",
  "versions.code.PIPELINE_GREEN": "Pipeline green",
  "livrer.objet.derogationEcartee": "{{code}} · waiver set aside: {{jours}} days of validity, {{max}} at most",
  "livrer.objet.derogationEcheance": "{{code}} · expires {{date}}",
  "membres.demandesRefusAdministration": "Only a project owner or the organisation’s administration decides access requests.",
  "decisions.rail.nonVerifiesTitre": "Unverified blocking points",
  "decisions.rail.nonVerifiesTexte": "{{codes}}: the answers to these points have not yet been verified in a version of the document. These points do not block approval: if you approve, the decision will be recorded with this warning.",
  "decisions.rail.nonVerifiesTexte_one": "{{codes}}: the answer to this point has not yet been verified in a version of the document. This point does not block approval: if you approve, the decision will be recorded with this warning.",
  "decisions.rail.nonVerifiesTexte_other": "{{codes}}: the answers to these points have not yet been verified in a version of the document. These points do not block approval: if you approve, the decision will be recorded with this warning.",
  "decisions.rail.nonVerifiesLien": "Verify these points",
  "membres.demandesVideIndiceAdministration": "Someone in the organisation who opens this project without being a member can request access; the request appears here and on the administration home.",
  "accueil.dev.type.generateFeatures": "Feature generation",
  "accueil.dev.type.generateStories": "User story generation",
  "accueil.dev.type.generateTasks": "Task generation",
  "accueil.dev.type.generateChildren": "Child item generation",
  "accueil.dev.type.runWorkflow": "Workflow run",
  "accueil.dev.type.analyzeRepository": "Repository analysis",
  "accueil.dev.type.implementChange": "Change implementation",
  "accueil.dev.type.designTests": "Test design",
  "accueil.dev.type.codeReview": "Code review",
  "accueil.dev.type.compareModels": "Model comparison",
  "accueil.dev.type.runPipeline": "Pipeline run",
  "accueil.dev.type.runTestCampaign": "Test campaign run",
  "accueil.dev.type.deployDocker": "Deployment",
  "accueil.dev.type.rollbackDocker": "Rollback to the previous version",
  "accueil.dev.type.runMcp": "MCP server run",
  "accueil.dev.type.publishAppRevision": "Revision publication to GitLab",
  "accueil.dev.type.planSprints": "Sprint planning",
  "accueil.dev.type.planMission": "Mission planning",
  "accueil.dev.type.runMission": "Mission step",
  "accueil.dev.type.buildSignRevision": "Revision build and signing",
  "accueil.dev.type.startPreview": "Preview start",
  "accueil.dev.type.stopPreview": "Preview stop",
  "accueil.dev.type.restartPreview": "Preview restart",
  "accueil.dev.echec.workerPerdu": "The worker running this job no longer responds: run the job again from the history.",
  "accueil.dev.echec.sansCause": "Failed; the worker reported no cause.",
  "accueil.dev.echec.sujetVide": "The mission subject has nothing to execute: every item is done, or only containers remain.",
  "accueil.dev.echec.provenance": "Refused ({{gate}}): the source specification has no current human-verified evidence; renew it, then run the job again.",
  "accueil.dev.echec.registreRefuse": "The revision registry refused to record this revision.",
  "accueil.dev.echec.testsLivres": "Application refused: some of the tests delivered with it fail.",
  "accueil.dev.echec.voirDetail": "The job failed: the cause is in the technical detail.",
  "accueil.dev.echec.code": "Failed (code {{code}})",
  "accueil.dev.echec.traitement": "Job",
  "activation.lienIncomplet": "This activation link is incomplete: it carries no token. Open the full link you received by email, or ask the administration that sent it for a new one.",
  "nonMembre.introuvableDescription": "No project in your organisation has the identifier {{id}}: the link is wrong or outdated, or it points to a project of another organisation.",
  "nonMembre.introuvableTitre": "This project cannot be found in your organisation",
  "nonMembre.descriptionNeutre": "You have no role in project {{id}}: its content is not shown to you. If it belongs to your organisation, you can ask its owners for access.",
  "nonMembre.adminArchive": "This project is archived: it cannot be joined.",
  "shell.basculerPanneau": "Collapse or expand the panel",
  "shell.panneauDescription": "Navigation panel opened from the rail. Escape closes it.",
  "shell.tiroirDescription": "Full-screen navigation drawer. Escape closes it and returns focus to the Menu button.",
  "tree.collapse": "Collapse",
  "tree.expand": "Expand",
  "app.versionDeployee": "Deployed version {{version}}",
  "app.versionDeployeeLe": "Deployed version {{version}} — deployed on {{date}}",
  "lifecycleRail.aria": "Lifecycle stages",
  "pipelines.stageNameAria": "Stage {{numero}} name",
  "pipelines.stageCommandAria": "Stage {{numero}} command",
  "user.navModeAfficherTout": "Show all entries",
  "user.navModeEssentiel": "Back to the essentials",
  "user.navModeMasquees": "{{n}} hidden entries",
  "user.navModeConflitEssentiel": "Another device chose “essentials” in the meantime.",
  "user.navModeConflitToutAfficher": "Another device chose “show all” in the meantime.",
  "user.navModeConflitUtiliser": "Use this value",
  "ecriture.refus.administrateurPlateforme": "Platform administrator: this account administers the platform but does not write in projects (create a project, validate, approve). Sign in with an owner or contributor account.",
  "ecriture.refus.lectureSeule": "Read-only: your role does not allow this action. An owner or a contributor can do it.",
  "savedFilters.selectAria": "Saved filter",
  "feedback.pageTitle": "Feedback",
  "feedback.noteSur5": "Rating {{note}} out of 5",
  "history.pageDescriptionDetail": "All the workspace's past work — every job, its status and the replayable details of its processing. Nothing that has been produced is lost from sight.",
  "history.detailTraitement": "Processing details",
  "history.detailTraitementDuJob": "Processing details for job {{job}}",
  "chat.sansProjet": "No project selected",
  "chat.sansProjetAide": "The assistant answers in the context of a project.",
  "compare.sansProjet": "No project selected",
  "compare.sansProjetAide": "A comparison runs on a project's allowed models and is kept there.",
  "ingestion.deleteConsequence": "The document and its indexed extracts are removed from the knowledge base: later answers will no longer be able to cite it.",
  "ingestion.deleteReversibilite": "To get it back, you will have to upload it again.",
  "ingestion.deleteVerb": "Delete the document",
  "ingestion.sansProjet": "No project selected",
  "ingestion.sansProjetAide": "Ingested documents and the knowledge base belong to a project.",
  "notif.sansProjet": "No project selected",
  "notif.sansProjetAide": "Notifications belong to a project.",
  "processView.chargement": "Loading the process…",
  "processView.etapesCycle": "Lifecycle steps",
  "workflow.sansProjetAide": "A custom agent runs on a project: its allowed agents, purposes and models.",
  "decisions.adresseInvalide": "Invalid address: a decision number is expected.",
  "echanges.adresseInvalide": "Invalid address: a request number is expected.",
  "echanges.retourDemandes": "Back to requests",
  "cycle.entite.organisations": "Organisation",
  "cycle.entite.programs": "Programmes",
  "cycle.entite.program_members": "Programme members",
  "cycle.entite.program_risks": "Programme risks",
  "cycle.entite.users": "Users",
  "cycle.entite.workspaces": "Projects",
  "cycle.entite.workspace_members": "Project members",
  "cycle.entite.workspace_teams": "Project teams",
  "cycle.entite.workspace_team_members": "Team members",
  "cycle.entite.workspace_invitations": "Project invitations",
  "cycle.entite.workspace_access_requests": "Project access requests",
  "cycle.entite.workspace_dependencies": "Dependencies between projects",
  "cycle.entite.workspace_allowed_agents": "Agents allowed in the project",
  "cycle.entite.workspace_allowed_models": "Models allowed in the project",
  "cycle.entite.organisation_invitations": "Organisation invitations",
  "cycle.entite.role_delegations": "Role delegations",
  "cycle.entite.backlog_items": "Backlog items",
  "cycle.entite.backlog_item_merges": "Item merges",
  "cycle.entite.item_comments": "Item comments",
  "cycle.entite.item_labels": "Labels applied to items",
  "cycle.entite.item_links": "Links between items",
  "cycle.entite.item_attachments": "Item attachments",
  "cycle.entite.item_status_history": "Item status history",
  "cycle.entite.labels": "Labels",
  "cycle.entite.components": "Components",
  "cycle.entite.saved_filters": "Saved filters",
  "cycle.entite.sprints": "Sprints",
  "cycle.entite.sprint_reviews": "Sprint reviews",
  "cycle.entite.sprint_carryovers": "Sprint carry-overs",
  "cycle.entite.sprint_daily_snapshots": "Daily sprint snapshots",
  "cycle.entite.demands": "Requests",
  "cycle.entite.demand_points": "Request points",
  "cycle.entite.approvals": "Approvals",
  "cycle.entite.approval_artifacts": "Supporting artifacts of approvals",
  "cycle.entite.artifact_versions": "Artifact versions",
  "cycle.entite.artifact_receipts": "Artifact receipts",
  "cycle.entite.waivers": "Waivers",
  "cycle.entite.adrs": "Architecture decisions",
  "cycle.entite.missions": "Missions",
  "cycle.entite.mission_tasks": "Mission tasks",
  "cycle.entite.mission_events": "Mission events",
  "cycle.entite.notifications": "Notifications",
  "cycle.entite.feedback": "Feedback on generations",
  "cycle.entite.documents": "Ingested documents",
  "cycle.entite.agents": "Agents",
  "cycle.entite.test_cases": "Test cases",
  "cycle.entite.test_plans": "Test plans",
  "cycle.entite.test_campaigns": "Test campaigns",
  "cycle.entite.test_executions": "Test executions",
  "cycle.entite.test_results": "Test results",
  "cycle.entite.test_evidence": "Test evidence",
  "cycle.entite.releases": "Releases",
  "cycle.entite.release_contents": "Release contents",
  "cycle.entite.release_deployment_plans": "Planned production releases",
  "cycle.entite.deployment_freeze_windows": "Freeze periods",
  "cycle.entite.deployments": "Deployments",
  "cycle.entite.environments": "Environments",
  "cycle.entite.pipelines": "Pipelines",
  "cycle.entite.pipeline_runs": "Pipeline runs",
  "cycle.entite.production_incidents": "Production incidents",
  "cycle.entite.defects": "Defects",
  "cycle.entite.audit_log": "Audit log",
  "cycle.entite.audit_pseudonyms": "Audit log pseudonyms",
  "cycle.entite.data_lifecycle_operations": "Lifecycle operation receipts",
  "cycle.entite.lifecycle_deletion_requests": "Deletion requests",
  "cycle.entite.organisation_status_history": "Organisation status history",
  "cycle.entite.platform_exceptional_access": "Platform exceptional access",
  "cycle.entite.user_lifecycle_audit": "Account lifecycle audit",
  "cycle.entite.unknown_quarantine_evidence": "Unknown-quarantine evidence",
  "cycle.entite.unknown_quarantine_audit_sink": "Unknown-quarantine audit",
  "cycle.entite.object_purge_queue": "Object erasure queue",
  "cycle.entite.flyway_schema_history": "Migration history",
  "cycle.adresseInvalide": "Invalid address: a deletion request number is expected.",
  "design.comparison.introuvable": "Comparison not found",
  "design.comparison.introuvableAide": "This comparison does not exist in this project, or the project is not open to you.",
  "design.usability.introuvable": "Usability test not found",
  "design.usability.introuvableAide": "This usability test does not exist in this project, or the project is not open to you.",
  "calendrier.sansProjet": "The production release calendar belongs to a project.",
  "calendrier.planAdresseInvalide": "Invalid address: a planned production release number is expected.",
  "calendrier.gelAdresseInvalide": "Invalid address: a freeze period number is expected.",
  "fonA.deleg.moiSeul": "me",
  "fonA.deleg.adresseInvalide": "Invalid address: a delegation number is expected.",
  "fonA.fiche.adresseInvalide": "Invalid address: a purpose number is expected.",
  "fonA.exigence.adresseInvalide": "Invalid address: a requirement number is expected.",
  "cycle.entite.access_policies": "Access policies",
  "cycle.entite.access_decision_observations": "Observed access denials",
  "cycle.entite.role_permissions": "Role permissions",
  "cycle.entite.decision_raci": "Decision RACI assignments",
  "cycle.entite.workspace_permission_grants": "Permissions granted by name",
  "cycle.entite.organisation_auth_policies": "Authentication policy",
  "cycle.entite.organisation_session_starts": "Observed session starts",
  "cycle.entite.organisation_enrolments": "Administrator activation links",
  "cycle.entite.user_offboardings": "User offboardings",
  "cycle.entite.workspace_creation_requests": "Project creation requests",
  "cycle.entite.user_navigation_preferences": "User navigation modes",
  "cycle.entite.navigation_preferences": "Navigation modes per project",
  "cycle.entite.navigation_preference_commands": "Navigation mode changes",
  "cycle.entite.profile_preferences": "Home views per profile",
  "cycle.entite.notification_preferences": "Notification preferences",
  "cycle.entite.notification_digests": "Notification digests",
  "cycle.entite.notification_channels": "Notification channels",
  "cycle.entite.notification_delivery_outbox": "External notification delivery queue",
  "cycle.entite.ai_kill_switches": "AI emergency stops",
  "cycle.entite.ai_kill_switch_history": "AI emergency stop history",
  "cycle.entite.ai_model_grants": "Models allowed for the organisation",
  "cycle.entite.ai_processing_purposes": "AI processing purposes",
  "cycle.entite.ai_subject_consents": "Consents to AI purposes",
  "cycle.entite.ai_provider_connections": "AI provider connections",
  "cycle.entite.ai_provider_connection_grants": "Provider connection activations",
  "cycle.entite.ai_tool_execution_requests": "Tool execution requests",
  "cycle.entite.ai_tool_execution_receipts": "Tool execution receipts",
  "cycle.entite.mcp_server_packages": "MCP server packages",
  "cycle.entite.mcp_server_agent_bindings": "MCP server and agent bindings",
  "cycle.entite.models": "Registered AI models",
  "cycle.entite.model_comparisons": "Model comparisons",
  "cycle.entite.agent_execution_status": "Agent run states",
  "cycle.entite.feedback_evaluations": "Evaluations of generation feedback",
  "cycle.entite.api_requests": "Logged API requests",
  "cycle.entite.quotas": "Quotas",
  "cycle.entite.quota_reservations": "Quota reservations",
  "cycle.entite.usage_ledger": "Daily usage records",
  "cycle.entite.organisation_plans": "Organisation plan",
  "cycle.entite.organisation_plan_history": "Plan history",
  "cycle.entite.tenant_retention_policy": "Retention policy",
  "cycle.entite.vector_store_retention": "Document vector retention",
  "cycle.entite.file_artifact_retention": "File artifact retention",
  "cycle.entite.export_requests": "Governed export requests",
  "cycle.entite.config_templates": "Configuration templates",
  "cycle.entite.config_template_versions": "Published template versions",
  "cycle.entite.template_migrations": "Template migrations",
  "cycle.entite.process_runs": "Process runs",
  "cycle.entite.process_action_runs": "Process action runs",
  "cycle.entite.project_governance": "Project inheritance mode",
  "cycle.entite.project_launch_drafts": "Project launch draft",
  "cycle.entite.workspace_wip_limits": "Work-in-progress limits",
  "cycle.entite.taxonomy_axes": "Attachment axes",
  "cycle.entite.item_axes": "Item attachments to axes",
  "cycle.entite.versions": "Fix versions",
  "cycle.entite.org_requirements": "Organisation requirements",
  "cycle.entite.scope_requirements": "Programme and project requirements",
  "cycle.entite.org_governance_settings": "Organisation governance settings",
  "cycle.entite.org_rule_observations": "Organisation rule measurements",
  "cycle.entite.org_rule_stage_decisions": "Rule stage changes",
  "cycle.entite.org_golden_path_versions": "Golden path versions",
  "cycle.entite.program_initiative_objectives": "Programme initiative objectives",
  "cycle.entite.spec_change_requests": "Specification change requests",
  "cycle.entite.spec_gate_receipts": "Spec Gate receipts",
  "cycle.entite.spec_gate_receipt_renewals": "Spec Gate receipt renewals",
  "cycle.entite.approval_publication_effects": "Approval publication effects",
  "cycle.entite.demand_links": "Request links",
  "cycle.entite.demand_point_events": "Request point events",
  "cycle.entite.demand_point_extractions": "Point extractions from approvals",
  "cycle.entite.technology_categories": "Technology categories",
  "cycle.entite.technology_baseline_versions": "Technology baseline versions",
  "cycle.entite.technology_baseline_entries": "Technology baseline entries",
  "cycle.entite.technology_change_requests": "Technology change requests",
  "cycle.entite.technology_change_decisions": "Technology change decisions",
  "cycle.entite.technology_change_rework_items": "Technology change rework items",
  "cycle.entite.project_stack_profiles": "Project stack profile",
  "cycle.entite.adr_criteria": "Architecture decision criteria",
  "cycle.entite.adr_options": "Architecture decision options",
  "cycle.entite.adr_scores": "Architecture option scores",
  "cycle.entite.design_charters": "Project design charters",
  "cycle.entite.design_charter_overrides": "Organisation charter overrides",
  "cycle.entite.org_design_charters": "Organisation design charters",
  "cycle.entite.design_screen_flows": "Screen flows",
  "cycle.entite.design_wireframes": "Wireframes",
  "cycle.entite.design_comparisons": "Wireframe ↔ application comparisons",
  "cycle.entite.design_usability_checks": "Usability tests",
  "cycle.entite.preview_environments": "Preview environments",
  "cycle.entite.preview_annotations": "Preview annotations",
  "cycle.entite.preview_share_links": "Preview share links",
  "cycle.entite.test_plan_cases": "Test cases of plans",
  "cycle.entite.test_plan_versions": "Test plan versions",
  "cycle.entite.test_plan_version_cases": "Test cases of plan versions",
  "cycle.entite.test_execution_assignments": "Test case assignments",
  "cycle.entite.test_execution_steps": "Test execution steps",
  "cycle.entite.test_runs": "Test runs",
  "cycle.entite.regression_acceptances": "Regression acceptances",
  "cycle.entite.defect_execution_links": "Executions linked to defects",
  "cycle.entite.defect_lessons": "Lessons learned from defects",
  "cycle.entite.defect_transitions": "Defect transitions",
  "cycle.entite.app_instances": "Application instances",
  "cycle.entite.app_publications": "Application publications",
  "cycle.entite.app_repositories": "Application repositories",
  "cycle.entite.release_documents": "Delivery documents",
  "cycle.entite.release_environment_approvals": "Release approvals per environment",
  "cycle.entite.release_note_versions": "Release notes",
  "cycle.entite.revision_artefacts": "Signed revision artifacts",
  "cycle.entite.revision_lineage": "Revision lineage",
  "cycle.entite.revision_migrations": "Revision schema migrations",
  "cycle.entite.revision_vulnerability_scans": "Revision vulnerability scans",
  "cycle.entite.scm_connections": "Source control connections",
  "cycle.entite.scm_delivery_events": "Source control delivery events",
  "cycle.entite.scm_item_commits": "Item publication proofs",
  "cycle.entite.odoo_connections": "Odoo connections",
  "cycle.entite.public_webhooks": "Public webhooks",
  "cycle.entite.public_webhook_events": "Webhook events received",
  "cycle.entite.public_webhook_rejection_audit": "Webhook rejection audit",
  "cycle.entite.production_incident_actions": "Incident corrective actions",
  "cycle.entite.production_incident_defects": "Defects linked to incidents",
  "cycle.entite.production_incident_events": "Incident timelines",
  "cycle.entite.production_incident_postmortems": "Incident post-mortems",
  "cycle.entite.service_objectives": "Business service objectives",
  "cycle.entite.slo_catalog": "Service level objectives",
  "cycle.entite.slo_error_budgets": "Error budgets",
  "cycle.entite.deployment_slo_incidents": "Objective violations that triggered a rollback",
  "cycle.entite.jobs_outbox": "Job queue",
  "cycle.entite.job_events": "Job events",
  "cycle.entite.background_active_scopes": "Active background-processing scopes",
  "cycle.entite.background_scope_transitions": "Background scope transitions",
  "decisions.adresseInvalideTitre": "Decision",
  "echanges.adresseInvalideTitre": "Request exchanges",
  "fonA.exigence.adresseInvalideTitre": "Requirement",
  "fonA.fiche.adresseInvalideTitre": "Purpose",
  "fonA.deleg.adresseInvalideTitre": "Delegation",
  "cycle.adresseInvalideTitre": "Deletion request",
  "cycle.entite.ai_promotion_decisions": "Model and prompt promotion decisions",
  "cycle.entite.profils_organisation": "Organisation profiles",
  "cycle.entite.profils_organisation_versions": "Organisation profile versions",
  "cycle.entite.profils_organisation_version_droits": "Rights of each profile version",
  "cycle.entite.profils_organisation_version_contributeurs": "Contributors to each profile version",
  "cycle.entite.attributions_profils": "Profiles assigned to people",
  "cycle.entite.attributions_plateforme": "Assigned platform profiles",
  "cycle.entite.droits_isoles": "Individually granted rights",
  "cycle.entite.proprietes": "Owners of organisations, programmes and projects",
  "cycle.entite.repair_experiences": "Colony repair bank",
  "cycle.entite.trace_links": "Traceability links between objects",
  "cycle.entite.trace_link_retirements": "Traceability link retirements",
  "cycle.entite.appartenances_retirees": "Memberships removed on departure",
  "cycle.entite.demandes_invitation": "Invitation requests",
  "cycle.entite.designations_projet": "Project designations",
  "cycle.entite.exports_organisation": "Organisation exports",
  "missions.jobStatus.done": "done",
  "missions.jobStatus.failed": "failed",
  "missions.jobStatus.pending": "pending",
  "missions.jobStatus.processing": "in progress",
  "missions.jobStatus.unknown": "not found",
  "valeurs.execution.passed": "passed",
  "valeurs.execution.failed": "failed",
  "valeurs.execution.blocked": "blocked",
  "valeurs.execution.skipped": "skipped",
  "valeurs.execution.running": "running",
  "valeurs.plan.draft": "draft",
  "valeurs.plan.active": "active",
  "valeurs.plan.archived": "archived",
  "valeurs.versionPlan.draft": "draft",
  "valeurs.versionPlan.published": "published",
  "valeurs.versionPlan.archived": "archived",
  "valeurs.campagne.open": "open",
  "valeurs.campagne.closed": "closed",
  "valeurs.campagne.cancelled": "cancelled",
  "valeurs.deploiement.pending": "pending",
  "valeurs.deploiement.running": "running",
  "valeurs.deploiement.succeeded": "succeeded",
  "valeurs.deploiement.failed": "failed",
  "valeurs.deploiement.rolled_back": "rolled back",
  "valeurs.deploiement.stopped": "stopped",
  "valeurs.deploiement.cancelled": "cancelled",
  "valeurs.livraison.none": "none",
  "valeurs.livraison.in_progress": "in progress",
  "valeurs.livraison.succeeded": "succeeded",
  "valeurs.livraison.failed": "failed",
  "valeurs.livraison.opened": "opened",
  "valeurs.livraison.merged": "merged",
  "valeurs.livraison.closed": "closed",
  "valeurs.livraison.unknown": "unknown",
  "valeurs.sante.healthy": "healthy",
  "valeurs.sante.unhealthy": "unhealthy",
  "valeurs.sante.degraded": "degraded",
  "valeurs.sante.not_configured": "not configured",
  "valeurs.sante.unknown": "unknown",
  "valeurs.sonde.healthy": "healthy",
  "valeurs.sonde.unhealthy": "unhealthy",
  "valeurs.sonde.degraded": "degraded",
  "valeurs.sonde.not_configured": "not configured",
  "valeurs.sonde.unknown": "unknown",
  "valeurs.signature.signed": "signed",
  "valeurs.signature.verified": "verified",
  "valeurs.signature.unsigned": "unsigned",
  "valeurs.signature.unavailable": "unavailable",
  "valeurs.niveau.low": "low",
  "valeurs.niveau.medium": "medium",
  "valeurs.niveau.high": "high",
  "valeurs.niveau.critical": "critical",
  "valeurs.priorite.low": "low",
  "valeurs.priorite.medium": "medium",
  "valeurs.priorite.high": "high",
  "valeurs.priorite.critical": "critical",
  "valeurs.cible.docker": "Docker",
  "valeurs.politiqueImage.digest-pinned": "pinned by digest",
  "valeurs.politiqueImage.tag-allowed": "tag allowed",
  "valeurs.dureeVie.persistent": "persistent",
  "valeurs.dureeVie.ephemeral": "ephemeral",
  "valeurs.item.todo": "to do",
  "valeurs.item.in_progress": "in progress",
  "valeurs.item.in_review": "in review",
  "valeurs.item.done": "done",
  "valeurs.oui": "Yes",
  "valeurs.non": "No",
  "lecture.prioriteStory": "priority {{p}}",
  "admin.polConditionVide": "no condition: the rule always applies",
  "admin.polConditionEt": "and",
  "admin.operationsHealthEtat.healthy": "healthy",
  "admin.operationsHealthEtat.degraded": "degraded",
  "admin.operationsHealthEtat.unavailable": "unavailable",
  "journalAudit.actionRefusee": "Refusal recorded",
  "journalAudit.parPlateforme": "{{action}} (by the platform)",
  "journalAudit.detail": "Details",
  "journalAudit.paire": "{{cle}}: {{valeur}}",
  "journalAudit.vrai": "true",
  "journalAudit.faux": "false",
  "journalAudit.action.org.user.deactivated": "User deactivated",
  "journalAudit.action.org.user.reactivated": "User reactivated",
  "journalAudit.action.org.user.role_changed": "Organisation role changed",
  "journalAudit.action.org.user.access_reset": "Access reset",
  "journalAudit.action.org.user.access_reset_completed": "Access reset completed",
  "journalAudit.action.org.user.sessions_closed": "Sessions closed",
  "journalAudit.action.org.user.read": "User record viewed",
  "journalAudit.action.org.users.read": "Directory viewed",
  "journalAudit.action.org.invitation.created": "Invitation sent",
  "journalAudit.action.org.invitation.accepted": "Invitation accepted",
  "journalAudit.action.org.invitation.revoked": "Invitation revoked",
  "journalAudit.action.org.invitation.renewed": "Invitation renewed",
  "journalAudit.action.org.invitations.read": "Invitations viewed",
  "journalAudit.action.org.auth_policy.changed": "Sign-in policy changed",
  "journalAudit.action.org.auth_policy.mfa_applied": "Second factor enforced",
  "journalAudit.action.org.auth_policy.read": "Sign-in policy viewed",
  "journalAudit.action.org.profile.created": "Organisation profile created",
  "journalAudit.action.org.profile.duplicated": "Organisation profile duplicated",
  "journalAudit.action.org.profile.draft_saved": "Profile draft saved",
  "journalAudit.action.org.profile.draft_deleted": "Profile draft deleted",
  "journalAudit.action.org.profile.submitted": "Profile submitted for validation",
  "journalAudit.action.org.profile.withdrawn": "Profile withdrawn from validation",
  "journalAudit.action.org.profile.refused": "Profile refused",
  "journalAudit.action.org.profile.validated": "Profile validated",
  "journalAudit.action.org.profile.published": "Profile published",
  "journalAudit.action.org.profile.retired": "Organisation profile retired",
  "journalAudit.action.organisation.provisioned": "Organisation provisioned",
  "journalAudit.action.organisation.provisioning_denied": "Organisation provisioning refused",
  "journalAudit.action.organisation.profile_updated": "Organisation profile updated",
  "journalAudit.action.organisation.enrolment_link_issued": "Activation link issued",
  "journalAudit.action.organisation.enrolment_link_revoked": "Activation link revoked",
  "journalAudit.action.organisation.admin_enrolled": "Organisation administrator enrolled",
  "journalAudit.action.organisation.write_refused_suspended": "Write refused: organisation suspended",
  "journalAudit.action.organisation.write_refused_deleted": "Write refused: organisation being deleted",
  "journalAudit.action.platform.organisation_plan_changed": "Organisation plan changed",
  "journalAudit.action.platform.organisation_suspended": "Organisation suspended",
  "journalAudit.action.platform.organisation_reactivated": "Organisation reactivated",
  "journalAudit.action.platform.organisation_deletion_requested": "Organisation deletion requested",
  "journalAudit.action.platform.organisation_deletion_cancelled": "Organisation deletion cancelled",
  "journalAudit.action.platform.organisation_export_ready": "Organisation export ready",
  "journalAudit.action.platform.organisation_export_expired": "Organisation export expired",
  "journalAudit.action.platform.organisation_purged": "Organisation purged",
  "journalAudit.action.platform.exceptional_access_opened": "Exceptional access opened",
  "journalAudit.action.platform.exceptional_access_read": "Read under exceptional access",
  "journalAudit.action.platform.exceptional_access_revoked": "Exceptional access revoked",
  "journalAudit.action.platform.continuity_backup_requested": "Backup requested",
  "journalAudit.action.platform.continuity_restore_requested": "Restore requested",
  "journalAudit.action.platform.journal_exported": "Platform journal exported",
  "journalAudit.action.platform.lifecycle_export_downloaded": "Deletion archive downloaded",
  "journalAudit.action.workspace.member_added": "Member added to the project",
  "journalAudit.action.workspace.member_joined": "Member joined the project",
  "journalAudit.action.workspace.member_removed": "Member removed from the project",
  "journalAudit.action.workspace.member_role_changed": "Project role changed",
  "journalAudit.action.workspace.permission_granted": "Project permission granted",
  "journalAudit.action.workspace.permission_revoked": "Project permission revoked",
  "journalAudit.action.droit_isole.accorde": "Individual right granted",
  "journalAudit.action.droit_isole.revoque": "Individual right revoked",
  "journalAudit.action.workspace.ownership_transferred": "Project ownership transferred",
  "journalAudit.action.workspace.access_requested": "Project access requested",
  "journalAudit.action.workspace.access_request_approved": "Access request approved",
  "journalAudit.action.workspace.access_request_rejected": "Access request rejected",
  "journalAudit.action.workspace.access_request_cancelled": "Access request cancelled",
  "journalAudit.action.workspace.access_denied": "Project access refused",
  "journalAudit.action.workspace.renamed": "Project renamed",
  "journalAudit.action.workspace.archived": "Project archived",
  "journalAudit.action.workspace.unarchived": "Project unarchived",
  "journalAudit.action.workspace.deletion_requested": "Project deletion requested",
  "journalAudit.action.workspace.deletion_cancelled": "Project deletion cancelled",
  "journalAudit.action.workspace.purged": "Project purged",
  "journalAudit.action.workspace.export": "Project exported",
  "journalAudit.action.program.member_added": "Member added to the programme",
  "journalAudit.action.program.workspace_attached": "Project attached to the programme",
  "journalAudit.action.audit.export": "Audit exported",
  "journalAudit.action.audit.journal_exported": "Audit journal exported",
  "journalAudit.action.lifecycle.request_read_denied": "Deletion request read refused",
  "journalAudit.action.lifecycle.requests_list_denied": "Deletion request list refused",
  "journalAudit.action.lifecycle.export_ready": "Deletion archive ready",
  "journalAudit.action.lifecycle.export_expired": "Deletion archive expired",
  "journalAudit.action.ai.purpose.read_denied": "AI purposes read refused",
  "journalAudit.action.ai_model_not_granted": "AI model not granted",
  "journalAudit.action.mission.launched": "Mission launched",
  "journalAudit.action.mission.decision": "Mission decision",
  "journalAudit.action.mission.plan_approved": "Mission plan approved",
  "journalAudit.action.mission.dossier_approved": "Mission dossier approved",
  "journalAudit.action.mission.dossier_rejected": "Mission dossier rejected",
  "journalAudit.action.mission.stopped": "Mission stopped",
  "journalAudit.action.mission.stopped_budget": "Mission stopped: budget reached",
  "journalAudit.action.mission.stops_acknowledged": "Mission stops acknowledged",
  "journalAudit.action.mission.failed": "Mission failed",
  "journalAudit.action.defect.created": "Defect reported",
  "journalAudit.action.defect.transition": "Defect status changed",
  "journalAudit.action.defect.test_case_linked": "Test case linked to the defect",
  "journalAudit.action.test_case.test_code_set": "Test code saved",
  "journalAudit.action.test_case.test_code_validated": "Test code validated",
  "journalAudit.action.recette.execute_denied": "Acceptance run refused",
  "journalAudit.action.release.created": "Release created",
  "journalAudit.action.release.transition": "Release status changed",
  "journalAudit.action.release.content_added": "Content added to the release",
  "journalAudit.action.release.content_removed": "Content removed from the release",
  "journalAudit.action.release.notes_generated": "Release notes generated",
  "journalAudit.action.release.notes_published": "Release notes published",
  "journalAudit.action.release.documents_generated": "Release documents generated",
  "journalAudit.action.release.approval_requested": "Release approval requested",
  "journalAudit.action.release.approval_decided": "Release approval decided",
  "journalAudit.action.release.revision_signing_requested": "Revision signing requested",
  "journalAudit.action.release.deploy_requested": "Deployment requested",
  "journalAudit.action.runops.environment_production_declared": "Environment declared as production",
  "journalAudit.action.preview.start_requested": "Preview start requested",
  "journalAudit.action.preview.stop_requested": "Preview stop requested",
  "journalAudit.action.preview.expired": "Preview expired",
  "journalAudit.action.technology_entry.created": "Technology catalogue entry created",
  "journalAudit.action.technology_baseline.created": "Technology baseline created",
  "journalAudit.action.technology_category.starter_set_applied": "Category starter set applied",
  "journalAudit.action.technology_catalog.starter_set_applied": "Catalogue starter set applied",
  "journalAudit.action.design.wireframe.validated": "Wireframe validated",
  "journalAudit.action.design.flow.validated": "Flow validated",
  "journalAudit.action.design.org_charter.created": "Organisation charter created",
  "journalAudit.action.design.org_charter.validated": "Organisation charter validated",
  "journalAudit.action.approval.governance_refused": "Approval refused by governance",
  "journalAudit.action.approval.spec_gate_evidence_renewed": "Spec Gate evidence renewed",
  "journalAudit.action.job_enqueued": "Job queued",
  "journalAudit.action.job_claimed": "Job claimed",
  "journalAudit.action.job_terminal": "Job finished",
  "journalAudit.action.job_done": "Job succeeded",
  "journalAudit.action.job_failed": "Job failed",
  "journalAudit.action.mission_step_done": "Mission step done",
  "journalAudit.action.mission_plan_proposed": "Mission plan proposed",
  "journalAudit.action.generation_started": "Generation started",
  "journalAudit.action.generation_finished": "Generation finished",
  "journalAudit.action.generated_tests_executed": "Generated tests run",
  "journalAudit.action.generated_tests_failed": "Generated tests failed",
  "journalAudit.action.generated_tests_repair_attempted": "Test repair attempted",
  "journalAudit.action.generated_tests_repair_finished": "Test repair finished",
  "journalAudit.action.approval_requested": "Approval requested",
  "journalAudit.action.approval_granted": "Approval granted",
  "journalAudit.action.approval_rejected": "Approval rejected",
  "journalAudit.action.artifact_written": "Artifact written",
  "journalAudit.action.app_tree_written": "Application tree written",
  "journalAudit.action.committed": "Changes committed",
  "journalAudit.action.stack_profile_resolved": "Stack profile resolved",
  "journalAudit.action.preview_starting": "Preview starting",
  "journalAudit.action.preview_running": "Preview running",
  "journalAudit.action.preview_stopped": "Preview stopped",
  "journalAudit.action.preview_failed": "Preview failed",
  "journalAudit.action.independent_review_submitted": "Independent review submitted",
  "journalAudit.action.spec_gate_started": "Spec Gate started",
  "journalAudit.action.spec_gate_done": "Spec Gate done",
  "journalAudit.action.deployment_started": "Deployment started",
  "journalAudit.action.deployment_succeeded": "Deployment succeeded",
  "journalAudit.action.deployment_failed": "Deployment failed",
  "journalAudit.action.revision_signing_started": "Revision signing started",
  "journalAudit.action.revision_signed": "Revision signed",
  "journalAudit.action.revision_signing_failed": "Revision signing failed",
  "journalAudit.action.environment_auto_stop_failed": "Environment auto-stop failed",
  "journalAudit.action.publication_blocked": "Publication blocked",
  "journalAudit.action.regeneration_previous_tree": "Previous tree shown for regeneration",
  "journalAudit.action.regeneration_previous_version": "Previous version reused for regeneration",
  "journalAudit.action.demand_decisions_resolved": "Team answers attached to the generation",
  "journalAudit.action.backlog_items_inserted": "Backlog items created",
  "journalAudit.action.black_box_inputs_ignored": "Code inputs ignored (black-box testing)",
  "journalAudit.action.design_flow_proposed": "Flow proposed",
  "journalAudit.action.children_reviewed": "Generated items reviewed by a second model",
  "journalAudit.action.publication_terminal_blocked": "Publication permanently blocked",
  "journalAudit.action.risk_mitigation_plan_recorded": "Risk mitigation plan recorded",
  "journalAudit.action.template_leakage_refused": "Output refused: template lines kept",
  "journalAudit.action.spec_gate_evidence_renewed": "Spec Gate evidence renewed",
  "journalAudit.acteurAide": "Exact identifier, shown under the name",
  "journalAudit.action.access.matrix.permission_granted": "Permission granted to a role",
  "journalAudit.action.access.matrix.permission_revoked": "Permission revoked from a role",
  "journalAudit.action.access.policy.created": "Access rule created",
  "journalAudit.action.access.policy.deleted": "Access rule deleted",
  "journalAudit.action.access.review.read": "Access review viewed",
  "journalAudit.action.adr.created": "ADR created",
  "journalAudit.action.adr.criterion_updated": "ADR criterion updated",
  "journalAudit.action.adr.decided": "ADR decided",
  "journalAudit.action.adr.decided.two_person_mode": "ADR decided (two-person mode)",
  "journalAudit.action.adr.reviewed": "ADR reviewed",
  "journalAudit.action.agent.promotion_requested": "Agent promotion requested",
  "journalAudit.action.agent.promoted": "Agent promoted",
  "journalAudit.action.agent.promotion_refused": "Agent promotion refused",
  "journalAudit.action.agent.promotion_withdrawn": "Agent promotion withdrawn",
  "journalAudit.action.ai.consent.granted": "AI consent granted",
  "journalAudit.action.ai.consent.withdrawn": "AI consent withdrawn",
  "journalAudit.action.ai.purpose.declared": "AI purpose declared",
  "journalAudit.action.ai.purpose.approved": "AI purpose approved",
  "journalAudit.action.ai.purpose.refused": "AI purpose refused",
  "journalAudit.action.ai.purpose.withdrawn": "AI purpose withdrawn",
  "journalAudit.action.harness.card_promotion_requested": "Card promotion requested",
  "journalAudit.action.harness.card_promotion_approved": "Card promotion approved",
  "journalAudit.action.harness.card_promotion_refused": "Card promotion refused",
  "journalAudit.action.harness.card_promotion_withdrawn": "Card promotion withdrawn",
  "journalAudit.action.approval.risk_category_raised": "Approval risk category raised",
  "journalAudit.action.approval.two_person_mode": "Approval decided in two-person mode",
  "journalAudit.action.backlog.item_assigned": "Backlog item assigned",
  "journalAudit.action.backlog.items_assigned": "Backlog items assigned in bulk",
  "journalAudit.action.backlog.item_ranked": "Backlog item re-ranked",
  "journalAudit.action.backlog.wip_limits.set": "Work-in-progress limits set",
  "journalAudit.action.backlog.wip_limits.refused": "Work-in-progress limits change refused",
  "journalAudit.action.backlog_item.deleted": "Backlog item deleted",
  "journalAudit.action.backlog_item.merged": "Backlog items merged",
  "journalAudit.action.classification.deleted": "Classification item deleted",
  "journalAudit.action.classification.version_updated": "Classification version updated",
  "journalAudit.action.item_axis.attached": "Axis attached to an item",
  "journalAudit.action.item_axis.detached": "Axis detached from an item",
  "journalAudit.action.workspace_team.deleted": "Project team deleted",
  "journalAudit.action.workspace_team.member_removed": "Member removed from the team",
  "journalAudit.action.defect.assigned": "Defect assigned",
  "journalAudit.action.defect_lesson.proposed": "Defect lesson proposed",
  "journalAudit.action.defect_lesson.validated": "Defect lesson validated",
  "journalAudit.action.defect_lesson.dismissed": "Defect lesson dismissed",
  "journalAudit.action.test_case.test_code_removed": "Test code removed",
  "journalAudit.action.test_execution.assigned": "Test case assigned in the campaign",
  "journalAudit.action.test_execution.unassigned": "Test case assignment removed",
  "journalAudit.action.test_execution.step_run_started": "Step-by-step run started",
  "journalAudit.action.test_execution.step_run_finished": "Step-by-step run finished",
  "journalAudit.action.regression.accept": "Regression accepted",
  "journalAudit.action.regression.accept.refused": "Regression acceptance refused",
  "journalAudit.action.regression_suite.case_added": "Case added to the regression suite",
  "journalAudit.action.regression_suite.case_removed": "Case removed from the regression suite",
  "journalAudit.action.regression_suite.designated": "Regression suite designated",
  "journalAudit.action.regression_suite.undesignated": "Regression suite designation removed",
  "journalAudit.action.design.charter.created": "Project charter created",
  "journalAudit.action.design.charter.validated": "Project charter validated",
  "journalAudit.action.design.charter_override.created": "Charter override created",
  "journalAudit.action.design.charter_override.ended": "Charter override ended",
  "journalAudit.action.design.charter_override.expired": "Charter override expired",
  "journalAudit.action.design.charter_waiver.requested": "Charter waiver requested",
  "journalAudit.action.design.charter_waiver.granted": "Charter waiver granted",
  "journalAudit.action.design.charter_waiver.refused": "Charter waiver refused",
  "journalAudit.action.design.comparison.filed": "Wireframe–application comparison filed",
  "journalAudit.action.design.flow.created": "Flow created",
  "journalAudit.action.design.org_charter.enforcement_changed": "Organisation charter enforcement changed",
  "journalAudit.action.design.usability_check.planned": "Usability test planned",
  "journalAudit.action.design.usability_check.completed": "Usability test completed",
  "journalAudit.action.design.usability_check.waived": "Usability test waived",
  "journalAudit.action.golden_path.published": "Golden path version published",
  "journalAudit.action.incident.declared": "Incident declared",
  "journalAudit.action.incident.updated": "Incident updated",
  "journalAudit.action.incident.status_changed": "Incident status changed",
  "journalAudit.action.incident.note_added": "Note added to the incident",
  "journalAudit.action.incident.defect_linked": "Defect linked to the incident",
  "journalAudit.action.incident.action_created": "Follow-up action created from the incident",
  "journalAudit.action.incident.postmortem_saved": "Post-mortem saved",
  "journalAudit.action.incident.postmortem_published": "Post-mortem published",
  "journalAudit.action.invitation.created": "Project invitation sent",
  "journalAudit.action.invitation.accepted": "Project invitation accepted",
  "journalAudit.action.invitation.revoked": "Project invitation revoked",
  "journalAudit.action.user.offboarded": "User offboarded",
  "journalAudit.action.notification.preferences_updated": "Notification preferences updated",
  "journalAudit.action.lifecycle.export_downloaded": "Deletion archive downloaded",
  "journalAudit.action.mcp.link_tested": "MCP link tested",
  "journalAudit.action.quarantine.replayed": "Quarantined event replayed",
  "journalAudit.action.quarantine.replay_refused": "Quarantined event replay refused",
  "journalAudit.action.referential.imported": "Referential imported",
  "journalAudit.action.scm.gitlab_disconnected": "GitLab disconnected from the project",
  "journalAudit.action.workspace.export.requested": "Project export requested",
  "journalAudit.action.mission.paused": "Mission paused",
  "journalAudit.action.mission.resumed": "Mission resumed",
  "journalAudit.action.mission.plan_rejected": "Mission plan rejected",
  "journalAudit.action.mission.replan_approved": "Mission replan approved",
  "journalAudit.action.mission.replan_rejected": "Mission replan rejected",
  "journalAudit.action.org_governance.settings_changed": "Organisation governance settings changed",
  "journalAudit.action.org_governance.external_ai_agents_changed": "Allowed external AI agents changed",
  "journalAudit.action.org_requirement.created": "Organisation requirement created",
  "journalAudit.action.org_requirement.updated": "Organisation requirement updated",
  "journalAudit.action.org_requirement.status_changed": "Organisation requirement status changed",
  "journalAudit.action.org_rule.stage_decided": "Organisation rule stage change decided",
  "journalAudit.action.project_governance.mode_changed": "Project governance mode changed",
  "journalAudit.action.scope_requirement.added": "Requirement added to the scope",
  "journalAudit.action.scope_requirement.removed": "Requirement removed from the scope",
  "journalAudit.action.scope_requirement.waived": "Requirement waived",
  "journalAudit.action.waiver.requested": "Waiver requested",
  "journalAudit.action.waiver.reviewed": "Waiver reviewed",
  "journalAudit.action.waiver.granted": "Waiver granted",
  "journalAudit.action.waiver.refused": "Waiver refused",
  "journalAudit.action.waiver.lifted": "Waiver lifted",
  "journalAudit.action.waiver.expired": "Waiver expired",
  "journalAudit.action.role_delegation.created": "Role delegation created",
  "journalAudit.action.role_delegation.revoked": "Role delegation revoked",
  "journalAudit.action.raci.updated": "RACI matrix updated",
  "journalAudit.action.service_objective.created": "Service objective created",
  "journalAudit.action.service_objective.updated": "Service objective updated",
  "journalAudit.action.spec_change.requested": "Specification change requested",
  "journalAudit.action.spec_change.withdrawn": "Specification change request withdrawn",
  "journalAudit.action.spec_change.accepted": "Specification change accepted",
  "journalAudit.action.spec_change.refused": "Specification change refused",
  "journalAudit.action.preview.restart_requested": "Preview restart requested",
  "journalAudit.action.preview.share_created": "Preview share link created",
  "journalAudit.action.preview.share_opened": "Preview share link opened",
  "journalAudit.action.preview.share_revoked": "Preview share link revoked",
  "journalAudit.action.program.initiative_objective_set": "Initiative objective set",
  "journalAudit.action.program.member_removed": "Member removed from the programme",
  "journalAudit.action.program.member_role_changed": "Programme role changed",
  "journalAudit.action.program.objective_updated": "Programme objective updated",
  "journalAudit.action.program.ownership_transferred": "Programme ownership transferred",
  "journalAudit.action.program.risk_added": "Programme risk added",
  "journalAudit.action.program.risk_updated": "Programme risk updated",
  "journalAudit.action.program.settings_updated": "Programme settings updated",
  "journalAudit.action.program.workspace_detached": "Project detached from the programme",
  "journalAudit.action.release.adopted": "Existing release adopted into the lifecycle",
  "journalAudit.action.release.approval_reviewed": "Release approval reviewed",
  "journalAudit.action.release.approval_withdrawn": "Release approval withdrawn",
  "journalAudit.action.release.campaign_linked": "Test campaign linked to the release",
  "journalAudit.action.release.deployment_planned": "Production release planned",
  "journalAudit.action.release.deployment_plan_cancelled": "Production release plan cancelled",
  "journalAudit.action.release.freeze_declared": "Freeze period declared",
  "journalAudit.action.release.freeze_cancelled": "Freeze period cancelled",
  "journalAudit.action.release.notes_edited": "Release notes edited",
  "journalAudit.action.release.target_date_set": "Release target date set",
  "journalAudit.action.revision_registry.vulnerability_scan_recorded": "Revision vulnerability scan recorded",
  "journalAudit.action.runops.deployment_outcome_declared": "Deployment outcome declared",
  "journalAudit.action.sprint.capacity_declared": "Sprint capacity declared",
  "journalAudit.action.sprint.closed": "Sprint closed",
  "journalAudit.action.sprint.retro_action_created": "Retrospective action created",
  "journalAudit.action.sprint.review_saved": "Sprint review saved",
  "journalAudit.action.technology_category.created": "Technology category created",
  "journalAudit.action.technology_category.updated": "Technology category updated",
  "journalAudit.action.technology_category.deleted": "Technology category deleted",
  "journalAudit.action.technology_change.created": "Technology change created",
  "journalAudit.action.technology_change.analysed": "Technology change analysed",
  "journalAudit.action.technology_change.confirmed": "Technology change dimension confirmed",
  "journalAudit.action.technology_change.submitted": "Technology change submitted for review",
  "journalAudit.action.technology_change.approved": "Technology change approved",
  "journalAudit.action.technology_change.refused": "Technology change refused",
  "journalAudit.action.technology_change.propagation_started": "Technology change propagation started",
  "journalAudit.action.technology_change.propagation_resumed": "Technology change propagation resumed",
  "journalAudit.action.technology_change.deviation_kept": "Deviation kept by an inheriting project",
  "journalAudit.action.technology_change.rework_item_added": "Rework item added to the technology change",
  "journalAudit.action.technology_change.verified": "Technology change verified",
  "journalAudit.action.technology_change.closed": "Technology change closed",
  "journalAudit.action.technology_change.cancelled": "Technology change cancelled",
  "journalAudit.action.technology_entry.status_changed": "Technology catalogue entry status changed",
  "journalAudit.action.technology_entry.updated": "Technology catalogue entry updated",
  "journalAudit.action.ai_model_quota_exceeded": "AI model call quota exceeded",
  "journalAudit.action.ai_reviewer_blocked": "AI reviewer blocked",
  "journalAudit.action.ai_model_attestation_gap": "AI model attestation missing",
  "journalAudit.action.ai_provider_policy_blocked": "AI provider blocked by policy",
  "journalAudit.action.ai_provider_qualification_blocked": "AI provider qualification blocked",
  "journalAudit.action.ai_provider_qualification_succeeded": "AI provider qualified",
  "design.comparison.authRequired": "Sign-in required: the survey does not sign in, so this screen was not measured.",
  "design.comparison.authCount": "{{count}} requiring sign-in (not measured); ",
  "design.comparison.summaryWithAuth": "{{compared}} screen(s) compared out of {{expected}}; {{missing}} missing from the application; {{auth}}{{without}} without a validated wireframe. Gaps: {{major}} major, {{minor}} minor, {{info}} info.",
  "design.comparison.opinion.partial": "partial comparison: some screens were not measured",
  "design.conformance.flowAuth": "including {{n}} requiring sign-in (not measured)",
  "design.conformance.flowAuth_one": "including {{n}} requiring sign-in (not measured)",
  "design.conformance.flowAuth_other": "including {{n}} requiring sign-in (not measured)",
  "apercu.compare.authRequired": "sign-in required",
  "apercu.count.authRequired": "{{n}} screens requiring sign-in (not measured)",
  "apercu.count.authRequired_one": "{{n}} screen requiring sign-in (not measured)",
  "apercu.count.authRequired_other": "{{n}} screens requiring sign-in (not measured)",
  "journalAudit.action.ai.grant_revoked": "AI model grant withdrawn from the organisation",
  "journalAudit.action.ai.grant_set": "AI model grant saved for the organisation",
  "slo.reserveEcriture": "Only the project owner, the organisation administration and the platform administration declare or edit a service objective; you keep read access to the budget.",
  "journalAudit.action.lifecycle.request.read": "Deletion request viewed",
  "journalAudit.action.lifecycle.requests.read": "Deletion requests viewed",
  "app.listeProjetsIllisible": "Your project list could not be read",
  "app.listeProjetsIllisibleAide": "Access to the project settings cannot be verified while this list is unreadable.",
  "app.coquilleIndisponible": "The interface could not start",
  "app.coquilleIndisponibleAide": "The interface configuration is inconsistent. Report it to the platform administration.",
  "runopsFiche.retourEnvironnements": "Back to environments and deployments",
  "runops.actualiserEnvironnements": "Refresh environments",
  "preteEnv.aucunEnvAideEcran": "Environments are declared in “Environments and deployments”.",
  "processView.configurerProcessus": "Configure the process",
  "processView.ouvrirPipelines": "Open the pipelines",
  "processView.chargerPlan": "Load the effective plan",
  "processView.examinerBlocage": "Review the blocker",
  "processView.attendreApprobation": "Wait for a human approval",
  "processView.suivreExecution": "Follow the execution",
  "processView.lancer": "Launch the process",
  "processView.projetActif": "Active project",
  "processView.defautIntegre": "Built-in Default",
  "processView.cyclePersonnalise": "custom lifecycle",
  "processView.cycleIntegre": "built-in lifecycle",
  "processView.provenance": "Provenance:",
  "processView.version": "Version:",
  "processView.empreinte": "Fingerprint:",
  "processView.resolution.instantane": "Pinned snapshot",
  "processView.resolution.courante": "Current configuration",
  "processView.resolution.integre": "Built-in template",
  "processView.processusPret": "Process ready",
  "processView.prerequisACompleter": "Prerequisites to complete",
  "processView.actualiser": "Refresh",
  "processView.erreurPlan": "Unable to load the plan: {{message}}",
  "processView.blocagesTitre": "What blocks the next step",
  "processView.blocagesAide": "The server evaluated these prerequisites before any execution.",
  "processView.politiqueUnique": "A single effective policy is evaluated for this project.",
  "processView.run": "Run: {{statut}}",
  "processView.aucuneEtape": "No step is declared in the effective template.",
  "processView.roles": "Roles:",
  "processView.tous": "All",
  "processView.approbation": "Approval:",
  "processView.approbation.aucune": "None",
  "processView.approbation.unePersonne": "One person",
  "processView.approbation.sod": "Separation of duties",
  "processView.approbation.quorum": "Quorum",
  "processView.approbation.nonDeclaree": "Not declared",
  "processView.prerequis": "Prerequisites:",
  "processView.aucun": "None",
  "processView.disponible": "Available",
  "processView.bloque": "Blocked",
  "processView.prochaineAction": "Next action",
  "processView.sodAutreApprobateur": "Separation of duties requires another approver.",
  "processView.ouvrir": "Open",
  "processView.termine": "Process completed",
  "processView.demarre": "The delivery process has been started.",
  "processView.workflowTitre": "Work item workflow",
  "processView.workflowAide": "Transitions and counters provided by the server for this project.",
  "processView.workflowLegende": "Statuses, allowed transitions and prerequisites",
  "processView.colStatut": "Status",
  "processView.colObjets": "Items",
  "processView.colTransitions": "Transitions",
  "processView.colPrerequis": "Prerequisites",
  "tree.priorityLabel": "Priority",
  "livrer.publication.numeroPipeline": "pipeline no. {{numero}}",
  "livrer.publication.pipelineEtat": "{{pipeline}}: {{etat}}",
  "processView.templateEffectifEtiquette": "Effective template:",
  "filters.deleteConsequencePersonnel": "This filter is personal: it only disappears from your list. The items themselves are not affected.",
  "n28.pastilleAriaSansDuree": "Next action for your role ({{role}}): {{action}}",
  "agile.annuaireRefusProgramme": "Reserved to a programme owner: you cannot add members here.",
  "admin.colRegression": "Accept a regression",
  "admin.colLimites": "Set work-in-progress limits",
  "admin.regressionCaseAria": "Accept a regression: {{u}}",
  "admin.limitesCaseAria": "Set work-in-progress limits: {{u}}",
  "admin.permissionsAide": "“Accept a regression”: accept, with a reason and a deadline, a regression found by the non-regression run. “Set work-in-progress limits”: set the work-in-progress limits of the board. The project owner already has both; tick them to give either one to another member. To use either one, a person needs an organisation role that can write (organisation administrator, project lead or contributor), whatever role they hold in this project, owner included: an organisation viewer or auditor can only use “Run an acceptance”. Every grant is audited.",
  "workflow.agentAExecuter": "Agent to run",
  "fonA.finalites.agentConcerne": "Agent covered by the purpose",
  "versions.code.CI_PIPELINE_UNREADABLE": "The status of a running pipeline could not be re-read from GitLab: blocking for a production target unless a signed waiver (14 days at most from its signature) covers it, on a project requirement whose control is ci_pipeline_green; a mere warning for any other target",
  "versions.code.CI_PIPELINE_NOT_APPLICABLE": "No revision is published and no repository is linked: no pipeline to wait for (not applicable)",
  "org.request.pipelineLimit": "Requirement with the {{controle}} control: 14 days at most from the signature (14 × 24 h). Latest acceptable date: {{date}}.",
  "org.request.pipelineLimitExceeded": "This deadline exceeds the validity of a pipeline waiver (14 × 24 h from its signature): the latest acceptable date is {{date}}.",
  "erreurs.code.WAIVER_PIPELINE_VALIDITY_EXCEEDED": "The requested deadline exceeds the validity of a pipeline waiver: 14 days at most from its signature (14 × 24 h). Choose an earlier date.",
  "org.waiver.expiredRequirement": "expired — requirement {{etat}}",
  "org.motifReinitialisationAnnuaire": "Reset requested from the directory",
  "org.membreAjoutPartiel": "Added as a reader; the requested profiles were not granted",
  "erreurs.code.BACKUP_RETENTION_NO_POLICY": "This backup has no retention policy recorded: its rotation cannot be recorded.",
  "erreurs.code.BACKUP_RETENTION_VERIFY_REFUSED_UNDER_HOLD": "This backup is under legal hold: its rotation cannot be recorded while the hold lasts.",
  "erreurs.code.CONTINUITY_ACTOR_MISMATCH": "A backup or restore request must be made in your own name.",
  "erreurs.code.CONTINUITY_PLATFORM_ADMIN_REQUIRED": "Platform backup and restore requests are reserved to platform administration.",
  "erreurs.code.CONTINUITY_REQUEST_APPEND_ONLY": "A backup or restore request can be neither changed nor deleted: it stays in the log.",
  "erreurs.code.DEPLOYMENT_PLAN_SCOPE_MISMATCH": "The chosen version or environment does not belong to the project of this planned production release.",
  "erreurs.code.ENROLMENT_ALREADY_CLOSED": "This activation link has already been used or revoked.",
  "erreurs.code.ENROLMENT_APPEND_ONLY": "An activation link cannot be deleted: revoke it instead.",
  "erreurs.code.ENROLMENT_IMMUTABLE": "An activation link cannot be changed: it can only be used or revoked.",
  "erreurs.code.ENROLMENT_NOT_VALID": "This activation link is no longer valid: it has expired, been used or been revoked.",
  "erreurs.code.ENROLMENT_UNKNOWN": "This activation link is unknown: ask platform administration for a new one.",
  "erreurs.code.EXCEPTIONAL_ACCESS_ACTOR_MISMATCH": "An exceptional access must be opened or revoked in your own name.",
  "erreurs.code.EXCEPTIONAL_ACCESS_ALREADY_ACTIVE": "You already have an active exceptional access session on this organisation.",
  "erreurs.code.EXCEPTIONAL_ACCESS_ALREADY_REVOKED": "This exceptional access session is already revoked.",
  "erreurs.code.EXCEPTIONAL_ACCESS_APPEND_ONLY": "An exceptional access session is never deleted: it is revoked.",
  "erreurs.code.EXCEPTIONAL_ACCESS_EXPIRED": "The window of this exceptional access session has closed: open a new session, with a new reason.",
  "erreurs.code.EXCEPTIONAL_ACCESS_IMMUTABLE": "An exceptional access session cannot be changed: it can only be revoked.",
  "erreurs.code.EXCEPTIONAL_ACCESS_NOT_ACTIVE": "This exceptional access session has already ended: there is nothing to revoke.",
  "erreurs.code.EXCEPTIONAL_ACCESS_NOT_FOUND": "This exceptional access session cannot be found.",
  "erreurs.code.EXCEPTIONAL_ACCESS_NOT_OWNER": "Only the administrator who opened this exceptional access session can read through it.",
  "erreurs.code.EXCEPTIONAL_ACCESS_PLATFORM_ADMIN_REQUIRED": "Exceptional accesses are reserved to platform administration.",
  "erreurs.code.EXCEPTIONAL_ACCESS_READ_ONLY_REQUIRED": "An exceptional access only gives read access: this operation was not opened as read-only.",
  "erreurs.code.EXCEPTIONAL_ACCESS_REVOKED": "This exceptional access session has been revoked: open a new session, with a new reason.",
  "erreurs.code.FILE_RETENTION_NOTHING_TO_RESTORE": "This file has not been removed: there is nothing to restore.",
  "erreurs.code.FILE_RETENTION_NO_POLICY": "This file has no retention policy recorded: its removal cannot be recorded.",
  "erreurs.code.FILE_RETENTION_VERIFY_REFUSED_UNDER_HOLD": "This file is under legal hold: its removal cannot be recorded while the hold lasts.",
  "erreurs.code.HARNESS_CASTES_SESSION_REQUIRED": "To read the castes in service, work from an organisation or sign in as a platform administrator.",
  "erreurs.code.LIFECYCLE_ACTOR_MISMATCH": "A deletion request must be made or cancelled in your own name.",
  "erreurs.code.LIFECYCLE_EXPORT_IMMUTABLE": "The archive of this deletion is ready: it no longer changes.",
  "erreurs.code.LIFECYCLE_EXPORT_REQUIRED": "The export archive is not ready: the purge waits until it has been produced.",
  "erreurs.code.LIFECYCLE_FORBIDDEN": "You do not have the authority needed to act on this deletion request.",
  "erreurs.code.LIFECYCLE_PERIMETER_NO_FIXPOINT": "The set of data to delete does not settle: the purge is suspended.",
  "erreurs.code.LIFECYCLE_PURGE_BLOCKED": "Linked data prevents the purge: it is suspended.",
  "erreurs.code.LIFECYCLE_PURGE_INCOMPLETE": "Data in scope remains after the purge: it is cancelled.",
  "erreurs.code.LIFECYCLE_PURGE_TOO_EARLY": "The delay before the purge has not elapsed: the deletion cannot be carried out yet.",
  "erreurs.code.LIFECYCLE_REQUEST_CLOSED": "This deletion request is closed: it no longer changes.",
  "erreurs.code.LIFECYCLE_REQUEST_IDENTITY_IMMUTABLE": "A deletion request keeps its target, its reason and its delay.",
  "erreurs.code.LIFECYCLE_REQUEST_IMMUTABLE": "A deletion request is not erased: it is closed or cancelled.",
  "erreurs.code.LIFECYCLE_REQUEST_NOT_FOUND": "This deletion request cannot be found.",
  "erreurs.code.LIFECYCLE_TABLE_OUT_OF_SCOPE": "This data table is not part of the scope of the deletion.",
  "erreurs.code.LIFECYCLE_TARGET_NOT_FOUND": "The project or organisation to delete cannot be found.",
  "erreurs.code.ORGANISATION_ALREADY_SUSPENDED": "This organisation is already suspended.",
  "erreurs.code.ORGANISATION_DELETED": "This organisation is already deleted: it can no longer be changed.",
  "erreurs.code.ORGANISATION_DELETION_PENDING": "A deletion is scheduled for this organisation: cancel it before reactivating it.",
  "erreurs.code.ORGANISATION_NOT_FOUND": "Organisation not found.",
  "erreurs.code.ORGANISATION_NOT_SUSPENDED": "This organisation is not suspended: there is nothing to reactivate.",
  "erreurs.code.ORGANISATION_SELF_DELETION_FORBIDDEN": "You cannot request the deletion of the organisation you are signed in to.",
  "erreurs.code.ORGANISATION_STATUS_HISTORY_APPEND_ONLY": "The status history of an organisation can be neither changed nor deleted.",
  "erreurs.code.ORGANISATION_STATUS_INVALID": "This status does not exist: an organisation is either active or suspended.",
  "erreurs.code.ORGANISATION_STATUS_PLATFORM_ADMIN_REQUIRED": "Changing the status of an organisation is reserved to platform administration.",
  "erreurs.code.ORGANISATION_STATUS_PLATFORM_ONLY": "The status of an organisation changes only through an act of platform administration.",
  "erreurs.code.ORG_INVITATION_ALREADY_CLOSED": "This invitation has already been accepted or revoked.",
  "erreurs.code.ORG_INVITATION_APPEND_ONLY": "An invitation cannot be deleted: revoke it instead.",
  "erreurs.code.ORG_INVITATION_IMMUTABLE": "An invitation cannot be changed: it can only be accepted or revoked.",
  "erreurs.code.ORG_INVITATION_NOT_VALID": "This invitation is no longer valid: it has expired, been accepted or been revoked.",
  "erreurs.code.ORG_INVITATION_UNKNOWN": "This invitation link is unknown: ask your organisation administration for a new one.",
  "erreurs.code.PLATFORM_JOURNAL_PLATFORM_ADMIN_REQUIRED": "The platform log is reserved to platform administration.",
  "erreurs.code.PURGED": "The final purge is refused: the organisation offboarding must be ready to purge, with no legal hold in force and the retention period over.",
  "erreurs.code.QUARANTINE_PLATFORM_ADMIN_REQUIRED": "Reading the quarantine across the whole installation is reserved to platform administration.",
  "erreurs.code.RELEASE_APPROVAL_APPEND_ONLY": "A version approval cannot be deleted: it is withdrawn.",
  "erreurs.code.RELEASE_APPROVAL_FROZEN": "The request, the review and the decision of an approval cannot be rewritten.",
  "erreurs.code.RELEASE_APPROVAL_INVALID": "This approval must belong to the project of the version.",
  "erreurs.code.RELEASE_APPROVAL_REQUIRED": "This version has no environment approval granted: get one before approving it.",
  "erreurs.code.RELEASE_APPROVAL_STATE_INVALID": "This approval is not in a state that allows this action.",
  "erreurs.code.RELEASE_CONTENT_FROZEN": "The content of this version is frozen outside draft; in draft, a line is removed then added, never edited.",
  "erreurs.code.RELEASE_CONTENT_INVALID": "This content does not belong to the project of the version.",
  "erreurs.code.RELEASE_ENVIRONMENT_NOT_FOUND": "This environment cannot be found from the project of the version.",
  "erreurs.code.RELEASE_IDENTITY_FROZEN": "The number, commit, source and creator of a version are frozen.",
  "erreurs.code.RELEASE_NOTES_PUBLICATION_INVALID": "Publishing release notes requires an author and a date.",
  "erreurs.code.RELEASE_NOTES_UNPUBLISH_FORBIDDEN": "A notes publication cannot be undone: it is replaced by a new version of the notes.",
  "erreurs.code.RELEASE_NOTES_VERSION_NOT_FOUND": "This version of the release notes cannot be found.",
  "erreurs.code.RELEASE_NOT_DEPLOYED": "This version has had no successful deployment on an approved environment.",
  "erreurs.code.RELEASE_NOT_FOUND": "Version not found in this project.",
  "erreurs.code.RELEASE_NOT_MANAGED": "This version is outside the lifecycle: prepare it first.",
  "erreurs.code.RELEASE_STATUS_INVALID": "The status of the version does not allow this action.",
  "erreurs.code.RELEASE_TEXT_APPEND_ONLY": "Release notes keep their history: no text version can be changed or deleted.",
  "erreurs.code.RELEASE_TRANSITION_FORBIDDEN": "This status change is refused: the version cannot move to that status from its current one, or a granted approval must be withdrawn first.",
  "erreurs.code.RETENTION_TENANT_SESSION_MISMATCH": "This retention operation targets a different organisation from the one of your session.",
  "erreurs.code.RETENTION_WORKSPACE_SESSION_MISMATCH": "This project belongs to a different organisation from the one of your session.",
  "erreurs.code.VECTOR_RETENTION_NO_POLICY": "The document vectors of this project have no retention policy recorded: their purge cannot be recorded.",
  "erreurs.code.VECTOR_RETENTION_VERIFY_REFUSED_UNDER_HOLD": "The document vectors of this project are under legal hold: their purge cannot be recorded while the hold lasts.",
  "erreurs.code.WORKSPACE_DELETION_PENDING": "A deletion is scheduled for this project: cancel it before unarchiving it.",
  "navMode.sansOrganisation": "The navigation mode is set per organisation: this account has none.",
  "porteProjet.verification": "Checking the project in your organisation…",
  "journalAudit.action.mission.partial_delivery_requested": "Delivery of completed tasks requested",
  "journalAudit.action.org.directory.exported": "Organisation directory exported",
  "journalAudit.action.org.invitation.resent": "Invitation resent",
  "journalAudit.action.org.invitation_request.approved": "Invitation request approved",
  "journalAudit.action.org.invitation_request.created": "Invitation request submitted",
  "journalAudit.action.org.invitation_request.refused": "Invitation request refused",
  "journalAudit.action.org.user.profiles_changed": "Organisation profiles changed",
  "journalAudit.action.program.member_profiles_changed": "Programme member profiles changed",
  "journalAudit.action.workspace.member_profiles_changed": "Project member profiles changed",
  "missions.reason.browser_proof_required": "browser proof required",
  "missions.reason.capability_missing": "worker capability missing",
  "missions.reason.budget_escalations_reached": "escalation budget exhausted",
  "missions.status.succeededPartial": "succeeded — partial delivery",
  "missions.decision.deliverConverged": "Deliver the converged tasks",
  "missions.decision.deliver.confirm": "{{n}} converged task(s) will be proposed for dossier approval; {{m}} stopped task(s) will be cancelled and left to be resumed.",
  "missions.decision.deliver.lastStop": "{{n}} converged task(s) will not be delivered; to deliver them: “Deliver the converged tasks”",
  "missions.decision.deliver.refused.WORKER_CAPABILITY_MISSING": "Delivery impossible: the running worker cannot yet deliver part of a mission. Update the worker and restart it.",
  "missions.decision.deliver.refused.MISSION_NOTHING_TO_DELIVER": "Delivery impossible: no task has converged.",
  "missions.decision.deliver.refused.MISSION_TASKS_STILL_ACTIVE": "Delivery impossible for now: a task is still running.",
  "missions.decision.deliver.refused.MISSION_STEP_IN_PROGRESS": "Delivery impossible for now: a mission step is in progress.",
  "missions.decision.effect.acknowledgeBudget": "The escalation is closed: the mission is stopped because its budget is exhausted, with no merge.",
  "construire.carteEnService": "in service",
  "missions.decision.deliver.refused.default": "Delivery impossible: the gateway refuses it.",
  "missions.decision.deliver.confirmNotStarted": "{{k}} task(s) not yet started will be cancelled.",
  "catalogueTech.gen.versionEnDesaccord": "qualified for {{qualifiee}}, entry on {{declaree}}: the colony does not generate this version",
  "erreurs.code.HARNESS_GENERATION_SESSION_REQUIRED": "To read what the generation engine runs, work from an organisation or sign in as a platform administrator.",
  "adr.stack.reason.REGISTRY_SNAPSHOT_MISSING": "Card registry unavailable: the generation engine in service has not published anything yet",
  "adr.stack.reason.GENERATION_TRUST_UNAVAILABLE": "The code run by the generation engine could not be fingerprinted: the measurement cannot be compared",
  "adr.stack.reason.GENERATION_CARD_NOT_ACTIVE": "The generation card is not active",
  "adr.stack.reason.GENERATION_CARD_RECEIPT_STALE": "The generation card receipt is out of date",
  "adr.stack.reason.QUALIFICATION_WITHOUT_FINGERPRINTS": "Old measurement without fingerprints: to be redone",
  "adr.stack.reason.QUALIFICATION_DRAWS_NOT_STANDARD": "Non-standard number of draws (3 per case, or 6 for a confirmation)",
  "adr.stack.reason.QUALIFICATION_DRAWS_NOT_STANDARD_NO_CASES": "Distinct cases not recorded: the {{draws}} draws per case of the measurement are not proven (re-record it with distinct_cases)",
  "adr.stack.reason.QUALIFICATION_STALE_CARD_VERSION": "Measured on card {{mesuree}}, in service {{service}}",
  "adr.stack.reason.QUALIFICATION_STALE_COMMON_BASE": "Shared generation code changed since the measurement",
  "adr.stack.reason.QUALIFICATION_STALE_GENERATION_SUBJECT": "Model or card text changed since the measurement",
  "adr.stack.reason.QUALIFICATION_STALE_STACK_DEFINITION": "Stack definition changed since the measurement",
  "adr.stack.confirmed": "qualified after confirmation ({{passed}} of {{total}}; initial measurement {{initialPassed}} of {{initialTotal}})",
  "adr.stack.confirmationMissed": "confirmation missed ({{passed}} of {{total}}; initial measurement {{initialPassed}} of {{initialTotal}})",
  "erreurs.code.PROMPT_CATALOG_APPEND_ONLY": "The prompt catalogue is append-only: published content and logged refusals cannot be changed or deleted.",
  "erreurs.code.POLITIQUE_APPROBATION_AJOUT_SEUL": "An approval policy in force cannot be changed or deleted: save a new version instead."
}
